import { createMapper, mapObject } from '@metorial/util-resource-mapper/compact';
import { createFetchWithRetry } from '@metorial/fetch';
import qs from 'qs';

var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var mapAgentsGetOutput = /* @__PURE__ */ mapObject(
  ["actor_id", "created_at", "updated_at", "archived_at"],
  1
);
var mapAgentsInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "agent_id",
    [
      "agent_client",
      1,
      [1, ["created_at", "updated_at", "last_connected_at"]]
    ],
    "created_at",
    "updated_at",
    "last_connected_at"
  ],
  1
);
var mapAgentsInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "agent_id",
        [
          "agent_client",
          1,
          [1, ["created_at", "updated_at", "last_connected_at"]]
        ],
        "created_at",
        "updated_at",
        "last_connected_at"
      ]
    ]
  ],
  1
);
var mapAgentsInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["agent_client_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapAgentsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["actor_id", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapAgentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapAssistantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "owner_type",
    "organization_id",
    [
      "default_model",
      1,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "available_models",
      1,
      [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapAssistantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "owner_type",
        "organization_id",
        [
          "default_model",
          1,
          [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
        ],
        [
          "available_models",
          1,
          [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapAssistantsListQuery = /* @__PURE__ */ createMapper(0);
var mapCallbackEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_trigger_key",
    "mapped_type",
    "mapped_id",
    "callback_id",
    "callback_instance_id",
    ["details", 0, [1, [["webhook", 0, [1, ["received_at"]]]]]],
    "occurred_at",
    "created_at"
  ],
  1
);
var mapCallbackEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_trigger_key",
        "mapped_type",
        "mapped_id",
        "callback_id",
        "callback_instance_id",
        "occurred_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapCallbackEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "callback_id",
          "callback_instance_id",
          "integration_id",
          "integration_provider_id",
          "provider_id",
          "provider_trigger_key",
          ["occurred_at", 1, 5],
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapCallbackInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "callback_id",
    "integration_instance_id",
    "integration_instance_provider_id",
    "created_at",
    "updated_at",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapCallbackInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "callback_id",
        "integration_instance_id",
        "integration_instance_provider_id",
        "created_at",
        "updated_at",
        ["sync", 0, [1, ["synced_at"]]]
      ]
    ]
  ],
  1
);
var mapCallbackInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "callback_id",
          "integration_id",
          "integration_instance_id",
          "integration_instance_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapCallbacksCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapCallbacksCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "integration_provider_id"
]);
var mapCallbacksDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapCallbacksGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapCallbacksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_provider_id",
        ["provider", 0, 8],
        "created_at",
        "updated_at",
        "auth_credentials_is_managed",
        ["sync", 0, [1, ["synced_at"]]]
      ]
    ]
  ],
  1
);
var mapCallbacksListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "integration_provider_id",
          "provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapCallbacksUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapCallbacksUpdateBody = /* @__PURE__ */ createMapper(0);
var mapChatConnectionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatConnectionsCreateBody = /* @__PURE__ */ mapObject([
  "private_metadata",
  [
    "provider",
    0,
    [
      1,
      [
        "provider_id",
        "provider_deployment_id",
        "provider_auth_method_id",
        "provider_auth_credentials_id",
        "provider_config_id"
      ]
    ]
  ]
]);
var mapChatConnectionsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                ["provider", 0, 8],
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_method_id",
                "auth_credentials_id",
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                "manual_webhook_trigger_groups"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapChatConnectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapChatConnectionsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatConnectionsUpdateBody = /* @__PURE__ */ mapObject(["private_metadata"]);
var mapChatEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    "chat_id",
    "channel_id",
    "thread_id",
    "message_id",
    "author_id",
    "provider_event_id",
    "provider_channel_id",
    "provider_thread_id",
    "provider_message_id",
    "provider_author_id",
    "occurred_at",
    "created_at",
    ["error", 0, [1, ["provider_code", "retry_after_ms"]]]
  ],
  1
);
var mapChatEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        "chat_id",
        "channel_id",
        "thread_id",
        "message_id",
        "author_id",
        "provider_event_id",
        "provider_channel_id",
        "provider_thread_id",
        "provider_message_id",
        "provider_author_id",
        "occurred_at",
        "created_at",
        ["error", 0, [1, ["provider_code", "retry_after_ms"]]]
      ]
    ]
  ],
  1
);
var mapChatEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "chat_id",
          "chat_connection_id",
          "chat_instance_id",
          ["created_at", 1, 5],
          ["occurred_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapChatInstancesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatInstancesCreateBody = /* @__PURE__ */ mapObject([
  "chat_connection_id",
  "private_metadata",
  "identity_actor_id",
  "identity_id"
]);
var mapChatInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapChatInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [1, ["chat_connection_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]
    ]
  ]
]);
var mapChatInstancesProviderAuthenticatedUserOutput = /* @__PURE__ */ mapObject([
  "chat_id",
  "provider_type",
  "provider_author_id",
  "user_name",
  "full_name",
  "image_url",
  "is_self",
  ["workspace", 0, [1, ["provider_workspace_id", "image_url"]]]
]);
var mapChatInstancesProviderGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_instance_id",
    "chat_connection_provider_id",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatInstancesProviderSetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_instance_id",
    "chat_connection_provider_id",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatInstancesProviderSetBody = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_deployment_id",
  "provider_config_id",
  "provider_auth_config_id"
]);
var mapChatInstancesSyncOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatInstancesUpdateBody = /* @__PURE__ */ mapObject(["private_metadata"]);
var mapChatWorkspacesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_workspace_id",
    "image_url",
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatWorkspacesGetQuery = /* @__PURE__ */ mapObject(["chat_instance_id"]);
var mapChatWorkspacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "provider_workspace_id",
        "image_url",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapChatWorkspacesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["chat_instance_id"]]]]
]);
var mapChatsChannelsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "workspace_id",
    "provider_type",
    "provider_channel_id",
    "has_access",
    [
      "recipient",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    "member_count",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapChatsChannelsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "workspace_id",
        "provider_type",
        "provider_channel_id",
        "has_access",
        [
          "recipient",
          0,
          [
            1,
            [
              "chat_id",
              "provider_type",
              "provider_author_id",
              "user_name",
              "full_name",
              "image_url",
              "is_self",
              "created_at",
              "updated_at",
              "last_interaction_at"
            ]
          ]
        ],
        "member_count",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapChatsChannelsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["workspace_id", "has_access"]]]]
]);
var mapChatsChannelsMembersGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_type",
    "provider_author_id",
    "user_name",
    "full_name",
    "image_url",
    "is_self",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapChatsChannelsMembersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "provider_type",
        "provider_author_id",
        "user_name",
        "full_name",
        "image_url",
        "is_self",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapChatsChannelsMembersListQuery = /* @__PURE__ */ createMapper(0);
var mapChatsChannelsTypingStartOutput = /* @__PURE__ */ createMapper(0);
var mapChatsChannelsTypingStartBody = /* @__PURE__ */ mapObject(["thread_id"]);
var mapChatsCommandsRespondOutput = /* @__PURE__ */ mapObject(
  [
    [
      "message",
      0,
      [
        1,
        [
          "chat_id",
          "channel_id",
          "thread_id",
          "provider_type",
          "provider_message_id",
          "provider_reply_to_message_id",
          [
            "author",
            0,
            [
              1,
              [
                "chat_id",
                "provider_type",
                "provider_author_id",
                "user_name",
                "full_name",
                "image_url",
                "is_self",
                "created_at",
                "updated_at",
                "last_interaction_at"
              ]
            ]
          ],
          [
            "attachments",
            0,
            [
              2,
              [
                1,
                [
                  "provider_attachment_id",
                  "mime_type",
                  "file_id",
                  "download_url",
                  "created_at"
                ]
              ]
            ]
          ],
          "sent_at",
          "edited_at",
          "created_at",
          "updated_at",
          "last_interaction_at",
          "deleted_at"
        ]
      ]
    ]
  ],
  1
);
var mapChatsCommandsRespondBody = /* @__PURE__ */ mapObject([
  "chat_event_id",
  "alt_text"
]);
var mapChatsDmsOpenOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "workspace_id",
    "provider_type",
    "provider_channel_id",
    "has_access",
    [
      "recipient",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    "member_count",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapChatsDmsOpenBody = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["user", 0, [3, [[0, [1, ["phone_number", "user_id"]]]]]],
            ["users", 0, [3, [[0, [1, ["phone_numbers", "user_ids"]]]]]]
          ]
        ]
      ]
    ]
  ]
);
var mapChatsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    "chat_instance_id",
    "chat_instance_provider_id",
    "provider_id",
    "workspace_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapChatsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        "chat_instance_id",
        "chat_instance_provider_id",
        "provider_id",
        "workspace_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapChatsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "chat_connection_id",
          "chat_instance_id",
          "chat_instance_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapChatsMessagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapChatsMessagesCreateBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "thread_id",
  "alt_text",
  ["attachments", 0, [2, [1, ["file_id"]]]],
  "reply_message_id",
  "ephemeral_target_user_id"
]);
var mapChatsMessagesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapChatsMessagesDeleteQuery = /* @__PURE__ */ mapObject(["channel_id"]);
var mapChatsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapChatsMessagesGetQuery = /* @__PURE__ */ mapObject(["channel_id"]);
var mapChatsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "channel_id",
        "thread_id",
        "provider_type",
        "provider_message_id",
        "provider_reply_to_message_id",
        [
          "author",
          0,
          [
            1,
            [
              "chat_id",
              "provider_type",
              "provider_author_id",
              "user_name",
              "full_name",
              "image_url",
              "is_self",
              "created_at",
              "updated_at",
              "last_interaction_at"
            ]
          ]
        ],
        [
          "attachments",
          0,
          [
            2,
            [
              1,
              [
                "provider_attachment_id",
                "mime_type",
                "file_id",
                "download_url",
                "created_at"
              ]
            ]
          ]
        ],
        "sent_at",
        "edited_at",
        "created_at",
        "updated_at",
        "last_interaction_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapChatsMessagesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["channel_id", "thread_id"]]]]
]);
var mapChatsMessagesReactionsCreateOutput = /* @__PURE__ */ createMapper(0);
var mapChatsMessagesReactionsCreateBody = /* @__PURE__ */ mapObject(["channel_id"]);
var mapChatsMessagesReactionsDeleteOutput = /* @__PURE__ */ createMapper(0);
var mapChatsMessagesReactionsDeleteQuery = /* @__PURE__ */ mapObject(["channel_id"]);
var mapChatsMessagesReactionsListOutput = /* @__PURE__ */ createMapper(0);
var mapChatsMessagesReactionsListQuery = /* @__PURE__ */ mapObject(["channel_id"]);
var mapChatsMessagesReadOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapChatsMessagesReadBody = /* @__PURE__ */ mapObject(["channel_id", "thread_id"]);
var mapChatsMessagesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapChatsMessagesUpdateBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "alt_text"
]);
var mapChatsThreadsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "provider_type",
    "provider_thread_id",
    "provider_root_message_id",
    "reply_count",
    "last_reply_at",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapChatsThreadsGetQuery = /* @__PURE__ */ mapObject(["channel_id"]);
var mapChatsThreadsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "channel_id",
        "provider_type",
        "provider_thread_id",
        "provider_root_message_id",
        "reply_count",
        "last_reply_at",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapChatsThreadsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["channel_id"]]]]
]);
var mapConsumerSurfacesGetOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_authoring",
    "allow_consumer_skill_publishing",
    [
      "skill_configuration",
      1,
      [
        1,
        [
          "is_default",
          "allow_scripts",
          "allowed_file_extensions",
          "allow_non_standard_directories"
        ]
      ]
    ],
    ["auth", 0, [1, ["session_expiry_time_in_seconds", "email_whitelist"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapConsumerSurfacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "allow_consumer_skill_authoring",
        "allow_consumer_skill_publishing",
        [
          "skill_configuration",
          1,
          [
            1,
            [
              "is_default",
              "allow_scripts",
              "allowed_file_extensions",
              "allow_non_standard_directories"
            ]
          ]
        ],
        [
          "auth",
          0,
          [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapConsumerSurfacesListQuery = /* @__PURE__ */ createMapper(0);
var mapConsumersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapConsumersCreateBody = /* @__PURE__ */ createMapper(0);
var mapConsumersGetMemberConsumerOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            [
              "profile",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "consumer_id",
                        "user_id",
                        "created_at",
                        "updated_at",
                        [
                          "groups",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                [
                                  "group",
                                  0,
                                  [
                                    1,
                                    ["is_default", "created_at", "updated_at"]
                                  ]
                                ],
                                "assigned_via"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapConsumersGetMemberConsumerBody = /* @__PURE__ */ mapObject([
  "surface_identifier"
]);
var mapConsumersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapConsumersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "user_id",
              "created_at",
              "updated_at",
              "is_portal_consumer",
              "is_organization_member",
              "is_service_account"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapConsumersListQuery = /* @__PURE__ */ createMapper(0);
var mapConsumersProfilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapConsumersProfilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "consumer_id",
              "user_id",
              "created_at",
              "updated_at",
              [
                "groups",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "group",
                        0,
                        [1, ["is_default", "created_at", "updated_at"]]
                      ],
                      "assigned_via"
                    ]
                  ]
                ]
              ],
              "is_service_account",
              [
                "surface",
                0,
                [
                  1,
                  [
                    "allow_consumer_skill_authoring",
                    "allow_consumer_skill_publishing",
                    [
                      "skill_configuration",
                      1,
                      [
                        1,
                        [
                          "is_default",
                          "allow_scripts",
                          "allowed_file_extensions",
                          "allow_non_standard_directories"
                        ]
                      ]
                    ],
                    [
                      "auth",
                      0,
                      [
                        1,
                        ["session_expiry_time_in_seconds", "email_whitelist"]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapConsumersProfilesListQuery = /* @__PURE__ */ createMapper(0);
var mapConsumersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapConsumersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapConversationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapConversationsCreateBody = /* @__PURE__ */ mapObject(["assistant_id"]);
var mapConversationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapConversationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "assistant_id",
        "instance_id",
        "organization_id",
        [
          "created_by_actor",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "root_message_id",
        [
          "assistant",
          0,
          [
            1,
            [
              "owner_type",
              "organization_id",
              [
                "default_model",
                1,
                [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
              ],
              [
                "available_models",
                1,
                [
                  2,
                  [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapConversationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["assistant_id"]]]]
]);
var mapConversationsMessagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapConversationsMessagesCreateBody = /* @__PURE__ */ mapObject([
  ["message", 0, [1, [["parts", 0, [2, [3, [[0, [1, ["media_type"]]]]]]]]]],
  "parent_message_id",
  "model_id"
]);
var mapConversationsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapConversationsMessagesHandoffResponsesOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapConversationsMessagesHandoffResponsesBody = /* @__PURE__ */ mapObject([
  ["responses", 0, [2, [1, ["tool_call_id"]]]]
]);
var mapConversationsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "conversation_item_id",
        "assistant_id",
        "parent_message_id",
        [
          "model",
          0,
          [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
        ],
        [
          "request",
          0,
          [
            1,
            [
              [
                "actor",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapConversationsMessagesListQuery = /* @__PURE__ */ createMapper(0);
var mapConversationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapConversationsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapCustomProvidersArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersCodeGetCodeEditorTokenOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapCustomProvidersCommitsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "custom_provider_deployment_id",
    [
      "to_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "from_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "target_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "previous_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "scm_push",
      1,
      [
        1,
        [
          ["actor", 0, [1, ["external_id"]]],
          ["commit", 0, [1, ["created_at"]]],
          [
            "repository",
            0,
            [1, ["is_private", "default_branch", "created_at"]]
          ],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "applied_at"
  ],
  1
);
var mapCustomProvidersCommitsCreateBody = /* @__PURE__ */ mapObject([
  [
    "action",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "from_environment_id",
              "to_environment_id",
              "environment_id",
              "version_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapCustomProvidersCommitsGetOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "custom_provider_deployment_id",
    [
      "to_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "from_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "target_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "previous_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "scm_push",
      1,
      [
        1,
        [
          ["actor", 0, [1, ["external_id"]]],
          ["commit", 0, [1, ["created_at"]]],
          [
            "repository",
            0,
            [1, ["is_private", "default_branch", "created_at"]]
          ],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "applied_at"
  ],
  1
);
var mapCustomProvidersCommitsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "custom_provider_id",
        "provider_id",
        "custom_provider_deployment_id",
        [
          "to_environment",
          1,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "current_provider_version_id",
              "instance_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "from_environment",
          1,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "current_provider_version_id",
              "instance_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "target_custom_provider_version",
          1,
          [
            1,
            [
              [
                "deployment",
                0,
                [
                  1,
                  [
                    "custom_provider_id",
                    "provider_id",
                    "custom_provider_version_id",
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "immutable_bucket",
                      1,
                      [
                        1,
                        [
                          "is_immutable",
                          "is_read_only",
                          [
                            "scm_repo_link",
                            1,
                            [
                              1,
                              [
                                "is_linked",
                                [
                                  "repository",
                                  0,
                                  [
                                    1,
                                    [
                                      "is_private",
                                      "default_branch",
                                      "created_at"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "actor",
                      0,
                      [1, ["organization_actor_id", "created_at"]]
                    ],
                    [
                      "scm_push",
                      1,
                      [
                        1,
                        [
                          ["actor", 0, [1, ["external_id"]]],
                          ["commit", 0, [1, ["created_at"]]],
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "environments",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "is_current_version_for_environment",
                      [
                        "environment",
                        0,
                        [
                          1,
                          [
                            "custom_provider_id",
                            "provider_id",
                            "current_provider_version_id",
                            "instance_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "custom_provider_id",
              "provider_id",
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "container_image",
                1,
                [
                  1,
                  [
                    "container_registry",
                    "container_image_tag",
                    "container_image"
                  ]
                ]
              ],
              "remote_mcp_server",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "previous_custom_provider_version",
          1,
          [
            1,
            [
              [
                "deployment",
                0,
                [
                  1,
                  [
                    "custom_provider_id",
                    "provider_id",
                    "custom_provider_version_id",
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "immutable_bucket",
                      1,
                      [
                        1,
                        [
                          "is_immutable",
                          "is_read_only",
                          [
                            "scm_repo_link",
                            1,
                            [
                              1,
                              [
                                "is_linked",
                                [
                                  "repository",
                                  0,
                                  [
                                    1,
                                    [
                                      "is_private",
                                      "default_branch",
                                      "created_at"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "actor",
                      0,
                      [1, ["organization_actor_id", "created_at"]]
                    ],
                    [
                      "scm_push",
                      1,
                      [
                        1,
                        [
                          ["actor", 0, [1, ["external_id"]]],
                          ["commit", 0, [1, ["created_at"]]],
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "environments",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "is_current_version_for_environment",
                      [
                        "environment",
                        0,
                        [
                          1,
                          [
                            "custom_provider_id",
                            "provider_id",
                            "current_provider_version_id",
                            "instance_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "custom_provider_id",
              "provider_id",
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "container_image",
                1,
                [
                  1,
                  [
                    "container_registry",
                    "container_image_tag",
                    "container_image"
                  ]
                ]
              ],
              "remote_mcp_server",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
        [
          "scm_push",
          1,
          [
            1,
            [
              ["actor", 0, [1, ["external_id"]]],
              ["commit", 0, [1, ["created_at"]]],
              [
                "repository",
                0,
                [1, ["is_private", "default_branch", "created_at"]]
              ],
              "created_at"
            ]
          ]
        ],
        "created_at",
        "applied_at"
      ]
    ]
  ],
  1
);
var mapCustomProvidersCommitsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "custom_provider_version_id",
          "custom_provider_environment_id",
          "custom_provider_id",
          "provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapCustomProvidersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersCreateBody = /* @__PURE__ */ mapObject([
  [
    "from",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_ref",
              "remote_url",
              "oauth_config",
              [
                "repository",
                0,
                [3, [[0, [1, ["repository_id", "repository_url"]]]]]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapCustomProvidersDeploymentsGetLogsOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_deployment_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            ["logs", 0, [2, [1, [["timestamp", 0, 4]]]]],
            "created_at",
            "started_at",
            "ended_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersDeploymentsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_id",
            "provider_id",
            "custom_provider_version_id",
            ["commit", 0, [1, ["created_at"]]],
            [
              "immutable_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ],
            ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
            [
              "scm_push",
              1,
              [
                1,
                [
                  ["actor", 0, [1, ["external_id"]]],
                  ["commit", 0, [1, ["created_at"]]],
                  [
                    "repository",
                    0,
                    [1, ["is_private", "default_branch", "created_at"]]
                  ],
                  "created_at"
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersDeploymentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "custom_provider_version_id",
              ["commit", 0, [1, ["created_at"]]],
              [
                "immutable_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "scm_push",
                1,
                [
                  1,
                  [
                    ["actor", 0, [1, ["external_id"]]],
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "repository",
                      0,
                      [1, ["is_private", "default_branch", "created_at"]]
                    ],
                    "created_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersDeploymentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "custom_provider_version_id",
          "custom_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapCustomProvidersEnvironmentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "current_provider_version_id",
    "instance_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapCustomProvidersEnvironmentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "custom_provider_id",
        "provider_id",
        "current_provider_version_id",
        "instance_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapCustomProvidersEnvironmentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "custom_provider_version_id",
          "custom_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapCustomProvidersGetEnvOutput = /* @__PURE__ */ createMapper(0);
var mapCustomProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "draft",
                0,
                [
                  1,
                  [
                    [
                      "container_image",
                      1,
                      [
                        1,
                        [
                          "container_registry",
                          "container_image_tag",
                          "container_image"
                        ]
                      ]
                    ],
                    "remote_mcp_server"
                  ]
                ]
              ],
              [
                "scm_repo",
                1,
                [1, ["is_private", "default_branch", "created_at"]]
              ],
              [
                "provider",
                0,
                [
                  1,
                  [
                    [
                      "publisher",
                      0,
                      [1, ["image_url", "created_at", "updated_at"]]
                    ],
                    [
                      "current_version",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "is_current",
                          "specification_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              [
                "draft_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapCustomProvidersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapCustomProvidersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapCustomProvidersVersionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "deployment",
      0,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "custom_provider_version_id",
          ["commit", 0, [1, ["created_at"]]],
          [
            "immutable_bucket",
            1,
            [
              1,
              [
                "is_immutable",
                "is_read_only",
                [
                  "scm_repo_link",
                  1,
                  [
                    1,
                    [
                      "is_linked",
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "scm_push",
            1,
            [
              1,
              [
                ["actor", 0, [1, ["external_id"]]],
                ["commit", 0, [1, ["created_at"]]],
                [
                  "repository",
                  0,
                  [1, ["is_private", "default_branch", "created_at"]]
                ],
                "created_at"
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "environments",
      0,
      [
        2,
        [
          1,
          [
            "is_current_version_for_environment",
            [
              "environment",
              0,
              [
                1,
                [
                  "custom_provider_id",
                  "provider_id",
                  "current_provider_version_id",
                  "instance_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "custom_provider_id",
    "provider_id",
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "container_image",
      1,
      [1, ["container_registry", "container_image_tag", "container_image"]]
    ],
    "remote_mcp_server",
    "created_at",
    "updated_at"
  ],
  1
);
var mapCustomProvidersVersionsCreateBody = /* @__PURE__ */ mapObject([
  "custom_provider_id",
  [
    "from",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_ref",
              "remote_url",
              "oauth_config",
              [
                "repository",
                0,
                [3, [[0, [1, ["repository_id", "repository_url"]]]]]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapCustomProvidersVersionsGetEnvOutput = /* @__PURE__ */ createMapper(0);
var mapCustomProvidersVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "deployment",
      0,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "custom_provider_version_id",
          ["commit", 0, [1, ["created_at"]]],
          [
            "immutable_bucket",
            1,
            [
              1,
              [
                "is_immutable",
                "is_read_only",
                [
                  "scm_repo_link",
                  1,
                  [
                    1,
                    [
                      "is_linked",
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "scm_push",
            1,
            [
              1,
              [
                ["actor", 0, [1, ["external_id"]]],
                ["commit", 0, [1, ["created_at"]]],
                [
                  "repository",
                  0,
                  [1, ["is_private", "default_branch", "created_at"]]
                ],
                "created_at"
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "environments",
      0,
      [
        2,
        [
          1,
          [
            "is_current_version_for_environment",
            [
              "environment",
              0,
              [
                1,
                [
                  "custom_provider_id",
                  "provider_id",
                  "current_provider_version_id",
                  "instance_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "custom_provider_id",
    "provider_id",
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "container_image",
      1,
      [1, ["container_registry", "container_image_tag", "container_image"]]
    ],
    "remote_mcp_server",
    "created_at",
    "updated_at"
  ],
  1
);
var mapCustomProvidersVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "deployment",
          0,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "custom_provider_version_id",
              ["commit", 0, [1, ["created_at"]]],
              [
                "immutable_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "scm_push",
                1,
                [
                  1,
                  [
                    ["actor", 0, [1, ["external_id"]]],
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "repository",
                      0,
                      [1, ["is_private", "default_branch", "created_at"]]
                    ],
                    "created_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "environments",
          0,
          [
            2,
            [
              1,
              [
                "is_current_version_for_environment",
                [
                  "environment",
                  0,
                  [
                    1,
                    [
                      "custom_provider_id",
                      "provider_id",
                      "current_provider_version_id",
                      "instance_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "custom_provider_id",
        "provider_id",
        ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
        [
          "container_image",
          1,
          [
            1,
            ["container_registry", "container_image_tag", "container_image"]
          ]
        ],
        "remote_mcp_server",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapCustomProvidersVersionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          "custom_provider_id",
          "custom_provider_deployment_id",
          "custom_provider_environment_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardBootOutput = /* @__PURE__ */ mapObject(
  [
    [
      "user",
      0,
      [
        1,
        ["first_name", "last_name", "image_url", "created_at", "updated_at"]
      ]
    ],
    [
      "organizations",
      0,
      [
        2,
        [
          3,
          [
            [
              0,
              [
                1,
                [
                  "image_url",
                  "magic_mcp_origin",
                  "created_at",
                  "updated_at",
                  [
                    "member",
                    0,
                    [
                      1,
                      [
                        "user_id",
                        "organization_id",
                        "actor_id",
                        "last_active_at",
                        "created_at",
                        "updated_at",
                        "deleted_at",
                        [
                          "actor",
                          0,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  [
                    "namespaces",
                    0,
                    [
                      2,
                      [1, [["namespace", 0, 8], "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "projects",
      0,
      [
        2,
        [
          3,
          [
            [
              0,
              [
                1,
                [
                  "organization_id",
                  "created_at",
                  "updated_at",
                  [
                    "organization",
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "magic_mcp_origin",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "instances",
      0,
      [
        2,
        [
          3,
          [
            [
              0,
              [
                1,
                [
                  "organization_id",
                  "sandbox_id",
                  "created_at",
                  "updated_at",
                  [
                    "project",
                    0,
                    [1, ["organization_id", "created_at", "updated_at"]]
                  ],
                  [
                    "organization",
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "magic_mcp_origin",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "consumers",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "organization",
              0,
              [
                1,
                ["image_url", "magic_mcp_origin", "created_at", "updated_at"]
              ]
            ],
            [
              "profiles",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "organization",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "magic_mcp_origin",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "instance",
                      0,
                      [
                        1,
                        [
                          "organization_id",
                          "sandbox_id",
                          "created_at",
                          "updated_at",
                          [
                            "project",
                            0,
                            [
                              1,
                              ["organization_id", "created_at", "updated_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ],
                    [
                      "profile",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["surface", 0, 8],
                    [
                      "portal",
                      0,
                      [
                        1,
                        [
                          [
                            "namespaces",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  ["namespace", 0, 8],
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardBootBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceAgentsGetOutput = /* @__PURE__ */ mapObject(
  ["actor_id", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceAgentsInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "agent_id",
    [
      "agent_client",
      1,
      [1, ["created_at", "updated_at", "last_connected_at"]]
    ],
    "created_at",
    "updated_at",
    "last_connected_at"
  ],
  1
);
var mapDashboardInstanceAgentsInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "agent_id",
        [
          "agent_client",
          1,
          [1, ["created_at", "updated_at", "last_connected_at"]]
        ],
        "created_at",
        "updated_at",
        "last_connected_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceAgentsInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["agent_client_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapDashboardInstanceAgentsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["actor_id", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapDashboardInstanceAgentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceAssistantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "owner_type",
    "organization_id",
    [
      "default_model",
      1,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "available_models",
      1,
      [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceAssistantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "owner_type",
        "organization_id",
        [
          "default_model",
          1,
          [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
        ],
        [
          "available_models",
          1,
          [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceAssistantsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceCallbackEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_trigger_key",
    "mapped_type",
    "mapped_id",
    "callback_id",
    "callback_instance_id",
    ["details", 0, [1, [["webhook", 0, [1, ["received_at"]]]]]],
    "occurred_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceCallbackEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_trigger_key",
        "mapped_type",
        "mapped_id",
        "callback_id",
        "callback_instance_id",
        "occurred_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCallbackEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "callback_id",
          "callback_instance_id",
          "integration_id",
          "integration_provider_id",
          "provider_id",
          "provider_trigger_key",
          ["occurred_at", 1, 5],
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceCallbackInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "callback_id",
    "integration_instance_id",
    "integration_instance_provider_id",
    "created_at",
    "updated_at",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapDashboardInstanceCallbackInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "callback_id",
        "integration_instance_id",
        "integration_instance_provider_id",
        "created_at",
        "updated_at",
        ["sync", 0, [1, ["synced_at"]]]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCallbackInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "callback_id",
          "integration_id",
          "integration_instance_id",
          "integration_instance_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceCallbacksCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapDashboardInstanceCallbacksCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "integration_provider_id"
]);
var mapDashboardInstanceCallbacksDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapDashboardInstanceCallbacksGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapDashboardInstanceCallbacksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_provider_id",
        ["provider", 0, 8],
        "created_at",
        "updated_at",
        "auth_credentials_is_managed",
        ["sync", 0, [1, ["synced_at"]]]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCallbacksListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "integration_provider_id",
          "provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceCallbacksUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapDashboardInstanceCallbacksUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceChatConnectionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatConnectionsCreateBody = /* @__PURE__ */ mapObject([
  "private_metadata",
  [
    "provider",
    0,
    [
      1,
      [
        "provider_id",
        "provider_deployment_id",
        "provider_auth_method_id",
        "provider_auth_credentials_id",
        "provider_config_id"
      ]
    ]
  ]
]);
var mapDashboardInstanceChatConnectionsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                ["provider", 0, 8],
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_method_id",
                "auth_credentials_id",
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                "manual_webhook_trigger_groups"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatConnectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceChatConnectionsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatConnectionsUpdateBody = /* @__PURE__ */ mapObject([
  "private_metadata"
]);
var mapDashboardInstanceChatEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    "chat_id",
    "channel_id",
    "thread_id",
    "message_id",
    "author_id",
    "provider_event_id",
    "provider_channel_id",
    "provider_thread_id",
    "provider_message_id",
    "provider_author_id",
    "occurred_at",
    "created_at",
    ["error", 0, [1, ["provider_code", "retry_after_ms"]]]
  ],
  1
);
var mapDashboardInstanceChatEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        "chat_id",
        "channel_id",
        "thread_id",
        "message_id",
        "author_id",
        "provider_event_id",
        "provider_channel_id",
        "provider_thread_id",
        "provider_message_id",
        "provider_author_id",
        "occurred_at",
        "created_at",
        ["error", 0, [1, ["provider_code", "retry_after_ms"]]]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "chat_id",
          "chat_connection_id",
          "chat_instance_id",
          ["created_at", 1, 5],
          ["occurred_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceChatInstancesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatInstancesCreateBody = /* @__PURE__ */ mapObject([
  "chat_connection_id",
  "private_metadata",
  "identity_actor_id",
  "identity_id"
]);
var mapDashboardInstanceChatInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [1, ["chat_connection_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]
    ]
  ]
]);
var mapDashboardInstanceChatInstancesProviderAuthenticatedUserOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_type",
    "provider_author_id",
    "user_name",
    "full_name",
    "image_url",
    "is_self",
    ["workspace", 0, [1, ["provider_workspace_id", "image_url"]]]
  ]
);
var mapDashboardInstanceChatInstancesProviderGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_instance_id",
    "chat_connection_provider_id",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatInstancesProviderSetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_instance_id",
    "chat_connection_provider_id",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatInstancesProviderSetBody = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_deployment_id",
  "provider_config_id",
  "provider_auth_config_id"
]);
var mapDashboardInstanceChatInstancesSyncOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatInstancesUpdateBody = /* @__PURE__ */ mapObject([
  "private_metadata"
]);
var mapDashboardInstanceChatWorkspacesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_workspace_id",
    "image_url",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatWorkspacesGetQuery = /* @__PURE__ */ mapObject([
  "chat_instance_id"
]);
var mapDashboardInstanceChatWorkspacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "provider_workspace_id",
        "image_url",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatWorkspacesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["chat_instance_id"]]]]
]);
var mapDashboardInstanceChatsChannelsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "workspace_id",
    "provider_type",
    "provider_channel_id",
    "has_access",
    [
      "recipient",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    "member_count",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapDashboardInstanceChatsChannelsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "workspace_id",
        "provider_type",
        "provider_channel_id",
        "has_access",
        [
          "recipient",
          0,
          [
            1,
            [
              "chat_id",
              "provider_type",
              "provider_author_id",
              "user_name",
              "full_name",
              "image_url",
              "is_self",
              "created_at",
              "updated_at",
              "last_interaction_at"
            ]
          ]
        ],
        "member_count",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatsChannelsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["workspace_id", "has_access"]]]]
]);
var mapDashboardInstanceChatsChannelsMembersGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_type",
    "provider_author_id",
    "user_name",
    "full_name",
    "image_url",
    "is_self",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapDashboardInstanceChatsChannelsMembersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "provider_type",
        "provider_author_id",
        "user_name",
        "full_name",
        "image_url",
        "is_self",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatsChannelsMembersListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceChatsChannelsTypingStartOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceChatsChannelsTypingStartBody = /* @__PURE__ */ mapObject([
  "thread_id"
]);
var mapDashboardInstanceChatsCommandsRespondOutput = /* @__PURE__ */ mapObject(
  [
    [
      "message",
      0,
      [
        1,
        [
          "chat_id",
          "channel_id",
          "thread_id",
          "provider_type",
          "provider_message_id",
          "provider_reply_to_message_id",
          [
            "author",
            0,
            [
              1,
              [
                "chat_id",
                "provider_type",
                "provider_author_id",
                "user_name",
                "full_name",
                "image_url",
                "is_self",
                "created_at",
                "updated_at",
                "last_interaction_at"
              ]
            ]
          ],
          [
            "attachments",
            0,
            [
              2,
              [
                1,
                [
                  "provider_attachment_id",
                  "mime_type",
                  "file_id",
                  "download_url",
                  "created_at"
                ]
              ]
            ]
          ],
          "sent_at",
          "edited_at",
          "created_at",
          "updated_at",
          "last_interaction_at",
          "deleted_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatsCommandsRespondBody = /* @__PURE__ */ mapObject([
  "chat_event_id",
  "alt_text"
]);
var mapDashboardInstanceChatsDmsOpenOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "workspace_id",
    "provider_type",
    "provider_channel_id",
    "has_access",
    [
      "recipient",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    "member_count",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapDashboardInstanceChatsDmsOpenBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["user", 0, [3, [[0, [1, ["phone_number", "user_id"]]]]]],
          ["users", 0, [3, [[0, [1, ["phone_numbers", "user_ids"]]]]]]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceChatsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    "chat_instance_id",
    "chat_instance_provider_id",
    "provider_id",
    "workspace_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceChatsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        "chat_instance_id",
        "chat_instance_provider_id",
        "provider_id",
        "workspace_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "chat_connection_id",
          "chat_instance_id",
          "chat_instance_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceChatsMessagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceChatsMessagesCreateBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "thread_id",
  "alt_text",
  ["attachments", 0, [2, [1, ["file_id"]]]],
  "reply_message_id",
  "ephemeral_target_user_id"
]);
var mapDashboardInstanceChatsMessagesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceChatsMessagesDeleteQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapDashboardInstanceChatsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceChatsMessagesGetQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapDashboardInstanceChatsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "channel_id",
        "thread_id",
        "provider_type",
        "provider_message_id",
        "provider_reply_to_message_id",
        [
          "author",
          0,
          [
            1,
            [
              "chat_id",
              "provider_type",
              "provider_author_id",
              "user_name",
              "full_name",
              "image_url",
              "is_self",
              "created_at",
              "updated_at",
              "last_interaction_at"
            ]
          ]
        ],
        [
          "attachments",
          0,
          [
            2,
            [
              1,
              [
                "provider_attachment_id",
                "mime_type",
                "file_id",
                "download_url",
                "created_at"
              ]
            ]
          ]
        ],
        "sent_at",
        "edited_at",
        "created_at",
        "updated_at",
        "last_interaction_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatsMessagesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["channel_id", "thread_id"]]]]
]);
var mapDashboardInstanceChatsMessagesReactionsCreateOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceChatsMessagesReactionsCreateBody = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapDashboardInstanceChatsMessagesReactionsDeleteOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceChatsMessagesReactionsDeleteQuery = /* @__PURE__ */ mapObject(
  ["channel_id"]
);
var mapDashboardInstanceChatsMessagesReactionsListOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceChatsMessagesReactionsListQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapDashboardInstanceChatsMessagesReadOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceChatsMessagesReadBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "thread_id"
]);
var mapDashboardInstanceChatsMessagesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceChatsMessagesUpdateBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "alt_text"
]);
var mapDashboardInstanceChatsThreadsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "provider_type",
    "provider_thread_id",
    "provider_root_message_id",
    "reply_count",
    "last_reply_at",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapDashboardInstanceChatsThreadsGetQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapDashboardInstanceChatsThreadsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "channel_id",
        "provider_type",
        "provider_thread_id",
        "provider_root_message_id",
        "reply_count",
        "last_reply_at",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceChatsThreadsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["channel_id"]]]]
]);
var mapDashboardInstanceConsumerSurfacesGetOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_authoring",
    "allow_consumer_skill_publishing",
    [
      "skill_configuration",
      1,
      [
        1,
        [
          "is_default",
          "allow_scripts",
          "allowed_file_extensions",
          "allow_non_standard_directories"
        ]
      ]
    ],
    ["auth", 0, [1, ["session_expiry_time_in_seconds", "email_whitelist"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceConsumerSurfacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "allow_consumer_skill_authoring",
        "allow_consumer_skill_publishing",
        [
          "skill_configuration",
          1,
          [
            1,
            [
              "is_default",
              "allow_scripts",
              "allowed_file_extensions",
              "allow_non_standard_directories"
            ]
          ]
        ],
        [
          "auth",
          0,
          [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumerSurfacesListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceConsumersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumersCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceConsumersGetMemberConsumerOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            [
              "profile",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "consumer_id",
                        "user_id",
                        "created_at",
                        "updated_at",
                        [
                          "groups",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                [
                                  "group",
                                  0,
                                  [
                                    1,
                                    ["is_default", "created_at", "updated_at"]
                                  ]
                                ],
                                "assigned_via"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumersGetMemberConsumerBody = /* @__PURE__ */ mapObject([
  "surface_identifier"
]);
var mapDashboardInstanceConsumersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "user_id",
              "created_at",
              "updated_at",
              "is_portal_consumer",
              "is_organization_member",
              "is_service_account"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumersListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceConsumersProfilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumersProfilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "consumer_id",
              "user_id",
              "created_at",
              "updated_at",
              [
                "groups",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "group",
                        0,
                        [1, ["is_default", "created_at", "updated_at"]]
                      ],
                      "assigned_via"
                    ]
                  ]
                ]
              ],
              "is_service_account",
              [
                "surface",
                0,
                [
                  1,
                  [
                    "allow_consumer_skill_authoring",
                    "allow_consumer_skill_publishing",
                    [
                      "skill_configuration",
                      1,
                      [
                        1,
                        [
                          "is_default",
                          "allow_scripts",
                          "allowed_file_extensions",
                          "allow_non_standard_directories"
                        ]
                      ]
                    ],
                    [
                      "auth",
                      0,
                      [
                        1,
                        ["session_expiry_time_in_seconds", "email_whitelist"]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumersProfilesListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceConsumersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConsumersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceConversationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceConversationsCreateBody = /* @__PURE__ */ mapObject([
  "assistant_id"
]);
var mapDashboardInstanceConversationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceConversationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "assistant_id",
        "instance_id",
        "organization_id",
        [
          "created_by_actor",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "root_message_id",
        [
          "assistant",
          0,
          [
            1,
            [
              "owner_type",
              "organization_id",
              [
                "default_model",
                1,
                [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
              ],
              [
                "available_models",
                1,
                [
                  2,
                  [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConversationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["assistant_id"]]]]
]);
var mapDashboardInstanceConversationsMessagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceConversationsMessagesCreateBody = /* @__PURE__ */ mapObject([
  ["message", 0, [1, [["parts", 0, [2, [3, [[0, [1, ["media_type"]]]]]]]]]],
  "parent_message_id",
  "model_id"
]);
var mapDashboardInstanceConversationsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceConversationsMessagesHandoffResponsesOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceConversationsMessagesHandoffResponsesBody = /* @__PURE__ */ mapObject(
  [["responses", 0, [2, [1, ["tool_call_id"]]]]]
);
var mapDashboardInstanceConversationsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "conversation_item_id",
        "assistant_id",
        "parent_message_id",
        [
          "model",
          0,
          [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
        ],
        [
          "request",
          0,
          [
            1,
            [
              [
                "actor",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceConversationsMessagesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceConversationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceConversationsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceCustomProvidersArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapDashboardInstanceCustomProvidersCommitsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "custom_provider_deployment_id",
    [
      "to_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "from_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "target_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "previous_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "scm_push",
      1,
      [
        1,
        [
          ["actor", 0, [1, ["external_id"]]],
          ["commit", 0, [1, ["created_at"]]],
          [
            "repository",
            0,
            [1, ["is_private", "default_branch", "created_at"]]
          ],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "applied_at"
  ],
  1
);
var mapDashboardInstanceCustomProvidersCommitsCreateBody = /* @__PURE__ */ mapObject([
  [
    "action",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "from_environment_id",
              "to_environment_id",
              "environment_id",
              "version_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceCustomProvidersCommitsGetOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "custom_provider_deployment_id",
    [
      "to_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "from_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "target_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "previous_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "scm_push",
      1,
      [
        1,
        [
          ["actor", 0, [1, ["external_id"]]],
          ["commit", 0, [1, ["created_at"]]],
          [
            "repository",
            0,
            [1, ["is_private", "default_branch", "created_at"]]
          ],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "applied_at"
  ],
  1
);
var mapDashboardInstanceCustomProvidersCommitsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "custom_provider_id",
        "provider_id",
        "custom_provider_deployment_id",
        [
          "to_environment",
          1,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "current_provider_version_id",
              "instance_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "from_environment",
          1,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "current_provider_version_id",
              "instance_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "target_custom_provider_version",
          1,
          [
            1,
            [
              [
                "deployment",
                0,
                [
                  1,
                  [
                    "custom_provider_id",
                    "provider_id",
                    "custom_provider_version_id",
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "immutable_bucket",
                      1,
                      [
                        1,
                        [
                          "is_immutable",
                          "is_read_only",
                          [
                            "scm_repo_link",
                            1,
                            [
                              1,
                              [
                                "is_linked",
                                [
                                  "repository",
                                  0,
                                  [
                                    1,
                                    [
                                      "is_private",
                                      "default_branch",
                                      "created_at"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "actor",
                      0,
                      [1, ["organization_actor_id", "created_at"]]
                    ],
                    [
                      "scm_push",
                      1,
                      [
                        1,
                        [
                          ["actor", 0, [1, ["external_id"]]],
                          ["commit", 0, [1, ["created_at"]]],
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "environments",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "is_current_version_for_environment",
                      [
                        "environment",
                        0,
                        [
                          1,
                          [
                            "custom_provider_id",
                            "provider_id",
                            "current_provider_version_id",
                            "instance_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "custom_provider_id",
              "provider_id",
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "container_image",
                1,
                [
                  1,
                  [
                    "container_registry",
                    "container_image_tag",
                    "container_image"
                  ]
                ]
              ],
              "remote_mcp_server",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "previous_custom_provider_version",
          1,
          [
            1,
            [
              [
                "deployment",
                0,
                [
                  1,
                  [
                    "custom_provider_id",
                    "provider_id",
                    "custom_provider_version_id",
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "immutable_bucket",
                      1,
                      [
                        1,
                        [
                          "is_immutable",
                          "is_read_only",
                          [
                            "scm_repo_link",
                            1,
                            [
                              1,
                              [
                                "is_linked",
                                [
                                  "repository",
                                  0,
                                  [
                                    1,
                                    [
                                      "is_private",
                                      "default_branch",
                                      "created_at"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "actor",
                      0,
                      [1, ["organization_actor_id", "created_at"]]
                    ],
                    [
                      "scm_push",
                      1,
                      [
                        1,
                        [
                          ["actor", 0, [1, ["external_id"]]],
                          ["commit", 0, [1, ["created_at"]]],
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "environments",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "is_current_version_for_environment",
                      [
                        "environment",
                        0,
                        [
                          1,
                          [
                            "custom_provider_id",
                            "provider_id",
                            "current_provider_version_id",
                            "instance_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "custom_provider_id",
              "provider_id",
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "container_image",
                1,
                [
                  1,
                  [
                    "container_registry",
                    "container_image_tag",
                    "container_image"
                  ]
                ]
              ],
              "remote_mcp_server",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
        [
          "scm_push",
          1,
          [
            1,
            [
              ["actor", 0, [1, ["external_id"]]],
              ["commit", 0, [1, ["created_at"]]],
              [
                "repository",
                0,
                [1, ["is_private", "default_branch", "created_at"]]
              ],
              "created_at"
            ]
          ]
        ],
        "created_at",
        "applied_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersCommitsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_version_id",
            "custom_provider_environment_id",
            "custom_provider_id",
            "provider_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceCustomProvidersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersCreateBody = /* @__PURE__ */ mapObject([
  [
    "from",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_ref",
              "remote_url",
              "oauth_config",
              [
                "repository",
                0,
                [3, [[0, [1, ["repository_id", "repository_url"]]]]]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceCustomProvidersDeploymentsGetLogsOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_deployment_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            ["logs", 0, [2, [1, [["timestamp", 0, 4]]]]],
            "created_at",
            "started_at",
            "ended_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersDeploymentsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_id",
            "provider_id",
            "custom_provider_version_id",
            ["commit", 0, [1, ["created_at"]]],
            [
              "immutable_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ],
            ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
            [
              "scm_push",
              1,
              [
                1,
                [
                  ["actor", 0, [1, ["external_id"]]],
                  ["commit", 0, [1, ["created_at"]]],
                  [
                    "repository",
                    0,
                    [1, ["is_private", "default_branch", "created_at"]]
                  ],
                  "created_at"
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersDeploymentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "custom_provider_version_id",
              ["commit", 0, [1, ["created_at"]]],
              [
                "immutable_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "scm_push",
                1,
                [
                  1,
                  [
                    ["actor", 0, [1, ["external_id"]]],
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "repository",
                      0,
                      [1, ["is_private", "default_branch", "created_at"]]
                    ],
                    "created_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersDeploymentsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_version_id",
            "custom_provider_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceCustomProvidersEnvironmentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "current_provider_version_id",
    "instance_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceCustomProvidersEnvironmentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "custom_provider_id",
        "provider_id",
        "current_provider_version_id",
        "instance_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersEnvironmentsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_version_id",
            "custom_provider_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceCustomProvidersGetEnvOutput = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceCustomProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "draft",
                0,
                [
                  1,
                  [
                    [
                      "container_image",
                      1,
                      [
                        1,
                        [
                          "container_registry",
                          "container_image_tag",
                          "container_image"
                        ]
                      ]
                    ],
                    "remote_mcp_server"
                  ]
                ]
              ],
              [
                "scm_repo",
                1,
                [1, ["is_private", "default_branch", "created_at"]]
              ],
              [
                "provider",
                0,
                [
                  1,
                  [
                    [
                      "publisher",
                      0,
                      [1, ["image_url", "created_at", "updated_at"]]
                    ],
                    [
                      "current_version",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "is_current",
                          "specification_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              [
                "draft_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapDashboardInstanceCustomProvidersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceCustomProvidersVersionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "deployment",
      0,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "custom_provider_version_id",
          ["commit", 0, [1, ["created_at"]]],
          [
            "immutable_bucket",
            1,
            [
              1,
              [
                "is_immutable",
                "is_read_only",
                [
                  "scm_repo_link",
                  1,
                  [
                    1,
                    [
                      "is_linked",
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "scm_push",
            1,
            [
              1,
              [
                ["actor", 0, [1, ["external_id"]]],
                ["commit", 0, [1, ["created_at"]]],
                [
                  "repository",
                  0,
                  [1, ["is_private", "default_branch", "created_at"]]
                ],
                "created_at"
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "environments",
      0,
      [
        2,
        [
          1,
          [
            "is_current_version_for_environment",
            [
              "environment",
              0,
              [
                1,
                [
                  "custom_provider_id",
                  "provider_id",
                  "current_provider_version_id",
                  "instance_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "custom_provider_id",
    "provider_id",
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "container_image",
      1,
      [1, ["container_registry", "container_image_tag", "container_image"]]
    ],
    "remote_mcp_server",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceCustomProvidersVersionsCreateBody = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    [
      "from",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "image_ref",
                "remote_url",
                "oauth_config",
                [
                  "repository",
                  0,
                  [3, [[0, [1, ["repository_id", "repository_url"]]]]]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceCustomProvidersVersionsGetEnvOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceCustomProvidersVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "deployment",
      0,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "custom_provider_version_id",
          ["commit", 0, [1, ["created_at"]]],
          [
            "immutable_bucket",
            1,
            [
              1,
              [
                "is_immutable",
                "is_read_only",
                [
                  "scm_repo_link",
                  1,
                  [
                    1,
                    [
                      "is_linked",
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "scm_push",
            1,
            [
              1,
              [
                ["actor", 0, [1, ["external_id"]]],
                ["commit", 0, [1, ["created_at"]]],
                [
                  "repository",
                  0,
                  [1, ["is_private", "default_branch", "created_at"]]
                ],
                "created_at"
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "environments",
      0,
      [
        2,
        [
          1,
          [
            "is_current_version_for_environment",
            [
              "environment",
              0,
              [
                1,
                [
                  "custom_provider_id",
                  "provider_id",
                  "current_provider_version_id",
                  "instance_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "custom_provider_id",
    "provider_id",
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "container_image",
      1,
      [1, ["container_registry", "container_image_tag", "container_image"]]
    ],
    "remote_mcp_server",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceCustomProvidersVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "deployment",
          0,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "custom_provider_version_id",
              ["commit", 0, [1, ["created_at"]]],
              [
                "immutable_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "scm_push",
                1,
                [
                  1,
                  [
                    ["actor", 0, [1, ["external_id"]]],
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "repository",
                      0,
                      [1, ["is_private", "default_branch", "created_at"]]
                    ],
                    "created_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "environments",
          0,
          [
            2,
            [
              1,
              [
                "is_current_version_for_environment",
                [
                  "environment",
                  0,
                  [
                    1,
                    [
                      "custom_provider_id",
                      "provider_id",
                      "current_provider_version_id",
                      "instance_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "custom_provider_id",
        "provider_id",
        ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
        [
          "container_image",
          1,
          [
            1,
            ["container_registry", "container_image_tag", "container_image"]
          ]
        ],
        "remote_mcp_server",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceCustomProvidersVersionsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_version_id",
            "custom_provider_id",
            "custom_provider_deployment_id",
            "custom_provider_environment_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceDocumentsCloneOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceDocumentsCloneBody = /* @__PURE__ */ mapObject([
  "target_document_id"
]);
var mapDashboardInstanceDocumentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceDocumentsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceDocumentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceDocumentsEditTokenGetOutput = /* @__PURE__ */ mapObject(
  ["expires_at", "document_id"],
  1
);
var mapDashboardInstanceDocumentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceDocumentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "file_id",
        "parent_document_id",
        "current_version_id",
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceDocumentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "file_id",
          "store_id",
          "parent_document_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceDocumentsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "edit_count",
    "last_edited_at",
    "last_viewed_at",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceDocumentsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "edit_count",
        "last_edited_at",
        "last_viewed_at",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceDocumentsParticipantsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceDocumentsPermissionsGetOutput = /* @__PURE__ */ mapObject([
  "document_id",
  "is_owner",
  "has_full_access",
  "relevant_store_ids",
  "readable_store_ids",
  "writable_store_ids"
]);
var mapDashboardInstanceDocumentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceDocumentsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceDocumentsVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "document_id",
    "version_number",
    "previous_version_id",
    "list_edited_at",
    [
      "editors",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            [
              "organization_actor",
              1,
              [
                1,
                [
                  "organization_id",
                  "image_url",
                  [
                    "teams",
                    0,
                    [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "consumer",
              0,
              [1, ["image_url", "user_id", "created_at", "updated_at"]]
            ],
            [
              "consumer_profile",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "consumer_id",
                        "user_id",
                        "created_at",
                        "updated_at",
                        [
                          "groups",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                [
                                  "group",
                                  0,
                                  [
                                    1,
                                    ["is_default", "created_at", "updated_at"]
                                  ]
                                ],
                                "assigned_via"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceDocumentsVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "document_id",
        "version_number",
        "previous_version_id",
        "list_edited_at",
        [
          "editors",
          0,
          [
            2,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceDocumentsVersionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["last_edited_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceFilesDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "file_name",
            "file_size",
            "file_type",
            [
              "created_by",
              1,
              [
                1,
                [
                  "image_url",
                  [
                    "organization_actor",
                    1,
                    [
                      1,
                      [
                        "organization_id",
                        "image_url",
                        [
                          "teams",
                          0,
                          [
                            2,
                            [1, ["assignment_id", "created_at", "updated_at"]]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "consumer",
                    0,
                    [1, ["image_url", "user_id", "created_at", "updated_at"]]
                  ],
                  [
                    "consumer_profile",
                    1,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "consumer_id",
                              "user_id",
                              "created_at",
                              "updated_at",
                              [
                                "groups",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      [
                                        "group",
                                        0,
                                        [
                                          1,
                                          [
                                            "is_default",
                                            "created_at",
                                            "updated_at"
                                          ]
                                        ]
                                      ],
                                      "assigned_via"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "download_url"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceFilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "file_name",
            "file_size",
            "file_type",
            [
              "created_by",
              1,
              [
                1,
                [
                  "image_url",
                  [
                    "organization_actor",
                    1,
                    [
                      1,
                      [
                        "organization_id",
                        "image_url",
                        [
                          "teams",
                          0,
                          [
                            2,
                            [1, ["assignment_id", "created_at", "updated_at"]]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "consumer",
                    0,
                    [1, ["image_url", "user_id", "created_at", "updated_at"]]
                  ],
                  [
                    "consumer_profile",
                    1,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "consumer_id",
                              "user_id",
                              "created_at",
                              "updated_at",
                              [
                                "groups",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      [
                                        "group",
                                        0,
                                        [
                                          1,
                                          [
                                            "is_default",
                                            "created_at",
                                            "updated_at"
                                          ]
                                        ]
                                      ],
                                      "assigned_via"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "download_url"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceFilesLinksCreateOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapDashboardInstanceFilesLinksCreateBody = /* @__PURE__ */ mapObject(
  ["file_id", "expires_at"],
  1
);
var mapDashboardInstanceFilesLinksDeleteOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapDashboardInstanceFilesLinksGetOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapDashboardInstanceFilesLinksListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["file_id", "created_at", "expires_at"]]],
  1
);
var mapDashboardInstanceFilesLinksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["file_id"]]]]
]);
var mapDashboardInstanceFilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "download_url"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceFilesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "store_id",
          "document_id",
          "file_link_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceFirewallsCreateOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceFirewallsCreateBody = /* @__PURE__ */ mapObject([
  "network_policy_ids"
]);
var mapDashboardInstanceFirewallsDeleteOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceFirewallsGetOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceFirewallsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["network_policies", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapDashboardInstanceFirewallsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "enclave_id",
          "provider_id",
          "network_policy_id",
          "machine_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceFirewallsNetworkPoliciesAttachOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceFirewallsNetworkPoliciesAttachBody = /* @__PURE__ */ mapObject(
  ["network_policy_id"]
);
var mapDashboardInstanceFirewallsNetworkPoliciesDetachOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceFirewallsUpdateOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceFirewallsUpdateBody = /* @__PURE__ */ mapObject([
  "network_policy_ids"
]);
var mapDashboardInstanceIdentitiesCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesCreateBody = /* @__PURE__ */ mapObject([
  "actor_id",
  [
    "credentials",
    0,
    [
      2,
      [
        1,
        [
          "deployment_id",
          "config_id",
          "auth_config_id",
          "delegation_config_id"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceIdentitiesCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesCredentialsCreateBody = /* @__PURE__ */ mapObject([
  "identity_id",
  "deployment_id",
  "config_id",
  "auth_config_id",
  "delegation_config_id"
]);
var mapDashboardInstanceIdentitiesCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesCredentialsGetOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "identity_id",
        "provider_id",
        "deployment_id",
        "config_id",
        "auth_config_id",
        "delegation_config_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentitiesCredentialsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "actor_id",
            "identity_id",
            "provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIdentitiesCredentialsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesCredentialsUpdateBody = /* @__PURE__ */ mapObject([
  "delegation_config_id"
]);
var mapDashboardInstanceIdentitiesDelegationConfigsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationConfigsCreateBody = /* @__PURE__ */ mapObject(
  ["sub_delegation_behavior", "sub_delegation_depth"]
);
var mapDashboardInstanceIdentitiesDelegationConfigsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationConfigsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        "sub_delegation_behavior",
        "sub_delegation_depth",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationConfigsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIdentitiesDelegationConfigsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationConfigsUpdateBody = /* @__PURE__ */ mapObject(
  ["sub_delegation_behavior", "sub_delegation_depth"]
);
var mapDashboardInstanceIdentitiesDelegationRequestsApproveOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationRequestsApproveQuery = /* @__PURE__ */ mapObject(
  ["allow_deleted"]
);
var mapDashboardInstanceIdentitiesDelegationRequestsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationRequestsCreateBody = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "requester_actor_id",
    "delegator_actor_id",
    "expires_at",
    "delegation_config_id",
    ["credential_overrides", 1, [2, [1, ["credential_id", "expires_at"]]]]
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationRequestsDenyOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationRequestsDenyQuery = /* @__PURE__ */ mapObject(
  ["allow_deleted"]
);
var mapDashboardInstanceIdentitiesDelegationRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationRequestsGetQuery = /* @__PURE__ */ mapObject(
  ["allow_deleted"]
);
var mapDashboardInstanceIdentitiesDelegationRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "denied_reason",
        [
          "requester",
          0,
          [
            1,
            [
              "agent_id",
              "consumer_id",
              "default_identity_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "identity_id",
        [
          "delegation",
          0,
          [
            1,
            [
              "denied_reason",
              "delegation_level",
              ["attestation", 0, [1, ["created_at"]]],
              "delegation_config_id",
              [
                "parties",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "actor",
                        0,
                        [
                          1,
                          [
                            "agent_id",
                            "consumer_id",
                            "default_identity_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ]
              ],
              [
                "request",
                0,
                [
                  1,
                  [
                    "denied_reason",
                    [
                      "requester",
                      0,
                      [
                        1,
                        [
                          "agent_id",
                          "consumer_id",
                          "default_identity_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "identity_id",
                    "expires_at",
                    "created_at"
                  ]
                ]
              ],
              [
                "credential_overrides",
                1,
                [2, [1, ["credential_id", "created_at", "expires_at"]]]
              ],
              "created_at",
              "expires_at",
              "revoked_at"
            ]
          ]
        ],
        "expires_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationRequestsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "actor_id",
            "identity_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIdentitiesDelegationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationsCreateBody = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "delegator_actor_id",
    "delegatee_actor_id",
    "expires_at",
    "delegation_config_id",
    ["credential_overrides", 1, [2, [1, ["credential_id", "expires_at"]]]]
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "denied_reason",
        "delegation_level",
        ["attestation", 0, [1, ["created_at"]]],
        "delegation_config_id",
        [
          "parties",
          0,
          [
            2,
            [
              1,
              [
                [
                  "actor",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ]
        ],
        [
          "request",
          0,
          [
            1,
            [
              "denied_reason",
              [
                "requester",
                0,
                [
                  1,
                  [
                    "agent_id",
                    "consumer_id",
                    "default_identity_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "identity_id",
              "expires_at",
              "created_at"
            ]
          ]
        ],
        [
          "credential_overrides",
          1,
          [2, [1, ["credential_id", "created_at", "expires_at"]]]
        ],
        "created_at",
        "expires_at",
        "revoked_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentitiesDelegationsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "owner_actor_id",
            "delegator_actor_id",
            "delegatee_actor_id",
            "identity_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIdentitiesDelegationsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "owner",
          0,
          [
            1,
            [
              [
                "actor",
                0,
                [
                  1,
                  [
                    "agent_id",
                    "consumer_id",
                    "default_identity_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "credentials",
          0,
          [
            2,
            [
              1,
              [
                "identity_id",
                "provider_id",
                "deployment_id",
                "config_id",
                "auth_config_id",
                "delegation_config_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "delegation_config_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentitiesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["agent_id", "actor_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapDashboardInstanceIdentitiesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIdentitiesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceIdentityActorsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentityActorsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceIdentityActorsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentityActorsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentityActorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "agent_id",
              "consumer_id",
              "default_identity_id",
              "created_at",
              "updated_at",
              [
                "consumer",
                0,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "user_id",
                          "created_at",
                          "updated_at",
                          "is_portal_consumer",
                          "is_organization_member",
                          "is_service_account"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentityActorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceIdentityActorsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIdentityActorsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceIncomingWebhooksGetOutput = /* @__PURE__ */ mapObject(
  ["attempt_count", "webhook_registration_id", "provider_id", "received_at"],
  1
);
var mapDashboardInstanceIncomingWebhooksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "attempt_count",
        "webhook_registration_id",
        "provider_id",
        "received_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIncomingWebhooksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["webhook_registration_id", "provider_id"]]]]
]);
var mapDashboardInstanceIntegrationEnclavesGetLastUsedOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "internet_gateway_id",
        "provider_deployment_id",
        ["enclave_environment", 1, [1, ["created_at"]]],
        "created_at",
        "last_used_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationEnclavesGetLastUsedQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceIntegrationEnclavesGetOutput = /* @__PURE__ */ mapObject(
  [
    "internet_gateway_id",
    "provider_deployment_id",
    ["enclave_environment", 1, [1, ["created_at"]]],
    "created_at",
    "last_used_at"
  ],
  1
);
var mapDashboardInstanceIntegrationEnclavesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "internet_gateway_id",
        "provider_deployment_id",
        ["enclave_environment", 1, [1, ["created_at"]]],
        "created_at",
        "last_used_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationEnclavesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "internet_gateway_id",
          "provider_deployment_id",
          "provider_id",
          "firewall_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceIntegrationFirewallAssignmentsCreateOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapDashboardInstanceIntegrationFirewallAssignmentsCreateBody = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["firewall_id", "target_type", "enclave_id", "provider_id"]]]]]
);
var mapDashboardInstanceIntegrationFirewallAssignmentsDeleteOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapDashboardInstanceIntegrationFirewallAssignmentsGetOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapDashboardInstanceIntegrationFirewallAssignmentsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["target_type", "created_at"]]],
  1
);
var mapDashboardInstanceIntegrationFirewallAssignmentsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "firewall_id",
            "enclave_id",
            "provider_id",
            "internet_gateway_id",
            "target_type",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationInternetGatewayGetOutput = /* @__PURE__ */ mapObject(
  ["created_at", "updated_at", ["public_ips", 1, [2, 8]]],
  1
);
var mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput = /* @__PURE__ */ mapObject(
  [
    "enclave_ids",
    [
      "records",
      0,
      [
        2,
        [
          1,
          [
            "enclave_id",
            "bucket_start",
            ["first_seen_at", 1, 0],
            ["last_seen_at", 1, 0]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery = /* @__PURE__ */ mapObject(
  ["enclave_id", "interval_minutes"]
);
var mapDashboardInstanceIntegrationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsCreateBody = /* @__PURE__ */ mapObject([
  "use_integration_name_in_tool_names",
  "can_attach_custom_tool_filters",
  "can_attach_custom_provider_config",
  "can_override_tool_filters",
  "enable_callback_tools"
]);
var mapDashboardInstanceIntegrationsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceIntegrationsInstanceGroupsCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsCreateBody = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [2, [1, ["integration_instance_provider_id", "tool_filters"]]]
    ]
  ]
);
var mapDashboardInstanceIntegrationsInstanceGroupsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsGetOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                "integration_instance_group_id",
                "integration_instance_id",
                "integration_provider_id",
                "integration_instance_provider_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "is_override_tool_filter",
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            "integration_instance_provider_id",
            "provider_id",
            "integration_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_instance_group_id",
        "integration_instance_id",
        "integration_provider_id",
        "integration_instance_provider_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "is_override_tool_filter",
        "created_at",
        "updated_at",
        "archived_at",
        ["provider", 0, 8],
        [
          "integration_provider",
          1,
          [
            1,
            [
              "provider_version",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "deployment_id",
              "auth_method_id",
              "auth_credentials_id",
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        [
          "integration_instance_provider",
          1,
          [
            1,
            [
              "integration_id",
              "integration_instance_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "is_override_tool_filter",
              ["provider", 0, 8],
              [
                "integration_provider",
                1,
                [
                  1,
                  [
                    "provider_version",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    "provider_id",
                    "deployment_id",
                    "auth_method_id",
                    "auth_credentials_id",
                    [
                      "config",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at",
                    "archived_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_config",
                1,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "callback_instance_id",
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_instance_group_id",
            "integration_id",
            "integration_instance_id",
            "integration_instance_provider_id",
            "provider_id",
            "integration_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapDashboardInstanceIntegrationsInstanceGroupsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstanceGroupsUpdateBody = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [2, [1, ["integration_instance_provider_id", "tool_filters"]]]
    ]
  ]
);
var mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceIntegrationsInstancesCreateSessionOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesCreateSessionBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceIntegrationsInstancesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "identity_actor_id",
  "identity_id",
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters",
          "is_override_tool_filter"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceIntegrationsInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "identity_actor_id",
        "identity_id",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        ["implementation", 0, [1, ["magic_mcp_server_id"]]],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                "integration_instance_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "is_override_tool_filter",
                ["provider", 0, 8],
                [
                  "integration_provider",
                  1,
                  [
                    1,
                    [
                      "provider_version",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      "provider_id",
                      "deployment_id",
                      "auth_method_id",
                      "auth_credentials_id",
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "auth_config",
                  1,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "callback_instance_id",
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at",
        "is_oauth_compatible"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "provider_id",
            "integration_provider_id",
            "identity_id",
            "identity_credential_id",
            "identity_actor_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationsInstancesProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "callback_instance_id",
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_instance_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "is_override_tool_filter",
        ["provider", 0, 8],
        [
          "integration_provider",
          1,
          [
            1,
            [
              "provider_version",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "deployment_id",
              "auth_method_id",
              "auth_credentials_id",
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "auth_config",
          1,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "callback_instance_id",
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            "provider_id",
            "integration_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationsInstancesProvidersSetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "callback_instance_id",
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesProvidersSetBody = /* @__PURE__ */ mapObject(
  [
    "provider_deployment_id",
    "provider_config_id",
    "provider_auth_config_id",
    "tool_filters",
    "is_override_tool_filter"
  ]
);
var mapDashboardInstanceIntegrationsInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapDashboardInstanceIntegrationsInstancesUpdateBody = /* @__PURE__ */ mapObject([
  "identity_actor_id",
  "identity_id",
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters",
          "is_override_tool_filter"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceIntegrationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "configuration",
          0,
          [
            1,
            [
              "can_attach_custom_tool_filters",
              "can_attach_custom_provider_config",
              "can_override_tool_filters",
              "enable_callback_tools",
              "use_integration_name_in_tool_names"
            ]
          ]
        ],
        [
          "implementation",
          0,
          [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
        ],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "callbacks",
                  0,
                  [
                    1,
                    [
                      "callback_id",
                      [
                        "callback",
                        0,
                        [
                          1,
                          [
                            "integration_id",
                            "integration_provider_id",
                            ["provider", 0, 8],
                            "created_at",
                            "updated_at",
                            "auth_credentials_is_managed",
                            ["sync", 0, [1, ["synced_at"]]]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at",
                ["provider", 0, 8],
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "auth_method",
                  1,
                  [
                    1,
                    [
                      "input_schema",
                      "output_schema",
                      "provider_id",
                      "provider_specification_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "auth_credentials",
                  1,
                  [
                    1,
                    [
                      "is_default",
                      "is_managed",
                      "provider_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "integration_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceIntegrationsProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsProvidersCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "provider_id",
  "provider_deployment_id",
  "provider_auth_method_id",
  "provider_auth_credentials_id",
  "provider_config_id",
  "tool_filters"
]);
var mapDashboardInstanceIntegrationsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "deployment_id",
        "auth_method_id",
        "auth_credentials_id",
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "callbacks",
          0,
          [
            1,
            [
              "callback_id",
              [
                "callback",
                0,
                [
                  1,
                  [
                    "integration_id",
                    "integration_provider_id",
                    ["provider", 0, 8],
                    "created_at",
                    "updated_at",
                    "auth_credentials_is_managed",
                    ["sync", 0, [1, ["synced_at"]]]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at",
        ["provider", 0, 8],
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "auth_method",
          1,
          [
            1,
            [
              "input_schema",
              "output_schema",
              "provider_id",
              "provider_specification_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "auth_credentials",
          1,
          [
            1,
            [
              "is_default",
              "is_managed",
              "provider_id",
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "provider_id",
            "provider_deployment_id",
            "provider_auth_method_id",
            "provider_auth_credentials_id",
            "provider_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationsProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsProvidersUpdateBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "provider_auth_method_id",
  "provider_auth_credentials_id",
  "provider_config_id",
  "tool_filters"
]);
var mapDashboardInstanceIntegrationsSetupSessionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "redirect_url",
    "integration_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    [
      "integration_instance",
      1,
      [
        1,
        [
          "integration_id",
          "identity_actor_id",
          "identity_id",
          ["owner_actor", 1, [1, ["consumer_id"]]],
          ["implementation", 0, [1, ["magic_mcp_server_id"]]],
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "integration_id",
                  "integration_instance_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "is_override_tool_filter",
                  ["provider", 0, 8],
                  [
                    "integration_provider",
                    1,
                    [
                      1,
                      [
                        "provider_version",
                        [
                          "tool_filter",
                          1,
                          [3, [[0, [1, ["ignore_parent_filters"]]]]]
                        ],
                        "provider_id",
                        "deployment_id",
                        "auth_method_id",
                        "auth_credentials_id",
                        [
                          "config",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "archived_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "callback_instance_id",
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "expires_at",
    "integration_instance_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            "integration_provider_id",
            ["provider", 0, 8],
            "provider_setup_session_id",
            "integration_instance_provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsSetupSessionsCreateBody = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    "identity_actor_id",
    "identity_id",
    "expires_at",
    "redirect_url",
    [
      "configuration",
      0,
      [
        1,
        [
          [
            "provider_search",
            1,
            [
              1,
              [
                ["groups", 0, [2, [1, ["group_id"]]]],
                ["collections", 0, [2, [1, ["collection_id"]]]],
                ["categories", 0, [2, [1, ["category_id"]]]]
              ]
            ]
          ],
          "tool_filters"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsSetupSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "redirect_url",
    "integration_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    [
      "integration_instance",
      1,
      [
        1,
        [
          "integration_id",
          "identity_actor_id",
          "identity_id",
          ["owner_actor", 1, [1, ["consumer_id"]]],
          ["implementation", 0, [1, ["magic_mcp_server_id"]]],
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "integration_id",
                  "integration_instance_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "is_override_tool_filter",
                  ["provider", 0, 8],
                  [
                    "integration_provider",
                    1,
                    [
                      1,
                      [
                        "provider_version",
                        [
                          "tool_filter",
                          1,
                          [3, [[0, [1, ["ignore_parent_filters"]]]]]
                        ],
                        "provider_id",
                        "deployment_id",
                        "auth_method_id",
                        "auth_credentials_id",
                        [
                          "config",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "archived_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "callback_instance_id",
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "expires_at",
    "integration_instance_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            "integration_provider_id",
            ["provider", 0, 8],
            "provider_setup_session_id",
            "integration_instance_provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsSetupSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "redirect_url",
        "integration_id",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        [
          "integration_instance",
          1,
          [
            1,
            [
              "integration_id",
              "identity_actor_id",
              "identity_id",
              ["owner_actor", 1, [1, ["consumer_id"]]],
              ["implementation", 0, [1, ["magic_mcp_server_id"]]],
              [
                "providers",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "integration_id",
                      "integration_instance_id",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      "is_override_tool_filter",
                      ["provider", 0, 8],
                      [
                        "integration_provider",
                        1,
                        [
                          1,
                          [
                            "provider_version",
                            [
                              "tool_filter",
                              1,
                              [3, [[0, [1, ["ignore_parent_filters"]]]]]
                            ],
                            "provider_id",
                            "deployment_id",
                            "auth_method_id",
                            "auth_credentials_id",
                            [
                              "config",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at",
                            "archived_at"
                          ]
                        ]
                      ],
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_config",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "callback_instance_id",
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "expires_at",
        "integration_instance_id",
        [
          "steps",
          0,
          [
            2,
            [
              1,
              [
                "integration_provider_id",
                ["provider", 0, 8],
                "provider_setup_session_id",
                "integration_instance_provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceIntegrationsSetupSessionsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceIntegrationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardInstanceIntegrationsUpdateBody = /* @__PURE__ */ mapObject([
  "use_integration_name_in_tool_names",
  "can_attach_custom_tool_filters",
  "can_attach_custom_provider_config",
  "can_override_tool_filters",
  "enable_callback_tools"
]);
var mapDashboardInstanceMagicMcpEndpointsAddServersOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpEndpointsAddServersBody = /* @__PURE__ */ mapObject([
  ["magic_mcp_servers", 1, [2, [1, ["magic_mcp_server_id", "tool_filters"]]]]
]);
var mapDashboardInstanceMagicMcpEndpointsCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpEndpointsCreateBody = /* @__PURE__ */ mapObject([
  "consumer_profile_id",
  "skill_plugin_id",
  "enable_skill_editing",
  ["magic_mcp_servers", 1, [2, [1, ["magic_mcp_server_id", "tool_filters"]]]]
]);
var mapDashboardInstanceMagicMcpEndpointsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpEndpointsGetOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpEndpointsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
        "enable_skill_editing",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpEndpointsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["magic_mcp_server_id"]]]]
]);
var mapDashboardInstanceMagicMcpEndpointsRemoveServersOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpEndpointsRemoveServersBody = /* @__PURE__ */ mapObject(
  ["magic_mcp_server_ids"]
);
var mapDashboardInstanceMagicMcpEndpointsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpEndpointsUpdateBody = /* @__PURE__ */ mapObject([
  "enable_skill_editing"
]);
var mapDashboardInstanceMagicMcpGroupsAddServersOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstanceMagicMcpGroupsAddServersBody = /* @__PURE__ */ mapObject([
  "magic_mcp_server_ids"
]);
var mapDashboardInstanceMagicMcpGroupsCreateOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceMagicMcpGroupsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceMagicMcpGroupsDeleteOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceMagicMcpGroupsGetOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceMagicMcpGroupsListOutput = /* @__PURE__ */ createMapper([
  7,
  8
]);
var mapDashboardInstanceMagicMcpGroupsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceMagicMcpGroupsRemoveServersOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstanceMagicMcpGroupsRemoveServersBody = /* @__PURE__ */ mapObject([
  "magic_mcp_server_ids"
]);
var mapDashboardInstanceMagicMcpGroupsUpdateOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceMagicMcpGroupsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceMagicMcpServersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersCreateBody = /* @__PURE__ */ mapObject([
  "provider_template_id",
  "integration_instance_id",
  "consumer_profile_id"
]);
var mapDashboardInstanceMagicMcpServersDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_management_mode",
              "provider_template_id",
              [
                "providers",
                0,
                [
                  2,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "magic_mcp_server_id",
                            "provider_management_mode",
                            [
                              "tool_filter",
                              1,
                              [3, [[0, [1, ["ignore_parent_filters"]]]]]
                            ],
                            ["provider", 0, 8],
                            [
                              "deployment",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_method",
                              1,
                              [
                                1,
                                [
                                  "input_schema",
                                  "output_schema",
                                  "provider_id",
                                  "provider_specification_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_credentials",
                              1,
                              [
                                1,
                                [
                                  "is_default",
                                  "is_managed",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "config",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_config",
                              1,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at",
                            "archived_at",
                            "can_update",
                            "can_delete"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "integration_id",
              "integration_instance_id",
              "backing_status",
              [
                "consumer_owners",
                1,
                [
                  2,
                  [
                    1,
                    [
                      "consumer_integration_id",
                      "consumer_id",
                      "consumer_profile_id",
                      "consumer_name",
                      "consumer_email",
                      "consumer_profile_name",
                      "consumer_profile_email"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "magic_mcp_group_id",
          "provider_template_id",
          "integration_instance_id",
          "provider_id",
          "consumer_id",
          "consumer_profile_id",
          "preconfigured_only"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceMagicMcpServersProvidersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersProvidersCreateBody = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_config_id",
    "provider_auth_config_id",
    "tool_filters"
  ]
);
var mapDashboardInstanceMagicMcpServersProvidersDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "magic_mcp_server_id",
              "provider_management_mode",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              ["provider", 0, 8],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_credentials",
                1,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_config",
                1,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at",
              "can_update",
              "can_delete"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceMagicMcpServersProvidersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersProvidersUpdateBody = /* @__PURE__ */ mapObject(
  [
    "provider_deployment_id",
    "provider_config_id",
    "provider_auth_config_id",
    "tool_filters"
  ]
);
var mapDashboardInstanceMagicMcpServersSessionCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpServersToolsOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpServersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceMagicMcpSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "magic_mcp_server",
      1,
      [
        1,
        [
          "provider_management_mode",
          "provider_template_id",
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "magic_mcp_server_id",
                  "provider_management_mode",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  ["provider", 0, 8],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_credentials",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "magic_mcp_endpoint",
      1,
      [
        1,
        [
          ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
          "enable_skill_editing",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "consumer_profile_id",
    "consumer_integration_ids",
    "session_id",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceMagicMcpSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "magic_mcp_server",
          1,
          [
            1,
            [
              "provider_management_mode",
              "provider_template_id",
              [
                "providers",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "magic_mcp_server_id",
                      "provider_management_mode",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      ["provider", 0, 8],
                      [
                        "deployment",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_method",
                        1,
                        [
                          1,
                          [
                            "input_schema",
                            "output_schema",
                            "provider_id",
                            "provider_specification_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_credentials",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "is_managed",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_config",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "magic_mcp_endpoint",
          1,
          [
            1,
            [
              ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
              "enable_skill_editing",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "consumer_profile_id",
        "consumer_integration_ids",
        "session_id",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMagicMcpSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["magic_mcp_server_id"]]]]
]);
var mapDashboardInstanceMagicMcpTokensAddGroupsOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceMagicMcpTokensAddGroupsBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids"
]);
var mapDashboardInstanceMagicMcpTokensCreateOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceMagicMcpTokensCreateBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids",
  "magic_mcp_server_id",
  "magic_mcp_endpoint_id"
]);
var mapDashboardInstanceMagicMcpTokensDeleteOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceMagicMcpTokensGetOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceMagicMcpTokensListOutput = /* @__PURE__ */ createMapper(
  [7, [1, [["groups", 0, [2, 8]], "created_at", "updated_at"]]],
  1
);
var mapDashboardInstanceMagicMcpTokensListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["magic_mcp_group_id", "magic_mcp_server_id", "magic_mcp_endpoint_id"]
      ]
    ]
  ]
]);
var mapDashboardInstanceMagicMcpTokensRemoveGroupsOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceMagicMcpTokensRemoveGroupsBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids"
]);
var mapDashboardInstanceMagicMcpTokensUpdateOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceMagicMcpTokensUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceMonitorAlertsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapDashboardInstanceMonitorAlertsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "monitor",
          0,
          [
            1,
            [
              "proto_guard_filter_id",
              "provider_id",
              "created_at",
              "updated_at",
              "first_alert_at",
              "last_alert_at"
            ]
          ]
        ],
        "proto_guard_alert_id",
        "proto_guard_run_id",
        [
          "specification_change_notification",
          1,
          [
            1,
            [
              "provider_id",
              "provider_version_id",
              ["from_specification", 1, 8],
              ["to_specification", 1, 8],
              ["from_provider_version", 1, 8],
              ["to_provider_version", 1, 8],
              "created_at"
            ]
          ]
        ],
        "created_at",
        "resolved_at",
        [
          "recipients",
          0,
          [2, [1, ["recipient_id", "viewed_at", "created_at"]]]
        ],
        ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMonitorAlertsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "monitor_id",
          "provider_id",
          "proto_guard_alert_id",
          "proto_guard_run_id",
          "proto_guard_filter_id",
          "specification_change_notification_id",
          "session_id",
          "session_message_id",
          "session_connection_id",
          "provider_run_id",
          ["created_at", 1, 5],
          ["resolved_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceMonitorAlertsResolveOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapDashboardInstanceMonitorAlertsUnresolveOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapDashboardInstanceMonitorAlertsViewedOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapDashboardInstanceMonitorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "proto_guard_filter_id",
    "provider_id",
    "created_at",
    "updated_at",
    "first_alert_at",
    "last_alert_at"
  ],
  1
);
var mapDashboardInstanceMonitorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "proto_guard_filter_id",
        "provider_id",
        "created_at",
        "updated_at",
        "first_alert_at",
        "last_alert_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceMonitorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "proto_guard_filter_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5],
          ["first_alert_at", 1, 5],
          ["last_alert_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceNetworkPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceNetworkPoliciesCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceNetworkPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceNetworkPoliciesGetOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceNetworkPoliciesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["firewall_ids", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapDashboardInstanceNetworkPoliciesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["firewall_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapDashboardInstanceNetworkPoliciesRulesCreateOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceNetworkPoliciesRulesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceNetworkPoliciesRulesDeleteOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceNetworkPoliciesRulesUpdateOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceNetworkPoliciesRulesUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceNetworkPoliciesUpdateOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapDashboardInstanceNetworkPoliciesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstancePortalsAccessCreateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsAccessCreateBody = /* @__PURE__ */ mapObject([
  "consumer_group_id",
  [
    "access",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_template_id",
              "magic_mcp_server_id",
              "skill_id",
              "skill_template_id",
              "skill_group_id",
              "skill_marketplace_id",
              "skill_plugin_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstancePortalsAccessDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsAccessGetOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsAccessListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "access_level",
        [
          "access",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server",
                    "skill_template",
                    "skill_group",
                    "skill_marketplace",
                    "skill_plugin"
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "consumer_group",
          1,
          [1, ["is_default", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsAccessListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "consumer_group_id",
          "provider_template_id",
          "magic_mcp_server_id",
          "skill_id",
          "skill_template_id",
          "skill_group_id",
          "skill_marketplace_id",
          "skill_plugin_id",
          "consumer_access_listing_id"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstancePortalsAccessUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsAccessUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstancePortalsAccessRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "resolution_message",
    "consumer_profile",
    [
      "target",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "reviewed_at"
  ],
  1
);
var mapDashboardInstancePortalsAccessRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "resolution_message",
        "consumer_profile",
        [
          "target",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server"
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "reviewed_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsAccessRequestsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["consumer_profile_id"]]]]]
);
var mapDashboardInstancePortalsAccessRequestsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "resolution_message",
    "consumer_profile",
    [
      "target",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "reviewed_at"
  ],
  1
);
var mapDashboardInstancePortalsAccessRequestsUpdateBody = /* @__PURE__ */ mapObject([
  "resolution_message",
  "consumer_group_id"
]);
var mapDashboardInstancePortalsConsumerGroupsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerGroupsCreateBody = /* @__PURE__ */ mapObject([
  "is_default"
]);
var mapDashboardInstancePortalsConsumerGroupsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerGroupsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              "created_at",
              "updated_at",
              "is_managed",
              "is_default_everyone_group"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerGroupsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePortalsConsumerGroupsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerGroupsUpdateBody = /* @__PURE__ */ mapObject([
  "is_default"
]);
var mapDashboardInstancePortalsConsumerInvitesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "portal_url",
    "consumer_profile",
    "invited_by",
    "accepted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsConsumerInvitesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePortalsConsumerInvitesGetOutput = /* @__PURE__ */ mapObject(
  [
    "portal_url",
    "consumer_profile",
    "invited_by",
    "accepted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsConsumerInvitesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "portal_url",
        "consumer_profile",
        "invited_by",
        "accepted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerInvitesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePortalsConsumerProfilesAssignGroupsOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerProfilesAssignGroupsBody = /* @__PURE__ */ mapObject(
  ["group_ids"]
);
var mapDashboardInstancePortalsConsumerProfilesCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerProfilesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePortalsConsumerProfilesDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerProfilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerProfilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "consumer_id",
              "user_id",
              "created_at",
              "updated_at",
              [
                "groups",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "group",
                        0,
                        [1, ["is_default", "created_at", "updated_at"]]
                      ],
                      "assigned_via"
                    ]
                  ]
                ]
              ],
              "is_service_account",
              [
                "surface",
                0,
                [
                  1,
                  [
                    "allow_consumer_skill_authoring",
                    "allow_consumer_skill_publishing",
                    [
                      "skill_configuration",
                      1,
                      [
                        1,
                        [
                          "is_default",
                          "allow_scripts",
                          "allowed_file_extensions",
                          "allow_non_standard_directories"
                        ]
                      ]
                    ],
                    [
                      "auth",
                      0,
                      [
                        1,
                        ["session_expiry_time_in_seconds", "email_whitelist"]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerProfilesListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["consumer_group_id"]]]]]
);
var mapDashboardInstancePortalsConsumerProfilesUnassignGroupsOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsConsumerProfilesUnassignGroupsBody = /* @__PURE__ */ mapObject(
  ["group_ids"]
);
var mapDashboardInstancePortalsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsCreateBody = /* @__PURE__ */ mapObject([
  "allowed_redirect_url_filters",
  "session_expiry_time_in_seconds",
  "allow_consumer_skill_authoring",
  "allow_consumer_skill_publishing"
]);
var mapDashboardInstancePortalsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "allow_consumer_skill_authoring",
              "allow_consumer_skill_publishing",
              [
                "skill_configuration",
                1,
                [
                  1,
                  [
                    "is_default",
                    "allow_scripts",
                    "allowed_file_extensions",
                    "allow_non_standard_directories"
                  ]
                ]
              ],
              [
                "auth",
                0,
                [
                  1,
                  [
                    "session_expiry_time_in_seconds",
                    "allowed_redirect_url_filters"
                  ]
                ]
              ],
              "magic_mcp_url",
              "created_at",
              "updated_at",
              "managed_everyone_group_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstancePortalsListingsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsListingsCreateBody = /* @__PURE__ */ mapObject([
  [
    "access",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_template_id",
              "magic_mcp_server_id",
              "skill_id",
              "skill_template_id",
              "skill_group_id",
              "skill_marketplace_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstancePortalsListingsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsListingsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsListingsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "access",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server",
                    "skill_template",
                    "skill_group",
                    "skill_marketplace",
                    "skill_plugin"
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsListingsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "consumer_surface_provider_group_id",
          "provider_template_id",
          "magic_mcp_server_id",
          "skill_id",
          "skill_template_id",
          "skill_group_id",
          "skill_marketplace_id"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstancePortalsListingsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePortalsListingsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstancePortalsSurfaceProviderGroupsAddListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstancePortalsSurfaceProviderGroupsAddListingBody = /* @__PURE__ */ mapObject(
  ["consumer_access_listing_id"]
);
var mapDashboardInstancePortalsSurfaceProviderGroupsCreateOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstancePortalsSurfaceProviderGroupsCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePortalsSurfaceProviderGroupsDeleteOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstancePortalsSurfaceProviderGroupsGetOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstancePortalsSurfaceProviderGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, 8]
);
var mapDashboardInstancePortalsSurfaceProviderGroupsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstancePortalsSurfaceProviderGroupsUpdateOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstancePortalsSurfaceProviderGroupsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePortalsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePortalsUpdateBody = /* @__PURE__ */ mapObject([
  "allowed_redirect_url_filters",
  "session_expiry_time_in_seconds",
  "allow_consumer_skill_authoring",
  "allow_consumer_skill_publishing",
  [
    "skill_configuration",
    1,
    [
      1,
      [
        "allow_scripts",
        "allowed_file_extensions",
        "allow_non_standard_directories"
      ]
    ]
  ]
]);
var mapDashboardInstanceProtoGuardAlertsGetOutput = /* @__PURE__ */ mapObject(
  [
    "run_id",
    "session_id",
    "session_message_id",
    "session_connection_id",
    "provider_run_id",
    ["filters", 0, [2, [1, ["filter_id", "issue_type", "created_at"]]]],
    "created_at"
  ],
  1
);
var mapDashboardInstanceProtoGuardAlertsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "run_id",
        "session_id",
        "session_message_id",
        "session_connection_id",
        "provider_run_id",
        ["filters", 0, [2, [1, ["filter_id", "issue_type", "created_at"]]]],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProtoGuardAlertsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "run_id",
          "filter_id",
          "session_id",
          "session_message_id",
          "session_connection_id",
          "provider_run_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProtoGuardConfigGetOutput = /* @__PURE__ */ mapObject([
  "alert_filter_count_threshold",
  [
    "filters",
    0,
    [
      2,
      [
        1,
        [
          "issue_type",
          "score_weight",
          "default_enabled",
          "default_alert_confidence_threshold",
          "alert_confidence_threshold"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput = /* @__PURE__ */ mapObject(
  [
    "alert_filter_count_threshold",
    [
      "filters",
      0,
      [
        2,
        [
          1,
          [
            "issue_type",
            "score_weight",
            "default_enabled",
            "default_alert_confidence_threshold",
            "alert_confidence_threshold"
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceProtoGuardConfigUpdateFilterOutput = /* @__PURE__ */ mapObject(
  [
    "alert_filter_count_threshold",
    [
      "filters",
      0,
      [
        2,
        [
          1,
          [
            "issue_type",
            "score_weight",
            "default_enabled",
            "default_alert_confidence_threshold",
            "alert_confidence_threshold"
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProtoGuardConfigUpdateFilterBody = /* @__PURE__ */ mapObject([
  "alert_confidence_threshold"
]);
var mapDashboardInstanceProviderAuthConfigErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "auth_config_event_id",
    "provider_auth_config_id",
    "provider_auth_credentials_id",
    "provider_oauth_setup_id",
    "provider_id",
    "provider_invocation_id",
    "group_id",
    "similar_error_count",
    "created_at"
  ],
  1
);
var mapDashboardInstanceProviderAuthConfigErrorsGroupsGetOutput = /* @__PURE__ */ mapObject(
  ["provider_id", "occurrence_count", "created_at"],
  1
);
var mapDashboardInstanceProviderAuthConfigErrorsGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["provider_id", "occurrence_count", "created_at"]]],
  1
);
var mapDashboardInstanceProviderAuthConfigErrorsGroupsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderAuthConfigErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "auth_config_event_id",
        "provider_auth_config_id",
        "provider_auth_credentials_id",
        "provider_oauth_setup_id",
        "provider_id",
        "provider_invocation_id",
        "group_id",
        "similar_error_count",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderAuthConfigErrorsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "auth_config_event_id",
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            "provider_oauth_setup_id",
            "provider_id",
            "provider_auth_config_error_group_id",
            "provider_invocation_id",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderAuthConfigEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "source_type",
    "source_id",
    "provider_auth_config_id",
    "provider_auth_credentials_id",
    "provider_oauth_setup_id",
    "provider_id",
    "provider_auth_error_id",
    "provider_invocation_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderAuthConfigEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "source_type",
        "source_id",
        "provider_auth_config_id",
        "provider_auth_credentials_id",
        "provider_oauth_setup_id",
        "provider_id",
        "provider_auth_error_id",
        "provider_invocation_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderAuthConfigEventsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            "provider_oauth_setup_id",
            "provider_id",
            "provider_invocation_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderCategoriesGetOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceProviderCategoriesListOutput = /* @__PURE__ */ createMapper([
  7,
  8
]);
var mapDashboardInstanceProviderCategoriesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "provider_listing_id"]]]]
]);
var mapDashboardInstanceProviderCollectionsGetOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstanceProviderCollectionsListOutput = /* @__PURE__ */ createMapper([
  7,
  8
]);
var mapDashboardInstanceProviderCollectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "provider_listing_id"]]]]
]);
var mapDashboardInstanceProviderDeploymentsAuthConfigsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsCreateBody = /* @__PURE__ */ mapObject(
  ["tool_filters", "provider_auth_method_id", "provider_deployment_id"]
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody = /* @__PURE__ */ mapObject(
  ["provider_auth_config_id"]
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_agent",
        [
          "auth_config",
          1,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "provider_id",
        "provider_deployment_id",
        "auth_method_id",
        "credentials_id",
        "created_at",
        "expires_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_credentials_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_auth_config_id",
    "provider_auth_method_id"
  ]
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput = /* @__PURE__ */ mapObject(
  ["specification_id", "provider_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_auth_config_id",
    "provider_auth_method_id"
  ]
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_agent",
        [
          "auth_config",
          1,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "provider_id",
        "provider_deployment_id",
        "auth_method_id",
        "credentials_id",
        "created_at",
        "expires_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_credentials_id",
            "provider_auth_config_id",
            "provider_deployment_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "available_for_use",
            "available_for_provider_deployment_id",
            "provider_auth_credentials_id",
            "provider_auth_method_id",
            "actor_id",
            "consumer_id",
            "identity_id",
            "identity_credential_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateBody = /* @__PURE__ */ mapObject(
  ["provider_id", ["config", 0, [1, ["client_id", "client_secret"]]]]
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsGetOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      ["is_default", "is_managed", "provider_id", "created_at", "updated_at"]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_method_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody = /* @__PURE__ */ mapObject(
  ["client_id", "client_secret"]
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsCreateBody = /* @__PURE__ */ mapObject(
  ["provider_id", "provider_deployment_id"]
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_config_vault_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceProviderDeploymentsConfigsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigsCreateBody = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "tool_filters",
            "provider_config_vault_id"
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsConfigsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput = /* @__PURE__ */ mapObject(
  ["specification_id", "provider_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_config_id",
    "provider_version_id",
    "provider_deployment_id"
  ]
);
var mapDashboardInstanceProviderDeploymentsConfigsGetValueOutput = /* @__PURE__ */ mapObject(
  ["provider_config_id"]
);
var mapDashboardInstanceProviderDeploymentsConfigsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "specification_id",
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "from_vault",
                1,
                [
                  1,
                  [
                    "provider_id",
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_specification_id",
            "provider_deployment_id",
            "available_for_use",
            "available_for_provider_deployment_id",
            "provider_config_vault_id",
            "actor_id",
            "consumer_id",
            "identity_id",
            "identity_credential_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsConfigsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsConfigsUpdateBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapDashboardInstanceProviderDeploymentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "tool_filters",
          "provider_id",
          "locked_provider_version_id",
          "provider_config_id",
          [
            "provider_config",
            1,
            [3, [[0, [1, ["provider_config_vault_id"]]]]]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProviderDeploymentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        [
          "locked_version",
          1,
          [
            1,
            [
              "provider_id",
              "is_current",
              "specification_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "default_config",
          1,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "identity_credential_id",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ],
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProviderDeploymentsSetupSessionsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsSetupSessionsCreateBody = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_auth_method_id",
    "provider_auth_credentials_id",
    "identity_id",
    "consumer_id",
    "redirect_url",
    [
      "configuration",
      0,
      [
        1,
        [
          [
            "provider_search",
            1,
            [
              1,
              [
                ["groups", 0, [2, [1, ["group_id"]]]],
                ["collections", 0, [2, [1, ["collection_id"]]]],
                ["categories", 0, [2, [1, ["category_id"]]]]
              ]
            ]
          ],
          "tool_filters"
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsSetupSessionsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsSetupSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_id",
              "identity_id",
              "identity_credential_id",
              ["owner_actor", 1, [1, ["consumer_id"]]],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_config",
                1,
                [
                  1,
                  [
                    "is_default",
                    "provider_id",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "credentials",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "is_managed",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "auth_method",
                      1,
                      [
                        1,
                        [
                          "input_schema",
                          "output_schema",
                          "provider_id",
                          "provider_specification_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["owner_actor", 1, [1, ["consumer_id"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [
                  1,
                  [
                    "is_default",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    "provider_id",
                    "specification_id",
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "from_vault",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["owner_actor", 1, [1, ["consumer_id"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "ui_mode",
              "redirect_url",
              "created_at",
              "updated_at",
              "expires_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsSetupSessionsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "provider_auth_method_id",
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateBody = /* @__PURE__ */ mapObject(
  ["identity_id"]
);
var mapDashboardInstanceProviderDeploymentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderDeploymentsUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters",
  "locked_provider_version_id"
]);
var mapDashboardInstanceProviderGroupsAddListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstanceProviderGroupsAddListingBody = /* @__PURE__ */ mapObject([
  "provider_listing_id"
]);
var mapDashboardInstanceProviderGroupsCreateOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceProviderGroupsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceProviderGroupsGetOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceProviderGroupsListOutput = /* @__PURE__ */ createMapper([
  7,
  8
]);
var mapDashboardInstanceProviderGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_listing_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProviderGroupsRemoveListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapDashboardInstanceProviderGroupsUpdateOutput = /* @__PURE__ */ createMapper(8);
var mapDashboardInstanceProviderGroupsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceProviderInvocationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_run_ids",
    "session_message_ids",
    "callback_event_ids",
    "auth_config_event_ids",
    "provider_oauth_setup_ids",
    "tool_call_id",
    "request_traces",
    ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]],
    "created_at"
  ],
  1
);
var mapDashboardInstanceProviderInvocationsListOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "provider_run_ids",
            "session_message_ids",
            "callback_event_ids",
            "auth_config_event_ids",
            "provider_oauth_setup_ids",
            "tool_call_id",
            "request_traces",
            ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]],
            "created_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderInvocationsListQuery = /* @__PURE__ */ mapObject([
  "provider_run_id",
  "session_message_id",
  "chat_event_id",
  "callback_event_id",
  "auth_config_event_id"
]);
var mapDashboardInstanceProviderListingsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderListingsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "attributes",
                0,
                [
                  1,
                  [
                    "is_public",
                    "is_customized",
                    "is_metorial",
                    "is_verified",
                    "is_official"
                  ]
                ]
              ],
              "image_url",
              [
                "provider",
                0,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          [
                            "publisher",
                            0,
                            [1, ["image_url", "created_at", "updated_at"]]
                          ],
                          [
                            "current_version",
                            1,
                            [
                              1,
                              [
                                "provider_id",
                                "is_current",
                                "specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "oauth",
                            0,
                            [1, ["callback_url", "auto_registration"]]
                          ],
                          "created_at",
                          "updated_at",
                          [
                            "type",
                            0,
                            [
                              1,
                              [
                                [
                                  "triggers",
                                  0,
                                  [3, [[0, [1, ["webhook_registration"]]]]]
                                ],
                                [
                                  "auth",
                                  0,
                                  [
                                    3,
                                    [
                                      [
                                        0,
                                        [
                                          1,
                                          [
                                            [
                                              "oauth",
                                              0,
                                              [
                                                3,
                                                [
                                                  [
                                                    0,
                                                    [
                                                      1,
                                                      [
                                                        "oauth_callback_url",
                                                        "oauth_auto_registration"
                                                      ]
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              ["categories", 0, [2, 8]],
              ["collections", 0, [2, 8]],
              ["groups", 0, [2, 8]],
              "created_at",
              "updated_at",
              ["docs", 0, [1, ["auth_methods"]]]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderListingsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_category_id",
          "provider_collection_id",
          "provider_group_id",
          "publisher_id",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ],
          "is_public",
          "only_from_tenant",
          "is_verified",
          "is_official",
          "is_metorial",
          "order_by_rank",
          "order_by_use",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProviderListingsResetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderListingsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderListingsUpdateBody = /* @__PURE__ */ mapObject([
  "image_url",
  "provider_category_ids",
  "provider_collection_ids"
]);
var mapDashboardInstanceProviderRunsGetLogsOutput = /* @__PURE__ */ mapObject([
  "provider_run_id",
  ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]]
]);
var mapDashboardInstanceProviderRunsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "session_provider_id",
    "provider_id",
    "connection_id",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProviderRunsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "session_provider_id",
        "provider_id",
        "connection_id",
        "completed_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderRunsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "provider_id",
          "session_provider_id",
          "session_connection_id",
          "provider_version_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProviderSpecificationChangeNotificationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_version_id",
    ["from_specification", 1, 8],
    ["to_specification", 1, 8],
    ["from_provider_version", 1, 8],
    ["to_provider_version", 1, 8],
    "created_at"
  ],
  1
);
var mapDashboardInstanceProviderSpecificationChangeNotificationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "provider_version_id",
        ["from_specification", 1, 8],
        ["to_specification", 1, 8],
        ["from_provider_version", 1, 8],
        ["to_provider_version", 1, 8],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProviderSpecificationChangeNotificationsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_version_id",
            "provider_specification_id",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProviderTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderTemplatesCreateBody = /* @__PURE__ */ mapObject([
  "integration_id"
]);
var mapDashboardInstanceProviderTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderTemplatesGetOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderTemplatesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["integration_id", "created_at", "updated_at"]]],
  1
);
var mapDashboardInstanceProviderTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["integration_id"]]]]
]);
var mapDashboardInstanceProviderTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceProviderTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceProvidersAuthMethodsGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    "provider_id",
    "provider_specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProvidersAuthMethodsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        "provider_id",
        "provider_specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProvidersAuthMethodsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id"]]]]
]);
var mapDashboardInstanceProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["publisher", 0, [1, ["image_url", "created_at", "updated_at"]]],
            [
              "current_version",
              1,
              [
                1,
                [
                  "provider_id",
                  "is_current",
                  "specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
            "created_at",
            "updated_at",
            [
              "type",
              0,
              [
                1,
                [
                  ["triggers", 0, [3, [[0, [1, ["webhook_registration"]]]]]],
                  [
                    "auth",
                    0,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              [
                                "oauth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          "oauth_callback_url",
                                          "oauth_auto_registration"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "publisher",
                0,
                [1, ["image_url", "created_at", "updated_at"]]
              ],
              [
                "current_version",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "is_current",
                    "specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
              "created_at",
              "updated_at",
              [
                "type",
                0,
                [
                  1,
                  [
                    [
                      "triggers",
                      0,
                      [3, [[0, [1, ["webhook_registration"]]]]]
                    ],
                    [
                      "auth",
                      0,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                [
                                  "oauth",
                                  0,
                                  [
                                    3,
                                    [
                                      [
                                        0,
                                        [
                                          1,
                                          [
                                            "oauth_callback_url",
                                            "oauth_auto_registration"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "auth_method",
          "auth_setup",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceProvidersSpecificationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "config_schema",
    "config_visibility",
    [
      "tools",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    ["tool_categories", 1, [2, [1, ["image_url", "tool_count"]]]],
    [
      "auth_methods",
      1,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            "provider_id",
            "provider_specification_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProvidersSpecificationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "config_schema",
        "config_visibility",
        [
          "tools",
          0,
          [
            2,
            [
              1,
              [
                "input_schema",
                "output_schema",
                ["tags", 0, [1, ["read_only"]]],
                "tool_category_keys",
                "specification_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        ["tool_categories", 1, [2, [1, ["image_url", "tool_count"]]]],
        [
          "auth_methods",
          1,
          [
            2,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProvidersSpecificationsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_version_id",
            "provider_deployment_id",
            "provider_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceProvidersToolsGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    ["tags", 0, [1, ["read_only"]]],
    "tool_category_keys",
    "specification_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProvidersToolsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        ["tags", 0, [1, ["read_only"]]],
        "tool_category_keys",
        "specification_id",
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProvidersToolsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id", "provider_auth_method_id"]]]]
]);
var mapDashboardInstanceProvidersTriggersGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    [
      "invocation",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              ["interval_seconds", "auto_registration", "auto_unregistration"]
            ]
          ]
        ]
      ]
    ],
    "provider_id",
    "provider_specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProvidersTriggersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        [
          "invocation",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    "interval_seconds",
                    "auto_registration",
                    "auto_unregistration"
                  ]
                ]
              ]
            ]
          ]
        ],
        "provider_id",
        "provider_specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProvidersTriggersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id", "user_managed_callbacks"]]]]
]);
var mapDashboardInstanceProvidersVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "is_current",
    "specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceProvidersVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "is_current",
        "specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceProvidersVersionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapDashboardInstancePublicMcpServersClientsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "client_id",
              "client_uri",
              "logo_uri",
              "redirect_uris",
              "token_endpoint_auth_method",
              "last_used_at",
              "expires_at",
              "created_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstancePublicMcpServersClientsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePublicMcpServersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePublicMcpServersCreateBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "tool_filters",
  "redirect_uri_filters",
  "max_active_grants",
  "access_token_ttl_seconds",
  "refresh_token_ttl_seconds",
  "grant_idle_expiry_seconds"
]);
var mapDashboardInstancePublicMcpServersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePublicMcpServersGetOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePublicMcpServersGrantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "revoked_reason",
    "public_mcp_server_id",
    ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
    "last_used_at",
    "revoked_at",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePublicMcpServersGrantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "revoked_reason",
        "public_mcp_server_id",
        ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
        "last_used_at",
        "revoked_at",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstancePublicMcpServersGrantsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, [["created_at", 1, 5]]]]]]
);
var mapDashboardInstancePublicMcpServersGrantsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "revoked_reason",
    "public_mcp_server_id",
    ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
    "last_used_at",
    "revoked_at",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePublicMcpServersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connect_url",
        "alternate_connect_urls",
        "provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "redirect_uri_filters",
        "max_active_grants",
        "access_token_ttl_seconds",
        "refresh_token_ttl_seconds",
        "grant_idle_expiry_seconds",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        "disabled_at",
        "archived_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstancePublicMcpServersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["provider_deployment_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapDashboardInstancePublicMcpServersSlugsCheckOutput = /* @__PURE__ */ mapObject([
  "is_available"
]);
var mapDashboardInstancePublicMcpServersSlugsCheckQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancePublicMcpServersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstancePublicMcpServersUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters",
  "redirect_uri_filters",
  "max_active_grants",
  "access_token_ttl_seconds",
  "refresh_token_ttl_seconds",
  "grant_idle_expiry_seconds"
]);
var mapDashboardInstancePublishersGetOutput = /* @__PURE__ */ mapObject(
  ["image_url", "created_at", "updated_at"],
  1
);
var mapDashboardInstancePublishersListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["image_url", "created_at", "updated_at"]]],
  1
);
var mapDashboardInstancePublishersListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxDisksCloneOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksCloneBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxDisksCreateOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksCreateBody = /* @__PURE__ */ mapObject([
  "size_bytes"
]);
var mapDashboardInstanceSandboxDisksDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksGetOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "size_bytes",
        ["machine", 0, [1, ["mount_path"]]],
        ["active_resize", 1, [1, ["target_size_bytes"]]],
        "created_at",
        "updated_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxDisksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_id"]]]]
]);
var mapDashboardInstanceSandboxDisksMountsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "disk_id",
        "machine_id",
        "machine_instance_id",
        "mount_path",
        "mounted_at",
        "released_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxDisksMountsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxDisksResizeOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksResizeBody = /* @__PURE__ */ mapObject([
  "size_bytes"
]);
var mapDashboardInstanceSandboxDisksResizesGetOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksResizesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "disk_id",
        "original_size_bytes",
        "target_size_bytes",
        "machine_ids",
        "created_at",
        "updated_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxDisksResizesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSandboxDisksResizesRetryOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxDisksUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxImageBuildsCancelOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSandboxImageBuildsGetOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSandboxImageBuildsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_id",
        "version_id",
        "version_number",
        "file_id",
        "dockerfile_path",
        "context_path",
        "build_arg_names",
        "timeout_seconds",
        "disk_size_bytes",
        "has_logs",
        "context_uploaded_at",
        "built_at",
        "ended_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxImageBuildsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_id", "image_version_id"]]]]
]);
var mapDashboardInstanceSandboxImageBuildsLogsOutput = /* @__PURE__ */ mapObject([
  ["lines", 0, [2, [1, [["timestamp", 0, 4]]]]],
  "next_cursor",
  "has_more",
  "line_count"
]);
var mapDashboardInstanceSandboxImageBuildsLogsQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxImagesBuildsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSandboxImagesBuildsCreateBody = /* @__PURE__ */ mapObject([
  "file_id",
  "dockerfile_path",
  "context_path",
  "build_args",
  "timeout_seconds",
  "disk_size_bytes"
]);
var mapDashboardInstanceSandboxImagesBuildsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_id",
        "version_id",
        "version_number",
        "file_id",
        "dockerfile_path",
        "context_path",
        "build_arg_names",
        "timeout_seconds",
        "disk_size_bytes",
        "has_logs",
        "context_uploaded_at",
        "built_at",
        "ended_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxImagesBuildsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_version_id"]]]]
]);
var mapDashboardInstanceSandboxImagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxImagesCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxImagesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxImagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxImagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "latest_version_id",
        "latest_version_number",
        "created_at",
        "updated_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxImagesListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxImagesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapDashboardInstanceSandboxImagesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxImagesVersionsGetOutput = /* @__PURE__ */ mapObject(
  ["image_id", "version_number", "build_id", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceSandboxImagesVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      ["image_id", "version_number", "build_id", "created_at", "updated_at"]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxImagesVersionsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSandboxMachinesAccessFilesOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapDashboardInstanceSandboxMachinesAccessFilesBody = /* @__PURE__ */ mapObject([
  "ttl_seconds"
]);
var mapDashboardInstanceSandboxMachinesAccessPortsOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapDashboardInstanceSandboxMachinesAccessPortsBody = /* @__PURE__ */ mapObject([
  "ttl_seconds"
]);
var mapDashboardInstanceSandboxMachinesAccessShellOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapDashboardInstanceSandboxMachinesAccessShellBody = /* @__PURE__ */ mapObject([
  "ttl_seconds"
]);
var mapDashboardInstanceSandboxMachinesCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesCreateBody = /* @__PURE__ */ mapObject([
  "image_id",
  "spec_id",
  "spec_identifier",
  "memory_gib",
  [
    "lifecycle_policy",
    1,
    [
      1,
      [
        "pause_after_idle_seconds",
        "hibernate_after_paused_seconds",
        "connection_idle_seconds"
      ]
    ]
  ],
  ["runtime", 0, [1, ["stop_signal"]]],
  ["lifecycle_hooks", 1, [2, [3, [[0, [1, ["timeout_seconds"]]]]]]],
  "ignore_image_hooks",
  "entrypoint_wait_seconds",
  ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
  "firewall_ids",
  "public_ports"
]);
var mapDashboardInstanceSandboxMachinesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "machine_instance_id",
    "operation_id",
    "event_id",
    "exit_code",
    "duration_ms",
    "occurred_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "machine_instance_id",
        "operation_id",
        "event_id",
        "exit_code",
        "duration_ms",
        "occurred_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxMachinesErrorsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["machine_instance_id"]]]]]
);
var mapDashboardInstanceSandboxMachinesEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "machine_instance_id",
    ["machine", 0, [1, ["from_status", "to_status"]]],
    ["instance", 0, [1, ["from_status", "to_status"]]],
    "operation_id",
    "guest_error_id",
    "occurred_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "machine_instance_id",
        ["machine", 0, [1, ["from_status", "to_status"]]],
        ["instance", 0, [1, ["from_status", "to_status"]]],
        "operation_id",
        "guest_error_id",
        "occurred_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxMachinesEventsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["machine_instance_id"]]]]]
);
var mapDashboardInstanceSandboxMachinesExecOutput = /* @__PURE__ */ mapObject([
  "exit_code",
  "timed_out",
  "stdout_truncated",
  "stderr_truncated"
]);
var mapDashboardInstanceSandboxMachinesExecBody = /* @__PURE__ */ mapObject([
  "timeout_seconds"
]);
var mapDashboardInstanceSandboxMachinesGetOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesHibernateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "creation_reason",
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["operation", 0, [1, ["requested_at"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "disks_ready",
    [
      "runtime",
      0,
      [
        1,
        [
          ["setup", 0, [2, [1, ["exit_code", "duration_ms"]]]],
          ["entrypoint", 0, [1, ["started_after_ms", "exit_code"]]]
        ]
      ]
    ],
    "has_logs",
    "created_at",
    "started_at",
    "ready_at",
    "paused_at",
    "terminated_at",
    "last_seen_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "creation_reason",
        ["image", 0, [1, ["version_id"]]],
        ["spec", 0, [1, ["memory_gib"]]],
        ["operation", 0, [1, ["requested_at"]]],
        ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
        "disks_ready",
        [
          "runtime",
          0,
          [
            1,
            [
              ["setup", 0, [2, [1, ["exit_code", "duration_ms"]]]],
              ["entrypoint", 0, [1, ["started_after_ms", "exit_code"]]]
            ]
          ]
        ],
        "has_logs",
        "created_at",
        "started_at",
        "ready_at",
        "paused_at",
        "terminated_at",
        "last_seen_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxMachinesInstancesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSandboxMachinesInstancesLogsOutput = /* @__PURE__ */ mapObject(
  [
    ["lines", 0, [2, [1, [["timestamp", 0, 4]]]]],
    "next_cursor",
    "has_more",
    "line_count"
  ]
);
var mapDashboardInstanceSandboxMachinesInstancesLogsQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSandboxMachinesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["image", 0, [1, ["version_id"]]],
        ["spec", 0, [1, ["memory_gib"]]],
        ["max_boost", 1, [1, ["memory_gib"]]],
        ["root_disk", 1, [1, ["size_bytes"]]],
        ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
        "firewall_ids",
        "public_ports",
        [
          "lifecycle_policy",
          1,
          [
            1,
            [
              "pause_after_idle_seconds",
              "hibernate_after_paused_seconds",
              "connection_idle_seconds"
            ]
          ]
        ],
        ["runtime", 0, [1, ["stop_signal"]]],
        ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
        "ignore_image_hooks",
        "entrypoint_wait_seconds",
        ["operation", 0, [1, ["requested_at"]]],
        "current_instance",
        "restart_required",
        "last_activity_at",
        "pause_at",
        "hibernates_at",
        ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
        "created_at",
        "running_at",
        "paused_at",
        "hibernated_at",
        "terminated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxMachinesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_id"]]]]
]);
var mapDashboardInstanceSandboxMachinesOperationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "from_machine_instance_id",
    "superseded_by_id",
    ["instance_operations", 1, [2, [1, ["machine_instance_id"]]]],
    "requested_at",
    "completed_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesOperationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "from_machine_instance_id",
        "superseded_by_id",
        ["instance_operations", 1, [2, [1, ["machine_instance_id"]]]],
        "requested_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSandboxMachinesOperationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["machine_instance_id"]]]]]
);
var mapDashboardInstanceSandboxMachinesPauseOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesRestartOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesStartOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesTouchOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapDashboardInstanceSandboxMachinesUpdateBody = /* @__PURE__ */ mapObject([
  "spec_id",
  "spec_identifier",
  "memory_gib",
  [
    "lifecycle_policy",
    1,
    [
      1,
      [
        "pause_after_idle_seconds",
        "hibernate_after_paused_seconds",
        "connection_idle_seconds"
      ]
    ]
  ],
  ["runtime", 0, [1, ["stop_signal"]]],
  ["lifecycle_hooks", 1, [2, [3, [[0, [1, ["timeout_seconds"]]]]]]],
  "ignore_image_hooks",
  "entrypoint_wait_seconds",
  ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
  "firewall_ids",
  "public_ports"
]);
var mapDashboardInstanceSandboxMachinesUsageSummaryOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    ["from", 0, 4],
    ["to", 0, 4],
    "group_by",
    [
      "groups",
      0,
      [
        2,
        [
          1,
          [
            ["group", 0, [1, ["machine_instance_id"]]],
            [
              "totals",
              0,
              [
                1,
                [
                  "runtime_seconds",
                  "cpu_core_seconds",
                  "average_cores_used",
                  "cpu_percent",
                  "peak_cores_used",
                  "memory_byte_seconds",
                  "average_memory_used_bytes",
                  "peak_memory_used_bytes",
                  "allocated_memory_byte_seconds",
                  "average_memory_allocated_bytes",
                  "network_rx_bytes",
                  "network_tx_bytes",
                  "disk_read_bytes",
                  "disk_write_bytes"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceSandboxMachinesUsageSummaryQuery = /* @__PURE__ */ mapObject([
  ["from", 0, 4],
  ["to", 0, 4],
  "machine_instance_id",
  "group_by",
  "max_series"
]);
var mapDashboardInstanceSandboxMachinesUsageTimelineOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    ["from", 0, 4],
    ["to", 0, 4],
    "group_by",
    [
      "series",
      0,
      [
        2,
        [
          1,
          [
            ["group", 0, [1, ["machine_instance_id"]]],
            [
              "points",
              0,
              [
                2,
                [
                  1,
                  [
                    ["timestamp", 0, 4],
                    "runtime_seconds",
                    "cpu_core_seconds",
                    "average_cores_used",
                    "cpu_percent",
                    "peak_cores_used",
                    "memory_byte_seconds",
                    "average_memory_used_bytes",
                    "peak_memory_used_bytes",
                    "allocated_memory_byte_seconds",
                    "average_memory_allocated_bytes",
                    "network_rx_bytes",
                    "network_tx_bytes",
                    "disk_read_bytes",
                    "disk_write_bytes"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceSandboxMachinesUsageTimelineQuery = /* @__PURE__ */ mapObject(
  [
    ["from", 0, 4],
    ["to", 0, 4],
    "machine_instance_id",
    "group_by",
    "max_series"
  ]
);
var mapDashboardInstanceSandboxMachinesUsageOutput = /* @__PURE__ */ createMapper([
  7,
  [
    1,
    [
      "machine_instance_id",
      ["timestamp", 0, 4],
      "cpu_percent",
      "cores_used",
      "cores_available",
      "memory_used_bytes",
      "memory_total_bytes",
      "network_rx_bytes",
      "network_tx_bytes",
      "disk_read_bytes",
      "disk_write_bytes"
    ]
  ]
]);
var mapDashboardInstanceSandboxMachinesUsageQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_instance_id"]]]]
]);
var mapDashboardInstanceSandboxRegionsGetOutput = /* @__PURE__ */ mapObject([
  "is_default"
]);
var mapDashboardInstanceSandboxRegionsListOutput = /* @__PURE__ */ createMapper([
  7,
  [1, ["is_default"]]
]);
var mapDashboardInstanceSandboxRegionsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSandboxSpecsGetOutput = /* @__PURE__ */ mapObject(
  ["memory_gib", "created_at"],
  1
);
var mapDashboardInstanceSandboxSpecsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["memory_gib", "created_at"]]],
  1
);
var mapDashboardInstanceSandboxSpecsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceScmAccountsPreviewOutput = /* @__PURE__ */ mapObject([
  ["accounts", 0, [2, [1, ["external_id", "image_url"]]]]
]);
var mapDashboardInstanceScmAccountsPreviewBody = /* @__PURE__ */ mapObject([
  "installation_id"
]);
var mapDashboardInstanceScmConnectionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "connection",
      0,
      [
        1,
        [
          "external_installation_id",
          "account_type",
          ["external_account", 1, [1, ["image_url"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapDashboardInstanceScmConnectionsCreateBody = /* @__PURE__ */ mapObject([
  "redirect_url"
]);
var mapDashboardInstanceScmConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "external_installation_id",
    "account_type",
    ["external_account", 1, [1, ["image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceScmConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "external_installation_id",
        "account_type",
        ["external_account", 1, [1, ["image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceScmConnectionsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceScmInstallationCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "connection",
      0,
      [
        1,
        [
          "external_installation_id",
          "account_type",
          ["external_account", 1, [1, ["image_url"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapDashboardInstanceScmInstallationCreateBody = /* @__PURE__ */ mapObject([
  "redirect_url"
]);
var mapDashboardInstanceScmInstallationListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "external_installation_id",
        "account_type",
        ["external_account", 1, [1, ["image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceScmInstallationListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceScmProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "provider",
      0,
      [1, ["api_url", "web_url", "is_default", "created_at", "updated_at"]]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapDashboardInstanceScmProvidersCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceScmProvidersGetOutput = /* @__PURE__ */ mapObject(
  ["api_url", "web_url", "is_default", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceScmProvidersListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["api_url", "web_url", "is_default", "created_at", "updated_at"]]],
  1
);
var mapDashboardInstanceScmProvidersListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceScmReposCreateOutput = /* @__PURE__ */ mapObject(
  ["is_private", "default_branch", "created_at"],
  1
);
var mapDashboardInstanceScmReposCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "installation_id",
          "external_repo_id",
          "external_account_id",
          "is_private"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceScmReposGetOutput = /* @__PURE__ */ mapObject(
  ["is_private", "default_branch", "created_at"],
  1
);
var mapDashboardInstanceScmReposListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["is_private", "default_branch", "created_at"]]],
  1
);
var mapDashboardInstanceScmReposListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapDashboardInstanceScmReposPreviewOutput = /* @__PURE__ */ mapObject([
  ["repos", 0, [2, [1, ["external_id"]]]],
  "next_cursor"
]);
var mapDashboardInstanceScmReposPreviewBody = /* @__PURE__ */ mapObject([
  "installation_id",
  "external_account_id"
]);
var mapDashboardInstanceSessionTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesCreateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters"
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesListToolsOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionTemplatesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_instance_id",
        "integration_instance_group_id",
        "identity_actor_id",
        "identity_id",
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "session_template_id",
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_config",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionTemplatesProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesProvidersCreateBody = /* @__PURE__ */ mapObject(
  [
    "session_template_id",
    "provider_deployment_id",
    "provider_config_id",
    "provider_config_vault_id",
    "provider_auth_config_id",
    "tool_filters"
  ]
);
var mapDashboardInstanceSessionTemplatesProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "session_template_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "auth_config",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionTemplatesProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "session_template_id",
            "provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceSessionTemplatesProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesProvidersUpdateBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapDashboardInstanceSessionTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSessionsConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["mcp", 0, [1, ["protocol_version"]]],
    "session_id",
    [
      "participant",
      0,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    "has_errors",
    "has_warnings",
    "created_at",
    "last_message_at",
    "last_active_at"
  ],
  1
);
var mapDashboardInstanceSessionsConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_state",
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        ["mcp", 0, [1, ["protocol_version"]]],
        "session_id",
        [
          "participant",
          0,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        "has_errors",
        "has_warnings",
        "created_at",
        "last_message_at",
        "last_active_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionsConnectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "connection_state",
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "session_id",
          "session_provider_id",
          "participant_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsCreateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [
      2,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "provider_deployment_id",
                [
                  "provider_deployment",
                  1,
                  [1, ["provider_id", "locked_provider_version_id"]]
                ],
                "provider_config_id",
                [
                  "provider_config",
                  1,
                  [3, [[0, [1, ["provider_config_vault_id", "provider_id"]]]]]
                ],
                "provider_auth_config_id",
                [
                  "provider_auth_config",
                  1,
                  [1, ["provider_auth_method_id", "provider_id"]]
                ],
                "session_template_id",
                "tool_filters"
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsErrorGroupsGetOutput = /* @__PURE__ */ mapObject(
  ["provider_id", "occurrence_count", "created_at"],
  1
);
var mapDashboardInstanceSessionsErrorGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["provider_id", "occurrence_count", "created_at"]]],
  1
);
var mapDashboardInstanceSessionsErrorGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["session_id", "provider_id"]]]]
]);
var mapDashboardInstanceSessionsErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "provider_run_id",
    "connection_id",
    "group_id",
    "similar_error_count",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSessionsErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "provider_run_id",
        "connection_id",
        "group_id",
        "similar_error_count",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionsErrorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "session_error_group_id",
          "provider_run_id",
          "provider_id",
          "session_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    [
      "connection",
      0,
      [
        1,
        [
          "connection_state",
          [
            "usage",
            0,
            [
              1,
              [
                "total_productive_client_message_count",
                "total_productive_provider_message_count"
              ]
            ]
          ],
          ["mcp", 0, [1, ["protocol_version"]]],
          "session_id",
          [
            "participant",
            0,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          "has_errors",
          "has_warnings",
          "created_at",
          "last_message_at",
          "last_active_at"
        ]
      ]
    ],
    [
      "provider_run",
      1,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "provider_id",
          "connection_id",
          "completed_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "message",
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "connection_id",
          "provider_run_id",
          ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
          [
            "transport",
            0,
            [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
          ],
          [
            "tool_call",
            1,
            [
              1,
              [
                "tool_key",
                "session_id",
                "message_id",
                "session_provider_id",
                "connection_id",
                "provider_run_id",
                [
                  "sender_participant",
                  1,
                  [
                    1,
                    [
                      "provider_id",
                      "connection_type",
                      "agent_id",
                      "agent_instance_id",
                      "identity_actor_id",
                      "identity_id",
                      "agent_actor_id",
                      "agent_client_id",
                      "consumer_id",
                      "created_at"
                    ]
                  ]
                ],
                [
                  "responder_participant",
                  1,
                  [
                    1,
                    [
                      "provider_id",
                      "connection_type",
                      "agent_id",
                      "agent_instance_id",
                      "identity_actor_id",
                      "identity_id",
                      "agent_actor_id",
                      "agent_client_id",
                      "consumer_id",
                      "created_at"
                    ]
                  ]
                ],
                [
                  "tool",
                  0,
                  [
                    1,
                    [
                      "input_schema",
                      "output_schema",
                      ["tags", 0, [1, ["read_only"]]],
                      "tool_category_keys",
                      "specification_id",
                      "provider_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "error",
                  0,
                  [
                    1,
                    [
                      "session_id",
                      "provider_run_id",
                      "connection_id",
                      "group_id",
                      "similar_error_count",
                      "created_at"
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          [
            "sender_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "responder_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "error",
            0,
            [
              1,
              [
                "session_id",
                "provider_run_id",
                "connection_id",
                "group_id",
                "similar_error_count",
                "created_at"
              ]
            ]
          ],
          "created_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    ["warning", 0, [1, ["session_id", "connection_id", "created_at"]]],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSessionsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        [
          "connection",
          0,
          [
            1,
            [
              "connection_state",
              [
                "usage",
                0,
                [
                  1,
                  [
                    "total_productive_client_message_count",
                    "total_productive_provider_message_count"
                  ]
                ]
              ],
              ["mcp", 0, [1, ["protocol_version"]]],
              "session_id",
              [
                "participant",
                0,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              "has_errors",
              "has_warnings",
              "created_at",
              "last_message_at",
              "last_active_at"
            ]
          ]
        ],
        [
          "provider_run",
          1,
          [
            1,
            [
              "session_id",
              "session_provider_id",
              "provider_id",
              "connection_id",
              "completed_at",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "message",
          0,
          [
            1,
            [
              "session_id",
              "session_provider_id",
              "connection_id",
              "provider_run_id",
              [
                "hierarchy",
                0,
                [1, ["parent_message_id", "child_message_ids"]]
              ],
              [
                "transport",
                0,
                [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
              ],
              [
                "tool_call",
                1,
                [
                  1,
                  [
                    "tool_key",
                    "session_id",
                    "message_id",
                    "session_provider_id",
                    "connection_id",
                    "provider_run_id",
                    [
                      "sender_participant",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "connection_type",
                          "agent_id",
                          "agent_instance_id",
                          "identity_actor_id",
                          "identity_id",
                          "agent_actor_id",
                          "agent_client_id",
                          "consumer_id",
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "responder_participant",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "connection_type",
                          "agent_id",
                          "agent_instance_id",
                          "identity_actor_id",
                          "identity_id",
                          "agent_actor_id",
                          "agent_client_id",
                          "consumer_id",
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "tool",
                      0,
                      [
                        1,
                        [
                          "input_schema",
                          "output_schema",
                          ["tags", 0, [1, ["read_only"]]],
                          "tool_category_keys",
                          "specification_id",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "error",
                      0,
                      [
                        1,
                        [
                          "session_id",
                          "provider_run_id",
                          "connection_id",
                          "group_id",
                          "similar_error_count",
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              [
                "sender_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "responder_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "error",
                0,
                [
                  1,
                  [
                    "session_id",
                    "provider_run_id",
                    "connection_id",
                    "group_id",
                    "similar_error_count",
                    "created_at"
                  ]
                ]
              ],
              "created_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        ["warning", 0, [1, ["session_id", "connection_id", "created_at"]]],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionsEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "provider_run_id",
          "session_message_id",
          "session_error_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_state",
        "connection_url",
        "client_secret",
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                [
                  "usage",
                  0,
                  [
                    1,
                    [
                      "total_productive_client_message_count",
                      "total_productive_provider_message_count"
                    ]
                  ]
                ],
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "session_id",
                "from_template_id",
                "from_template_provider_id",
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_config",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "from_template_ids",
        "has_errors",
        "has_warnings",
        "identity_actor_id",
        "identity_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "session_template_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
    [
      "transport",
      0,
      [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
    ],
    [
      "tool_call",
      1,
      [
        1,
        [
          "tool_key",
          "session_id",
          "message_id",
          "session_provider_id",
          "connection_id",
          "provider_run_id",
          [
            "sender_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "responder_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "tool",
            0,
            [
              1,
              [
                "input_schema",
                "output_schema",
                ["tags", 0, [1, ["read_only"]]],
                "tool_category_keys",
                "specification_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "error",
            0,
            [
              1,
              [
                "session_id",
                "provider_run_id",
                "connection_id",
                "group_id",
                "similar_error_count",
                "created_at"
              ]
            ]
          ],
          "created_at"
        ]
      ]
    ],
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSessionsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "session_provider_id",
        "connection_id",
        "provider_run_id",
        ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
        [
          "transport",
          0,
          [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
        ],
        [
          "tool_call",
          1,
          [
            1,
            [
              "tool_key",
              "session_id",
              "message_id",
              "session_provider_id",
              "connection_id",
              "provider_run_id",
              [
                "sender_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "responder_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "tool",
                0,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    ["tags", 0, [1, ["read_only"]]],
                    "tool_category_keys",
                    "specification_id",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "error",
                0,
                [
                  1,
                  [
                    "session_id",
                    "provider_run_id",
                    "connection_id",
                    "group_id",
                    "similar_error_count",
                    "created_at"
                  ]
                ]
              ],
              "created_at"
            ]
          ]
        ],
        [
          "sender_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "responder_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionsMessagesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "provider_run_id",
          "error_id",
          "participant_id",
          "parent_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "connection_type",
    "agent_id",
    "agent_instance_id",
    "identity_actor_id",
    "identity_id",
    "agent_actor_id",
    "agent_client_id",
    "consumer_id",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSessionsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "connection_type",
        "agent_id",
        "agent_instance_id",
        "identity_actor_id",
        "identity_id",
        "agent_actor_id",
        "agent_client_id",
        "consumer_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionsParticipantsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "session_id",
          "session_connection_id",
          "session_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsProvidersCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "tool_filters",
          "provider_deployment_id",
          [
            "provider_deployment",
            1,
            [1, ["provider_id", "locked_provider_version_id"]]
          ],
          "provider_config_id",
          [
            "provider_config",
            1,
            [3, [[0, [1, ["provider_config_vault_id", "provider_id"]]]]]
          ],
          "provider_auth_config_id",
          [
            "provider_auth_config",
            1,
            [1, ["provider_auth_method_id", "provider_id"]]
          ]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "session_id",
        "from_template_id",
        "from_template_provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "auth_config",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSessionsProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_template_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSessionsProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsProvidersUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters"
]);
var mapDashboardInstanceSessionsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSessionsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsAgentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsAgentsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsAgentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsAgentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsAgentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        "store_id",
        "store_item_id",
        "document_id",
        "archived_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsAgentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["include_archived"]]]]
]);
var mapDashboardInstanceSkillsAgentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsAgentsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsConfigurationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsConfigurationsCreateBody = /* @__PURE__ */ mapObject([
  "allow_scripts",
  "allowed_file_extensions",
  "allow_non_standard_directories"
]);
var mapDashboardInstanceSkillsConfigurationsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsConfigurationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsConfigurationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        "allow_scripts",
        "allowed_file_extensions",
        "allow_non_standard_directories",
        "deleted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsConfigurationsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSkillsConfigurationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsConfigurationsUpdateBody = /* @__PURE__ */ mapObject([
  "allow_scripts",
  "allowed_file_extensions",
  "allow_non_standard_directories"
]);
var mapDashboardInstanceSkillsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsCreateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id",
  "template_id",
  "skill_group_id"
]);
var mapDashboardInstanceSkillsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsDuplicateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsDuplicateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata"
]);
var mapDashboardInstanceSkillsExportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "started_at",
    "completed_at"
  ],
  1
);
var mapDashboardInstanceSkillsExportsCreateBody = /* @__PURE__ */ mapObject([
  "skill_id",
  "skill_plugin_id",
  "skill_marketplace_id"
]);
var mapDashboardInstanceSkillsExportsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "started_at",
    "completed_at"
  ],
  1
);
var mapDashboardInstanceSkillsExportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "file",
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "started_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsExportsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsFilesBatchOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "previous_path",
        [
          "file",
          0,
          [
            1,
            [
              "skill_id",
              "store_item_id",
              "document_id",
              "file_id",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsFilesBatchBody = /* @__PURE__ */ mapObject([
  ["changes", 0, [2, [3, [[0, [1, ["file_id", "if_match", "to_path"]]]]]]]
]);
var mapDashboardInstanceSkillsFilesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsFilesDeleteQuery = /* @__PURE__ */ mapObject([
  "if_match"
]);
var mapDashboardInstanceSkillsFilesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_item_id",
    "document_id",
    "file_id",
    "updated_at",
    "download_url"
  ],
  1
);
var mapDashboardInstanceSkillsFilesGetQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsFilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [1, ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]]
  ],
  1
);
var mapDashboardInstanceSkillsFilesMoveOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsFilesMoveBody = /* @__PURE__ */ mapObject([
  "to_path",
  "if_match"
]);
var mapDashboardInstanceSkillsFilesPutOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsFilesPutBody = /* @__PURE__ */ mapObject([
  "file_id",
  "if_match"
]);
var mapDashboardInstanceSkillsForkSyncsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "fork_skill_id",
    "upstream_skill_id",
    "merge_request_id",
    "processing_started_at",
    "action_required_at",
    "completed_at",
    "failed_at",
    "cancelled_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsForkSyncsCreateBody = /* @__PURE__ */ mapObject([
  "skill_id"
]);
var mapDashboardInstanceSkillsForkSyncsGetOutput = /* @__PURE__ */ mapObject(
  [
    "fork_skill_id",
    "upstream_skill_id",
    "merge_request_id",
    "processing_started_at",
    "action_required_at",
    "completed_at",
    "failed_at",
    "cancelled_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsForkOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsForkBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id"
]);
var mapDashboardInstanceSkillsGetOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsCreateBody = /* @__PURE__ */ mapObject([
  "skill_ids",
  "allow_consumer_skill_assignment"
]);
var mapDashboardInstanceSkillsGroupsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsGetOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsItemsCreateBody = /* @__PURE__ */ mapObject([
  "skill_id"
]);
var mapDashboardInstanceSkillsGroupsItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_group_id",
        [
          "skill",
          0,
          [
            1,
            [
              "image_url",
              "client_name",
              "client_description",
              "client_metadata",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsGroupsItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["skill_id", ["created_at", 1, 5]]]]]
]);
var mapDashboardInstanceSkillsGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "allow_consumer_skill_assignment",
        [
          "skills",
          0,
          [
            2,
            [
              1,
              [
                "image_url",
                "client_name",
                "client_description",
                "client_metadata",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["skill_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapDashboardInstanceSkillsGroupsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsGroupsUpdateBody = /* @__PURE__ */ mapObject([
  "skill_ids",
  "allow_consumer_skill_assignment"
]);
var mapDashboardInstanceSkillsImportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "source",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "repository_url",
                "repository_name",
                "repository_id",
                "file_id",
                "file_name"
              ]
            ]
          ]
        ]
      ]
    ],
    ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsImportsCreateBody = /* @__PURE__ */ mapObject([
  [
    "source",
    0,
    [3, [[0, [1, ["repository_url", "repository_id", "file_id"]]]]]
  ]
]);
var mapDashboardInstanceSkillsImportsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "source",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "repository_url",
                "repository_name",
                "repository_id",
                "file_id",
                "file_name"
              ]
            ]
          ]
        ]
      ]
    ],
    ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsImportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "source",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    "repository_url",
                    "repository_name",
                    "repository_id",
                    "file_id",
                    "file_name"
                  ]
                ]
              ]
            ]
          ]
        ],
        ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
        "started_at",
        "completed_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsImportsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsItemsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "integration_id"]]]]
]);
var mapDashboardInstanceSkillsItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        [
          "integration",
          0,
          [
            1,
            [
              [
                "configuration",
                0,
                [
                  1,
                  [
                    "can_attach_custom_tool_filters",
                    "can_attach_custom_provider_config",
                    "can_override_tool_filters",
                    "enable_callback_tools",
                    "use_integration_name_in_tool_names"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        ["provider", 0, 8],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["integration_id", "provider_id", ["created_at", 1, 5]]]]]
]);
var mapDashboardInstanceSkillsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_url",
        "client_name",
        "client_description",
        "client_metadata",
        "store_id",
        [
          "hierarchy",
          0,
          [
            1,
            [
              "parent_skill_id",
              [
                "creator",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              [
                "fork",
                0,
                [
                  1,
                  [
                    "parent_skill_id",
                    [
                      "creator",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          [
                            "organization_actor",
                            1,
                            [
                              1,
                              [
                                "organization_id",
                                "image_url",
                                [
                                  "teams",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        "assignment_id",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer",
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "user_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer_profile",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "consumer_id",
                                      "user_id",
                                      "created_at",
                                      "updated_at",
                                      [
                                        "groups",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              [
                                                "group",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "is_default",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "assigned_via"
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    [
                      "original_creator",
                      1,
                      [
                        1,
                        [
                          "image_url",
                          [
                            "organization_actor",
                            1,
                            [
                              1,
                              [
                                "organization_id",
                                "image_url",
                                [
                                  "teams",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        "assignment_id",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer",
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "user_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer_profile",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "consumer_id",
                                      "user_id",
                                      "created_at",
                                      "updated_at",
                                      [
                                        "groups",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              [
                                                "group",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "is_default",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "assigned_via"
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              [
                "entity",
                0,
                [1, ["parent_skill_id", "created_at", "updated_at"]]
              ]
            ]
          ]
        ],
        [
          "integrations",
          0,
          [
            2,
            [
              1,
              [
                [
                  "configuration",
                  0,
                  [
                    1,
                    [
                      "can_attach_custom_tool_filters",
                      "can_attach_custom_provider_config",
                      "can_override_tool_filters",
                      "enable_callback_tools",
                      "use_integration_name_in_tool_names"
                    ]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        ["providers", 0, [2, 8]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_group_id",
          "integration_id",
          "provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSkillsMarketplacesArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesCreateBody = /* @__PURE__ */ mapObject([
  "image_file_id",
  "skill_configuration_id",
  "repository_access_mode",
  "force_merge_or_push",
  "merge_before_checks_pass"
]);
var mapDashboardInstanceSkillsMarketplacesGetEditorUrlOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapDashboardInstanceSkillsMarketplacesGetEditorUrlBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSkillsMarketplacesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "repository_access_mode",
              "force_merge_or_push",
              "merge_before_checks_pass",
              "sync_status",
              "image_url",
              "skill_configuration_id",
              [
                "plugins",
                0,
                [
                  2,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "skill_configuration_id",
                            "skill_marketplace_id",
                            [
                              "skill_plugin",
                              1,
                              [
                                3,
                                [
                                  [
                                    0,
                                    [
                                      1,
                                      [
                                        "sync_status",
                                        "image_url",
                                        "long_description",
                                        "skill_configuration_id",
                                        [
                                          "skills",
                                          0,
                                          [
                                            2,
                                            [
                                              1,
                                              [
                                                "client_name",
                                                "client_description",
                                                "client_metadata",
                                                "skill_configuration_id",
                                                "skill_id",
                                                [
                                                  "skill",
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "image_url",
                                                      "client_name",
                                                      "client_description",
                                                      "client_metadata",
                                                      "created_at",
                                                      "updated_at"
                                                    ]
                                                  ]
                                                ],
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ]
                                        ],
                                        "created_at",
                                        "updated_at",
                                        "can_update",
                                        "can_delete"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "can_create_plugins"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["skill_configuration_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapDashboardInstanceSkillsMarketplacesPluginsAddOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesPluginsAddBody = /* @__PURE__ */ mapObject([
  "skill_plugin_id",
  "skill_configuration_id"
]);
var mapDashboardInstanceSkillsMarketplacesPluginsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesPluginsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "skill_configuration_id",
              "skill_marketplace_id",
              [
                "skill_plugin",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "sync_status",
                          "image_url",
                          "long_description",
                          "skill_configuration_id",
                          [
                            "skills",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  "client_name",
                                  "client_description",
                                  "client_metadata",
                                  "skill_configuration_id",
                                  "skill_id",
                                  [
                                    "skill",
                                    0,
                                    [
                                      1,
                                      [
                                        "image_url",
                                        "client_name",
                                        "client_description",
                                        "client_metadata",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesPluginsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_plugin_id",
            "skill_configuration_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardInstanceSkillsMarketplacesPluginsRemoveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesRepositoriesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesRepositoriesCreateBody = /* @__PURE__ */ mapObject(
  ["repo_id"]
);
var mapDashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesRepositoriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesRepositoriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_marketplace_id",
        "repo_id",
        [
          "repository",
          0,
          [1, ["is_private", "default_branch", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesRepositoriesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSkillsMarketplacesSyncOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesSyncBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsMarketplacesUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMarketplacesUpdateBody = /* @__PURE__ */ mapObject([
  "image_file_id",
  "skill_configuration_id",
  "repository_access_mode",
  "force_merge_or_push",
  "merge_before_checks_pass"
]);
var mapDashboardInstanceSkillsMergeRequestsCloseOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsCommentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsCommentsCreateBody = /* @__PURE__ */ mapObject(
  ["item_id", "in_reply_to_comment_id"]
);
var mapDashboardInstanceSkillsMergeRequestsCommentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsCommentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsCommentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_merge_request_item_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "in_reply_to_comment_id",
        "deleted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsCommentsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["item_id"]]]]]
);
var mapDashboardInstanceSkillsMergeRequestsCommentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsCommentsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSkillsMergeRequestsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsCreateBody = /* @__PURE__ */ mapObject([
  "source_skill_id",
  "target_skill_id"
]);
var mapDashboardInstanceSkillsMergeRequestsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "comment",
      0,
      [
        1,
        [
          "skill_merge_request_item_id",
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "in_reply_to_comment_id",
          "deleted_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "error_code",
    "error_message",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "comment",
          0,
          [
            1,
            [
              "skill_merge_request_item_id",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "in_reply_to_comment_id",
              "deleted_at",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "error_code",
        "error_message",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsEventsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, [["created_at", 1, 5]]]]]]
);
var mapDashboardInstanceSkillsMergeRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_merge_request_id",
        "change_type",
        "resolution_type",
        "conflict_reason",
        [
          "resolved_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "resolved_at",
        "applied_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveBody = /* @__PURE__ */ mapObject(
  [["items", 0, [2, [1, ["item_id", "resolution_type"]]]]]
);
var mapDashboardInstanceSkillsMergeRequestsItemsResolveOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_id",
    "change_type",
    "resolution_type",
    "conflict_reason",
    [
      "resolved_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "resolved_at",
    "applied_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsItemsResolveBody = /* @__PURE__ */ mapObject(
  ["resolution_type"]
);
var mapDashboardInstanceSkillsMergeRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "base_strategy",
        "merge_error",
        "merge_error_code",
        "source_skill_id",
        "target_skill_id",
        "base_target_skill_version_id",
        "requested_source_skill_version_id",
        "requested_target_skill_version_id",
        "pre_merge_target_skill_version_id",
        "merged_target_skill_version_id",
        "rollback_target_skill_version_id",
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "item_count",
        "comment_count",
        "merge_started_at",
        "merged_at",
        "closed_at",
        "rolled_back_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "source_skill_id",
          "target_skill_id",
          "created_by_actor_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSkillsMergeRequestsPerformOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsPlanGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "merge_request",
      1,
      [
        1,
        [
          "base_strategy",
          "merge_error",
          "merge_error_code",
          "source_skill_id",
          "target_skill_id",
          "base_target_skill_version_id",
          "requested_source_skill_version_id",
          "requested_target_skill_version_id",
          "pre_merge_target_skill_version_id",
          "merged_target_skill_version_id",
          "rollback_target_skill_version_id",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "item_count",
          "comment_count",
          "merge_started_at",
          "merged_at",
          "closed_at",
          "rolled_back_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "item",
              0,
              [
                1,
                [
                  "skill_merge_request_id",
                  "change_type",
                  "resolution_type",
                  "conflict_reason",
                  [
                    "resolved_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "resolved_at",
                  "applied_at",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "base",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "source",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "target",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "document_merge",
              1,
              [
                1,
                [
                  "base_content",
                  "source_content",
                  "target_content",
                  "has_conflict"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsMergeRequestsRollbackOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsParticipantsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsPluginsArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsCreateBody = /* @__PURE__ */ mapObject([
  "long_description",
  "image_file_id",
  "skill_configuration_id",
  "skill_marketplace_id"
]);
var mapDashboardInstanceSkillsPluginsGetEditorUrlOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapDashboardInstanceSkillsPluginsGetEditorUrlBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSkillsPluginsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "sync_status",
              "image_url",
              "long_description",
              "skill_configuration_id",
              [
                "skills",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "client_name",
                      "client_description",
                      "client_metadata",
                      "skill_configuration_id",
                      "skill_id",
                      [
                        "skill",
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "client_name",
                            "client_description",
                            "client_metadata",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "can_update",
              "can_delete"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_marketplace_id",
          "skill_configuration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSkillsPluginsRepositoriesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsPluginsRepositoriesCreateBody = /* @__PURE__ */ mapObject(
  ["repo_id"]
);
var mapDashboardInstanceSkillsPluginsRepositoriesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsPluginsRepositoriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsPluginsRepositoriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_plugin_id",
        "repo_id",
        [
          "repository",
          0,
          [1, ["is_private", "default_branch", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsRepositoriesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSkillsPluginsSkillsAddOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsPluginsSkillsAddBody = /* @__PURE__ */ mapObject([
  "skill_id",
  "client_name",
  "client_description",
  "client_metadata",
  "skill_configuration_id"
]);
var mapDashboardInstanceSkillsPluginsSkillsGetOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsPluginsSkillsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "client_name",
        "client_description",
        "client_metadata",
        "skill_configuration_id",
        "skill_id",
        [
          "skill",
          0,
          [
            1,
            [
              "image_url",
              "client_name",
              "client_description",
              "client_metadata",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsSkillsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_id",
          "skill_configuration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSkillsPluginsSkillsRemoveOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsPluginsSkillsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsPluginsSkillsUpdateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "skill_configuration_id"
]);
var mapDashboardInstanceSkillsPluginsSyncOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsSyncBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsPluginsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsPluginsUpdateBody = /* @__PURE__ */ mapObject([
  "long_description",
  "image_file_id",
  "skill_configuration_id"
]);
var mapDashboardInstanceSkillsPublishConsumerSkillOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsShareOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsShareBody = /* @__PURE__ */ mapObject([
  "consumer_profile_ids",
  "organization_member_ids"
]);
var mapDashboardInstanceSkillsSyncsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "skill_plugin_id",
    ["logs", 0, [2, [1, [["timestamp", 0, 4]]]]],
    [
      "repository_propagations",
      1,
      [
        2,
        [
          1,
          [
            "repo_id",
            "repository_access_mode",
            "branch_name",
            "pr_name",
            "pr_description",
            "commit_message",
            "error_message",
            "created_at",
            "updated_at",
            "started_at",
            "completed_at"
          ]
        ]
      ]
    ],
    "created_at",
    "started_at",
    "completed_at"
  ],
  1
);
var mapDashboardInstanceSkillsSyncsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_marketplace_id",
        "skill_plugin_id",
        ["logs", 0, [2, [1, [["timestamp", 0, 4]]]]],
        [
          "repository_propagations",
          1,
          [
            2,
            [
              1,
              [
                "repo_id",
                "repository_access_mode",
                "branch_name",
                "pr_name",
                "pr_description",
                "commit_message",
                "error_message",
                "created_at",
                "updated_at",
                "started_at",
                "completed_at"
              ]
            ]
          ]
        ],
        "created_at",
        "started_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsSyncsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [1, ["skill_marketplace_id", "skill_plugin_id", ["created_at", 1, 5]]]
    ]
  ]
]);
var mapDashboardInstanceSkillsSyncsRepositoryChecksOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "propagation_id",
            "repo_id",
            "repository_name",
            "repository_url",
            "pull_request_url",
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "override_attempt_status",
            "override_refusal_reason",
            "target_branch",
            "origin_status",
            "review_status",
            "required_review_count",
            "approved_review_count",
            "last_checked_at",
            "error_message"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesCreateBody = /* @__PURE__ */ mapObject([
  ["from_skill_Id", "fromSkillId"]
]);
var mapDashboardInstanceSkillsTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesItemsCreateBody = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["provider_id", "integration_id"]]]]]
);
var mapDashboardInstanceSkillsTemplatesItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "integration",
          0,
          [
            1,
            [
              [
                "configuration",
                0,
                [
                  1,
                  [
                    "can_attach_custom_tool_filters",
                    "can_attach_custom_provider_config",
                    "can_override_tool_filters",
                    "enable_callback_tools",
                    "use_integration_name_in_tool_names"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        ["provider", 0, 8],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesItemsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstanceSkillsTemplatesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        [
          "items",
          0,
          [
            2,
            [
              1,
              [
                [
                  "integration",
                  0,
                  [
                    1,
                    [
                      [
                        "configuration",
                        0,
                        [
                          1,
                          [
                            "can_attach_custom_tool_filters",
                            "can_attach_custom_provider_config",
                            "can_override_tool_filters",
                            "enable_callback_tools",
                            "use_integration_name_in_tool_names"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ],
                ["provider", 0, 8],
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "integration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceSkillsTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceSkillsUpdateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id"
]);
var mapDashboardInstanceSkillsVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_version_id",
    "version_number",
    "created_at"
  ],
  1
);
var mapDashboardInstanceSkillsVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        "store_id",
        "store_version_id",
        "version_number",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceSkillsVersionsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceSkillsVersionsSnapshotGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_version_id",
    "version_number",
    [
      "items",
      0,
      [
        2,
        [1, ["file_id", "document_id", "document_version_id", "created_at"]]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceStoresCreateOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceStoresCreateBody = /* @__PURE__ */ mapObject([
  "template_id",
  "parent_id"
]);
var mapDashboardInstanceStoresDeleteOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceStoresGetOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceStoresItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    "directory_id",
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "document",
      0,
      [
        1,
        [
          "file_id",
          "parent_document_id",
          "current_version_id",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardInstanceStoresItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        "directory_id",
        [
          "file",
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "document",
          0,
          [
            1,
            [
              "file_id",
              "parent_document_id",
              "current_version_id",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceStoresItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["file_id", "document_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapDashboardInstanceStoresItemsModifyOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "store_id",
            "directory_id",
            [
              "file",
              0,
              [
                1,
                [
                  "file_name",
                  "file_size",
                  "file_type",
                  [
                    "created_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "document",
              0,
              [
                1,
                [
                  "file_id",
                  "parent_document_id",
                  "current_version_id",
                  [
                    "created_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardInstanceStoresItemsModifyBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceStoresListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["item_count", "created_at", "updated_at"]]],
  1
);
var mapDashboardInstanceStoresListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceStoresParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceStoresParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceStoresParticipantsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceStoresPermissionsGetOutput = /* @__PURE__ */ mapObject([
  "store_id",
  "has_full_access",
  "relevant_store_ids",
  "readable_store_ids",
  "writable_store_ids"
]);
var mapDashboardInstanceStoresUpdateOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapDashboardInstanceStoresUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardInstanceToolCallsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "tool_key",
    "session_id",
    "message_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "tool",
      0,
      [
        1,
        [
          "input_schema",
          "output_schema",
          ["tags", 0, [1, ["read_only"]]],
          "tool_category_keys",
          "specification_id",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceToolCallsCreateBody = /* @__PURE__ */ mapObject([
  "tool_id",
  "session_id"
]);
var mapDashboardInstanceToolCallsGetOutput = /* @__PURE__ */ mapObject(
  [
    "tool_key",
    "session_id",
    "message_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "tool",
      0,
      [
        1,
        [
          "input_schema",
          "output_schema",
          ["tags", 0, [1, ["read_only"]]],
          "tool_category_keys",
          "specification_id",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardInstanceToolCallsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "tool_key",
        "session_id",
        "message_id",
        "session_provider_id",
        "connection_id",
        "provider_run_id",
        [
          "sender_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "responder_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "tool",
          0,
          [
            1,
            [
              "input_schema",
              "output_schema",
              ["tags", 0, [1, ["read_only"]]],
              "tool_category_keys",
              "specification_id",
              "provider_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardInstanceToolCallsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_template_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "tool_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardInstanceWebhookRegistrationsCreateOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceWebhookRegistrationsCreateBody = /* @__PURE__ */ mapObject([
  "provider_id"
]);
var mapDashboardInstanceWebhookRegistrationsDeleteOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceWebhookRegistrationsGetOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceWebhookRegistrationsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["receive_url", ["provider", 0, 8], "created_at", "updated_at"]]],
  1
);
var mapDashboardInstanceWebhookRegistrationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapDashboardInstanceWebhookRegistrationsSetupOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceWebhookRegistrationsSetupBody = /* @__PURE__ */ mapObject([
  "user_config"
]);
var mapDashboardInstanceWebhookRegistrationsUpdateOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapDashboardInstanceWebhookRegistrationsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardInstancesResourceCountsGetOutput = /* @__PURE__ */ createMapper(0);
var mapDashboardInstancesResourceCountsGetQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardOauthAuthorizationRequestsApproveOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "user_code",
    "redirect_uri",
    "redirect_url",
    "created_at",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOauthAuthorizationRequestsApproveBody = /* @__PURE__ */ mapObject([
  "organization_id",
  "consumer_profile_id"
]);
var mapDashboardOauthAuthorizationRequestsConsumerTargetsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["consumer_profile_id"]]]
);
var mapDashboardOauthAuthorizationRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "user_code",
    "redirect_uri",
    "redirect_url",
    "created_at",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOauthAuthorizationRequestsRejectOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "user_code",
    "redirect_uri",
    "redirect_url",
    "created_at",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOauthAuthorizationRequestsRejectBody = /* @__PURE__ */ mapObject([
  "organization_id",
  "consumer_profile_id"
]);
var mapDashboardOrganizationsAccessPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessPoliciesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsAccessPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessPoliciesGetOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessPoliciesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["organization_id", "created_at", "updated_at"]]],
  1
);
var mapDashboardOrganizationsAccessPoliciesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsAccessPoliciesUpdateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessPoliciesUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsAccessPoliciesVersionsOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["access_policy_id", "created_at"]]],
  1
);
var mapDashboardOrganizationsAccessPoliciesVersionsQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsAccessRolesCreateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessRolesCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsAccessRolesDeleteOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessRolesGetOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessRolesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["organization_id", "is_admin", "created_at", "updated_at"]]],
  1
);
var mapDashboardOrganizationsAccessRolesListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsAccessRolesUpdateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsAccessRolesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsAccessRolesVersionsOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [1, ["access_role_id", "scopes_added", "scopes_removed", "created_at"]]
  ],
  1
);
var mapDashboardOrganizationsAccessRolesVersionsQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsApiKeysCreateOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapDashboardOrganizationsApiKeysCreateBody = /* @__PURE__ */ mapObject(
  ["instance_id", "expires_at", "ip_filters"],
  1
);
var mapDashboardOrganizationsApiKeysGetOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapDashboardOrganizationsApiKeysListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "secret_redacted",
        "secret_redacted_long",
        "ip_filters",
        [
          "machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "deleted_at",
        "last_used_at",
        "expires_at",
        "created_at",
        "updated_at",
        ["reveal_info", 1, [1, [["until", 0, 4]]]]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsApiKeysListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["instance_id"]]]]
]);
var mapDashboardOrganizationsApiKeysRevealOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapDashboardOrganizationsApiKeysRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapDashboardOrganizationsApiKeysRotateOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapDashboardOrganizationsApiKeysRotateBody = /* @__PURE__ */ mapObject(
  ["current_expires_at"],
  1
);
var mapDashboardOrganizationsApiKeysUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapDashboardOrganizationsApiKeysUpdateBody = /* @__PURE__ */ mapObject(
  ["expires_at", "ip_filters"],
  1
);
var mapDashboardOrganizationsAuditLogStreamsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsCreateBody = /* @__PURE__ */ mapObject([
  "provider_data"
]);
var mapDashboardOrganizationsAuditLogStreamsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "audit_log_stream_id",
    [
      "error_details",
      1,
      [
        1,
        [
          "error_name",
          "http_status_code",
          "http_status_text",
          "provider_error_code",
          "response_body",
          "batch_identifier",
          "batch_number",
          "successful_batch_count",
          "event_count",
          "first_event_id",
          "last_event_id"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "audit_log_stream_id",
        [
          "error_details",
          1,
          [
            1,
            [
              "error_name",
              "http_status_code",
              "http_status_text",
              "provider_error_code",
              "response_body",
              "batch_identifier",
              "batch_number",
              "successful_batch_count",
              "event_count",
              "first_event_id",
              "last_event_id"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsEventsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsAuditLogStreamsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "access_status",
        "is_paused_due_to_error",
        "error_message",
        "consecutive_error_count",
        "is_started",
        "provider_data",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsAuditLogStreamsResumeOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsAuditLogStreamsUpdateBody = /* @__PURE__ */ mapObject([
  "provider_data"
]);
var mapDashboardOrganizationsAuditLogsGetOutput = /* @__PURE__ */ mapObject(
  [
    "event_id",
    "organization_id",
    "instance_id",
    "organization_actor_id",
    "previous_attributes",
    "recorded_at"
  ],
  1
);
var mapDashboardOrganizationsAuditLogsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "event_id",
        "organization_id",
        "instance_id",
        "organization_actor_id",
        "previous_attributes",
        "recorded_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsAuditLogsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsConfigsGetOutput = /* @__PURE__ */ mapObject(
  [
    "config_type_id",
    "user_id",
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "config_type_id",
        "user_id",
        "organization_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsConfigsSetOutput = /* @__PURE__ */ mapObject(
  [
    "config_type_id",
    "user_id",
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsConfigsSetBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsConfigureAuditLogRetentionGetOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "audit_log_retention_in_days", "updated_at"],
  1
);
var mapDashboardOrganizationsConfigureAuditLogRetentionUpdateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "audit_log_retention_in_days", "updated_at"],
  1
);
var mapDashboardOrganizationsConfigureAuditLogRetentionUpdateBody = /* @__PURE__ */ mapObject(
  ["audit_log_retention_in_days"]
);
var mapDashboardOrganizationsCreateOutput = /* @__PURE__ */ mapObject(
  ["image_url", "magic_mcp_origin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsDeleteOutput = /* @__PURE__ */ mapObject(
  ["image_url", "magic_mcp_origin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsEventDeliveriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_id",
    "event_type",
    "event_destination_id",
    "attempt_count",
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "attempts",
      0,
      [
        2,
        [
          1,
          [
            "event_delivery_id",
            "event_id",
            "event_destination_id",
            "attempt_number",
            "duration_ms",
            "is_retryable",
            ["response", 0, [1, ["status_code", "is_body_truncated"]]],
            "started_at",
            "completed_at",
            "created_at"
          ]
        ]
      ]
    ],
    "last_attempt_at",
    "next_attempt_at",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsEventDeliveriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "instance_id",
        "event_id",
        "event_type",
        "event_destination_id",
        "attempt_count",
        [
          "retry",
          0,
          [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
        ],
        [
          "attempts",
          0,
          [
            2,
            [
              1,
              [
                "event_delivery_id",
                "event_id",
                "event_destination_id",
                "attempt_number",
                "duration_ms",
                "is_retryable",
                ["response", 0, [1, ["status_code", "is_body_truncated"]]],
                "started_at",
                "completed_at",
                "created_at"
              ]
            ]
          ]
        ],
        "last_attempt_at",
        "next_attempt_at",
        "completed_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsEventDeliveriesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [1, ["event_id", "event_type", "event_destination_id", "instance_id"]]
    ]
  ]
]);
var mapDashboardOrganizationsEventDeliveriesRetryOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_id",
    "event_type",
    "event_destination_id",
    "attempt_count",
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "attempts",
      0,
      [
        2,
        [
          1,
          [
            "event_delivery_id",
            "event_id",
            "event_destination_id",
            "attempt_number",
            "duration_ms",
            "is_retryable",
            ["response", 0, [1, ["status_code", "is_body_truncated"]]],
            "started_at",
            "completed_at",
            "created_at"
          ]
        ]
      ]
    ],
    "last_attempt_at",
    "next_attempt_at",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsEventDeliveryAttemptsGetOutput = /* @__PURE__ */ mapObject(
  [
    "event_delivery_id",
    "event_id",
    "event_destination_id",
    "attempt_number",
    "duration_ms",
    "is_retryable",
    ["response", 0, [1, ["status_code", "is_body_truncated"]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapDashboardOrganizationsEventDeliveryAttemptsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "event_delivery_id",
        "event_id",
        "event_destination_id",
        "attempt_number",
        "duration_ms",
        "is_retryable",
        ["response", 0, [1, ["status_code", "is_body_truncated"]]],
        "started_at",
        "completed_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsEventDeliveryAttemptsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["event_delivery_id", "event_id", "event_destination_id"]]]]]
);
var mapDashboardOrganizationsEventDestinationListenersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationListenersCreateBody = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "provider_id",
            "chat_connection_id"
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardOrganizationsEventDestinationListenersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationListenersGetOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationListenersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "instance_id",
        "event_destination_id",
        "event_types",
        "callback_id",
        "chat_connection_id",
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsEventDestinationListenersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "event_destination_id",
            "instance_id",
            "callback_id",
            "chat_connection_id",
            "provider_id"
          ]
        ]
      ]
    ]
  ]
);
var mapDashboardOrganizationsEventDestinationListenersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationListenersUpdateBody = /* @__PURE__ */ mapObject(
  ["event_types"]
);
var mapDashboardOrganizationsEventDestinationsArchiveOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationsCreateBody = /* @__PURE__ */ mapObject([
  [
    "retry",
    0,
    [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
  ]
]);
var mapDashboardOrganizationsEventDestinationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        ["webhook", 0, [1, ["signing_secret"]]],
        [
          "retry",
          0,
          [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
        ],
        [
          "listeners",
          0,
          [
            2,
            [
              1,
              [
                "instance_id",
                "event_destination_id",
                "event_types",
                "callback_id",
                "chat_connection_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsEventDestinationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["callback_id", "chat_connection_id"]]]]]
);
var mapDashboardOrganizationsEventDestinationsPingOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_id",
    "event_type",
    "event_destination_id",
    "attempt_count",
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "attempts",
      0,
      [
        2,
        [
          1,
          [
            "event_delivery_id",
            "event_id",
            "event_destination_id",
            "attempt_number",
            "duration_ms",
            "is_retryable",
            ["response", 0, [1, ["status_code", "is_body_truncated"]]],
            "started_at",
            "completed_at",
            "created_at"
          ]
        ]
      ]
    ],
    "last_attempt_at",
    "next_attempt_at",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationsRotateWebhookSecretOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapDashboardOrganizationsEventDestinationsUpdateBody = /* @__PURE__ */ mapObject([
  [
    "retry",
    0,
    [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
  ]
]);
var mapDashboardOrganizationsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_type",
    "callback_id",
    "callback_event_id",
    "callback_trigger_key",
    "chat_event_id",
    "chat_connection_id",
    "provider_id",
    "created_at"
  ],
  1
);
var mapDashboardOrganizationsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "instance_id",
        "event_type",
        "callback_id",
        "callback_event_id",
        "callback_trigger_key",
        "chat_event_id",
        "chat_connection_id",
        "provider_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "instance_id",
          "event_type",
          "callback_id",
          "callback_trigger_key",
          "chat_connection_id",
          "provider_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDashboardOrganizationsGetOutput = /* @__PURE__ */ mapObject(
  ["image_url", "magic_mcp_origin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "sandbox_id",
    "created_at",
    "updated_at",
    ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
  ],
  1
);
var mapDashboardOrganizationsInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "sandbox_id",
    "created_at",
    "updated_at",
    ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
  ],
  1
);
var mapDashboardOrganizationsInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "sandbox_id",
        "created_at",
        "updated_at",
        ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["project_id"]]]]
]);
var mapDashboardOrganizationsInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "sandbox_id",
    "created_at",
    "updated_at",
    ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
  ],
  1
);
var mapDashboardOrganizationsInstancesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsInvitesCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsInvitesCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsInvitesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsInvitesEnsureLinkOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsInvitesGetOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsInvitesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
        "created_at",
        "updated_at",
        "expires_at",
        "accepted_at",
        "rejected_at",
        "deleted_at",
        [
          "organization",
          0,
          [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
        ],
        [
          "invited_by",
          1,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsInvitesListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsInvitesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsInvitesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsJoinAcceptOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsJoinAcceptBody = /* @__PURE__ */ mapObject([
  "invite_key"
]);
var mapDashboardOrganizationsJoinGetOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsJoinGetQuery = /* @__PURE__ */ mapObject(["invite_key"]);
var mapDashboardOrganizationsJoinRejectOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsJoinRejectBody = /* @__PURE__ */ mapObject([
  "invite_key"
]);
var mapDashboardOrganizationsLayoutsGetOutput = /* @__PURE__ */ mapObject(
  [
    "layout_type_id",
    "user_id",
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsLayoutsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "layout_type_id",
        "user_id",
        "organization_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsLayoutsSetOutput = /* @__PURE__ */ mapObject(
  [
    "layout_type_id",
    "user_id",
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsLayoutsSetBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]],
  1
);
var mapDashboardOrganizationsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsMembersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsMembersGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsMembersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_id",
        "organization_id",
        "actor_id",
        "last_active_at",
        "created_at",
        "updated_at",
        "deleted_at",
        [
          "actor",
          0,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsMembersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["team_id"]]]]
]);
var mapDashboardOrganizationsMembersPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsMembersPoliciesCreateBody = /* @__PURE__ */ mapObject([
  "access_policy_id"
]);
var mapDashboardOrganizationsMembersPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsMembersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsMembersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsOauthAppsClientSecretsCreateOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapDashboardOrganizationsOauthAppsClientSecretsDeleteOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapDashboardOrganizationsOauthAppsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthAppsCreateBody = /* @__PURE__ */ mapObject([
  "access_level",
  "subject_type",
  "allow_token_exchange_without_client_secret",
  "website_url",
  "privacy_policy_url",
  "terms_of_service_url",
  "redirect_uris"
]);
var mapDashboardOrganizationsOauthAppsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthAppsGetOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthAppsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "access_level",
        "subject_type",
        "allow_token_exchange_without_client_secret",
        "image_url",
        "website_url",
        "privacy_policy_url",
        "terms_of_service_url",
        "redirect_uris",
        "client_id",
        ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
        "organization_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOauthAppsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["subject_type"]]]]
]);
var mapDashboardOrganizationsOauthAppsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthAppsUpdateBody = /* @__PURE__ */ mapObject([
  "access_level",
  "allow_token_exchange_without_client_secret",
  "website_url",
  "privacy_policy_url",
  "terms_of_service_url",
  "redirect_uris"
]);
var mapDashboardOrganizationsOauthAuthorizationLogsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "redirect_uri",
        "client_ip",
        [
          "oauth_application",
          1,
          [
            1,
            [
              "access_level",
              "subject_type",
              "allow_token_exchange_without_client_secret",
              "image_url",
              "website_url",
              "privacy_policy_url",
              "terms_of_service_url",
              "redirect_uris",
              "client_id",
              ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
              "organization_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "actor",
          0,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "user",
          0,
          [
            1,
            [
              "first_name",
              "last_name",
              "image_url",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "accepted_at",
        "denied_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOauthAuthorizationLogsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["app_id", "user_id"]]]]]
);
var mapDashboardOrganizationsOauthAuthorizationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "organization_id",
    "oauth_application_id",
    "oauth_installation_id",
    "user_id",
    "organization_member_id",
    "consumer_profile_id",
    "portal_id",
    "instance_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "requesting_ip",
    "accepting_ip",
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthAuthorizationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "subject_type",
        "organization_id",
        "oauth_application_id",
        "oauth_installation_id",
        "user_id",
        "organization_member_id",
        "consumer_profile_id",
        "portal_id",
        "instance_id",
        [
          "oauth_application",
          1,
          [
            1,
            [
              "access_level",
              "subject_type",
              "allow_token_exchange_without_client_secret",
              "image_url",
              "website_url",
              "privacy_policy_url",
              "terms_of_service_url",
              "redirect_uris",
              "client_id",
              ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
              "organization_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "requesting_ip",
        "accepting_ip",
        "last_used_at",
        "revoked_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOauthAuthorizationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["installation_id", "app_id", "subject_type"]]]]]
);
var mapDashboardOrganizationsOauthAuthorizationsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "organization_id",
    "oauth_application_id",
    "oauth_installation_id",
    "user_id",
    "organization_member_id",
    "consumer_profile_id",
    "portal_id",
    "instance_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "requesting_ip",
    "accepting_ip",
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthCliDevicesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "oauth_authorization_id",
    "created_at",
    "updated_at",
    [
      "user",
      0,
      [
        1,
        ["first_name", "last_name", "image_url", "created_at", "updated_at"]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOauthCliDevicesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "oauth_authorization_id",
        "created_at",
        "updated_at",
        [
          "user",
          0,
          [
            1,
            [
              "first_name",
              "last_name",
              "image_url",
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOauthCliDevicesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsOauthInstallationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "server_side_machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthInstallationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        [
          "oauth_application",
          1,
          [
            1,
            [
              "access_level",
              "subject_type",
              "allow_token_exchange_without_client_secret",
              "image_url",
              "website_url",
              "privacy_policy_url",
              "terms_of_service_url",
              "redirect_uris",
              "client_id",
              ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
              "organization_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "server_side_machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "last_used_at",
        "revoked_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOauthInstallationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["app_id"]]]]]
);
var mapDashboardOrganizationsOauthInstallationsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "server_side_machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOauthScopesListOutput = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsOauthScopesListQuery = /* @__PURE__ */ mapObject([
  "subject_type"
]);
var mapDashboardOrganizationsOutpostsAccessListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "outpost_id",
        "project_id",
        "instance_id",
        "organization_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOutpostsAccessListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["organization_id", "instance_id"]]]]
]);
var mapDashboardOrganizationsOutpostsAccessSetOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "outpost_id",
        "project_id",
        "instance_id",
        "organization_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOutpostsAccessSetBody = /* @__PURE__ */ mapObject([
  ["grants", 0, [2, [1, ["instance_id"]]]]
]);
var mapDashboardOrganizationsOutpostsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsOutpostsCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsCredentialsCreateBody = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapDashboardOrganizationsOutpostsCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsCredentialsDisableOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsCredentialsGetOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "outpost_id",
        "envelope_preview",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOutpostsCredentialsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsOutpostsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsDisableOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsEnableOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_status",
        "organization_id",
        "instance_count",
        "last_seen_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsOutpostsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsOutpostsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsOutpostsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsProjectsBrandingGetOutput = /* @__PURE__ */ mapObject(
  ["image_url", "project_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsProjectsBrandingUpdateOutput = /* @__PURE__ */ mapObject(
  ["image_url", "project_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsProjectsBrandingUpdateBody = /* @__PURE__ */ mapObject([
  "image_file_id"
]);
var mapDashboardOrganizationsProjectsCreateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsProjectsCreateBody = /* @__PURE__ */ mapObject([
  "magic_mcp_session_duration_minutes"
]);
var mapDashboardOrganizationsProjectsDeleteOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsProjectsGetOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsProjectsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["organization_id", "created_at", "updated_at"]]],
  1
);
var mapDashboardOrganizationsProjectsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["team_id"]]]]
]);
var mapDashboardOrganizationsProjectsUpdateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsProjectsUpdateBody = /* @__PURE__ */ mapObject([
  "magic_mcp_session_duration_minutes"
]);
var mapDashboardOrganizationsSandboxesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "instance",
      0,
      [
        1,
        [
          "organization_id",
          "sandbox_id",
          "created_at",
          "updated_at",
          ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "creator_actor",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsSandboxesCreateBody = /* @__PURE__ */ mapObject([
  "project_id"
]);
var mapDashboardOrganizationsSandboxesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "instance",
      0,
      [
        1,
        [
          "organization_id",
          "sandbox_id",
          "created_at",
          "updated_at",
          ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "creator_actor",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsSandboxesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        [
          "instance",
          0,
          [
            1,
            [
              "organization_id",
              "sandbox_id",
              "created_at",
              "updated_at",
              [
                "project",
                0,
                [1, ["organization_id", "created_at", "updated_at"]]
              ]
            ]
          ]
        ],
        [
          "creator_actor",
          1,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsSandboxesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["project_id"]]]]
]);
var mapDashboardOrganizationsSandboxesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "instance",
      0,
      [
        1,
        [
          "organization_id",
          "sandbox_id",
          "created_at",
          "updated_at",
          ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "creator_actor",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsSandboxesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsServiceAccountsClientSecretsCreateOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapDashboardOrganizationsServiceAccountsClientSecretsDeleteOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapDashboardOrganizationsServiceAccountsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsCreateBody = /* @__PURE__ */ mapObject([
  "subject_type",
  "portal_id"
]);
var mapDashboardOrganizationsServiceAccountsCredentialsGetOutput = /* @__PURE__ */ mapObject(
  [
    "service_account_id",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "service_account_id",
        [
          "machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "last_used_at",
        "revoked_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsCredentialsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsServiceAccountsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsGetOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "subject_type",
        "client_id",
        ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
        "organization_id",
        "portal_id",
        "consumer_profile_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsServiceAccountsPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsPoliciesCreateBody = /* @__PURE__ */ mapObject(
  ["access_policy_id"]
);
var mapDashboardOrganizationsServiceAccountsPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsServiceAccountsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardOrganizationsTeamsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsTeamsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        [
          "projects",
          0,
          [
            2,
            [
              1,
              [
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardOrganizationsTeamsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsTeamsMembersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsMembersCreateBody = /* @__PURE__ */ mapObject([
  "actor_id"
]);
var mapDashboardOrganizationsTeamsMembersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsPoliciesCreateBody = /* @__PURE__ */ mapObject([
  "access_policy_id"
]);
var mapDashboardOrganizationsTeamsPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardOrganizationsTeamsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDashboardOrganizationsUpdateOutput = /* @__PURE__ */ mapObject(
  ["image_url", "magic_mcp_origin", "created_at", "updated_at"],
  1
);
var mapDashboardOrganizationsUpdateBody = /* @__PURE__ */ mapObject([
  "image_file_id",
  "magic_mcp_origin"
]);
var mapDashboardOrganizationsWebhookEventsListOutput = /* @__PURE__ */ createMapper([
  7,
  0
]);
var mapDashboardProjectsConfigureAuthConfigGetOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "allow_auth_config_export",
    "allow_auth_config_import",
    "only_allow_oauth_auth_methods",
    "consumer_auth_client_registrations_per_hour_limit",
    "consumer_auth_client_registrations_per_minute_limit",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureAuthConfigUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "allow_auth_config_export",
    "allow_auth_config_import",
    "only_allow_oauth_auth_methods",
    "consumer_auth_client_registrations_per_hour_limit",
    "consumer_auth_client_registrations_per_minute_limit",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureAuthConfigUpdateBody = /* @__PURE__ */ mapObject([
  "allow_auth_config_export",
  "allow_auth_config_import",
  "only_allow_oauth_auth_methods",
  "consumer_auth_client_registrations_per_hour_limit",
  "consumer_auth_client_registrations_per_minute_limit"
]);
var mapDashboardProjectsConfigureDataRetentionGetOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "data_retention_level",
    "store_tool_call_attachments",
    "collect_errors",
    "disable_callbacks",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureDataRetentionUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "data_retention_level",
    "store_tool_call_attachments",
    "collect_errors",
    "disable_callbacks",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureDataRetentionUpdateBody = /* @__PURE__ */ mapObject([
  "data_retention_level",
  "store_tool_call_attachments",
  "collect_errors",
  "disable_callbacks"
]);
var mapDashboardProjectsConfigureIntegrationNamingGetOutput = /* @__PURE__ */ mapObject(
  ["project_id", "use_integration_name_in_tool_names", "updated_at"],
  1
);
var mapDashboardProjectsConfigureIntegrationNamingUpdateOutput = /* @__PURE__ */ mapObject(
  ["project_id", "use_integration_name_in_tool_names", "updated_at"],
  1
);
var mapDashboardProjectsConfigureIntegrationNamingUpdateBody = /* @__PURE__ */ mapObject(
  ["use_integration_name_in_tool_names"]
);
var mapDashboardProjectsConfigureRetentionGetOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "log_retention_in_days",
    "enforce_session_expiry",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureRetentionUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "log_retention_in_days",
    "enforce_session_expiry",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureRetentionUpdateBody = /* @__PURE__ */ mapObject([
  "log_retention_in_days",
  "enforce_session_expiry"
]);
var mapDashboardProjectsConfigureSessionlessMcpGetOutput = /* @__PURE__ */ mapObject(
  ["project_id", "sessionless_mcp_enabled", "updated_at"],
  1
);
var mapDashboardProjectsConfigureSessionlessMcpUpdateOutput = /* @__PURE__ */ mapObject(
  ["project_id", "sessionless_mcp_enabled", "updated_at"],
  1
);
var mapDashboardProjectsConfigureSessionlessMcpUpdateBody = /* @__PURE__ */ mapObject(
  ["sessionless_mcp_enabled"]
);
var mapDashboardProjectsConfigureSkillSyncGetOutput = /* @__PURE__ */ mapObject(
  ["project_id", "git_lfs_threshold_bytes", "updated_at"],
  1
);
var mapDashboardProjectsConfigureSkillSyncUpdateOutput = /* @__PURE__ */ mapObject(
  ["project_id", "git_lfs_threshold_bytes", "updated_at"],
  1
);
var mapDashboardProjectsConfigureSkillSyncUpdateBody = /* @__PURE__ */ mapObject([
  "git_lfs_threshold_bytes"
]);
var mapDashboardProjectsConfigureToolCallingGetOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "collect_operation_description_for_tool_calls",
    "message_processing_timeout_ms",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureToolCallingUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "collect_operation_description_for_tool_calls",
    "message_processing_timeout_ms",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureToolCallingUpdateBody = /* @__PURE__ */ mapObject([
  "collect_operation_description_for_tool_calls",
  "message_processing_timeout_ms"
]);
var mapDashboardProjectsConfigureWorkforceGetOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "auto_add_organization_members_to_portals",
    "allow_consumer_skill_editing",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureWorkforceUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "project_id",
    "auto_add_organization_members_to_portals",
    "allow_consumer_skill_editing",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsConfigureWorkforceUpdateBody = /* @__PURE__ */ mapObject([
  "auto_add_organization_members_to_portals",
  "allow_consumer_skill_editing"
]);
var mapDashboardProjectsKeyProvidersCreateManagedOutput = /* @__PURE__ */ mapObject(
  [
    "is_metorial_managed",
    "key_reuse_time_seconds",
    "key_info",
    "is_default",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsKeyProvidersCreateManagedBody = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardProjectsKeyProvidersErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [1, [["day", 0, 4], "sample_message", "first_seen_at", "last_seen_at"]]
  ],
  1
);
var mapDashboardProjectsKeyProvidersErrorsListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardProjectsKeyProvidersGetSetupInfoOutput = /* @__PURE__ */ createMapper(
  0
);
var mapDashboardProjectsKeyProvidersGetSetupInfoQuery = /* @__PURE__ */ mapObject([
  "key_id"
]);
var mapDashboardProjectsKeyProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_metorial_managed",
    "key_reuse_time_seconds",
    "key_info",
    "is_default",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsKeyProvidersImportOutput = /* @__PURE__ */ mapObject(
  [
    "is_metorial_managed",
    "key_reuse_time_seconds",
    "key_info",
    "is_default",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsKeyProvidersImportBody = /* @__PURE__ */ mapObject([
  "key_input"
]);
var mapDashboardProjectsKeyProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_metorial_managed",
        "key_reuse_time_seconds",
        "key_info",
        "is_default",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDashboardProjectsKeyProvidersListQuery = /* @__PURE__ */ createMapper(0);
var mapDashboardProjectsKeyProvidersSetDefaultOutput = /* @__PURE__ */ mapObject(
  [
    "is_metorial_managed",
    "key_reuse_time_seconds",
    "key_info",
    "is_default",
    "created_at",
    "updated_at"
  ],
  1
);
var mapDashboardProjectsKeyProvidersValidateOutput = /* @__PURE__ */ mapObject([
  "key_provider_id"
]);
var mapDashboardUsageTimelineOutput = /* @__PURE__ */ mapObject([
  [
    "timeline",
    0,
    [
      2,
      [
        1,
        [
          "entity_id",
          "entity_type",
          "owner_id",
          ["entries", 0, [2, [1, [["ts", 0, 4]]]]]
        ]
      ]
    ]
  ]
]);
var mapDashboardUsageTimelineQuery = /* @__PURE__ */ mapObject([
  ["from", 0, 4],
  ["to", 0, 4]
]);
var mapDocumentsCloneOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDocumentsCloneBody = /* @__PURE__ */ mapObject(["target_document_id"]);
var mapDocumentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDocumentsCreateBody = /* @__PURE__ */ createMapper(0);
var mapDocumentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDocumentsEditTokenGetOutput = /* @__PURE__ */ mapObject(
  ["expires_at", "document_id"],
  1
);
var mapDocumentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDocumentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "file_id",
        "parent_document_id",
        "current_version_id",
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapDocumentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "file_id",
          "store_id",
          "parent_document_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDocumentsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "edit_count",
    "last_edited_at",
    "last_viewed_at",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDocumentsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "edit_count",
        "last_edited_at",
        "last_viewed_at",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDocumentsParticipantsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapDocumentsPermissionsGetOutput = /* @__PURE__ */ mapObject([
  "document_id",
  "is_owner",
  "has_full_access",
  "relevant_store_ids",
  "readable_store_ids",
  "writable_store_ids"
]);
var mapDocumentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapDocumentsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapDocumentsVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "document_id",
    "version_number",
    "previous_version_id",
    "list_edited_at",
    [
      "editors",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            [
              "organization_actor",
              1,
              [
                1,
                [
                  "organization_id",
                  "image_url",
                  [
                    "teams",
                    0,
                    [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "consumer",
              0,
              [1, ["image_url", "user_id", "created_at", "updated_at"]]
            ],
            [
              "consumer_profile",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "consumer_id",
                        "user_id",
                        "created_at",
                        "updated_at",
                        [
                          "groups",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                [
                                  "group",
                                  0,
                                  [
                                    1,
                                    ["is_default", "created_at", "updated_at"]
                                  ]
                                ],
                                "assigned_via"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapDocumentsVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "document_id",
        "version_number",
        "previous_version_id",
        "list_edited_at",
        [
          "editors",
          0,
          [
            2,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapDocumentsVersionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["last_edited_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapFilesDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "file_name",
            "file_size",
            "file_type",
            [
              "created_by",
              1,
              [
                1,
                [
                  "image_url",
                  [
                    "organization_actor",
                    1,
                    [
                      1,
                      [
                        "organization_id",
                        "image_url",
                        [
                          "teams",
                          0,
                          [
                            2,
                            [1, ["assignment_id", "created_at", "updated_at"]]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "consumer",
                    0,
                    [1, ["image_url", "user_id", "created_at", "updated_at"]]
                  ],
                  [
                    "consumer_profile",
                    1,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "consumer_id",
                              "user_id",
                              "created_at",
                              "updated_at",
                              [
                                "groups",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      [
                                        "group",
                                        0,
                                        [
                                          1,
                                          [
                                            "is_default",
                                            "created_at",
                                            "updated_at"
                                          ]
                                        ]
                                      ],
                                      "assigned_via"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "download_url"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapFilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "file_name",
            "file_size",
            "file_type",
            [
              "created_by",
              1,
              [
                1,
                [
                  "image_url",
                  [
                    "organization_actor",
                    1,
                    [
                      1,
                      [
                        "organization_id",
                        "image_url",
                        [
                          "teams",
                          0,
                          [
                            2,
                            [1, ["assignment_id", "created_at", "updated_at"]]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "consumer",
                    0,
                    [1, ["image_url", "user_id", "created_at", "updated_at"]]
                  ],
                  [
                    "consumer_profile",
                    1,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "consumer_id",
                              "user_id",
                              "created_at",
                              "updated_at",
                              [
                                "groups",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      [
                                        "group",
                                        0,
                                        [
                                          1,
                                          [
                                            "is_default",
                                            "created_at",
                                            "updated_at"
                                          ]
                                        ]
                                      ],
                                      "assigned_via"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "download_url"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapFilesLinksCreateOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapFilesLinksCreateBody = /* @__PURE__ */ mapObject(["file_id", "expires_at"], 1);
var mapFilesLinksDeleteOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapFilesLinksGetOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapFilesLinksListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["file_id", "created_at", "expires_at"]]],
  1
);
var mapFilesLinksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["file_id"]]]]
]);
var mapFilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [1, ["assignment_id", "created_at", "updated_at"]]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [1, ["image_url", "user_id", "created_at", "updated_at"]]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "download_url"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapFilesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "store_id",
          "document_id",
          "file_link_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapFirewallsCreateOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapFirewallsCreateBody = /* @__PURE__ */ mapObject(["network_policy_ids"]);
var mapFirewallsDeleteOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapFirewallsGetOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapFirewallsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["network_policies", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapFirewallsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "enclave_id",
          "provider_id",
          "network_policy_id",
          "machine_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapFirewallsNetworkPoliciesAttachOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapFirewallsNetworkPoliciesAttachBody = /* @__PURE__ */ mapObject([
  "network_policy_id"
]);
var mapFirewallsNetworkPoliciesDetachOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapFirewallsUpdateOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapFirewallsUpdateBody = /* @__PURE__ */ mapObject(["network_policy_ids"]);
var mapIdentitiesCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesCreateBody = /* @__PURE__ */ mapObject([
  "actor_id",
  [
    "credentials",
    0,
    [
      2,
      [
        1,
        [
          "deployment_id",
          "config_id",
          "auth_config_id",
          "delegation_config_id"
        ]
      ]
    ]
  ]
]);
var mapIdentitiesCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesCredentialsCreateBody = /* @__PURE__ */ mapObject([
  "identity_id",
  "deployment_id",
  "config_id",
  "auth_config_id",
  "delegation_config_id"
]);
var mapIdentitiesCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesCredentialsGetOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "identity_id",
        "provider_id",
        "deployment_id",
        "config_id",
        "auth_config_id",
        "delegation_config_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapIdentitiesCredentialsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "actor_id",
          "identity_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIdentitiesCredentialsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesCredentialsUpdateBody = /* @__PURE__ */ mapObject([
  "delegation_config_id"
]);
var mapIdentitiesDelegationConfigsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesDelegationConfigsCreateBody = /* @__PURE__ */ mapObject([
  "sub_delegation_behavior",
  "sub_delegation_depth"
]);
var mapIdentitiesDelegationConfigsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesDelegationConfigsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesDelegationConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        "sub_delegation_behavior",
        "sub_delegation_depth",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapIdentitiesDelegationConfigsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIdentitiesDelegationConfigsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesDelegationConfigsUpdateBody = /* @__PURE__ */ mapObject([
  "sub_delegation_behavior",
  "sub_delegation_depth"
]);
var mapIdentitiesDelegationRequestsApproveOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapIdentitiesDelegationRequestsApproveQuery = /* @__PURE__ */ mapObject([
  "allow_deleted"
]);
var mapIdentitiesDelegationRequestsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapIdentitiesDelegationRequestsCreateBody = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "requester_actor_id",
    "delegator_actor_id",
    "expires_at",
    "delegation_config_id",
    ["credential_overrides", 1, [2, [1, ["credential_id", "expires_at"]]]]
  ],
  1
);
var mapIdentitiesDelegationRequestsDenyOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapIdentitiesDelegationRequestsDenyQuery = /* @__PURE__ */ mapObject([
  "allow_deleted"
]);
var mapIdentitiesDelegationRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapIdentitiesDelegationRequestsGetQuery = /* @__PURE__ */ mapObject([
  "allow_deleted"
]);
var mapIdentitiesDelegationRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "denied_reason",
        [
          "requester",
          0,
          [
            1,
            [
              "agent_id",
              "consumer_id",
              "default_identity_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "identity_id",
        [
          "delegation",
          0,
          [
            1,
            [
              "denied_reason",
              "delegation_level",
              ["attestation", 0, [1, ["created_at"]]],
              "delegation_config_id",
              [
                "parties",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "actor",
                        0,
                        [
                          1,
                          [
                            "agent_id",
                            "consumer_id",
                            "default_identity_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ]
              ],
              [
                "request",
                0,
                [
                  1,
                  [
                    "denied_reason",
                    [
                      "requester",
                      0,
                      [
                        1,
                        [
                          "agent_id",
                          "consumer_id",
                          "default_identity_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "identity_id",
                    "expires_at",
                    "created_at"
                  ]
                ]
              ],
              [
                "credential_overrides",
                1,
                [2, [1, ["credential_id", "created_at", "expires_at"]]]
              ],
              "created_at",
              "expires_at",
              "revoked_at"
            ]
          ]
        ],
        "expires_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapIdentitiesDelegationRequestsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "actor_id",
          "identity_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIdentitiesDelegationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapIdentitiesDelegationsCreateBody = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "delegator_actor_id",
    "delegatee_actor_id",
    "expires_at",
    "delegation_config_id",
    ["credential_overrides", 1, [2, [1, ["credential_id", "expires_at"]]]]
  ],
  1
);
var mapIdentitiesDelegationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapIdentitiesDelegationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "denied_reason",
        "delegation_level",
        ["attestation", 0, [1, ["created_at"]]],
        "delegation_config_id",
        [
          "parties",
          0,
          [
            2,
            [
              1,
              [
                [
                  "actor",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ]
        ],
        [
          "request",
          0,
          [
            1,
            [
              "denied_reason",
              [
                "requester",
                0,
                [
                  1,
                  [
                    "agent_id",
                    "consumer_id",
                    "default_identity_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "identity_id",
              "expires_at",
              "created_at"
            ]
          ]
        ],
        [
          "credential_overrides",
          1,
          [2, [1, ["credential_id", "created_at", "expires_at"]]]
        ],
        "created_at",
        "expires_at",
        "revoked_at"
      ]
    ]
  ],
  1
);
var mapIdentitiesDelegationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "owner_actor_id",
          "delegator_actor_id",
          "delegatee_actor_id",
          "identity_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIdentitiesDelegationsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapIdentitiesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "owner",
          0,
          [
            1,
            [
              [
                "actor",
                0,
                [
                  1,
                  [
                    "agent_id",
                    "consumer_id",
                    "default_identity_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "credentials",
          0,
          [
            2,
            [
              1,
              [
                "identity_id",
                "provider_id",
                "deployment_id",
                "config_id",
                "auth_config_id",
                "delegation_config_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "delegation_config_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapIdentitiesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["agent_id", "actor_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapIdentitiesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIdentitiesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapIdentityActorsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIdentityActorsCreateBody = /* @__PURE__ */ createMapper(0);
var mapIdentityActorsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIdentityActorsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIdentityActorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "agent_id",
              "consumer_id",
              "default_identity_id",
              "created_at",
              "updated_at",
              [
                "consumer",
                0,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "user_id",
                          "created_at",
                          "updated_at",
                          "is_portal_consumer",
                          "is_organization_member",
                          "is_service_account"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIdentityActorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIdentityActorsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIdentityActorsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapIncomingWebhooksGetOutput = /* @__PURE__ */ mapObject(
  ["attempt_count", "webhook_registration_id", "provider_id", "received_at"],
  1
);
var mapIncomingWebhooksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "attempt_count",
        "webhook_registration_id",
        "provider_id",
        "received_at"
      ]
    ]
  ],
  1
);
var mapIncomingWebhooksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["webhook_registration_id", "provider_id"]]]]
]);
var mapIntegrationEnclavesGetOutput = /* @__PURE__ */ mapObject(
  [
    "internet_gateway_id",
    "provider_deployment_id",
    ["enclave_environment", 1, [1, ["created_at"]]],
    "created_at",
    "last_used_at"
  ],
  1
);
var mapIntegrationEnclavesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "internet_gateway_id",
        "provider_deployment_id",
        ["enclave_environment", 1, [1, ["created_at"]]],
        "created_at",
        "last_used_at"
      ]
    ]
  ],
  1
);
var mapIntegrationEnclavesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "internet_gateway_id",
          "provider_deployment_id",
          "provider_id",
          "firewall_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationFirewallAssignmentsCreateOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapIntegrationFirewallAssignmentsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["firewall_id", "target_type", "enclave_id", "provider_id"]]]]
]);
var mapIntegrationFirewallAssignmentsDeleteOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapIntegrationFirewallAssignmentsGetOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapIntegrationFirewallAssignmentsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["target_type", "created_at"]]],
  1
);
var mapIntegrationFirewallAssignmentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "firewall_id",
          "enclave_id",
          "provider_id",
          "internet_gateway_id",
          "target_type",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationInternetGatewayGetOutput = /* @__PURE__ */ mapObject(
  ["created_at", "updated_at", ["public_ips", 1, [2, 8]]],
  1
);
var mapIntegrationInternetGatewayListNetworkLogsOutput = /* @__PURE__ */ mapObject([
  "enclave_ids",
  [
    "records",
    0,
    [
      2,
      [
        1,
        [
          "enclave_id",
          "bucket_start",
          ["first_seen_at", 1, 0],
          ["last_seen_at", 1, 0]
        ]
      ]
    ]
  ]
]);
var mapIntegrationInternetGatewayListNetworkLogsQuery = /* @__PURE__ */ mapObject([
  "enclave_id",
  "interval_minutes"
]);
var mapIntegrationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsCreateBody = /* @__PURE__ */ mapObject([
  "use_integration_name_in_tool_names",
  "can_attach_custom_tool_filters",
  "can_attach_custom_provider_config",
  "can_override_tool_filters",
  "enable_callback_tools"
]);
var mapIntegrationsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsInstanceGroupsCreateSessionTemplateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapIntegrationsInstanceGroupsCreateSessionTemplateBody = /* @__PURE__ */ createMapper(
  0
);
var mapIntegrationsInstanceGroupsCreateSessionOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIntegrationsInstanceGroupsCreateSessionBody = /* @__PURE__ */ createMapper(0);
var mapIntegrationsInstanceGroupsCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsInstanceGroupsCreateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [2, [1, ["integration_instance_provider_id", "tool_filters"]]]
  ]
]);
var mapIntegrationsInstanceGroupsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsInstanceGroupsGetOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsInstanceGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                "integration_instance_group_id",
                "integration_instance_id",
                "integration_provider_id",
                "integration_instance_provider_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "is_override_tool_filter",
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapIntegrationsInstanceGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          "integration_instance_provider_id",
          "provider_id",
          "integration_provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "session_template_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationsInstanceGroupsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsInstanceGroupsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsInstanceGroupsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_instance_group_id",
        "integration_instance_id",
        "integration_provider_id",
        "integration_instance_provider_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "is_override_tool_filter",
        "created_at",
        "updated_at",
        "archived_at",
        ["provider", 0, 8],
        [
          "integration_provider",
          1,
          [
            1,
            [
              "provider_version",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "deployment_id",
              "auth_method_id",
              "auth_credentials_id",
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        [
          "integration_instance_provider",
          1,
          [
            1,
            [
              "integration_id",
              "integration_instance_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "is_override_tool_filter",
              ["provider", 0, 8],
              [
                "integration_provider",
                1,
                [
                  1,
                  [
                    "provider_version",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    "provider_id",
                    "deployment_id",
                    "auth_method_id",
                    "auth_credentials_id",
                    [
                      "config",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at",
                    "archived_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_config",
                1,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "callback_instance_id",
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsInstanceGroupsProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_instance_group_id",
          "integration_id",
          "integration_instance_id",
          "integration_instance_provider_id",
          "provider_id",
          "integration_provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "session_template_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationsInstanceGroupsProvidersSetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsInstanceGroupsProvidersSetBody = /* @__PURE__ */ mapObject([
  "tool_filters"
]);
var mapIntegrationsInstanceGroupsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsInstanceGroupsUpdateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [2, [1, ["integration_instance_provider_id", "tool_filters"]]]
  ]
]);
var mapIntegrationsInstancesCreateSessionTemplateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapIntegrationsInstancesCreateSessionTemplateBody = /* @__PURE__ */ createMapper(
  0
);
var mapIntegrationsInstancesCreateSessionOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapIntegrationsInstancesCreateSessionBody = /* @__PURE__ */ createMapper(0);
var mapIntegrationsInstancesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapIntegrationsInstancesCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "identity_actor_id",
  "identity_id",
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters",
          "is_override_tool_filter"
        ]
      ]
    ]
  ]
]);
var mapIntegrationsInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapIntegrationsInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapIntegrationsInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "identity_actor_id",
        "identity_id",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        ["implementation", 0, [1, ["magic_mcp_server_id"]]],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                "integration_instance_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "is_override_tool_filter",
                ["provider", 0, 8],
                [
                  "integration_provider",
                  1,
                  [
                    1,
                    [
                      "provider_version",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      "provider_id",
                      "deployment_id",
                      "auth_method_id",
                      "auth_credentials_id",
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "auth_config",
                  1,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "callback_instance_id",
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at",
        "is_oauth_compatible"
      ]
    ]
  ],
  1
);
var mapIntegrationsInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "provider_id",
          "integration_provider_id",
          "identity_id",
          "identity_credential_id",
          "identity_actor_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "session_template_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationsInstancesProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "callback_instance_id",
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsInstancesProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_instance_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "is_override_tool_filter",
        ["provider", 0, 8],
        [
          "integration_provider",
          1,
          [
            1,
            [
              "provider_version",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "deployment_id",
              "auth_method_id",
              "auth_credentials_id",
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "auth_config",
          1,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "callback_instance_id",
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapIntegrationsInstancesProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          "provider_id",
          "integration_provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "session_template_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationsInstancesProvidersSetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "callback_instance_id",
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsInstancesProvidersSetBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "provider_config_id",
  "provider_auth_config_id",
  "tool_filters",
  "is_override_tool_filter"
]);
var mapIntegrationsInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapIntegrationsInstancesUpdateBody = /* @__PURE__ */ mapObject([
  "identity_actor_id",
  "identity_id",
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters",
          "is_override_tool_filter"
        ]
      ]
    ]
  ]
]);
var mapIntegrationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "configuration",
          0,
          [
            1,
            [
              "can_attach_custom_tool_filters",
              "can_attach_custom_provider_config",
              "can_override_tool_filters",
              "enable_callback_tools",
              "use_integration_name_in_tool_names"
            ]
          ]
        ],
        [
          "implementation",
          0,
          [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
        ],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "callbacks",
                  0,
                  [
                    1,
                    [
                      "callback_id",
                      [
                        "callback",
                        0,
                        [
                          1,
                          [
                            "integration_id",
                            "integration_provider_id",
                            ["provider", 0, 8],
                            "created_at",
                            "updated_at",
                            "auth_credentials_is_managed",
                            ["sync", 0, [1, ["synced_at"]]]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at",
                ["provider", 0, 8],
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "auth_method",
                  1,
                  [
                    1,
                    [
                      "input_schema",
                      "output_schema",
                      "provider_id",
                      "provider_specification_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "auth_credentials",
                  1,
                  [
                    1,
                    [
                      "is_default",
                      "is_managed",
                      "provider_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapIntegrationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "integration_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationsProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsProvidersCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "provider_id",
  "provider_deployment_id",
  "provider_auth_method_id",
  "provider_auth_credentials_id",
  "provider_config_id",
  "tool_filters"
]);
var mapIntegrationsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "deployment_id",
        "auth_method_id",
        "auth_credentials_id",
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "callbacks",
          0,
          [
            1,
            [
              "callback_id",
              [
                "callback",
                0,
                [
                  1,
                  [
                    "integration_id",
                    "integration_provider_id",
                    ["provider", 0, 8],
                    "created_at",
                    "updated_at",
                    "auth_credentials_is_managed",
                    ["sync", 0, [1, ["synced_at"]]]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at",
        ["provider", 0, 8],
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "auth_method",
          1,
          [
            1,
            [
              "input_schema",
              "output_schema",
              "provider_id",
              "provider_specification_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "auth_credentials",
          1,
          [
            1,
            [
              "is_default",
              "is_managed",
              "provider_id",
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "provider_id",
          "provider_deployment_id",
          "provider_auth_method_id",
          "provider_auth_credentials_id",
          "provider_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationsProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsProvidersUpdateBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "provider_auth_method_id",
  "provider_auth_credentials_id",
  "provider_config_id",
  "tool_filters"
]);
var mapIntegrationsSetupSessionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "redirect_url",
    "integration_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    [
      "integration_instance",
      1,
      [
        1,
        [
          "integration_id",
          "identity_actor_id",
          "identity_id",
          ["owner_actor", 1, [1, ["consumer_id"]]],
          ["implementation", 0, [1, ["magic_mcp_server_id"]]],
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "integration_id",
                  "integration_instance_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "is_override_tool_filter",
                  ["provider", 0, 8],
                  [
                    "integration_provider",
                    1,
                    [
                      1,
                      [
                        "provider_version",
                        [
                          "tool_filter",
                          1,
                          [3, [[0, [1, ["ignore_parent_filters"]]]]]
                        ],
                        "provider_id",
                        "deployment_id",
                        "auth_method_id",
                        "auth_credentials_id",
                        [
                          "config",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "archived_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "callback_instance_id",
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "expires_at",
    "integration_instance_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            "integration_provider_id",
            ["provider", 0, 8],
            "provider_setup_session_id",
            "integration_instance_provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsSetupSessionsCreateBody = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    "identity_actor_id",
    "identity_id",
    "expires_at",
    "redirect_url",
    [
      "configuration",
      0,
      [
        1,
        [
          [
            "provider_search",
            1,
            [
              1,
              [
                ["groups", 0, [2, [1, ["group_id"]]]],
                ["collections", 0, [2, [1, ["collection_id"]]]],
                ["categories", 0, [2, [1, ["category_id"]]]]
              ]
            ]
          ],
          "tool_filters"
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsSetupSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "redirect_url",
    "integration_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    [
      "integration_instance",
      1,
      [
        1,
        [
          "integration_id",
          "identity_actor_id",
          "identity_id",
          ["owner_actor", 1, [1, ["consumer_id"]]],
          ["implementation", 0, [1, ["magic_mcp_server_id"]]],
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "integration_id",
                  "integration_instance_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "is_override_tool_filter",
                  ["provider", 0, 8],
                  [
                    "integration_provider",
                    1,
                    [
                      1,
                      [
                        "provider_version",
                        [
                          "tool_filter",
                          1,
                          [3, [[0, [1, ["ignore_parent_filters"]]]]]
                        ],
                        "provider_id",
                        "deployment_id",
                        "auth_method_id",
                        "auth_credentials_id",
                        [
                          "config",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "archived_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "callback_instance_id",
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "expires_at",
    "integration_instance_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            "integration_provider_id",
            ["provider", 0, 8],
            "provider_setup_session_id",
            "integration_instance_provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsSetupSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "redirect_url",
        "integration_id",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        [
          "integration_instance",
          1,
          [
            1,
            [
              "integration_id",
              "identity_actor_id",
              "identity_id",
              ["owner_actor", 1, [1, ["consumer_id"]]],
              ["implementation", 0, [1, ["magic_mcp_server_id"]]],
              [
                "providers",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "integration_id",
                      "integration_instance_id",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      "is_override_tool_filter",
                      ["provider", 0, 8],
                      [
                        "integration_provider",
                        1,
                        [
                          1,
                          [
                            "provider_version",
                            [
                              "tool_filter",
                              1,
                              [3, [[0, [1, ["ignore_parent_filters"]]]]]
                            ],
                            "provider_id",
                            "deployment_id",
                            "auth_method_id",
                            "auth_credentials_id",
                            [
                              "config",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at",
                            "archived_at"
                          ]
                        ]
                      ],
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_config",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "callback_instance_id",
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "expires_at",
        "integration_instance_id",
        [
          "steps",
          0,
          [
            2,
            [
              1,
              [
                "integration_provider_id",
                ["provider", 0, 8],
                "provider_setup_session_id",
                "integration_instance_provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapIntegrationsSetupSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapIntegrationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapIntegrationsUpdateBody = /* @__PURE__ */ mapObject([
  "use_integration_name_in_tool_names",
  "can_attach_custom_tool_filters",
  "can_attach_custom_provider_config",
  "can_override_tool_filters",
  "enable_callback_tools"
]);
var mapMagicMcpEndpointsAddServersOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpEndpointsAddServersBody = /* @__PURE__ */ mapObject([
  ["magic_mcp_servers", 1, [2, [1, ["magic_mcp_server_id", "tool_filters"]]]]
]);
var mapMagicMcpEndpointsCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpEndpointsCreateBody = /* @__PURE__ */ mapObject([
  "consumer_profile_id",
  "skill_plugin_id",
  "enable_skill_editing",
  ["magic_mcp_servers", 1, [2, [1, ["magic_mcp_server_id", "tool_filters"]]]]
]);
var mapMagicMcpEndpointsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpEndpointsGetOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpEndpointsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
        "enable_skill_editing",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapMagicMcpEndpointsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["magic_mcp_server_id"]]]]
]);
var mapMagicMcpEndpointsRemoveServersOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpEndpointsRemoveServersBody = /* @__PURE__ */ mapObject([
  "magic_mcp_server_ids"
]);
var mapMagicMcpEndpointsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpEndpointsUpdateBody = /* @__PURE__ */ mapObject([
  "enable_skill_editing"
]);
var mapMagicMcpGroupsAddServersOutput = /* @__PURE__ */ createMapper(8);
var mapMagicMcpGroupsAddServersBody = /* @__PURE__ */ mapObject([
  "magic_mcp_server_ids"
]);
var mapMagicMcpGroupsCreateOutput = /* @__PURE__ */ createMapper(8);
var mapMagicMcpGroupsCreateBody = /* @__PURE__ */ createMapper(0);
var mapMagicMcpGroupsDeleteOutput = /* @__PURE__ */ createMapper(8);
var mapMagicMcpGroupsGetOutput = /* @__PURE__ */ createMapper(8);
var mapMagicMcpGroupsListOutput = /* @__PURE__ */ createMapper([7, 8]);
var mapMagicMcpGroupsListQuery = /* @__PURE__ */ createMapper(0);
var mapMagicMcpGroupsRemoveServersOutput = /* @__PURE__ */ createMapper(8);
var mapMagicMcpGroupsRemoveServersBody = /* @__PURE__ */ mapObject([
  "magic_mcp_server_ids"
]);
var mapMagicMcpGroupsUpdateOutput = /* @__PURE__ */ createMapper(8);
var mapMagicMcpGroupsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapMagicMcpServersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersCreateBody = /* @__PURE__ */ mapObject([
  "provider_template_id",
  "integration_instance_id",
  "consumer_profile_id"
]);
var mapMagicMcpServersDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_management_mode",
              "provider_template_id",
              [
                "providers",
                0,
                [
                  2,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "magic_mcp_server_id",
                            "provider_management_mode",
                            [
                              "tool_filter",
                              1,
                              [3, [[0, [1, ["ignore_parent_filters"]]]]]
                            ],
                            ["provider", 0, 8],
                            [
                              "deployment",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_method",
                              1,
                              [
                                1,
                                [
                                  "input_schema",
                                  "output_schema",
                                  "provider_id",
                                  "provider_specification_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_credentials",
                              1,
                              [
                                1,
                                [
                                  "is_default",
                                  "is_managed",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "config",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_config",
                              1,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at",
                            "archived_at",
                            "can_update",
                            "can_delete"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "integration_id",
              "integration_instance_id",
              "backing_status",
              [
                "consumer_owners",
                1,
                [
                  2,
                  [
                    1,
                    [
                      "consumer_integration_id",
                      "consumer_id",
                      "consumer_profile_id",
                      "consumer_name",
                      "consumer_email",
                      "consumer_profile_name",
                      "consumer_profile_email"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "magic_mcp_group_id",
          "provider_template_id",
          "integration_instance_id",
          "provider_id",
          "consumer_id",
          "consumer_profile_id",
          "preconfigured_only"
        ]
      ]
    ]
  ]
]);
var mapMagicMcpServersProvidersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersProvidersCreateBody = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_deployment_id",
  "provider_config_id",
  "provider_auth_config_id",
  "tool_filters"
]);
var mapMagicMcpServersProvidersDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "magic_mcp_server_id",
              "provider_management_mode",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              ["provider", 0, 8],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_credentials",
                1,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_config",
                1,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at",
              "can_update",
              "can_delete"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "integration_provider_id",
          "integration_instance_provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapMagicMcpServersProvidersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersProvidersUpdateBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "provider_config_id",
  "provider_auth_config_id",
  "tool_filters"
]);
var mapMagicMcpServersSessionCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpServersToolsOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapMagicMcpServersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapMagicMcpSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "magic_mcp_server",
      1,
      [
        1,
        [
          "provider_management_mode",
          "provider_template_id",
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "magic_mcp_server_id",
                  "provider_management_mode",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  ["provider", 0, 8],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_credentials",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "magic_mcp_endpoint",
      1,
      [
        1,
        [
          ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
          "enable_skill_editing",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "consumer_profile_id",
    "consumer_integration_ids",
    "session_id",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapMagicMcpSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "magic_mcp_server",
          1,
          [
            1,
            [
              "provider_management_mode",
              "provider_template_id",
              [
                "providers",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "magic_mcp_server_id",
                      "provider_management_mode",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      ["provider", 0, 8],
                      [
                        "deployment",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_method",
                        1,
                        [
                          1,
                          [
                            "input_schema",
                            "output_schema",
                            "provider_id",
                            "provider_specification_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_credentials",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "is_managed",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_config",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "magic_mcp_endpoint",
          1,
          [
            1,
            [
              ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
              "enable_skill_editing",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "consumer_profile_id",
        "consumer_integration_ids",
        "session_id",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapMagicMcpSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["magic_mcp_server_id"]]]]
]);
var mapMagicMcpTokensAddGroupsOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapMagicMcpTokensAddGroupsBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids"
]);
var mapMagicMcpTokensCreateOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapMagicMcpTokensCreateBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids",
  "magic_mcp_server_id",
  "magic_mcp_endpoint_id"
]);
var mapMagicMcpTokensDeleteOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapMagicMcpTokensGetOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapMagicMcpTokensListOutput = /* @__PURE__ */ createMapper(
  [7, [1, [["groups", 0, [2, 8]], "created_at", "updated_at"]]],
  1
);
var mapMagicMcpTokensListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["magic_mcp_group_id", "magic_mcp_server_id", "magic_mcp_endpoint_id"]
      ]
    ]
  ]
]);
var mapMagicMcpTokensRemoveGroupsOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapMagicMcpTokensRemoveGroupsBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids"
]);
var mapMagicMcpTokensUpdateOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapMagicMcpTokensUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceAgentsGetOutput = /* @__PURE__ */ mapObject(
  ["actor_id", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceAgentsInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "agent_id",
    [
      "agent_client",
      1,
      [1, ["created_at", "updated_at", "last_connected_at"]]
    ],
    "created_at",
    "updated_at",
    "last_connected_at"
  ],
  1
);
var mapManagementInstanceAgentsInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "agent_id",
        [
          "agent_client",
          1,
          [1, ["created_at", "updated_at", "last_connected_at"]]
        ],
        "created_at",
        "updated_at",
        "last_connected_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceAgentsInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["agent_client_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapManagementInstanceAgentsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["actor_id", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapManagementInstanceAgentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceAssistantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "owner_type",
    "organization_id",
    [
      "default_model",
      1,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "available_models",
      1,
      [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceAssistantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "owner_type",
        "organization_id",
        [
          "default_model",
          1,
          [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
        ],
        [
          "available_models",
          1,
          [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceAssistantsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceCallbackEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_trigger_key",
    "mapped_type",
    "mapped_id",
    "callback_id",
    "callback_instance_id",
    ["details", 0, [1, [["webhook", 0, [1, ["received_at"]]]]]],
    "occurred_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceCallbackEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_trigger_key",
        "mapped_type",
        "mapped_id",
        "callback_id",
        "callback_instance_id",
        "occurred_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceCallbackEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "callback_id",
          "callback_instance_id",
          "integration_id",
          "integration_provider_id",
          "provider_id",
          "provider_trigger_key",
          ["occurred_at", 1, 5],
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceCallbackInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "callback_id",
    "integration_instance_id",
    "integration_instance_provider_id",
    "created_at",
    "updated_at",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapManagementInstanceCallbackInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "callback_id",
        "integration_instance_id",
        "integration_instance_provider_id",
        "created_at",
        "updated_at",
        ["sync", 0, [1, ["synced_at"]]]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCallbackInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "callback_id",
          "integration_id",
          "integration_instance_id",
          "integration_instance_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceCallbacksCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapManagementInstanceCallbacksCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "integration_provider_id"
]);
var mapManagementInstanceCallbacksDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapManagementInstanceCallbacksGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapManagementInstanceCallbacksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_provider_id",
        ["provider", 0, 8],
        "created_at",
        "updated_at",
        "auth_credentials_is_managed",
        ["sync", 0, [1, ["synced_at"]]]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCallbacksListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "integration_id",
          "integration_provider_id",
          "provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceCallbacksUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_provider_id",
    ["provider", 0, 8],
    "created_at",
    "updated_at",
    "auth_credentials_is_managed",
    ["sync", 0, [1, ["synced_at"]]]
  ],
  1
);
var mapManagementInstanceCallbacksUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceChatConnectionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatConnectionsCreateBody = /* @__PURE__ */ mapObject([
  "private_metadata",
  [
    "provider",
    0,
    [
      1,
      [
        "provider_id",
        "provider_deployment_id",
        "provider_auth_method_id",
        "provider_auth_credentials_id",
        "provider_config_id"
      ]
    ]
  ]
]);
var mapManagementInstanceChatConnectionsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                ["provider", 0, 8],
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_method_id",
                "auth_credentials_id",
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                "manual_webhook_trigger_groups"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatConnectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceChatConnectionsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_method_id",
            "auth_credentials_id",
            "created_at",
            "updated_at",
            "auth_credentials_is_managed",
            "manual_webhook_trigger_groups"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatConnectionsUpdateBody = /* @__PURE__ */ mapObject([
  "private_metadata"
]);
var mapManagementInstanceChatEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    "chat_id",
    "channel_id",
    "thread_id",
    "message_id",
    "author_id",
    "provider_event_id",
    "provider_channel_id",
    "provider_thread_id",
    "provider_message_id",
    "provider_author_id",
    "occurred_at",
    "created_at",
    ["error", 0, [1, ["provider_code", "retry_after_ms"]]]
  ],
  1
);
var mapManagementInstanceChatEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        "chat_id",
        "channel_id",
        "thread_id",
        "message_id",
        "author_id",
        "provider_event_id",
        "provider_channel_id",
        "provider_thread_id",
        "provider_message_id",
        "provider_author_id",
        "occurred_at",
        "created_at",
        ["error", 0, [1, ["provider_code", "retry_after_ms"]]]
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "chat_id",
          "chat_connection_id",
          "chat_instance_id",
          ["created_at", 1, 5],
          ["occurred_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceChatInstancesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatInstancesCreateBody = /* @__PURE__ */ mapObject([
  "chat_connection_id",
  "private_metadata",
  "identity_actor_id",
  "identity_id"
]);
var mapManagementInstanceChatInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [1, ["chat_connection_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]
    ]
  ]
]);
var mapManagementInstanceChatInstancesProviderAuthenticatedUserOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_type",
    "provider_author_id",
    "user_name",
    "full_name",
    "image_url",
    "is_self",
    ["workspace", 0, [1, ["provider_workspace_id", "image_url"]]]
  ]
);
var mapManagementInstanceChatInstancesProviderGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_instance_id",
    "chat_connection_provider_id",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatInstancesProviderSetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_instance_id",
    "chat_connection_provider_id",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatInstancesProviderSetBody = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_deployment_id",
  "provider_config_id",
  "provider_auth_config_id"
]);
var mapManagementInstanceChatInstancesSyncOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    ["identity", 0, [1, ["user_id", "provider_type", "image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatInstancesUpdateBody = /* @__PURE__ */ mapObject([
  "private_metadata"
]);
var mapManagementInstanceChatWorkspacesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_workspace_id",
    "image_url",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatWorkspacesGetQuery = /* @__PURE__ */ mapObject([
  "chat_instance_id"
]);
var mapManagementInstanceChatWorkspacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "provider_workspace_id",
        "image_url",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatWorkspacesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["chat_instance_id"]]]]
]);
var mapManagementInstanceChatsChannelsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "workspace_id",
    "provider_type",
    "provider_channel_id",
    "has_access",
    [
      "recipient",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    "member_count",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapManagementInstanceChatsChannelsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "workspace_id",
        "provider_type",
        "provider_channel_id",
        "has_access",
        [
          "recipient",
          0,
          [
            1,
            [
              "chat_id",
              "provider_type",
              "provider_author_id",
              "user_name",
              "full_name",
              "image_url",
              "is_self",
              "created_at",
              "updated_at",
              "last_interaction_at"
            ]
          ]
        ],
        "member_count",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatsChannelsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["workspace_id", "has_access"]]]]
]);
var mapManagementInstanceChatsChannelsMembersGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "provider_type",
    "provider_author_id",
    "user_name",
    "full_name",
    "image_url",
    "is_self",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapManagementInstanceChatsChannelsMembersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "provider_type",
        "provider_author_id",
        "user_name",
        "full_name",
        "image_url",
        "is_self",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatsChannelsMembersListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceChatsChannelsTypingStartOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceChatsChannelsTypingStartBody = /* @__PURE__ */ mapObject([
  "thread_id"
]);
var mapManagementInstanceChatsCommandsRespondOutput = /* @__PURE__ */ mapObject(
  [
    [
      "message",
      0,
      [
        1,
        [
          "chat_id",
          "channel_id",
          "thread_id",
          "provider_type",
          "provider_message_id",
          "provider_reply_to_message_id",
          [
            "author",
            0,
            [
              1,
              [
                "chat_id",
                "provider_type",
                "provider_author_id",
                "user_name",
                "full_name",
                "image_url",
                "is_self",
                "created_at",
                "updated_at",
                "last_interaction_at"
              ]
            ]
          ],
          [
            "attachments",
            0,
            [
              2,
              [
                1,
                [
                  "provider_attachment_id",
                  "mime_type",
                  "file_id",
                  "download_url",
                  "created_at"
                ]
              ]
            ]
          ],
          "sent_at",
          "edited_at",
          "created_at",
          "updated_at",
          "last_interaction_at",
          "deleted_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatsCommandsRespondBody = /* @__PURE__ */ mapObject([
  "chat_event_id",
  "alt_text"
]);
var mapManagementInstanceChatsDmsOpenOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "workspace_id",
    "provider_type",
    "provider_channel_id",
    "has_access",
    [
      "recipient",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    "member_count",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapManagementInstanceChatsDmsOpenBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["user", 0, [3, [[0, [1, ["phone_number", "user_id"]]]]]],
          ["users", 0, [3, [[0, [1, ["phone_numbers", "user_ids"]]]]]]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceChatsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_connection_id",
    "chat_instance_id",
    "chat_instance_provider_id",
    "provider_id",
    "workspace_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceChatsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_connection_id",
        "chat_instance_id",
        "chat_instance_provider_id",
        "provider_id",
        "workspace_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "chat_connection_id",
          "chat_instance_id",
          "chat_instance_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceChatsMessagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceChatsMessagesCreateBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "thread_id",
  "alt_text",
  ["attachments", 0, [2, [1, ["file_id"]]]],
  "reply_message_id",
  "ephemeral_target_user_id"
]);
var mapManagementInstanceChatsMessagesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceChatsMessagesDeleteQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapManagementInstanceChatsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceChatsMessagesGetQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapManagementInstanceChatsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "channel_id",
        "thread_id",
        "provider_type",
        "provider_message_id",
        "provider_reply_to_message_id",
        [
          "author",
          0,
          [
            1,
            [
              "chat_id",
              "provider_type",
              "provider_author_id",
              "user_name",
              "full_name",
              "image_url",
              "is_self",
              "created_at",
              "updated_at",
              "last_interaction_at"
            ]
          ]
        ],
        [
          "attachments",
          0,
          [
            2,
            [
              1,
              [
                "provider_attachment_id",
                "mime_type",
                "file_id",
                "download_url",
                "created_at"
              ]
            ]
          ]
        ],
        "sent_at",
        "edited_at",
        "created_at",
        "updated_at",
        "last_interaction_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatsMessagesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["channel_id", "thread_id"]]]]
]);
var mapManagementInstanceChatsMessagesReactionsCreateOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceChatsMessagesReactionsCreateBody = /* @__PURE__ */ mapObject(
  ["channel_id"]
);
var mapManagementInstanceChatsMessagesReactionsDeleteOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceChatsMessagesReactionsDeleteQuery = /* @__PURE__ */ mapObject(
  ["channel_id"]
);
var mapManagementInstanceChatsMessagesReactionsListOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceChatsMessagesReactionsListQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapManagementInstanceChatsMessagesReadOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceChatsMessagesReadBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "thread_id"
]);
var mapManagementInstanceChatsMessagesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "thread_id",
    "provider_type",
    "provider_message_id",
    "provider_reply_to_message_id",
    [
      "author",
      0,
      [
        1,
        [
          "chat_id",
          "provider_type",
          "provider_author_id",
          "user_name",
          "full_name",
          "image_url",
          "is_self",
          "created_at",
          "updated_at",
          "last_interaction_at"
        ]
      ]
    ],
    [
      "attachments",
      0,
      [
        2,
        [
          1,
          [
            "provider_attachment_id",
            "mime_type",
            "file_id",
            "download_url",
            "created_at"
          ]
        ]
      ]
    ],
    "sent_at",
    "edited_at",
    "created_at",
    "updated_at",
    "last_interaction_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceChatsMessagesUpdateBody = /* @__PURE__ */ mapObject([
  "channel_id",
  "alt_text"
]);
var mapManagementInstanceChatsThreadsGetOutput = /* @__PURE__ */ mapObject(
  [
    "chat_id",
    "channel_id",
    "provider_type",
    "provider_thread_id",
    "provider_root_message_id",
    "reply_count",
    "last_reply_at",
    "created_at",
    "updated_at",
    "last_interaction_at"
  ],
  1
);
var mapManagementInstanceChatsThreadsGetQuery = /* @__PURE__ */ mapObject([
  "channel_id"
]);
var mapManagementInstanceChatsThreadsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "chat_id",
        "channel_id",
        "provider_type",
        "provider_thread_id",
        "provider_root_message_id",
        "reply_count",
        "last_reply_at",
        "created_at",
        "updated_at",
        "last_interaction_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceChatsThreadsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["channel_id"]]]]
]);
var mapManagementInstanceConsumerSurfacesGetOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_authoring",
    "allow_consumer_skill_publishing",
    [
      "skill_configuration",
      1,
      [
        1,
        [
          "is_default",
          "allow_scripts",
          "allowed_file_extensions",
          "allow_non_standard_directories"
        ]
      ]
    ],
    ["auth", 0, [1, ["session_expiry_time_in_seconds", "email_whitelist"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceConsumerSurfacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "allow_consumer_skill_authoring",
        "allow_consumer_skill_publishing",
        [
          "skill_configuration",
          1,
          [
            1,
            [
              "is_default",
              "allow_scripts",
              "allowed_file_extensions",
              "allow_non_standard_directories"
            ]
          ]
        ],
        [
          "auth",
          0,
          [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumerSurfacesListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceConsumersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumersCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceConsumersGetMemberConsumerOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            [
              "profile",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "consumer_id",
                        "user_id",
                        "created_at",
                        "updated_at",
                        [
                          "groups",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                [
                                  "group",
                                  0,
                                  [
                                    1,
                                    ["is_default", "created_at", "updated_at"]
                                  ]
                                ],
                                "assigned_via"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumersGetMemberConsumerBody = /* @__PURE__ */ mapObject([
  "surface_identifier"
]);
var mapManagementInstanceConsumersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "user_id",
              "created_at",
              "updated_at",
              "is_portal_consumer",
              "is_organization_member",
              "is_service_account"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumersListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceConsumersProfilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumersProfilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "consumer_id",
              "user_id",
              "created_at",
              "updated_at",
              [
                "groups",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "group",
                        0,
                        [1, ["is_default", "created_at", "updated_at"]]
                      ],
                      "assigned_via"
                    ]
                  ]
                ]
              ],
              "is_service_account",
              [
                "surface",
                0,
                [
                  1,
                  [
                    "allow_consumer_skill_authoring",
                    "allow_consumer_skill_publishing",
                    [
                      "skill_configuration",
                      1,
                      [
                        1,
                        [
                          "is_default",
                          "allow_scripts",
                          "allowed_file_extensions",
                          "allow_non_standard_directories"
                        ]
                      ]
                    ],
                    [
                      "auth",
                      0,
                      [
                        1,
                        ["session_expiry_time_in_seconds", "email_whitelist"]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumersProfilesListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceConsumersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "user_id",
            "created_at",
            "updated_at",
            "is_portal_consumer",
            "is_organization_member",
            "is_service_account"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceConsumersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceConversationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceConversationsCreateBody = /* @__PURE__ */ mapObject([
  "assistant_id"
]);
var mapManagementInstanceConversationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceConversationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "assistant_id",
        "instance_id",
        "organization_id",
        [
          "created_by_actor",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "root_message_id",
        [
          "assistant",
          0,
          [
            1,
            [
              "owner_type",
              "organization_id",
              [
                "default_model",
                1,
                [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
              ],
              [
                "available_models",
                1,
                [
                  2,
                  [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceConversationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["assistant_id"]]]]
]);
var mapManagementInstanceConversationsMessagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceConversationsMessagesCreateBody = /* @__PURE__ */ mapObject([
  ["message", 0, [1, [["parts", 0, [2, [3, [[0, [1, ["media_type"]]]]]]]]]],
  "parent_message_id",
  "model_id"
]);
var mapManagementInstanceConversationsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceConversationsMessagesHandoffResponsesOutput = /* @__PURE__ */ mapObject(
  [
    "conversation_item_id",
    "assistant_id",
    "parent_message_id",
    [
      "model",
      0,
      [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
    ],
    [
      "request",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceConversationsMessagesHandoffResponsesBody = /* @__PURE__ */ mapObject(
  [["responses", 0, [2, [1, ["tool_call_id"]]]]]
);
var mapManagementInstanceConversationsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "conversation_item_id",
        "assistant_id",
        "parent_message_id",
        [
          "model",
          0,
          [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
        ],
        [
          "request",
          0,
          [
            1,
            [
              [
                "actor",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceConversationsMessagesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceConversationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "assistant_id",
    "instance_id",
    "organization_id",
    [
      "created_by_actor",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "root_message_id",
    [
      "assistant",
      0,
      [
        1,
        [
          "owner_type",
          "organization_id",
          [
            "default_model",
            1,
            [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]
          ],
          [
            "available_models",
            1,
            [2, [1, ["context_window", ["provider", 0, [1, ["image_url"]]]]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceConversationsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceCustomProvidersArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersCodeGetCodeEditorTokenOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapManagementInstanceCustomProvidersCommitsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "custom_provider_deployment_id",
    [
      "to_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "from_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "target_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "previous_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "scm_push",
      1,
      [
        1,
        [
          ["actor", 0, [1, ["external_id"]]],
          ["commit", 0, [1, ["created_at"]]],
          [
            "repository",
            0,
            [1, ["is_private", "default_branch", "created_at"]]
          ],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "applied_at"
  ],
  1
);
var mapManagementInstanceCustomProvidersCommitsCreateBody = /* @__PURE__ */ mapObject(
  [
    [
      "action",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "from_environment_id",
                "to_environment_id",
                "environment_id",
                "version_id"
              ]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceCustomProvidersCommitsGetOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "custom_provider_deployment_id",
    [
      "to_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "from_environment",
      1,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "current_provider_version_id",
          "instance_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "target_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "previous_custom_provider_version",
      1,
      [
        1,
        [
          [
            "deployment",
            0,
            [
              1,
              [
                "custom_provider_id",
                "provider_id",
                "custom_provider_version_id",
                ["commit", 0, [1, ["created_at"]]],
                [
                  "immutable_bucket",
                  1,
                  [
                    1,
                    [
                      "is_immutable",
                      "is_read_only",
                      [
                        "scm_repo_link",
                        1,
                        [
                          1,
                          [
                            "is_linked",
                            [
                              "repository",
                              0,
                              [
                                1,
                                ["is_private", "default_branch", "created_at"]
                              ]
                            ]
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
                [
                  "scm_push",
                  1,
                  [
                    1,
                    [
                      ["actor", 0, [1, ["external_id"]]],
                      ["commit", 0, [1, ["created_at"]]],
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ],
                      "created_at"
                    ]
                  ]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "environments",
            0,
            [
              2,
              [
                1,
                [
                  "is_current_version_for_environment",
                  [
                    "environment",
                    0,
                    [
                      1,
                      [
                        "custom_provider_id",
                        "provider_id",
                        "current_provider_version_id",
                        "instance_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "custom_provider_id",
          "provider_id",
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "container_image",
            1,
            [
              1,
              ["container_registry", "container_image_tag", "container_image"]
            ]
          ],
          "remote_mcp_server",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "scm_push",
      1,
      [
        1,
        [
          ["actor", 0, [1, ["external_id"]]],
          ["commit", 0, [1, ["created_at"]]],
          [
            "repository",
            0,
            [1, ["is_private", "default_branch", "created_at"]]
          ],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "applied_at"
  ],
  1
);
var mapManagementInstanceCustomProvidersCommitsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "custom_provider_id",
        "provider_id",
        "custom_provider_deployment_id",
        [
          "to_environment",
          1,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "current_provider_version_id",
              "instance_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "from_environment",
          1,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "current_provider_version_id",
              "instance_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "target_custom_provider_version",
          1,
          [
            1,
            [
              [
                "deployment",
                0,
                [
                  1,
                  [
                    "custom_provider_id",
                    "provider_id",
                    "custom_provider_version_id",
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "immutable_bucket",
                      1,
                      [
                        1,
                        [
                          "is_immutable",
                          "is_read_only",
                          [
                            "scm_repo_link",
                            1,
                            [
                              1,
                              [
                                "is_linked",
                                [
                                  "repository",
                                  0,
                                  [
                                    1,
                                    [
                                      "is_private",
                                      "default_branch",
                                      "created_at"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "actor",
                      0,
                      [1, ["organization_actor_id", "created_at"]]
                    ],
                    [
                      "scm_push",
                      1,
                      [
                        1,
                        [
                          ["actor", 0, [1, ["external_id"]]],
                          ["commit", 0, [1, ["created_at"]]],
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "environments",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "is_current_version_for_environment",
                      [
                        "environment",
                        0,
                        [
                          1,
                          [
                            "custom_provider_id",
                            "provider_id",
                            "current_provider_version_id",
                            "instance_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "custom_provider_id",
              "provider_id",
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "container_image",
                1,
                [
                  1,
                  [
                    "container_registry",
                    "container_image_tag",
                    "container_image"
                  ]
                ]
              ],
              "remote_mcp_server",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "previous_custom_provider_version",
          1,
          [
            1,
            [
              [
                "deployment",
                0,
                [
                  1,
                  [
                    "custom_provider_id",
                    "provider_id",
                    "custom_provider_version_id",
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "immutable_bucket",
                      1,
                      [
                        1,
                        [
                          "is_immutable",
                          "is_read_only",
                          [
                            "scm_repo_link",
                            1,
                            [
                              1,
                              [
                                "is_linked",
                                [
                                  "repository",
                                  0,
                                  [
                                    1,
                                    [
                                      "is_private",
                                      "default_branch",
                                      "created_at"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "actor",
                      0,
                      [1, ["organization_actor_id", "created_at"]]
                    ],
                    [
                      "scm_push",
                      1,
                      [
                        1,
                        [
                          ["actor", 0, [1, ["external_id"]]],
                          ["commit", 0, [1, ["created_at"]]],
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ],
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "environments",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "is_current_version_for_environment",
                      [
                        "environment",
                        0,
                        [
                          1,
                          [
                            "custom_provider_id",
                            "provider_id",
                            "current_provider_version_id",
                            "instance_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "custom_provider_id",
              "provider_id",
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "container_image",
                1,
                [
                  1,
                  [
                    "container_registry",
                    "container_image_tag",
                    "container_image"
                  ]
                ]
              ],
              "remote_mcp_server",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
        [
          "scm_push",
          1,
          [
            1,
            [
              ["actor", 0, [1, ["external_id"]]],
              ["commit", 0, [1, ["created_at"]]],
              [
                "repository",
                0,
                [1, ["is_private", "default_branch", "created_at"]]
              ],
              "created_at"
            ]
          ]
        ],
        "created_at",
        "applied_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersCommitsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_version_id",
            "custom_provider_environment_id",
            "custom_provider_id",
            "provider_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceCustomProvidersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersCreateBody = /* @__PURE__ */ mapObject([
  [
    "from",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_ref",
              "remote_url",
              "oauth_config",
              [
                "repository",
                0,
                [3, [[0, [1, ["repository_id", "repository_url"]]]]]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceCustomProvidersDeploymentsGetLogsOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_deployment_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            ["logs", 0, [2, [1, [["timestamp", 0, 4]]]]],
            "created_at",
            "started_at",
            "ended_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersDeploymentsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_id",
            "provider_id",
            "custom_provider_version_id",
            ["commit", 0, [1, ["created_at"]]],
            [
              "immutable_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ],
            ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
            [
              "scm_push",
              1,
              [
                1,
                [
                  ["actor", 0, [1, ["external_id"]]],
                  ["commit", 0, [1, ["created_at"]]],
                  [
                    "repository",
                    0,
                    [1, ["is_private", "default_branch", "created_at"]]
                  ],
                  "created_at"
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersDeploymentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "custom_provider_version_id",
              ["commit", 0, [1, ["created_at"]]],
              [
                "immutable_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "scm_push",
                1,
                [
                  1,
                  [
                    ["actor", 0, [1, ["external_id"]]],
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "repository",
                      0,
                      [1, ["is_private", "default_branch", "created_at"]]
                    ],
                    "created_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersDeploymentsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_version_id",
            "custom_provider_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceCustomProvidersEnvironmentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    "provider_id",
    "current_provider_version_id",
    "instance_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceCustomProvidersEnvironmentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "custom_provider_id",
        "provider_id",
        "current_provider_version_id",
        "instance_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersEnvironmentsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "custom_provider_version_id",
            "custom_provider_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceCustomProvidersGetEnvOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceCustomProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "draft",
                0,
                [
                  1,
                  [
                    [
                      "container_image",
                      1,
                      [
                        1,
                        [
                          "container_registry",
                          "container_image_tag",
                          "container_image"
                        ]
                      ]
                    ],
                    "remote_mcp_server"
                  ]
                ]
              ],
              [
                "scm_repo",
                1,
                [1, ["is_private", "default_branch", "created_at"]]
              ],
              [
                "provider",
                0,
                [
                  1,
                  [
                    [
                      "publisher",
                      0,
                      [1, ["image_url", "created_at", "updated_at"]]
                    ],
                    [
                      "current_version",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "is_current",
                          "specification_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              [
                "draft_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapManagementInstanceCustomProvidersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "draft",
              0,
              [
                1,
                [
                  [
                    "container_image",
                    1,
                    [
                      1,
                      [
                        "container_registry",
                        "container_image_tag",
                        "container_image"
                      ]
                    ]
                  ],
                  "remote_mcp_server"
                ]
              ]
            ],
            [
              "scm_repo",
              1,
              [1, ["is_private", "default_branch", "created_at"]]
            ],
            [
              "provider",
              0,
              [
                1,
                [
                  [
                    "publisher",
                    0,
                    [1, ["image_url", "created_at", "updated_at"]]
                  ],
                  [
                    "current_version",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        "is_current",
                        "specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            [
              "draft_bucket",
              1,
              [
                1,
                [
                  "is_immutable",
                  "is_read_only",
                  [
                    "scm_repo_link",
                    1,
                    [
                      1,
                      [
                        "is_linked",
                        [
                          "repository",
                          0,
                          [1, ["is_private", "default_branch", "created_at"]]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceCustomProvidersVersionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "deployment",
      0,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "custom_provider_version_id",
          ["commit", 0, [1, ["created_at"]]],
          [
            "immutable_bucket",
            1,
            [
              1,
              [
                "is_immutable",
                "is_read_only",
                [
                  "scm_repo_link",
                  1,
                  [
                    1,
                    [
                      "is_linked",
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "scm_push",
            1,
            [
              1,
              [
                ["actor", 0, [1, ["external_id"]]],
                ["commit", 0, [1, ["created_at"]]],
                [
                  "repository",
                  0,
                  [1, ["is_private", "default_branch", "created_at"]]
                ],
                "created_at"
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "environments",
      0,
      [
        2,
        [
          1,
          [
            "is_current_version_for_environment",
            [
              "environment",
              0,
              [
                1,
                [
                  "custom_provider_id",
                  "provider_id",
                  "current_provider_version_id",
                  "instance_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "custom_provider_id",
    "provider_id",
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "container_image",
      1,
      [1, ["container_registry", "container_image_tag", "container_image"]]
    ],
    "remote_mcp_server",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceCustomProvidersVersionsCreateBody = /* @__PURE__ */ mapObject(
  [
    "custom_provider_id",
    [
      "from",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "image_ref",
                "remote_url",
                "oauth_config",
                [
                  "repository",
                  0,
                  [3, [[0, [1, ["repository_id", "repository_url"]]]]]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceCustomProvidersVersionsGetEnvOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceCustomProvidersVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "deployment",
      0,
      [
        1,
        [
          "custom_provider_id",
          "provider_id",
          "custom_provider_version_id",
          ["commit", 0, [1, ["created_at"]]],
          [
            "immutable_bucket",
            1,
            [
              1,
              [
                "is_immutable",
                "is_read_only",
                [
                  "scm_repo_link",
                  1,
                  [
                    1,
                    [
                      "is_linked",
                      [
                        "repository",
                        0,
                        [1, ["is_private", "default_branch", "created_at"]]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
          [
            "scm_push",
            1,
            [
              1,
              [
                ["actor", 0, [1, ["external_id"]]],
                ["commit", 0, [1, ["created_at"]]],
                [
                  "repository",
                  0,
                  [1, ["is_private", "default_branch", "created_at"]]
                ],
                "created_at"
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "environments",
      0,
      [
        2,
        [
          1,
          [
            "is_current_version_for_environment",
            [
              "environment",
              0,
              [
                1,
                [
                  "custom_provider_id",
                  "provider_id",
                  "current_provider_version_id",
                  "instance_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "custom_provider_id",
    "provider_id",
    ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
    [
      "container_image",
      1,
      [1, ["container_registry", "container_image_tag", "container_image"]]
    ],
    "remote_mcp_server",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceCustomProvidersVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "deployment",
          0,
          [
            1,
            [
              "custom_provider_id",
              "provider_id",
              "custom_provider_version_id",
              ["commit", 0, [1, ["created_at"]]],
              [
                "immutable_bucket",
                1,
                [
                  1,
                  [
                    "is_immutable",
                    "is_read_only",
                    [
                      "scm_repo_link",
                      1,
                      [
                        1,
                        [
                          "is_linked",
                          [
                            "repository",
                            0,
                            [
                              1,
                              ["is_private", "default_branch", "created_at"]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
              [
                "scm_push",
                1,
                [
                  1,
                  [
                    ["actor", 0, [1, ["external_id"]]],
                    ["commit", 0, [1, ["created_at"]]],
                    [
                      "repository",
                      0,
                      [1, ["is_private", "default_branch", "created_at"]]
                    ],
                    "created_at"
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "environments",
          0,
          [
            2,
            [
              1,
              [
                "is_current_version_for_environment",
                [
                  "environment",
                  0,
                  [
                    1,
                    [
                      "custom_provider_id",
                      "provider_id",
                      "current_provider_version_id",
                      "instance_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "custom_provider_id",
        "provider_id",
        ["actor", 0, [1, ["organization_actor_id", "created_at"]]],
        [
          "container_image",
          1,
          [
            1,
            ["container_registry", "container_image_tag", "container_image"]
          ]
        ],
        "remote_mcp_server",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceCustomProvidersVersionsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_version_id",
            "custom_provider_id",
            "custom_provider_deployment_id",
            "custom_provider_environment_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceDocumentsCloneOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceDocumentsCloneBody = /* @__PURE__ */ mapObject([
  "target_document_id"
]);
var mapManagementInstanceDocumentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceDocumentsCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceDocumentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceDocumentsEditTokenGetOutput = /* @__PURE__ */ mapObject(
  ["expires_at", "document_id"],
  1
);
var mapManagementInstanceDocumentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceDocumentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "file_id",
        "parent_document_id",
        "current_version_id",
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceDocumentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "file_id",
          "store_id",
          "parent_document_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceDocumentsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "edit_count",
    "last_edited_at",
    "last_viewed_at",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceDocumentsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "edit_count",
        "last_edited_at",
        "last_viewed_at",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceDocumentsParticipantsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceDocumentsPermissionsGetOutput = /* @__PURE__ */ mapObject([
  "document_id",
  "is_owner",
  "has_full_access",
  "relevant_store_ids",
  "readable_store_ids",
  "writable_store_ids"
]);
var mapManagementInstanceDocumentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "file_id",
    "parent_document_id",
    "current_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceDocumentsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceDocumentsVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "document_id",
    "version_number",
    "previous_version_id",
    "list_edited_at",
    [
      "editors",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            [
              "organization_actor",
              1,
              [
                1,
                [
                  "organization_id",
                  "image_url",
                  [
                    "teams",
                    0,
                    [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "consumer",
              0,
              [1, ["image_url", "user_id", "created_at", "updated_at"]]
            ],
            [
              "consumer_profile",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "consumer_id",
                        "user_id",
                        "created_at",
                        "updated_at",
                        [
                          "groups",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                [
                                  "group",
                                  0,
                                  [
                                    1,
                                    ["is_default", "created_at", "updated_at"]
                                  ]
                                ],
                                "assigned_via"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceDocumentsVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "document_id",
        "version_number",
        "previous_version_id",
        "list_edited_at",
        [
          "editors",
          0,
          [
            2,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceDocumentsVersionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["last_edited_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceFilesDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "file_name",
            "file_size",
            "file_type",
            [
              "created_by",
              1,
              [
                1,
                [
                  "image_url",
                  [
                    "organization_actor",
                    1,
                    [
                      1,
                      [
                        "organization_id",
                        "image_url",
                        [
                          "teams",
                          0,
                          [
                            2,
                            [1, ["assignment_id", "created_at", "updated_at"]]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "consumer",
                    0,
                    [1, ["image_url", "user_id", "created_at", "updated_at"]]
                  ],
                  [
                    "consumer_profile",
                    1,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "consumer_id",
                              "user_id",
                              "created_at",
                              "updated_at",
                              [
                                "groups",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      [
                                        "group",
                                        0,
                                        [
                                          1,
                                          [
                                            "is_default",
                                            "created_at",
                                            "updated_at"
                                          ]
                                        ]
                                      ],
                                      "assigned_via"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "download_url"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceFilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "file_name",
            "file_size",
            "file_type",
            [
              "created_by",
              1,
              [
                1,
                [
                  "image_url",
                  [
                    "organization_actor",
                    1,
                    [
                      1,
                      [
                        "organization_id",
                        "image_url",
                        [
                          "teams",
                          0,
                          [
                            2,
                            [1, ["assignment_id", "created_at", "updated_at"]]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "consumer",
                    0,
                    [1, ["image_url", "user_id", "created_at", "updated_at"]]
                  ],
                  [
                    "consumer_profile",
                    1,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "consumer_id",
                              "user_id",
                              "created_at",
                              "updated_at",
                              [
                                "groups",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      [
                                        "group",
                                        0,
                                        [
                                          1,
                                          [
                                            "is_default",
                                            "created_at",
                                            "updated_at"
                                          ]
                                        ]
                                      ],
                                      "assigned_via"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "download_url"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceFilesLinksCreateOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapManagementInstanceFilesLinksCreateBody = /* @__PURE__ */ mapObject(
  ["file_id", "expires_at"],
  1
);
var mapManagementInstanceFilesLinksDeleteOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapManagementInstanceFilesLinksGetOutput = /* @__PURE__ */ mapObject(
  ["file_id", "created_at", "expires_at"],
  1
);
var mapManagementInstanceFilesLinksListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["file_id", "created_at", "expires_at"]]],
  1
);
var mapManagementInstanceFilesLinksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["file_id"]]]]
]);
var mapManagementInstanceFilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "download_url"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceFilesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "store_id",
          "document_id",
          "file_link_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceFirewallsCreateOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceFirewallsCreateBody = /* @__PURE__ */ mapObject([
  "network_policy_ids"
]);
var mapManagementInstanceFirewallsDeleteOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceFirewallsGetOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceFirewallsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["network_policies", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapManagementInstanceFirewallsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "enclave_id",
          "provider_id",
          "network_policy_id",
          "machine_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceFirewallsNetworkPoliciesAttachOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceFirewallsNetworkPoliciesAttachBody = /* @__PURE__ */ mapObject(
  ["network_policy_id"]
);
var mapManagementInstanceFirewallsNetworkPoliciesDetachOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceFirewallsUpdateOutput = /* @__PURE__ */ mapObject(
  ["network_policies", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceFirewallsUpdateBody = /* @__PURE__ */ mapObject([
  "network_policy_ids"
]);
var mapManagementInstanceIdentitiesCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesCreateBody = /* @__PURE__ */ mapObject([
  "actor_id",
  [
    "credentials",
    0,
    [
      2,
      [
        1,
        [
          "deployment_id",
          "config_id",
          "auth_config_id",
          "delegation_config_id"
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceIdentitiesCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesCredentialsCreateBody = /* @__PURE__ */ mapObject([
  "identity_id",
  "deployment_id",
  "config_id",
  "auth_config_id",
  "delegation_config_id"
]);
var mapManagementInstanceIdentitiesCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesCredentialsGetOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "identity_id",
        "provider_id",
        "deployment_id",
        "config_id",
        "auth_config_id",
        "delegation_config_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentitiesCredentialsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "actor_id",
            "identity_id",
            "provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIdentitiesCredentialsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "provider_id",
    "deployment_id",
    "config_id",
    "auth_config_id",
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesCredentialsUpdateBody = /* @__PURE__ */ mapObject([
  "delegation_config_id"
]);
var mapManagementInstanceIdentitiesDelegationConfigsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationConfigsCreateBody = /* @__PURE__ */ mapObject(
  ["sub_delegation_behavior", "sub_delegation_depth"]
);
var mapManagementInstanceIdentitiesDelegationConfigsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationConfigsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        "sub_delegation_behavior",
        "sub_delegation_depth",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationConfigsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIdentitiesDelegationConfigsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "sub_delegation_behavior",
    "sub_delegation_depth",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationConfigsUpdateBody = /* @__PURE__ */ mapObject(
  ["sub_delegation_behavior", "sub_delegation_depth"]
);
var mapManagementInstanceIdentitiesDelegationRequestsApproveOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationRequestsApproveQuery = /* @__PURE__ */ mapObject(
  ["allow_deleted"]
);
var mapManagementInstanceIdentitiesDelegationRequestsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationRequestsCreateBody = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "requester_actor_id",
    "delegator_actor_id",
    "expires_at",
    "delegation_config_id",
    ["credential_overrides", 1, [2, [1, ["credential_id", "expires_at"]]]]
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationRequestsDenyOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationRequestsDenyQuery = /* @__PURE__ */ mapObject(
  ["allow_deleted"]
);
var mapManagementInstanceIdentitiesDelegationRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    [
      "requester",
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          "default_identity_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "identity_id",
    [
      "delegation",
      0,
      [
        1,
        [
          "denied_reason",
          "delegation_level",
          ["attestation", 0, [1, ["created_at"]]],
          "delegation_config_id",
          [
            "parties",
            0,
            [
              2,
              [
                1,
                [
                  [
                    "actor",
                    0,
                    [
                      1,
                      [
                        "agent_id",
                        "consumer_id",
                        "default_identity_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ],
          [
            "request",
            0,
            [
              1,
              [
                "denied_reason",
                [
                  "requester",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "identity_id",
                "expires_at",
                "created_at"
              ]
            ]
          ],
          [
            "credential_overrides",
            1,
            [2, [1, ["credential_id", "created_at", "expires_at"]]]
          ],
          "created_at",
          "expires_at",
          "revoked_at"
        ]
      ]
    ],
    "expires_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationRequestsGetQuery = /* @__PURE__ */ mapObject(
  ["allow_deleted"]
);
var mapManagementInstanceIdentitiesDelegationRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "denied_reason",
        [
          "requester",
          0,
          [
            1,
            [
              "agent_id",
              "consumer_id",
              "default_identity_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "identity_id",
        [
          "delegation",
          0,
          [
            1,
            [
              "denied_reason",
              "delegation_level",
              ["attestation", 0, [1, ["created_at"]]],
              "delegation_config_id",
              [
                "parties",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "actor",
                        0,
                        [
                          1,
                          [
                            "agent_id",
                            "consumer_id",
                            "default_identity_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at"
                    ]
                  ]
                ]
              ],
              [
                "request",
                0,
                [
                  1,
                  [
                    "denied_reason",
                    [
                      "requester",
                      0,
                      [
                        1,
                        [
                          "agent_id",
                          "consumer_id",
                          "default_identity_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "identity_id",
                    "expires_at",
                    "created_at"
                  ]
                ]
              ],
              [
                "credential_overrides",
                1,
                [2, [1, ["credential_id", "created_at", "expires_at"]]]
              ],
              "created_at",
              "expires_at",
              "revoked_at"
            ]
          ]
        ],
        "expires_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationRequestsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "actor_id",
            "identity_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIdentitiesDelegationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationsCreateBody = /* @__PURE__ */ mapObject(
  [
    "identity_id",
    "delegator_actor_id",
    "delegatee_actor_id",
    "expires_at",
    "delegation_config_id",
    ["credential_overrides", 1, [2, [1, ["credential_id", "expires_at"]]]]
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "denied_reason",
        "delegation_level",
        ["attestation", 0, [1, ["created_at"]]],
        "delegation_config_id",
        [
          "parties",
          0,
          [
            2,
            [
              1,
              [
                [
                  "actor",
                  0,
                  [
                    1,
                    [
                      "agent_id",
                      "consumer_id",
                      "default_identity_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ]
        ],
        [
          "request",
          0,
          [
            1,
            [
              "denied_reason",
              [
                "requester",
                0,
                [
                  1,
                  [
                    "agent_id",
                    "consumer_id",
                    "default_identity_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "identity_id",
              "expires_at",
              "created_at"
            ]
          ]
        ],
        [
          "credential_overrides",
          1,
          [2, [1, ["credential_id", "created_at", "expires_at"]]]
        ],
        "created_at",
        "expires_at",
        "revoked_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentitiesDelegationsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "owner_actor_id",
            "delegator_actor_id",
            "delegatee_actor_id",
            "identity_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIdentitiesDelegationsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "denied_reason",
    "delegation_level",
    ["attestation", 0, [1, ["created_at"]]],
    "delegation_config_id",
    [
      "parties",
      0,
      [
        2,
        [
          1,
          [
            [
              "actor",
              0,
              [
                1,
                [
                  "agent_id",
                  "consumer_id",
                  "default_identity_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at"
          ]
        ]
      ]
    ],
    [
      "request",
      0,
      [
        1,
        [
          "denied_reason",
          [
            "requester",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          "identity_id",
          "expires_at",
          "created_at"
        ]
      ]
    ],
    [
      "credential_overrides",
      1,
      [2, [1, ["credential_id", "created_at", "expires_at"]]]
    ],
    "created_at",
    "expires_at",
    "revoked_at"
  ],
  1
);
var mapManagementInstanceIdentitiesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "owner",
          0,
          [
            1,
            [
              [
                "actor",
                0,
                [
                  1,
                  [
                    "agent_id",
                    "consumer_id",
                    "default_identity_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "credentials",
          0,
          [
            2,
            [
              1,
              [
                "identity_id",
                "provider_id",
                "deployment_id",
                "config_id",
                "auth_config_id",
                "delegation_config_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "delegation_config_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentitiesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["agent_id", "actor_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapManagementInstanceIdentitiesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "owner",
      0,
      [
        1,
        [
          [
            "actor",
            0,
            [
              1,
              [
                "agent_id",
                "consumer_id",
                "default_identity_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "credentials",
      0,
      [
        2,
        [
          1,
          [
            "identity_id",
            "provider_id",
            "deployment_id",
            "config_id",
            "auth_config_id",
            "delegation_config_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "delegation_config_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIdentitiesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceIdentityActorsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentityActorsCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceIdentityActorsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentityActorsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentityActorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "agent_id",
              "consumer_id",
              "default_identity_id",
              "created_at",
              "updated_at",
              [
                "consumer",
                0,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "user_id",
                          "created_at",
                          "updated_at",
                          "is_portal_consumer",
                          "is_organization_member",
                          "is_service_account"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentityActorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "consumer_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceIdentityActorsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "consumer_id",
            "default_identity_id",
            "created_at",
            "updated_at",
            [
              "consumer",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "image_url",
                        "user_id",
                        "created_at",
                        "updated_at",
                        "is_portal_consumer",
                        "is_organization_member",
                        "is_service_account"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIdentityActorsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceIncomingWebhooksGetOutput = /* @__PURE__ */ mapObject(
  ["attempt_count", "webhook_registration_id", "provider_id", "received_at"],
  1
);
var mapManagementInstanceIncomingWebhooksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "attempt_count",
        "webhook_registration_id",
        "provider_id",
        "received_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIncomingWebhooksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["webhook_registration_id", "provider_id"]]]]
]);
var mapManagementInstanceIntegrationEnclavesGetOutput = /* @__PURE__ */ mapObject(
  [
    "internet_gateway_id",
    "provider_deployment_id",
    ["enclave_environment", 1, [1, ["created_at"]]],
    "created_at",
    "last_used_at"
  ],
  1
);
var mapManagementInstanceIntegrationEnclavesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "internet_gateway_id",
        "provider_deployment_id",
        ["enclave_environment", 1, [1, ["created_at"]]],
        "created_at",
        "last_used_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationEnclavesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "internet_gateway_id",
          "provider_deployment_id",
          "provider_id",
          "firewall_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceIntegrationFirewallAssignmentsCreateOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapManagementInstanceIntegrationFirewallAssignmentsCreateBody = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["firewall_id", "target_type", "enclave_id", "provider_id"]]]]]
);
var mapManagementInstanceIntegrationFirewallAssignmentsDeleteOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapManagementInstanceIntegrationFirewallAssignmentsGetOutput = /* @__PURE__ */ mapObject(
  ["target_type", "created_at"],
  1
);
var mapManagementInstanceIntegrationFirewallAssignmentsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["target_type", "created_at"]]],
  1
);
var mapManagementInstanceIntegrationFirewallAssignmentsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "firewall_id",
            "enclave_id",
            "provider_id",
            "internet_gateway_id",
            "target_type",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationInternetGatewayGetOutput = /* @__PURE__ */ mapObject(
  ["created_at", "updated_at", ["public_ips", 1, [2, 8]]],
  1
);
var mapManagementInstanceIntegrationInternetGatewayListNetworkLogsOutput = /* @__PURE__ */ mapObject(
  [
    "enclave_ids",
    [
      "records",
      0,
      [
        2,
        [
          1,
          [
            "enclave_id",
            "bucket_start",
            ["first_seen_at", 1, 0],
            ["last_seen_at", 1, 0]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationInternetGatewayListNetworkLogsQuery = /* @__PURE__ */ mapObject(
  ["enclave_id", "interval_minutes"]
);
var mapManagementInstanceIntegrationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsCreateBody = /* @__PURE__ */ mapObject([
  "use_integration_name_in_tool_names",
  "can_attach_custom_tool_filters",
  "can_attach_custom_provider_config",
  "can_override_tool_filters",
  "enable_callback_tools"
]);
var mapManagementInstanceIntegrationsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceIntegrationsInstanceGroupsCreateSessionOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsCreateSessionBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceIntegrationsInstanceGroupsCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsCreateBody = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [2, [1, ["integration_instance_provider_id", "tool_filters"]]]
    ]
  ]
);
var mapManagementInstanceIntegrationsInstanceGroupsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsGetOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                "integration_instance_group_id",
                "integration_instance_id",
                "integration_provider_id",
                "integration_instance_provider_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "is_override_tool_filter",
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            "integration_instance_provider_id",
            "provider_id",
            "integration_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationsInstanceGroupsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_instance_group_id",
        "integration_instance_id",
        "integration_provider_id",
        "integration_instance_provider_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "is_override_tool_filter",
        "created_at",
        "updated_at",
        "archived_at",
        ["provider", 0, 8],
        [
          "integration_provider",
          1,
          [
            1,
            [
              "provider_version",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "deployment_id",
              "auth_method_id",
              "auth_credentials_id",
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        [
          "integration_instance_provider",
          1,
          [
            1,
            [
              "integration_id",
              "integration_instance_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "is_override_tool_filter",
              ["provider", 0, 8],
              [
                "integration_provider",
                1,
                [
                  1,
                  [
                    "provider_version",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    "provider_id",
                    "deployment_id",
                    "auth_method_id",
                    "auth_credentials_id",
                    [
                      "config",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at",
                    "archived_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_config",
                1,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "callback_instance_id",
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_instance_group_id",
            "integration_id",
            "integration_instance_id",
            "integration_instance_provider_id",
            "provider_id",
            "integration_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationsInstanceGroupsProvidersSetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_group_id",
    "integration_instance_id",
    "integration_provider_id",
    "integration_instance_provider_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "integration_instance_provider",
      1,
      [
        1,
        [
          "integration_id",
          "integration_instance_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "is_override_tool_filter",
          ["provider", 0, 8],
          [
            "integration_provider",
            1,
            [
              1,
              [
                "provider_version",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ],
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "auth_config",
            1,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "callback_instance_id",
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsProvidersSetBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapManagementInstanceIntegrationsInstanceGroupsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["implementation", 0, [1, ["magic_mcp_endpoint_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_group_id",
            "integration_instance_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstanceGroupsUpdateBody = /* @__PURE__ */ mapObject(
  [
    [
      "providers",
      0,
      [2, [1, ["integration_instance_provider_id", "tool_filters"]]]
    ]
  ]
);
var mapManagementInstanceIntegrationsInstancesCreateSessionTemplateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesCreateSessionTemplateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceIntegrationsInstancesCreateSessionOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesCreateSessionBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceIntegrationsInstancesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "identity_actor_id",
  "identity_id",
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters",
          "is_override_tool_filter"
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceIntegrationsInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "identity_actor_id",
        "identity_id",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        ["implementation", 0, [1, ["magic_mcp_server_id"]]],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                "integration_instance_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "is_override_tool_filter",
                ["provider", 0, 8],
                [
                  "integration_provider",
                  1,
                  [
                    1,
                    [
                      "provider_version",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      "provider_id",
                      "deployment_id",
                      "auth_method_id",
                      "auth_credentials_id",
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "auth_config",
                  1,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "callback_instance_id",
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at",
        "is_oauth_compatible"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "provider_id",
            "integration_provider_id",
            "identity_id",
            "identity_credential_id",
            "identity_actor_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationsInstancesProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "callback_instance_id",
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        "integration_instance_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "is_override_tool_filter",
        ["provider", 0, 8],
        [
          "integration_provider",
          1,
          [
            1,
            [
              "provider_version",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "deployment_id",
              "auth_method_id",
              "auth_credentials_id",
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "auth_config",
          1,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "callback_instance_id",
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            "provider_id",
            "integration_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            "session_template_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationsInstancesProvidersSetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "is_override_tool_filter",
    ["provider", 0, 8],
    [
      "integration_provider",
      1,
      [
        1,
        [
          "provider_version",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          "provider_id",
          "deployment_id",
          "auth_method_id",
          "auth_credentials_id",
          [
            "config",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "callback_instance_id",
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesProvidersSetBody = /* @__PURE__ */ mapObject(
  [
    "provider_deployment_id",
    "provider_config_id",
    "provider_auth_config_id",
    "tool_filters",
    "is_override_tool_filter"
  ]
);
var mapManagementInstanceIntegrationsInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "identity_actor_id",
    "identity_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    ["implementation", 0, [1, ["magic_mcp_server_id"]]],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "is_override_tool_filter",
            ["provider", 0, 8],
            [
              "integration_provider",
              1,
              [
                1,
                [
                  "provider_version",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "deployment_id",
                  "auth_method_id",
                  "auth_credentials_id",
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "callback_instance_id",
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    "is_oauth_compatible"
  ],
  1
);
var mapManagementInstanceIntegrationsInstancesUpdateBody = /* @__PURE__ */ mapObject([
  "identity_actor_id",
  "identity_id",
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters",
          "is_override_tool_filter"
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceIntegrationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "configuration",
          0,
          [
            1,
            [
              "can_attach_custom_tool_filters",
              "can_attach_custom_provider_config",
              "can_override_tool_filters",
              "enable_callback_tools",
              "use_integration_name_in_tool_names"
            ]
          ]
        ],
        [
          "implementation",
          0,
          [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
        ],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                "integration_id",
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "deployment_id",
                "auth_method_id",
                "auth_credentials_id",
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "callbacks",
                  0,
                  [
                    1,
                    [
                      "callback_id",
                      [
                        "callback",
                        0,
                        [
                          1,
                          [
                            "integration_id",
                            "integration_provider_id",
                            ["provider", 0, 8],
                            "created_at",
                            "updated_at",
                            "auth_credentials_is_managed",
                            ["sync", 0, [1, ["synced_at"]]]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at",
                ["provider", 0, 8],
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "auth_method",
                  1,
                  [
                    1,
                    [
                      "input_schema",
                      "output_schema",
                      "provider_id",
                      "provider_specification_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "auth_credentials",
                  1,
                  [
                    1,
                    [
                      "is_default",
                      "is_managed",
                      "provider_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "integration_provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceIntegrationsProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsProvidersCreateBody = /* @__PURE__ */ mapObject([
  "integration_id",
  "provider_id",
  "provider_deployment_id",
  "provider_auth_method_id",
  "provider_auth_credentials_id",
  "provider_config_id",
  "tool_filters"
]);
var mapManagementInstanceIntegrationsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_id",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "deployment_id",
        "auth_method_id",
        "auth_credentials_id",
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "callbacks",
          0,
          [
            1,
            [
              "callback_id",
              [
                "callback",
                0,
                [
                  1,
                  [
                    "integration_id",
                    "integration_provider_id",
                    ["provider", 0, 8],
                    "created_at",
                    "updated_at",
                    "auth_credentials_is_managed",
                    ["sync", 0, [1, ["synced_at"]]]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at",
        ["provider", 0, 8],
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "auth_method",
          1,
          [
            1,
            [
              "input_schema",
              "output_schema",
              "provider_id",
              "provider_specification_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "auth_credentials",
          1,
          [
            1,
            [
              "is_default",
              "is_managed",
              "provider_id",
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "provider_id",
            "provider_deployment_id",
            "provider_auth_method_id",
            "provider_auth_credentials_id",
            "provider_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationsProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "deployment_id",
    "auth_method_id",
    "auth_credentials_id",
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "callbacks",
      0,
      [
        1,
        [
          "callback_id",
          [
            "callback",
            0,
            [
              1,
              [
                "integration_id",
                "integration_provider_id",
                ["provider", 0, 8],
                "created_at",
                "updated_at",
                "auth_credentials_is_managed",
                ["sync", 0, [1, ["synced_at"]]]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at",
    ["provider", 0, 8],
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "auth_method",
      1,
      [
        1,
        [
          "input_schema",
          "output_schema",
          "provider_id",
          "provider_specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "auth_credentials",
      1,
      [
        1,
        [
          "is_default",
          "is_managed",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsProvidersUpdateBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "provider_auth_method_id",
  "provider_auth_credentials_id",
  "provider_config_id",
  "tool_filters"
]);
var mapManagementInstanceIntegrationsSetupSessionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "redirect_url",
    "integration_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    [
      "integration_instance",
      1,
      [
        1,
        [
          "integration_id",
          "identity_actor_id",
          "identity_id",
          ["owner_actor", 1, [1, ["consumer_id"]]],
          ["implementation", 0, [1, ["magic_mcp_server_id"]]],
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "integration_id",
                  "integration_instance_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "is_override_tool_filter",
                  ["provider", 0, 8],
                  [
                    "integration_provider",
                    1,
                    [
                      1,
                      [
                        "provider_version",
                        [
                          "tool_filter",
                          1,
                          [3, [[0, [1, ["ignore_parent_filters"]]]]]
                        ],
                        "provider_id",
                        "deployment_id",
                        "auth_method_id",
                        "auth_credentials_id",
                        [
                          "config",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "archived_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "callback_instance_id",
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "expires_at",
    "integration_instance_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            "integration_provider_id",
            ["provider", 0, 8],
            "provider_setup_session_id",
            "integration_instance_provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsSetupSessionsCreateBody = /* @__PURE__ */ mapObject(
  [
    "integration_id",
    "integration_instance_id",
    "identity_actor_id",
    "identity_id",
    "expires_at",
    "redirect_url",
    [
      "configuration",
      0,
      [
        1,
        [
          [
            "provider_search",
            1,
            [
              1,
              [
                ["groups", 0, [2, [1, ["group_id"]]]],
                ["collections", 0, [2, [1, ["collection_id"]]]],
                ["categories", 0, [2, [1, ["category_id"]]]]
              ]
            ]
          ],
          "tool_filters"
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsSetupSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "redirect_url",
    "integration_id",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    [
      "integration_instance",
      1,
      [
        1,
        [
          "integration_id",
          "identity_actor_id",
          "identity_id",
          ["owner_actor", 1, [1, ["consumer_id"]]],
          ["implementation", 0, [1, ["magic_mcp_server_id"]]],
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "integration_id",
                  "integration_instance_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "is_override_tool_filter",
                  ["provider", 0, 8],
                  [
                    "integration_provider",
                    1,
                    [
                      1,
                      [
                        "provider_version",
                        [
                          "tool_filter",
                          1,
                          [3, [[0, [1, ["ignore_parent_filters"]]]]]
                        ],
                        "provider_id",
                        "deployment_id",
                        "auth_method_id",
                        "auth_credentials_id",
                        [
                          "config",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "archived_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "callback_instance_id",
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "expires_at",
    "integration_instance_id",
    [
      "steps",
      0,
      [
        2,
        [
          1,
          [
            "integration_provider_id",
            ["provider", 0, 8],
            "provider_setup_session_id",
            "integration_instance_provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsSetupSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "redirect_url",
        "integration_id",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        [
          "integration_instance",
          1,
          [
            1,
            [
              "integration_id",
              "identity_actor_id",
              "identity_id",
              ["owner_actor", 1, [1, ["consumer_id"]]],
              ["implementation", 0, [1, ["magic_mcp_server_id"]]],
              [
                "providers",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "integration_id",
                      "integration_instance_id",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      "is_override_tool_filter",
                      ["provider", 0, 8],
                      [
                        "integration_provider",
                        1,
                        [
                          1,
                          [
                            "provider_version",
                            [
                              "tool_filter",
                              1,
                              [3, [[0, [1, ["ignore_parent_filters"]]]]]
                            ],
                            "provider_id",
                            "deployment_id",
                            "auth_method_id",
                            "auth_credentials_id",
                            [
                              "config",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at",
                            "archived_at"
                          ]
                        ]
                      ],
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_config",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "callback_instance_id",
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "expires_at",
        "integration_instance_id",
        [
          "steps",
          0,
          [
            2,
            [
              1,
              [
                "integration_provider_id",
                ["provider", 0, 8],
                "provider_setup_session_id",
                "integration_instance_provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceIntegrationsSetupSessionsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "integration_id",
            "integration_instance_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceIntegrationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "configuration",
      0,
      [
        1,
        [
          "can_attach_custom_tool_filters",
          "can_attach_custom_provider_config",
          "can_override_tool_filters",
          "enable_callback_tools",
          "use_integration_name_in_tool_names"
        ]
      ]
    ],
    [
      "implementation",
      0,
      [3, [[0, [1, ["provider_template_id", "magic_mcp_server_id"]]]]]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            "integration_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "deployment_id",
            "auth_method_id",
            "auth_credentials_id",
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "callbacks",
              0,
              [
                1,
                [
                  "callback_id",
                  [
                    "callback",
                    0,
                    [
                      1,
                      [
                        "integration_id",
                        "integration_provider_id",
                        ["provider", 0, 8],
                        "created_at",
                        "updated_at",
                        "auth_credentials_is_managed",
                        ["sync", 0, [1, ["synced_at"]]]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementInstanceIntegrationsUpdateBody = /* @__PURE__ */ mapObject([
  "use_integration_name_in_tool_names",
  "can_attach_custom_tool_filters",
  "can_attach_custom_provider_config",
  "can_override_tool_filters",
  "enable_callback_tools"
]);
var mapManagementInstanceMagicMcpEndpointsAddServersOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpEndpointsAddServersBody = /* @__PURE__ */ mapObject([
  ["magic_mcp_servers", 1, [2, [1, ["magic_mcp_server_id", "tool_filters"]]]]
]);
var mapManagementInstanceMagicMcpEndpointsCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpEndpointsCreateBody = /* @__PURE__ */ mapObject([
  "consumer_profile_id",
  "skill_plugin_id",
  "enable_skill_editing",
  ["magic_mcp_servers", 1, [2, [1, ["magic_mcp_server_id", "tool_filters"]]]]
]);
var mapManagementInstanceMagicMcpEndpointsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpEndpointsGetOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpEndpointsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
        "enable_skill_editing",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpEndpointsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["magic_mcp_server_id"]]]]
]);
var mapManagementInstanceMagicMcpEndpointsRemoveServersOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpEndpointsRemoveServersBody = /* @__PURE__ */ mapObject(
  ["magic_mcp_server_ids"]
);
var mapManagementInstanceMagicMcpEndpointsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
    "enable_skill_editing",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpEndpointsUpdateBody = /* @__PURE__ */ mapObject([
  "enable_skill_editing"
]);
var mapManagementInstanceMagicMcpGroupsAddServersOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstanceMagicMcpGroupsAddServersBody = /* @__PURE__ */ mapObject([
  "magic_mcp_server_ids"
]);
var mapManagementInstanceMagicMcpGroupsCreateOutput = /* @__PURE__ */ createMapper(8);
var mapManagementInstanceMagicMcpGroupsCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceMagicMcpGroupsDeleteOutput = /* @__PURE__ */ createMapper(8);
var mapManagementInstanceMagicMcpGroupsGetOutput = /* @__PURE__ */ createMapper(8);
var mapManagementInstanceMagicMcpGroupsListOutput = /* @__PURE__ */ createMapper([
  7,
  8
]);
var mapManagementInstanceMagicMcpGroupsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceMagicMcpGroupsRemoveServersOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstanceMagicMcpGroupsRemoveServersBody = /* @__PURE__ */ mapObject([
  "magic_mcp_server_ids"
]);
var mapManagementInstanceMagicMcpGroupsUpdateOutput = /* @__PURE__ */ createMapper(8);
var mapManagementInstanceMagicMcpGroupsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceMagicMcpServersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersCreateBody = /* @__PURE__ */ mapObject([
  "provider_template_id",
  "integration_instance_id",
  "consumer_profile_id"
]);
var mapManagementInstanceMagicMcpServersDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_management_mode",
              "provider_template_id",
              [
                "providers",
                0,
                [
                  2,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "magic_mcp_server_id",
                            "provider_management_mode",
                            [
                              "tool_filter",
                              1,
                              [3, [[0, [1, ["ignore_parent_filters"]]]]]
                            ],
                            ["provider", 0, 8],
                            [
                              "deployment",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_method",
                              1,
                              [
                                1,
                                [
                                  "input_schema",
                                  "output_schema",
                                  "provider_id",
                                  "provider_specification_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_credentials",
                              1,
                              [
                                1,
                                [
                                  "is_default",
                                  "is_managed",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "config",
                              0,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            [
                              "auth_config",
                              1,
                              [
                                1,
                                [
                                  "is_default",
                                  "provider_id",
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at",
                            "archived_at",
                            "can_update",
                            "can_delete"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "integration_id",
              "integration_instance_id",
              "backing_status",
              [
                "consumer_owners",
                1,
                [
                  2,
                  [
                    1,
                    [
                      "consumer_integration_id",
                      "consumer_id",
                      "consumer_profile_id",
                      "consumer_name",
                      "consumer_email",
                      "consumer_profile_name",
                      "consumer_profile_email"
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "magic_mcp_group_id",
          "provider_template_id",
          "integration_instance_id",
          "provider_id",
          "consumer_id",
          "consumer_profile_id",
          "preconfigured_only"
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceMagicMcpServersProvidersCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersProvidersCreateBody = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_config_id",
    "provider_auth_config_id",
    "tool_filters"
  ]
);
var mapManagementInstanceMagicMcpServersProvidersDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "magic_mcp_server_id",
              "provider_management_mode",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              ["provider", 0, 8],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_credentials",
                1,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "auth_config",
                1,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              "created_at",
              "updated_at",
              "archived_at",
              "can_update",
              "can_delete"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "integration_provider_id",
            "integration_instance_provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceMagicMcpServersProvidersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "magic_mcp_server_id",
            "provider_management_mode",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            ["provider", 0, 8],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_credentials",
              1,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "auth_config",
              1,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "created_at",
            "updated_at",
            "archived_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersProvidersUpdateBody = /* @__PURE__ */ mapObject(
  [
    "provider_deployment_id",
    "provider_config_id",
    "provider_auth_config_id",
    "tool_filters"
  ]
);
var mapManagementInstanceMagicMcpServersSessionCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpServersToolsOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_management_mode",
            "provider_template_id",
            [
              "providers",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "magic_mcp_server_id",
                          "provider_management_mode",
                          [
                            "tool_filter",
                            1,
                            [3, [[0, [1, ["ignore_parent_filters"]]]]]
                          ],
                          ["provider", 0, 8],
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_method",
                            1,
                            [
                              1,
                              [
                                "input_schema",
                                "output_schema",
                                "provider_id",
                                "provider_specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_credentials",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "is_managed",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "config",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "auth_config",
                            1,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "archived_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "integration_id",
            "integration_instance_id",
            "backing_status",
            [
              "consumer_owners",
              1,
              [
                2,
                [
                  1,
                  [
                    "consumer_integration_id",
                    "consumer_id",
                    "consumer_profile_id",
                    "consumer_name",
                    "consumer_email",
                    "consumer_profile_name",
                    "consumer_profile_email"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpServersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceMagicMcpSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "magic_mcp_server",
      1,
      [
        1,
        [
          "provider_management_mode",
          "provider_template_id",
          [
            "providers",
            0,
            [
              2,
              [
                1,
                [
                  "magic_mcp_server_id",
                  "provider_management_mode",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  ["provider", 0, 8],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_credentials",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "config",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_config",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "magic_mcp_endpoint",
      1,
      [
        1,
        [
          ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
          "enable_skill_editing",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "consumer_profile_id",
    "consumer_integration_ids",
    "session_id",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceMagicMcpSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "magic_mcp_server",
          1,
          [
            1,
            [
              "provider_management_mode",
              "provider_template_id",
              [
                "providers",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "magic_mcp_server_id",
                      "provider_management_mode",
                      [
                        "tool_filter",
                        1,
                        [3, [[0, [1, ["ignore_parent_filters"]]]]]
                      ],
                      ["provider", 0, 8],
                      [
                        "deployment",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_method",
                        1,
                        [
                          1,
                          [
                            "input_schema",
                            "output_schema",
                            "provider_id",
                            "provider_specification_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_credentials",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "is_managed",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "config",
                        0,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "auth_config",
                        1,
                        [
                          1,
                          [
                            "is_default",
                            "provider_id",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "magic_mcp_endpoint",
          1,
          [
            1,
            [
              ["servers", 0, [2, [3, [[0, [1, ["tool_filters"]]]]]]],
              "enable_skill_editing",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "consumer_profile_id",
        "consumer_integration_ids",
        "session_id",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceMagicMcpSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["magic_mcp_server_id"]]]]
]);
var mapManagementInstanceMagicMcpTokensAddGroupsOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapManagementInstanceMagicMcpTokensAddGroupsBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids"
]);
var mapManagementInstanceMagicMcpTokensCreateOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapManagementInstanceMagicMcpTokensCreateBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids",
  "magic_mcp_server_id",
  "magic_mcp_endpoint_id"
]);
var mapManagementInstanceMagicMcpTokensDeleteOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapManagementInstanceMagicMcpTokensGetOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapManagementInstanceMagicMcpTokensListOutput = /* @__PURE__ */ createMapper(
  [7, [1, [["groups", 0, [2, 8]], "created_at", "updated_at"]]],
  1
);
var mapManagementInstanceMagicMcpTokensListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["magic_mcp_group_id", "magic_mcp_server_id", "magic_mcp_endpoint_id"]
      ]
    ]
  ]
]);
var mapManagementInstanceMagicMcpTokensRemoveGroupsOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapManagementInstanceMagicMcpTokensRemoveGroupsBody = /* @__PURE__ */ mapObject([
  "magic_mcp_group_ids"
]);
var mapManagementInstanceMagicMcpTokensUpdateOutput = /* @__PURE__ */ mapObject(
  [["groups", 0, [2, 8]], "created_at", "updated_at"],
  1
);
var mapManagementInstanceMagicMcpTokensUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceMonitorAlertsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapManagementInstanceMonitorAlertsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "monitor",
          0,
          [
            1,
            [
              "proto_guard_filter_id",
              "provider_id",
              "created_at",
              "updated_at",
              "first_alert_at",
              "last_alert_at"
            ]
          ]
        ],
        "proto_guard_alert_id",
        "proto_guard_run_id",
        [
          "specification_change_notification",
          1,
          [
            1,
            [
              "provider_id",
              "provider_version_id",
              ["from_specification", 1, 8],
              ["to_specification", 1, 8],
              ["from_provider_version", 1, 8],
              ["to_provider_version", 1, 8],
              "created_at"
            ]
          ]
        ],
        "created_at",
        "resolved_at",
        [
          "recipients",
          0,
          [2, [1, ["recipient_id", "viewed_at", "created_at"]]]
        ],
        ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
      ]
    ]
  ],
  1
);
var mapManagementInstanceMonitorAlertsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "monitor_id",
          "provider_id",
          "proto_guard_alert_id",
          "proto_guard_run_id",
          "proto_guard_filter_id",
          "specification_change_notification_id",
          "session_id",
          "session_message_id",
          "session_connection_id",
          "provider_run_id",
          ["created_at", 1, 5],
          ["resolved_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceMonitorAlertsResolveOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapManagementInstanceMonitorAlertsUnresolveOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapManagementInstanceMonitorAlertsViewedOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapManagementInstanceMonitorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "proto_guard_filter_id",
    "provider_id",
    "created_at",
    "updated_at",
    "first_alert_at",
    "last_alert_at"
  ],
  1
);
var mapManagementInstanceMonitorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "proto_guard_filter_id",
        "provider_id",
        "created_at",
        "updated_at",
        "first_alert_at",
        "last_alert_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceMonitorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "proto_guard_filter_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5],
          ["first_alert_at", 1, 5],
          ["last_alert_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceNetworkPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceNetworkPoliciesCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceNetworkPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceNetworkPoliciesGetOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceNetworkPoliciesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["firewall_ids", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapManagementInstanceNetworkPoliciesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["firewall_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapManagementInstanceNetworkPoliciesRulesCreateOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceNetworkPoliciesRulesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceNetworkPoliciesRulesDeleteOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceNetworkPoliciesRulesUpdateOutput = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceNetworkPoliciesRulesUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceNetworkPoliciesUpdateOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapManagementInstanceNetworkPoliciesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstancePortalsAccessCreateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsAccessCreateBody = /* @__PURE__ */ mapObject([
  "consumer_group_id",
  [
    "access",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_template_id",
              "magic_mcp_server_id",
              "skill_id",
              "skill_template_id",
              "skill_group_id",
              "skill_marketplace_id",
              "skill_plugin_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapManagementInstancePortalsAccessDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsAccessGetOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsAccessListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "access_level",
        [
          "access",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server",
                    "skill_template",
                    "skill_group",
                    "skill_marketplace",
                    "skill_plugin"
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "consumer_group",
          1,
          [1, ["is_default", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsAccessListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "consumer_group_id",
          "provider_template_id",
          "magic_mcp_server_id",
          "skill_id",
          "skill_template_id",
          "skill_group_id",
          "skill_marketplace_id",
          "skill_plugin_id",
          "consumer_access_listing_id"
        ]
      ]
    ]
  ]
]);
var mapManagementInstancePortalsAccessUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsAccessUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstancePortalsAccessRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "resolution_message",
    "consumer_profile",
    [
      "target",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "reviewed_at"
  ],
  1
);
var mapManagementInstancePortalsAccessRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "resolution_message",
        "consumer_profile",
        [
          "target",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server"
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "reviewed_at"
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsAccessRequestsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["consumer_profile_id"]]]]]
);
var mapManagementInstancePortalsAccessRequestsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "resolution_message",
    "consumer_profile",
    [
      "target",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "reviewed_at"
  ],
  1
);
var mapManagementInstancePortalsAccessRequestsUpdateBody = /* @__PURE__ */ mapObject([
  "resolution_message",
  "consumer_group_id"
]);
var mapManagementInstancePortalsConsumerGroupsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerGroupsCreateBody = /* @__PURE__ */ mapObject([
  "is_default"
]);
var mapManagementInstancePortalsConsumerGroupsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerGroupsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              "created_at",
              "updated_at",
              "is_managed",
              "is_default_everyone_group"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerGroupsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePortalsConsumerGroupsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerGroupsUpdateBody = /* @__PURE__ */ mapObject([
  "is_default"
]);
var mapManagementInstancePortalsConsumerInvitesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "portal_url",
    "consumer_profile",
    "invited_by",
    "accepted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsConsumerInvitesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePortalsConsumerInvitesGetOutput = /* @__PURE__ */ mapObject(
  [
    "portal_url",
    "consumer_profile",
    "invited_by",
    "accepted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsConsumerInvitesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "portal_url",
        "consumer_profile",
        "invited_by",
        "accepted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerInvitesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePortalsConsumerProfilesAssignGroupsOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerProfilesAssignGroupsBody = /* @__PURE__ */ mapObject(
  ["group_ids"]
);
var mapManagementInstancePortalsConsumerProfilesCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerProfilesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePortalsConsumerProfilesDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerProfilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerProfilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "consumer_id",
              "user_id",
              "created_at",
              "updated_at",
              [
                "groups",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "group",
                        0,
                        [1, ["is_default", "created_at", "updated_at"]]
                      ],
                      "assigned_via"
                    ]
                  ]
                ]
              ],
              "is_service_account",
              [
                "surface",
                0,
                [
                  1,
                  [
                    "allow_consumer_skill_authoring",
                    "allow_consumer_skill_publishing",
                    [
                      "skill_configuration",
                      1,
                      [
                        1,
                        [
                          "is_default",
                          "allow_scripts",
                          "allowed_file_extensions",
                          "allow_non_standard_directories"
                        ]
                      ]
                    ],
                    [
                      "auth",
                      0,
                      [
                        1,
                        ["session_expiry_time_in_seconds", "email_whitelist"]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerProfilesListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["consumer_group_id"]]]]]
);
var mapManagementInstancePortalsConsumerProfilesUnassignGroupsOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsConsumerProfilesUnassignGroupsBody = /* @__PURE__ */ mapObject(
  ["group_ids"]
);
var mapManagementInstancePortalsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsCreateBody = /* @__PURE__ */ mapObject([
  "allowed_redirect_url_filters",
  "session_expiry_time_in_seconds",
  "allow_consumer_skill_authoring",
  "allow_consumer_skill_publishing"
]);
var mapManagementInstancePortalsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "allow_consumer_skill_authoring",
              "allow_consumer_skill_publishing",
              [
                "skill_configuration",
                1,
                [
                  1,
                  [
                    "is_default",
                    "allow_scripts",
                    "allowed_file_extensions",
                    "allow_non_standard_directories"
                  ]
                ]
              ],
              [
                "auth",
                0,
                [
                  1,
                  [
                    "session_expiry_time_in_seconds",
                    "allowed_redirect_url_filters"
                  ]
                ]
              ],
              "magic_mcp_url",
              "created_at",
              "updated_at",
              "managed_everyone_group_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstancePortalsListingsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsListingsCreateBody = /* @__PURE__ */ mapObject([
  [
    "access",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_template_id",
              "magic_mcp_server_id",
              "skill_id",
              "skill_template_id",
              "skill_group_id",
              "skill_marketplace_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapManagementInstancePortalsListingsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsListingsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsListingsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "access",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server",
                    "skill_template",
                    "skill_group",
                    "skill_marketplace",
                    "skill_plugin"
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsListingsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "consumer_surface_provider_group_id",
          "provider_template_id",
          "magic_mcp_server_id",
          "skill_id",
          "skill_template_id",
          "skill_group_id",
          "skill_marketplace_id"
        ]
      ]
    ]
  ]
]);
var mapManagementInstancePortalsListingsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePortalsListingsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstancePortalsSurfaceProviderGroupsAddListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstancePortalsSurfaceProviderGroupsAddListingBody = /* @__PURE__ */ mapObject(
  ["consumer_access_listing_id"]
);
var mapManagementInstancePortalsSurfaceProviderGroupsCreateOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstancePortalsSurfaceProviderGroupsCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePortalsSurfaceProviderGroupsDeleteOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstancePortalsSurfaceProviderGroupsGetOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstancePortalsSurfaceProviderGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, 8]
);
var mapManagementInstancePortalsSurfaceProviderGroupsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePortalsSurfaceProviderGroupsRemoveListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstancePortalsSurfaceProviderGroupsUpdateOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstancePortalsSurfaceProviderGroupsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePortalsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePortalsUpdateBody = /* @__PURE__ */ mapObject([
  "allowed_redirect_url_filters",
  "session_expiry_time_in_seconds",
  "allow_consumer_skill_authoring",
  "allow_consumer_skill_publishing",
  [
    "skill_configuration",
    1,
    [
      1,
      [
        "allow_scripts",
        "allowed_file_extensions",
        "allow_non_standard_directories"
      ]
    ]
  ]
]);
var mapManagementInstanceProtoGuardAlertsGetOutput = /* @__PURE__ */ mapObject(
  [
    "run_id",
    "session_id",
    "session_message_id",
    "session_connection_id",
    "provider_run_id",
    ["filters", 0, [2, [1, ["filter_id", "issue_type", "created_at"]]]],
    "created_at"
  ],
  1
);
var mapManagementInstanceProtoGuardAlertsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "run_id",
        "session_id",
        "session_message_id",
        "session_connection_id",
        "provider_run_id",
        ["filters", 0, [2, [1, ["filter_id", "issue_type", "created_at"]]]],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProtoGuardAlertsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "run_id",
          "filter_id",
          "session_id",
          "session_message_id",
          "session_connection_id",
          "provider_run_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceProtoGuardConfigGetOutput = /* @__PURE__ */ mapObject([
  "alert_filter_count_threshold",
  [
    "filters",
    0,
    [
      2,
      [
        1,
        [
          "issue_type",
          "score_weight",
          "default_enabled",
          "default_alert_confidence_threshold",
          "alert_confidence_threshold"
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput = /* @__PURE__ */ mapObject(
  [
    "alert_filter_count_threshold",
    [
      "filters",
      0,
      [
        2,
        [
          1,
          [
            "issue_type",
            "score_weight",
            "default_enabled",
            "default_alert_confidence_threshold",
            "alert_confidence_threshold"
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProtoGuardConfigSetAlertFilterCountThresholdBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceProtoGuardConfigUpdateFilterOutput = /* @__PURE__ */ mapObject(
  [
    "alert_filter_count_threshold",
    [
      "filters",
      0,
      [
        2,
        [
          1,
          [
            "issue_type",
            "score_weight",
            "default_enabled",
            "default_alert_confidence_threshold",
            "alert_confidence_threshold"
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProtoGuardConfigUpdateFilterBody = /* @__PURE__ */ mapObject(
  ["alert_confidence_threshold"]
);
var mapManagementInstanceProviderAuthConfigErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "auth_config_event_id",
    "provider_auth_config_id",
    "provider_auth_credentials_id",
    "provider_oauth_setup_id",
    "provider_id",
    "provider_invocation_id",
    "group_id",
    "similar_error_count",
    "created_at"
  ],
  1
);
var mapManagementInstanceProviderAuthConfigErrorsGroupsGetOutput = /* @__PURE__ */ mapObject(
  ["provider_id", "occurrence_count", "created_at"],
  1
);
var mapManagementInstanceProviderAuthConfigErrorsGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["provider_id", "occurrence_count", "created_at"]]],
  1
);
var mapManagementInstanceProviderAuthConfigErrorsGroupsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderAuthConfigErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "auth_config_event_id",
        "provider_auth_config_id",
        "provider_auth_credentials_id",
        "provider_oauth_setup_id",
        "provider_id",
        "provider_invocation_id",
        "group_id",
        "similar_error_count",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderAuthConfigErrorsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "auth_config_event_id",
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            "provider_oauth_setup_id",
            "provider_id",
            "provider_auth_config_error_group_id",
            "provider_invocation_id",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderAuthConfigEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "source_type",
    "source_id",
    "provider_auth_config_id",
    "provider_auth_credentials_id",
    "provider_oauth_setup_id",
    "provider_id",
    "provider_auth_error_id",
    "provider_invocation_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderAuthConfigEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "source_type",
        "source_id",
        "provider_auth_config_id",
        "provider_auth_credentials_id",
        "provider_oauth_setup_id",
        "provider_id",
        "provider_auth_error_id",
        "provider_invocation_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderAuthConfigEventsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            "provider_oauth_setup_id",
            "provider_id",
            "provider_invocation_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderCategoriesGetOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstanceProviderCategoriesListOutput = /* @__PURE__ */ createMapper([
  7,
  8
]);
var mapManagementInstanceProviderCategoriesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "provider_listing_id"]]]]
]);
var mapManagementInstanceProviderCollectionsGetOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstanceProviderCollectionsListOutput = /* @__PURE__ */ createMapper(
  [7, 8]
);
var mapManagementInstanceProviderCollectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "provider_listing_id"]]]]
]);
var mapManagementInstanceProviderDeploymentsAuthConfigsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsCreateBody = /* @__PURE__ */ mapObject(
  ["tool_filters", "provider_auth_method_id", "provider_deployment_id"]
);
var mapManagementInstanceProviderDeploymentsAuthConfigsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsExportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsExportsCreateBody = /* @__PURE__ */ mapObject(
  ["provider_auth_config_id"]
);
var mapManagementInstanceProviderDeploymentsAuthConfigsExportsGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsExportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_agent",
        [
          "auth_config",
          1,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "provider_id",
        "provider_deployment_id",
        "auth_method_id",
        "credentials_id",
        "created_at",
        "expires_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsExportsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_credentials_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsAuthConfigsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsImportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsImportsCreateBody = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_auth_config_id",
    "provider_auth_method_id"
  ]
);
var mapManagementInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput = /* @__PURE__ */ mapObject(
  ["specification_id", "provider_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_auth_config_id",
    "provider_auth_method_id"
  ]
);
var mapManagementInstanceProviderDeploymentsAuthConfigsImportsGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsImportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_agent",
        [
          "auth_config",
          1,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "provider_id",
        "provider_deployment_id",
        "auth_method_id",
        "credentials_id",
        "created_at",
        "expires_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsImportsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_credentials_id",
            "provider_auth_config_id",
            "provider_deployment_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsAuthConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "available_for_use",
            "available_for_provider_deployment_id",
            "provider_auth_credentials_id",
            "provider_auth_method_id",
            "actor_id",
            "consumer_id",
            "identity_id",
            "identity_credential_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsAuthConfigsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthConfigsUpdateBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsCreateBody = /* @__PURE__ */ mapObject(
  ["provider_id", ["config", 0, [1, ["client_id", "client_secret"]]]]
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsGetOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      ["is_default", "is_managed", "provider_id", "created_at", "updated_at"]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_auth_method_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsUpdateOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderDeploymentsAuthCredentialsUpdateBody = /* @__PURE__ */ mapObject(
  ["client_id", "client_secret"]
);
var mapManagementInstanceProviderDeploymentsConfigVaultsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigVaultsCreateBody = /* @__PURE__ */ mapObject(
  ["provider_id", "provider_deployment_id"]
);
var mapManagementInstanceProviderDeploymentsConfigVaultsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigVaultsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigVaultsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigVaultsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_config_vault_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsConfigVaultsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigVaultsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceProviderDeploymentsConfigsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigsCreateBody = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "tool_filters",
            "provider_config_vault_id"
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsConfigsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigsGetConfigSchemaOutput = /* @__PURE__ */ mapObject(
  ["specification_id", "provider_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderDeploymentsConfigsGetConfigSchemaQuery = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_config_id",
    "provider_version_id",
    "provider_deployment_id"
  ]
);
var mapManagementInstanceProviderDeploymentsConfigsGetValueOutput = /* @__PURE__ */ mapObject(
  ["provider_config_id"]
);
var mapManagementInstanceProviderDeploymentsConfigsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "specification_id",
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "from_vault",
                1,
                [
                  1,
                  [
                    "provider_id",
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_specification_id",
            "provider_deployment_id",
            "available_for_use",
            "available_for_provider_deployment_id",
            "provider_config_vault_id",
            "actor_id",
            "consumer_id",
            "identity_id",
            "identity_credential_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsConfigsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsConfigsUpdateBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapManagementInstanceProviderDeploymentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsCreateBody = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "tool_filters",
            "provider_id",
            "locked_provider_version_id",
            "provider_config_id",
            [
              "provider_config",
              1,
              [3, [[0, [1, ["provider_config_vault_id"]]]]]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        [
          "locked_version",
          1,
          [
            1,
            [
              "provider_id",
              "is_current",
              "specification_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "default_config",
          1,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "identity_credential_id",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ],
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceProviderDeploymentsSetupSessionsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsSetupSessionsCreateBody = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_auth_method_id",
    "provider_auth_credentials_id",
    "identity_id",
    "consumer_id",
    "redirect_url",
    [
      "configuration",
      0,
      [
        1,
        [
          [
            "provider_search",
            1,
            [
              1,
              [
                ["groups", 0, [2, [1, ["group_id"]]]],
                ["collections", 0, [2, [1, ["collection_id"]]]],
                ["categories", 0, [2, [1, ["category_id"]]]]
              ]
            ]
          ],
          "tool_filters"
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsSetupSessionsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsSetupSessionsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsSetupSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_id",
              "identity_id",
              "identity_credential_id",
              ["owner_actor", 1, [1, ["consumer_id"]]],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_config",
                1,
                [
                  1,
                  [
                    "is_default",
                    "provider_id",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "credentials",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "is_managed",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "auth_method",
                      1,
                      [
                        1,
                        [
                          "input_schema",
                          "output_schema",
                          "provider_id",
                          "provider_specification_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["owner_actor", 1, [1, ["consumer_id"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [
                  1,
                  [
                    "is_default",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    "provider_id",
                    "specification_id",
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "from_vault",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["owner_actor", 1, [1, ["consumer_id"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "ui_mode",
              "redirect_url",
              "created_at",
              "updated_at",
              "expires_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsSetupSessionsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_deployment_id",
            "provider_auth_method_id",
            "provider_auth_config_id",
            "provider_auth_credentials_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderDeploymentsSetupSessionsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderDeploymentsSetupSessionsUpdateBody = /* @__PURE__ */ mapObject(
  ["identity_id"]
);
var mapManagementInstanceProviderDeploymentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderDeploymentsUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters",
  "locked_provider_version_id"
]);
var mapManagementInstanceProviderGroupsAddListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstanceProviderGroupsAddListingBody = /* @__PURE__ */ mapObject([
  "provider_listing_id"
]);
var mapManagementInstanceProviderGroupsCreateOutput = /* @__PURE__ */ createMapper(8);
var mapManagementInstanceProviderGroupsCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceProviderGroupsGetOutput = /* @__PURE__ */ createMapper(8);
var mapManagementInstanceProviderGroupsListOutput = /* @__PURE__ */ createMapper([
  7,
  8
]);
var mapManagementInstanceProviderGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_listing_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceProviderGroupsRemoveListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapManagementInstanceProviderGroupsUpdateOutput = /* @__PURE__ */ createMapper(8);
var mapManagementInstanceProviderGroupsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceProviderInvocationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_run_ids",
    "session_message_ids",
    "callback_event_ids",
    "auth_config_event_ids",
    "provider_oauth_setup_ids",
    "tool_call_id",
    "request_traces",
    ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]],
    "created_at"
  ],
  1
);
var mapManagementInstanceProviderInvocationsListOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "provider_run_ids",
            "session_message_ids",
            "callback_event_ids",
            "auth_config_event_ids",
            "provider_oauth_setup_ids",
            "tool_call_id",
            "request_traces",
            ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]],
            "created_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderInvocationsListQuery = /* @__PURE__ */ mapObject([
  "provider_run_id",
  "session_message_id",
  "chat_event_id",
  "callback_event_id",
  "auth_config_event_id"
]);
var mapManagementInstanceProviderListingsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderListingsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "attributes",
                0,
                [
                  1,
                  [
                    "is_public",
                    "is_customized",
                    "is_metorial",
                    "is_verified",
                    "is_official"
                  ]
                ]
              ],
              "image_url",
              [
                "provider",
                0,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          [
                            "publisher",
                            0,
                            [1, ["image_url", "created_at", "updated_at"]]
                          ],
                          [
                            "current_version",
                            1,
                            [
                              1,
                              [
                                "provider_id",
                                "is_current",
                                "specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "oauth",
                            0,
                            [1, ["callback_url", "auto_registration"]]
                          ],
                          "created_at",
                          "updated_at",
                          [
                            "type",
                            0,
                            [
                              1,
                              [
                                [
                                  "triggers",
                                  0,
                                  [3, [[0, [1, ["webhook_registration"]]]]]
                                ],
                                [
                                  "auth",
                                  0,
                                  [
                                    3,
                                    [
                                      [
                                        0,
                                        [
                                          1,
                                          [
                                            [
                                              "oauth",
                                              0,
                                              [
                                                3,
                                                [
                                                  [
                                                    0,
                                                    [
                                                      1,
                                                      [
                                                        "oauth_callback_url",
                                                        "oauth_auto_registration"
                                                      ]
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              ["categories", 0, [2, 8]],
              ["collections", 0, [2, 8]],
              ["groups", 0, [2, 8]],
              "created_at",
              "updated_at",
              ["docs", 0, [1, ["auth_methods"]]]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderListingsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_category_id",
          "provider_collection_id",
          "provider_group_id",
          "publisher_id",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ],
          "is_public",
          "only_from_tenant",
          "is_verified",
          "is_official",
          "is_metorial",
          "order_by_rank",
          "order_by_use",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceProviderListingsResetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderListingsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderListingsUpdateBody = /* @__PURE__ */ mapObject([
  "image_url",
  "provider_category_ids",
  "provider_collection_ids"
]);
var mapManagementInstanceProviderRunsGetLogsOutput = /* @__PURE__ */ mapObject([
  "provider_run_id",
  ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]]
]);
var mapManagementInstanceProviderRunsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "session_provider_id",
    "provider_id",
    "connection_id",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProviderRunsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "session_provider_id",
        "provider_id",
        "connection_id",
        "completed_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderRunsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "provider_id",
          "session_provider_id",
          "session_connection_id",
          "provider_version_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceProviderSpecificationChangeNotificationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_version_id",
    ["from_specification", 1, 8],
    ["to_specification", 1, 8],
    ["from_provider_version", 1, 8],
    ["to_provider_version", 1, 8],
    "created_at"
  ],
  1
);
var mapManagementInstanceProviderSpecificationChangeNotificationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "provider_version_id",
        ["from_specification", 1, 8],
        ["to_specification", 1, 8],
        ["from_provider_version", 1, 8],
        ["to_provider_version", 1, 8],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProviderSpecificationChangeNotificationsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_version_id",
            "provider_specification_id",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProviderTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderTemplatesCreateBody = /* @__PURE__ */ mapObject([
  "integration_id"
]);
var mapManagementInstanceProviderTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderTemplatesGetOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderTemplatesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["integration_id", "created_at", "updated_at"]]],
  1
);
var mapManagementInstanceProviderTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["integration_id"]]]]
]);
var mapManagementInstanceProviderTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceProviderTemplatesUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceProvidersAuthMethodsGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    "provider_id",
    "provider_specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProvidersAuthMethodsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        "provider_id",
        "provider_specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProvidersAuthMethodsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["provider_version_id"]]]]]
);
var mapManagementInstanceProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["publisher", 0, [1, ["image_url", "created_at", "updated_at"]]],
            [
              "current_version",
              1,
              [
                1,
                [
                  "provider_id",
                  "is_current",
                  "specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
            "created_at",
            "updated_at",
            [
              "type",
              0,
              [
                1,
                [
                  ["triggers", 0, [3, [[0, [1, ["webhook_registration"]]]]]],
                  [
                    "auth",
                    0,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              [
                                "oauth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          "oauth_callback_url",
                                          "oauth_auto_registration"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "publisher",
                0,
                [1, ["image_url", "created_at", "updated_at"]]
              ],
              [
                "current_version",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "is_current",
                    "specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
              "created_at",
              "updated_at",
              [
                "type",
                0,
                [
                  1,
                  [
                    [
                      "triggers",
                      0,
                      [3, [[0, [1, ["webhook_registration"]]]]]
                    ],
                    [
                      "auth",
                      0,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                [
                                  "oauth",
                                  0,
                                  [
                                    3,
                                    [
                                      [
                                        0,
                                        [
                                          1,
                                          [
                                            "oauth_callback_url",
                                            "oauth_auto_registration"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "auth_method",
          "auth_setup",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceProvidersSpecificationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "config_schema",
    "config_visibility",
    [
      "tools",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    ["tool_categories", 1, [2, [1, ["image_url", "tool_count"]]]],
    [
      "auth_methods",
      1,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            "provider_id",
            "provider_specification_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProvidersSpecificationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "config_schema",
        "config_visibility",
        [
          "tools",
          0,
          [
            2,
            [
              1,
              [
                "input_schema",
                "output_schema",
                ["tags", 0, [1, ["read_only"]]],
                "tool_category_keys",
                "specification_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        ["tool_categories", 1, [2, [1, ["image_url", "tool_count"]]]],
        [
          "auth_methods",
          1,
          [
            2,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProvidersSpecificationsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_version_id",
            "provider_deployment_id",
            "provider_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceProvidersToolsGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    ["tags", 0, [1, ["read_only"]]],
    "tool_category_keys",
    "specification_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProvidersToolsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        ["tags", 0, [1, ["read_only"]]],
        "tool_category_keys",
        "specification_id",
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProvidersToolsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id", "provider_auth_method_id"]]]]
]);
var mapManagementInstanceProvidersTriggersGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    [
      "invocation",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              ["interval_seconds", "auto_registration", "auto_unregistration"]
            ]
          ]
        ]
      ]
    ],
    "provider_id",
    "provider_specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProvidersTriggersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        [
          "invocation",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    "interval_seconds",
                    "auto_registration",
                    "auto_unregistration"
                  ]
                ]
              ]
            ]
          ]
        ],
        "provider_id",
        "provider_specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProvidersTriggersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id"]]]]
]);
var mapManagementInstanceProvidersVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "is_current",
    "specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceProvidersVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "is_current",
        "specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceProvidersVersionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapManagementInstancePublicMcpServersClientsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "client_id",
              "client_uri",
              "logo_uri",
              "redirect_uris",
              "token_endpoint_auth_method",
              "last_used_at",
              "expires_at",
              "created_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstancePublicMcpServersClientsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePublicMcpServersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePublicMcpServersCreateBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "tool_filters",
  "redirect_uri_filters",
  "max_active_grants",
  "access_token_ttl_seconds",
  "refresh_token_ttl_seconds",
  "grant_idle_expiry_seconds"
]);
var mapManagementInstancePublicMcpServersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePublicMcpServersGetOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePublicMcpServersGrantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "revoked_reason",
    "public_mcp_server_id",
    ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
    "last_used_at",
    "revoked_at",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePublicMcpServersGrantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "revoked_reason",
        "public_mcp_server_id",
        ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
        "last_used_at",
        "revoked_at",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstancePublicMcpServersGrantsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, [["created_at", 1, 5]]]]]]
);
var mapManagementInstancePublicMcpServersGrantsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "revoked_reason",
    "public_mcp_server_id",
    ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
    "last_used_at",
    "revoked_at",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePublicMcpServersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connect_url",
        "alternate_connect_urls",
        "provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "redirect_uri_filters",
        "max_active_grants",
        "access_token_ttl_seconds",
        "refresh_token_ttl_seconds",
        "grant_idle_expiry_seconds",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        "disabled_at",
        "archived_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstancePublicMcpServersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["provider_deployment_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapManagementInstancePublicMcpServersSlugsCheckOutput = /* @__PURE__ */ mapObject(
  ["is_available"]
);
var mapManagementInstancePublicMcpServersSlugsCheckQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstancePublicMcpServersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstancePublicMcpServersUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters",
  "redirect_uri_filters",
  "max_active_grants",
  "access_token_ttl_seconds",
  "refresh_token_ttl_seconds",
  "grant_idle_expiry_seconds"
]);
var mapManagementInstancePublishersGetOutput = /* @__PURE__ */ mapObject(
  ["image_url", "created_at", "updated_at"],
  1
);
var mapManagementInstancePublishersListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["image_url", "created_at", "updated_at"]]],
  1
);
var mapManagementInstancePublishersListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSandboxDisksCloneOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksCloneBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSandboxDisksCreateOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksCreateBody = /* @__PURE__ */ mapObject([
  "size_bytes"
]);
var mapManagementInstanceSandboxDisksDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksGetOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "size_bytes",
        ["machine", 0, [1, ["mount_path"]]],
        ["active_resize", 1, [1, ["target_size_bytes"]]],
        "created_at",
        "updated_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxDisksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_id"]]]]
]);
var mapManagementInstanceSandboxDisksMountsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "disk_id",
        "machine_id",
        "machine_instance_id",
        "mount_path",
        "mounted_at",
        "released_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxDisksMountsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSandboxDisksResizeOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksResizeBody = /* @__PURE__ */ mapObject([
  "size_bytes"
]);
var mapManagementInstanceSandboxDisksResizesGetOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksResizesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "disk_id",
        "original_size_bytes",
        "target_size_bytes",
        "machine_ids",
        "created_at",
        "updated_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxDisksResizesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSandboxDisksResizesRetryOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxDisksUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSandboxImageBuildsCancelOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceSandboxImageBuildsGetOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceSandboxImageBuildsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_id",
        "version_id",
        "version_number",
        "file_id",
        "dockerfile_path",
        "context_path",
        "build_arg_names",
        "timeout_seconds",
        "disk_size_bytes",
        "has_logs",
        "context_uploaded_at",
        "built_at",
        "ended_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxImageBuildsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_id", "image_version_id"]]]]
]);
var mapManagementInstanceSandboxImageBuildsLogsOutput = /* @__PURE__ */ mapObject([
  ["lines", 0, [2, [1, [["timestamp", 0, 4]]]]],
  "next_cursor",
  "has_more",
  "line_count"
]);
var mapManagementInstanceSandboxImageBuildsLogsQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSandboxImagesBuildsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceSandboxImagesBuildsCreateBody = /* @__PURE__ */ mapObject([
  "file_id",
  "dockerfile_path",
  "context_path",
  "build_args",
  "timeout_seconds",
  "disk_size_bytes"
]);
var mapManagementInstanceSandboxImagesBuildsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_id",
        "version_id",
        "version_number",
        "file_id",
        "dockerfile_path",
        "context_path",
        "build_arg_names",
        "timeout_seconds",
        "disk_size_bytes",
        "has_logs",
        "context_uploaded_at",
        "built_at",
        "ended_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxImagesBuildsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_version_id"]]]]
]);
var mapManagementInstanceSandboxImagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxImagesCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSandboxImagesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxImagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxImagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "latest_version_id",
        "latest_version_number",
        "created_at",
        "updated_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxImagesListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSandboxImagesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapManagementInstanceSandboxImagesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSandboxImagesVersionsGetOutput = /* @__PURE__ */ mapObject(
  ["image_id", "version_number", "build_id", "created_at", "updated_at"],
  1
);
var mapManagementInstanceSandboxImagesVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      ["image_id", "version_number", "build_id", "created_at", "updated_at"]
    ]
  ],
  1
);
var mapManagementInstanceSandboxImagesVersionsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSandboxMachinesAccessFilesOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapManagementInstanceSandboxMachinesAccessFilesBody = /* @__PURE__ */ mapObject([
  "ttl_seconds"
]);
var mapManagementInstanceSandboxMachinesAccessPortsOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapManagementInstanceSandboxMachinesAccessPortsBody = /* @__PURE__ */ mapObject([
  "ttl_seconds"
]);
var mapManagementInstanceSandboxMachinesAccessShellOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapManagementInstanceSandboxMachinesAccessShellBody = /* @__PURE__ */ mapObject([
  "ttl_seconds"
]);
var mapManagementInstanceSandboxMachinesCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesCreateBody = /* @__PURE__ */ mapObject([
  "image_id",
  "spec_id",
  "spec_identifier",
  "memory_gib",
  [
    "lifecycle_policy",
    1,
    [
      1,
      [
        "pause_after_idle_seconds",
        "hibernate_after_paused_seconds",
        "connection_idle_seconds"
      ]
    ]
  ],
  ["runtime", 0, [1, ["stop_signal"]]],
  ["lifecycle_hooks", 1, [2, [3, [[0, [1, ["timeout_seconds"]]]]]]],
  "ignore_image_hooks",
  "entrypoint_wait_seconds",
  ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
  "firewall_ids",
  "public_ports"
]);
var mapManagementInstanceSandboxMachinesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "machine_instance_id",
    "operation_id",
    "event_id",
    "exit_code",
    "duration_ms",
    "occurred_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "machine_instance_id",
        "operation_id",
        "event_id",
        "exit_code",
        "duration_ms",
        "occurred_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxMachinesErrorsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["machine_instance_id"]]]]]
);
var mapManagementInstanceSandboxMachinesEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "machine_instance_id",
    ["machine", 0, [1, ["from_status", "to_status"]]],
    ["instance", 0, [1, ["from_status", "to_status"]]],
    "operation_id",
    "guest_error_id",
    "occurred_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "machine_instance_id",
        ["machine", 0, [1, ["from_status", "to_status"]]],
        ["instance", 0, [1, ["from_status", "to_status"]]],
        "operation_id",
        "guest_error_id",
        "occurred_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxMachinesEventsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["machine_instance_id"]]]]]
);
var mapManagementInstanceSandboxMachinesExecOutput = /* @__PURE__ */ mapObject([
  "exit_code",
  "timed_out",
  "stdout_truncated",
  "stderr_truncated"
]);
var mapManagementInstanceSandboxMachinesExecBody = /* @__PURE__ */ mapObject([
  "timeout_seconds"
]);
var mapManagementInstanceSandboxMachinesGetOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesHibernateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "creation_reason",
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["operation", 0, [1, ["requested_at"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "disks_ready",
    [
      "runtime",
      0,
      [
        1,
        [
          ["setup", 0, [2, [1, ["exit_code", "duration_ms"]]]],
          ["entrypoint", 0, [1, ["started_after_ms", "exit_code"]]]
        ]
      ]
    ],
    "has_logs",
    "created_at",
    "started_at",
    "ready_at",
    "paused_at",
    "terminated_at",
    "last_seen_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "creation_reason",
        ["image", 0, [1, ["version_id"]]],
        ["spec", 0, [1, ["memory_gib"]]],
        ["operation", 0, [1, ["requested_at"]]],
        ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
        "disks_ready",
        [
          "runtime",
          0,
          [
            1,
            [
              ["setup", 0, [2, [1, ["exit_code", "duration_ms"]]]],
              ["entrypoint", 0, [1, ["started_after_ms", "exit_code"]]]
            ]
          ]
        ],
        "has_logs",
        "created_at",
        "started_at",
        "ready_at",
        "paused_at",
        "terminated_at",
        "last_seen_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxMachinesInstancesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSandboxMachinesInstancesLogsOutput = /* @__PURE__ */ mapObject(
  [
    ["lines", 0, [2, [1, [["timestamp", 0, 4]]]]],
    "next_cursor",
    "has_more",
    "line_count"
  ]
);
var mapManagementInstanceSandboxMachinesInstancesLogsQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSandboxMachinesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["image", 0, [1, ["version_id"]]],
        ["spec", 0, [1, ["memory_gib"]]],
        ["max_boost", 1, [1, ["memory_gib"]]],
        ["root_disk", 1, [1, ["size_bytes"]]],
        ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
        "firewall_ids",
        "public_ports",
        [
          "lifecycle_policy",
          1,
          [
            1,
            [
              "pause_after_idle_seconds",
              "hibernate_after_paused_seconds",
              "connection_idle_seconds"
            ]
          ]
        ],
        ["runtime", 0, [1, ["stop_signal"]]],
        ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
        "ignore_image_hooks",
        "entrypoint_wait_seconds",
        ["operation", 0, [1, ["requested_at"]]],
        "current_instance",
        "restart_required",
        "last_activity_at",
        "pause_at",
        "hibernates_at",
        ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
        "created_at",
        "running_at",
        "paused_at",
        "hibernated_at",
        "terminated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxMachinesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_id"]]]]
]);
var mapManagementInstanceSandboxMachinesOperationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "from_machine_instance_id",
    "superseded_by_id",
    ["instance_operations", 1, [2, [1, ["machine_instance_id"]]]],
    "requested_at",
    "completed_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesOperationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "from_machine_instance_id",
        "superseded_by_id",
        ["instance_operations", 1, [2, [1, ["machine_instance_id"]]]],
        "requested_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSandboxMachinesOperationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["machine_instance_id"]]]]]
);
var mapManagementInstanceSandboxMachinesPauseOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesRestartOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesStartOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesTouchOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapManagementInstanceSandboxMachinesUpdateBody = /* @__PURE__ */ mapObject([
  "spec_id",
  "spec_identifier",
  "memory_gib",
  [
    "lifecycle_policy",
    1,
    [
      1,
      [
        "pause_after_idle_seconds",
        "hibernate_after_paused_seconds",
        "connection_idle_seconds"
      ]
    ]
  ],
  ["runtime", 0, [1, ["stop_signal"]]],
  ["lifecycle_hooks", 1, [2, [3, [[0, [1, ["timeout_seconds"]]]]]]],
  "ignore_image_hooks",
  "entrypoint_wait_seconds",
  ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
  "firewall_ids",
  "public_ports"
]);
var mapManagementInstanceSandboxMachinesUsageSummaryOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    ["from", 0, 4],
    ["to", 0, 4],
    "group_by",
    [
      "groups",
      0,
      [
        2,
        [
          1,
          [
            ["group", 0, [1, ["machine_instance_id"]]],
            [
              "totals",
              0,
              [
                1,
                [
                  "runtime_seconds",
                  "cpu_core_seconds",
                  "average_cores_used",
                  "cpu_percent",
                  "peak_cores_used",
                  "memory_byte_seconds",
                  "average_memory_used_bytes",
                  "peak_memory_used_bytes",
                  "allocated_memory_byte_seconds",
                  "average_memory_allocated_bytes",
                  "network_rx_bytes",
                  "network_tx_bytes",
                  "disk_read_bytes",
                  "disk_write_bytes"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceSandboxMachinesUsageSummaryQuery = /* @__PURE__ */ mapObject(
  [
    ["from", 0, 4],
    ["to", 0, 4],
    "machine_instance_id",
    "group_by",
    "max_series"
  ]
);
var mapManagementInstanceSandboxMachinesUsageTimelineOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    ["from", 0, 4],
    ["to", 0, 4],
    "group_by",
    [
      "series",
      0,
      [
        2,
        [
          1,
          [
            ["group", 0, [1, ["machine_instance_id"]]],
            [
              "points",
              0,
              [
                2,
                [
                  1,
                  [
                    ["timestamp", 0, 4],
                    "runtime_seconds",
                    "cpu_core_seconds",
                    "average_cores_used",
                    "cpu_percent",
                    "peak_cores_used",
                    "memory_byte_seconds",
                    "average_memory_used_bytes",
                    "peak_memory_used_bytes",
                    "allocated_memory_byte_seconds",
                    "average_memory_allocated_bytes",
                    "network_rx_bytes",
                    "network_tx_bytes",
                    "disk_read_bytes",
                    "disk_write_bytes"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceSandboxMachinesUsageTimelineQuery = /* @__PURE__ */ mapObject(
  [
    ["from", 0, 4],
    ["to", 0, 4],
    "machine_instance_id",
    "group_by",
    "max_series"
  ]
);
var mapManagementInstanceSandboxMachinesUsageOutput = /* @__PURE__ */ createMapper([
  7,
  [
    1,
    [
      "machine_instance_id",
      ["timestamp", 0, 4],
      "cpu_percent",
      "cores_used",
      "cores_available",
      "memory_used_bytes",
      "memory_total_bytes",
      "network_rx_bytes",
      "network_tx_bytes",
      "disk_read_bytes",
      "disk_write_bytes"
    ]
  ]
]);
var mapManagementInstanceSandboxMachinesUsageQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_instance_id"]]]]
]);
var mapManagementInstanceSandboxRegionsGetOutput = /* @__PURE__ */ mapObject([
  "is_default"
]);
var mapManagementInstanceSandboxRegionsListOutput = /* @__PURE__ */ createMapper([
  7,
  [1, ["is_default"]]
]);
var mapManagementInstanceSandboxRegionsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSandboxSpecsGetOutput = /* @__PURE__ */ mapObject(
  ["memory_gib", "created_at"],
  1
);
var mapManagementInstanceSandboxSpecsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["memory_gib", "created_at"]]],
  1
);
var mapManagementInstanceSandboxSpecsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceScmAccountsPreviewOutput = /* @__PURE__ */ mapObject([
  ["accounts", 0, [2, [1, ["external_id", "image_url"]]]]
]);
var mapManagementInstanceScmAccountsPreviewBody = /* @__PURE__ */ mapObject([
  "installation_id"
]);
var mapManagementInstanceScmConnectionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "connection",
      0,
      [
        1,
        [
          "external_installation_id",
          "account_type",
          ["external_account", 1, [1, ["image_url"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapManagementInstanceScmConnectionsCreateBody = /* @__PURE__ */ mapObject([
  "redirect_url"
]);
var mapManagementInstanceScmConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "external_installation_id",
    "account_type",
    ["external_account", 1, [1, ["image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceScmConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "external_installation_id",
        "account_type",
        ["external_account", 1, [1, ["image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceScmConnectionsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceScmInstallationCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "connection",
      0,
      [
        1,
        [
          "external_installation_id",
          "account_type",
          ["external_account", 1, [1, ["image_url"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapManagementInstanceScmInstallationCreateBody = /* @__PURE__ */ mapObject([
  "redirect_url"
]);
var mapManagementInstanceScmInstallationListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "external_installation_id",
        "account_type",
        ["external_account", 1, [1, ["image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceScmInstallationListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceScmProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "provider",
      0,
      [1, ["api_url", "web_url", "is_default", "created_at", "updated_at"]]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapManagementInstanceScmProvidersCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceScmProvidersGetOutput = /* @__PURE__ */ mapObject(
  ["api_url", "web_url", "is_default", "created_at", "updated_at"],
  1
);
var mapManagementInstanceScmProvidersListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["api_url", "web_url", "is_default", "created_at", "updated_at"]]],
  1
);
var mapManagementInstanceScmProvidersListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceScmReposCreateOutput = /* @__PURE__ */ mapObject(
  ["is_private", "default_branch", "created_at"],
  1
);
var mapManagementInstanceScmReposCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "installation_id",
          "external_repo_id",
          "external_account_id",
          "is_private"
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceScmReposGetOutput = /* @__PURE__ */ mapObject(
  ["is_private", "default_branch", "created_at"],
  1
);
var mapManagementInstanceScmReposListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["is_private", "default_branch", "created_at"]]],
  1
);
var mapManagementInstanceScmReposListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapManagementInstanceScmReposPreviewOutput = /* @__PURE__ */ mapObject([
  ["repos", 0, [2, [1, ["external_id"]]]],
  "next_cursor"
]);
var mapManagementInstanceScmReposPreviewBody = /* @__PURE__ */ mapObject([
  "installation_id",
  "external_account_id"
]);
var mapManagementInstanceSessionTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesCreateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters"
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesListToolsOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionTemplatesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_instance_id",
        "integration_instance_group_id",
        "identity_actor_id",
        "identity_id",
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "session_template_id",
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_config",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionTemplatesProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesProvidersCreateBody = /* @__PURE__ */ mapObject(
  [
    "session_template_id",
    "provider_deployment_id",
    "provider_config_id",
    "provider_config_vault_id",
    "provider_auth_config_id",
    "tool_filters"
  ]
);
var mapManagementInstanceSessionTemplatesProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "session_template_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "auth_config",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionTemplatesProvidersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "session_template_id",
            "provider_id",
            "provider_deployment_id",
            "provider_config_id",
            "provider_auth_config_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceSessionTemplatesProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesProvidersUpdateBody = /* @__PURE__ */ mapObject(
  ["tool_filters"]
);
var mapManagementInstanceSessionTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSessionsConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["mcp", 0, [1, ["protocol_version"]]],
    "session_id",
    [
      "participant",
      0,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    "has_errors",
    "has_warnings",
    "created_at",
    "last_message_at",
    "last_active_at"
  ],
  1
);
var mapManagementInstanceSessionsConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_state",
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        ["mcp", 0, [1, ["protocol_version"]]],
        "session_id",
        [
          "participant",
          0,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        "has_errors",
        "has_warnings",
        "created_at",
        "last_message_at",
        "last_active_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionsConnectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "connection_state",
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "session_id",
          "session_provider_id",
          "participant_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsCreateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [
      2,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "provider_deployment_id",
                [
                  "provider_deployment",
                  1,
                  [1, ["provider_id", "locked_provider_version_id"]]
                ],
                "provider_config_id",
                [
                  "provider_config",
                  1,
                  [3, [[0, [1, ["provider_config_vault_id", "provider_id"]]]]]
                ],
                "provider_auth_config_id",
                [
                  "provider_auth_config",
                  1,
                  [1, ["provider_auth_method_id", "provider_id"]]
                ],
                "session_template_id",
                "tool_filters"
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsErrorGroupsGetOutput = /* @__PURE__ */ mapObject(
  ["provider_id", "occurrence_count", "created_at"],
  1
);
var mapManagementInstanceSessionsErrorGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["provider_id", "occurrence_count", "created_at"]]],
  1
);
var mapManagementInstanceSessionsErrorGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["session_id", "provider_id"]]]]
]);
var mapManagementInstanceSessionsErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "provider_run_id",
    "connection_id",
    "group_id",
    "similar_error_count",
    "created_at"
  ],
  1
);
var mapManagementInstanceSessionsErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "provider_run_id",
        "connection_id",
        "group_id",
        "similar_error_count",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionsErrorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "session_error_group_id",
          "provider_run_id",
          "provider_id",
          "session_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    [
      "connection",
      0,
      [
        1,
        [
          "connection_state",
          [
            "usage",
            0,
            [
              1,
              [
                "total_productive_client_message_count",
                "total_productive_provider_message_count"
              ]
            ]
          ],
          ["mcp", 0, [1, ["protocol_version"]]],
          "session_id",
          [
            "participant",
            0,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          "has_errors",
          "has_warnings",
          "created_at",
          "last_message_at",
          "last_active_at"
        ]
      ]
    ],
    [
      "provider_run",
      1,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "provider_id",
          "connection_id",
          "completed_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "message",
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "connection_id",
          "provider_run_id",
          ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
          [
            "transport",
            0,
            [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
          ],
          [
            "tool_call",
            1,
            [
              1,
              [
                "tool_key",
                "session_id",
                "message_id",
                "session_provider_id",
                "connection_id",
                "provider_run_id",
                [
                  "sender_participant",
                  1,
                  [
                    1,
                    [
                      "provider_id",
                      "connection_type",
                      "agent_id",
                      "agent_instance_id",
                      "identity_actor_id",
                      "identity_id",
                      "agent_actor_id",
                      "agent_client_id",
                      "consumer_id",
                      "created_at"
                    ]
                  ]
                ],
                [
                  "responder_participant",
                  1,
                  [
                    1,
                    [
                      "provider_id",
                      "connection_type",
                      "agent_id",
                      "agent_instance_id",
                      "identity_actor_id",
                      "identity_id",
                      "agent_actor_id",
                      "agent_client_id",
                      "consumer_id",
                      "created_at"
                    ]
                  ]
                ],
                [
                  "tool",
                  0,
                  [
                    1,
                    [
                      "input_schema",
                      "output_schema",
                      ["tags", 0, [1, ["read_only"]]],
                      "tool_category_keys",
                      "specification_id",
                      "provider_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "error",
                  0,
                  [
                    1,
                    [
                      "session_id",
                      "provider_run_id",
                      "connection_id",
                      "group_id",
                      "similar_error_count",
                      "created_at"
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          [
            "sender_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "responder_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "error",
            0,
            [
              1,
              [
                "session_id",
                "provider_run_id",
                "connection_id",
                "group_id",
                "similar_error_count",
                "created_at"
              ]
            ]
          ],
          "created_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    ["warning", 0, [1, ["session_id", "connection_id", "created_at"]]],
    "created_at"
  ],
  1
);
var mapManagementInstanceSessionsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        [
          "connection",
          0,
          [
            1,
            [
              "connection_state",
              [
                "usage",
                0,
                [
                  1,
                  [
                    "total_productive_client_message_count",
                    "total_productive_provider_message_count"
                  ]
                ]
              ],
              ["mcp", 0, [1, ["protocol_version"]]],
              "session_id",
              [
                "participant",
                0,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              "has_errors",
              "has_warnings",
              "created_at",
              "last_message_at",
              "last_active_at"
            ]
          ]
        ],
        [
          "provider_run",
          1,
          [
            1,
            [
              "session_id",
              "session_provider_id",
              "provider_id",
              "connection_id",
              "completed_at",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "message",
          0,
          [
            1,
            [
              "session_id",
              "session_provider_id",
              "connection_id",
              "provider_run_id",
              [
                "hierarchy",
                0,
                [1, ["parent_message_id", "child_message_ids"]]
              ],
              [
                "transport",
                0,
                [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
              ],
              [
                "tool_call",
                1,
                [
                  1,
                  [
                    "tool_key",
                    "session_id",
                    "message_id",
                    "session_provider_id",
                    "connection_id",
                    "provider_run_id",
                    [
                      "sender_participant",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "connection_type",
                          "agent_id",
                          "agent_instance_id",
                          "identity_actor_id",
                          "identity_id",
                          "agent_actor_id",
                          "agent_client_id",
                          "consumer_id",
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "responder_participant",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "connection_type",
                          "agent_id",
                          "agent_instance_id",
                          "identity_actor_id",
                          "identity_id",
                          "agent_actor_id",
                          "agent_client_id",
                          "consumer_id",
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "tool",
                      0,
                      [
                        1,
                        [
                          "input_schema",
                          "output_schema",
                          ["tags", 0, [1, ["read_only"]]],
                          "tool_category_keys",
                          "specification_id",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "error",
                      0,
                      [
                        1,
                        [
                          "session_id",
                          "provider_run_id",
                          "connection_id",
                          "group_id",
                          "similar_error_count",
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              [
                "sender_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "responder_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "error",
                0,
                [
                  1,
                  [
                    "session_id",
                    "provider_run_id",
                    "connection_id",
                    "group_id",
                    "similar_error_count",
                    "created_at"
                  ]
                ]
              ],
              "created_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        ["warning", 0, [1, ["session_id", "connection_id", "created_at"]]],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionsEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "provider_run_id",
          "session_message_id",
          "session_error_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_state",
        "connection_url",
        "client_secret",
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                [
                  "usage",
                  0,
                  [
                    1,
                    [
                      "total_productive_client_message_count",
                      "total_productive_provider_message_count"
                    ]
                  ]
                ],
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "session_id",
                "from_template_id",
                "from_template_provider_id",
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_config",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "from_template_ids",
        "has_errors",
        "has_warnings",
        "identity_actor_id",
        "identity_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "session_template_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
    [
      "transport",
      0,
      [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
    ],
    [
      "tool_call",
      1,
      [
        1,
        [
          "tool_key",
          "session_id",
          "message_id",
          "session_provider_id",
          "connection_id",
          "provider_run_id",
          [
            "sender_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "responder_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "tool",
            0,
            [
              1,
              [
                "input_schema",
                "output_schema",
                ["tags", 0, [1, ["read_only"]]],
                "tool_category_keys",
                "specification_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "error",
            0,
            [
              1,
              [
                "session_id",
                "provider_run_id",
                "connection_id",
                "group_id",
                "similar_error_count",
                "created_at"
              ]
            ]
          ],
          "created_at"
        ]
      ]
    ],
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceSessionsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "session_provider_id",
        "connection_id",
        "provider_run_id",
        ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
        [
          "transport",
          0,
          [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
        ],
        [
          "tool_call",
          1,
          [
            1,
            [
              "tool_key",
              "session_id",
              "message_id",
              "session_provider_id",
              "connection_id",
              "provider_run_id",
              [
                "sender_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "responder_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "tool",
                0,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    ["tags", 0, [1, ["read_only"]]],
                    "tool_category_keys",
                    "specification_id",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "error",
                0,
                [
                  1,
                  [
                    "session_id",
                    "provider_run_id",
                    "connection_id",
                    "group_id",
                    "similar_error_count",
                    "created_at"
                  ]
                ]
              ],
              "created_at"
            ]
          ]
        ],
        [
          "sender_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "responder_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionsMessagesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "provider_run_id",
          "error_id",
          "participant_id",
          "parent_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "connection_type",
    "agent_id",
    "agent_instance_id",
    "identity_actor_id",
    "identity_id",
    "agent_actor_id",
    "agent_client_id",
    "consumer_id",
    "created_at"
  ],
  1
);
var mapManagementInstanceSessionsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "connection_type",
        "agent_id",
        "agent_instance_id",
        "identity_actor_id",
        "identity_id",
        "agent_actor_id",
        "agent_client_id",
        "consumer_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionsParticipantsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "agent_id",
            "actor_id",
            "consumer_id",
            "identity_id",
            "agent_instance_id",
            "session_id",
            "session_connection_id",
            "session_message_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceSessionsProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsProvidersCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "tool_filters",
          "provider_deployment_id",
          [
            "provider_deployment",
            1,
            [1, ["provider_id", "locked_provider_version_id"]]
          ],
          "provider_config_id",
          [
            "provider_config",
            1,
            [3, [[0, [1, ["provider_config_vault_id", "provider_id"]]]]]
          ],
          "provider_auth_config_id",
          [
            "provider_auth_config",
            1,
            [1, ["provider_auth_method_id", "provider_id"]]
          ]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "session_id",
        "from_template_id",
        "from_template_provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "auth_config",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSessionsProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_template_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSessionsProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsProvidersUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters"
]);
var mapManagementInstanceSessionsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSessionsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsAgentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsAgentsCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsAgentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsAgentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsAgentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        "store_id",
        "store_item_id",
        "document_id",
        "archived_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsAgentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["include_archived"]]]]
]);
var mapManagementInstanceSkillsAgentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsAgentsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsConfigurationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsConfigurationsCreateBody = /* @__PURE__ */ mapObject([
  "allow_scripts",
  "allowed_file_extensions",
  "allow_non_standard_directories"
]);
var mapManagementInstanceSkillsConfigurationsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsConfigurationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsConfigurationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        "allow_scripts",
        "allowed_file_extensions",
        "allow_non_standard_directories",
        "deleted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsConfigurationsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsConfigurationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsConfigurationsUpdateBody = /* @__PURE__ */ mapObject([
  "allow_scripts",
  "allowed_file_extensions",
  "allow_non_standard_directories"
]);
var mapManagementInstanceSkillsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsCreateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id",
  "template_id",
  "skill_group_id"
]);
var mapManagementInstanceSkillsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsDuplicateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsDuplicateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata"
]);
var mapManagementInstanceSkillsExportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "started_at",
    "completed_at"
  ],
  1
);
var mapManagementInstanceSkillsExportsCreateBody = /* @__PURE__ */ mapObject([
  "skill_id",
  "skill_plugin_id",
  "skill_marketplace_id"
]);
var mapManagementInstanceSkillsExportsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "started_at",
    "completed_at"
  ],
  1
);
var mapManagementInstanceSkillsExportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "file",
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "started_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsExportsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsFilesBatchOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "previous_path",
        [
          "file",
          0,
          [
            1,
            [
              "skill_id",
              "store_item_id",
              "document_id",
              "file_id",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsFilesBatchBody = /* @__PURE__ */ mapObject([
  ["changes", 0, [2, [3, [[0, [1, ["file_id", "if_match", "to_path"]]]]]]]
]);
var mapManagementInstanceSkillsFilesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsFilesDeleteQuery = /* @__PURE__ */ mapObject([
  "if_match"
]);
var mapManagementInstanceSkillsFilesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_item_id",
    "document_id",
    "file_id",
    "updated_at",
    "download_url"
  ],
  1
);
var mapManagementInstanceSkillsFilesGetQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsFilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [1, ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]]
  ],
  1
);
var mapManagementInstanceSkillsFilesMoveOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsFilesMoveBody = /* @__PURE__ */ mapObject([
  "to_path",
  "if_match"
]);
var mapManagementInstanceSkillsFilesPutOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsFilesPutBody = /* @__PURE__ */ mapObject([
  "file_id",
  "if_match"
]);
var mapManagementInstanceSkillsForkSyncsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "fork_skill_id",
    "upstream_skill_id",
    "merge_request_id",
    "processing_started_at",
    "action_required_at",
    "completed_at",
    "failed_at",
    "cancelled_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsForkSyncsCreateBody = /* @__PURE__ */ mapObject([
  "skill_id"
]);
var mapManagementInstanceSkillsForkSyncsGetOutput = /* @__PURE__ */ mapObject(
  [
    "fork_skill_id",
    "upstream_skill_id",
    "merge_request_id",
    "processing_started_at",
    "action_required_at",
    "completed_at",
    "failed_at",
    "cancelled_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsForkOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsForkBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id"
]);
var mapManagementInstanceSkillsGetOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsCreateBody = /* @__PURE__ */ mapObject([
  "skill_ids",
  "allow_consumer_skill_assignment"
]);
var mapManagementInstanceSkillsGroupsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsGetOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsItemsCreateBody = /* @__PURE__ */ mapObject([
  "skill_id"
]);
var mapManagementInstanceSkillsGroupsItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_group_id",
        [
          "skill",
          0,
          [
            1,
            [
              "image_url",
              "client_name",
              "client_description",
              "client_metadata",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsGroupsItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["skill_id", ["created_at", 1, 5]]]]]
]);
var mapManagementInstanceSkillsGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "allow_consumer_skill_assignment",
        [
          "skills",
          0,
          [
            2,
            [
              1,
              [
                "image_url",
                "client_name",
                "client_description",
                "client_metadata",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["skill_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapManagementInstanceSkillsGroupsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsGroupsUpdateBody = /* @__PURE__ */ mapObject([
  "skill_ids",
  "allow_consumer_skill_assignment"
]);
var mapManagementInstanceSkillsImportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "source",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "repository_url",
                "repository_name",
                "repository_id",
                "file_id",
                "file_name"
              ]
            ]
          ]
        ]
      ]
    ],
    ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsImportsCreateBody = /* @__PURE__ */ mapObject([
  [
    "source",
    0,
    [3, [[0, [1, ["repository_url", "repository_id", "file_id"]]]]]
  ]
]);
var mapManagementInstanceSkillsImportsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "source",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "repository_url",
                "repository_name",
                "repository_id",
                "file_id",
                "file_name"
              ]
            ]
          ]
        ]
      ]
    ],
    ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsImportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "source",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    "repository_url",
                    "repository_name",
                    "repository_id",
                    "file_id",
                    "file_name"
                  ]
                ]
              ]
            ]
          ]
        ],
        ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
        "started_at",
        "completed_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsImportsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsItemsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "integration_id"]]]]
]);
var mapManagementInstanceSkillsItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        [
          "integration",
          0,
          [
            1,
            [
              [
                "configuration",
                0,
                [
                  1,
                  [
                    "can_attach_custom_tool_filters",
                    "can_attach_custom_provider_config",
                    "can_override_tool_filters",
                    "enable_callback_tools",
                    "use_integration_name_in_tool_names"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        ["provider", 0, 8],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["integration_id", "provider_id", ["created_at", 1, 5]]]]]
]);
var mapManagementInstanceSkillsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_url",
        "client_name",
        "client_description",
        "client_metadata",
        "store_id",
        [
          "hierarchy",
          0,
          [
            1,
            [
              "parent_skill_id",
              [
                "creator",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              [
                "fork",
                0,
                [
                  1,
                  [
                    "parent_skill_id",
                    [
                      "creator",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          [
                            "organization_actor",
                            1,
                            [
                              1,
                              [
                                "organization_id",
                                "image_url",
                                [
                                  "teams",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        "assignment_id",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer",
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "user_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer_profile",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "consumer_id",
                                      "user_id",
                                      "created_at",
                                      "updated_at",
                                      [
                                        "groups",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              [
                                                "group",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "is_default",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "assigned_via"
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    [
                      "original_creator",
                      1,
                      [
                        1,
                        [
                          "image_url",
                          [
                            "organization_actor",
                            1,
                            [
                              1,
                              [
                                "organization_id",
                                "image_url",
                                [
                                  "teams",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        "assignment_id",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer",
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "user_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer_profile",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "consumer_id",
                                      "user_id",
                                      "created_at",
                                      "updated_at",
                                      [
                                        "groups",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              [
                                                "group",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "is_default",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "assigned_via"
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              [
                "entity",
                0,
                [1, ["parent_skill_id", "created_at", "updated_at"]]
              ]
            ]
          ]
        ],
        [
          "integrations",
          0,
          [
            2,
            [
              1,
              [
                [
                  "configuration",
                  0,
                  [
                    1,
                    [
                      "can_attach_custom_tool_filters",
                      "can_attach_custom_provider_config",
                      "can_override_tool_filters",
                      "enable_callback_tools",
                      "use_integration_name_in_tool_names"
                    ]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        ["providers", 0, [2, 8]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_group_id",
          "integration_id",
          "provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSkillsMarketplacesArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesCreateBody = /* @__PURE__ */ mapObject([
  "image_file_id",
  "skill_configuration_id",
  "repository_access_mode",
  "force_merge_or_push",
  "merge_before_checks_pass"
]);
var mapManagementInstanceSkillsMarketplacesGetEditorUrlOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapManagementInstanceSkillsMarketplacesGetEditorUrlBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsMarketplacesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "repository_access_mode",
              "force_merge_or_push",
              "merge_before_checks_pass",
              "sync_status",
              "image_url",
              "skill_configuration_id",
              [
                "plugins",
                0,
                [
                  2,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "skill_configuration_id",
                            "skill_marketplace_id",
                            [
                              "skill_plugin",
                              1,
                              [
                                3,
                                [
                                  [
                                    0,
                                    [
                                      1,
                                      [
                                        "sync_status",
                                        "image_url",
                                        "long_description",
                                        "skill_configuration_id",
                                        [
                                          "skills",
                                          0,
                                          [
                                            2,
                                            [
                                              1,
                                              [
                                                "client_name",
                                                "client_description",
                                                "client_metadata",
                                                "skill_configuration_id",
                                                "skill_id",
                                                [
                                                  "skill",
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "image_url",
                                                      "client_name",
                                                      "client_description",
                                                      "client_metadata",
                                                      "created_at",
                                                      "updated_at"
                                                    ]
                                                  ]
                                                ],
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ]
                                        ],
                                        "created_at",
                                        "updated_at",
                                        "can_update",
                                        "can_delete"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "can_create_plugins"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["skill_configuration_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapManagementInstanceSkillsMarketplacesPluginsAddOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesPluginsAddBody = /* @__PURE__ */ mapObject(
  ["skill_plugin_id", "skill_configuration_id"]
);
var mapManagementInstanceSkillsMarketplacesPluginsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesPluginsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "skill_configuration_id",
              "skill_marketplace_id",
              [
                "skill_plugin",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "sync_status",
                          "image_url",
                          "long_description",
                          "skill_configuration_id",
                          [
                            "skills",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  "client_name",
                                  "client_description",
                                  "client_metadata",
                                  "skill_configuration_id",
                                  "skill_id",
                                  [
                                    "skill",
                                    0,
                                    [
                                      1,
                                      [
                                        "image_url",
                                        "client_name",
                                        "client_description",
                                        "client_metadata",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesPluginsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_plugin_id",
            "skill_configuration_id",
            ["created_at", 1, 5],
            ["updated_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapManagementInstanceSkillsMarketplacesPluginsRemoveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesRepositoriesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesRepositoriesCreateBody = /* @__PURE__ */ mapObject(
  ["repo_id"]
);
var mapManagementInstanceSkillsMarketplacesRepositoriesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesRepositoriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesRepositoriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_marketplace_id",
        "repo_id",
        [
          "repository",
          0,
          [1, ["is_private", "default_branch", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesRepositoriesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsMarketplacesSyncOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesSyncBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsMarketplacesUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMarketplacesUpdateBody = /* @__PURE__ */ mapObject([
  "image_file_id",
  "skill_configuration_id",
  "repository_access_mode",
  "force_merge_or_push",
  "merge_before_checks_pass"
]);
var mapManagementInstanceSkillsMergeRequestsCloseOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsCommentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsCommentsCreateBody = /* @__PURE__ */ mapObject(
  ["item_id", "in_reply_to_comment_id"]
);
var mapManagementInstanceSkillsMergeRequestsCommentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsCommentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsCommentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_merge_request_item_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "in_reply_to_comment_id",
        "deleted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsCommentsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["item_id"]]]]]
);
var mapManagementInstanceSkillsMergeRequestsCommentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsCommentsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsMergeRequestsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsCreateBody = /* @__PURE__ */ mapObject([
  "source_skill_id",
  "target_skill_id"
]);
var mapManagementInstanceSkillsMergeRequestsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "comment",
      0,
      [
        1,
        [
          "skill_merge_request_item_id",
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "in_reply_to_comment_id",
          "deleted_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "error_code",
    "error_message",
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "comment",
          0,
          [
            1,
            [
              "skill_merge_request_item_id",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "in_reply_to_comment_id",
              "deleted_at",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "error_code",
        "error_message",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsEventsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, [["created_at", 1, 5]]]]]]
);
var mapManagementInstanceSkillsMergeRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsItemsBulkResolveOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_merge_request_id",
        "change_type",
        "resolution_type",
        "conflict_reason",
        [
          "resolved_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "resolved_at",
        "applied_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsItemsBulkResolveBody = /* @__PURE__ */ mapObject(
  [["items", 0, [2, [1, ["item_id", "resolution_type"]]]]]
);
var mapManagementInstanceSkillsMergeRequestsItemsResolveOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_id",
    "change_type",
    "resolution_type",
    "conflict_reason",
    [
      "resolved_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "resolved_at",
    "applied_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsItemsResolveBody = /* @__PURE__ */ mapObject(
  ["resolution_type"]
);
var mapManagementInstanceSkillsMergeRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "base_strategy",
        "merge_error",
        "merge_error_code",
        "source_skill_id",
        "target_skill_id",
        "base_target_skill_version_id",
        "requested_source_skill_version_id",
        "requested_target_skill_version_id",
        "pre_merge_target_skill_version_id",
        "merged_target_skill_version_id",
        "rollback_target_skill_version_id",
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "item_count",
        "comment_count",
        "merge_started_at",
        "merged_at",
        "closed_at",
        "rolled_back_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "source_skill_id",
          "target_skill_id",
          "created_by_actor_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSkillsMergeRequestsPerformOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsPlanGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "merge_request",
      1,
      [
        1,
        [
          "base_strategy",
          "merge_error",
          "merge_error_code",
          "source_skill_id",
          "target_skill_id",
          "base_target_skill_version_id",
          "requested_source_skill_version_id",
          "requested_target_skill_version_id",
          "pre_merge_target_skill_version_id",
          "merged_target_skill_version_id",
          "rollback_target_skill_version_id",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "item_count",
          "comment_count",
          "merge_started_at",
          "merged_at",
          "closed_at",
          "rolled_back_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "item",
              0,
              [
                1,
                [
                  "skill_merge_request_id",
                  "change_type",
                  "resolution_type",
                  "conflict_reason",
                  [
                    "resolved_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "resolved_at",
                  "applied_at",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "base",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "source",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "target",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "document_merge",
              1,
              [
                1,
                [
                  "base_content",
                  "source_content",
                  "target_content",
                  "has_conflict"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsMergeRequestsRollbackOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsParticipantsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsPluginsArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsCreateBody = /* @__PURE__ */ mapObject([
  "long_description",
  "image_file_id",
  "skill_configuration_id",
  "skill_marketplace_id"
]);
var mapManagementInstanceSkillsPluginsGetEditorUrlOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapManagementInstanceSkillsPluginsGetEditorUrlBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsPluginsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "sync_status",
              "image_url",
              "long_description",
              "skill_configuration_id",
              [
                "skills",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "client_name",
                      "client_description",
                      "client_metadata",
                      "skill_configuration_id",
                      "skill_id",
                      [
                        "skill",
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "client_name",
                            "client_description",
                            "client_metadata",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "can_update",
              "can_delete"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_marketplace_id",
          "skill_configuration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSkillsPluginsRepositoriesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsPluginsRepositoriesCreateBody = /* @__PURE__ */ mapObject(
  ["repo_id"]
);
var mapManagementInstanceSkillsPluginsRepositoriesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsPluginsRepositoriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsPluginsRepositoriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_plugin_id",
        "repo_id",
        [
          "repository",
          0,
          [1, ["is_private", "default_branch", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsRepositoriesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsPluginsSkillsAddOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsPluginsSkillsAddBody = /* @__PURE__ */ mapObject([
  "skill_id",
  "client_name",
  "client_description",
  "client_metadata",
  "skill_configuration_id"
]);
var mapManagementInstanceSkillsPluginsSkillsGetOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsPluginsSkillsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "client_name",
        "client_description",
        "client_metadata",
        "skill_configuration_id",
        "skill_id",
        [
          "skill",
          0,
          [
            1,
            [
              "image_url",
              "client_name",
              "client_description",
              "client_metadata",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsSkillsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_id",
          "skill_configuration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSkillsPluginsSkillsRemoveOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsPluginsSkillsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsPluginsSkillsUpdateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "skill_configuration_id"
]);
var mapManagementInstanceSkillsPluginsSyncOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsSyncBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsPluginsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsPluginsUpdateBody = /* @__PURE__ */ mapObject([
  "long_description",
  "image_file_id",
  "skill_configuration_id"
]);
var mapManagementInstanceSkillsPublishConsumerSkillOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsShareOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsShareBody = /* @__PURE__ */ mapObject([
  "consumer_profile_ids",
  "organization_member_ids"
]);
var mapManagementInstanceSkillsTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsTemplatesCreateBody = /* @__PURE__ */ mapObject([
  ["from_skill_Id", "fromSkillId"]
]);
var mapManagementInstanceSkillsTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsTemplatesGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsTemplatesItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsTemplatesItemsCreateBody = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["provider_id", "integration_id"]]]]]
);
var mapManagementInstanceSkillsTemplatesItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsTemplatesItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsTemplatesItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "integration",
          0,
          [
            1,
            [
              [
                "configuration",
                0,
                [
                  1,
                  [
                    "can_attach_custom_tool_filters",
                    "can_attach_custom_provider_config",
                    "can_override_tool_filters",
                    "enable_callback_tools",
                    "use_integration_name_in_tool_names"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        ["provider", 0, 8],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsTemplatesItemsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceSkillsTemplatesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        [
          "items",
          0,
          [
            2,
            [
              1,
              [
                [
                  "integration",
                  0,
                  [
                    1,
                    [
                      [
                        "configuration",
                        0,
                        [
                          1,
                          [
                            "can_attach_custom_tool_filters",
                            "can_attach_custom_provider_config",
                            "can_override_tool_filters",
                            "enable_callback_tools",
                            "use_integration_name_in_tool_names"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ],
                ["provider", 0, 8],
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "integration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceSkillsTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceSkillsUpdateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id"
]);
var mapManagementInstanceSkillsVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_version_id",
    "version_number",
    "created_at"
  ],
  1
);
var mapManagementInstanceSkillsVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        "store_id",
        "store_version_id",
        "version_number",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceSkillsVersionsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceSkillsVersionsSnapshotGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_version_id",
    "version_number",
    [
      "items",
      0,
      [
        2,
        [1, ["file_id", "document_id", "document_version_id", "created_at"]]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceStoresCreateOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapManagementInstanceStoresCreateBody = /* @__PURE__ */ mapObject([
  "template_id",
  "parent_id"
]);
var mapManagementInstanceStoresDeleteOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapManagementInstanceStoresGetOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapManagementInstanceStoresItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    "directory_id",
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "document",
      0,
      [
        1,
        [
          "file_id",
          "parent_document_id",
          "current_version_id",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementInstanceStoresItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        "directory_id",
        [
          "file",
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "document",
          0,
          [
            1,
            [
              "file_id",
              "parent_document_id",
              "current_version_id",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceStoresItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["file_id", "document_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapManagementInstanceStoresItemsModifyOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "store_id",
            "directory_id",
            [
              "file",
              0,
              [
                1,
                [
                  "file_name",
                  "file_size",
                  "file_type",
                  [
                    "created_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "document",
              0,
              [
                1,
                [
                  "file_id",
                  "parent_document_id",
                  "current_version_id",
                  [
                    "created_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementInstanceStoresItemsModifyBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceStoresListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["item_count", "created_at", "updated_at"]]],
  1
);
var mapManagementInstanceStoresListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceStoresParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceStoresParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceStoresParticipantsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementInstanceStoresPermissionsGetOutput = /* @__PURE__ */ mapObject([
  "store_id",
  "has_full_access",
  "relevant_store_ids",
  "readable_store_ids",
  "writable_store_ids"
]);
var mapManagementInstanceStoresUpdateOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapManagementInstanceStoresUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementInstanceToolCallsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "tool_key",
    "session_id",
    "message_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "tool",
      0,
      [
        1,
        [
          "input_schema",
          "output_schema",
          ["tags", 0, [1, ["read_only"]]],
          "tool_category_keys",
          "specification_id",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceToolCallsCreateBody = /* @__PURE__ */ mapObject([
  "tool_id",
  "session_id"
]);
var mapManagementInstanceToolCallsGetOutput = /* @__PURE__ */ mapObject(
  [
    "tool_key",
    "session_id",
    "message_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "tool",
      0,
      [
        1,
        [
          "input_schema",
          "output_schema",
          ["tags", 0, [1, ["read_only"]]],
          "tool_category_keys",
          "specification_id",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementInstanceToolCallsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "tool_key",
        "session_id",
        "message_id",
        "session_provider_id",
        "connection_id",
        "provider_run_id",
        [
          "sender_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "responder_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "tool",
          0,
          [
            1,
            [
              "input_schema",
              "output_schema",
              ["tags", 0, [1, ["read_only"]]],
              "tool_category_keys",
              "specification_id",
              "provider_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementInstanceToolCallsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_template_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "tool_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementInstanceWebhookRegistrationsCreateOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapManagementInstanceWebhookRegistrationsCreateBody = /* @__PURE__ */ mapObject([
  "provider_id"
]);
var mapManagementInstanceWebhookRegistrationsDeleteOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapManagementInstanceWebhookRegistrationsGetOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapManagementInstanceWebhookRegistrationsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["receive_url", ["provider", 0, 8], "created_at", "updated_at"]]],
  1
);
var mapManagementInstanceWebhookRegistrationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]]
);
var mapManagementInstanceWebhookRegistrationsSetupOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapManagementInstanceWebhookRegistrationsSetupBody = /* @__PURE__ */ mapObject([
  "user_config"
]);
var mapManagementInstanceWebhookRegistrationsUpdateOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapManagementInstanceWebhookRegistrationsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationAccessPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessPoliciesCreateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationAccessPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessPoliciesGetOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessPoliciesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["organization_id", "created_at", "updated_at"]]],
  1
);
var mapManagementOrganizationAccessPoliciesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationAccessPoliciesUpdateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessPoliciesUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationAccessPoliciesVersionsOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["access_policy_id", "created_at"]]],
  1
);
var mapManagementOrganizationAccessPoliciesVersionsQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationAccessRolesCreateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessRolesCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationAccessRolesDeleteOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessRolesGetOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessRolesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["organization_id", "is_admin", "created_at", "updated_at"]]],
  1
);
var mapManagementOrganizationAccessRolesListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationAccessRolesUpdateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "is_admin", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationAccessRolesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationAccessRolesVersionsOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [1, ["access_role_id", "scopes_added", "scopes_removed", "created_at"]]
  ],
  1
);
var mapManagementOrganizationAccessRolesVersionsQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationApiKeysCreateOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapManagementOrganizationApiKeysCreateBody = /* @__PURE__ */ mapObject(
  ["instance_id", "expires_at", "ip_filters"],
  1
);
var mapManagementOrganizationApiKeysGetOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapManagementOrganizationApiKeysListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "secret_redacted",
        "secret_redacted_long",
        "ip_filters",
        [
          "machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "deleted_at",
        "last_used_at",
        "expires_at",
        "created_at",
        "updated_at",
        ["reveal_info", 1, [1, [["until", 0, 4]]]]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationApiKeysListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["instance_id"]]]]
]);
var mapManagementOrganizationApiKeysRevealOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapManagementOrganizationApiKeysRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapManagementOrganizationApiKeysRotateOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapManagementOrganizationApiKeysRotateBody = /* @__PURE__ */ mapObject(
  ["current_expires_at"],
  1
);
var mapManagementOrganizationApiKeysUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "secret_redacted",
    "secret_redacted_long",
    "ip_filters",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "deleted_at",
    "last_used_at",
    "expires_at",
    "created_at",
    "updated_at",
    ["reveal_info", 1, [1, [["until", 0, 4]]]]
  ],
  1
);
var mapManagementOrganizationApiKeysUpdateBody = /* @__PURE__ */ mapObject(
  ["expires_at", "ip_filters"],
  1
);
var mapManagementOrganizationAuditLogStreamsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsCreateBody = /* @__PURE__ */ mapObject([
  "provider_data"
]);
var mapManagementOrganizationAuditLogStreamsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "audit_log_stream_id",
    [
      "error_details",
      1,
      [
        1,
        [
          "error_name",
          "http_status_code",
          "http_status_text",
          "provider_error_code",
          "response_body",
          "batch_identifier",
          "batch_number",
          "successful_batch_count",
          "event_count",
          "first_event_id",
          "last_event_id"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "audit_log_stream_id",
        [
          "error_details",
          1,
          [
            1,
            [
              "error_name",
              "http_status_code",
              "http_status_text",
              "provider_error_code",
              "response_body",
              "batch_identifier",
              "batch_number",
              "successful_batch_count",
              "event_count",
              "first_event_id",
              "last_event_id"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsEventsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationAuditLogStreamsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "access_status",
        "is_paused_due_to_error",
        "error_message",
        "consecutive_error_count",
        "is_started",
        "provider_data",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationAuditLogStreamsResumeOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "access_status",
    "is_paused_due_to_error",
    "error_message",
    "consecutive_error_count",
    "is_started",
    "provider_data",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationAuditLogStreamsUpdateBody = /* @__PURE__ */ mapObject([
  "provider_data"
]);
var mapManagementOrganizationAuditLogsGetOutput = /* @__PURE__ */ mapObject(
  [
    "event_id",
    "organization_id",
    "instance_id",
    "organization_actor_id",
    "previous_attributes",
    "recorded_at"
  ],
  1
);
var mapManagementOrganizationAuditLogsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "event_id",
        "organization_id",
        "instance_id",
        "organization_actor_id",
        "previous_attributes",
        "recorded_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationAuditLogsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationEventDeliveriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_id",
    "event_type",
    "event_destination_id",
    "attempt_count",
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "attempts",
      0,
      [
        2,
        [
          1,
          [
            "event_delivery_id",
            "event_id",
            "event_destination_id",
            "attempt_number",
            "duration_ms",
            "is_retryable",
            ["response", 0, [1, ["status_code", "is_body_truncated"]]],
            "started_at",
            "completed_at",
            "created_at"
          ]
        ]
      ]
    ],
    "last_attempt_at",
    "next_attempt_at",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationEventDeliveriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "instance_id",
        "event_id",
        "event_type",
        "event_destination_id",
        "attempt_count",
        [
          "retry",
          0,
          [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
        ],
        [
          "attempts",
          0,
          [
            2,
            [
              1,
              [
                "event_delivery_id",
                "event_id",
                "event_destination_id",
                "attempt_number",
                "duration_ms",
                "is_retryable",
                ["response", 0, [1, ["status_code", "is_body_truncated"]]],
                "started_at",
                "completed_at",
                "created_at"
              ]
            ]
          ]
        ],
        "last_attempt_at",
        "next_attempt_at",
        "completed_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationEventDeliveriesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [1, ["event_id", "event_type", "event_destination_id", "instance_id"]]
    ]
  ]
]);
var mapManagementOrganizationEventDeliveriesRetryOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_id",
    "event_type",
    "event_destination_id",
    "attempt_count",
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "attempts",
      0,
      [
        2,
        [
          1,
          [
            "event_delivery_id",
            "event_id",
            "event_destination_id",
            "attempt_number",
            "duration_ms",
            "is_retryable",
            ["response", 0, [1, ["status_code", "is_body_truncated"]]],
            "started_at",
            "completed_at",
            "created_at"
          ]
        ]
      ]
    ],
    "last_attempt_at",
    "next_attempt_at",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationEventDeliveryAttemptsGetOutput = /* @__PURE__ */ mapObject(
  [
    "event_delivery_id",
    "event_id",
    "event_destination_id",
    "attempt_number",
    "duration_ms",
    "is_retryable",
    ["response", 0, [1, ["status_code", "is_body_truncated"]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapManagementOrganizationEventDeliveryAttemptsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "event_delivery_id",
        "event_id",
        "event_destination_id",
        "attempt_number",
        "duration_ms",
        "is_retryable",
        ["response", 0, [1, ["status_code", "is_body_truncated"]]],
        "started_at",
        "completed_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationEventDeliveryAttemptsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["event_delivery_id", "event_id", "event_destination_id"]]]]]
);
var mapManagementOrganizationEventDestinationListenersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationListenersCreateBody = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "provider_id",
            "chat_connection_id"
          ]
        ]
      ]
    ]
  ]
);
var mapManagementOrganizationEventDestinationListenersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationListenersGetOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationListenersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "instance_id",
        "event_destination_id",
        "event_types",
        "callback_id",
        "chat_connection_id",
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationEventDestinationListenersListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "event_destination_id",
            "instance_id",
            "callback_id",
            "chat_connection_id",
            "provider_id"
          ]
        ]
      ]
    ]
  ]
);
var mapManagementOrganizationEventDestinationListenersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "instance_id",
    "event_destination_id",
    "event_types",
    "callback_id",
    "chat_connection_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationListenersUpdateBody = /* @__PURE__ */ mapObject(
  ["event_types"]
);
var mapManagementOrganizationEventDestinationsArchiveOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationsCreateBody = /* @__PURE__ */ mapObject([
  [
    "retry",
    0,
    [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
  ]
]);
var mapManagementOrganizationEventDestinationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        ["webhook", 0, [1, ["signing_secret"]]],
        [
          "retry",
          0,
          [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
        ],
        [
          "listeners",
          0,
          [
            2,
            [
              1,
              [
                "instance_id",
                "event_destination_id",
                "event_types",
                "callback_id",
                "chat_connection_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "archived_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationEventDestinationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["callback_id", "chat_connection_id"]]]]]
);
var mapManagementOrganizationEventDestinationsPingOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_id",
    "event_type",
    "event_destination_id",
    "attempt_count",
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "attempts",
      0,
      [
        2,
        [
          1,
          [
            "event_delivery_id",
            "event_id",
            "event_destination_id",
            "attempt_number",
            "duration_ms",
            "is_retryable",
            ["response", 0, [1, ["status_code", "is_body_truncated"]]],
            "started_at",
            "completed_at",
            "created_at"
          ]
        ]
      ]
    ],
    "last_attempt_at",
    "next_attempt_at",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationsRotateWebhookSecretOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    ["webhook", 0, [1, ["signing_secret"]]],
    [
      "retry",
      0,
      [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
    ],
    [
      "listeners",
      0,
      [
        2,
        [
          1,
          [
            "instance_id",
            "event_destination_id",
            "event_types",
            "callback_id",
            "chat_connection_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "archived_at"
  ],
  1
);
var mapManagementOrganizationEventDestinationsUpdateBody = /* @__PURE__ */ mapObject([
  [
    "retry",
    0,
    [1, ["max_attempts", "base_delay_seconds", "max_delay_seconds"]]
  ]
]);
var mapManagementOrganizationEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "instance_id",
    "event_type",
    "callback_id",
    "callback_event_id",
    "callback_trigger_key",
    "chat_event_id",
    "chat_connection_id",
    "provider_id",
    "created_at"
  ],
  1
);
var mapManagementOrganizationEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "instance_id",
        "event_type",
        "callback_id",
        "callback_event_id",
        "callback_trigger_key",
        "chat_event_id",
        "chat_connection_id",
        "provider_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "instance_id",
          "event_type",
          "callback_id",
          "callback_trigger_key",
          "chat_connection_id",
          "provider_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapManagementOrganizationGetOutput = /* @__PURE__ */ mapObject(
  ["image_url", "magic_mcp_origin", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationInstancesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "sandbox_id",
    "created_at",
    "updated_at",
    ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
  ],
  1
);
var mapManagementOrganizationInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "sandbox_id",
    "created_at",
    "updated_at",
    ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
  ],
  1
);
var mapManagementOrganizationInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "sandbox_id",
        "created_at",
        "updated_at",
        ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationInstancesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["project_id"]]]]
]);
var mapManagementOrganizationInstancesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "sandbox_id",
    "created_at",
    "updated_at",
    ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
  ],
  1
);
var mapManagementOrganizationInstancesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationInvitesCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationInvitesCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationInvitesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationInvitesEnsureLinkOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationInvitesGetOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationInvitesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
        "created_at",
        "updated_at",
        "expires_at",
        "accepted_at",
        "rejected_at",
        "deleted_at",
        [
          "organization",
          0,
          [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
        ],
        [
          "invited_by",
          1,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationInvitesListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationInvitesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["invite_link", 1, [1, ["key_redacted", "created_at"]]],
    "created_at",
    "updated_at",
    "expires_at",
    "accepted_at",
    "rejected_at",
    "deleted_at",
    [
      "organization",
      0,
      [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
    ],
    [
      "invited_by",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationInvitesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationMembersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationMembersGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationMembersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_id",
        "organization_id",
        "actor_id",
        "last_active_at",
        "created_at",
        "updated_at",
        "deleted_at",
        [
          "actor",
          0,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationMembersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["team_id"]]]]
]);
var mapManagementOrganizationMembersPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationMembersPoliciesCreateBody = /* @__PURE__ */ mapObject([
  "access_policy_id"
]);
var mapManagementOrganizationMembersPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationMembersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "user_id",
    "organization_id",
    "actor_id",
    "last_active_at",
    "created_at",
    "updated_at",
    "deleted_at",
    [
      "actor",
      0,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationMembersUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationOauthAppsClientSecretsCreateOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapManagementOrganizationOauthAppsClientSecretsDeleteOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapManagementOrganizationOauthAppsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthAppsCreateBody = /* @__PURE__ */ mapObject([
  "access_level",
  "subject_type",
  "allow_token_exchange_without_client_secret",
  "website_url",
  "privacy_policy_url",
  "terms_of_service_url",
  "redirect_uris"
]);
var mapManagementOrganizationOauthAppsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthAppsGetOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthAppsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "access_level",
        "subject_type",
        "allow_token_exchange_without_client_secret",
        "image_url",
        "website_url",
        "privacy_policy_url",
        "terms_of_service_url",
        "redirect_uris",
        "client_id",
        ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
        "organization_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOauthAppsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["subject_type"]]]]
]);
var mapManagementOrganizationOauthAppsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    "subject_type",
    "allow_token_exchange_without_client_secret",
    "image_url",
    "website_url",
    "privacy_policy_url",
    "terms_of_service_url",
    "redirect_uris",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthAppsUpdateBody = /* @__PURE__ */ mapObject([
  "access_level",
  "allow_token_exchange_without_client_secret",
  "website_url",
  "privacy_policy_url",
  "terms_of_service_url",
  "redirect_uris"
]);
var mapManagementOrganizationOauthAuthorizationLogsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "redirect_uri",
        "client_ip",
        [
          "oauth_application",
          1,
          [
            1,
            [
              "access_level",
              "subject_type",
              "allow_token_exchange_without_client_secret",
              "image_url",
              "website_url",
              "privacy_policy_url",
              "terms_of_service_url",
              "redirect_uris",
              "client_id",
              ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
              "organization_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "actor",
          0,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "user",
          0,
          [
            1,
            [
              "first_name",
              "last_name",
              "image_url",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "accepted_at",
        "denied_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOauthAuthorizationLogsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["app_id", "user_id"]]]]]
);
var mapManagementOrganizationOauthAuthorizationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "organization_id",
    "oauth_application_id",
    "oauth_installation_id",
    "user_id",
    "organization_member_id",
    "consumer_profile_id",
    "portal_id",
    "instance_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "requesting_ip",
    "accepting_ip",
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthAuthorizationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "subject_type",
        "organization_id",
        "oauth_application_id",
        "oauth_installation_id",
        "user_id",
        "organization_member_id",
        "consumer_profile_id",
        "portal_id",
        "instance_id",
        [
          "oauth_application",
          1,
          [
            1,
            [
              "access_level",
              "subject_type",
              "allow_token_exchange_without_client_secret",
              "image_url",
              "website_url",
              "privacy_policy_url",
              "terms_of_service_url",
              "redirect_uris",
              "client_id",
              ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
              "organization_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "requesting_ip",
        "accepting_ip",
        "last_used_at",
        "revoked_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOauthAuthorizationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["installation_id", "app_id", "subject_type"]]]]]
);
var mapManagementOrganizationOauthAuthorizationsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "organization_id",
    "oauth_application_id",
    "oauth_installation_id",
    "user_id",
    "organization_member_id",
    "consumer_profile_id",
    "portal_id",
    "instance_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "requesting_ip",
    "accepting_ip",
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthCliDevicesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    "oauth_authorization_id",
    "created_at",
    "updated_at",
    [
      "user",
      0,
      [
        1,
        ["first_name", "last_name", "image_url", "created_at", "updated_at"]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOauthCliDevicesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        "oauth_authorization_id",
        "created_at",
        "updated_at",
        [
          "user",
          0,
          [
            1,
            [
              "first_name",
              "last_name",
              "image_url",
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOauthCliDevicesListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationOauthInstallationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "server_side_machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthInstallationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        [
          "oauth_application",
          1,
          [
            1,
            [
              "access_level",
              "subject_type",
              "allow_token_exchange_without_client_secret",
              "image_url",
              "website_url",
              "privacy_policy_url",
              "terms_of_service_url",
              "redirect_uris",
              "client_id",
              ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
              "organization_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "server_side_machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "last_used_at",
        "revoked_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOauthInstallationsListQuery = /* @__PURE__ */ createMapper(
  [3, [[0, [1, ["app_id"]]]]]
);
var mapManagementOrganizationOauthInstallationsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "oauth_application",
      1,
      [
        1,
        [
          "access_level",
          "subject_type",
          "allow_token_exchange_without_client_secret",
          "image_url",
          "website_url",
          "privacy_policy_url",
          "terms_of_service_url",
          "redirect_uris",
          "client_id",
          ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
          "organization_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "server_side_machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOauthScopesListOutput = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationOauthScopesListQuery = /* @__PURE__ */ mapObject([
  "subject_type"
]);
var mapManagementOrganizationOutpostsAccessListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "outpost_id",
        "project_id",
        "instance_id",
        "organization_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOutpostsAccessListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["organization_id", "instance_id"]]]]
]);
var mapManagementOrganizationOutpostsAccessSetOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "outpost_id",
        "project_id",
        "instance_id",
        "organization_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOutpostsAccessSetBody = /* @__PURE__ */ mapObject([
  ["grants", 0, [2, [1, ["instance_id"]]]]
]);
var mapManagementOrganizationOutpostsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationOutpostsCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsCredentialsCreateBody = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapManagementOrganizationOutpostsCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsCredentialsDisableOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsCredentialsGetOutput = /* @__PURE__ */ mapObject(
  [
    "outpost_id",
    "envelope_preview",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "outpost_id",
        "envelope_preview",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOutpostsCredentialsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationOutpostsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsDisableOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsEnableOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_status",
        "organization_id",
        "instance_count",
        "last_seen_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationOutpostsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationOutpostsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_status",
    "organization_id",
    "instance_count",
    "last_seen_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationOutpostsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationProjectsBrandingGetOutput = /* @__PURE__ */ mapObject(
  ["image_url", "project_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationProjectsBrandingUpdateOutput = /* @__PURE__ */ mapObject(
  ["image_url", "project_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationProjectsBrandingUpdateBody = /* @__PURE__ */ mapObject([
  "image_file_id"
]);
var mapManagementOrganizationProjectsCreateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationProjectsCreateBody = /* @__PURE__ */ mapObject([
  "magic_mcp_session_duration_minutes"
]);
var mapManagementOrganizationProjectsDeleteOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationProjectsGetOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationProjectsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["organization_id", "created_at", "updated_at"]]],
  1
);
var mapManagementOrganizationProjectsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["team_id"]]]]
]);
var mapManagementOrganizationProjectsUpdateOutput = /* @__PURE__ */ mapObject(
  ["organization_id", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationProjectsUpdateBody = /* @__PURE__ */ mapObject([
  "magic_mcp_session_duration_minutes"
]);
var mapManagementOrganizationSandboxesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "instance",
      0,
      [
        1,
        [
          "organization_id",
          "sandbox_id",
          "created_at",
          "updated_at",
          ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "creator_actor",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationSandboxesCreateBody = /* @__PURE__ */ mapObject([
  "project_id"
]);
var mapManagementOrganizationSandboxesGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "instance",
      0,
      [
        1,
        [
          "organization_id",
          "sandbox_id",
          "created_at",
          "updated_at",
          ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "creator_actor",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationSandboxesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        [
          "instance",
          0,
          [
            1,
            [
              "organization_id",
              "sandbox_id",
              "created_at",
              "updated_at",
              [
                "project",
                0,
                [1, ["organization_id", "created_at", "updated_at"]]
              ]
            ]
          ]
        ],
        [
          "creator_actor",
          1,
          [
            1,
            [
              "organization_id",
              "image_url",
              [
                "teams",
                0,
                [2, [1, ["assignment_id", "created_at", "updated_at"]]]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationSandboxesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["project_id"]]]]
]);
var mapManagementOrganizationSandboxesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "instance",
      0,
      [
        1,
        [
          "organization_id",
          "sandbox_id",
          "created_at",
          "updated_at",
          ["project", 0, [1, ["organization_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "creator_actor",
      1,
      [
        1,
        [
          "organization_id",
          "image_url",
          [
            "teams",
            0,
            [2, [1, ["assignment_id", "created_at", "updated_at"]]]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationSandboxesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationServiceAccountsClientSecretsCreateOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapManagementOrganizationServiceAccountsClientSecretsDeleteOutput = /* @__PURE__ */ mapObject(
  ["created_at", "deleted_at"],
  1
);
var mapManagementOrganizationServiceAccountsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationServiceAccountsCreateBody = /* @__PURE__ */ mapObject([
  "subject_type",
  "portal_id"
]);
var mapManagementOrganizationServiceAccountsCredentialsGetOutput = /* @__PURE__ */ mapObject(
  [
    "service_account_id",
    [
      "machine_access",
      1,
      [
        1,
        [
          "last_used_at",
          "created_at",
          "updated_at",
          "deleted_at",
          [
            "actor",
            0,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "instance",
            0,
            [
              1,
              [
                "organization_id",
                "sandbox_id",
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ],
          [
            "organization",
            0,
            [1, ["image_url", "magic_mcp_origin", "created_at", "updated_at"]]
          ],
          [
            "user",
            0,
            [
              1,
              [
                "first_name",
                "last_name",
                "image_url",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ]
      ]
    ],
    "last_used_at",
    "revoked_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationServiceAccountsCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "service_account_id",
        [
          "machine_access",
          1,
          [
            1,
            [
              "last_used_at",
              "created_at",
              "updated_at",
              "deleted_at",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "instance",
                0,
                [
                  1,
                  [
                    "organization_id",
                    "sandbox_id",
                    "created_at",
                    "updated_at",
                    [
                      "project",
                      0,
                      [1, ["organization_id", "created_at", "updated_at"]]
                    ]
                  ]
                ]
              ],
              [
                "organization",
                0,
                [
                  1,
                  [
                    "image_url",
                    "magic_mcp_origin",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "user",
                0,
                [
                  1,
                  [
                    "first_name",
                    "last_name",
                    "image_url",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ],
        "last_used_at",
        "revoked_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationServiceAccountsCredentialsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationServiceAccountsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationServiceAccountsGetOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationServiceAccountsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "subject_type",
        "client_id",
        ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
        "organization_id",
        "portal_id",
        "consumer_profile_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationServiceAccountsListQuery = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationServiceAccountsPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationServiceAccountsPoliciesCreateBody = /* @__PURE__ */ mapObject(
  ["access_policy_id"]
);
var mapManagementOrganizationServiceAccountsPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationServiceAccountsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "subject_type",
    "client_id",
    ["client_secrets", 1, [2, [1, ["created_at", "deleted_at"]]]],
    "organization_id",
    "portal_id",
    "consumer_profile_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationServiceAccountsUpdateBody = /* @__PURE__ */ createMapper(
  0
);
var mapManagementOrganizationTeamsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsCreateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationTeamsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsGetOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "organization_id",
        [
          "projects",
          0,
          [
            2,
            [
              1,
              [
                "created_at",
                "updated_at",
                [
                  "project",
                  0,
                  [1, ["organization_id", "created_at", "updated_at"]]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapManagementOrganizationTeamsListQuery = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationTeamsMembersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsMembersCreateBody = /* @__PURE__ */ mapObject([
  "actor_id"
]);
var mapManagementOrganizationTeamsMembersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsPoliciesCreateBody = /* @__PURE__ */ mapObject([
  "access_policy_id"
]);
var mapManagementOrganizationTeamsPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "organization_id",
    [
      "projects",
      0,
      [
        2,
        [
          1,
          [
            "created_at",
            "updated_at",
            [
              "project",
              0,
              [1, ["organization_id", "created_at", "updated_at"]]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapManagementOrganizationTeamsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapManagementOrganizationUpdateOutput = /* @__PURE__ */ mapObject(
  ["image_url", "magic_mcp_origin", "created_at", "updated_at"],
  1
);
var mapManagementOrganizationUpdateBody = /* @__PURE__ */ mapObject([
  "image_file_id"
]);
var mapManagementOrganizationWebhookEventsListOutput = /* @__PURE__ */ createMapper([
  7,
  0
]);
var mapManagementUserDeleteOutput = /* @__PURE__ */ mapObject(
  ["first_name", "last_name", "image_url", "created_at", "updated_at"],
  1
);
var mapManagementUserDeleteBody = /* @__PURE__ */ createMapper(0);
var mapManagementUserGetOutput = /* @__PURE__ */ mapObject(
  ["first_name", "last_name", "image_url", "created_at", "updated_at"],
  1
);
var mapManagementUserUpdateOutput = /* @__PURE__ */ mapObject(
  ["first_name", "last_name", "image_url", "created_at", "updated_at"],
  1
);
var mapManagementUserUpdateBody = /* @__PURE__ */ createMapper(0);
var mapMonitorAlertsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapMonitorAlertsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "monitor",
          0,
          [
            1,
            [
              "proto_guard_filter_id",
              "provider_id",
              "created_at",
              "updated_at",
              "first_alert_at",
              "last_alert_at"
            ]
          ]
        ],
        "proto_guard_alert_id",
        "proto_guard_run_id",
        [
          "specification_change_notification",
          1,
          [
            1,
            [
              "provider_id",
              "provider_version_id",
              ["from_specification", 1, 8],
              ["to_specification", 1, 8],
              ["from_provider_version", 1, 8],
              ["to_provider_version", 1, 8],
              "created_at"
            ]
          ]
        ],
        "created_at",
        "resolved_at",
        [
          "recipients",
          0,
          [2, [1, ["recipient_id", "viewed_at", "created_at"]]]
        ],
        ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
      ]
    ]
  ],
  1
);
var mapMonitorAlertsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "monitor_id",
          "provider_id",
          "proto_guard_alert_id",
          "proto_guard_run_id",
          "proto_guard_filter_id",
          "specification_change_notification_id",
          "session_id",
          "session_message_id",
          "session_connection_id",
          "provider_run_id",
          ["created_at", 1, 5],
          ["resolved_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapMonitorAlertsResolveOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapMonitorAlertsUnresolveOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapMonitorAlertsViewedOutput = /* @__PURE__ */ mapObject(
  [
    [
      "monitor",
      0,
      [
        1,
        [
          "proto_guard_filter_id",
          "provider_id",
          "created_at",
          "updated_at",
          "first_alert_at",
          "last_alert_at"
        ]
      ]
    ],
    "proto_guard_alert_id",
    "proto_guard_run_id",
    [
      "specification_change_notification",
      1,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          ["from_specification", 1, 8],
          ["to_specification", 1, 8],
          ["from_provider_version", 1, 8],
          ["to_provider_version", 1, 8],
          "created_at"
        ]
      ]
    ],
    "created_at",
    "resolved_at",
    ["recipients", 0, [2, [1, ["recipient_id", "viewed_at", "created_at"]]]],
    ["events", 0, [2, [1, ["actor_id", "created_at"]]]]
  ],
  1
);
var mapMonitorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "proto_guard_filter_id",
    "provider_id",
    "created_at",
    "updated_at",
    "first_alert_at",
    "last_alert_at"
  ],
  1
);
var mapMonitorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "proto_guard_filter_id",
        "provider_id",
        "created_at",
        "updated_at",
        "first_alert_at",
        "last_alert_at"
      ]
    ]
  ],
  1
);
var mapMonitorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "proto_guard_filter_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5],
          ["first_alert_at", 1, 5],
          ["last_alert_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapNetworkPoliciesCreateOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapNetworkPoliciesCreateBody = /* @__PURE__ */ createMapper(0);
var mapNetworkPoliciesDeleteOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapNetworkPoliciesGetOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapNetworkPoliciesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["firewall_ids", "created_at", "updated_at", "archived_at"]]],
  1
);
var mapNetworkPoliciesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["firewall_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapNetworkPoliciesRulesCreateOutput = /* @__PURE__ */ createMapper(0);
var mapNetworkPoliciesRulesCreateBody = /* @__PURE__ */ createMapper(0);
var mapNetworkPoliciesRulesDeleteOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapNetworkPoliciesRulesUpdateOutput = /* @__PURE__ */ createMapper(0);
var mapNetworkPoliciesRulesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapNetworkPoliciesUpdateOutput = /* @__PURE__ */ mapObject(
  ["firewall_ids", "created_at", "updated_at", "archived_at"],
  1
);
var mapNetworkPoliciesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapOrganizationsFlagsGetOutput = /* @__PURE__ */ createMapper(0);
var mapOrganizationsFlagsGetQuery = /* @__PURE__ */ mapObject(["project_id"]);
var mapOrganizationsProfileGetOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "is_official",
    "is_metorial",
    "is_verified",
    "created_at",
    "updated_at"
  ],
  1
);
var mapOrganizationsProfileUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "is_official",
    "is_metorial",
    "is_verified",
    "created_at",
    "updated_at"
  ],
  1
);
var mapOrganizationsProfileUpdateBody = /* @__PURE__ */ createMapper(0);
var mapOrganizationsScopesGetOutput = /* @__PURE__ */ createMapper(0);
var mapPortalsAccessCreateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsAccessCreateBody = /* @__PURE__ */ mapObject([
  "consumer_group_id",
  [
    "access",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_template_id",
              "magic_mcp_server_id",
              "skill_id",
              "skill_template_id",
              "skill_group_id",
              "skill_marketplace_id",
              "skill_plugin_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapPortalsAccessDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsAccessGetOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsAccessListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "access_level",
        [
          "access",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server",
                    "skill_template",
                    "skill_group",
                    "skill_marketplace",
                    "skill_plugin"
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "consumer_group",
          1,
          [1, ["is_default", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapPortalsAccessListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "consumer_group_id",
          "provider_template_id",
          "magic_mcp_server_id",
          "skill_id",
          "skill_template_id",
          "skill_group_id",
          "skill_marketplace_id",
          "skill_plugin_id",
          "consumer_access_listing_id"
        ]
      ]
    ]
  ]
]);
var mapPortalsAccessUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "access_level",
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    ["consumer_group", 1, [1, ["is_default", "created_at", "updated_at"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsAccessUpdateBody = /* @__PURE__ */ createMapper(0);
var mapPortalsAccessRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "resolution_message",
    "consumer_profile",
    [
      "target",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "reviewed_at"
  ],
  1
);
var mapPortalsAccessRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "resolution_message",
        "consumer_profile",
        [
          "target",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server"
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at",
        "reviewed_at"
      ]
    ]
  ],
  1
);
var mapPortalsAccessRequestsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["consumer_profile_id"]]]]
]);
var mapPortalsAccessRequestsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "resolution_message",
    "consumer_profile",
    [
      "target",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at",
    "reviewed_at"
  ],
  1
);
var mapPortalsAccessRequestsUpdateBody = /* @__PURE__ */ mapObject([
  "resolution_message",
  "consumer_group_id"
]);
var mapPortalsConsumerGroupsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerGroupsCreateBody = /* @__PURE__ */ mapObject(["is_default"]);
var mapPortalsConsumerGroupsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerGroupsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              "created_at",
              "updated_at",
              "is_managed",
              "is_default_everyone_group"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerGroupsListQuery = /* @__PURE__ */ createMapper(0);
var mapPortalsConsumerGroupsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "created_at",
            "updated_at",
            "is_managed",
            "is_default_everyone_group"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerGroupsUpdateBody = /* @__PURE__ */ mapObject(["is_default"]);
var mapPortalsConsumerInvitesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "portal_url",
    "consumer_profile",
    "invited_by",
    "accepted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsConsumerInvitesCreateBody = /* @__PURE__ */ createMapper(0);
var mapPortalsConsumerInvitesGetOutput = /* @__PURE__ */ mapObject(
  [
    "portal_url",
    "consumer_profile",
    "invited_by",
    "accepted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsConsumerInvitesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "portal_url",
        "consumer_profile",
        "invited_by",
        "accepted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapPortalsConsumerInvitesListQuery = /* @__PURE__ */ createMapper(0);
var mapPortalsConsumerProfilesAssignGroupsOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerProfilesAssignGroupsBody = /* @__PURE__ */ mapObject([
  "group_ids"
]);
var mapPortalsConsumerProfilesCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerProfilesCreateBody = /* @__PURE__ */ createMapper(0);
var mapPortalsConsumerProfilesDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerProfilesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerProfilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "image_url",
              "consumer_id",
              "user_id",
              "created_at",
              "updated_at",
              [
                "groups",
                0,
                [
                  2,
                  [
                    1,
                    [
                      [
                        "group",
                        0,
                        [1, ["is_default", "created_at", "updated_at"]]
                      ],
                      "assigned_via"
                    ]
                  ]
                ]
              ],
              "is_service_account",
              [
                "surface",
                0,
                [
                  1,
                  [
                    "allow_consumer_skill_authoring",
                    "allow_consumer_skill_publishing",
                    [
                      "skill_configuration",
                      1,
                      [
                        1,
                        [
                          "is_default",
                          "allow_scripts",
                          "allowed_file_extensions",
                          "allow_non_standard_directories"
                        ]
                      ]
                    ],
                    [
                      "auth",
                      0,
                      [
                        1,
                        ["session_expiry_time_in_seconds", "email_whitelist"]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerProfilesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["consumer_group_id"]]]]
]);
var mapPortalsConsumerProfilesUnassignGroupsOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "image_url",
            "consumer_id",
            "user_id",
            "created_at",
            "updated_at",
            [
              "groups",
              0,
              [
                2,
                [
                  1,
                  [
                    [
                      "group",
                      0,
                      [1, ["is_default", "created_at", "updated_at"]]
                    ],
                    "assigned_via"
                  ]
                ]
              ]
            ],
            "is_service_account",
            [
              "surface",
              0,
              [
                1,
                [
                  "allow_consumer_skill_authoring",
                  "allow_consumer_skill_publishing",
                  [
                    "skill_configuration",
                    1,
                    [
                      1,
                      [
                        "is_default",
                        "allow_scripts",
                        "allowed_file_extensions",
                        "allow_non_standard_directories"
                      ]
                    ]
                  ],
                  [
                    "auth",
                    0,
                    [1, ["session_expiry_time_in_seconds", "email_whitelist"]]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsConsumerProfilesUnassignGroupsBody = /* @__PURE__ */ mapObject([
  "group_ids"
]);
var mapPortalsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsCreateBody = /* @__PURE__ */ mapObject([
  "allowed_redirect_url_filters",
  "session_expiry_time_in_seconds",
  "allow_consumer_skill_authoring",
  "allow_consumer_skill_publishing"
]);
var mapPortalsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "allow_consumer_skill_authoring",
              "allow_consumer_skill_publishing",
              [
                "skill_configuration",
                1,
                [
                  1,
                  [
                    "is_default",
                    "allow_scripts",
                    "allowed_file_extensions",
                    "allow_non_standard_directories"
                  ]
                ]
              ],
              [
                "auth",
                0,
                [
                  1,
                  [
                    "session_expiry_time_in_seconds",
                    "allowed_redirect_url_filters"
                  ]
                ]
              ],
              "magic_mcp_url",
              "created_at",
              "updated_at",
              "managed_everyone_group_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsListQuery = /* @__PURE__ */ createMapper(0);
var mapPortalsListingsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsListingsCreateBody = /* @__PURE__ */ mapObject([
  [
    "access",
    0,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_template_id",
              "magic_mcp_server_id",
              "skill_id",
              "skill_template_id",
              "skill_group_id",
              "skill_marketplace_id"
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapPortalsListingsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsListingsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsListingsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "access",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    [
                      "provider_template",
                      1,
                      [1, ["integration_id", "created_at", "updated_at"]]
                    ],
                    "magic_mcp_server",
                    "skill_template",
                    "skill_group",
                    "skill_marketplace",
                    "skill_plugin"
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapPortalsListingsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "consumer_surface_provider_group_id",
          "provider_template_id",
          "magic_mcp_server_id",
          "skill_id",
          "skill_template_id",
          "skill_group_id",
          "skill_marketplace_id"
        ]
      ]
    ]
  ]
]);
var mapPortalsListingsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "access",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                [
                  "provider_template",
                  1,
                  [1, ["integration_id", "created_at", "updated_at"]]
                ],
                "magic_mcp_server",
                "skill_template",
                "skill_group",
                "skill_marketplace",
                "skill_plugin"
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapPortalsListingsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapPortalsSurfaceProviderGroupsAddListingOutput = /* @__PURE__ */ createMapper(8);
var mapPortalsSurfaceProviderGroupsAddListingBody = /* @__PURE__ */ mapObject([
  "consumer_access_listing_id"
]);
var mapPortalsSurfaceProviderGroupsCreateOutput = /* @__PURE__ */ createMapper(8);
var mapPortalsSurfaceProviderGroupsCreateBody = /* @__PURE__ */ createMapper(0);
var mapPortalsSurfaceProviderGroupsDeleteOutput = /* @__PURE__ */ createMapper(8);
var mapPortalsSurfaceProviderGroupsGetOutput = /* @__PURE__ */ createMapper(8);
var mapPortalsSurfaceProviderGroupsListOutput = /* @__PURE__ */ createMapper([7, 8]);
var mapPortalsSurfaceProviderGroupsListQuery = /* @__PURE__ */ createMapper(0);
var mapPortalsSurfaceProviderGroupsRemoveListingOutput = /* @__PURE__ */ createMapper(
  8
);
var mapPortalsSurfaceProviderGroupsUpdateOutput = /* @__PURE__ */ createMapper(8);
var mapPortalsSurfaceProviderGroupsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapPortalsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "allow_consumer_skill_authoring",
            "allow_consumer_skill_publishing",
            [
              "skill_configuration",
              1,
              [
                1,
                [
                  "is_default",
                  "allow_scripts",
                  "allowed_file_extensions",
                  "allow_non_standard_directories"
                ]
              ]
            ],
            [
              "auth",
              0,
              [
                1,
                [
                  "session_expiry_time_in_seconds",
                  "allowed_redirect_url_filters"
                ]
              ]
            ],
            "magic_mcp_url",
            "created_at",
            "updated_at",
            "managed_everyone_group_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPortalsUpdateBody = /* @__PURE__ */ mapObject([
  "allowed_redirect_url_filters",
  "session_expiry_time_in_seconds",
  "allow_consumer_skill_authoring",
  "allow_consumer_skill_publishing",
  [
    "skill_configuration",
    1,
    [
      1,
      [
        "allow_scripts",
        "allowed_file_extensions",
        "allow_non_standard_directories"
      ]
    ]
  ]
]);
var mapProtoGuardAlertsGetOutput = /* @__PURE__ */ mapObject(
  [
    "run_id",
    "session_id",
    "session_message_id",
    "session_connection_id",
    "provider_run_id",
    ["filters", 0, [2, [1, ["filter_id", "issue_type", "created_at"]]]],
    "created_at"
  ],
  1
);
var mapProtoGuardAlertsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "run_id",
        "session_id",
        "session_message_id",
        "session_connection_id",
        "provider_run_id",
        ["filters", 0, [2, [1, ["filter_id", "issue_type", "created_at"]]]],
        "created_at"
      ]
    ]
  ],
  1
);
var mapProtoGuardAlertsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "run_id",
          "filter_id",
          "session_id",
          "session_message_id",
          "session_connection_id",
          "provider_run_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProtoGuardConfigGetOutput = /* @__PURE__ */ mapObject([
  "alert_filter_count_threshold",
  [
    "filters",
    0,
    [
      2,
      [
        1,
        [
          "issue_type",
          "score_weight",
          "default_enabled",
          "default_alert_confidence_threshold",
          "alert_confidence_threshold"
        ]
      ]
    ]
  ]
]);
var mapProtoGuardConfigSetAlertFilterCountThresholdOutput = /* @__PURE__ */ mapObject(
  [
    "alert_filter_count_threshold",
    [
      "filters",
      0,
      [
        2,
        [
          1,
          [
            "issue_type",
            "score_weight",
            "default_enabled",
            "default_alert_confidence_threshold",
            "alert_confidence_threshold"
          ]
        ]
      ]
    ]
  ]
);
var mapProtoGuardConfigSetAlertFilterCountThresholdBody = /* @__PURE__ */ createMapper(
  0
);
var mapProtoGuardConfigUpdateFilterOutput = /* @__PURE__ */ mapObject([
  "alert_filter_count_threshold",
  [
    "filters",
    0,
    [
      2,
      [
        1,
        [
          "issue_type",
          "score_weight",
          "default_enabled",
          "default_alert_confidence_threshold",
          "alert_confidence_threshold"
        ]
      ]
    ]
  ]
]);
var mapProtoGuardConfigUpdateFilterBody = /* @__PURE__ */ mapObject([
  "alert_confidence_threshold"
]);
var mapProviderAuthConfigErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "auth_config_event_id",
    "provider_auth_config_id",
    "provider_auth_credentials_id",
    "provider_oauth_setup_id",
    "provider_id",
    "provider_invocation_id",
    "group_id",
    "similar_error_count",
    "created_at"
  ],
  1
);
var mapProviderAuthConfigErrorsGroupsGetOutput = /* @__PURE__ */ mapObject(
  ["provider_id", "occurrence_count", "created_at"],
  1
);
var mapProviderAuthConfigErrorsGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["provider_id", "occurrence_count", "created_at"]]],
  1
);
var mapProviderAuthConfigErrorsGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_auth_config_id",
          "provider_auth_credentials_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderAuthConfigErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "auth_config_event_id",
        "provider_auth_config_id",
        "provider_auth_credentials_id",
        "provider_oauth_setup_id",
        "provider_id",
        "provider_invocation_id",
        "group_id",
        "similar_error_count",
        "created_at"
      ]
    ]
  ],
  1
);
var mapProviderAuthConfigErrorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "auth_config_event_id",
          "provider_auth_config_id",
          "provider_auth_credentials_id",
          "provider_oauth_setup_id",
          "provider_id",
          "provider_auth_config_error_group_id",
          "provider_invocation_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderAuthConfigEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "source_type",
    "source_id",
    "provider_auth_config_id",
    "provider_auth_credentials_id",
    "provider_oauth_setup_id",
    "provider_id",
    "provider_auth_error_id",
    "provider_invocation_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderAuthConfigEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "source_type",
        "source_id",
        "provider_auth_config_id",
        "provider_auth_credentials_id",
        "provider_oauth_setup_id",
        "provider_id",
        "provider_auth_error_id",
        "provider_invocation_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProviderAuthConfigEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_auth_config_id",
          "provider_auth_credentials_id",
          "provider_oauth_setup_id",
          "provider_id",
          "provider_invocation_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderCategoriesGetOutput = /* @__PURE__ */ createMapper(8);
var mapProviderCategoriesListOutput = /* @__PURE__ */ createMapper([7, 8]);
var mapProviderCategoriesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "provider_listing_id"]]]]
]);
var mapProviderCollectionsGetOutput = /* @__PURE__ */ createMapper(8);
var mapProviderCollectionsListOutput = /* @__PURE__ */ createMapper([7, 8]);
var mapProviderCollectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "provider_listing_id"]]]]
]);
var mapProviderDeploymentsAuthConfigsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthConfigsCreateBody = /* @__PURE__ */ mapObject([
  "tool_filters",
  "provider_auth_method_id",
  "provider_deployment_id"
]);
var mapProviderDeploymentsAuthConfigsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthConfigsExportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapProviderDeploymentsAuthConfigsExportsCreateBody = /* @__PURE__ */ mapObject([
  "provider_auth_config_id"
]);
var mapProviderDeploymentsAuthConfigsExportsGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapProviderDeploymentsAuthConfigsExportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_agent",
        [
          "auth_config",
          1,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "provider_id",
        "provider_deployment_id",
        "auth_method_id",
        "credentials_id",
        "created_at",
        "expires_at"
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthConfigsExportsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_auth_credentials_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsAuthConfigsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthConfigsImportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapProviderDeploymentsAuthConfigsImportsCreateBody = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_deployment_id",
  "provider_auth_config_id",
  "provider_auth_method_id"
]);
var mapProviderDeploymentsAuthConfigsImportsGetSchemaOutput = /* @__PURE__ */ mapObject(
  ["specification_id", "provider_id", "created_at", "updated_at"],
  1
);
var mapProviderDeploymentsAuthConfigsImportsGetSchemaQuery = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_deployment_id",
    "provider_auth_config_id",
    "provider_auth_method_id"
  ]
);
var mapProviderDeploymentsAuthConfigsImportsGetOutput = /* @__PURE__ */ mapObject(
  [
    "user_agent",
    [
      "auth_config",
      1,
      [
        1,
        [
          "is_default",
          "provider_id",
          ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
          [
            "deployment",
            0,
            [1, ["is_default", "provider_id", "created_at", "updated_at"]]
          ],
          [
            "credentials",
            0,
            [
              1,
              [
                "is_default",
                "is_managed",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "auth_method",
            1,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          ["owner_actor", 1, [1, ["consumer_id"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "provider_id",
    "provider_deployment_id",
    "auth_method_id",
    "credentials_id",
    "created_at",
    "expires_at"
  ],
  1
);
var mapProviderDeploymentsAuthConfigsImportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "user_agent",
        [
          "auth_config",
          1,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "provider_id",
        "provider_deployment_id",
        "auth_method_id",
        "credentials_id",
        "created_at",
        "expires_at"
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthConfigsImportsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_auth_credentials_id",
          "provider_auth_config_id",
          "provider_deployment_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsAuthConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              "provider_id",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthConfigsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_deployment_id",
          "available_for_use",
          "available_for_provider_deployment_id",
          "provider_auth_credentials_id",
          "provider_auth_method_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "identity_credential_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsAuthConfigsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            "provider_id",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthConfigsUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters"
]);
var mapProviderDeploymentsAuthCredentialsCreateOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapProviderDeploymentsAuthCredentialsCreateBody = /* @__PURE__ */ mapObject([
  "provider_id",
  ["config", 0, [1, ["client_id", "client_secret"]]]
]);
var mapProviderDeploymentsAuthCredentialsDeleteOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapProviderDeploymentsAuthCredentialsGetOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapProviderDeploymentsAuthCredentialsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      ["is_default", "is_managed", "provider_id", "created_at", "updated_at"]
    ]
  ],
  1
);
var mapProviderDeploymentsAuthCredentialsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_auth_method_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsAuthCredentialsUpdateOutput = /* @__PURE__ */ mapObject(
  ["is_default", "is_managed", "provider_id", "created_at", "updated_at"],
  1
);
var mapProviderDeploymentsAuthCredentialsUpdateBody = /* @__PURE__ */ mapObject([
  "client_id",
  "client_secret"
]);
var mapProviderDeploymentsConfigVaultsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsConfigVaultsCreateBody = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_deployment_id"
]);
var mapProviderDeploymentsConfigVaultsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsConfigVaultsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsConfigVaultsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsConfigVaultsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_config_vault_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsConfigVaultsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsConfigVaultsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapProviderDeploymentsConfigsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsConfigsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_deployment_id",
          "tool_filters",
          "provider_config_vault_id"
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsConfigsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsConfigsGetConfigSchemaOutput = /* @__PURE__ */ mapObject(
  ["specification_id", "provider_id", "created_at", "updated_at"],
  1
);
var mapProviderDeploymentsConfigsGetConfigSchemaQuery = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_config_id",
  "provider_version_id",
  "provider_deployment_id"
]);
var mapProviderDeploymentsConfigsGetValueOutput = /* @__PURE__ */ mapObject([
  "provider_config_id"
]);
var mapProviderDeploymentsConfigsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsConfigsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "is_default",
              ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
              "provider_id",
              "specification_id",
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "from_vault",
                1,
                [
                  1,
                  [
                    "provider_id",
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["owner_actor", 1, [1, ["consumer_id"]]],
              "created_at",
              "updated_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsConfigsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_specification_id",
          "provider_deployment_id",
          "available_for_use",
          "available_for_provider_deployment_id",
          "provider_config_vault_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "identity_credential_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsConfigsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "is_default",
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "specification_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "from_vault",
              1,
              [
                1,
                [
                  "provider_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["owner_actor", 1, [1, ["consumer_id"]]],
            "created_at",
            "updated_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsConfigsUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters"
]);
var mapProviderDeploymentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "tool_filters",
          "provider_id",
          "locked_provider_version_id",
          "provider_config_id",
          [
            "provider_config",
            1,
            [3, [[0, [1, ["provider_config_vault_id"]]]]]
          ]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        [
          "locked_version",
          1,
          [
            1,
            [
              "provider_id",
              "is_current",
              "specification_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "default_config",
          1,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "identity_credential_id",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ],
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsSetupSessionsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsSetupSessionsCreateBody = /* @__PURE__ */ mapObject([
  "provider_id",
  "provider_deployment_id",
  "provider_auth_method_id",
  "provider_auth_credentials_id",
  "identity_id",
  "consumer_id",
  "redirect_url",
  [
    "configuration",
    0,
    [
      1,
      [
        [
          "provider_search",
          1,
          [
            1,
            [
              ["groups", 0, [2, [1, ["group_id"]]]],
              ["collections", 0, [2, [1, ["collection_id"]]]],
              ["categories", 0, [2, [1, ["category_id"]]]]
            ]
          ]
        ],
        "tool_filters"
      ]
    ]
  ]
]);
var mapProviderDeploymentsSetupSessionsDeleteOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsSetupSessionsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsSetupSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "provider_id",
              "identity_id",
              "identity_credential_id",
              ["owner_actor", 1, [1, ["consumer_id"]]],
              [
                "auth_method",
                1,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    "provider_id",
                    "provider_specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "deployment",
                0,
                [1, ["is_default", "provider_id", "created_at", "updated_at"]]
              ],
              [
                "credentials",
                0,
                [
                  1,
                  [
                    "is_default",
                    "is_managed",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "auth_config",
                1,
                [
                  1,
                  [
                    "is_default",
                    "provider_id",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "credentials",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "is_managed",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "auth_method",
                      1,
                      [
                        1,
                        [
                          "input_schema",
                          "output_schema",
                          "provider_id",
                          "provider_specification_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["owner_actor", 1, [1, ["consumer_id"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "config",
                0,
                [
                  1,
                  [
                    "is_default",
                    [
                      "tool_filter",
                      1,
                      [3, [[0, [1, ["ignore_parent_filters"]]]]]
                    ],
                    "provider_id",
                    "specification_id",
                    [
                      "deployment",
                      0,
                      [
                        1,
                        [
                          "is_default",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "from_vault",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          [
                            "deployment",
                            0,
                            [
                              1,
                              [
                                "is_default",
                                "provider_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    ["owner_actor", 1, [1, ["consumer_id"]]],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              "ui_mode",
              "redirect_url",
              "created_at",
              "updated_at",
              "expires_at",
              "public_mcp_server_id"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsSetupSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_deployment_id",
          "provider_auth_method_id",
          "provider_auth_config_id",
          "provider_auth_credentials_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderDeploymentsSetupSessionsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "identity_id",
            "identity_credential_id",
            ["owner_actor", 1, [1, ["consumer_id"]]],
            [
              "auth_method",
              1,
              [
                1,
                [
                  "input_schema",
                  "output_schema",
                  "provider_id",
                  "provider_specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "credentials",
              0,
              [
                1,
                [
                  "is_default",
                  "is_managed",
                  "provider_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "auth_config",
              1,
              [
                1,
                [
                  "is_default",
                  "provider_id",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "credentials",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "is_managed",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "auth_method",
                    1,
                    [
                      1,
                      [
                        "input_schema",
                        "output_schema",
                        "provider_id",
                        "provider_specification_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "config",
              0,
              [
                1,
                [
                  "is_default",
                  [
                    "tool_filter",
                    1,
                    [3, [[0, [1, ["ignore_parent_filters"]]]]]
                  ],
                  "provider_id",
                  "specification_id",
                  [
                    "deployment",
                    0,
                    [
                      1,
                      [
                        "is_default",
                        "provider_id",
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  [
                    "from_vault",
                    1,
                    [
                      1,
                      [
                        "provider_id",
                        [
                          "deployment",
                          0,
                          [
                            1,
                            [
                              "is_default",
                              "provider_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at"
                      ]
                    ]
                  ],
                  ["owner_actor", 1, [1, ["consumer_id"]]],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "ui_mode",
            "redirect_url",
            "created_at",
            "updated_at",
            "expires_at",
            "public_mcp_server_id"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderDeploymentsSetupSessionsUpdateBody = /* @__PURE__ */ mapObject([
  "identity_id"
]);
var mapProviderDeploymentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    [
      "locked_version",
      1,
      [
        1,
        [
          "provider_id",
          "is_current",
          "specification_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "default_config",
      1,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderDeploymentsUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters",
  "locked_provider_version_id"
]);
var mapProviderGroupsAddListingOutput = /* @__PURE__ */ createMapper(8);
var mapProviderGroupsAddListingBody = /* @__PURE__ */ mapObject([
  "provider_listing_id"
]);
var mapProviderGroupsCreateOutput = /* @__PURE__ */ createMapper(8);
var mapProviderGroupsCreateBody = /* @__PURE__ */ createMapper(0);
var mapProviderGroupsGetOutput = /* @__PURE__ */ createMapper(8);
var mapProviderGroupsListOutput = /* @__PURE__ */ createMapper([7, 8]);
var mapProviderGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_listing_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderGroupsRemoveListingOutput = /* @__PURE__ */ createMapper(8);
var mapProviderGroupsUpdateOutput = /* @__PURE__ */ createMapper(8);
var mapProviderGroupsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapProviderInvocationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_run_ids",
    "session_message_ids",
    "callback_event_ids",
    "auth_config_event_ids",
    "provider_oauth_setup_ids",
    "tool_call_id",
    "request_traces",
    ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]],
    "created_at"
  ],
  1
);
var mapProviderInvocationsListOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "provider_run_ids",
            "session_message_ids",
            "callback_event_ids",
            "auth_config_event_ids",
            "provider_oauth_setup_ids",
            "tool_call_id",
            "request_traces",
            ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]],
            "created_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderInvocationsListQuery = /* @__PURE__ */ mapObject([
  "provider_run_id",
  "session_message_id",
  "chat_event_id",
  "callback_event_id",
  "auth_config_event_id"
]);
var mapProviderListingsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderListingsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "attributes",
                0,
                [
                  1,
                  [
                    "is_public",
                    "is_customized",
                    "is_metorial",
                    "is_verified",
                    "is_official"
                  ]
                ]
              ],
              "image_url",
              [
                "provider",
                0,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          [
                            "publisher",
                            0,
                            [1, ["image_url", "created_at", "updated_at"]]
                          ],
                          [
                            "current_version",
                            1,
                            [
                              1,
                              [
                                "provider_id",
                                "is_current",
                                "specification_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "oauth",
                            0,
                            [1, ["callback_url", "auto_registration"]]
                          ],
                          "created_at",
                          "updated_at",
                          [
                            "type",
                            0,
                            [
                              1,
                              [
                                [
                                  "triggers",
                                  0,
                                  [3, [[0, [1, ["webhook_registration"]]]]]
                                ],
                                [
                                  "auth",
                                  0,
                                  [
                                    3,
                                    [
                                      [
                                        0,
                                        [
                                          1,
                                          [
                                            [
                                              "oauth",
                                              0,
                                              [
                                                3,
                                                [
                                                  [
                                                    0,
                                                    [
                                                      1,
                                                      [
                                                        "oauth_callback_url",
                                                        "oauth_auto_registration"
                                                      ]
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at"
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              ["categories", 0, [2, 8]],
              ["collections", 0, [2, 8]],
              ["groups", 0, [2, 8]],
              "created_at",
              "updated_at",
              ["docs", 0, [1, ["auth_methods"]]]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderListingsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_category_id",
          "provider_collection_id",
          "provider_group_id",
          "publisher_id",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ],
          "is_public",
          "only_from_tenant",
          "is_verified",
          "is_official",
          "is_metorial",
          "order_by_rank",
          "order_by_use",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderListingsResetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderListingsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            [
              "attributes",
              0,
              [
                1,
                [
                  "is_public",
                  "is_customized",
                  "is_metorial",
                  "is_verified",
                  "is_official"
                ]
              ]
            ],
            "image_url",
            [
              "provider",
              0,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        [
                          "publisher",
                          0,
                          [1, ["image_url", "created_at", "updated_at"]]
                        ],
                        [
                          "current_version",
                          1,
                          [
                            1,
                            [
                              "provider_id",
                              "is_current",
                              "specification_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "oauth",
                          0,
                          [1, ["callback_url", "auto_registration"]]
                        ],
                        "created_at",
                        "updated_at",
                        [
                          "type",
                          0,
                          [
                            1,
                            [
                              [
                                "triggers",
                                0,
                                [3, [[0, [1, ["webhook_registration"]]]]]
                              ],
                              [
                                "auth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          [
                                            "oauth",
                                            0,
                                            [
                                              3,
                                              [
                                                [
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "oauth_callback_url",
                                                      "oauth_auto_registration"
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ],
                              "created_at"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            ["categories", 0, [2, 8]],
            ["collections", 0, [2, 8]],
            ["groups", 0, [2, 8]],
            "created_at",
            "updated_at",
            ["docs", 0, [1, ["auth_methods"]]]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProviderListingsUpdateBody = /* @__PURE__ */ mapObject([
  "image_url",
  "provider_category_ids",
  "provider_collection_ids"
]);
var mapProviderRunsGetLogsOutput = /* @__PURE__ */ mapObject([
  "provider_run_id",
  ["logs", 0, [2, [1, [["timestamp", 0, 4], "output_type"]]]]
]);
var mapProviderRunsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "session_provider_id",
    "provider_id",
    "connection_id",
    "completed_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapProviderRunsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "session_provider_id",
        "provider_id",
        "connection_id",
        "completed_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProviderRunsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "provider_id",
          "session_provider_id",
          "session_connection_id",
          "provider_version_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProviderSpecificationChangeNotificationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "provider_version_id",
    ["from_specification", 1, 8],
    ["to_specification", 1, 8],
    ["from_provider_version", 1, 8],
    ["to_provider_version", 1, 8],
    "created_at"
  ],
  1
);
var mapProviderSpecificationChangeNotificationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "provider_version_id",
        ["from_specification", 1, 8],
        ["to_specification", 1, 8],
        ["from_provider_version", 1, 8],
        ["to_provider_version", 1, 8],
        "created_at"
      ]
    ]
  ],
  1
);
var mapProviderSpecificationChangeNotificationsListQuery = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "provider_id",
            "provider_version_id",
            "provider_specification_id",
            ["created_at", 1, 5]
          ]
        ]
      ]
    ]
  ]
);
var mapProviderTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapProviderTemplatesCreateBody = /* @__PURE__ */ mapObject(["integration_id"]);
var mapProviderTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapProviderTemplatesGetOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapProviderTemplatesListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["integration_id", "created_at", "updated_at"]]],
  1
);
var mapProviderTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["integration_id"]]]]
]);
var mapProviderTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  ["integration_id", "created_at", "updated_at"],
  1
);
var mapProviderTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapProvidersAuthMethodsGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    "provider_id",
    "provider_specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapProvidersAuthMethodsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        "provider_id",
        "provider_specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProvidersAuthMethodsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id"]]]]
]);
var mapProvidersGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            ["publisher", 0, [1, ["image_url", "created_at", "updated_at"]]],
            [
              "current_version",
              1,
              [
                1,
                [
                  "provider_id",
                  "is_current",
                  "specification_id",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
            "created_at",
            "updated_at",
            [
              "type",
              0,
              [
                1,
                [
                  ["triggers", 0, [3, [[0, [1, ["webhook_registration"]]]]]],
                  [
                    "auth",
                    0,
                    [
                      3,
                      [
                        [
                          0,
                          [
                            1,
                            [
                              [
                                "oauth",
                                0,
                                [
                                  3,
                                  [
                                    [
                                      0,
                                      [
                                        1,
                                        [
                                          "oauth_callback_url",
                                          "oauth_auto_registration"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              [
                "publisher",
                0,
                [1, ["image_url", "created_at", "updated_at"]]
              ],
              [
                "current_version",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "is_current",
                    "specification_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              ["oauth", 0, [1, ["callback_url", "auto_registration"]]],
              "created_at",
              "updated_at",
              [
                "type",
                0,
                [
                  1,
                  [
                    [
                      "triggers",
                      0,
                      [3, [[0, [1, ["webhook_registration"]]]]]
                    ],
                    [
                      "auth",
                      0,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                [
                                  "oauth",
                                  0,
                                  [
                                    3,
                                    [
                                      [
                                        0,
                                        [
                                          1,
                                          [
                                            "oauth_callback_url",
                                            "oauth_auto_registration"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "auth_method",
          "auth_setup",
          [
            "capabilities",
            0,
            [
              1,
              [
                ["supportsOAuth", "supportsOauth"],
                [
                  "supportsOAuthAutoRegistration",
                  "supportsOauthAutoRegistration"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapProvidersSpecificationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "config_schema",
    "config_visibility",
    [
      "tools",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    ["tool_categories", 1, [2, [1, ["image_url", "tool_count"]]]],
    [
      "auth_methods",
      1,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            "provider_id",
            "provider_specification_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapProvidersSpecificationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "config_schema",
        "config_visibility",
        [
          "tools",
          0,
          [
            2,
            [
              1,
              [
                "input_schema",
                "output_schema",
                ["tags", 0, [1, ["read_only"]]],
                "tool_category_keys",
                "specification_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        ["tool_categories", 1, [2, [1, ["image_url", "tool_count"]]]],
        [
          "auth_methods",
          1,
          [
            2,
            [
              1,
              [
                "input_schema",
                "output_schema",
                "provider_id",
                "provider_specification_id",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProvidersSpecificationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "provider_version_id",
          "provider_deployment_id",
          "provider_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapProvidersToolsGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    ["tags", 0, [1, ["read_only"]]],
    "tool_category_keys",
    "specification_id",
    "provider_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapProvidersToolsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        ["tags", 0, [1, ["read_only"]]],
        "tool_category_keys",
        "specification_id",
        "provider_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProvidersToolsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id", "provider_auth_method_id"]]]]
]);
var mapProvidersTriggersGetOutput = /* @__PURE__ */ mapObject(
  [
    "input_schema",
    "output_schema",
    [
      "invocation",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              ["interval_seconds", "auto_registration", "auto_unregistration"]
            ]
          ]
        ]
      ]
    ],
    "provider_id",
    "provider_specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapProvidersTriggersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "input_schema",
        "output_schema",
        [
          "invocation",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    "interval_seconds",
                    "auto_registration",
                    "auto_unregistration"
                  ]
                ]
              ]
            ]
          ]
        ],
        "provider_id",
        "provider_specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProvidersTriggersListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_version_id"]]]]
]);
var mapProvidersVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "is_current",
    "specification_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapProvidersVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "is_current",
        "specification_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapProvidersVersionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapPublicMcpServersClientsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "client_id",
              "client_uri",
              "logo_uri",
              "redirect_uris",
              "token_endpoint_auth_method",
              "last_used_at",
              "expires_at",
              "created_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapPublicMcpServersClientsListQuery = /* @__PURE__ */ createMapper(0);
var mapPublicMcpServersCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPublicMcpServersCreateBody = /* @__PURE__ */ mapObject([
  "provider_deployment_id",
  "tool_filters",
  "redirect_uri_filters",
  "max_active_grants",
  "access_token_ttl_seconds",
  "refresh_token_ttl_seconds",
  "grant_idle_expiry_seconds"
]);
var mapPublicMcpServersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPublicMcpServersGetOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPublicMcpServersGrantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "revoked_reason",
    "public_mcp_server_id",
    ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
    "last_used_at",
    "revoked_at",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPublicMcpServersGrantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "revoked_reason",
        "public_mcp_server_id",
        ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
        "last_used_at",
        "revoked_at",
        "expires_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapPublicMcpServersGrantsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, [["created_at", 1, 5]]]]]
]);
var mapPublicMcpServersGrantsRevokeOutput = /* @__PURE__ */ mapObject(
  [
    "revoked_reason",
    "public_mcp_server_id",
    ["client", 0, [1, ["client_id", "client_uri", "logo_uri"]]],
    "last_used_at",
    "revoked_at",
    "expires_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPublicMcpServersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connect_url",
        "alternate_connect_urls",
        "provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "redirect_uri_filters",
        "max_active_grants",
        "access_token_ttl_seconds",
        "refresh_token_ttl_seconds",
        "grant_idle_expiry_seconds",
        ["owner_actor", 1, [1, ["consumer_id"]]],
        "disabled_at",
        "archived_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapPublicMcpServersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["provider_deployment_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapPublicMcpServersSlugsCheckOutput = /* @__PURE__ */ mapObject(["is_available"]);
var mapPublicMcpServersSlugsCheckQuery = /* @__PURE__ */ createMapper(0);
var mapPublicMcpServersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connect_url",
    "alternate_connect_urls",
    "provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "redirect_uri_filters",
    "max_active_grants",
    "access_token_ttl_seconds",
    "refresh_token_ttl_seconds",
    "grant_idle_expiry_seconds",
    ["owner_actor", 1, [1, ["consumer_id"]]],
    "disabled_at",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapPublicMcpServersUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters",
  "redirect_uri_filters",
  "max_active_grants",
  "access_token_ttl_seconds",
  "refresh_token_ttl_seconds",
  "grant_idle_expiry_seconds"
]);
var mapPublishersGetOutput = /* @__PURE__ */ mapObject(
  ["image_url", "created_at", "updated_at"],
  1
);
var mapPublishersListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["image_url", "created_at", "updated_at"]]],
  1
);
var mapPublishersListQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxDisksCloneOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxDisksCloneBody = /* @__PURE__ */ createMapper(0);
var mapSandboxDisksCreateOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxDisksCreateBody = /* @__PURE__ */ mapObject(["size_bytes"]);
var mapSandboxDisksDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxDisksGetOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxDisksListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "size_bytes",
        ["machine", 0, [1, ["mount_path"]]],
        ["active_resize", 1, [1, ["target_size_bytes"]]],
        "created_at",
        "updated_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapSandboxDisksListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_id"]]]]
]);
var mapSandboxDisksMountsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "disk_id",
        "machine_id",
        "machine_instance_id",
        "mount_path",
        "mounted_at",
        "released_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSandboxDisksMountsListQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxDisksResizeOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapSandboxDisksResizeBody = /* @__PURE__ */ mapObject(["size_bytes"]);
var mapSandboxDisksResizesGetOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapSandboxDisksResizesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "disk_id",
        "original_size_bytes",
        "target_size_bytes",
        "machine_ids",
        "created_at",
        "updated_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapSandboxDisksResizesListQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxDisksResizesRetryOutput = /* @__PURE__ */ mapObject(
  [
    "disk_id",
    "original_size_bytes",
    "target_size_bytes",
    "machine_ids",
    "created_at",
    "updated_at",
    "completed_at"
  ],
  1
);
var mapSandboxDisksUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "size_bytes",
    ["machine", 0, [1, ["mount_path"]]],
    ["active_resize", 1, [1, ["target_size_bytes"]]],
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxDisksUpdateBody = /* @__PURE__ */ createMapper(0);
var mapSandboxImageBuildsCancelOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapSandboxImageBuildsGetOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapSandboxImageBuildsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_id",
        "version_id",
        "version_number",
        "file_id",
        "dockerfile_path",
        "context_path",
        "build_arg_names",
        "timeout_seconds",
        "disk_size_bytes",
        "has_logs",
        "context_uploaded_at",
        "built_at",
        "ended_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSandboxImageBuildsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_id", "image_version_id"]]]]
]);
var mapSandboxImageBuildsLogsOutput = /* @__PURE__ */ mapObject([
  ["lines", 0, [2, [1, [["timestamp", 0, 4]]]]],
  "next_cursor",
  "has_more",
  "line_count"
]);
var mapSandboxImageBuildsLogsQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxImagesBuildsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "image_id",
    "version_id",
    "version_number",
    "file_id",
    "dockerfile_path",
    "context_path",
    "build_arg_names",
    "timeout_seconds",
    "disk_size_bytes",
    "has_logs",
    "context_uploaded_at",
    "built_at",
    "ended_at",
    "created_at"
  ],
  1
);
var mapSandboxImagesBuildsCreateBody = /* @__PURE__ */ mapObject([
  "file_id",
  "dockerfile_path",
  "context_path",
  "build_args",
  "timeout_seconds",
  "disk_size_bytes"
]);
var mapSandboxImagesBuildsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_id",
        "version_id",
        "version_number",
        "file_id",
        "dockerfile_path",
        "context_path",
        "build_arg_names",
        "timeout_seconds",
        "disk_size_bytes",
        "has_logs",
        "context_uploaded_at",
        "built_at",
        "ended_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSandboxImagesBuildsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_version_id"]]]]
]);
var mapSandboxImagesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxImagesCreateBody = /* @__PURE__ */ createMapper(0);
var mapSandboxImagesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxImagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxImagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "latest_version_id",
        "latest_version_number",
        "created_at",
        "updated_at",
        "deleted_at"
      ]
    ]
  ],
  1
);
var mapSandboxImagesListQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxImagesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "latest_version_id",
    "latest_version_number",
    "created_at",
    "updated_at",
    "deleted_at"
  ],
  1
);
var mapSandboxImagesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapSandboxImagesVersionsGetOutput = /* @__PURE__ */ mapObject(
  ["image_id", "version_number", "build_id", "created_at", "updated_at"],
  1
);
var mapSandboxImagesVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      ["image_id", "version_number", "build_id", "created_at", "updated_at"]
    ]
  ],
  1
);
var mapSandboxImagesVersionsListQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxMachinesAccessFilesOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapSandboxMachinesAccessFilesBody = /* @__PURE__ */ mapObject(["ttl_seconds"]);
var mapSandboxMachinesAccessPortsOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapSandboxMachinesAccessPortsBody = /* @__PURE__ */ mapObject(["ttl_seconds"]);
var mapSandboxMachinesAccessShellOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapSandboxMachinesAccessShellBody = /* @__PURE__ */ mapObject(["ttl_seconds"]);
var mapSandboxMachinesCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesCreateBody = /* @__PURE__ */ mapObject([
  "image_id",
  "spec_id",
  "spec_identifier",
  "memory_gib",
  [
    "lifecycle_policy",
    1,
    [
      1,
      [
        "pause_after_idle_seconds",
        "hibernate_after_paused_seconds",
        "connection_idle_seconds"
      ]
    ]
  ],
  ["runtime", 0, [1, ["stop_signal"]]],
  ["lifecycle_hooks", 1, [2, [3, [[0, [1, ["timeout_seconds"]]]]]]],
  "ignore_image_hooks",
  "entrypoint_wait_seconds",
  ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
  "firewall_ids",
  "public_ports"
]);
var mapSandboxMachinesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "machine_instance_id",
    "operation_id",
    "event_id",
    "exit_code",
    "duration_ms",
    "occurred_at"
  ],
  1
);
var mapSandboxMachinesErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "machine_instance_id",
        "operation_id",
        "event_id",
        "exit_code",
        "duration_ms",
        "occurred_at"
      ]
    ]
  ],
  1
);
var mapSandboxMachinesErrorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_instance_id"]]]]
]);
var mapSandboxMachinesEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "machine_instance_id",
    ["machine", 0, [1, ["from_status", "to_status"]]],
    ["instance", 0, [1, ["from_status", "to_status"]]],
    "operation_id",
    "guest_error_id",
    "occurred_at"
  ],
  1
);
var mapSandboxMachinesEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "machine_instance_id",
        ["machine", 0, [1, ["from_status", "to_status"]]],
        ["instance", 0, [1, ["from_status", "to_status"]]],
        "operation_id",
        "guest_error_id",
        "occurred_at"
      ]
    ]
  ],
  1
);
var mapSandboxMachinesEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_instance_id"]]]]
]);
var mapSandboxMachinesExecOutput = /* @__PURE__ */ mapObject([
  "exit_code",
  "timed_out",
  "stdout_truncated",
  "stderr_truncated"
]);
var mapSandboxMachinesExecBody = /* @__PURE__ */ mapObject(["timeout_seconds"]);
var mapSandboxMachinesGetOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesHibernateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesInstancesGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "creation_reason",
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["operation", 0, [1, ["requested_at"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "disks_ready",
    [
      "runtime",
      0,
      [
        1,
        [
          ["setup", 0, [2, [1, ["exit_code", "duration_ms"]]]],
          ["entrypoint", 0, [1, ["started_after_ms", "exit_code"]]]
        ]
      ]
    ],
    "has_logs",
    "created_at",
    "started_at",
    "ready_at",
    "paused_at",
    "terminated_at",
    "last_seen_at"
  ],
  1
);
var mapSandboxMachinesInstancesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "creation_reason",
        ["image", 0, [1, ["version_id"]]],
        ["spec", 0, [1, ["memory_gib"]]],
        ["operation", 0, [1, ["requested_at"]]],
        ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
        "disks_ready",
        [
          "runtime",
          0,
          [
            1,
            [
              ["setup", 0, [2, [1, ["exit_code", "duration_ms"]]]],
              ["entrypoint", 0, [1, ["started_after_ms", "exit_code"]]]
            ]
          ]
        ],
        "has_logs",
        "created_at",
        "started_at",
        "ready_at",
        "paused_at",
        "terminated_at",
        "last_seen_at"
      ]
    ]
  ],
  1
);
var mapSandboxMachinesInstancesListQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxMachinesInstancesLogsOutput = /* @__PURE__ */ mapObject([
  ["lines", 0, [2, [1, [["timestamp", 0, 4]]]]],
  "next_cursor",
  "has_more",
  "line_count"
]);
var mapSandboxMachinesInstancesLogsQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxMachinesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["image", 0, [1, ["version_id"]]],
        ["spec", 0, [1, ["memory_gib"]]],
        ["max_boost", 1, [1, ["memory_gib"]]],
        ["root_disk", 1, [1, ["size_bytes"]]],
        ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
        "firewall_ids",
        "public_ports",
        [
          "lifecycle_policy",
          1,
          [
            1,
            [
              "pause_after_idle_seconds",
              "hibernate_after_paused_seconds",
              "connection_idle_seconds"
            ]
          ]
        ],
        ["runtime", 0, [1, ["stop_signal"]]],
        ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
        "ignore_image_hooks",
        "entrypoint_wait_seconds",
        ["operation", 0, [1, ["requested_at"]]],
        "current_instance",
        "restart_required",
        "last_activity_at",
        "pause_at",
        "hibernates_at",
        ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
        "created_at",
        "running_at",
        "paused_at",
        "hibernated_at",
        "terminated_at"
      ]
    ]
  ],
  1
);
var mapSandboxMachinesListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["image_id"]]]]
]);
var mapSandboxMachinesOperationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "machine_id",
    "from_machine_instance_id",
    "superseded_by_id",
    ["instance_operations", 1, [2, [1, ["machine_instance_id"]]]],
    "requested_at",
    "completed_at"
  ],
  1
);
var mapSandboxMachinesOperationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "machine_id",
        "from_machine_instance_id",
        "superseded_by_id",
        ["instance_operations", 1, [2, [1, ["machine_instance_id"]]]],
        "requested_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapSandboxMachinesOperationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_instance_id"]]]]
]);
var mapSandboxMachinesPauseOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesRestartOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesStartOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesTouchOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["image", 0, [1, ["version_id"]]],
    ["spec", 0, [1, ["memory_gib"]]],
    ["max_boost", 1, [1, ["memory_gib"]]],
    ["root_disk", 1, [1, ["size_bytes"]]],
    ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
    "firewall_ids",
    "public_ports",
    [
      "lifecycle_policy",
      1,
      [
        1,
        [
          "pause_after_idle_seconds",
          "hibernate_after_paused_seconds",
          "connection_idle_seconds"
        ]
      ]
    ],
    ["runtime", 0, [1, ["stop_signal"]]],
    ["lifecycle_hooks", 1, [2, [1, ["timeout_seconds"]]]],
    "ignore_image_hooks",
    "entrypoint_wait_seconds",
    ["operation", 0, [1, ["requested_at"]]],
    "current_instance",
    "restart_required",
    "last_activity_at",
    "pause_at",
    "hibernates_at",
    ["upcoming_events", 1, [2, [1, ["occurs_at"]]]],
    "created_at",
    "running_at",
    "paused_at",
    "hibernated_at",
    "terminated_at"
  ],
  1
);
var mapSandboxMachinesUpdateBody = /* @__PURE__ */ mapObject([
  "spec_id",
  "spec_identifier",
  "memory_gib",
  [
    "lifecycle_policy",
    1,
    [
      1,
      [
        "pause_after_idle_seconds",
        "hibernate_after_paused_seconds",
        "connection_idle_seconds"
      ]
    ]
  ],
  ["runtime", 0, [1, ["stop_signal"]]],
  ["lifecycle_hooks", 1, [2, [3, [[0, [1, ["timeout_seconds"]]]]]]],
  "ignore_image_hooks",
  "entrypoint_wait_seconds",
  ["mounts", 0, [2, [1, ["disk_id", "mount_path"]]]],
  "firewall_ids",
  "public_ports"
]);
var mapSandboxMachinesUsageSummaryOutput = /* @__PURE__ */ mapObject([
  "machine_id",
  ["from", 0, 4],
  ["to", 0, 4],
  "group_by",
  [
    "groups",
    0,
    [
      2,
      [
        1,
        [
          ["group", 0, [1, ["machine_instance_id"]]],
          [
            "totals",
            0,
            [
              1,
              [
                "runtime_seconds",
                "cpu_core_seconds",
                "average_cores_used",
                "cpu_percent",
                "peak_cores_used",
                "memory_byte_seconds",
                "average_memory_used_bytes",
                "peak_memory_used_bytes",
                "allocated_memory_byte_seconds",
                "average_memory_allocated_bytes",
                "network_rx_bytes",
                "network_tx_bytes",
                "disk_read_bytes",
                "disk_write_bytes"
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapSandboxMachinesUsageSummaryQuery = /* @__PURE__ */ mapObject([
  ["from", 0, 4],
  ["to", 0, 4],
  "machine_instance_id",
  "group_by",
  "max_series"
]);
var mapSandboxMachinesUsageTimelineOutput = /* @__PURE__ */ mapObject([
  "machine_id",
  ["from", 0, 4],
  ["to", 0, 4],
  "group_by",
  [
    "series",
    0,
    [
      2,
      [
        1,
        [
          ["group", 0, [1, ["machine_instance_id"]]],
          [
            "points",
            0,
            [
              2,
              [
                1,
                [
                  ["timestamp", 0, 4],
                  "runtime_seconds",
                  "cpu_core_seconds",
                  "average_cores_used",
                  "cpu_percent",
                  "peak_cores_used",
                  "memory_byte_seconds",
                  "average_memory_used_bytes",
                  "peak_memory_used_bytes",
                  "allocated_memory_byte_seconds",
                  "average_memory_allocated_bytes",
                  "network_rx_bytes",
                  "network_tx_bytes",
                  "disk_read_bytes",
                  "disk_write_bytes"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapSandboxMachinesUsageTimelineQuery = /* @__PURE__ */ mapObject([
  ["from", 0, 4],
  ["to", 0, 4],
  "machine_instance_id",
  "group_by",
  "max_series"
]);
var mapSandboxMachinesUsageOutput = /* @__PURE__ */ createMapper([
  7,
  [
    1,
    [
      "machine_instance_id",
      ["timestamp", 0, 4],
      "cpu_percent",
      "cores_used",
      "cores_available",
      "memory_used_bytes",
      "memory_total_bytes",
      "network_rx_bytes",
      "network_tx_bytes",
      "disk_read_bytes",
      "disk_write_bytes"
    ]
  ]
]);
var mapSandboxMachinesUsageQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["machine_instance_id"]]]]
]);
var mapSandboxRegionsGetOutput = /* @__PURE__ */ mapObject(["is_default"]);
var mapSandboxRegionsListOutput = /* @__PURE__ */ createMapper([
  7,
  [1, ["is_default"]]
]);
var mapSandboxRegionsListQuery = /* @__PURE__ */ createMapper(0);
var mapSandboxSpecsGetOutput = /* @__PURE__ */ mapObject(
  ["memory_gib", "created_at"],
  1
);
var mapSandboxSpecsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["memory_gib", "created_at"]]],
  1
);
var mapSandboxSpecsListQuery = /* @__PURE__ */ createMapper(0);
var mapScmAccountsPreviewOutput = /* @__PURE__ */ mapObject([
  ["accounts", 0, [2, [1, ["external_id", "image_url"]]]]
]);
var mapScmAccountsPreviewBody = /* @__PURE__ */ mapObject(["installation_id"]);
var mapScmConnectionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "connection",
      0,
      [
        1,
        [
          "external_installation_id",
          "account_type",
          ["external_account", 1, [1, ["image_url"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapScmConnectionsCreateBody = /* @__PURE__ */ mapObject(["redirect_url"]);
var mapScmConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "external_installation_id",
    "account_type",
    ["external_account", 1, [1, ["image_url"]]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapScmConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "external_installation_id",
        "account_type",
        ["external_account", 1, [1, ["image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapScmConnectionsListQuery = /* @__PURE__ */ createMapper(0);
var mapScmInstallationCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "connection",
      0,
      [
        1,
        [
          "external_installation_id",
          "account_type",
          ["external_account", 1, [1, ["image_url"]]],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapScmInstallationCreateBody = /* @__PURE__ */ mapObject(["redirect_url"]);
var mapScmInstallationListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "external_installation_id",
        "account_type",
        ["external_account", 1, [1, ["image_url"]]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapScmInstallationListQuery = /* @__PURE__ */ createMapper(0);
var mapScmProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "provider",
      0,
      [1, ["api_url", "web_url", "is_default", "created_at", "updated_at"]]
    ],
    "created_at",
    "expires_at"
  ],
  1
);
var mapScmProvidersCreateBody = /* @__PURE__ */ createMapper(0);
var mapScmProvidersGetOutput = /* @__PURE__ */ mapObject(
  ["api_url", "web_url", "is_default", "created_at", "updated_at"],
  1
);
var mapScmProvidersListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["api_url", "web_url", "is_default", "created_at", "updated_at"]]],
  1
);
var mapScmProvidersListQuery = /* @__PURE__ */ createMapper(0);
var mapScmReposCreateOutput = /* @__PURE__ */ mapObject(
  ["is_private", "default_branch", "created_at"],
  1
);
var mapScmReposCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "installation_id",
          "external_repo_id",
          "external_account_id",
          "is_private"
        ]
      ]
    ]
  ]
]);
var mapScmReposGetOutput = /* @__PURE__ */ mapObject(
  ["is_private", "default_branch", "created_at"],
  1
);
var mapScmReposListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["is_private", "default_branch", "created_at"]]],
  1
);
var mapScmReposListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapScmReposPreviewOutput = /* @__PURE__ */ mapObject([
  ["repos", 0, [2, [1, ["external_id"]]]],
  "next_cursor"
]);
var mapScmReposPreviewBody = /* @__PURE__ */ mapObject([
  "installation_id",
  "external_account_id"
]);
var mapSessionTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesCreateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [
      2,
      [
        1,
        [
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "tool_filters"
        ]
      ]
    ]
  ]
]);
var mapSessionTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesGetOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesListToolsOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "input_schema",
            "output_schema",
            ["tags", 0, [1, ["read_only"]]],
            "tool_category_keys",
            "specification_id",
            "provider_id",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSessionTemplatesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "integration_instance_id",
        "integration_instance_group_id",
        "identity_actor_id",
        "identity_id",
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "session_template_id",
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_config",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSessionTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionTemplatesProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesProvidersCreateBody = /* @__PURE__ */ mapObject([
  "session_template_id",
  "provider_deployment_id",
  "provider_config_id",
  "provider_config_vault_id",
  "provider_auth_config_id",
  "tool_filters"
]);
var mapSessionTemplatesProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "session_template_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "auth_config",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSessionTemplatesProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_template_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionTemplatesProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_template_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesProvidersUpdateBody = /* @__PURE__ */ mapObject([
  "tool_filters"
]);
var mapSessionTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "integration_instance_id",
    "integration_instance_group_id",
    "identity_actor_id",
    "identity_id",
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_template_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapSessionsConnectionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["mcp", 0, [1, ["protocol_version"]]],
    "session_id",
    [
      "participant",
      0,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    "has_errors",
    "has_warnings",
    "created_at",
    "last_message_at",
    "last_active_at"
  ],
  1
);
var mapSessionsConnectionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_state",
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        ["mcp", 0, [1, ["protocol_version"]]],
        "session_id",
        [
          "participant",
          0,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        "has_errors",
        "has_warnings",
        "created_at",
        "last_message_at",
        "last_active_at"
      ]
    ]
  ],
  1
);
var mapSessionsConnectionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "connection_state",
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "session_id",
          "session_provider_id",
          "participant_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsCreateBody = /* @__PURE__ */ mapObject([
  [
    "providers",
    0,
    [
      2,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "provider_deployment_id",
                [
                  "provider_deployment",
                  1,
                  [1, ["provider_id", "locked_provider_version_id"]]
                ],
                "provider_config_id",
                [
                  "provider_config",
                  1,
                  [3, [[0, [1, ["provider_config_vault_id", "provider_id"]]]]]
                ],
                "provider_auth_config_id",
                [
                  "provider_auth_config",
                  1,
                  [1, ["provider_auth_method_id", "provider_id"]]
                ],
                "session_template_id",
                "tool_filters"
              ]
            ]
          ]
        ]
      ]
    ]
  ]
]);
var mapSessionsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsErrorGroupsGetOutput = /* @__PURE__ */ mapObject(
  ["provider_id", "occurrence_count", "created_at"],
  1
);
var mapSessionsErrorGroupsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["provider_id", "occurrence_count", "created_at"]]],
  1
);
var mapSessionsErrorGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["session_id", "provider_id"]]]]
]);
var mapSessionsErrorsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "provider_run_id",
    "connection_id",
    "group_id",
    "similar_error_count",
    "created_at"
  ],
  1
);
var mapSessionsErrorsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "provider_run_id",
        "connection_id",
        "group_id",
        "similar_error_count",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSessionsErrorsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "session_error_group_id",
          "provider_run_id",
          "provider_id",
          "session_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    [
      "connection",
      0,
      [
        1,
        [
          "connection_state",
          [
            "usage",
            0,
            [
              1,
              [
                "total_productive_client_message_count",
                "total_productive_provider_message_count"
              ]
            ]
          ],
          ["mcp", 0, [1, ["protocol_version"]]],
          "session_id",
          [
            "participant",
            0,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          "has_errors",
          "has_warnings",
          "created_at",
          "last_message_at",
          "last_active_at"
        ]
      ]
    ],
    [
      "provider_run",
      1,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "provider_id",
          "connection_id",
          "completed_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "message",
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "connection_id",
          "provider_run_id",
          ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
          [
            "transport",
            0,
            [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
          ],
          [
            "tool_call",
            1,
            [
              1,
              [
                "tool_key",
                "session_id",
                "message_id",
                "session_provider_id",
                "connection_id",
                "provider_run_id",
                [
                  "sender_participant",
                  1,
                  [
                    1,
                    [
                      "provider_id",
                      "connection_type",
                      "agent_id",
                      "agent_instance_id",
                      "identity_actor_id",
                      "identity_id",
                      "agent_actor_id",
                      "agent_client_id",
                      "consumer_id",
                      "created_at"
                    ]
                  ]
                ],
                [
                  "responder_participant",
                  1,
                  [
                    1,
                    [
                      "provider_id",
                      "connection_type",
                      "agent_id",
                      "agent_instance_id",
                      "identity_actor_id",
                      "identity_id",
                      "agent_actor_id",
                      "agent_client_id",
                      "consumer_id",
                      "created_at"
                    ]
                  ]
                ],
                [
                  "tool",
                  0,
                  [
                    1,
                    [
                      "input_schema",
                      "output_schema",
                      ["tags", 0, [1, ["read_only"]]],
                      "tool_category_keys",
                      "specification_id",
                      "provider_id",
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "error",
                  0,
                  [
                    1,
                    [
                      "session_id",
                      "provider_run_id",
                      "connection_id",
                      "group_id",
                      "similar_error_count",
                      "created_at"
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          [
            "sender_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "responder_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "error",
            0,
            [
              1,
              [
                "session_id",
                "provider_run_id",
                "connection_id",
                "group_id",
                "similar_error_count",
                "created_at"
              ]
            ]
          ],
          "created_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    ["warning", 0, [1, ["session_id", "connection_id", "created_at"]]],
    "created_at"
  ],
  1
);
var mapSessionsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        [
          "connection",
          0,
          [
            1,
            [
              "connection_state",
              [
                "usage",
                0,
                [
                  1,
                  [
                    "total_productive_client_message_count",
                    "total_productive_provider_message_count"
                  ]
                ]
              ],
              ["mcp", 0, [1, ["protocol_version"]]],
              "session_id",
              [
                "participant",
                0,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              "has_errors",
              "has_warnings",
              "created_at",
              "last_message_at",
              "last_active_at"
            ]
          ]
        ],
        [
          "provider_run",
          1,
          [
            1,
            [
              "session_id",
              "session_provider_id",
              "provider_id",
              "connection_id",
              "completed_at",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "message",
          0,
          [
            1,
            [
              "session_id",
              "session_provider_id",
              "connection_id",
              "provider_run_id",
              [
                "hierarchy",
                0,
                [1, ["parent_message_id", "child_message_ids"]]
              ],
              [
                "transport",
                0,
                [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
              ],
              [
                "tool_call",
                1,
                [
                  1,
                  [
                    "tool_key",
                    "session_id",
                    "message_id",
                    "session_provider_id",
                    "connection_id",
                    "provider_run_id",
                    [
                      "sender_participant",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "connection_type",
                          "agent_id",
                          "agent_instance_id",
                          "identity_actor_id",
                          "identity_id",
                          "agent_actor_id",
                          "agent_client_id",
                          "consumer_id",
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "responder_participant",
                      1,
                      [
                        1,
                        [
                          "provider_id",
                          "connection_type",
                          "agent_id",
                          "agent_instance_id",
                          "identity_actor_id",
                          "identity_id",
                          "agent_actor_id",
                          "agent_client_id",
                          "consumer_id",
                          "created_at"
                        ]
                      ]
                    ],
                    [
                      "tool",
                      0,
                      [
                        1,
                        [
                          "input_schema",
                          "output_schema",
                          ["tags", 0, [1, ["read_only"]]],
                          "tool_category_keys",
                          "specification_id",
                          "provider_id",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "error",
                      0,
                      [
                        1,
                        [
                          "session_id",
                          "provider_run_id",
                          "connection_id",
                          "group_id",
                          "similar_error_count",
                          "created_at"
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              [
                "sender_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "responder_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "error",
                0,
                [
                  1,
                  [
                    "session_id",
                    "provider_run_id",
                    "connection_id",
                    "group_id",
                    "similar_error_count",
                    "created_at"
                  ]
                ]
              ],
              "created_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        ["warning", 0, [1, ["session_id", "connection_id", "created_at"]]],
        "created_at"
      ]
    ]
  ],
  1
);
var mapSessionsEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "provider_run_id",
          "session_message_id",
          "session_error_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "connection_state",
        "connection_url",
        "client_secret",
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        [
          "providers",
          0,
          [
            2,
            [
              1,
              [
                [
                  "usage",
                  0,
                  [
                    1,
                    [
                      "total_productive_client_message_count",
                      "total_productive_provider_message_count"
                    ]
                  ]
                ],
                [
                  "tool_filter",
                  1,
                  [3, [[0, [1, ["ignore_parent_filters"]]]]]
                ],
                "provider_id",
                "session_id",
                "from_template_id",
                "from_template_provider_id",
                [
                  "deployment",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                [
                  "config",
                  0,
                  [
                    1,
                    ["is_default", "provider_id", "created_at", "updated_at"]
                  ]
                ],
                "auth_config",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "from_template_ids",
        "has_errors",
        "has_warnings",
        "identity_actor_id",
        "identity_id",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSessionsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "session_template_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionsMessagesGetOutput = /* @__PURE__ */ mapObject(
  [
    "session_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
    [
      "transport",
      0,
      [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
    ],
    [
      "tool_call",
      1,
      [
        1,
        [
          "tool_key",
          "session_id",
          "message_id",
          "session_provider_id",
          "connection_id",
          "provider_run_id",
          [
            "sender_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "responder_participant",
            1,
            [
              1,
              [
                "provider_id",
                "connection_type",
                "agent_id",
                "agent_instance_id",
                "identity_actor_id",
                "identity_id",
                "agent_actor_id",
                "agent_client_id",
                "consumer_id",
                "created_at"
              ]
            ]
          ],
          [
            "tool",
            0,
            [
              1,
              [
                "input_schema",
                "output_schema",
                ["tags", 0, [1, ["read_only"]]],
                "tool_category_keys",
                "specification_id",
                "provider_id",
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "error",
            0,
            [
              1,
              [
                "session_id",
                "provider_run_id",
                "connection_id",
                "group_id",
                "similar_error_count",
                "created_at"
              ]
            ]
          ],
          "created_at"
        ]
      ]
    ],
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapSessionsMessagesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "session_id",
        "session_provider_id",
        "connection_id",
        "provider_run_id",
        ["hierarchy", 0, [1, ["parent_message_id", "child_message_ids"]]],
        [
          "transport",
          0,
          [1, [["mcp", 0, [1, ["protocol_version"]]], "tool_call"]]
        ],
        [
          "tool_call",
          1,
          [
            1,
            [
              "tool_key",
              "session_id",
              "message_id",
              "session_provider_id",
              "connection_id",
              "provider_run_id",
              [
                "sender_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "responder_participant",
                1,
                [
                  1,
                  [
                    "provider_id",
                    "connection_type",
                    "agent_id",
                    "agent_instance_id",
                    "identity_actor_id",
                    "identity_id",
                    "agent_actor_id",
                    "agent_client_id",
                    "consumer_id",
                    "created_at"
                  ]
                ]
              ],
              [
                "tool",
                0,
                [
                  1,
                  [
                    "input_schema",
                    "output_schema",
                    ["tags", 0, [1, ["read_only"]]],
                    "tool_category_keys",
                    "specification_id",
                    "provider_id",
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "error",
                0,
                [
                  1,
                  [
                    "session_id",
                    "provider_run_id",
                    "connection_id",
                    "group_id",
                    "similar_error_count",
                    "created_at"
                  ]
                ]
              ],
              "created_at"
            ]
          ]
        ],
        [
          "sender_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "responder_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapSessionsMessagesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_provider_id",
          "session_connection_id",
          "provider_run_id",
          "error_id",
          "participant_id",
          "parent_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "provider_id",
    "connection_type",
    "agent_id",
    "agent_instance_id",
    "identity_actor_id",
    "identity_id",
    "agent_actor_id",
    "agent_client_id",
    "consumer_id",
    "created_at"
  ],
  1
);
var mapSessionsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "provider_id",
        "connection_type",
        "agent_id",
        "agent_instance_id",
        "identity_actor_id",
        "identity_id",
        "agent_actor_id",
        "agent_client_id",
        "consumer_id",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSessionsParticipantsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "session_id",
          "session_connection_id",
          "session_message_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionsProvidersCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsProvidersCreateBody = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "tool_filters",
          "provider_deployment_id",
          [
            "provider_deployment",
            1,
            [1, ["provider_id", "locked_provider_version_id"]]
          ],
          "provider_config_id",
          [
            "provider_config",
            1,
            [3, [[0, [1, ["provider_config_vault_id", "provider_id"]]]]]
          ],
          "provider_auth_config_id",
          [
            "provider_auth_config",
            1,
            [1, ["provider_auth_method_id", "provider_id"]]
          ]
        ]
      ]
    ]
  ]
]);
var mapSessionsProvidersDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsProvidersGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsProvidersListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "usage",
          0,
          [
            1,
            [
              "total_productive_client_message_count",
              "total_productive_provider_message_count"
            ]
          ]
        ],
        ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
        "provider_id",
        "session_id",
        "from_template_id",
        "from_template_provider_id",
        [
          "deployment",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        [
          "config",
          0,
          [1, ["is_default", "provider_id", "created_at", "updated_at"]]
        ],
        "auth_config",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSessionsProvidersListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_template_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSessionsProvidersUpdateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
    "provider_id",
    "session_id",
    "from_template_id",
    "from_template_provider_id",
    [
      "deployment",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    [
      "config",
      0,
      [1, ["is_default", "provider_id", "created_at", "updated_at"]]
    ],
    "auth_config",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsProvidersUpdateBody = /* @__PURE__ */ mapObject(["tool_filters"]);
var mapSessionsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "connection_state",
    "connection_url",
    "client_secret",
    [
      "usage",
      0,
      [
        1,
        [
          "total_productive_client_message_count",
          "total_productive_provider_message_count"
        ]
      ]
    ],
    [
      "providers",
      0,
      [
        2,
        [
          1,
          [
            [
              "usage",
              0,
              [
                1,
                [
                  "total_productive_client_message_count",
                  "total_productive_provider_message_count"
                ]
              ]
            ],
            ["tool_filter", 1, [3, [[0, [1, ["ignore_parent_filters"]]]]]],
            "provider_id",
            "session_id",
            "from_template_id",
            "from_template_provider_id",
            [
              "deployment",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            [
              "config",
              0,
              [1, ["is_default", "provider_id", "created_at", "updated_at"]]
            ],
            "auth_config",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "from_template_ids",
    "has_errors",
    "has_warnings",
    "identity_actor_id",
    "identity_id",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSessionsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapSkillsAgentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsAgentsCreateBody = /* @__PURE__ */ createMapper(0);
var mapSkillsAgentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsAgentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsAgentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        "store_id",
        "store_item_id",
        "document_id",
        "archived_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsAgentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["include_archived"]]]]
]);
var mapSkillsAgentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_item_id",
    "document_id",
    "archived_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsAgentsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapSkillsConfigurationsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsConfigurationsCreateBody = /* @__PURE__ */ mapObject([
  "allow_scripts",
  "allowed_file_extensions",
  "allow_non_standard_directories"
]);
var mapSkillsConfigurationsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsConfigurationsGetOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsConfigurationsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "is_default",
        "allow_scripts",
        "allowed_file_extensions",
        "allow_non_standard_directories",
        "deleted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsConfigurationsListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsConfigurationsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "is_default",
    "allow_scripts",
    "allowed_file_extensions",
    "allow_non_standard_directories",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsConfigurationsUpdateBody = /* @__PURE__ */ mapObject([
  "allow_scripts",
  "allowed_file_extensions",
  "allow_non_standard_directories"
]);
var mapSkillsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsCreateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id",
  "template_id",
  "skill_group_id"
]);
var mapSkillsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsDuplicateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsDuplicateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata"
]);
var mapSkillsExportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "started_at",
    "completed_at"
  ],
  1
);
var mapSkillsExportsCreateBody = /* @__PURE__ */ mapObject([
  "skill_id",
  "skill_plugin_id",
  "skill_marketplace_id"
]);
var mapSkillsExportsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "started_at",
    "completed_at"
  ],
  1
);
var mapSkillsExportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "file",
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        ["file_link", 1, [1, ["file_id", "created_at", "expires_at"]]],
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "started_at",
        "completed_at"
      ]
    ]
  ],
  1
);
var mapSkillsExportsListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsFilesBatchOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "previous_path",
        [
          "file",
          0,
          [
            1,
            [
              "skill_id",
              "store_item_id",
              "document_id",
              "file_id",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsFilesBatchBody = /* @__PURE__ */ mapObject([
  ["changes", 0, [2, [3, [[0, [1, ["file_id", "if_match", "to_path"]]]]]]]
]);
var mapSkillsFilesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapSkillsFilesDeleteQuery = /* @__PURE__ */ mapObject(["if_match"]);
var mapSkillsFilesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_item_id",
    "document_id",
    "file_id",
    "updated_at",
    "download_url"
  ],
  1
);
var mapSkillsFilesGetQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsFilesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [1, ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]]
  ],
  1
);
var mapSkillsFilesMoveOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapSkillsFilesMoveBody = /* @__PURE__ */ mapObject(["to_path", "if_match"]);
var mapSkillsFilesPutOutput = /* @__PURE__ */ mapObject(
  [
    "previous_path",
    [
      "file",
      0,
      [
        1,
        ["skill_id", "store_item_id", "document_id", "file_id", "updated_at"]
      ]
    ]
  ],
  1
);
var mapSkillsFilesPutBody = /* @__PURE__ */ mapObject(["file_id", "if_match"]);
var mapSkillsForkSyncsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "fork_skill_id",
    "upstream_skill_id",
    "merge_request_id",
    "processing_started_at",
    "action_required_at",
    "completed_at",
    "failed_at",
    "cancelled_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsForkSyncsCreateBody = /* @__PURE__ */ mapObject(["skill_id"]);
var mapSkillsForkSyncsGetOutput = /* @__PURE__ */ mapObject(
  [
    "fork_skill_id",
    "upstream_skill_id",
    "merge_request_id",
    "processing_started_at",
    "action_required_at",
    "completed_at",
    "failed_at",
    "cancelled_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsForkOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  ["assignment_id", "created_at", "updated_at"]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  ["assignment_id", "created_at", "updated_at"]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsForkBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id"
]);
var mapSkillsGetOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  ["assignment_id", "created_at", "updated_at"]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  ["assignment_id", "created_at", "updated_at"]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsGroupsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsGroupsCreateBody = /* @__PURE__ */ mapObject([
  "skill_ids",
  "allow_consumer_skill_assignment"
]);
var mapSkillsGroupsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsGroupsGetOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsGroupsItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapSkillsGroupsItemsCreateBody = /* @__PURE__ */ mapObject(["skill_id"]);
var mapSkillsGroupsItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapSkillsGroupsItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_group_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapSkillsGroupsItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_group_id",
        [
          "skill",
          0,
          [
            1,
            [
              "image_url",
              "client_name",
              "client_description",
              "client_metadata",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapSkillsGroupsItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["skill_id", ["created_at", 1, 5]]]]]
]);
var mapSkillsGroupsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "allow_consumer_skill_assignment",
        [
          "skills",
          0,
          [
            2,
            [
              1,
              [
                "image_url",
                "client_name",
                "client_description",
                "client_metadata",
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsGroupsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["skill_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapSkillsGroupsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "allow_consumer_skill_assignment",
    [
      "skills",
      0,
      [
        2,
        [
          1,
          [
            "image_url",
            "client_name",
            "client_description",
            "client_metadata",
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsGroupsUpdateBody = /* @__PURE__ */ mapObject([
  "skill_ids",
  "allow_consumer_skill_assignment"
]);
var mapSkillsImportsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "source",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "repository_url",
                "repository_name",
                "repository_id",
                "file_id",
                "file_name"
              ]
            ]
          ]
        ]
      ]
    ],
    ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapSkillsImportsCreateBody = /* @__PURE__ */ mapObject([
  [
    "source",
    0,
    [3, [[0, [1, ["repository_url", "repository_id", "file_id"]]]]]
  ]
]);
var mapSkillsImportsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "source",
      0,
      [
        3,
        [
          [
            0,
            [
              1,
              [
                "repository_url",
                "repository_name",
                "repository_id",
                "file_id",
                "file_name"
              ]
            ]
          ]
        ]
      ]
    ],
    ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
    "started_at",
    "completed_at",
    "created_at"
  ],
  1
);
var mapSkillsImportsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "source",
          0,
          [
            3,
            [
              [
                0,
                [
                  1,
                  [
                    "repository_url",
                    "repository_name",
                    "repository_id",
                    "file_id",
                    "file_name"
                  ]
                ]
              ]
            ]
          ]
        ],
        ["items", 0, [2, [1, ["started_at", "completed_at", "created_at"]]]],
        "started_at",
        "completed_at",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSkillsImportsListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapSkillsItemsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "integration_id"]]]]
]);
var mapSkillsItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapSkillsItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at"
  ],
  1
);
var mapSkillsItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        [
          "integration",
          0,
          [
            1,
            [
              [
                "configuration",
                0,
                [
                  1,
                  [
                    "can_attach_custom_tool_filters",
                    "can_attach_custom_provider_config",
                    "can_override_tool_filters",
                    "enable_callback_tools",
                    "use_integration_name_in_tool_names"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        ["provider", 0, 8],
        "created_at"
      ]
    ]
  ],
  1
);
var mapSkillsItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["integration_id", "provider_id", ["created_at", 1, 5]]]]]
]);
var mapSkillsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "image_url",
        "client_name",
        "client_description",
        "client_metadata",
        "store_id",
        [
          "hierarchy",
          0,
          [
            1,
            [
              "parent_skill_id",
              [
                "creator",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [1, ["assignment_id", "created_at", "updated_at"]]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [1, ["image_url", "user_id", "created_at", "updated_at"]]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              [
                "fork",
                0,
                [
                  1,
                  [
                    "parent_skill_id",
                    [
                      "creator",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          [
                            "organization_actor",
                            1,
                            [
                              1,
                              [
                                "organization_id",
                                "image_url",
                                [
                                  "teams",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        "assignment_id",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer",
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "user_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer_profile",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "consumer_id",
                                      "user_id",
                                      "created_at",
                                      "updated_at",
                                      [
                                        "groups",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              [
                                                "group",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "is_default",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "assigned_via"
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    [
                      "original_creator",
                      1,
                      [
                        1,
                        [
                          "image_url",
                          [
                            "organization_actor",
                            1,
                            [
                              1,
                              [
                                "organization_id",
                                "image_url",
                                [
                                  "teams",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        "assignment_id",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer",
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "user_id",
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ],
                          [
                            "consumer_profile",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "consumer_id",
                                      "user_id",
                                      "created_at",
                                      "updated_at",
                                      [
                                        "groups",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              [
                                                "group",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "is_default",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "assigned_via"
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ],
                    "created_at"
                  ]
                ]
              ],
              [
                "entity",
                0,
                [1, ["parent_skill_id", "created_at", "updated_at"]]
              ]
            ]
          ]
        ],
        [
          "integrations",
          0,
          [
            2,
            [
              1,
              [
                [
                  "configuration",
                  0,
                  [
                    1,
                    [
                      "can_attach_custom_tool_filters",
                      "can_attach_custom_provider_config",
                      "can_override_tool_filters",
                      "enable_callback_tools",
                      "use_integration_name_in_tool_names"
                    ]
                  ]
                ],
                "created_at",
                "updated_at",
                "archived_at"
              ]
            ]
          ]
        ],
        ["providers", 0, [2, 8]],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_group_id",
          "integration_id",
          "provider_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSkillsMarketplacesArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesCreateBody = /* @__PURE__ */ mapObject([
  "image_file_id",
  "skill_configuration_id",
  "repository_access_mode",
  "force_merge_or_push",
  "merge_before_checks_pass"
]);
var mapSkillsMarketplacesGetEditorUrlOutput = /* @__PURE__ */ mapObject(
  ["expires_at"],
  1
);
var mapSkillsMarketplacesGetEditorUrlBody = /* @__PURE__ */ createMapper(0);
var mapSkillsMarketplacesGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "repository_access_mode",
              "force_merge_or_push",
              "merge_before_checks_pass",
              "sync_status",
              "image_url",
              "skill_configuration_id",
              [
                "plugins",
                0,
                [
                  2,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "skill_configuration_id",
                            "skill_marketplace_id",
                            [
                              "skill_plugin",
                              1,
                              [
                                3,
                                [
                                  [
                                    0,
                                    [
                                      1,
                                      [
                                        "sync_status",
                                        "image_url",
                                        "long_description",
                                        "skill_configuration_id",
                                        [
                                          "skills",
                                          0,
                                          [
                                            2,
                                            [
                                              1,
                                              [
                                                "client_name",
                                                "client_description",
                                                "client_metadata",
                                                "skill_configuration_id",
                                                "skill_id",
                                                [
                                                  "skill",
                                                  0,
                                                  [
                                                    1,
                                                    [
                                                      "image_url",
                                                      "client_name",
                                                      "client_description",
                                                      "client_metadata",
                                                      "created_at",
                                                      "updated_at"
                                                    ]
                                                  ]
                                                ],
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ]
                                        ],
                                        "created_at",
                                        "updated_at",
                                        "can_update",
                                        "can_delete"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "can_create_plugins"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["skill_configuration_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapSkillsMarketplacesPluginsAddOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesPluginsAddBody = /* @__PURE__ */ mapObject([
  "skill_plugin_id",
  "skill_configuration_id"
]);
var mapSkillsMarketplacesPluginsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesPluginsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "skill_configuration_id",
              "skill_marketplace_id",
              [
                "skill_plugin",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "sync_status",
                          "image_url",
                          "long_description",
                          "skill_configuration_id",
                          [
                            "skills",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  "client_name",
                                  "client_description",
                                  "client_metadata",
                                  "skill_configuration_id",
                                  "skill_id",
                                  [
                                    "skill",
                                    0,
                                    [
                                      1,
                                      [
                                        "image_url",
                                        "client_name",
                                        "client_description",
                                        "client_metadata",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "created_at",
                                  "updated_at"
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at",
                          "can_update",
                          "can_delete"
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesPluginsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_plugin_id",
          "skill_configuration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSkillsMarketplacesPluginsRemoveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "skill_configuration_id",
            "skill_marketplace_id",
            [
              "skill_plugin",
              1,
              [
                3,
                [
                  [
                    0,
                    [
                      1,
                      [
                        "sync_status",
                        "image_url",
                        "long_description",
                        "skill_configuration_id",
                        [
                          "skills",
                          0,
                          [
                            2,
                            [
                              1,
                              [
                                "client_name",
                                "client_description",
                                "client_metadata",
                                "skill_configuration_id",
                                "skill_id",
                                [
                                  "skill",
                                  0,
                                  [
                                    1,
                                    [
                                      "image_url",
                                      "client_name",
                                      "client_description",
                                      "client_metadata",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ],
                                "created_at",
                                "updated_at"
                              ]
                            ]
                          ]
                        ],
                        "created_at",
                        "updated_at",
                        "can_update",
                        "can_delete"
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesRepositoriesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMarketplacesRepositoriesCreateBody = /* @__PURE__ */ mapObject([
  "repo_id"
]);
var mapSkillsMarketplacesRepositoriesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMarketplacesRepositoriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_marketplace_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMarketplacesRepositoriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_marketplace_id",
        "repo_id",
        [
          "repository",
          0,
          [1, ["is_private", "default_branch", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesRepositoriesListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsMarketplacesSyncOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesSyncBody = /* @__PURE__ */ createMapper(0);
var mapSkillsMarketplacesUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "repository_access_mode",
            "force_merge_or_push",
            "merge_before_checks_pass",
            "sync_status",
            "image_url",
            "skill_configuration_id",
            [
              "plugins",
              0,
              [
                2,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "skill_configuration_id",
                          "skill_marketplace_id",
                          [
                            "skill_plugin",
                            1,
                            [
                              3,
                              [
                                [
                                  0,
                                  [
                                    1,
                                    [
                                      "sync_status",
                                      "image_url",
                                      "long_description",
                                      "skill_configuration_id",
                                      [
                                        "skills",
                                        0,
                                        [
                                          2,
                                          [
                                            1,
                                            [
                                              "client_name",
                                              "client_description",
                                              "client_metadata",
                                              "skill_configuration_id",
                                              "skill_id",
                                              [
                                                "skill",
                                                0,
                                                [
                                                  1,
                                                  [
                                                    "image_url",
                                                    "client_name",
                                                    "client_description",
                                                    "client_metadata",
                                                    "created_at",
                                                    "updated_at"
                                                  ]
                                                ]
                                              ],
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ]
                                      ],
                                      "created_at",
                                      "updated_at",
                                      "can_update",
                                      "can_delete"
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_create_plugins"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMarketplacesUpdateBody = /* @__PURE__ */ mapObject([
  "image_file_id",
  "skill_configuration_id",
  "repository_access_mode",
  "force_merge_or_push",
  "merge_before_checks_pass"
]);
var mapSkillsMergeRequestsCloseOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsCommentsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsCommentsCreateBody = /* @__PURE__ */ mapObject([
  "item_id",
  "in_reply_to_comment_id"
]);
var mapSkillsMergeRequestsCommentsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsCommentsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsCommentsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_merge_request_item_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "in_reply_to_comment_id",
        "deleted_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsMergeRequestsCommentsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["item_id"]]]]
]);
var mapSkillsMergeRequestsCommentsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_item_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "in_reply_to_comment_id",
    "deleted_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsCommentsUpdateBody = /* @__PURE__ */ createMapper(0);
var mapSkillsMergeRequestsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsCreateBody = /* @__PURE__ */ mapObject([
  "source_skill_id",
  "target_skill_id"
]);
var mapSkillsMergeRequestsEventsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    [
      "comment",
      0,
      [
        1,
        [
          "skill_merge_request_item_id",
          [
            "actor",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "in_reply_to_comment_id",
          "deleted_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "error_code",
    "error_message",
    "created_at"
  ],
  1
);
var mapSkillsMergeRequestsEventsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        [
          "comment",
          0,
          [
            1,
            [
              "skill_merge_request_item_id",
              [
                "actor",
                0,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "in_reply_to_comment_id",
              "deleted_at",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "error_code",
        "error_message",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSkillsMergeRequestsEventsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, [["created_at", 1, 5]]]]]
]);
var mapSkillsMergeRequestsGetOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsItemsBulkResolveOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_merge_request_id",
        "change_type",
        "resolution_type",
        "conflict_reason",
        [
          "resolved_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "resolved_at",
        "applied_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsMergeRequestsItemsBulkResolveBody = /* @__PURE__ */ mapObject([
  ["items", 0, [2, [1, ["item_id", "resolution_type"]]]]
]);
var mapSkillsMergeRequestsItemsResolveOutput = /* @__PURE__ */ mapObject(
  [
    "skill_merge_request_id",
    "change_type",
    "resolution_type",
    "conflict_reason",
    [
      "resolved_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "resolved_at",
    "applied_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsItemsResolveBody = /* @__PURE__ */ mapObject([
  "resolution_type"
]);
var mapSkillsMergeRequestsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "base_strategy",
        "merge_error",
        "merge_error_code",
        "source_skill_id",
        "target_skill_id",
        "base_target_skill_version_id",
        "requested_source_skill_version_id",
        "requested_target_skill_version_id",
        "pre_merge_target_skill_version_id",
        "merged_target_skill_version_id",
        "rollback_target_skill_version_id",
        [
          "created_by",
          1,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "item_count",
        "comment_count",
        "merge_started_at",
        "merged_at",
        "closed_at",
        "rolled_back_at",
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsMergeRequestsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "source_skill_id",
          "target_skill_id",
          "created_by_actor_id",
          ["created_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSkillsMergeRequestsPerformOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsMergeRequestsPlanGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "merge_request",
      1,
      [
        1,
        [
          "base_strategy",
          "merge_error",
          "merge_error_code",
          "source_skill_id",
          "target_skill_id",
          "base_target_skill_version_id",
          "requested_source_skill_version_id",
          "requested_target_skill_version_id",
          "pre_merge_target_skill_version_id",
          "merged_target_skill_version_id",
          "rollback_target_skill_version_id",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "item_count",
          "comment_count",
          "merge_started_at",
          "merged_at",
          "closed_at",
          "rolled_back_at",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "item",
              0,
              [
                1,
                [
                  "skill_merge_request_id",
                  "change_type",
                  "resolution_type",
                  "conflict_reason",
                  [
                    "resolved_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "resolved_at",
                  "applied_at",
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "base",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "source",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "target",
              0,
              [
                1,
                [
                  "file_id",
                  "document_id",
                  "document_title",
                  "document_version_id"
                ]
              ]
            ],
            [
              "document_merge",
              1,
              [
                1,
                [
                  "base_content",
                  "source_content",
                  "target_content",
                  "has_conflict"
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsMergeRequestsRollbackOutput = /* @__PURE__ */ mapObject(
  [
    "base_strategy",
    "merge_error",
    "merge_error_code",
    "source_skill_id",
    "target_skill_id",
    "base_target_skill_version_id",
    "requested_source_skill_version_id",
    "requested_target_skill_version_id",
    "pre_merge_target_skill_version_id",
    "merged_target_skill_version_id",
    "rollback_target_skill_version_id",
    [
      "created_by",
      1,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "item_count",
    "comment_count",
    "merge_started_at",
    "merged_at",
    "closed_at",
    "rolled_back_at",
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsParticipantsListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsPluginsArchiveOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsPluginsCreateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsPluginsCreateBody = /* @__PURE__ */ mapObject([
  "long_description",
  "image_file_id",
  "skill_configuration_id",
  "skill_marketplace_id"
]);
var mapSkillsPluginsGetEditorUrlOutput = /* @__PURE__ */ mapObject(["expires_at"], 1);
var mapSkillsPluginsGetEditorUrlBody = /* @__PURE__ */ createMapper(0);
var mapSkillsPluginsGetOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsPluginsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      3,
      [
        [
          0,
          [
            1,
            [
              "sync_status",
              "image_url",
              "long_description",
              "skill_configuration_id",
              [
                "skills",
                0,
                [
                  2,
                  [
                    1,
                    [
                      "client_name",
                      "client_description",
                      "client_metadata",
                      "skill_configuration_id",
                      "skill_id",
                      [
                        "skill",
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "client_name",
                            "client_description",
                            "client_metadata",
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "can_update",
              "can_delete"
            ]
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsPluginsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_marketplace_id",
          "skill_configuration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSkillsPluginsRepositoriesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsPluginsRepositoriesCreateBody = /* @__PURE__ */ mapObject(["repo_id"]);
var mapSkillsPluginsRepositoriesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsPluginsRepositoriesGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_plugin_id",
    "repo_id",
    [
      "repository",
      0,
      [1, ["is_private", "default_branch", "created_at", "updated_at"]]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsPluginsRepositoriesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_plugin_id",
        "repo_id",
        [
          "repository",
          0,
          [1, ["is_private", "default_branch", "created_at", "updated_at"]]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsPluginsRepositoriesListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsPluginsSkillsAddOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsPluginsSkillsAddBody = /* @__PURE__ */ mapObject([
  "skill_id",
  "client_name",
  "client_description",
  "client_metadata",
  "skill_configuration_id"
]);
var mapSkillsPluginsSkillsGetOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsPluginsSkillsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "client_name",
        "client_description",
        "client_metadata",
        "skill_configuration_id",
        "skill_id",
        [
          "skill",
          0,
          [
            1,
            [
              "image_url",
              "client_name",
              "client_description",
              "client_metadata",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsPluginsSkillsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "skill_id",
          "skill_configuration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSkillsPluginsSkillsRemoveOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsPluginsSkillsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "client_name",
    "client_description",
    "client_metadata",
    "skill_configuration_id",
    "skill_id",
    [
      "skill",
      0,
      [
        1,
        [
          "image_url",
          "client_name",
          "client_description",
          "client_metadata",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsPluginsSkillsUpdateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "skill_configuration_id"
]);
var mapSkillsPluginsSyncOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsPluginsSyncBody = /* @__PURE__ */ createMapper(0);
var mapSkillsPluginsUpdateOutput = /* @__PURE__ */ createMapper(
  [
    3,
    [
      [
        0,
        [
          1,
          [
            "sync_status",
            "image_url",
            "long_description",
            "skill_configuration_id",
            [
              "skills",
              0,
              [
                2,
                [
                  1,
                  [
                    "client_name",
                    "client_description",
                    "client_metadata",
                    "skill_configuration_id",
                    "skill_id",
                    [
                      "skill",
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "client_name",
                          "client_description",
                          "client_metadata",
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "can_update",
            "can_delete"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapSkillsPluginsUpdateBody = /* @__PURE__ */ mapObject([
  "long_description",
  "image_file_id",
  "skill_configuration_id"
]);
var mapSkillsPublishConsumerSkillOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsShareOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  ["assignment_id", "created_at", "updated_at"]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  ["assignment_id", "created_at", "updated_at"]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsShareBody = /* @__PURE__ */ mapObject([
  "consumer_profile_ids",
  "organization_member_ids"
]);
var mapSkillsTemplatesCreateOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsTemplatesCreateBody = /* @__PURE__ */ mapObject([
  ["from_skill_Id", "fromSkillId"]
]);
var mapSkillsTemplatesDeleteOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsTemplatesGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsTemplatesItemsCreateOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsTemplatesItemsCreateBody = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", "integration_id"]]]]
]);
var mapSkillsTemplatesItemsDeleteOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsTemplatesItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    [
      "integration",
      0,
      [
        1,
        [
          [
            "configuration",
            0,
            [
              1,
              [
                "can_attach_custom_tool_filters",
                "can_attach_custom_provider_config",
                "can_override_tool_filters",
                "enable_callback_tools",
                "use_integration_name_in_tool_names"
              ]
            ]
          ],
          "created_at",
          "updated_at",
          "archived_at"
        ]
      ]
    ],
    ["provider", 0, 8],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsTemplatesItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        [
          "integration",
          0,
          [
            1,
            [
              [
                "configuration",
                0,
                [
                  1,
                  [
                    "can_attach_custom_tool_filters",
                    "can_attach_custom_provider_config",
                    "can_override_tool_filters",
                    "enable_callback_tools",
                    "use_integration_name_in_tool_names"
                  ]
                ]
              ],
              "created_at",
              "updated_at",
              "archived_at"
            ]
          ]
        ],
        ["provider", 0, 8],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsTemplatesItemsListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsTemplatesListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        [
          "items",
          0,
          [
            2,
            [
              1,
              [
                [
                  "integration",
                  0,
                  [
                    1,
                    [
                      [
                        "configuration",
                        0,
                        [
                          1,
                          [
                            "can_attach_custom_tool_filters",
                            "can_attach_custom_provider_config",
                            "can_override_tool_filters",
                            "enable_callback_tools",
                            "use_integration_name_in_tool_names"
                          ]
                        ]
                      ],
                      "created_at",
                      "updated_at",
                      "archived_at"
                    ]
                  ]
                ],
                ["provider", 0, 8],
                "created_at",
                "updated_at"
              ]
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapSkillsTemplatesListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "provider_id",
          "integration_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapSkillsTemplatesUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            [
              "integration",
              0,
              [
                1,
                [
                  [
                    "configuration",
                    0,
                    [
                      1,
                      [
                        "can_attach_custom_tool_filters",
                        "can_attach_custom_provider_config",
                        "can_override_tool_filters",
                        "enable_callback_tools",
                        "use_integration_name_in_tool_names"
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at",
                  "archived_at"
                ]
              ]
            ],
            ["provider", 0, 8],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsTemplatesUpdateBody = /* @__PURE__ */ createMapper(0);
var mapSkillsUpdateOutput = /* @__PURE__ */ mapObject(
  [
    "image_url",
    "client_name",
    "client_description",
    "client_metadata",
    "store_id",
    [
      "hierarchy",
      0,
      [
        1,
        [
          "parent_skill_id",
          [
            "creator",
            0,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          [
            "fork",
            0,
            [
              1,
              [
                "parent_skill_id",
                [
                  "creator",
                  0,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                [
                  "original_creator",
                  1,
                  [
                    1,
                    [
                      "image_url",
                      [
                        "organization_actor",
                        1,
                        [
                          1,
                          [
                            "organization_id",
                            "image_url",
                            [
                              "teams",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    "assignment_id",
                                    "created_at",
                                    "updated_at"
                                  ]
                                ]
                              ]
                            ],
                            "created_at",
                            "updated_at"
                          ]
                        ]
                      ],
                      [
                        "consumer",
                        0,
                        [
                          1,
                          ["image_url", "user_id", "created_at", "updated_at"]
                        ]
                      ],
                      [
                        "consumer_profile",
                        1,
                        [
                          3,
                          [
                            [
                              0,
                              [
                                1,
                                [
                                  "image_url",
                                  "consumer_id",
                                  "user_id",
                                  "created_at",
                                  "updated_at",
                                  [
                                    "groups",
                                    0,
                                    [
                                      2,
                                      [
                                        1,
                                        [
                                          [
                                            "group",
                                            0,
                                            [
                                              1,
                                              [
                                                "is_default",
                                                "created_at",
                                                "updated_at"
                                              ]
                                            ]
                                          ],
                                          "assigned_via"
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ],
                "created_at"
              ]
            ]
          ],
          ["entity", 0, [1, ["parent_skill_id", "created_at", "updated_at"]]]
        ]
      ]
    ],
    [
      "integrations",
      0,
      [
        2,
        [
          1,
          [
            [
              "configuration",
              0,
              [
                1,
                [
                  "can_attach_custom_tool_filters",
                  "can_attach_custom_provider_config",
                  "can_override_tool_filters",
                  "enable_callback_tools",
                  "use_integration_name_in_tool_names"
                ]
              ]
            ],
            "created_at",
            "updated_at",
            "archived_at"
          ]
        ]
      ]
    ],
    ["providers", 0, [2, 8]],
    "created_at",
    "updated_at"
  ],
  1
);
var mapSkillsUpdateBody = /* @__PURE__ */ mapObject([
  "client_name",
  "client_description",
  "client_metadata",
  "image_file_id"
]);
var mapSkillsVersionsGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_version_id",
    "version_number",
    "created_at"
  ],
  1
);
var mapSkillsVersionsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "skill_id",
        "store_id",
        "store_version_id",
        "version_number",
        "created_at"
      ]
    ]
  ],
  1
);
var mapSkillsVersionsListQuery = /* @__PURE__ */ createMapper(0);
var mapSkillsVersionsSnapshotGetOutput = /* @__PURE__ */ mapObject(
  [
    "skill_id",
    "store_id",
    "store_version_id",
    "version_number",
    [
      "items",
      0,
      [
        2,
        [1, ["file_id", "document_id", "document_version_id", "created_at"]]
      ]
    ],
    "created_at"
  ],
  1
);
var mapStoresCreateOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapStoresCreateBody = /* @__PURE__ */ mapObject([
  "template_id",
  "parent_id"
]);
var mapStoresDeleteOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapStoresGetOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapStoresItemsGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    "directory_id",
    [
      "file",
      0,
      [
        1,
        [
          "file_name",
          "file_size",
          "file_type",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "document",
      0,
      [
        1,
        [
          "file_id",
          "parent_document_id",
          "current_version_id",
          [
            "created_by",
            1,
            [
              1,
              [
                "image_url",
                [
                  "organization_actor",
                  1,
                  [
                    1,
                    [
                      "organization_id",
                      "image_url",
                      [
                        "teams",
                        0,
                        [
                          2,
                          [1, ["assignment_id", "created_at", "updated_at"]]
                        ]
                      ],
                      "created_at",
                      "updated_at"
                    ]
                  ]
                ],
                [
                  "consumer",
                  0,
                  [1, ["image_url", "user_id", "created_at", "updated_at"]]
                ],
                [
                  "consumer_profile",
                  1,
                  [
                    3,
                    [
                      [
                        0,
                        [
                          1,
                          [
                            "image_url",
                            "consumer_id",
                            "user_id",
                            "created_at",
                            "updated_at",
                            [
                              "groups",
                              0,
                              [
                                2,
                                [
                                  1,
                                  [
                                    [
                                      "group",
                                      0,
                                      [
                                        1,
                                        [
                                          "is_default",
                                          "created_at",
                                          "updated_at"
                                        ]
                                      ]
                                    ],
                                    "assigned_via"
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ],
          "created_at",
          "updated_at"
        ]
      ]
    ],
    "created_at",
    "updated_at"
  ],
  1
);
var mapStoresItemsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        "directory_id",
        [
          "file",
          0,
          [
            1,
            [
              "file_name",
              "file_size",
              "file_type",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "document",
          0,
          [
            1,
            [
              "file_id",
              "parent_document_id",
              "current_version_id",
              [
                "created_by",
                1,
                [
                  1,
                  [
                    "image_url",
                    [
                      "organization_actor",
                      1,
                      [
                        1,
                        [
                          "organization_id",
                          "image_url",
                          [
                            "teams",
                            0,
                            [
                              2,
                              [
                                1,
                                ["assignment_id", "created_at", "updated_at"]
                              ]
                            ]
                          ],
                          "created_at",
                          "updated_at"
                        ]
                      ]
                    ],
                    [
                      "consumer",
                      0,
                      [
                        1,
                        ["image_url", "user_id", "created_at", "updated_at"]
                      ]
                    ],
                    [
                      "consumer_profile",
                      1,
                      [
                        3,
                        [
                          [
                            0,
                            [
                              1,
                              [
                                "image_url",
                                "consumer_id",
                                "user_id",
                                "created_at",
                                "updated_at",
                                [
                                  "groups",
                                  0,
                                  [
                                    2,
                                    [
                                      1,
                                      [
                                        [
                                          "group",
                                          0,
                                          [
                                            1,
                                            [
                                              "is_default",
                                              "created_at",
                                              "updated_at"
                                            ]
                                          ]
                                        ],
                                        "assigned_via"
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ],
              "created_at",
              "updated_at"
            ]
          ]
        ],
        "created_at",
        "updated_at"
      ]
    ]
  ],
  1
);
var mapStoresItemsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        ["file_id", "document_id", ["created_at", 1, 5], ["updated_at", 1, 5]]
      ]
    ]
  ]
]);
var mapStoresItemsModifyOutput = /* @__PURE__ */ mapObject(
  [
    [
      "items",
      0,
      [
        2,
        [
          1,
          [
            "store_id",
            "directory_id",
            [
              "file",
              0,
              [
                1,
                [
                  "file_name",
                  "file_size",
                  "file_type",
                  [
                    "created_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            [
              "document",
              0,
              [
                1,
                [
                  "file_id",
                  "parent_document_id",
                  "current_version_id",
                  [
                    "created_by",
                    1,
                    [
                      1,
                      [
                        "image_url",
                        [
                          "organization_actor",
                          1,
                          [
                            1,
                            [
                              "organization_id",
                              "image_url",
                              [
                                "teams",
                                0,
                                [
                                  2,
                                  [
                                    1,
                                    [
                                      "assignment_id",
                                      "created_at",
                                      "updated_at"
                                    ]
                                  ]
                                ]
                              ],
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer",
                          0,
                          [
                            1,
                            [
                              "image_url",
                              "user_id",
                              "created_at",
                              "updated_at"
                            ]
                          ]
                        ],
                        [
                          "consumer_profile",
                          1,
                          [
                            3,
                            [
                              [
                                0,
                                [
                                  1,
                                  [
                                    "image_url",
                                    "consumer_id",
                                    "user_id",
                                    "created_at",
                                    "updated_at",
                                    [
                                      "groups",
                                      0,
                                      [
                                        2,
                                        [
                                          1,
                                          [
                                            [
                                              "group",
                                              0,
                                              [
                                                1,
                                                [
                                                  "is_default",
                                                  "created_at",
                                                  "updated_at"
                                                ]
                                              ]
                                            ],
                                            "assigned_via"
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ],
                  "created_at",
                  "updated_at"
                ]
              ]
            ],
            "created_at",
            "updated_at"
          ]
        ]
      ]
    ]
  ],
  1
);
var mapStoresItemsModifyBody = /* @__PURE__ */ createMapper(0);
var mapStoresListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["item_count", "created_at", "updated_at"]]],
  1
);
var mapStoresListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapStoresParticipantsGetOutput = /* @__PURE__ */ mapObject(
  [
    "store_id",
    [
      "actor",
      0,
      [
        1,
        [
          "image_url",
          [
            "organization_actor",
            1,
            [
              1,
              [
                "organization_id",
                "image_url",
                [
                  "teams",
                  0,
                  [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                ],
                "created_at",
                "updated_at"
              ]
            ]
          ],
          [
            "consumer",
            0,
            [1, ["image_url", "user_id", "created_at", "updated_at"]]
          ],
          [
            "consumer_profile",
            1,
            [
              3,
              [
                [
                  0,
                  [
                    1,
                    [
                      "image_url",
                      "consumer_id",
                      "user_id",
                      "created_at",
                      "updated_at",
                      [
                        "groups",
                        0,
                        [
                          2,
                          [
                            1,
                            [
                              [
                                "group",
                                0,
                                [
                                  1,
                                  ["is_default", "created_at", "updated_at"]
                                ]
                              ],
                              "assigned_via"
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapStoresParticipantsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "store_id",
        [
          "actor",
          0,
          [
            1,
            [
              "image_url",
              [
                "organization_actor",
                1,
                [
                  1,
                  [
                    "organization_id",
                    "image_url",
                    [
                      "teams",
                      0,
                      [2, [1, ["assignment_id", "created_at", "updated_at"]]]
                    ],
                    "created_at",
                    "updated_at"
                  ]
                ]
              ],
              [
                "consumer",
                0,
                [1, ["image_url", "user_id", "created_at", "updated_at"]]
              ],
              [
                "consumer_profile",
                1,
                [
                  3,
                  [
                    [
                      0,
                      [
                        1,
                        [
                          "image_url",
                          "consumer_id",
                          "user_id",
                          "created_at",
                          "updated_at",
                          [
                            "groups",
                            0,
                            [
                              2,
                              [
                                1,
                                [
                                  [
                                    "group",
                                    0,
                                    [
                                      1,
                                      [
                                        "is_default",
                                        "created_at",
                                        "updated_at"
                                      ]
                                    ]
                                  ],
                                  "assigned_via"
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapStoresParticipantsListQuery = /* @__PURE__ */ createMapper(0);
var mapStoresPermissionsGetOutput = /* @__PURE__ */ mapObject([
  "store_id",
  "has_full_access",
  "relevant_store_ids",
  "readable_store_ids",
  "writable_store_ids"
]);
var mapStoresUpdateOutput = /* @__PURE__ */ mapObject(
  ["item_count", "created_at", "updated_at"],
  1
);
var mapStoresUpdateBody = /* @__PURE__ */ createMapper(0);
var mapTestHelpersConsumerOauthAuthorizationsCreateOutput = /* @__PURE__ */ mapObject(
  ["expires_at", "created_at"],
  1
);
var mapTestHelpersConsumerOauthAuthorizationsCreateBody = /* @__PURE__ */ mapObject([
  "instance_id",
  "consumer_profile_id",
  "magic_mcp_endpoint_id"
]);
var mapToolCallsCreateOutput = /* @__PURE__ */ mapObject(
  [
    "tool_key",
    "session_id",
    "message_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "tool",
      0,
      [
        1,
        [
          "input_schema",
          "output_schema",
          ["tags", 0, [1, ["read_only"]]],
          "tool_category_keys",
          "specification_id",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapToolCallsCreateBody = /* @__PURE__ */ mapObject(["tool_id", "session_id"]);
var mapToolCallsGetOutput = /* @__PURE__ */ mapObject(
  [
    "tool_key",
    "session_id",
    "message_id",
    "session_provider_id",
    "connection_id",
    "provider_run_id",
    [
      "sender_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "responder_participant",
      1,
      [
        1,
        [
          "provider_id",
          "connection_type",
          "agent_id",
          "agent_instance_id",
          "identity_actor_id",
          "identity_id",
          "agent_actor_id",
          "agent_client_id",
          "consumer_id",
          "created_at"
        ]
      ]
    ],
    [
      "tool",
      0,
      [
        1,
        [
          "input_schema",
          "output_schema",
          ["tags", 0, [1, ["read_only"]]],
          "tool_category_keys",
          "specification_id",
          "provider_id",
          "created_at",
          "updated_at"
        ]
      ]
    ],
    [
      "error",
      0,
      [
        1,
        [
          "session_id",
          "provider_run_id",
          "connection_id",
          "group_id",
          "similar_error_count",
          "created_at"
        ]
      ]
    ],
    "created_at"
  ],
  1
);
var mapToolCallsListOutput = /* @__PURE__ */ createMapper(
  [
    7,
    [
      1,
      [
        "tool_key",
        "session_id",
        "message_id",
        "session_provider_id",
        "connection_id",
        "provider_run_id",
        [
          "sender_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "responder_participant",
          1,
          [
            1,
            [
              "provider_id",
              "connection_type",
              "agent_id",
              "agent_instance_id",
              "identity_actor_id",
              "identity_id",
              "agent_actor_id",
              "agent_client_id",
              "consumer_id",
              "created_at"
            ]
          ]
        ],
        [
          "tool",
          0,
          [
            1,
            [
              "input_schema",
              "output_schema",
              ["tags", 0, [1, ["read_only"]]],
              "tool_category_keys",
              "specification_id",
              "provider_id",
              "created_at",
              "updated_at"
            ]
          ]
        ],
        [
          "error",
          0,
          [
            1,
            [
              "session_id",
              "provider_run_id",
              "connection_id",
              "group_id",
              "similar_error_count",
              "created_at"
            ]
          ]
        ],
        "created_at"
      ]
    ]
  ],
  1
);
var mapToolCallsListQuery = /* @__PURE__ */ createMapper([
  3,
  [
    [
      0,
      [
        1,
        [
          "session_id",
          "session_template_id",
          "session_provider_id",
          "provider_id",
          "provider_deployment_id",
          "provider_config_id",
          "provider_auth_config_id",
          "agent_id",
          "actor_id",
          "consumer_id",
          "identity_id",
          "agent_instance_id",
          "tool_id",
          ["created_at", 1, 5],
          ["updated_at", 1, 5]
        ]
      ]
    ]
  ]
]);
var mapWebhookRegistrationsCreateOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapWebhookRegistrationsCreateBody = /* @__PURE__ */ mapObject(["provider_id"]);
var mapWebhookRegistrationsDeleteOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapWebhookRegistrationsGetOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapWebhookRegistrationsListOutput = /* @__PURE__ */ createMapper(
  [7, [1, ["receive_url", ["provider", 0, 8], "created_at", "updated_at"]]],
  1
);
var mapWebhookRegistrationsListQuery = /* @__PURE__ */ createMapper([
  3,
  [[0, [1, ["provider_id", ["created_at", 1, 5], ["updated_at", 1, 5]]]]]
]);
var mapWebhookRegistrationsSetupOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapWebhookRegistrationsSetupBody = /* @__PURE__ */ mapObject(["user_config"]);
var mapWebhookRegistrationsUpdateOutput = /* @__PURE__ */ mapObject(
  ["receive_url", ["provider", 0, 8], "created_at", "updated_at"],
  1
);
var mapWebhookRegistrationsUpdateBody = /* @__PURE__ */ createMapper(0);

// src/gen/src/mt_2025_01_01_dashboard/endpoints/agents.ts
var MetorialAgentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List agents
   * @description Returns a paginated list of agents for the instance.
   *
   * @param `query` - DashboardInstanceAgentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "agents";
    let request = {
      path,
      query: query ? mapDashboardInstanceAgentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceAgentsListOutput);
  }
  /**
   * @name Get agent
   * @description Retrieves a specific agent by ID.
   *
   * @param `agentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(agentId, opts) {
    let path = `agents/${agentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceAgentsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/agents_instances.ts
var MetorialAgentsInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List agent instances
   * @description Returns a paginated list of instances for an agent.
   *
   * @param `agentId` - string
   * @param `query` - DashboardInstanceAgentsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(agentId, query, opts) {
    let path = `agents/${agentId}/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceAgentsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAgentsInstancesListOutput
    );
  }
  /**
   * @name Get agent instance
   * @description Retrieves a specific agent instance by ID.
   *
   * @param `agentId` - string
   * @param `agentInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(agentId, agentInstanceId, opts) {
    let path = `agents/${agentId}/instances/${agentInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAgentsInstancesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/assistants.ts
var MetorialAssistantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistants
   * @description List assistants available in an instance.
   *
   * @param `query` - DashboardInstanceAssistantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAssistantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "assistants";
    let request = {
      path,
      query: query ? mapDashboardInstanceAssistantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAssistantsListOutput
    );
  }
  /**
   * @name Get assistant
   * @description Get an assistant available in an instance.
   *
   * @param `assistantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAssistantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(assistantId, opts) {
    let path = `assistants/${assistantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAssistantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/callback-events.ts
var MetorialCallbackEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callback events
   * @description Returns a paginated list of callback events.
   *
   * @param `query` - DashboardInstanceCallbackEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "callback-events";
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbackEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackEventsListOutput
    );
  }
  /**
   * @name Get callback event
   * @description Retrieves a specific callback event by ID, enriched with the payload the provider produced for it and, if it came from a webhook, the inbound request behind it.
   *
   * @param `callbackEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(callbackEventId, opts) {
    let path = `callback-events/${callbackEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/callback-instances.ts
var MetorialCallbackInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callback instances
   * @description Returns a paginated list of callback instances.
   *
   * @param `query` - DashboardInstanceCallbackInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "callback-instances";
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbackInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackInstancesListOutput
    );
  }
  /**
   * @name Get callback instance
   * @description Retrieves a specific callback instance by ID.
   *
   * @param `callbackInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(callbackInstanceId, opts) {
    let path = `callback-instances/${callbackInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackInstancesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/callbacks.ts
var MetorialCallbacksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callbacks
   * @description Returns a paginated list of callbacks.
   *
   * @param `query` - DashboardInstanceCallbacksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "callbacks";
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbacksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbacksListOutput
    );
  }
  /**
   * @name Create callback
   * @description Enables callbacks for an integration provider and returns the callback it created. Only providers whose type reports `triggers.status` as `enabled` support this. Callback instances are then registered for every matching integration instance in the background.
   *
   * @param `body` - DashboardInstanceCallbacksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "callbacks";
    let request = {
      path,
      body: mapDashboardInstanceCallbacksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCallbacksCreateOutput
    );
  }
  /**
   * @name Get callback
   * @description Retrieves a specific callback by ID.
   *
   * @param `callbackId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(callbackId, opts) {
    let path = `callbacks/${callbackId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceCallbacksGetOutput);
  }
  /**
   * @name Update callback
   * @description Updates the name, description or metadata of a callback. Everything else about a callback is derived from its integration provider - set `callbacks.status` to `disabled` there to tear it down.
   *
   * @param `callbackId` - string
   * @param `body` - DashboardInstanceCallbacksUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(callbackId, body, opts) {
    let path = `callbacks/${callbackId}`;
    let request = {
      path,
      body: mapDashboardInstanceCallbacksUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceCallbacksUpdateOutput
    );
  }
  /**
   * @name Delete callback
   * @description Disables callbacks on the underlying integration provider, tearing down this callback and every callback instance registered for it.
   *
   * @param `callbackId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(callbackId, opts) {
    let path = `callbacks/${callbackId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceCallbacksDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chat_connections.ts
var MetorialChatConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat connections
   * @description Returns a paginated list of chat connections.
   *
   * @param `query` - DashboardInstanceChatConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "chat/connections";
    let request = {
      path,
      query: query ? mapDashboardInstanceChatConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatConnectionsListOutput
    );
  }
  /**
   * @name Get chat connection
   * @description Retrieves a specific chat connection.
   *
   * @param `chatConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatConnectionId, opts) {
    let path = `chat/connections/${chatConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatConnectionsGetOutput
    );
  }
  /**
   * @name Create chat connection
   * @description Creates a new chat connection, together with the single provider it is linked to.
   *
   * @param `body` - DashboardInstanceChatConnectionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "chat/connections";
    let request = {
      path,
      body: mapDashboardInstanceChatConnectionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatConnectionsCreateOutput
    );
  }
  /**
   * @name Update chat connection
   * @description Updates a specific chat connection.
   *
   * @param `chatConnectionId` - string
   * @param `body` - DashboardInstanceChatConnectionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(chatConnectionId, body, opts) {
    let path = `chat/connections/${chatConnectionId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatConnectionsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatConnectionsUpdateOutput
    );
  }
  /**
   * @name Delete chat connection
   * @description Archives a specific chat connection.
   *
   * @param `chatConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(chatConnectionId, opts) {
    let path = `chat/connections/${chatConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatConnectionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chat_events.ts
var MetorialChatEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat events
   * @description Returns a paginated list of chat events.
   *
   * @param `query` - DashboardInstanceChatEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "chat/events";
    let request = {
      path,
      query: query ? mapDashboardInstanceChatEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatEventsListOutput
    );
  }
  /**
   * @name Get chat event
   * @description Retrieves a specific chat event.
   *
   * @param `chatEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatEventId, opts) {
    let path = `chat/events/${chatEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chat_instances.ts
var MetorialChatInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat instances
   * @description Returns a paginated list of chat instances.
   *
   * @param `query` - DashboardInstanceChatInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "chat/instances";
    let request = {
      path,
      query: query ? mapDashboardInstanceChatInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesListOutput
    );
  }
  /**
   * @name Get chat instance
   * @description Retrieves a specific chat instance.
   *
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatInstanceId, opts) {
    let path = `chat/instances/${chatInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesGetOutput
    );
  }
  /**
   * @name Create chat instance
   * @description Creates a new chat instance for a chat connection.
   *
   * @param `body` - DashboardInstanceChatInstancesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "chat/instances";
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatInstancesCreateOutput
    );
  }
  /**
   * @name Update chat instance
   * @description Updates a specific chat instance.
   *
   * @param `chatInstanceId` - string
   * @param `body` - DashboardInstanceChatInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(chatInstanceId, body, opts) {
    let path = `chat/instances/${chatInstanceId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatInstancesUpdateOutput
    );
  }
  /**
   * @name Delete chat instance
   * @description Archives a specific chat instance.
   *
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(chatInstanceId, opts) {
    let path = `chat/instances/${chatInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatInstancesDeleteOutput
    );
  }
  /**
   * @name Sync chat instance
   * @description Triggers a sync of the workspaces available on this chat instance.
   *
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(chatInstanceId, opts) {
    let path = `chat/instances/${chatInstanceId}/sync`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatInstancesSyncOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chat_instances_provider.ts
var MetorialChatInstancesProviderEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get chat instance provider
   * @description Retrieves the single provider configured for a chat instance.
   *
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatInstanceId, opts) {
    let path = `chat/instances/${chatInstanceId}/provider`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesProviderGetOutput
    );
  }
  /**
   * @name Set chat instance provider
   * @description Creates or updates the single provider for a chat instance.
   *
   * @param `chatInstanceId` - string
   * @param `body` - DashboardInstanceChatInstancesProviderSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(chatInstanceId, body, opts) {
    let path = `chat/instances/${chatInstanceId}/provider`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesProviderSetBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatInstancesProviderSetOutput
    );
  }
  /**
   * @name Get chat instance authenticated user
   * @description Retrieves the chat provider account this chat instance is authenticated as.
   *
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderAuthenticatedUserOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  authenticatedUser(chatInstanceId, opts) {
    let path = `chat/instances/${chatInstanceId}/provider/authenticated-user`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesProviderAuthenticatedUserOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chat_workspaces.ts
var MetorialChatWorkspacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat workspaces
   * @description Returns a paginated list of workspaces for a chat instance.
   *
   * @param `query` - DashboardInstanceChatWorkspacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatWorkspacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "chat/workspaces";
    let request = {
      path,
      query: query ? mapDashboardInstanceChatWorkspacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatWorkspacesListOutput
    );
  }
  /**
   * @name Get chat workspace
   * @description Retrieves a specific chat workspace.
   *
   * @param `chatWorkspaceId` - string
   * @param `query` - DashboardInstanceChatWorkspacesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatWorkspacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatWorkspaceId, query, opts) {
    let path = `chat/workspaces/${chatWorkspaceId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatWorkspacesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatWorkspacesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats.ts
var MetorialChatsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chats
   * @description Returns a paginated list of chats.
   *
   * @param `query` - DashboardInstanceChatsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "chats";
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceChatsListOutput);
  }
  /**
   * @name Get chat
   * @description Retrieves a specific chat.
   *
   * @param `chatId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatId, opts) {
    let path = `chats/${chatId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceChatsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_channels.ts
var MetorialChatsChannelsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat channels
   * @description Returns a paginated list of channels for a chat.
   *
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsChannelsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(chatId, query, opts) {
    let path = `chats/${chatId}/channels`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsChannelsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsListOutput
    );
  }
  /**
   * @name Get chat channel
   * @description Retrieves a specific chat channel.
   *
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatId, channelId, opts) {
    let path = `chats/${chatId}/channels/${channelId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_channels_members.ts
var MetorialChatsChannelsMembersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat channel members
   * @description Returns a paginated list of members of a chat channel.
   *
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `query` - DashboardInstanceChatsChannelsMembersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsMembersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(chatId, channelId, query, opts) {
    let path = `chats/${chatId}/channels/${channelId}/members`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsChannelsMembersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsMembersListOutput
    );
  }
  /**
   * @name Get chat channel member
   * @description Retrieves a specific member of a chat channel.
   *
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `userId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsMembersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatId, channelId, userId, opts) {
    let path = `chats/${chatId}/channels/${channelId}/members/${userId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsMembersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_channels_typing.ts
var MetorialChatsChannelsTypingEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Start chat typing indicator
   * @description Shows a typing indicator in a chat channel.
   *
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `body` - DashboardInstanceChatsChannelsTypingStartBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsTypingStartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  start(chatId, channelId, body, opts) {
    let path = `chats/${chatId}/channels/${channelId}/typing`;
    let request = {
      path,
      body: mapDashboardInstanceChatsChannelsTypingStartBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsChannelsTypingStartOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_commands.ts
var MetorialChatsCommandsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Respond to chat command
   * @description Replies to a slash command from a chat.command.invoked event, using the provider's native command response.
   *
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsCommandsRespondBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsCommandsRespondOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  respond(chatId, body, opts) {
    let path = `chats/${chatId}/commands/respond`;
    let request = {
      path,
      body: mapDashboardInstanceChatsCommandsRespondBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsCommandsRespondOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_dms.ts
var MetorialChatsDmsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Open chat DM
   * @description Opens (or retrieves) a direct message channel with one or more users.
   *
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsDmsOpenBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsDmsOpenOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  open(chatId, body, opts) {
    let path = `chats/${chatId}/dms`;
    let request = {
      path,
      body: mapDashboardInstanceChatsDmsOpenBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsDmsOpenOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_messages.ts
var MetorialChatsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat messages
   * @description Returns a paginated list of messages in a chat channel.
   *
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(chatId, query, opts) {
    let path = `chats/${chatId}/messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesListOutput
    );
  }
  /**
   * @name Get chat message
   * @description Retrieves a specific chat message.
   *
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatId, messageId, query, opts) {
    let path = `chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesGetOutput
    );
  }
  /**
   * @name Send chat message
   * @description Sends a new message to a chat channel.
   *
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsMessagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(chatId, body, opts) {
    let path = `chats/${chatId}/messages`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesCreateOutput
    );
  }
  /**
   * @name Edit chat message
   * @description Edits a specific chat message.
   *
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(chatId, messageId, body, opts) {
    let path = `chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatsMessagesUpdateOutput
    );
  }
  /**
   * @name Delete chat message
   * @description Deletes a specific chat message.
   *
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(chatId, messageId, query, opts) {
    let path = `chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesDeleteQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatsMessagesDeleteOutput
    );
  }
  /**
   * @name Mark chat message read
   * @description Marks a specific chat message as read.
   *
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesReadBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReadOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  read(chatId, messageId, body, opts) {
    let path = `chats/${chatId}/messages/${messageId}/read`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesReadBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesReadOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_messages_reactions.ts
var MetorialChatsMessagesReactionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat message reactions
   * @description Returns the reactions left on a specific chat message.
   *
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesReactionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(chatId, messageId, query, opts) {
    let path = `chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesReactionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesReactionsListOutput
    );
  }
  /**
   * @name Add chat message reaction
   * @description Adds a reaction to a specific chat message.
   *
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesReactionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(chatId, messageId, body, opts) {
    let path = `chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesReactionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesReactionsCreateOutput
    );
  }
  /**
   * @name Remove chat message reaction
   * @description Removes a reaction from a specific chat message.
   *
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesReactionsDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(chatId, messageId, query, opts) {
    let path = `chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesReactionsDeleteQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatsMessagesReactionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/chats_threads.ts
var MetorialChatsThreadsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat threads
   * @description Returns a paginated list of threads in a chat channel.
   *
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsThreadsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsThreadsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(chatId, query, opts) {
    let path = `chats/${chatId}/threads`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsThreadsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsThreadsListOutput
    );
  }
  /**
   * @name Get chat thread
   * @description Retrieves a specific chat thread.
   *
   * @param `chatId` - string
   * @param `threadId` - string
   * @param `query` - DashboardInstanceChatsThreadsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsThreadsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(chatId, threadId, query, opts) {
    let path = `chats/${chatId}/threads/${threadId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsThreadsGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsThreadsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/consumer-surfaces.ts
var MetorialConsumerSurfacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumer surfaces
   * @description Returns a paginated list of consumer surfaces for an instance.
   *
   * @param `query` - DashboardInstanceConsumerSurfacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumerSurfacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "consumer-surfaces";
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumerSurfacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumerSurfacesListOutput
    );
  }
  /**
   * @name Get consumer surface
   * @description Retrieves a consumer surface by ID.
   *
   * @param `consumerSurfaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumerSurfacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(consumerSurfaceId, opts) {
    let path = `consumer-surfaces/${consumerSurfaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumerSurfacesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/consumers.ts
var MetorialConsumersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumers
   * @description Returns a paginated list of consumers for an instance.
   *
   * @param `query` - DashboardInstanceConsumersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "consumers";
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersListOutput
    );
  }
  /**
   * @name Get consumer
   * @description Retrieves a consumer by ID.
   *
   * @param `consumerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(consumerId, opts) {
    let path = `consumers/${consumerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceConsumersGetOutput);
  }
  /**
   * @name Create consumer
   * @description Creates or links a consumer for an instance.
   *
   * @param `body` - DashboardInstanceConsumersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "consumers";
    let request = {
      path,
      body: mapDashboardInstanceConsumersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConsumersCreateOutput
    );
  }
  /**
   * @name Get member consumer
   * @description Upserts and returns the consumer for the authenticated organization member.
   *
   * @param `body` - DashboardInstanceConsumersGetMemberConsumerBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersGetMemberConsumerOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getMemberConsumer(body, opts) {
    let path = "get-member-consumer";
    let request = {
      path,
      body: mapDashboardInstanceConsumersGetMemberConsumerBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConsumersGetMemberConsumerOutput
    );
  }
  /**
   * @name Update consumer
   * @description Updates a consumer for an instance.
   *
   * @param `consumerId` - string
   * @param `body` - DashboardInstanceConsumersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(consumerId, body, opts) {
    let path = `consumers/${consumerId}`;
    let request = {
      path,
      body: mapDashboardInstanceConsumersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceConsumersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/consumers_profiles.ts
var MetorialConsumersProfilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumer profiles
   * @description Returns a paginated list of profiles for a consumer in an instance.
   *
   * @param `consumerId` - string
   * @param `query` - DashboardInstanceConsumersProfilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersProfilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(consumerId, query, opts) {
    let path = `consumers/${consumerId}/profiles`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumersProfilesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersProfilesListOutput
    );
  }
  /**
   * @name Get consumer profile
   * @description Retrieves a consumer profile by ID for a consumer.
   *
   * @param `consumerId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersProfilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(consumerId, consumerProfileId, opts) {
    let path = `consumers/${consumerId}/profiles/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersProfilesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/conversations.ts
var MetorialConversationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistant conversations
   * @description List assistant conversations in an instance.
   *
   * @param `query` - DashboardInstanceConversationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "conversations";
    let request = {
      path,
      query: query ? mapDashboardInstanceConversationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsListOutput
    );
  }
  /**
   * @name Create assistant conversation
   * @description Create a new assistant conversation in an instance.
   *
   * @param `body` - DashboardInstanceConversationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "conversations";
    let request = {
      path,
      body: mapDashboardInstanceConversationsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsCreateOutput
    );
  }
  /**
   * @name Get assistant conversation
   * @description Get a specific assistant conversation.
   *
   * @param `assistantConversationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(assistantConversationId, opts) {
    let path = `conversations/${assistantConversationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsGetOutput
    );
  }
  /**
   * @name Update assistant conversation
   * @description Update a specific assistant conversation.
   *
   * @param `assistantConversationId` - string
   * @param `body` - DashboardInstanceConversationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(assistantConversationId, body, opts) {
    let path = `conversations/${assistantConversationId}`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceConversationsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/conversations_messages.ts
var MetorialConversationsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistant messages
   * @description List messages in a specific assistant conversation.
   *
   * @param `assistantConversationId` - string
   * @param `query` - DashboardInstanceConversationsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(assistantConversationId, query, opts) {
    let path = `conversations/${assistantConversationId}/messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConversationsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsMessagesListOutput
    );
  }
  /**
   * @name Create assistant message
   * @description Create a user message and assistant request in a specific conversation.
   *
   * @param `assistantConversationId` - string
   * @param `body` - DashboardInstanceConversationsMessagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(assistantConversationId, body, opts) {
    let path = `conversations/${assistantConversationId}/messages`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsMessagesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsMessagesCreateOutput
    );
  }
  /**
   * @name Get assistant message
   * @description Get a specific assistant message.
   *
   * @param `assistantConversationId` - string
   * @param `assistantMessageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(assistantConversationId, assistantMessageId, opts) {
    let path = `conversations/${assistantConversationId}/messages/${assistantMessageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsMessagesGetOutput
    );
  }
  /**
   * @name Respond to assistant handoffs
   * @description Submit one or more client handoff tool responses for a waiting message.
   *
   * @param `assistantConversationId` - string
   * @param `assistantMessageId` - string
   * @param `body` - DashboardInstanceConversationsMessagesHandoffResponsesBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesHandoffResponsesOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  handoffResponses(assistantConversationId, assistantMessageId, body, opts) {
    let path = `conversations/${assistantConversationId}/messages/${assistantMessageId}/handoff-responses`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsMessagesHandoffResponsesBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsMessagesHandoffResponsesOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/custom-providers.ts
var MetorialCustomProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom providers
   * @description Returns a paginated list of custom providers.
   *
   * @param `query` - DashboardInstanceCustomProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "custom-providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersListOutput
    );
  }
  /**
   * @name Get custom provider
   * @description Retrieves a specific custom provider by ID.
   *
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(customProviderId, opts) {
    let path = `custom-providers/${customProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersGetOutput
    );
  }
  /**
   * @name Get custom provider environment
   * @description Retrieves the environment variables for a specific custom provider by ID.
   *
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersGetEnvOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEnv(customProviderId, opts) {
    let path = `custom-providers/${customProviderId}/env`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersGetEnvOutput
    );
  }
  /**
   * @name Create custom provider
   * @description Creates a new custom provider.
   *
   * @param `body` - DashboardInstanceCustomProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "custom-providers";
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersCreateOutput
    );
  }
  /**
   * @name Update custom provider
   * @description Updates a specific custom provider.
   *
   * @param `customProviderId` - string
   * @param `body` - DashboardInstanceCustomProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(customProviderId, body, opts) {
    let path = `custom-providers/${customProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceCustomProvidersUpdateOutput
    );
  }
  /**
   * @name Archive custom provider
   * @description Archives a specific custom provider and disables new connections to it.
   *
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(customProviderId, opts) {
    let path = `custom-providers/${customProviderId}/archive`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersArchiveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/custom-providers_code.ts
var MetorialCustomProvidersCodeEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get code editor token
   * @description Get a token to access the code editor for a custom provider.
   *
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getCodeEditorToken(customProviderId, opts) {
    let path = `custom-providers/${customProviderId}/code-editor-token`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/custom-providers_commits.ts
var MetorialCustomProvidersCommitsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider commits
   * @description Returns a paginated list of commits for a custom provider.
   *
   * @param `query` - DashboardInstanceCustomProvidersCommitsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "custom-provider-commits";
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersCommitsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCommitsListOutput
    );
  }
  /**
   * @name Get custom provider commit
   * @description Retrieves a specific commit.
   *
   * @param `customProviderCommitId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(customProviderCommitId, opts) {
    let path = `custom-provider-commits/${customProviderCommitId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCommitsGetOutput
    );
  }
  /**
   * @name Create custom provider commit
   * @description Creates a new commit to promote or rollback a version in an environment.
   *
   * @param `body` - DashboardInstanceCustomProvidersCommitsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "custom-provider-commits";
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersCommitsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersCommitsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/custom-providers_deployments.ts
var MetorialCustomProvidersDeploymentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider deployments
   * @description Returns a paginated list of deployments for a custom provider.
   *
   * @param `query` - DashboardInstanceCustomProvidersDeploymentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "custom-provider-deployments";
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersDeploymentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsListOutput
    );
  }
  /**
   * @name Get custom provider deployment
   * @description Retrieves a specific deployment.
   *
   * @param `customProviderDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(customProviderDeploymentId, opts) {
    let path = `custom-provider-deployments/${customProviderDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsGetOutput
    );
  }
  /**
   * @name Get deployment logs
   * @description Retrieves the build and deployment logs for a deployment.
   *
   * @param `customProviderDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsGetLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getLogs(customProviderDeploymentId, opts) {
    let path = `custom-provider-deployments/${customProviderDeploymentId}/logs`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsGetLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/custom-providers_environments.ts
var MetorialCustomProvidersEnvironmentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider environments
   * @description Returns a paginated list of environments for a custom provider.
   *
   * @param `query` - DashboardInstanceCustomProvidersEnvironmentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersEnvironmentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "custom-provider-environments";
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersEnvironmentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersEnvironmentsListOutput
    );
  }
  /**
   * @name Get custom provider environment
   * @description Retrieves a specific environment.
   *
   * @param `customProviderEnvironmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersEnvironmentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(customProviderEnvironmentId, opts) {
    let path = `custom-provider-environments/${customProviderEnvironmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersEnvironmentsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/custom-providers_versions.ts
var MetorialCustomProvidersVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider versions
   * @description Returns a paginated list of versions for a custom provider.
   *
   * @param `query` - DashboardInstanceCustomProvidersVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "custom-provider-versions";
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersVersionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsListOutput
    );
  }
  /**
   * @name Get custom provider version
   * @description Retrieves a specific version of a custom provider.
   *
   * @param `customProviderVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(customProviderVersionId, opts) {
    let path = `custom-provider-versions/${customProviderVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsGetOutput
    );
  }
  /**
   * @name Get custom provider version environment
   * @description Retrieves the environment variables for a specific version of a custom provider.
   *
   * @param `customProviderVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsGetEnvOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEnv(customProviderVersionId, opts) {
    let path = `custom-provider-versions/${customProviderVersionId}/env`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsGetEnvOutput
    );
  }
  /**
   * @name Create custom provider version
   * @description Creates a new version for a custom provider.
   *
   * @param `body` - DashboardInstanceCustomProvidersVersionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "custom-provider-versions";
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersVersionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersVersionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard.ts
var MetorialDashboardEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create organization
   * @description Create a new organization
   *
   * @param `body` - DashboardBootBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardBootOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  boot(body, opts) {
    let path = "dashboard/boot";
    let request = {
      path,
      body: mapDashboardBootBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardBootOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_agents.ts
var MetorialDashboardInstanceAgentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List agents
   * @description Returns a paginated list of agents for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceAgentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/agents`;
    let request = {
      path,
      query: query ? mapDashboardInstanceAgentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceAgentsListOutput);
  }
  /**
   * @name Get agent
   * @description Retrieves a specific agent by ID.
   *
   * @param `instanceId` - string
   * @param `agentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, agentId, opts) {
    let path = `dashboard/instances/${instanceId}/agents/${agentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceAgentsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_agents_instances.ts
var MetorialDashboardInstanceAgentsInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List agent instances
   * @description Returns a paginated list of instances for an agent.
   *
   * @param `instanceId` - string
   * @param `agentId` - string
   * @param `query` - DashboardInstanceAgentsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, agentId, query, opts) {
    let path = `dashboard/instances/${instanceId}/agents/${agentId}/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceAgentsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAgentsInstancesListOutput
    );
  }
  /**
   * @name Get agent instance
   * @description Retrieves a specific agent instance by ID.
   *
   * @param `instanceId` - string
   * @param `agentId` - string
   * @param `agentInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, agentId, agentInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/agents/${agentId}/instances/${agentInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAgentsInstancesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_assistants.ts
var MetorialDashboardInstanceAssistantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistants
   * @description List assistants available in an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceAssistantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAssistantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/assistants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceAssistantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAssistantsListOutput
    );
  }
  /**
   * @name Get assistant
   * @description Get an assistant available in an instance.
   *
   * @param `instanceId` - string
   * @param `assistantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAssistantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, assistantId, opts) {
    let path = `dashboard/instances/${instanceId}/assistants/${assistantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAssistantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_callback-events.ts
var MetorialDashboardInstanceCallbackEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callback events
   * @description Returns a paginated list of callback events.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCallbackEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/callback-events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbackEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackEventsListOutput
    );
  }
  /**
   * @name Get callback event
   * @description Retrieves a specific callback event by ID, enriched with the payload the provider produced for it and, if it came from a webhook, the inbound request behind it.
   *
   * @param `instanceId` - string
   * @param `callbackEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, callbackEventId, opts) {
    let path = `dashboard/instances/${instanceId}/callback-events/${callbackEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_callback-instances.ts
var MetorialDashboardInstanceCallbackInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callback instances
   * @description Returns a paginated list of callback instances.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCallbackInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/callback-instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbackInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackInstancesListOutput
    );
  }
  /**
   * @name Get callback instance
   * @description Retrieves a specific callback instance by ID.
   *
   * @param `instanceId` - string
   * @param `callbackInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, callbackInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/callback-instances/${callbackInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackInstancesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_callbacks.ts
var MetorialDashboardInstanceCallbacksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callbacks
   * @description Returns a paginated list of callbacks.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCallbacksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/callbacks`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbacksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbacksListOutput
    );
  }
  /**
   * @name Create callback
   * @description Enables callbacks for an integration provider and returns the callback it created. Only providers whose type reports `triggers.status` as `enabled` support this. Callback instances are then registered for every matching integration instance in the background.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCallbacksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/callbacks`;
    let request = {
      path,
      body: mapDashboardInstanceCallbacksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCallbacksCreateOutput
    );
  }
  /**
   * @name Get callback
   * @description Retrieves a specific callback by ID.
   *
   * @param `instanceId` - string
   * @param `callbackId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, callbackId, opts) {
    let path = `dashboard/instances/${instanceId}/callbacks/${callbackId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceCallbacksGetOutput);
  }
  /**
   * @name Update callback
   * @description Updates the name, description or metadata of a callback. Everything else about a callback is derived from its integration provider - set `callbacks.status` to `disabled` there to tear it down.
   *
   * @param `instanceId` - string
   * @param `callbackId` - string
   * @param `body` - DashboardInstanceCallbacksUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, callbackId, body, opts) {
    let path = `dashboard/instances/${instanceId}/callbacks/${callbackId}`;
    let request = {
      path,
      body: mapDashboardInstanceCallbacksUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceCallbacksUpdateOutput
    );
  }
  /**
   * @name Delete callback
   * @description Disables callbacks on the underlying integration provider, tearing down this callback and every callback instance registered for it.
   *
   * @param `instanceId` - string
   * @param `callbackId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, callbackId, opts) {
    let path = `dashboard/instances/${instanceId}/callbacks/${callbackId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceCallbacksDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chat_connections.ts
var MetorialDashboardInstanceChatConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat connections
   * @description Returns a paginated list of chat connections.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chat/connections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatConnectionsListOutput
    );
  }
  /**
   * @name Get chat connection
   * @description Retrieves a specific chat connection.
   *
   * @param `instanceId` - string
   * @param `chatConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatConnectionId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/connections/${chatConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatConnectionsGetOutput
    );
  }
  /**
   * @name Create chat connection
   * @description Creates a new chat connection, together with the single provider it is linked to.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceChatConnectionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chat/connections`;
    let request = {
      path,
      body: mapDashboardInstanceChatConnectionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatConnectionsCreateOutput
    );
  }
  /**
   * @name Update chat connection
   * @description Updates a specific chat connection.
   *
   * @param `instanceId` - string
   * @param `chatConnectionId` - string
   * @param `body` - DashboardInstanceChatConnectionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, chatConnectionId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chat/connections/${chatConnectionId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatConnectionsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatConnectionsUpdateOutput
    );
  }
  /**
   * @name Delete chat connection
   * @description Archives a specific chat connection.
   *
   * @param `instanceId` - string
   * @param `chatConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatConnectionId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/connections/${chatConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatConnectionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chat_events.ts
var MetorialDashboardInstanceChatEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat events
   * @description Returns a paginated list of chat events.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chat/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatEventsListOutput
    );
  }
  /**
   * @name Get chat event
   * @description Retrieves a specific chat event.
   *
   * @param `instanceId` - string
   * @param `chatEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatEventId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/events/${chatEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chat_instances.ts
var MetorialDashboardInstanceChatInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat instances
   * @description Returns a paginated list of chat instances.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesListOutput
    );
  }
  /**
   * @name Get chat instance
   * @description Retrieves a specific chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances/${chatInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesGetOutput
    );
  }
  /**
   * @name Create chat instance
   * @description Creates a new chat instance for a chat connection.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceChatInstancesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatInstancesCreateOutput
    );
  }
  /**
   * @name Update chat instance
   * @description Updates a specific chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `body` - DashboardInstanceChatInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, chatInstanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances/${chatInstanceId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatInstancesUpdateOutput
    );
  }
  /**
   * @name Delete chat instance
   * @description Archives a specific chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances/${chatInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatInstancesDeleteOutput
    );
  }
  /**
   * @name Sync chat instance
   * @description Triggers a sync of the workspaces available on this chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(instanceId, chatInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances/${chatInstanceId}/sync`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatInstancesSyncOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chat_instances_provider.ts
var MetorialDashboardInstanceChatInstancesProviderEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get chat instance provider
   * @description Retrieves the single provider configured for a chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances/${chatInstanceId}/provider`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesProviderGetOutput
    );
  }
  /**
   * @name Set chat instance provider
   * @description Creates or updates the single provider for a chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `body` - DashboardInstanceChatInstancesProviderSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(instanceId, chatInstanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances/${chatInstanceId}/provider`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesProviderSetBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatInstancesProviderSetOutput
    );
  }
  /**
   * @name Get chat instance authenticated user
   * @description Retrieves the chat provider account this chat instance is authenticated as.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderAuthenticatedUserOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  authenticatedUser(instanceId, chatInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/chat/instances/${chatInstanceId}/provider/authenticated-user`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesProviderAuthenticatedUserOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chat_workspaces.ts
var MetorialDashboardInstanceChatWorkspacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat workspaces
   * @description Returns a paginated list of workspaces for a chat instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatWorkspacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatWorkspacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chat/workspaces`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatWorkspacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatWorkspacesListOutput
    );
  }
  /**
   * @name Get chat workspace
   * @description Retrieves a specific chat workspace.
   *
   * @param `instanceId` - string
   * @param `chatWorkspaceId` - string
   * @param `query` - DashboardInstanceChatWorkspacesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatWorkspacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatWorkspaceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chat/workspaces/${chatWorkspaceId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatWorkspacesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatWorkspacesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats.ts
var MetorialDashboardInstanceChatsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chats
   * @description Returns a paginated list of chats.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceChatsListOutput);
  }
  /**
   * @name Get chat
   * @description Retrieves a specific chat.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceChatsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_channels.ts
var MetorialDashboardInstanceChatsChannelsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat channels
   * @description Returns a paginated list of channels for a chat.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsChannelsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/channels`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsChannelsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsListOutput
    );
  }
  /**
   * @name Get chat channel
   * @description Retrieves a specific chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, channelId, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/channels/${channelId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_channels_members.ts
var MetorialDashboardInstanceChatsChannelsMembersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat channel members
   * @description Returns a paginated list of members of a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `query` - DashboardInstanceChatsChannelsMembersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsMembersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, channelId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/channels/${channelId}/members`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsChannelsMembersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsMembersListOutput
    );
  }
  /**
   * @name Get chat channel member
   * @description Retrieves a specific member of a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `userId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsMembersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, channelId, userId, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/channels/${channelId}/members/${userId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsMembersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_channels_typing.ts
var MetorialDashboardInstanceChatsChannelsTypingEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Start chat typing indicator
   * @description Shows a typing indicator in a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `body` - DashboardInstanceChatsChannelsTypingStartBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsTypingStartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  start(instanceId, chatId, channelId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/channels/${channelId}/typing`;
    let request = {
      path,
      body: mapDashboardInstanceChatsChannelsTypingStartBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsChannelsTypingStartOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_commands.ts
var MetorialDashboardInstanceChatsCommandsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Respond to chat command
   * @description Replies to a slash command from a chat.command.invoked event, using the provider's native command response.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsCommandsRespondBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsCommandsRespondOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  respond(instanceId, chatId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/commands/respond`;
    let request = {
      path,
      body: mapDashboardInstanceChatsCommandsRespondBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsCommandsRespondOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_dms.ts
var MetorialDashboardInstanceChatsDmsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Open chat DM
   * @description Opens (or retrieves) a direct message channel with one or more users.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsDmsOpenBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsDmsOpenOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  open(instanceId, chatId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/dms`;
    let request = {
      path,
      body: mapDashboardInstanceChatsDmsOpenBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsDmsOpenOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_messages.ts
var MetorialDashboardInstanceChatsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat messages
   * @description Returns a paginated list of messages in a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesListOutput
    );
  }
  /**
   * @name Get chat message
   * @description Retrieves a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, messageId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesGetOutput
    );
  }
  /**
   * @name Send chat message
   * @description Sends a new message to a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsMessagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, chatId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesCreateOutput
    );
  }
  /**
   * @name Edit chat message
   * @description Edits a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, chatId, messageId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatsMessagesUpdateOutput
    );
  }
  /**
   * @name Delete chat message
   * @description Deletes a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatId, messageId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesDeleteQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatsMessagesDeleteOutput
    );
  }
  /**
   * @name Mark chat message read
   * @description Marks a specific chat message as read.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesReadBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReadOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  read(instanceId, chatId, messageId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages/${messageId}/read`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesReadBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesReadOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_messages_reactions.ts
var MetorialDashboardInstanceChatsMessagesReactionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat message reactions
   * @description Returns the reactions left on a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesReactionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, messageId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesReactionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesReactionsListOutput
    );
  }
  /**
   * @name Add chat message reaction
   * @description Adds a reaction to a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesReactionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, chatId, messageId, body, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesReactionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesReactionsCreateOutput
    );
  }
  /**
   * @name Remove chat message reaction
   * @description Removes a reaction from a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesReactionsDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatId, messageId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesReactionsDeleteQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatsMessagesReactionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_chats_threads.ts
var MetorialDashboardInstanceChatsThreadsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat threads
   * @description Returns a paginated list of threads in a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsThreadsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsThreadsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/threads`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsThreadsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsThreadsListOutput
    );
  }
  /**
   * @name Get chat thread
   * @description Retrieves a specific chat thread.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `threadId` - string
   * @param `query` - DashboardInstanceChatsThreadsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsThreadsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, threadId, query, opts) {
    let path = `dashboard/instances/${instanceId}/chats/${chatId}/threads/${threadId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsThreadsGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsThreadsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_consumer-surfaces.ts
var MetorialDashboardInstanceConsumerSurfacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumer surfaces
   * @description Returns a paginated list of consumer surfaces for an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceConsumerSurfacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumerSurfacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/consumer-surfaces`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumerSurfacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumerSurfacesListOutput
    );
  }
  /**
   * @name Get consumer surface
   * @description Retrieves a consumer surface by ID.
   *
   * @param `instanceId` - string
   * @param `consumerSurfaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumerSurfacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, consumerSurfaceId, opts) {
    let path = `dashboard/instances/${instanceId}/consumer-surfaces/${consumerSurfaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumerSurfacesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_consumers.ts
var MetorialDashboardInstanceConsumersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumers
   * @description Returns a paginated list of consumers for an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceConsumersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/consumers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersListOutput
    );
  }
  /**
   * @name Get consumer
   * @description Retrieves a consumer by ID.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, consumerId, opts) {
    let path = `dashboard/instances/${instanceId}/consumers/${consumerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceConsumersGetOutput);
  }
  /**
   * @name Create consumer
   * @description Creates or links a consumer for an instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceConsumersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/consumers`;
    let request = {
      path,
      body: mapDashboardInstanceConsumersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConsumersCreateOutput
    );
  }
  /**
   * @name Get member consumer
   * @description Upserts and returns the consumer for the authenticated organization member.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceConsumersGetMemberConsumerBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersGetMemberConsumerOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getMemberConsumer(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/get-member-consumer`;
    let request = {
      path,
      body: mapDashboardInstanceConsumersGetMemberConsumerBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConsumersGetMemberConsumerOutput
    );
  }
  /**
   * @name Update consumer
   * @description Updates a consumer for an instance.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `body` - DashboardInstanceConsumersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, consumerId, body, opts) {
    let path = `dashboard/instances/${instanceId}/consumers/${consumerId}`;
    let request = {
      path,
      body: mapDashboardInstanceConsumersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceConsumersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_consumers_profiles.ts
var MetorialDashboardInstanceConsumersProfilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumer profiles
   * @description Returns a paginated list of profiles for a consumer in an instance.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `query` - DashboardInstanceConsumersProfilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersProfilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, consumerId, query, opts) {
    let path = `dashboard/instances/${instanceId}/consumers/${consumerId}/profiles`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumersProfilesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersProfilesListOutput
    );
  }
  /**
   * @name Get consumer profile
   * @description Retrieves a consumer profile by ID for a consumer.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersProfilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, consumerId, consumerProfileId, opts) {
    let path = `dashboard/instances/${instanceId}/consumers/${consumerId}/profiles/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersProfilesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_conversations.ts
var MetorialDashboardInstanceConversationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistant conversations
   * @description List assistant conversations in an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceConversationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/conversations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConversationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsListOutput
    );
  }
  /**
   * @name Create assistant conversation
   * @description Create a new assistant conversation in an instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceConversationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/conversations`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsCreateOutput
    );
  }
  /**
   * @name Get assistant conversation
   * @description Get a specific assistant conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, assistantConversationId, opts) {
    let path = `dashboard/instances/${instanceId}/conversations/${assistantConversationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsGetOutput
    );
  }
  /**
   * @name Update assistant conversation
   * @description Update a specific assistant conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `body` - DashboardInstanceConversationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, assistantConversationId, body, opts) {
    let path = `dashboard/instances/${instanceId}/conversations/${assistantConversationId}`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceConversationsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_conversations_messages.ts
var MetorialDashboardInstanceConversationsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistant messages
   * @description List messages in a specific assistant conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `query` - DashboardInstanceConversationsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, assistantConversationId, query, opts) {
    let path = `dashboard/instances/${instanceId}/conversations/${assistantConversationId}/messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConversationsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsMessagesListOutput
    );
  }
  /**
   * @name Create assistant message
   * @description Create a user message and assistant request in a specific conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `body` - DashboardInstanceConversationsMessagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, assistantConversationId, body, opts) {
    let path = `dashboard/instances/${instanceId}/conversations/${assistantConversationId}/messages`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsMessagesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsMessagesCreateOutput
    );
  }
  /**
   * @name Get assistant message
   * @description Get a specific assistant message.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `assistantMessageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, assistantConversationId, assistantMessageId, opts) {
    let path = `dashboard/instances/${instanceId}/conversations/${assistantConversationId}/messages/${assistantMessageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsMessagesGetOutput
    );
  }
  /**
   * @name Respond to assistant handoffs
   * @description Submit one or more client handoff tool responses for a waiting message.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `assistantMessageId` - string
   * @param `body` - DashboardInstanceConversationsMessagesHandoffResponsesBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesHandoffResponsesOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  handoffResponses(instanceId, assistantConversationId, assistantMessageId, body, opts) {
    let path = `dashboard/instances/${instanceId}/conversations/${assistantConversationId}/messages/${assistantMessageId}/handoff-responses`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsMessagesHandoffResponsesBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsMessagesHandoffResponsesOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_custom-providers.ts
var MetorialDashboardInstanceCustomProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom providers
   * @description Returns a paginated list of custom providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/custom-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersListOutput
    );
  }
  /**
   * @name Get custom provider
   * @description Retrieves a specific custom provider by ID.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-providers/${customProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersGetOutput
    );
  }
  /**
   * @name Get custom provider environment
   * @description Retrieves the environment variables for a specific custom provider by ID.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersGetEnvOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEnv(instanceId, customProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-providers/${customProviderId}/env`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersGetEnvOutput
    );
  }
  /**
   * @name Create custom provider
   * @description Creates a new custom provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCustomProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/custom-providers`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersCreateOutput
    );
  }
  /**
   * @name Update custom provider
   * @description Updates a specific custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `body` - DashboardInstanceCustomProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, customProviderId, body, opts) {
    let path = `dashboard/instances/${instanceId}/custom-providers/${customProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceCustomProvidersUpdateOutput
    );
  }
  /**
   * @name Archive custom provider
   * @description Archives a specific custom provider and disables new connections to it.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(instanceId, customProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-providers/${customProviderId}/archive`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersArchiveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_custom-providers_code.ts
var MetorialDashboardInstanceCustomProvidersCodeEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get code editor token
   * @description Get a token to access the code editor for a custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getCodeEditorToken(instanceId, customProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-providers/${customProviderId}/code-editor-token`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_custom-providers_commits.ts
var MetorialDashboardInstanceCustomProvidersCommitsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider commits
   * @description Returns a paginated list of commits for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersCommitsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-commits`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersCommitsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCommitsListOutput
    );
  }
  /**
   * @name Get custom provider commit
   * @description Retrieves a specific commit.
   *
   * @param `instanceId` - string
   * @param `customProviderCommitId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderCommitId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-commits/${customProviderCommitId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCommitsGetOutput
    );
  }
  /**
   * @name Create custom provider commit
   * @description Creates a new commit to promote or rollback a version in an environment.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCustomProvidersCommitsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-commits`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersCommitsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersCommitsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_custom-providers_deployments.ts
var MetorialDashboardInstanceCustomProvidersDeploymentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider deployments
   * @description Returns a paginated list of deployments for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersDeploymentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-deployments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersDeploymentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsListOutput
    );
  }
  /**
   * @name Get custom provider deployment
   * @description Retrieves a specific deployment.
   *
   * @param `instanceId` - string
   * @param `customProviderDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderDeploymentId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-deployments/${customProviderDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsGetOutput
    );
  }
  /**
   * @name Get deployment logs
   * @description Retrieves the build and deployment logs for a deployment.
   *
   * @param `instanceId` - string
   * @param `customProviderDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsGetLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getLogs(instanceId, customProviderDeploymentId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-deployments/${customProviderDeploymentId}/logs`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsGetLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_custom-providers_environments.ts
var MetorialDashboardInstanceCustomProvidersEnvironmentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider environments
   * @description Returns a paginated list of environments for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersEnvironmentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersEnvironmentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-environments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersEnvironmentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersEnvironmentsListOutput
    );
  }
  /**
   * @name Get custom provider environment
   * @description Retrieves a specific environment.
   *
   * @param `instanceId` - string
   * @param `customProviderEnvironmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersEnvironmentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderEnvironmentId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-environments/${customProviderEnvironmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersEnvironmentsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_custom-providers_versions.ts
var MetorialDashboardInstanceCustomProvidersVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider versions
   * @description Returns a paginated list of versions for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersVersionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsListOutput
    );
  }
  /**
   * @name Get custom provider version
   * @description Retrieves a specific version of a custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderVersionId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-versions/${customProviderVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsGetOutput
    );
  }
  /**
   * @name Get custom provider version environment
   * @description Retrieves the environment variables for a specific version of a custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsGetEnvOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEnv(instanceId, customProviderVersionId, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-versions/${customProviderVersionId}/env`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsGetEnvOutput
    );
  }
  /**
   * @name Create custom provider version
   * @description Creates a new version for a custom provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCustomProvidersVersionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/custom-provider-versions`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersVersionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersVersionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_documents.ts
var MetorialDashboardInstanceDocumentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List documents
   * @description Returns a paginated list of documents owned by the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceDocumentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/documents`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsListOutput
    );
  }
  /**
   * @name Create document
   * @description Creates a new document for the instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceDocumentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/documents`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceDocumentsCreateOutput
    );
  }
  /**
   * @name Get document by ID
   * @description Retrieves a document by its ID.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceDocumentsGetOutput);
  }
  /**
   * @name Update document by ID
   * @description Updates a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `body` - DashboardInstanceDocumentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, documentId, body, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceDocumentsUpdateOutput
    );
  }
  /**
   * @name Delete document by ID
   * @description Deletes a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, documentId, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceDocumentsDeleteOutput
    );
  }
  /**
   * @name Clone document by ID
   * @description Clones a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `body` - DashboardInstanceDocumentsCloneBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsCloneOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  clone(instanceId, documentId, body, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}/clone`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsCloneBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceDocumentsCloneOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_documents_edit-token.ts
var MetorialDashboardInstanceDocumentsEditTokenEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get document edit token
   * @description Returns a short-lived read or write token for establishing a live document session.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsEditTokenGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}/edit-token`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsEditTokenGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_documents_participants.ts
var MetorialDashboardInstanceDocumentsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List document participants
   * @description Returns a paginated list of participants for a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `query` - DashboardInstanceDocumentsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, documentId, query, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsParticipantsListOutput
    );
  }
  /**
   * @name Get document participant by ID
   * @description Retrieves a specific document participant by its ID.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `documentParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, documentParticipantId, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}/participants/${documentParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_documents_permissions.ts
var MetorialDashboardInstanceDocumentsPermissionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get document permissions
   * @description Returns the effective Cargo permissions for the current actor on a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsPermissionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}/permissions`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsPermissionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_documents_versions.ts
var MetorialDashboardInstanceDocumentsVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List document versions
   * @description Returns a paginated list of versions for a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `query` - DashboardInstanceDocumentsVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, documentId, query, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsVersionsListOutput
    );
  }
  /**
   * @name Get document version by ID
   * @description Retrieves a specific document version by its ID.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `documentVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, documentVersionId, opts) {
    let path = `dashboard/instances/${instanceId}/documents/${documentId}/versions/${documentVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_files.ts
var MetorialDashboardInstanceFilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List instance files
   * @description Returns a paginated list of files owned by the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceFilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/files`;
    let request = {
      path,
      query: query ? mapDashboardInstanceFilesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFilesListOutput);
  }
  /**
   * @name Get file by ID
   * @description Retrieves details for a specific file by its ID.
   *
   * @param `instanceId` - string
   * @param `fileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, fileId, opts) {
    let path = `dashboard/instances/${instanceId}/files/${fileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFilesGetOutput);
  }
  /**
   * @name Delete file by ID
   * @description Deletes a specific file by its ID.
   *
   * @param `instanceId` - string
   * @param `fileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, fileId, opts) {
    let path = `dashboard/instances/${instanceId}/files/${fileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFilesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_files_links.ts
var MetorialDashboardInstanceFilesLinksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List file links
   * @description Returns a paginated list of file links owned by the instance organization.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceFilesLinksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/file-links`;
    let request = {
      path,
      query: query ? mapDashboardInstanceFilesLinksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFilesLinksListOutput
    );
  }
  /**
   * @name Get file link by ID
   * @description Retrieves the details of a specific file link by its ID.
   *
   * @param `instanceId` - string
   * @param `linkId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, linkId, opts) {
    let path = `dashboard/instances/${instanceId}/file-links/${linkId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFilesLinksGetOutput
    );
  }
  /**
   * @name Create file link
   * @description Creates a new link for a specific file.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceFilesLinksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/file-links`;
    let request = {
      path,
      body: mapDashboardInstanceFilesLinksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFilesLinksCreateOutput
    );
  }
  /**
   * @name Delete file link by ID
   * @description Deletes a specific file link by its ID.
   *
   * @param `instanceId` - string
   * @param `linkId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, linkId, opts) {
    let path = `dashboard/instances/${instanceId}/file-links/${linkId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFilesLinksDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_firewalls.ts
var MetorialDashboardInstanceFirewallsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List firewalls
   * @description Returns a paginated list of firewalls.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceFirewallsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/firewalls`;
    let request = {
      path,
      query: query ? mapDashboardInstanceFirewallsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFirewallsListOutput
    );
  }
  /**
   * @name Get firewall
   * @description Retrieves a specific firewall by ID.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, firewallId, opts) {
    let path = `dashboard/instances/${instanceId}/firewalls/${firewallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFirewallsGetOutput);
  }
  /**
   * @name Create firewall
   * @description Creates a new firewall.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceFirewallsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/firewalls`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFirewallsCreateOutput
    );
  }
  /**
   * @name Update firewall
   * @description Updates a firewall definition.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `body` - DashboardInstanceFirewallsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, firewallId, body, opts) {
    let path = `dashboard/instances/${instanceId}/firewalls/${firewallId}`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceFirewallsUpdateOutput
    );
  }
  /**
   * @name Delete firewall
   * @description Archives a firewall.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, firewallId, opts) {
    let path = `dashboard/instances/${instanceId}/firewalls/${firewallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFirewallsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_firewalls_network-policies.ts
var MetorialDashboardInstanceFirewallsNetworkPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Attach network policy
   * @description Attaches a network policy to a firewall.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `body` - DashboardInstanceFirewallsNetworkPoliciesAttachBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsNetworkPoliciesAttachOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  attach(instanceId, firewallId, body, opts) {
    let path = `dashboard/instances/${instanceId}/firewalls/${firewallId}/network-policies`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsNetworkPoliciesAttachBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFirewallsNetworkPoliciesAttachOutput
    );
  }
  /**
   * @name Detach network policy
   * @description Detaches a network policy from a firewall.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsNetworkPoliciesDetachOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  detach(instanceId, firewallId, networkPolicyId, opts) {
    let path = `dashboard/instances/${instanceId}/firewalls/${firewallId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFirewallsNetworkPoliciesDetachOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_identities.ts
var MetorialDashboardInstanceIdentitiesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identities
   * @description Returns a paginated list of identities for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identities`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesListOutput
    );
  }
  /**
   * @name Get identity
   * @description Retrieves a specific identity by ID.
   *
   * @param `instanceId` - string
   * @param `identityId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityId, opts) {
    let path = `dashboard/instances/${instanceId}/identities/${identityId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesGetOutput
    );
  }
  /**
   * @name Create identity
   * @description Creates a new identity owned by an existing identity actor.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identities`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesCreateOutput
    );
  }
  /**
   * @name Update identity
   * @description Updates mutable fields on an existing identity.
   *
   * @param `instanceId` - string
   * @param `identityId` - string
   * @param `body` - DashboardInstanceIdentitiesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identities/${identityId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesUpdateOutput
    );
  }
  /**
   * @name Delete identity
   * @description Archives an identity.
   *
   * @param `instanceId` - string
   * @param `identityId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityId, opts) {
    let path = `dashboard/instances/${instanceId}/identities/${identityId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_identities_credentials.ts
var MetorialDashboardInstanceIdentitiesCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity credentials
   * @description Returns a paginated list of identity credentials for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-credentials`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesCredentialsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesCredentialsListOutput
    );
  }
  /**
   * @name Get identity credential
   * @description Retrieves a specific identity credential by ID.
   *
   * @param `instanceId` - string
   * @param `identityCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityCredentialId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesCredentialsGetOutput
    );
  }
  /**
   * @name Create identity credential
   * @description Creates a new credential and attaches it to an identity.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-credentials`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesCredentialsCreateOutput
    );
  }
  /**
   * @name Update identity credential
   * @description Updates the delegation config attached to an identity credential.
   *
   * @param `instanceId` - string
   * @param `identityCredentialId` - string
   * @param `body` - DashboardInstanceIdentitiesCredentialsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityCredentialId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCredentialsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesCredentialsUpdateOutput
    );
  }
  /**
   * @name Delete identity credential
   * @description Archives an identity credential.
   *
   * @param `instanceId` - string
   * @param `identityCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityCredentialId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_identities_delegation-configs.ts
var MetorialDashboardInstanceIdentitiesDelegationConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegation configs
   * @description Returns a paginated list of identity delegation configs.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-configs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsListOutput
    );
  }
  /**
   * @name Get identity delegation config
   * @description Retrieves a specific identity delegation config by ID.
   *
   * @param `instanceId` - string
   * @param `identityDelegationConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityDelegationConfigId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsGetOutput
    );
  }
  /**
   * @name Create identity delegation config
   * @description Creates a new identity delegation config.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-configs`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsCreateOutput
    );
  }
  /**
   * @name Update identity delegation config
   * @description Updates mutable fields on an existing identity delegation config.
   *
   * @param `instanceId` - string
   * @param `identityDelegationConfigId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityDelegationConfigId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsUpdateOutput
    );
  }
  /**
   * @name Delete identity delegation config
   * @description Archives an identity delegation config.
   *
   * @param `instanceId` - string
   * @param `identityDelegationConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityDelegationConfigId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_identities_delegation-requests.ts
var MetorialDashboardInstanceIdentitiesDelegationRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegation requests
   * @description Returns a paginated list of identity delegation requests.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-requests`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsListOutput
    );
  }
  /**
   * @name Get identity delegation request
   * @description Retrieves a specific identity delegation request by ID.
   *
   * @param `instanceId` - string
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityDelegationRequestId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-requests/${identityDelegationRequestId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsGetQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsGetOutput
    );
  }
  /**
   * @name Create identity delegation request
   * @description Creates a new identity delegation request.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationRequestsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-requests`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationRequestsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsCreateOutput
    );
  }
  /**
   * @name Approve identity delegation request
   * @description Approves an existing identity delegation request.
   *
   * @param `instanceId` - string
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsApproveQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsApproveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  approve(instanceId, identityDelegationRequestId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-requests/${identityDelegationRequestId}/approve`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsApproveQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsApproveOutput
    );
  }
  /**
   * @name Deny identity delegation request
   * @description Denies an existing identity delegation request.
   *
   * @param `instanceId` - string
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsDenyQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsDenyOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  deny(instanceId, identityDelegationRequestId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegation-requests/${identityDelegationRequestId}/deny`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsDenyQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsDenyOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_identities_delegations.ts
var MetorialDashboardInstanceIdentitiesDelegationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegations
   * @description Returns a paginated list of identity delegations for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationsListOutput
    );
  }
  /**
   * @name Get identity delegation
   * @description Retrieves a specific identity delegation by ID.
   *
   * @param `instanceId` - string
   * @param `identityDelegationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityDelegationId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegations/${identityDelegationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationsGetOutput
    );
  }
  /**
   * @name Create identity delegation
   * @description Creates a new identity delegation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegations`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationsCreateOutput
    );
  }
  /**
   * @name Revoke identity delegation
   * @description Revokes an existing identity delegation.
   *
   * @param `instanceId` - string
   * @param `identityDelegationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(instanceId, identityDelegationId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-delegations/${identityDelegationId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_identity-actors.ts
var MetorialDashboardInstanceIdentityActorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity actors
   * @description Returns a paginated list of identity actors for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentityActorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/identity-actors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentityActorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentityActorsListOutput
    );
  }
  /**
   * @name Get identity actor
   * @description Retrieves a specific identity actor by ID.
   *
   * @param `instanceId` - string
   * @param `identityActorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityActorId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-actors/${identityActorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentityActorsGetOutput
    );
  }
  /**
   * @name Create identity actor
   * @description Creates a new identity actor.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentityActorsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-actors`;
    let request = {
      path,
      body: mapDashboardInstanceIdentityActorsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentityActorsCreateOutput
    );
  }
  /**
   * @name Update identity actor
   * @description Updates mutable fields on an existing identity actor.
   *
   * @param `instanceId` - string
   * @param `identityActorId` - string
   * @param `body` - DashboardInstanceIdentityActorsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityActorId, body, opts) {
    let path = `dashboard/instances/${instanceId}/identity-actors/${identityActorId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentityActorsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentityActorsUpdateOutput
    );
  }
  /**
   * @name Delete identity actor
   * @description Archives an identity actor.
   *
   * @param `instanceId` - string
   * @param `identityActorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityActorId, opts) {
    let path = `dashboard/instances/${instanceId}/identity-actors/${identityActorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentityActorsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_incoming-webhooks.ts
var MetorialDashboardInstanceIncomingWebhooksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List incoming webhooks
   * @description Returns a paginated list of incoming webhooks you can see.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIncomingWebhooksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIncomingWebhooksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/incoming-webhooks`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIncomingWebhooksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIncomingWebhooksListOutput
    );
  }
  /**
   * @name Get incoming webhook
   * @description Retrieves a specific incoming webhook.
   *
   * @param `instanceId` - string
   * @param `incomingWebhookId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIncomingWebhooksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, incomingWebhookId, opts) {
    let path = `dashboard/instances/${instanceId}/incoming-webhooks/${incomingWebhookId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIncomingWebhooksGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integration-enclaves.ts
var MetorialDashboardInstanceIntegrationEnclavesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get last used integration enclaves
   * @description Returns recently used integration enclaves for dashboard filters.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationEnclavesGetLastUsedQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationEnclavesGetLastUsedOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getLastUsed(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-enclaves/last-used`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationEnclavesGetLastUsedQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationEnclavesGetLastUsedOutput
    );
  }
  /**
   * @name List integration enclaves
   * @description Returns a paginated list of integration enclaves.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationEnclavesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationEnclavesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-enclaves`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationEnclavesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationEnclavesListOutput
    );
  }
  /**
   * @name Get integration enclave
   * @description Retrieves a specific integration enclave by ID.
   *
   * @param `instanceId` - string
   * @param `integrationEnclaveId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationEnclavesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationEnclaveId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-enclaves/${integrationEnclaveId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationEnclavesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integration-firewall-assignments.ts
var MetorialDashboardInstanceIntegrationFirewallAssignmentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration firewall assignments
   * @description Returns a paginated list of integration firewall assignments.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationFirewallAssignmentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-firewall-assignments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationFirewallAssignmentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsListOutput
    );
  }
  /**
   * @name Get integration firewall assignment
   * @description Retrieves a specific integration firewall assignment by ID.
   *
   * @param `instanceId` - string
   * @param `integrationFirewallAssignmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationFirewallAssignmentId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-firewall-assignments/${integrationFirewallAssignmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsGetOutput
    );
  }
  /**
   * @name Create integration firewall assignment
   * @description Creates an assignment that applies a firewall to a target.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationFirewallAssignmentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-firewall-assignments`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationFirewallAssignmentsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsCreateOutput
    );
  }
  /**
   * @name Delete integration firewall assignment
   * @description Deletes an integration firewall assignment.
   *
   * @param `instanceId` - string
   * @param `integrationFirewallAssignmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationFirewallAssignmentId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-firewall-assignments/${integrationFirewallAssignmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integration-internet-gateway.ts
var MetorialDashboardInstanceIntegrationInternetGatewayEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get integration internet gateway
   * @description Retrieves the integration internet gateway of the instance, including its public IPs.
   *
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationInternetGatewayGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-internet-gateway`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationInternetGatewayGetOutput
    );
  }
  /**
   * @name List integration internet gateway network logs
   * @description Returns ingress or egress network logs for integration enclaves in the instance environment.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  listNetworkLogs(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-internet-gateway/network-logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integrations.ts
var MetorialDashboardInstanceIntegrationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integrations
   * @description Returns a paginated list of integrations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integrations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsListOutput
    );
  }
  /**
   * @name Get integration
   * @description Retrieves a specific integration.
   *
   * @param `instanceId` - string
   * @param `integrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationId, opts) {
    let path = `dashboard/instances/${instanceId}/integrations/${integrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsGetOutput
    );
  }
  /**
   * @name Create integration
   * @description Creates a new integration.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integrations`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsCreateOutput
    );
  }
  /**
   * @name Update integration
   * @description Updates a specific integration.
   *
   * @param `instanceId` - string
   * @param `integrationId` - string
   * @param `body` - DashboardInstanceIntegrationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integrations/${integrationId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsUpdateOutput
    );
  }
  /**
   * @name Delete integration
   * @description Archives a specific integration.
   *
   * @param `instanceId` - string
   * @param `integrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationId, opts) {
    let path = `dashboard/instances/${instanceId}/integrations/${integrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integrations_instance-groups.ts
var MetorialDashboardInstanceIntegrationsInstanceGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance groups
   * @description Returns a paginated list of integration instance groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstanceGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstanceGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsListOutput
    );
  }
  /**
   * @name Get integration instance group
   * @description Retrieves a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsGetOutput
    );
  }
  /**
   * @name Create integration instance group session template
   * @description Creates or updates the shared session template for a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSessionTemplate(instanceId, integrationInstanceGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}/session-template`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput
    );
  }
  /**
   * @name Create integration instance group session
   * @description Creates a session from the shared session template of a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateSessionBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSession(instanceId, integrationInstanceGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}/session`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput
    );
  }
  /**
   * @name Create integration instance group
   * @description Creates a new integration instance group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateOutput
    );
  }
  /**
   * @name Update integration instance group
   * @description Updates a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationInstanceGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsUpdateOutput
    );
  }
  /**
   * @name Delete integration instance group
   * @description Archives a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationInstanceGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integrations_instance-groups_providers.ts
var MetorialDashboardInstanceIntegrationsInstanceGroupsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance group providers
   * @description Returns a paginated list of integration instance group providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstanceGroupsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-group-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstanceGroupsProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersListOutput
    );
  }
  /**
   * @name Get integration instance group provider
   * @description Retrieves a specific integration instance group provider.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceGroupProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-group-providers/${integrationInstanceGroupProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput
    );
  }
  /**
   * @name Set integration instance group provider
   * @description Creates or updates the effective integration instance group provider materialization.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `integrationInstanceProviderId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsProvidersSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(instanceId, integrationInstanceGroupId, integrationInstanceProviderId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}/providers/${integrationInstanceProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput
    );
  }
  /**
   * @name Delete integration instance group provider
   * @description Archives a specific integration instance group provider.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationInstanceGroupProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-group-providers/${integrationInstanceGroupProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integrations_instances.ts
var MetorialDashboardInstanceIntegrationsInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instances
   * @description Returns a paginated list of integration instances.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesListOutput
    );
  }
  /**
   * @name Get integration instance
   * @description Retrieves a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesGetOutput
    );
  }
  /**
   * @name Create integration instance session template
   * @description Creates or updates the shared session template for a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateSessionTemplateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSessionTemplate(instanceId, integrationInstanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances/${integrationInstanceId}/session-template`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput
    );
  }
  /**
   * @name Create integration instance session
   * @description Creates a session from the shared session template of a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateSessionBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateSessionOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSession(instanceId, integrationInstanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances/${integrationInstanceId}/session`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateSessionBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateSessionOutput
    );
  }
  /**
   * @name Create integration instance
   * @description Creates a new integration instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateOutput
    );
  }
  /**
   * @name Update integration instance
   * @description Updates a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationInstanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsInstancesUpdateOutput
    );
  }
  /**
   * @name Delete integration instance
   * @description Archives a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstancesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integrations_instances_providers.ts
var MetorialDashboardInstanceIntegrationsInstancesProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance providers
   * @description Returns a paginated list of integration instance providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstancesProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstancesProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersListOutput
    );
  }
  /**
   * @name Get integration instance provider
   * @description Retrieves a specific integration instance provider.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instance-providers/${integrationInstanceProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersGetOutput
    );
  }
  /**
   * @name Set integration instance provider
   * @description Creates or updates the effective integration instance provider materialization.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `providerId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesProvidersSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(instanceId, integrationInstanceId, providerId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-instances/${integrationInstanceId}/providers/${providerId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesProvidersSetBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersSetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integrations_providers.ts
var MetorialDashboardInstanceIntegrationsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration providers
   * @description Returns a paginated list of integration providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsProvidersListOutput
    );
  }
  /**
   * @name Get integration provider
   * @description Retrieves a specific integration provider.
   *
   * @param `instanceId` - string
   * @param `integrationProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-providers/${integrationProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsProvidersGetOutput
    );
  }
  /**
   * @name Create integration provider
   * @description Creates a new integration provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-providers`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsProvidersCreateOutput
    );
  }
  /**
   * @name Update integration provider
   * @description Updates a specific integration provider.
   *
   * @param `instanceId` - string
   * @param `integrationProviderId` - string
   * @param `body` - DashboardInstanceIntegrationsProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationProviderId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-providers/${integrationProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsProvidersUpdateOutput
    );
  }
  /**
   * @name Delete integration provider
   * @description Archives a specific integration provider.
   *
   * @param `instanceId` - string
   * @param `integrationProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-providers/${integrationProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_integrations_setup-sessions.ts
var MetorialDashboardInstanceIntegrationsSetupSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration setup sessions
   * @description Returns a paginated list of integration setup sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsSetupSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/integration-setup-sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsSetupSessionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsListOutput
    );
  }
  /**
   * @name Get integration setup session
   * @description Retrieves a specific integration setup session.
   *
   * @param `instanceId` - string
   * @param `integrationSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationSetupSessionId, opts) {
    let path = `dashboard/instances/${instanceId}/integration-setup-sessions/${integrationSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsGetOutput
    );
  }
  /**
   * @name Create integration setup session
   * @description Creates a new integration setup session. Creates a draft integration instance unless integration_instance_id is given, in which case that instance is reused and its config and auth config are overwritten on completion.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsSetupSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/integration-setup-sessions`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsSetupSessionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_magic-mcp-endpoints.ts
var MetorialDashboardInstanceMagicMcpEndpointsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP endpoints
   * @description Returns a paginated list of magic MCP endpoints.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpEndpointsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-endpoints`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpEndpointsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpEndpointsListOutput
    );
  }
  /**
   * @name Get magic MCP endpoint
   * @description Retrieves a specific magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpEndpointId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpEndpointsGetOutput
    );
  }
  /**
   * @name Create magic MCP endpoint
   * @description Creates a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-endpoints`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsCreateOutput
    );
  }
  /**
   * @name Delete magic MCP endpoint
   * @description Archives a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpEndpointId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpEndpointsDeleteOutput
    );
  }
  /**
   * @name Update magic MCP endpoint
   * @description Updates a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpEndpointId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpEndpointsUpdateOutput
    );
  }
  /**
   * @name Add servers to magic MCP endpoint
   * @description Adds magic MCP servers to a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsAddServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsAddServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addServers(instanceId, magicMcpEndpointId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}/add-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsAddServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsAddServersOutput
    );
  }
  /**
   * @name Remove servers from magic MCP endpoint
   * @description Removes magic MCP servers from a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsRemoveServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsRemoveServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeServers(instanceId, magicMcpEndpointId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}/remove-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsRemoveServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsRemoveServersOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_magic-mcp-groups.ts
var MetorialDashboardInstanceMagicMcpGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP groups
   * @description Returns a paginated list of magic MCP groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpGroupsListOutput
    );
  }
  /**
   * @name Get magic MCP group
   * @description Retrieves a specific magic MCP group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpGroupsGetOutput
    );
  }
  /**
   * @name Create magic MCP group
   * @description Creates a magic MCP group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsCreateOutput
    );
  }
  /**
   * @name Delete magic MCP group
   * @description Deletes a magic MCP group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpGroupsDeleteOutput
    );
  }
  /**
   * @name Update magic MCP group
   * @description Updates a magic MCP group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpGroupsUpdateOutput
    );
  }
  /**
   * @name Add servers to magic MCP group
   * @description Adds magic MCP servers to a group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsAddServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsAddServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addServers(instanceId, magicMcpGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}/add-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsAddServersBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsAddServersOutput
    );
  }
  /**
   * @name Remove servers from magic MCP group
   * @description Removes magic MCP servers from a group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsRemoveServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsRemoveServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeServers(instanceId, magicMcpGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}/remove-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsRemoveServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsRemoveServersOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_magic-mcp-servers.ts
var MetorialDashboardInstanceMagicMcpServersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP servers
   * @description Returns a paginated list of magic MCP servers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpServersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpServersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersListOutput
    );
  }
  /**
   * @name Get magic MCP server
   * @description Retrieves a specific magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpServerId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersGetOutput
    );
  }
  /**
   * @name List magic MCP server tools
   * @description Returns the effective set of tools available through the providers backing a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersToolsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  tools(instanceId, magicMcpServerId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/tools`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersToolsOutput
    );
  }
  /**
   * @name Create magic MCP server
   * @description Creates a magic MCP server with a new session template. A Subspace session is created automatically on first connection and then reused.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpServersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersCreateOutput
    );
  }
  /**
   * @name Delete magic MCP server
   * @description Archives a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpServerId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpServersDeleteOutput
    );
  }
  /**
   * @name Update magic MCP server
   * @description Updates a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `body` - DashboardInstanceMagicMcpServersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpServerId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpServersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_magic-mcp-servers_providers.ts
var MetorialDashboardInstanceMagicMcpServersProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP server providers
   * @description Returns the backing integration instance providers configured for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `query` - DashboardInstanceMagicMcpServersProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, magicMcpServerId, query, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpServersProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersListOutput
    );
  }
  /**
   * @name Create magic MCP server provider
   * @description Creates a configurable provider row for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `body` - DashboardInstanceMagicMcpServersProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, magicMcpServerId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersCreateOutput
    );
  }
  /**
   * @name Get magic MCP server provider
   * @description Retrieves a specific backing integration instance provider for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpServerId, magicMcpServerProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersGetOutput
    );
  }
  /**
   * @name Update magic MCP server provider
   * @description Updates a backing integration provider and then sets the corresponding integration instance provider for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `body` - DashboardInstanceMagicMcpServersProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpServerId, magicMcpServerProviderId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersUpdateOutput
    );
  }
  /**
   * @name Delete magic MCP server provider
   * @description Archives a backing integration instance provider from a magic MCP server and removes the shared integration provider when unused.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpServerId, magicMcpServerProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_magic-mcp-servers_session.ts
var MetorialDashboardInstanceMagicMcpServersSessionEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create linked magic MCP server session
   * @description Resolves the current internal ephemeral managed session for a magic MCP server and returns it as a dashboard session.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersSessionCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, magicMcpServerId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/session`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersSessionCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_magic-mcp-sessions.ts
var MetorialDashboardInstanceMagicMcpSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP sessions
   * @description Returns a paginated list of magic MCP sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpSessionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpSessionsListOutput
    );
  }
  /**
   * @name Get magic MCP session
   * @description Retrieves a specific magic MCP session.
   *
   * @param `instanceId` - string
   * @param `magicMcpSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpSessionId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-sessions/${magicMcpSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpSessionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_magic-mcp-tokens.ts
var MetorialDashboardInstanceMagicMcpTokensEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP tokens
   * @description Returns a paginated list of magic MCP tokens.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpTokensListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-tokens`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpTokensListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpTokensListOutput
    );
  }
  /**
   * @name Get magic MCP token
   * @description Retrieves a specific magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpTokenId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpTokensGetOutput
    );
  }
  /**
   * @name Create magic MCP token
   * @description Creates a new magic MCP token.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-tokens`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensCreateOutput
    );
  }
  /**
   * @name Delete magic MCP token
   * @description Deletes a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpTokenId, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpTokensDeleteOutput
    );
  }
  /**
   * @name Update magic MCP token
   * @description Updates a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpTokenId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpTokensUpdateOutput
    );
  }
  /**
   * @name Add magic MCP groups to token
   * @description Adds groups to a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensAddGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensAddGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addGroups(instanceId, magicMcpTokenId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}/add-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensAddGroupsBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensAddGroupsOutput
    );
  }
  /**
   * @name Remove magic MCP groups from token
   * @description Removes groups from a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensRemoveGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensRemoveGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeGroups(instanceId, magicMcpTokenId, body, opts) {
    let path = `dashboard/instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}/remove-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensRemoveGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensRemoveGroupsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_monitor-alerts.ts
var MetorialDashboardInstanceMonitorAlertsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List monitor alerts
   * @description Returns a paginated list of monitor alerts for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMonitorAlertsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/monitor-alerts`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMonitorAlertsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMonitorAlertsListOutput
    );
  }
  /**
   * @name Get monitor alert
   * @description Retrieves a monitor alert by ID.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, monitorAlertId, opts) {
    let path = `dashboard/instances/${instanceId}/monitor-alerts/${monitorAlertId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMonitorAlertsGetOutput
    );
  }
  /**
   * @name Mark monitor alert viewed
   * @description Marks a monitor alert as viewed by the current actor.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsViewedOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  viewed(instanceId, monitorAlertId, opts) {
    let path = `dashboard/instances/${instanceId}/monitor-alerts/${monitorAlertId}/viewed`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsViewedOutput
    );
  }
  /**
   * @name Resolve monitor alert
   * @description Marks a monitor alert as resolved.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resolve(instanceId, monitorAlertId, opts) {
    let path = `dashboard/instances/${instanceId}/monitor-alerts/${monitorAlertId}/resolve`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsResolveOutput
    );
  }
  /**
   * @name Unresolve monitor alert
   * @description Reopens a resolved monitor alert.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsUnresolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  unresolve(instanceId, monitorAlertId, opts) {
    let path = `dashboard/instances/${instanceId}/monitor-alerts/${monitorAlertId}/unresolve`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsUnresolveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_monitors.ts
var MetorialDashboardInstanceMonitorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List monitors
   * @description Returns a paginated list of monitors for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMonitorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/monitors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMonitorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceMonitorsListOutput);
  }
  /**
   * @name Get monitor
   * @description Retrieves a monitor by ID.
   *
   * @param `instanceId` - string
   * @param `monitorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, monitorId, opts) {
    let path = `dashboard/instances/${instanceId}/monitors/${monitorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceMonitorsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_network-policies.ts
var MetorialDashboardInstanceNetworkPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List network policies
   * @description Returns a paginated list of network policies.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceNetworkPoliciesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies`;
    let request = {
      path,
      query: query ? mapDashboardInstanceNetworkPoliciesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceNetworkPoliciesListOutput
    );
  }
  /**
   * @name Get network policy
   * @description Retrieves a specific network policy by ID.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, networkPolicyId, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceNetworkPoliciesGetOutput
    );
  }
  /**
   * @name Create network policy
   * @description Creates a new network policy.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceNetworkPoliciesCreateOutput
    );
  }
  /**
   * @name Update network policy
   * @description Updates a network policy definition.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, networkPolicyId, body, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceNetworkPoliciesUpdateOutput
    );
  }
  /**
   * @name Delete network policy
   * @description Archives a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, networkPolicyId, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceNetworkPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_network-policies_rules.ts
var MetorialDashboardInstanceNetworkPoliciesRulesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create network policy rule
   * @description Adds a rule to a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesRulesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, networkPolicyId, body, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies/${networkPolicyId}/rules`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesRulesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesCreateOutput
    );
  }
  /**
   * @name Update network policy rule
   * @description Updates a rule on a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `ruleId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesRulesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, networkPolicyId, ruleId, body, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies/${networkPolicyId}/rules/${ruleId}`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesRulesUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesUpdateOutput
    );
  }
  /**
   * @name Delete network policy rule
   * @description Removes a rule from a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `ruleId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, networkPolicyId, ruleId, opts) {
    let path = `dashboard/instances/${instanceId}/network-policies/${networkPolicyId}/rules/${ruleId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals.ts
var MetorialDashboardInstancePortalsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portals
   * @description Returns a paginated list of portals.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePortalsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstancePortalsListOutput);
  }
  /**
   * @name Get portal
   * @description Retrieves details for a specific portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstancePortalsGetOutput);
  }
  /**
   * @name Create portal
   * @description Creates a new portal for the instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstancePortalsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals`;
    let request = {
      path,
      body: mapDashboardInstancePortalsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsCreateOutput
    );
  }
  /**
   * @name Update portal
   * @description Updates an existing portal for the instance.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsUpdateOutput
    );
  }
  /**
   * @name Delete portal
   * @description Archives a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals_access-requests.ts
var MetorialDashboardInstancePortalsAccessRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal access requests
   * @description Returns a paginated list of access requests for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsAccessRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access-requests`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsAccessRequestsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessRequestsListOutput
    );
  }
  /**
   * @name Get portal access request
   * @description Retrieves a access request by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, accessRequestId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access-requests/${accessRequestId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessRequestsGetOutput
    );
  }
  /**
   * @name Review portal access request
   * @description Approves or rejects a access request.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessRequestId` - string
   * @param `body` - DashboardInstancePortalsAccessRequestsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, accessRequestId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access-requests/${accessRequestId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessRequestsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsAccessRequestsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals_access.ts
var MetorialDashboardInstancePortalsAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal access
   * @description Returns a paginated list of consumer access rules for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsAccessListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsAccessListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessListOutput
    );
  }
  /**
   * @name Get portal access
   * @description Retrieves a portal access rule by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, accessId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessGetOutput
    );
  }
  /**
   * @name Create portal access
   * @description Creates a new consumer access rule for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsAccessCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsAccessCreateOutput
    );
  }
  /**
   * @name Update portal access
   * @description Updates the shared listing fields for a portal access rule.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `body` - DashboardInstancePortalsAccessUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, accessId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsAccessUpdateOutput
    );
  }
  /**
   * @name Delete portal access
   * @description Deletes a consumer access rule from the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, accessId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsAccessDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals_consumer-groups.ts
var MetorialDashboardInstancePortalsConsumerGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer groups
   * @description Returns a paginated list of consumer groups for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerGroupsListOutput
    );
  }
  /**
   * @name Get portal consumer group
   * @description Retrieves a portal consumer group by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerGroupsGetOutput
    );
  }
  /**
   * @name Create portal consumer group
   * @description Creates a new consumer group for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerGroupsCreateOutput
    );
  }
  /**
   * @name Update portal consumer group
   * @description Updates a consumer group for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `body` - DashboardInstancePortalsConsumerGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, consumerGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsConsumerGroupsUpdateOutput
    );
  }
  /**
   * @name Delete portal consumer group
   * @description Archives a consumer group for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, consumerGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsConsumerGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals_consumer-invites.ts
var MetorialDashboardInstancePortalsConsumerInvitesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer invites
   * @description Returns a paginated list of invites for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerInvitesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-invites`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerInvitesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerInvitesListOutput
    );
  }
  /**
   * @name Create portal consumer invite
   * @description Invites a consumer to a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerInvitesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-invites`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerInvitesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerInvitesCreateOutput
    );
  }
  /**
   * @name Get portal consumer invite
   * @description Retrieves a portal consumer invite by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerInviteId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerInviteId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-invites/${consumerInviteId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerInvitesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals_consumer-profiles.ts
var MetorialDashboardInstancePortalsConsumerProfilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer profiles
   * @description Returns a paginated list of consumer profiles for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerProfilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-profile`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerProfilesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerProfilesListOutput
    );
  }
  /**
   * @name Get portal consumer profile
   * @description Retrieves a portal consumer profile by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerProfileId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerProfilesGetOutput
    );
  }
  /**
   * @name Create portal consumer profile
   * @description Creates a new portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-profile`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesCreateOutput
    );
  }
  /**
   * @name Delete portal consumer profile
   * @description Soft-deletes a portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, consumerProfileId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsConsumerProfilesDeleteOutput
    );
  }
  /**
   * @name Assign portal consumer profile groups
   * @description Assigns one or more groups to a portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesAssignGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesAssignGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  assignGroups(instanceId, portalId, consumerProfileId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}/assign-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesAssignGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesAssignGroupsOutput
    );
  }
  /**
   * @name Unassign portal consumer profile groups
   * @description Removes one or more groups from a portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesUnassignGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesUnassignGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  unassignGroups(instanceId, portalId, consumerProfileId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}/unassign-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesUnassignGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesUnassignGroupsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals_listings.ts
var MetorialDashboardInstancePortalsListingsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal listings
   * @description Returns a paginated list of shared listings for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsListingsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/listings`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsListingsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsListingsListOutput
    );
  }
  /**
   * @name Get portal listing
   * @description Retrieves one shared listing for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, listingId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsListingsGetOutput
    );
  }
  /**
   * @name Create portal listing
   * @description Creates a shared listing for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsListingsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/listings`;
    let request = {
      path,
      body: mapDashboardInstancePortalsListingsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsListingsCreateOutput
    );
  }
  /**
   * @name Update portal listing
   * @description Updates listing metadata for a portal listing.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `body` - DashboardInstancePortalsListingsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, listingId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsListingsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsListingsUpdateOutput
    );
  }
  /**
   * @name Delete portal listing
   * @description Deletes a portal listing and all consumer access attached to it.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, listingId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsListingsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_portals_surface-provider-groups.ts
var MetorialDashboardInstancePortalsSurfaceProviderGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal surface provider groups
   * @description Returns a paginated list of provider groups linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsSurfaceProviderGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/surface-provider-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsSurfaceProviderGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsListOutput
    );
  }
  /**
   * @name Get portal surface provider group
   * @description Retrieves a portal surface provider group by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerSurfaceProviderGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsGetOutput
    );
  }
  /**
   * @name Create portal surface provider group
   * @description Creates a new provider group linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/surface-provider-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsCreateOutput
    );
  }
  /**
   * @name Update portal surface provider group
   * @description Updates a provider group linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, consumerSurfaceProviderGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsUpdateOutput
    );
  }
  /**
   * @name Delete portal surface provider group
   * @description Deletes a provider group linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, consumerSurfaceProviderGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsDeleteOutput
    );
  }
  /**
   * @name Add listing to surface provider group
   * @description Adds a consumer access listing to the surface provider group.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsAddListingBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsAddListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addListing(instanceId, portalId, consumerSurfaceProviderGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}/listings`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsAddListingBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsAddListingOutput
    );
  }
  /**
   * @name Remove listing from surface provider group
   * @description Removes a consumer access listing from the surface provider group.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `consumerAccessListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeListing(instanceId, portalId, consumerSurfaceProviderGroupId, consumerAccessListingId, opts) {
    let path = `dashboard/instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}/listings/${consumerAccessListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_proto-guard-alerts.ts
var MetorialDashboardInstanceProtoGuardAlertsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List ProtoGuard alerts
   * @description Returns a paginated list of ProtoGuard alerts for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProtoGuardAlertsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardAlertsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/protoguard-alerts`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProtoGuardAlertsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardAlertsListOutput
    );
  }
  /**
   * @name Get ProtoGuard alert
   * @description Retrieves a ProtoGuard alert by ID.
   *
   * @param `instanceId` - string
   * @param `protoGuardAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardAlertsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, protoGuardAlertId, opts) {
    let path = `dashboard/instances/${instanceId}/protoguard-alerts/${protoGuardAlertId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardAlertsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_proto-guard-config.ts
var MetorialDashboardInstanceProtoGuardConfigEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get ProtoGuard config
   * @description Retrieves ProtoGuard filter configuration for this instance.
   *
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, opts) {
    let path = `dashboard/instances/${instanceId}/protoguard-config`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardConfigGetOutput
    );
  }
  /**
   * @name Update ProtoGuard filter config
   * @description Updates ProtoGuard filter settings for this instance.
   *
   * @param `instanceId` - string
   * @param `filterId` - string
   * @param `body` - DashboardInstanceProtoGuardConfigUpdateFilterBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigUpdateFilterOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  updateFilter(instanceId, filterId, body, opts) {
    let path = `dashboard/instances/${instanceId}/protoguard-config/filters/${filterId}`;
    let request = {
      path,
      body: mapDashboardInstanceProtoGuardConfigUpdateFilterBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProtoGuardConfigUpdateFilterOutput
    );
  }
  /**
   * @name Set ProtoGuard alert filter count threshold
   * @description Sets or clears the number of matching ProtoGuard filters required to create an alert.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  setAlertFilterCountThreshold(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/protoguard-config/alert-filter-count-threshold`;
    let request = {
      path,
      body: mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-auth-config-errors.ts
var MetorialDashboardInstanceProviderAuthConfigErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config errors
   * @description Returns a paginated list of provider auth config errors for dashboard diagnostics.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderAuthConfigErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-errors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigErrorsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsListOutput
    );
  }
  /**
   * @name Get provider auth config error
   * @description Retrieves a specific provider auth config error by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigErrorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigErrorId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-errors/${providerAuthConfigErrorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-auth-config-errors_groups.ts
var MetorialDashboardInstanceProviderAuthConfigErrorsGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config error groups
   * @description Returns grouped provider auth config errors aggregated by type and canonical message.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderAuthConfigErrorsGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-error-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigErrorsGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGroupsListOutput
    );
  }
  /**
   * @name Get provider auth config error group
   * @description Retrieves a specific grouped provider auth config error by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigErrorGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigErrorGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-error-groups/${providerAuthConfigErrorGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGroupsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-auth-config-events.ts
var MetorialDashboardInstanceProviderAuthConfigEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config events
   * @description Returns a paginated list of provider auth config events for dashboard diagnostics.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderAuthConfigEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigEventsListOutput
    );
  }
  /**
   * @name Get provider auth config event
   * @description Retrieves a specific provider auth config event by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigEventId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-events/${providerAuthConfigEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-categories.ts
var MetorialDashboardInstanceProviderCategoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider categories
   * @description Returns a paginated list of provider categories.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderCategoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCategoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-categories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderCategoriesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCategoriesListOutput
    );
  }
  /**
   * @name Get provider category
   * @description Retrieves a specific provider category by ID.
   *
   * @param `instanceId` - string
   * @param `providerCategoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCategoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerCategoryId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-categories/${providerCategoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCategoriesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-collections.ts
var MetorialDashboardInstanceProviderCollectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider collections
   * @description Returns a paginated list of provider collections.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderCollectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCollectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-collections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderCollectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCollectionsListOutput
    );
  }
  /**
   * @name Get provider collection
   * @description Retrieves a specific provider collection by ID.
   *
   * @param `instanceId` - string
   * @param `providerCollectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCollectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerCollectionId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-collections/${providerCollectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCollectionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments.ts
var MetorialDashboardInstanceProviderDeploymentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider deployments
   * @description Returns a paginated list of provider deployments.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-deployments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsListOutput
    );
  }
  /**
   * @name Get provider deployment
   * @description Retrieves a specific provider deployment by ID.
   *
   * @param `instanceId` - string
   * @param `providerDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerDeploymentId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsGetOutput
    );
  }
  /**
   * @name Create provider deployment
   * @description Creates a new provider deployment.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-deployments`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsCreateOutput
    );
  }
  /**
   * @name Update provider deployment
   * @description Updates a specific provider deployment.
   *
   * @param `instanceId` - string
   * @param `providerDeploymentId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerDeploymentId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsUpdateOutput
    );
  }
  /**
   * @name Delete provider deployment
   * @description Permanently deletes a provider deployment.
   *
   * @param `instanceId` - string
   * @param `providerDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerDeploymentId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments_auth-configs.ts
var MetorialDashboardInstanceProviderDeploymentsAuthConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth configs
   * @description Returns a paginated list of provider auth configs.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-configs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsListOutput
    );
  }
  /**
   * @name Get provider auth config
   * @description Retrieves a specific provider auth config by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsGetOutput
    );
  }
  /**
   * @name Create provider auth config
   * @description Creates a new provider auth config.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-configs`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsCreateOutput
    );
  }
  /**
   * @name Update provider auth config
   * @description Updates a specific provider auth config.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerAuthConfigId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput
    );
  }
  /**
   * @name Delete provider auth config
   * @description Permanently deletes a provider auth config.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerAuthConfigId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments_auth-configs_exports.ts
var MetorialDashboardInstanceProviderDeploymentsAuthConfigsExportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth exports
   * @description Returns a paginated list of provider auth exports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-exports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput
    );
  }
  /**
   * @name Get provider auth export
   * @description Retrieves a specific provider auth export by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthExportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthExportId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-exports/${providerAuthExportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput
    );
  }
  /**
   * @name Create provider auth export
   * @description Exports authentication credentials from a provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-exports`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments_auth-configs_imports.ts
var MetorialDashboardInstanceProviderDeploymentsAuthConfigsImportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth imports
   * @description Returns a paginated list of provider auth imports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-imports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput
    );
  }
  /**
   * @name Get provider auth import
   * @description Retrieves a specific provider auth import by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthImportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthImportId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-imports/${providerAuthImportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput
    );
  }
  /**
   * @name Create provider auth import
   * @description Imports authentication credentials for a provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-imports`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput
    );
  }
  /**
   * @name Get auth import schema
   * @description Retrieves the JSON Schema for importing authentication credentials.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getSchema(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-config-imports/schema`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments_auth-credentials.ts
var MetorialDashboardInstanceProviderDeploymentsAuthCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth credentials
   * @description Returns a paginated list of provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-credentials`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthCredentialsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsListOutput
    );
  }
  /**
   * @name Get provider auth credentials
   * @description Retrieves specific provider auth credentials by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthCredentialsId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthCredentialsId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsGetOutput
    );
  }
  /**
   * @name Create provider auth credentials
   * @description Creates new provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-credentials`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput
    );
  }
  /**
   * @name Update provider auth credentials
   * @description Updates specific provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `providerAuthCredentialsId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerAuthCredentialsId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput
    );
  }
  /**
   * @name Delete provider auth credentials
   * @description Permanently deletes provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `providerAuthCredentialsId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerAuthCredentialsId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments_config-vaults.ts
var MetorialDashboardInstanceProviderDeploymentsConfigVaultsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider config vaults
   * @description Returns a paginated list of provider config vaults.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsConfigVaultsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-config-vaults`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigVaultsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsListOutput
    );
  }
  /**
   * @name Get provider config vault
   * @description Retrieves a specific provider config vault by ID.
   *
   * @param `instanceId` - string
   * @param `providerConfigVaultId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerConfigVaultId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsGetOutput
    );
  }
  /**
   * @name Create provider config vault
   * @description Creates a new provider config vault.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigVaultsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-config-vaults`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigVaultsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsCreateOutput
    );
  }
  /**
   * @name Update provider config vault
   * @description Updates a specific provider config vault.
   *
   * @param `instanceId` - string
   * @param `providerConfigVaultId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigVaultsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerConfigVaultId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput
    );
  }
  /**
   * @name Delete provider config vault
   * @description Permanently deletes a provider config vault.
   *
   * @param `instanceId` - string
   * @param `providerConfigVaultId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerConfigVaultId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments_configs.ts
var MetorialDashboardInstanceProviderDeploymentsConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider configs
   * @description Returns a paginated list of provider configs.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-configs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsListOutput
    );
  }
  /**
   * @name Get provider config
   * @description Retrieves a specific provider config by ID.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerConfigId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-configs/${providerConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetOutput
    );
  }
  /**
   * @name Create provider config
   * @description Creates a new provider config.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-configs`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsCreateOutput
    );
  }
  /**
   * @name Update provider config
   * @description Updates a specific provider config. Passing `value` replaces its configuration values with a new config version.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerConfigId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-configs/${providerConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsUpdateOutput
    );
  }
  /**
   * @name Get provider config value
   * @description Retrieves a provider config's current configuration values, unless the provider stores them encrypted.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetValueOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getValue(instanceId, providerConfigId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-configs/${providerConfigId}/value`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetValueOutput
    );
  }
  /**
   * @name Delete provider config
   * @description Permanently deletes a provider config.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerConfigId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-configs/${providerConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsDeleteOutput
    );
  }
  /**
   * @name Get config schema
   * @description Retrieves the JSON Schema for configuration of this provider deployment.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getConfigSchema(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-config-schema`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-deployments_setup-sessions.ts
var MetorialDashboardInstanceProviderDeploymentsSetupSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider setup sessions
   * @description Returns a paginated list of provider setup sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsSetupSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-setup-sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsSetupSessionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsListOutput
    );
  }
  /**
   * @name Get provider setup session
   * @description Retrieves a specific provider setup session by ID.
   *
   * @param `instanceId` - string
   * @param `providerSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerSetupSessionId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsGetOutput
    );
  }
  /**
   * @name Create provider setup session
   * @description Creates a new provider setup session for OAuth authentication.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsSetupSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-setup-sessions`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsSetupSessionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsCreateOutput
    );
  }
  /**
   * @name Update provider setup session
   * @description Updates a specific provider setup session.
   *
   * @param `instanceId` - string
   * @param `providerSetupSessionId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsSetupSessionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerSetupSessionId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput
    );
  }
  /**
   * @name Delete provider setup session
   * @description Deletes a provider setup session.
   *
   * @param `instanceId` - string
   * @param `providerSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerSetupSessionId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-groups.ts
var MetorialDashboardInstanceProviderGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider groups
   * @description Returns a paginated list of provider groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderGroupsListOutput
    );
  }
  /**
   * @name Get provider group
   * @description Retrieves a specific provider group by ID.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-groups/${providerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderGroupsGetOutput
    );
  }
  /**
   * @name Create provider group
   * @description Creates a new custom provider group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-groups`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderGroupsCreateOutput
    );
  }
  /**
   * @name Update provider group
   * @description Updates an existing provider group.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `body` - DashboardInstanceProviderGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-groups/${providerGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderGroupsUpdateOutput
    );
  }
  /**
   * @name Add listing to group
   * @description Adds a provider listing to a group.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `body` - DashboardInstanceProviderGroupsAddListingBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsAddListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addListing(instanceId, providerGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-groups/${providerGroupId}/listings`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsAddListingBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderGroupsAddListingOutput
    );
  }
  /**
   * @name Remove listing from group
   * @description Removes a provider listing from a group.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsRemoveListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeListing(instanceId, providerGroupId, providerListingId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-groups/${providerGroupId}/listings/${providerListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderGroupsRemoveListingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-invocations.ts
var MetorialDashboardInstanceProviderInvocationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get provider invocation
   * @description Returns a single normalized provider invocation by ID.
   *
   * @param `instanceId` - string
   * @param `providerInvocationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderInvocationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerInvocationId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-invocations/${providerInvocationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderInvocationsGetOutput
    );
  }
  /**
   * @name List provider invocations
   * @description Returns normalized provider invocations and their logs for dashboard diagnostics.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderInvocationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderInvocationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-invocations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderInvocationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderInvocationsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-listings.ts
var MetorialDashboardInstanceProviderListingsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider listings
   * @description Returns a paginated list of provider listings.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderListingsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-listings`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderListingsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderListingsListOutput
    );
  }
  /**
   * @name Get provider listing
   * @description Retrieves a specific provider listing by ID.
   *
   * @param `instanceId` - string
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerListingId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-listings/${providerListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderListingsGetOutput
    );
  }
  /**
   * @name Update provider listing
   * @description Updates how a provider listing appears in the library. Edited fields survive catalog re-syncs.
   *
   * @param `instanceId` - string
   * @param `providerListingId` - string
   * @param `body` - DashboardInstanceProviderListingsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerListingId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-listings/${providerListingId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderListingsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderListingsUpdateOutput
    );
  }
  /**
   * @name Reset provider listing
   * @description Drops the admin customization so the next catalog sync restores the original name, description, readme, logo, categories and rank.
   *
   * @param `instanceId` - string
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsResetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  reset(instanceId, providerListingId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-listings/${providerListingId}/reset`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderListingsResetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-runs.ts
var MetorialDashboardInstanceProviderRunsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all provider runs
   * @description Returns a paginated list of provider runs across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderRunsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-runs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderRunsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsListOutput
    );
  }
  /**
   * @name Get provider run
   * @description Retrieves a specific provider run by ID.
   *
   * @param `instanceId` - string
   * @param `providerRunId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerRunId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-runs/${providerRunId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsGetOutput
    );
  }
  /**
   * @name Get provider run logs
   * @description Retrieves the logs for a specific provider run.
   *
   * @param `instanceId` - string
   * @param `providerRunId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsGetLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getLogs(instanceId, providerRunId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-runs/${providerRunId}/logs`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsGetLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-specification-change-notifications.ts
var MetorialDashboardInstanceProviderSpecificationChangeNotificationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider specification change notifications
   * @description Returns a paginated list of provider specification change notifications for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderSpecificationChangeNotificationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderSpecificationChangeNotificationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-specification-change-notifications`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderSpecificationChangeNotificationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderSpecificationChangeNotificationsListOutput
    );
  }
  /**
   * @name Get provider specification change notification
   * @description Retrieves a provider specification change notification by ID.
   *
   * @param `instanceId` - string
   * @param `notificationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderSpecificationChangeNotificationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, notificationId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-specification-change-notifications/${notificationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderSpecificationChangeNotificationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_provider-templates.ts
var MetorialDashboardInstanceProviderTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider templates
   * @description Returns a paginated list of provider templates.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-templates`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderTemplatesListOutput
    );
  }
  /**
   * @name Get provider template
   * @description Retrieves a specific provider template.
   *
   * @param `instanceId` - string
   * @param `providerTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerTemplateId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-templates/${providerTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderTemplatesGetOutput
    );
  }
  /**
   * @name Create provider template
   * @description Creates a new provider template from an existing integration.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-templates`;
    let request = {
      path,
      body: mapDashboardInstanceProviderTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderTemplatesCreateOutput
    );
  }
  /**
   * @name Update provider template
   * @description Updates an existing provider template.
   *
   * @param `instanceId` - string
   * @param `providerTemplateId` - string
   * @param `body` - DashboardInstanceProviderTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerTemplateId, body, opts) {
    let path = `dashboard/instances/${instanceId}/provider-templates/${providerTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderTemplatesUpdateOutput
    );
  }
  /**
   * @name Archive provider template
   * @description Archives an existing provider template.
   *
   * @param `instanceId` - string
   * @param `providerTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerTemplateId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-templates/${providerTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderTemplatesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_providers.ts
var MetorialDashboardInstanceProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List providers
   * @description Returns a paginated list of providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersListOutput
    );
  }
  /**
   * @name Get provider
   * @description Retrieves a specific provider by ID.
   *
   * @param `instanceId` - string
   * @param `providerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerId, opts) {
    let path = `dashboard/instances/${instanceId}/providers/${providerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceProvidersGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_providers_auth-methods.ts
var MetorialDashboardInstanceProvidersAuthMethodsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth methods
   * @description Returns a paginated list of provider auth methods.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersAuthMethodsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersAuthMethodsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-methods`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersAuthMethodsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersAuthMethodsListOutput
    );
  }
  /**
   * @name Get provider auth method
   * @description Retrieves a specific provider auth method by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthMethodId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersAuthMethodsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthMethodId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-auth-methods/${providerAuthMethodId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersAuthMethodsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_providers_specifications.ts
var MetorialDashboardInstanceProvidersSpecificationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider specifications
   * @description Returns a paginated list of provider specifications.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersSpecificationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersSpecificationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-specifications`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersSpecificationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersSpecificationsListOutput
    );
  }
  /**
   * @name Get provider specification
   * @description Retrieves a specific provider specification by ID.
   *
   * @param `instanceId` - string
   * @param `providerSpecificationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersSpecificationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerSpecificationId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-specifications/${providerSpecificationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersSpecificationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_providers_tools.ts
var MetorialDashboardInstanceProvidersToolsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider tools
   * @description Returns a paginated list of provider tools. By default returns tools from the latest version. Use optional filters to get tools for a specific version.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersToolsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersToolsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-tools`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersToolsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersToolsListOutput
    );
  }
  /**
   * @name Get provider tool
   * @description Retrieves a specific provider tool by ID.
   *
   * @param `instanceId` - string
   * @param `providerToolId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersToolsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerToolId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-tools/${providerToolId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersToolsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_providers_triggers.ts
var MetorialDashboardInstanceProvidersTriggersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider triggers
   * @description Returns a paginated list of provider triggers for a provider version or all active user-managed callbacks in the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersTriggersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersTriggersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-triggers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersTriggersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersTriggersListOutput
    );
  }
  /**
   * @name Get provider trigger
   * @description Retrieves a specific provider trigger by ID.
   *
   * @param `instanceId` - string
   * @param `providerTriggerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersTriggersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerTriggerId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-triggers/${providerTriggerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersTriggersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_providers_versions.ts
var MetorialDashboardInstanceProvidersVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider versions
   * @description Returns a paginated list of provider versions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/provider-versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersVersionsListOutput
    );
  }
  /**
   * @name Get provider version
   * @description Retrieves a specific provider version by ID.
   *
   * @param `instanceId` - string
   * @param `providerVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerVersionId, opts) {
    let path = `dashboard/instances/${instanceId}/provider-versions/${providerVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_public-mcp-servers.ts
var MetorialDashboardInstancePublicMcpServersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP servers
   * @description Returns a paginated list of public MCP servers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePublicMcpServersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersListOutput
    );
  }
  /**
   * @name Get public MCP server
   * @description Retrieves a specific public MCP server by ID.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, publicMcpServerId, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGetOutput
    );
  }
  /**
   * @name Create public MCP server
   * @description Creates a public MCP server for a provider deployment.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstancePublicMcpServersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers`;
    let request = {
      path,
      body: mapDashboardInstancePublicMcpServersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePublicMcpServersCreateOutput
    );
  }
  /**
   * @name Update public MCP server
   * @description Updates a public MCP server. Set status to disabled to stop accepting connections.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `body` - DashboardInstancePublicMcpServersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, publicMcpServerId, body, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      body: mapDashboardInstancePublicMcpServersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePublicMcpServersUpdateOutput
    );
  }
  /**
   * @name Delete public MCP server
   * @description Archives a public MCP server, revokes every grant, and releases its slug.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, publicMcpServerId, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePublicMcpServersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_public-mcp-servers_clients.ts
var MetorialDashboardInstancePublicMcpServersClientsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP server clients
   * @description Returns the OAuth clients registered with a public MCP server.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `query` - DashboardInstancePublicMcpServersClientsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersClientsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, publicMcpServerId, query, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/clients`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersClientsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersClientsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_public-mcp-servers_grants.ts
var MetorialDashboardInstancePublicMcpServersGrantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP server grants
   * @description Returns the end-user grants of a public MCP server.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `query` - DashboardInstancePublicMcpServersGrantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, publicMcpServerId, query, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/grants`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersGrantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGrantsListOutput
    );
  }
  /**
   * @name Get public MCP server grant
   * @description Retrieves a specific end-user grant.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `publicMcpServerGrantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, publicMcpServerId, publicMcpServerGrantId, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/grants/${publicMcpServerGrantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGrantsGetOutput
    );
  }
  /**
   * @name Revoke public MCP server grant
   * @description Revokes an end-user grant. Its tokens stop working and the user's credentials are deleted.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `publicMcpServerGrantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(instanceId, publicMcpServerId, publicMcpServerGrantId, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/grants/${publicMcpServerGrantId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePublicMcpServersGrantsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_public-mcp-servers_slugs.ts
var MetorialDashboardInstancePublicMcpServersSlugsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Check public MCP server slug
   * @description Checks whether a slug can be claimed for a new public MCP server.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePublicMcpServersSlugsCheckQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersSlugsCheckOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  check(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/public-mcp-server-slugs/availability`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersSlugsCheckQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersSlugsCheckOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_publishers.ts
var MetorialDashboardInstancePublishersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List publishers
   * @description Returns a paginated list of publishers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePublishersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublishersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/publishers`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublishersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublishersListOutput
    );
  }
  /**
   * @name Get publisher
   * @description Retrieves a specific publisher by ID.
   *
   * @param `instanceId` - string
   * @param `publisherId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublishersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, publisherId, opts) {
    let path = `dashboard/instances/${instanceId}/publishers/${publisherId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublishersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_disks.ts
var MetorialDashboardInstanceSandboxDisksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox disks
   * @description Returns a paginated list of disks.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxDisksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksListOutput
    );
  }
  /**
   * @name Get sandbox disk
   * @description Retrieves a disk by ID.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, diskId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksGetOutput
    );
  }
  /**
   * @name Create sandbox disk
   * @description Creates an empty disk.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSandboxDisksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksCreateOutput
    );
  }
  /**
   * @name Update sandbox disk
   * @description Updates a disk name and metadata. Only metadata can be updated for root filesystem disks.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, diskId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxDisksUpdateOutput
    );
  }
  /**
   * @name Delete sandbox disk
   * @description Deletes a disk. Root filesystem disks cannot be deleted; they are removed with their machine.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, diskId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxDisksDeleteOutput
    );
  }
  /**
   * @name Clone sandbox disk
   * @description Creates a copy of a disk in the same region.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksCloneBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksCloneOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  clone(instanceId, diskId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}/clone`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksCloneBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksCloneOutput
    );
  }
  /**
   * @name Resize sandbox disk
   * @description Starts growing a disk to a larger size.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksResizeBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resize(instanceId, diskId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}/resize`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksResizeBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksResizeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_disks_mounts.ts
var MetorialDashboardInstanceSandboxDisksMountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List disk mounts
   * @description Returns a paginated list of the times a disk was mounted into a machine.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `query` - DashboardInstanceSandboxDisksMountsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksMountsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, diskId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}/mounts`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksMountsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksMountsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_disks_resizes.ts
var MetorialDashboardInstanceSandboxDisksResizesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List disk resizes
   * @description Returns a paginated list of the resizes of a disk.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `query` - DashboardInstanceSandboxDisksResizesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, diskId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}/resizes`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksResizesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksResizesListOutput
    );
  }
  /**
   * @name Get disk resize
   * @description Retrieves a resize of a disk.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `resizeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, diskId, resizeId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}/resizes/${resizeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksResizesGetOutput
    );
  }
  /**
   * @name Retry disk resize
   * @description Retries a resize that failed.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `resizeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesRetryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  retry(instanceId, diskId, resizeId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/disks/${diskId}/resizes/${resizeId}/retry`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksResizesRetryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_image-builds.ts
var MetorialDashboardInstanceSandboxImageBuildsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image builds
   * @description Returns a paginated list of image builds across all images.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxImageBuildsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/image-builds`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImageBuildsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsListOutput
    );
  }
  /**
   * @name Get image build
   * @description Retrieves an image build by ID.
   *
   * @param `instanceId` - string
   * @param `buildId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, buildId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/image-builds/${buildId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsGetOutput
    );
  }
  /**
   * @name Cancel image build
   * @description Cancels a build that is still running.
   *
   * @param `instanceId` - string
   * @param `buildId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsCancelOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  cancel(instanceId, buildId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/image-builds/${buildId}/cancel`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImageBuildsCancelOutput
    );
  }
  /**
   * @name Get image build logs
   * @description Returns a page of the build output.
   *
   * @param `instanceId` - string
   * @param `buildId` - string
   * @param `query` - DashboardInstanceSandboxImageBuildsLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  logs(instanceId, buildId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/image-builds/${buildId}/logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImageBuildsLogsQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_images.ts
var MetorialDashboardInstanceSandboxImagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox images
   * @description Returns a paginated list of the images you can create machines from.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxImagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesListOutput
    );
  }
  /**
   * @name Get sandbox image
   * @description Retrieves an image by ID.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, imageId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images/${imageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesGetOutput
    );
  }
  /**
   * @name Create sandbox image
   * @description Creates an empty image. Build a version of it to make it available to machines.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSandboxImagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImagesCreateOutput
    );
  }
  /**
   * @name Update sandbox image
   * @description Updates the name and metadata of one of your images.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `body` - DashboardInstanceSandboxImagesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, imageId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images/${imageId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxImagesUpdateOutput
    );
  }
  /**
   * @name Delete sandbox image
   * @description Deletes one of your images and cancels its running builds.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, imageId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images/${imageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxImagesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_images_builds.ts
var MetorialDashboardInstanceSandboxImagesBuildsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image builds
   * @description Returns a paginated list of the builds of an image.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `query` - DashboardInstanceSandboxImagesBuildsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesBuildsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, imageId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images/${imageId}/builds`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesBuildsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesBuildsListOutput
    );
  }
  /**
   * @name Build image
   * @description Builds a new version of an image from a Dockerfile. Upload the build context as a file with the sandbox_image_build_context purpose first.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `body` - DashboardInstanceSandboxImagesBuildsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesBuildsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, imageId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images/${imageId}/builds`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesBuildsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImagesBuildsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_images_versions.ts
var MetorialDashboardInstanceSandboxImagesVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image versions
   * @description Returns a paginated list of the versions of an image.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `query` - DashboardInstanceSandboxImagesVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, imageId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images/${imageId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesVersionsListOutput
    );
  }
  /**
   * @name Get image version
   * @description Retrieves a version of an image.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `versionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, imageId, versionId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/images/${imageId}/versions/${versionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_machines.ts
var MetorialDashboardInstanceSandboxMachinesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox machines
   * @description Returns a paginated list of machines.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxMachinesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesListOutput
    );
  }
  /**
   * @name Get sandbox machine
   * @description Retrieves a machine by ID.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesGetOutput
    );
  }
  /**
   * @name Create sandbox machine
   * @description Creates a machine and, unless disabled, starts it.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSandboxMachinesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesCreateOutput
    );
  }
  /**
   * @name Update sandbox machine
   * @description Updates a machine. Changes to its size, runtime, or mounts take effect once the machine restarts, which happens on its own for a running machine, and the machine reports restart_required until then.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, machineId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxMachinesUpdateOutput
    );
  }
  /**
   * @name Terminate sandbox machine
   * @description Terminates a machine and deletes its root disk.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, machineId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxMachinesDeleteOutput
    );
  }
  /**
   * @name Start sandbox machine
   * @description Starts a paused or hibernated machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesStartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  start(instanceId, machineId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/start`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesStartOutput
    );
  }
  /**
   * @name Pause sandbox machine
   * @description Pauses a running machine and keeps its memory state.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesPauseOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  pause(instanceId, machineId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/pause`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesPauseOutput
    );
  }
  /**
   * @name Hibernate sandbox machine
   * @description Hibernates a machine so it stops consuming compute resources.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesHibernateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  hibernate(instanceId, machineId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/hibernate`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesHibernateOutput
    );
  }
  /**
   * @name Restart sandbox machine
   * @description Restarts a machine on a fresh instance.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesRestartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  restart(instanceId, machineId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/restart`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesRestartOutput
    );
  }
  /**
   * @name Touch sandbox machine
   * @description Records activity so the machine is not paused for being idle.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesTouchOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  touch(instanceId, machineId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/touch`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesTouchOutput
    );
  }
  /**
   * @name List sandbox machine usage
   * @description Returns resource usage samples of a machine, newest first.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  usage(instanceId, machineId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/usage`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageOutput
    );
  }
  /**
   * @name Run a command
   * @description Runs a shell command in the machine and returns its exit code and output. Non-interactive; starts the machine if needed.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesExecBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesExecOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  exec(instanceId, machineId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/exec`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesExecBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesExecOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_machines_access.ts
var MetorialDashboardInstanceSandboxMachinesAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create shell access
   * @description Creates a short-lived token for an interactive shell in the machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessShellBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessShellOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  shell(instanceId, machineId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/access/shell`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessShellBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessShellOutput
    );
  }
  /**
   * @name Create files access
   * @description Creates a short-lived token for the machine's file service.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessFilesBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessFilesOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  files(instanceId, machineId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/access/files`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessFilesBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessFilesOutput
    );
  }
  /**
   * @name Create port access
   * @description Creates a short-lived token for reaching ports inside the machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessPortsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessPortsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  ports(instanceId, machineId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/access/ports`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessPortsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessPortsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_machines_errors.ts
var MetorialDashboardInstanceSandboxMachinesErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine errors
   * @description Returns a paginated list of the errors reported by a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/errors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesErrorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesErrorsListOutput
    );
  }
  /**
   * @name Get machine error
   * @description Retrieves an error reported by a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `errorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, errorId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/errors/${errorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_machines_events.ts
var MetorialDashboardInstanceSandboxMachinesEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine events
   * @description Returns a paginated list of the events of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesEventsListOutput
    );
  }
  /**
   * @name Get machine event
   * @description Retrieves an event of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, eventId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_machines_instances.ts
var MetorialDashboardInstanceSandboxMachinesInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine instances
   * @description Returns a paginated list of the instances of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesInstancesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesListOutput
    );
  }
  /**
   * @name Get machine instance
   * @description Retrieves an instance of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `machineInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, machineInstanceId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/instances/${machineInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesGetOutput
    );
  }
  /**
   * @name Get machine instance logs
   * @description Returns a page of the console output of an instance.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `machineInstanceId` - string
   * @param `query` - DashboardInstanceSandboxMachinesInstancesLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  logs(instanceId, machineId, machineInstanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/instances/${machineInstanceId}/logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesInstancesLogsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_machines_operations.ts
var MetorialDashboardInstanceSandboxMachinesOperationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine operations
   * @description Returns a paginated list of the operations of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesOperationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesOperationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/operations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesOperationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesOperationsListOutput
    );
  }
  /**
   * @name Get machine operation
   * @description Retrieves an operation of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `operationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesOperationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, operationId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/operations/${operationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesOperationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_machines_usage.ts
var MetorialDashboardInstanceSandboxMachinesUsageEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get sandbox machine usage timeline
   * @description Returns chronological usage buckets. Minute data is retained for 7 days and hourly data for 30 days. Zero samples means no observations, not necessarily a stopped machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageTimelineQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageTimelineOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  timeline(instanceId, machineId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/usage/timeline`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageTimelineQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageTimelineOutput
    );
  }
  /**
   * @name Get sandbox machine usage summary
   * @description Returns totals and averages for a range. Summary bounds align independently to minute or hour source buckets. Use a timeline’s effective bounds to compare its totals with a summary.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageSummaryQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageSummaryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  summary(instanceId, machineId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/machines/${machineId}/usage/summary`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageSummaryQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageSummaryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_regions.ts
var MetorialDashboardInstanceSandboxRegionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox regions
   * @description Returns a paginated list of regions sandboxes can run in.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxRegionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxRegionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/regions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxRegionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxRegionsListOutput
    );
  }
  /**
   * @name Get sandbox region
   * @description Retrieves a sandbox region by its identifier.
   *
   * @param `instanceId` - string
   * @param `regionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxRegionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, regionId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/regions/${regionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxRegionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sandbox_specs.ts
var MetorialDashboardInstanceSandboxSpecsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox specs
   * @description Returns a paginated list of machine specs. The available field shows whether your plan allows creating machines of that size.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxSpecsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxSpecsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/specs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxSpecsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxSpecsListOutput
    );
  }
  /**
   * @name Get sandbox spec
   * @description Retrieves a machine spec by ID.
   *
   * @param `instanceId` - string
   * @param `specId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxSpecsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, specId, opts) {
    let path = `dashboard/instances/${instanceId}/sandbox/specs/${specId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxSpecsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_scm_accounts.ts
var MetorialDashboardInstanceScmAccountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Preview SCM accounts
   * @description Lists available accounts from an SCM installation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmAccountsPreviewBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmAccountsPreviewOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  preview(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/scm/accounts/preview`;
    let request = {
      path,
      body: mapDashboardInstanceScmAccountsPreviewBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmAccountsPreviewOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_scm_connections.ts
var MetorialDashboardInstanceScmConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM connections
   * @description Returns a paginated list of SCM connections.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/scm/connections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmConnectionsListOutput
    );
  }
  /**
   * @name Get SCM connection
   * @description Retrieves a specific SCM connection by ID.
   *
   * @param `instanceId` - string
   * @param `scmConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, scmConnectionId, opts) {
    let path = `dashboard/instances/${instanceId}/scm/connections/${scmConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmConnectionsGetOutput
    );
  }
  /**
   * @name Create SCM connection
   * @description Initiates an SCM connection setup session.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmConnectionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/scm/connections`;
    let request = {
      path,
      body: mapDashboardInstanceScmConnectionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmConnectionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_scm_installation.ts
var MetorialDashboardInstanceScmInstallationEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM installations
   * @description Returns a paginated list of SCM installations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmInstallationListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmInstallationListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/scm/installations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmInstallationListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmInstallationListOutput
    );
  }
  /**
   * @name Create SCM installation
   * @description Initiates an SCM installation setup (e.g. GitHub App authorization).
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmInstallationCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmInstallationCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/scm/installations`;
    let request = {
      path,
      body: mapDashboardInstanceScmInstallationCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmInstallationCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_scm_providers.ts
var MetorialDashboardInstanceScmProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM providers
   * @description Returns a paginated list of SCM providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/scm/providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmProvidersListOutput
    );
  }
  /**
   * @name Get SCM provider
   * @description Retrieves a specific SCM provider by ID.
   *
   * @param `instanceId` - string
   * @param `scmProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, scmProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/scm/providers/${scmProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmProvidersGetOutput
    );
  }
  /**
   * @name Create SCM provider
   * @description Initiates a setup session for a self-hosted SCM provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/scm/providers`;
    let request = {
      path,
      body: mapDashboardInstanceScmProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmProvidersCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_scm_repos.ts
var MetorialDashboardInstanceScmReposEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM repos
   * @description Returns a paginated list of SCM repositories.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmReposListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/scm/repos`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmReposListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceScmReposListOutput);
  }
  /**
   * @name Get SCM repo
   * @description Retrieves a specific SCM repository by ID.
   *
   * @param `instanceId` - string
   * @param `scmRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, scmRepositoryId, opts) {
    let path = `dashboard/instances/${instanceId}/scm/repos/${scmRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceScmReposGetOutput);
  }
  /**
   * @name Preview SCM repos
   * @description Lists available repositories from an SCM installation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmReposPreviewBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposPreviewOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  preview(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/scm/repos/preview`;
    let request = {
      path,
      body: mapDashboardInstanceScmReposPreviewBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmReposPreviewOutput
    );
  }
  /**
   * @name Create SCM repo
   * @description Links or creates a repository in an SCM installation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmReposCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/scm/repos`;
    let request = {
      path,
      body: mapDashboardInstanceScmReposCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmReposCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_session-templates.ts
var MetorialDashboardInstanceSessionTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session templates
   * @description Returns a paginated list of session templates.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-templates`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesListOutput
    );
  }
  /**
   * @name Get session template
   * @description Retrieves a specific session template by ID.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionTemplateId, opts) {
    let path = `dashboard/instances/${instanceId}/session-templates/${sessionTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesGetOutput
    );
  }
  /**
   * @name Create session template
   * @description Creates a new session template.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/session-templates`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionTemplatesCreateOutput
    );
  }
  /**
   * @name Update session template
   * @description Updates a specific session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `body` - DashboardInstanceSessionTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionTemplateId, body, opts) {
    let path = `dashboard/instances/${instanceId}/session-templates/${sessionTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionTemplatesUpdateOutput
    );
  }
  /**
   * @name Delete session template
   * @description Deletes a specific session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionTemplateId, opts) {
    let path = `dashboard/instances/${instanceId}/session-templates/${sessionTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionTemplatesDeleteOutput
    );
  }
  /**
   * @name List session template tools
   * @description Returns the effective set of tools available through the providers in a session template, filtered by the tool filters of each provider, deployment, config, and auth config.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesListToolsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  listTools(instanceId, sessionTemplateId, opts) {
    let path = `dashboard/instances/${instanceId}/session-templates/${sessionTemplateId}/tools`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesListToolsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_session-templates_providers.ts
var MetorialDashboardInstanceSessionTemplatesProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session template providers
   * @description Returns a paginated list of providers configured for a session template.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionTemplatesProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-template-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionTemplatesProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersListOutput
    );
  }
  /**
   * @name Get session template provider
   * @description Retrieves a specific provider configuration from a session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionTemplateProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersGetOutput
    );
  }
  /**
   * @name Create session template provider
   * @description Adds a new provider configuration to a session template.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionTemplatesProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/session-template-providers`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersCreateOutput
    );
  }
  /**
   * @name Update session template provider
   * @description Updates a provider configuration in a session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateProviderId` - string
   * @param `body` - DashboardInstanceSessionTemplatesProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionTemplateProviderId, body, opts) {
    let path = `dashboard/instances/${instanceId}/session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersUpdateOutput
    );
  }
  /**
   * @name Delete session template provider
   * @description Removes a provider configuration from a session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionTemplateProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions.ts
var MetorialDashboardInstanceSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sessions
   * @description Returns a paginated list of sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSessionsListOutput);
  }
  /**
   * @name Get session
   * @description Retrieves a specific session by ID.
   *
   * @param `instanceId` - string
   * @param `sessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionId, opts) {
    let path = `dashboard/instances/${instanceId}/sessions/${sessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSessionsGetOutput);
  }
  /**
   * @name Create session
   * @description Creates a new session with provider deployments.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sessions`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionsCreateOutput
    );
  }
  /**
   * @name Update session
   * @description Updates a session.
   *
   * @param `instanceId` - string
   * @param `sessionId` - string
   * @param `body` - DashboardInstanceSessionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionId, body, opts) {
    let path = `dashboard/instances/${instanceId}/sessions/${sessionId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionsUpdateOutput
    );
  }
  /**
   * @name Delete session
   * @description Deletes a session.
   *
   * @param `instanceId` - string
   * @param `sessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionId, opts) {
    let path = `dashboard/instances/${instanceId}/sessions/${sessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions_connections.ts
var MetorialDashboardInstanceSessionsConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session connections
   * @description Returns a paginated list of connections for a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-connections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsConnectionsListOutput
    );
  }
  /**
   * @name Get session connection
   * @description Retrieves a specific connection from a session.
   *
   * @param `instanceId` - string
   * @param `sessionConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionConnectionId, opts) {
    let path = `dashboard/instances/${instanceId}/session-connections/${sessionConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsConnectionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions_error-groups.ts
var MetorialDashboardInstanceSessionsErrorGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all session error groups
   * @description Returns a paginated list of error groups across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsErrorGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-error-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsErrorGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorGroupsListOutput
    );
  }
  /**
   * @name Get session error group
   * @description Retrieves a specific error group by ID across all sessions.
   *
   * @param `instanceId` - string
   * @param `sessionErrorGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionErrorGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/session-error-groups/${sessionErrorGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorGroupsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions_errors.ts
var MetorialDashboardInstanceSessionsErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all session errors
   * @description Returns a paginated list of errors across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-errors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsErrorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorsListOutput
    );
  }
  /**
   * @name Get session error
   * @description Retrieves a specific error that occurred in a session.
   *
   * @param `instanceId` - string
   * @param `sessionErrorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionErrorId, opts) {
    let path = `dashboard/instances/${instanceId}/session-errors/${sessionErrorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions_events.ts
var MetorialDashboardInstanceSessionsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session events
   * @description Returns a paginated list of events for a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsEventsListOutput
    );
  }
  /**
   * @name Get session event
   * @description Retrieves a specific event from a session.
   *
   * @param `instanceId` - string
   * @param `sessionEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionEventId, opts) {
    let path = `dashboard/instances/${instanceId}/session-events/${sessionEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions_messages.ts
var MetorialDashboardInstanceSessionsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session messages
   * @description Returns a paginated list of messages for a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsMessagesListOutput
    );
  }
  /**
   * @name Get session message
   * @description Retrieves a specific message from a session.
   *
   * @param `instanceId` - string
   * @param `sessionMessageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionMessageId, opts) {
    let path = `dashboard/instances/${instanceId}/session-messages/${sessionMessageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsMessagesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions_participants.ts
var MetorialDashboardInstanceSessionsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session participants
   * @description Returns a paginated list of participants in a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsParticipantsListOutput
    );
  }
  /**
   * @name Get session participant
   * @description Retrieves a specific participant in a session.
   *
   * @param `instanceId` - string
   * @param `sessionParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionParticipantId, opts) {
    let path = `dashboard/instances/${instanceId}/session-participants/${sessionParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_sessions_providers.ts
var MetorialDashboardInstanceSessionsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session providers
   * @description Returns a paginated list of providers connected to a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/session-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsProvidersListOutput
    );
  }
  /**
   * @name Get session provider
   * @description Retrieves a specific provider connected to a session.
   *
   * @param `instanceId` - string
   * @param `sessionProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/session-providers/${sessionProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsProvidersGetOutput
    );
  }
  /**
   * @name Create session provider
   * @description Adds a new provider to an active session.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionsProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/session-providers`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionsProvidersCreateOutput
    );
  }
  /**
   * @name Update session provider
   * @description Updates a provider connected to a session.
   *
   * @param `instanceId` - string
   * @param `sessionProviderId` - string
   * @param `body` - DashboardInstanceSessionsProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionProviderId, body, opts) {
    let path = `dashboard/instances/${instanceId}/session-providers/${sessionProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsProvidersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionsProvidersUpdateOutput
    );
  }
  /**
   * @name Delete session provider
   * @description Removes a provider from a session.
   *
   * @param `instanceId` - string
   * @param `sessionProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionProviderId, opts) {
    let path = `dashboard/instances/${instanceId}/session-providers/${sessionProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills.ts
var MetorialDashboardInstanceSkillsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skills
   * @description Returns a paginated list of skills.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSkillsListOutput);
  }
  /**
   * @name Get skill
   * @description Retrieves a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSkillsGetOutput);
  }
  /**
   * @name Create skill
   * @description Creates a new skill.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsCreateOutput
    );
  }
  /**
   * @name Update skill
   * @description Updates a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsUpdateOutput
    );
  }
  /**
   * @name Delete skill
   * @description Archives a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsDeleteOutput
    );
  }
  /**
   * @name Fork skill
   * @description Forks a skill for the current consumer. Non-consumer callers duplicate the skill instead.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsForkBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  fork(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/fork`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsForkBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardInstanceSkillsForkOutput);
  }
  /**
   * @name Publish consumer skill
   * @description Publishes a consumer-owned skill to the consumer groups they belong to.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPublishConsumerSkillOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  publishConsumerSkill(instanceId, skillId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/publish`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPublishConsumerSkillOutput
    );
  }
  /**
   * @name Share skill
   * @description Shares a skill with consumers or organization members.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsShareBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsShareOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  share(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/shares`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsShareBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardInstanceSkillsShareOutput);
  }
  /**
   * @name Duplicate skill
   * @description Duplicates a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsDuplicateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsDuplicateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  duplicate(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/duplicate`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsDuplicateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsDuplicateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_agents.ts
var MetorialDashboardInstanceSkillsAgentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill agent
   * @description Creates a new agent document in the skill agents directory.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsAgentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/agents`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsAgentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsAgentsCreateOutput
    );
  }
  /**
   * @name List skill agents
   * @description Returns a paginated list of agents for a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsAgentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/agents`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsAgentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsAgentsListOutput
    );
  }
  /**
   * @name Get skill agent by ID
   * @description Retrieves a specific agent within a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillAgentId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsAgentsGetOutput
    );
  }
  /**
   * @name Update skill agent
   * @description Updates the name or description for a specific skill agent.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `body` - DashboardInstanceSkillsAgentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillId, skillAgentId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsAgentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsAgentsUpdateOutput
    );
  }
  /**
   * @name Delete skill agent
   * @description Archives a specific skill agent and removes its linked store item.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, skillAgentId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsAgentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_configurations.ts
var MetorialDashboardInstanceSkillsConfigurationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill configuration
   * @description Creates a new non-default skill configuration.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsConfigurationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/configurations`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsConfigurationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsConfigurationsCreateOutput
    );
  }
  /**
   * @name List skill configurations
   * @description Returns a paginated list of visible skill configurations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsConfigurationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills/configurations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsConfigurationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsConfigurationsListOutput
    );
  }
  /**
   * @name Get skill configuration
   * @description Retrieves a specific skill configuration by ID, or the default.
   *
   * @param `instanceId` - string
   * @param `skillConfigurationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillConfigurationId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsConfigurationsGetOutput
    );
  }
  /**
   * @name Update skill configuration
   * @description Updates a specific skill configuration. Updating default creates it first if needed.
   *
   * @param `instanceId` - string
   * @param `skillConfigurationId` - string
   * @param `body` - DashboardInstanceSkillsConfigurationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillConfigurationId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsConfigurationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsConfigurationsUpdateOutput
    );
  }
  /**
   * @name Delete skill configuration
   * @description Soft deletes a specific non-internal skill configuration.
   *
   * @param `instanceId` - string
   * @param `skillConfigurationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillConfigurationId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsConfigurationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_exports.ts
var MetorialDashboardInstanceSkillsExportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill exports
   * @description Returns a paginated list of skill exports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsExportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-exports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsExportsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsExportsListOutput
    );
  }
  /**
   * @name Get skill export
   * @description Retrieves a skill export.
   *
   * @param `instanceId` - string
   * @param `skillExportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillExportId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-exports/${skillExportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsExportsGetOutput
    );
  }
  /**
   * @name Create skill export
   * @description Creates a skill, plugin, or marketplace export.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsExportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-exports`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsExportsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsExportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_files.ts
var MetorialDashboardInstanceSkillsFilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill files
   * @description Lists every file of a skill with its path, size and etag. Directories are implied by file paths.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/files`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsFilesListOutput
    );
  }
  /**
   * @name Get skill file
   * @description Retrieves a single skill file by path. Documents include their text content, other files include a download URL.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsFilesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/files/content`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsFilesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsFilesGetOutput
    );
  }
  /**
   * @name Write skill file
   * @description Creates or replaces the file at a path. Parent directories are created automatically.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesPutBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesPutOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  put(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/files`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesPutBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceSkillsFilesPutOutput
    );
  }
  /**
   * @name Delete skill file
   * @description Deletes the file at a path. Directories that were created automatically and become empty are removed. The root SKILL.md cannot be deleted.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsFilesDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/files`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsFilesDeleteQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsFilesDeleteOutput
    );
  }
  /**
   * @name Move skill file
   * @description Moves or renames a file. The root SKILL.md cannot be moved.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesMoveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesMoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  move(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/files/move`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesMoveBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsFilesMoveOutput
    );
  }
  /**
   * @name Apply skill file changes
   * @description Applies up to 100 put, delete and move changes one after another, in order. Every change is validated before any is applied, but changes are not applied atomically: if a change fails while being applied, the changes before it stay applied. Every change can carry its own if_match precondition.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesBatchBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesBatchOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  batch(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/files/batch`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesBatchBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsFilesBatchOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_fork-syncs.ts
var MetorialDashboardInstanceSkillsForkSyncsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill fork sync
   * @description Queues synchronization of upstream changes into a forked skill.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsForkSyncsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkSyncsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-fork-syncs`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsForkSyncsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsForkSyncsCreateOutput
    );
  }
  /**
   * @name Get skill fork sync
   * @description Retrieves the state of a fork synchronization.
   *
   * @param `instanceId` - string
   * @param `skillForkSyncId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkSyncsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillForkSyncId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-fork-syncs/${skillForkSyncId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsForkSyncsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_groups.ts
var MetorialDashboardInstanceSkillsGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill groups
   * @description Returns a paginated list of skill groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsListOutput
    );
  }
  /**
   * @name Get skill group
   * @description Retrieves a specific skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups/${skillGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsGetOutput
    );
  }
  /**
   * @name Create skill group
   * @description Creates a skill group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsGroupsCreateOutput
    );
  }
  /**
   * @name Update skill group
   * @description Updates a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `body` - DashboardInstanceSkillsGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups/${skillGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsGroupsUpdateOutput
    );
  }
  /**
   * @name Delete skill group
   * @description Archives a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillGroupId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups/${skillGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_groups_items.ts
var MetorialDashboardInstanceSkillsGroupsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill group items
   * @description Returns a paginated list of items for a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `query` - DashboardInstanceSkillsGroupsItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillGroupId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups/${skillGroupId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsGroupsItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsItemsListOutput
    );
  }
  /**
   * @name Get skill group item
   * @description Retrieves a specific skill group item.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `skillGroupItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillGroupId, skillGroupItemId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups/${skillGroupId}/items/${skillGroupItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsItemsGetOutput
    );
  }
  /**
   * @name Create skill group item
   * @description Adds a skill to a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `body` - DashboardInstanceSkillsGroupsItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillGroupId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups/${skillGroupId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsItemsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsGroupsItemsCreateOutput
    );
  }
  /**
   * @name Delete skill group item
   * @description Archives a skill group item.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `skillGroupItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillGroupId, skillGroupItemId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-groups/${skillGroupId}/items/${skillGroupItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsGroupsItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_imports.ts
var MetorialDashboardInstanceSkillsImportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill imports
   * @description Returns a paginated list of skill imports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsImportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-imports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsImportsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsImportsListOutput
    );
  }
  /**
   * @name Get skill import
   * @description Retrieves an individual skill import and its results.
   *
   * @param `instanceId` - string
   * @param `skillImportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillImportId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-imports/${skillImportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsImportsGetOutput
    );
  }
  /**
   * @name Create skill import
   * @description Queues a skill import from a repository or uploaded file.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsImportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-imports`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsImportsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsImportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_items.ts
var MetorialDashboardInstanceSkillsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill items
   * @description Returns a paginated list of items for a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsItemsListOutput
    );
  }
  /**
   * @name Get skill item
   * @description Retrieves a specific skill item.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillItemId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/items/${skillItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsItemsGetOutput
    );
  }
  /**
   * @name Create skill item
   * @description Creates a new item on a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsItemsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsItemsCreateOutput
    );
  }
  /**
   * @name Delete skill item
   * @description Archives a skill item.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, skillItemId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/items/${skillItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_marketplaces.ts
var MetorialDashboardInstanceSkillsMarketplacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplaces
   * @description Returns a paginated list of skill marketplaces.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesListOutput
    );
  }
  /**
   * @name Get skill marketplace
   * @description Retrieves a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMarketplaceId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesGetOutput
    );
  }
  /**
   * @name Create skill marketplace
   * @description Creates a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesCreateOutput
    );
  }
  /**
   * @name Update skill marketplace
   * @description Updates a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillMarketplaceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMarketplacesUpdateOutput
    );
  }
  /**
   * @name Archive skill marketplace
   * @description Archives a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(instanceId, skillMarketplaceId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesArchiveOutput
    );
  }
  /**
   * @name Sync skill marketplace
   * @description Forces a skill marketplace sync.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesSyncBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(instanceId, skillMarketplaceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/sync`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesSyncBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesSyncOutput
    );
  }
  /**
   * @name Get skill marketplace editor URL
   * @description Creates an embeddable editor URL for a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesGetEditorUrlBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesGetEditorUrlOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEditorUrl(instanceId, skillMarketplaceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/editor-url`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesGetEditorUrlBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesGetEditorUrlOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_marketplaces_plugins.ts
var MetorialDashboardInstanceSkillsMarketplacesPluginsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplace plugins
   * @description Returns plugins linked to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesPluginsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMarketplaceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesPluginsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsListOutput
    );
  }
  /**
   * @name Add skill marketplace plugin
   * @description Adds a skill plugin to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesPluginsAddBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsAddOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  add(instanceId, skillMarketplaceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesPluginsAddBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsAddOutput
    );
  }
  /**
   * @name Get skill marketplace plugin
   * @description Retrieves a skill marketplace plugin link.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplacePluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMarketplaceId, skillMarketplacePluginId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins/${skillMarketplacePluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsGetOutput
    );
  }
  /**
   * @name Remove skill marketplace plugin
   * @description Removes a skill plugin from a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplacePluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsRemoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  remove(instanceId, skillMarketplaceId, skillMarketplacePluginId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins/${skillMarketplacePluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsRemoveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_marketplaces_repositories.ts
var MetorialDashboardInstanceSkillsMarketplacesRepositoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplace repositories
   * @description Returns repositories linked to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesRepositoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMarketplaceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesRepositoriesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesListOutput
    );
  }
  /**
   * @name Get skill marketplace repository
   * @description Retrieves a repository linked to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplaceRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMarketplaceId, skillMarketplaceRepositoryId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories/${skillMarketplaceRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesGetOutput
    );
  }
  /**
   * @name Link skill marketplace repository
   * @description Links an SCM repository to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesRepositoriesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillMarketplaceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesRepositoriesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesCreateOutput
    );
  }
  /**
   * @name Unlink skill marketplace repository
   * @description Unlinks an SCM repository from a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplaceRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillMarketplaceId, skillMarketplaceRepositoryId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories/${skillMarketplaceRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_merge-requests.ts
var MetorialDashboardInstanceSkillsMergeRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge requests
   * @description Returns a paginated list of skill merge requests.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsListOutput
    );
  }
  /**
   * @name Create skill merge request
   * @description Creates a merge request from one skill into another.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCreateOutput
    );
  }
  /**
   * @name Get skill merge request
   * @description Retrieves a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsGetOutput
    );
  }
  /**
   * @name Perform skill merge request
   * @description Queues application of a resolved skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsPerformOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  perform(instanceId, skillMergeRequestId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/perform`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsPerformOutput
    );
  }
  /**
   * @name Close skill merge request
   * @description Closes an open skill merge request without applying it.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCloseOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  close(instanceId, skillMergeRequestId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/close`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCloseOutput
    );
  }
  /**
   * @name Rollback skill merge request
   * @description Restores the target skill to its state before a completed merge.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsRollbackOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  rollback(instanceId, skillMergeRequestId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/rollback`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsRollbackOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_merge-requests_comments.ts
var MetorialDashboardInstanceSkillsMergeRequestsCommentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge request comments
   * @description Lists comments on a skill merge request or one of its items.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsCommentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMergeRequestId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsCommentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsListOutput
    );
  }
  /**
   * @name Create skill merge request comment
   * @description Adds a comment to a skill merge request or one of its items.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCommentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillMergeRequestId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCommentsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsCreateOutput
    );
  }
  /**
   * @name Get skill merge request comment
   * @description Retrieves a comment on a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, commentId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsGetOutput
    );
  }
  /**
   * @name Update skill merge request comment
   * @description Updates a comment authored by the current actor.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCommentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillMergeRequestId, commentId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCommentsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsUpdateOutput
    );
  }
  /**
   * @name Delete skill merge request comment
   * @description Deletes a comment authored by the current actor.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillMergeRequestId, commentId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_merge-requests_events.ts
var MetorialDashboardInstanceSkillsMergeRequestsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge request events
   * @description Returns a paginated activity history for a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMergeRequestId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsEventsListOutput
    );
  }
  /**
   * @name Get skill merge request event
   * @description Retrieves one event from a skill merge request activity history.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, eventId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_merge-requests_items.ts
var MetorialDashboardInstanceSkillsMergeRequestsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Resolve skill merge request item
   * @description Saves a resolution for one proposed skill change.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `itemId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsItemsResolveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsItemsResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resolve(instanceId, skillMergeRequestId, itemId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/items/${itemId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsItemsResolveBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsItemsResolveOutput
    );
  }
  /**
   * @name Resolve skill merge request items
   * @description Saves resolutions for multiple proposed skill changes.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsItemsBulkResolveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  bulkResolve(instanceId, skillMergeRequestId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_merge-requests_plan.ts
var MetorialDashboardInstanceSkillsMergeRequestsPlanEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get skill merge plan
   * @description Returns the proposed changes and conflicts for a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsPlanGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/plan`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsPlanGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_participants.ts
var MetorialDashboardInstanceSkillsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill participants
   * @description Returns a paginated list of participants for a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsParticipantsListOutput
    );
  }
  /**
   * @name Get skill participant by ID
   * @description Retrieves a specific participant within a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillParticipantId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/participants/${skillParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_plugins.ts
var MetorialDashboardInstanceSkillsPluginsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugins
   * @description Returns a paginated list of skill plugins.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsPluginsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsListOutput
    );
  }
  /**
   * @name Get skill plugin
   * @description Retrieves a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillPluginId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsGetOutput
    );
  }
  /**
   * @name Create skill plugin
   * @description Creates a skill plugin.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsPluginsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsCreateOutput
    );
  }
  /**
   * @name Update skill plugin
   * @description Updates a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillPluginId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsPluginsUpdateOutput
    );
  }
  /**
   * @name Archive skill plugin
   * @description Archives a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(instanceId, skillPluginId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsArchiveOutput
    );
  }
  /**
   * @name Sync skill plugin
   * @description Forces a skill plugin sync.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSyncBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(instanceId, skillPluginId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/sync`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSyncBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsSyncOutput
    );
  }
  /**
   * @name Get skill plugin editor URL
   * @description Creates an embeddable editor URL for a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsGetEditorUrlBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsGetEditorUrlOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEditorUrl(instanceId, skillPluginId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/editor-url`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsGetEditorUrlBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsGetEditorUrlOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_plugins_repositories.ts
var MetorialDashboardInstanceSkillsPluginsRepositoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugin repositories
   * @description Returns repositories linked to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `query` - DashboardInstanceSkillsPluginsRepositoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillPluginId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/repositories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsRepositoriesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesListOutput
    );
  }
  /**
   * @name Get skill plugin repository
   * @description Retrieves a repository linked to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillPluginId, skillPluginRepositoryId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/repositories/${skillPluginRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesGetOutput
    );
  }
  /**
   * @name Link skill plugin repository
   * @description Links an SCM repository to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsRepositoriesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillPluginId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/repositories`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsRepositoriesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesCreateOutput
    );
  }
  /**
   * @name Unlink skill plugin repository
   * @description Unlinks an SCM repository from a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillPluginId, skillPluginRepositoryId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/repositories/${skillPluginRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_plugins_skills.ts
var MetorialDashboardInstanceSkillsPluginsSkillsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugin skills
   * @description Returns skills linked to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `query` - DashboardInstanceSkillsPluginsSkillsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillPluginId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/skills`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsSkillsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsListOutput
    );
  }
  /**
   * @name Add skill plugin skill
   * @description Adds a skill to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSkillsAddBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsAddOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  add(instanceId, skillPluginId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/skills`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSkillsAddBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsAddOutput
    );
  }
  /**
   * @name Get skill plugin skill
   * @description Retrieves a skill plugin skill link.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillPluginId, skillPluginSkillId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsGetOutput
    );
  }
  /**
   * @name Update skill plugin skill
   * @description Updates a skill plugin skill link.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSkillsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillPluginId, skillPluginSkillId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSkillsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsUpdateOutput
    );
  }
  /**
   * @name Remove skill plugin skill
   * @description Removes a skill from a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsRemoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  remove(instanceId, skillPluginId, skillPluginSkillId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsRemoveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_syncs.ts
var MetorialDashboardInstanceSkillsSyncsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill syncs
   * @description Returns a paginated list of skill syncs.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsSyncsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsSyncsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-syncs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsSyncsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsSyncsListOutput
    );
  }
  /**
   * @name Get skill sync
   * @description Retrieves a skill sync.
   *
   * @param `instanceId` - string
   * @param `skillSyncId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsSyncsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillSyncId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-syncs/${skillSyncId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsSyncsGetOutput
    );
  }
  /**
   * @name Get skill sync repository checks
   * @description Returns the latest repository checks and review requirements.
   *
   * @param `instanceId` - string
   * @param `skillSyncId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsSyncsRepositoryChecksOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  repositoryChecks(instanceId, skillSyncId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-syncs/${skillSyncId}/repository-checks`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsSyncsRepositoryChecksOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_templates.ts
var MetorialDashboardInstanceSkillsTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill templates
   * @description Returns a paginated list of skill templates.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesListOutput
    );
  }
  /**
   * @name Get skill template
   * @description Retrieves a specific skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillTemplateId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates/${skillTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesGetOutput
    );
  }
  /**
   * @name Create skill template
   * @description Creates a skill template.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsTemplatesCreateOutput
    );
  }
  /**
   * @name Update skill template
   * @description Updates a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillTemplateId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates/${skillTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsTemplatesUpdateOutput
    );
  }
  /**
   * @name Delete skill template
   * @description Archives a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillTemplateId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates/${skillTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsTemplatesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_templates_items.ts
var MetorialDashboardInstanceSkillsTemplatesItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill template items
   * @description Returns a paginated list of items for a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `query` - DashboardInstanceSkillsTemplatesItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillTemplateId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates/${skillTemplateId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsTemplatesItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsListOutput
    );
  }
  /**
   * @name Get skill template item
   * @description Retrieves a specific skill template item.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `skillTemplateItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillTemplateId, skillTemplateItemId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates/${skillTemplateId}/items/${skillTemplateItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsGetOutput
    );
  }
  /**
   * @name Create skill template item
   * @description Adds a provider or integration item to a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillTemplateId, body, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates/${skillTemplateId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesItemsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsCreateOutput
    );
  }
  /**
   * @name Delete skill template item
   * @description Deletes a skill template item.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `skillTemplateItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillTemplateId, skillTemplateItemId, opts) {
    let path = `dashboard/instances/${instanceId}/skill-templates/${skillTemplateId}/items/${skillTemplateItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_versions.ts
var MetorialDashboardInstanceSkillsVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill versions
   * @description Returns a paginated list of versions for a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsListOutput
    );
  }
  /**
   * @name Get skill version by ID
   * @description Retrieves a specific skill version by its ID.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillVersionId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/versions/${skillVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_skills_versions_snapshot.ts
var MetorialDashboardInstanceSkillsVersionsSnapshotEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get skill version snapshot
   * @description Retrieves the store-backed snapshot for a specific skill version.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsSnapshotGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillVersionId, opts) {
    let path = `dashboard/instances/${instanceId}/skills/${skillId}/versions/${skillVersionId}/snapshot`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsSnapshotGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_stores.ts
var MetorialDashboardInstanceStoresEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List stores
   * @description Returns a paginated list of stores owned by the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceStoresListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/stores`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceStoresListOutput);
  }
  /**
   * @name Create store
   * @description Creates a new store for the instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceStoresCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/stores`;
    let request = {
      path,
      body: mapDashboardInstanceStoresCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceStoresCreateOutput
    );
  }
  /**
   * @name Get store by ID
   * @description Retrieves a store by its ID.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceStoresGetOutput);
  }
  /**
   * @name Update store by ID
   * @description Updates a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `body` - DashboardInstanceStoresUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, storeId, body, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}`;
    let request = {
      path,
      body: mapDashboardInstanceStoresUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceStoresUpdateOutput
    );
  }
  /**
   * @name Delete store by ID
   * @description Deletes a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, storeId, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceStoresDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_stores_items.ts
var MetorialDashboardInstanceStoresItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Modify store items
   * @description Applies bulk item operations to a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `body` - DashboardInstanceStoresItemsModifyBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsModifyOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  modify(instanceId, storeId, body, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceStoresItemsModifyBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceStoresItemsModifyOutput
    );
  }
  /**
   * @name List store items
   * @description Returns a paginated list of items for a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `query` - DashboardInstanceStoresItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, storeId, query, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresItemsListOutput
    );
  }
  /**
   * @name Get store item by ID
   * @description Retrieves a specific item within a store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `itemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, itemId, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}/items/${itemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresItemsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_stores_participants.ts
var MetorialDashboardInstanceStoresParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List store participants
   * @description Returns a paginated list of participants for a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `query` - DashboardInstanceStoresParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, storeId, query, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresParticipantsListOutput
    );
  }
  /**
   * @name Get store participant by ID
   * @description Retrieves a specific participant within a store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `storeParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, storeParticipantId, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}/participants/${storeParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_stores_permissions.ts
var MetorialDashboardInstanceStoresPermissionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get store permissions
   * @description Returns the effective Cargo permissions for the current actor on a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresPermissionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, opts) {
    let path = `dashboard/instances/${instanceId}/stores/${storeId}/permissions`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresPermissionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_tool-calls.ts
var MetorialDashboardInstanceToolCallsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all tool calls
   * @description Returns a paginated list of tool calls across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceToolCallsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/tool-calls`;
    let request = {
      path,
      query: query ? mapDashboardInstanceToolCallsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceToolCallsListOutput
    );
  }
  /**
   * @name Get tool call
   * @description Retrieves a specific tool call by ID.
   *
   * @param `instanceId` - string
   * @param `toolCallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, toolCallId, opts) {
    let path = `dashboard/instances/${instanceId}/tool-calls/${toolCallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceToolCallsGetOutput);
  }
  /**
   * @name Create tool call
   * @description Creates a new tool call in a session by invoking a specific tool.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceToolCallsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/tool-calls`;
    let request = {
      path,
      body: mapDashboardInstanceToolCallsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceToolCallsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instance_webhook-registrations.ts
var MetorialDashboardInstanceWebhookRegistrationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List webhook registrations
   * @description Returns a paginated list of webhook registrations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceWebhookRegistrationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/webhook-registrations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceWebhookRegistrationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceWebhookRegistrationsListOutput
    );
  }
  /**
   * @name Get webhook registration
   * @description Retrieves a specific webhook registration by ID.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, webhookRegistrationId, opts) {
    let path = `dashboard/instances/${instanceId}/webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceWebhookRegistrationsGetOutput
    );
  }
  /**
   * @name Create webhook registration
   * @description Creates a webhook registration for a provider. Only providers whose type reports `triggers.webhook_registration.status` as `supported` can receive one. The registration starts out awaiting setup.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `dashboard/instances/${instanceId}/webhook-registrations`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceWebhookRegistrationsCreateOutput
    );
  }
  /**
   * @name Complete webhook registration setup
   * @description Submits the provider-specific configuration described by the registration setup document, activating the registration.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsSetupBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsSetupOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  setup(instanceId, webhookRegistrationId, body, opts) {
    let path = `dashboard/instances/${instanceId}/webhook-registrations/${webhookRegistrationId}/setup`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsSetupBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceWebhookRegistrationsSetupOutput
    );
  }
  /**
   * @name Update webhook registration
   * @description Updates a webhook registration.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, webhookRegistrationId, body, opts) {
    let path = `dashboard/instances/${instanceId}/webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceWebhookRegistrationsUpdateOutput
    );
  }
  /**
   * @name Delete webhook registration
   * @description Archives a webhook registration. The receiver is torn down on the provider before the record is removed for good.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, webhookRegistrationId, opts) {
    let path = `dashboard/instances/${instanceId}/webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceWebhookRegistrationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_instances_resource-counts.ts
var MetorialDashboardInstancesResourceCountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get resource counts
   * @description Returns counts for requested dashboard resources.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancesResourceCountsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancesResourceCountsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, query, opts) {
    let path = `dashboard/instances/${instanceId}/resource-counts`;
    let request = {
      path,
      query: query ? mapDashboardInstancesResourceCountsGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancesResourceCountsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_oauth_authorization-requests.ts
var MetorialDashboardOauthAuthorizationRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get OAuth authorization request
   * @description Get an oauth authorization request by its url token
   *
   * @param `urlToken` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOauthAuthorizationRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(urlToken, opts) {
    let path = `dashboard/oauth/authorization-requests/${urlToken}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOauthAuthorizationRequestsGetOutput
    );
  }
  /**
   * @name Approve OAuth authorization request
   * @description Approve an oauth authorization request for an organization
   *
   * @param `urlToken` - string
   * @param `body` - DashboardOauthAuthorizationRequestsApproveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOauthAuthorizationRequestsApproveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  approve(urlToken, body, opts) {
    let path = `dashboard/oauth/authorization-requests/${urlToken}/approve`;
    let request = {
      path,
      body: mapDashboardOauthAuthorizationRequestsApproveBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOauthAuthorizationRequestsApproveOutput
    );
  }
  /**
   * @name Reject OAuth authorization request
   * @description Reject an oauth authorization request
   *
   * @param `urlToken` - string
   * @param `body` - DashboardOauthAuthorizationRequestsRejectBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOauthAuthorizationRequestsRejectOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  reject(urlToken, body, opts) {
    let path = `dashboard/oauth/authorization-requests/${urlToken}/reject`;
    let request = {
      path,
      body: mapDashboardOauthAuthorizationRequestsRejectBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOauthAuthorizationRequestsRejectOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_oauth_authorization-requests_consumer-targets.ts
var MetorialDashboardOauthAuthorizationRequestsConsumerTargetsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List OAuth authorization request consumer targets
   * @description Lists the portal consumer profiles the current user can approve a consumer oauth authorization request as
   *
   * @param `urlToken` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOauthAuthorizationRequestsConsumerTargetsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(urlToken, opts) {
    let path = `dashboard/oauth/authorization-requests/${urlToken}/consumer-targets`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOauthAuthorizationRequestsConsumerTargetsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations.ts
var MetorialDashboardOrganizationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create organization
   * @description Create a new organization
   *
   * @param `body` - DashboardOrganizationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "dashboard/organizations";
    let request = {
      path,
      body: mapDashboardOrganizationsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardOrganizationsCreateOutput);
  }
  /**
   * @name List organizations
   * @description List all organizations
   *
   * @param `query` - DashboardOrganizationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "dashboard/organizations";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardOrganizationsListOutput);
  }
  /**
   * @name Get organization
   * @description Get the current organization information
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardOrganizationsGetOutput);
  }
  /**
   * @name Update organization
   * @description Update the current organization information
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsUpdateOutput
    );
  }
  /**
   * @name Delete organization
   * @description Delete the current organization
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_access-policies.ts
var MetorialDashboardOrganizationsAccessPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List access policies
   * @description List organization access policies
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsAccessPoliciesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/access-policies`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessPoliciesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessPoliciesListOutput
    );
  }
  /**
   * @name Get access policy
   * @description Get a single organization access policy
   *
   * @param `organizationId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, accessPolicyId, opts) {
    let path = `dashboard/organizations/${organizationId}/access-policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessPoliciesGetOutput
    );
  }
  /**
   * @name List access policy versions
   * @description List version history for an organization access policy
   *
   * @param `organizationId` - string
   * @param `accessPolicyId` - string
   * @param `query` - DashboardOrganizationsAccessPoliciesVersionsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesVersionsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  versions(organizationId, accessPolicyId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/access-policies/${accessPolicyId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessPoliciesVersionsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessPoliciesVersionsOutput
    );
  }
  /**
   * @name Create access policy
   * @description Create an organization access policy
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsAccessPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/access-policies`;
    let request = {
      path,
      body: mapDashboardOrganizationsAccessPoliciesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAccessPoliciesCreateOutput
    );
  }
  /**
   * @name Update access policy
   * @description Update an organization access policy
   *
   * @param `organizationId` - string
   * @param `accessPolicyId` - string
   * @param `body` - DashboardOrganizationsAccessPoliciesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, accessPolicyId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/access-policies/${accessPolicyId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsAccessPoliciesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsAccessPoliciesUpdateOutput
    );
  }
  /**
   * @name Delete access policy
   * @description Delete an organization access policy
   *
   * @param `organizationId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, accessPolicyId, opts) {
    let path = `dashboard/organizations/${organizationId}/access-policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsAccessPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_access-roles.ts
var MetorialDashboardOrganizationsAccessRolesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List access roles
   * @description List organization access roles
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsAccessRolesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/access-roles`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessRolesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessRolesListOutput
    );
  }
  /**
   * @name Get access role
   * @description Get a single organization access role
   *
   * @param `organizationId` - string
   * @param `accessRoleId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, accessRoleId, opts) {
    let path = `dashboard/organizations/${organizationId}/access-roles/${accessRoleId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessRolesGetOutput
    );
  }
  /**
   * @name List access role versions
   * @description List version history for an organization access role
   *
   * @param `organizationId` - string
   * @param `accessRoleId` - string
   * @param `query` - DashboardOrganizationsAccessRolesVersionsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesVersionsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  versions(organizationId, accessRoleId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/access-roles/${accessRoleId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessRolesVersionsQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessRolesVersionsOutput
    );
  }
  /**
   * @name Create access role
   * @description Create an organization access role
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsAccessRolesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/access-roles`;
    let request = {
      path,
      body: mapDashboardOrganizationsAccessRolesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAccessRolesCreateOutput
    );
  }
  /**
   * @name Update access role
   * @description Update an organization access role
   *
   * @param `organizationId` - string
   * @param `accessRoleId` - string
   * @param `body` - DashboardOrganizationsAccessRolesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, accessRoleId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/access-roles/${accessRoleId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsAccessRolesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsAccessRolesUpdateOutput
    );
  }
  /**
   * @name Delete access role
   * @description Delete an organization access role
   *
   * @param `organizationId` - string
   * @param `accessRoleId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, accessRoleId, opts) {
    let path = `dashboard/organizations/${organizationId}/access-roles/${accessRoleId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsAccessRolesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_api-keys.ts
var MetorialDashboardOrganizationsApiKeysEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get user
   * @description Get the current user information
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsApiKeysListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/api-keys`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsApiKeysListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsApiKeysListOutput
    );
  }
  /**
   * @name Get API key
   * @description Get the information of a specific API key
   *
   * @param `organizationId` - string
   * @param `apiKeyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, apiKeyId, opts) {
    let path = `dashboard/organizations/${organizationId}/api-keys/${apiKeyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsApiKeysGetOutput
    );
  }
  /**
   * @name Create API key
   * @description Create a new API key
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsApiKeysCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/api-keys`;
    let request = {
      path,
      body: mapDashboardOrganizationsApiKeysCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysCreateOutput
    );
  }
  /**
   * @name Update API key
   * @description Update the information of a specific API key
   *
   * @param `organizationId` - string
   * @param `apiKeyId` - string
   * @param `body` - DashboardOrganizationsApiKeysUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, apiKeyId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/api-keys/${apiKeyId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsApiKeysUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysUpdateOutput
    );
  }
  /**
   * @name Revoke API key
   * @description Revoke a specific API key
   *
   * @param `organizationId` - string
   * @param `apiKeyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(organizationId, apiKeyId, opts) {
    let path = `dashboard/organizations/${organizationId}/api-keys/${apiKeyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsApiKeysRevokeOutput
    );
  }
  /**
   * @name Rotate API key
   * @description Rotate a specific API key
   *
   * @param `organizationId` - string
   * @param `apiKeyId` - string
   * @param `body` - DashboardOrganizationsApiKeysRotateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysRotateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  rotate(organizationId, apiKeyId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/api-keys/${apiKeyId}/rotate`;
    let request = {
      path,
      body: mapDashboardOrganizationsApiKeysRotateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysRotateOutput
    );
  }
  /**
   * @name Reveal API key
   * @description Reveal a specific API key
   *
   * @param `organizationId` - string
   * @param `apiKeyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysRevealOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  reveal(organizationId, apiKeyId, opts) {
    let path = `dashboard/organizations/${organizationId}/api-keys/${apiKeyId}/reveal`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysRevealOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_audit-log-streams.ts
var MetorialDashboardOrganizationsAuditLogStreamsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization audit log streams
   * @description List all audit log streams configured for the organization
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsAuditLogStreamsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAuditLogStreamsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsListOutput
    );
  }
  /**
   * @name Get organization audit log stream
   * @description Get a specific audit log stream configured for the organization
   *
   * @param `organizationId` - string
   * @param `auditLogStreamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, auditLogStreamId, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams/${auditLogStreamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsGetOutput
    );
  }
  /**
   * @name Create organization audit log stream
   * @description Create an audit log stream for the organization
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsAuditLogStreamsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams`;
    let request = {
      path,
      body: mapDashboardOrganizationsAuditLogStreamsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAuditLogStreamsCreateOutput
    );
  }
  /**
   * @name Update organization audit log stream
   * @description Update an audit log stream configured for the organization
   *
   * @param `organizationId` - string
   * @param `auditLogStreamId` - string
   * @param `body` - DashboardOrganizationsAuditLogStreamsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, auditLogStreamId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams/${auditLogStreamId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsAuditLogStreamsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsAuditLogStreamsUpdateOutput
    );
  }
  /**
   * @name Resume organization audit log stream
   * @description Resume an audit log stream paused after repeated delivery errors
   *
   * @param `organizationId` - string
   * @param `auditLogStreamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsResumeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resume(organizationId, auditLogStreamId, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams/${auditLogStreamId}/resume`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAuditLogStreamsResumeOutput
    );
  }
  /**
   * @name Delete organization audit log stream
   * @description Delete an audit log stream configured for the organization
   *
   * @param `organizationId` - string
   * @param `auditLogStreamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, auditLogStreamId, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams/${auditLogStreamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsAuditLogStreamsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_audit-log-streams_events.ts
var MetorialDashboardOrganizationsAuditLogStreamsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List audit log stream events
   * @description List lifecycle events recorded for an audit log stream
   *
   * @param `organizationId` - string
   * @param `auditLogStreamId` - string
   * @param `query` - DashboardOrganizationsAuditLogStreamsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, auditLogStreamId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams/${auditLogStreamId}/events`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAuditLogStreamsEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsEventsListOutput
    );
  }
  /**
   * @name Get audit log stream event
   * @description Get a lifecycle event recorded for an audit log stream
   *
   * @param `organizationId` - string
   * @param `auditLogStreamId` - string
   * @param `auditLogStreamEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, auditLogStreamId, auditLogStreamEventId, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-log-streams/${auditLogStreamId}/events/${auditLogStreamEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_audit-logs.ts
var MetorialDashboardOrganizationsAuditLogsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization audit logs
   * @description List audit logs recorded for the organization
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsAuditLogsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-logs`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAuditLogsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogsListOutput
    );
  }
  /**
   * @name Get organization audit log
   * @description Get a specific audit log recorded for the organization
   *
   * @param `organizationId` - string
   * @param `auditLogId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, auditLogId, opts) {
    let path = `dashboard/organizations/${organizationId}/audit-logs/${auditLogId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_configs.ts
var MetorialDashboardOrganizationsConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization configs
   * @description List materialized configs for the current user and organization
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/configs`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsConfigsListOutput
    );
  }
  /**
   * @name Get organization config
   * @description Get a config by config ID, config type ID, or type identifier
   *
   * @param `organizationId` - string
   * @param `selector` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, selector, opts) {
    let path = `dashboard/organizations/${organizationId}/configs/${selector}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsConfigsGetOutput
    );
  }
  /**
   * @name Set organization config
   * @description Set a config by config ID, config type ID, or type identifier
   *
   * @param `organizationId` - string
   * @param `selector` - string
   * @param `body` - DashboardOrganizationsConfigsSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsConfigsSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(organizationId, selector, body, opts) {
    let path = `dashboard/organizations/${organizationId}/configs/${selector}`;
    let request = {
      path,
      body: mapDashboardOrganizationsConfigsSetBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardOrganizationsConfigsSetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_configure_audit-log-retention.ts
var MetorialDashboardOrganizationsConfigureAuditLogRetentionEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get audit log retention configuration
   * @description Get the audit log retention period for an organization
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsConfigureAuditLogRetentionGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/configure/audit-log-retention`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsConfigureAuditLogRetentionGetOutput
    );
  }
  /**
   * @name Update audit log retention configuration
   * @description Update the audit log retention period for an organization
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsConfigureAuditLogRetentionUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsConfigureAuditLogRetentionUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/configure/audit-log-retention`;
    let request = {
      path,
      body: mapDashboardOrganizationsConfigureAuditLogRetentionUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsConfigureAuditLogRetentionUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_event-deliveries.ts
var MetorialDashboardOrganizationsEventDeliveriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event deliveries
   * @description List event deliveries recorded for the organization
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsEventDeliveriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/event-deliveries`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDeliveriesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveriesListOutput
    );
  }
  /**
   * @name Get event delivery
   * @description Get a specific event delivery recorded for the organization
   *
   * @param `organizationId` - string
   * @param `eventDeliveryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, eventDeliveryId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-deliveries/${eventDeliveryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveriesGetOutput
    );
  }
  /**
   * @name Retry event delivery
   * @description Schedules another attempt for a delivery that has finished, whether it succeeded or gave up. The delivery is given a fresh attempt budget.
   *
   * @param `organizationId` - string
   * @param `eventDeliveryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveriesRetryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  retry(organizationId, eventDeliveryId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-deliveries/${eventDeliveryId}/retry`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDeliveriesRetryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_event-delivery-attempts.ts
var MetorialDashboardOrganizationsEventDeliveryAttemptsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event delivery attempts
   * @description List delivery attempts recorded for the organization
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsEventDeliveryAttemptsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveryAttemptsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/event-delivery-attempts`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDeliveryAttemptsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveryAttemptsListOutput
    );
  }
  /**
   * @name Get event delivery attempt
   * @description Get a specific delivery attempt, including the request Metorial sent and the response the destination returned
   *
   * @param `organizationId` - string
   * @param `eventDeliveryAttemptId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveryAttemptsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, eventDeliveryAttemptId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-delivery-attempts/${eventDeliveryAttemptId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveryAttemptsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_event-destination-listeners.ts
var MetorialDashboardOrganizationsEventDestinationListenersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event destination listeners
   * @description Returns a paginated list of event destination listeners for the organization.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsEventDestinationListenersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destination-listeners`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDestinationListenersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationListenersListOutput
    );
  }
  /**
   * @name Get event destination listener
   * @description Retrieves a specific event destination listener by ID.
   *
   * @param `organizationId` - string
   * @param `eventDestinationListenerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, eventDestinationListenerId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destination-listeners/${eventDestinationListenerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationListenersGetOutput
    );
  }
  /**
   * @name Create event destination listener
   * @description Subscribes an event destination to events for this instance — generic resource events, a callback's trigger events, or a chat connection's events.
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsEventDestinationListenersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destination-listeners`;
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationListenersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationListenersCreateOutput
    );
  }
  /**
   * @name Update event destination listener
   * @description Updates the event types or callback triggers an event destination listener subscribes to.
   *
   * @param `organizationId` - string
   * @param `eventDestinationListenerId` - string
   * @param `body` - DashboardOrganizationsEventDestinationListenersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, eventDestinationListenerId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destination-listeners/${eventDestinationListenerId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationListenersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsEventDestinationListenersUpdateOutput
    );
  }
  /**
   * @name Delete event destination listener
   * @description Removes an event destination listener.
   *
   * @param `organizationId` - string
   * @param `eventDestinationListenerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, eventDestinationListenerId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destination-listeners/${eventDestinationListenerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsEventDestinationListenersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_event-destinations.ts
var MetorialDashboardOrganizationsEventDestinationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event destinations
   * @description List all event destinations configured for the organization
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsEventDestinationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destinations`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDestinationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationsListOutput
    );
  }
  /**
   * @name Get event destination
   * @description Get a specific event destination configured for the organization
   *
   * @param `organizationId` - string
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, eventDestinationId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destinations/${eventDestinationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationsGetOutput
    );
  }
  /**
   * @name Create event destination
   * @description Create an event destination for the organization
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsEventDestinationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destinations`;
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsCreateOutput
    );
  }
  /**
   * @name Update event destination
   * @description Update an event destination configured for the organization
   *
   * @param `organizationId` - string
   * @param `eventDestinationId` - string
   * @param `body` - DashboardOrganizationsEventDestinationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, eventDestinationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destinations/${eventDestinationId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsEventDestinationsUpdateOutput
    );
  }
  /**
   * @name Archive event destination
   * @description Archives an event destination. Listeners pointed at it stop being delivered to.
   *
   * @param `organizationId` - string
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(organizationId, eventDestinationId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destinations/${eventDestinationId}/archive`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsArchiveOutput
    );
  }
  /**
   * @name Rotate event destination webhook secret
   * @description Generates a new signing secret for this event destination's webhook, invalidating the previous one. The new secret is only returned in this response.
   *
   * @param `organizationId` - string
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsRotateWebhookSecretOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  rotateWebhookSecret(organizationId, eventDestinationId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destinations/${eventDestinationId}/rotate-webhook-secret`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsRotateWebhookSecretOutput
    );
  }
  /**
   * @name Ping event destination
   * @description Sends a test delivery to this event destination immediately, regardless of its listeners. The ping goes through the normal delivery/retry pipeline and shows up in delivery history.
   *
   * @param `organizationId` - string
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsPingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  ping(organizationId, eventDestinationId, opts) {
    let path = `dashboard/organizations/${organizationId}/event-destinations/${eventDestinationId}/ping`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsPingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_events.ts
var MetorialDashboardOrganizationsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List events
   * @description List events recorded for the organization
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/events`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventsListOutput
    );
  }
  /**
   * @name Get event
   * @description Get a specific event recorded for the organization
   *
   * @param `organizationId` - string
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, eventId, opts) {
    let path = `dashboard/organizations/${organizationId}/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_instances.ts
var MetorialDashboardOrganizationsInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization instances
   * @description List all organization instances
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/instances`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInstancesListOutput
    );
  }
  /**
   * @name Get organization instance
   * @description Get the information of a specific organization instance
   *
   * @param `organizationId` - string
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, instanceId, opts) {
    let path = `dashboard/organizations/${organizationId}/instances/${instanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInstancesGetOutput
    );
  }
  /**
   * @name Delete organization instance
   * @description Remove an organization instance
   *
   * @param `organizationId` - string
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, instanceId, opts) {
    let path = `dashboard/organizations/${organizationId}/instances/${instanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsInstancesDeleteOutput
    );
  }
  /**
   * @name Update organization instance
   * @description Update the role of an organization instance
   *
   * @param `organizationId` - string
   * @param `instanceId` - string
   * @param `body` - DashboardOrganizationsInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, instanceId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/instances/${instanceId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsInstancesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInstancesUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_invites.ts
var MetorialDashboardOrganizationsInvitesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization invites
   * @description List all organization invites
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsInvitesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/invites`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsInvitesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInvitesListOutput
    );
  }
  /**
   * @name Get organization invite
   * @description Get the information of a specific organization invite
   *
   * @param `organizationId` - string
   * @param `inviteId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, inviteId, opts) {
    let path = `dashboard/organizations/${organizationId}/invites/${inviteId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInvitesGetOutput
    );
  }
  /**
   * @name Create organization invite
   * @description Create a new organization invite
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsInvitesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/invites`;
    let request = {
      path,
      body: mapDashboardOrganizationsInvitesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInvitesCreateOutput
    );
  }
  /**
   * @name Ensure organization invite link
   * @description Ensure the invite link for the organization
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesEnsureLinkOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  ensureLink(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/invites/ensure`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInvitesEnsureLinkOutput
    );
  }
  /**
   * @name Delete organization invite
   * @description Remove an organization invite
   *
   * @param `organizationId` - string
   * @param `inviteId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, inviteId, opts) {
    let path = `dashboard/organizations/${organizationId}/invites/${inviteId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsInvitesDeleteOutput
    );
  }
  /**
   * @name Update organization invite
   * @description Update the role of an organization invite
   *
   * @param `organizationId` - string
   * @param `inviteId` - string
   * @param `body` - DashboardOrganizationsInvitesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, inviteId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/invites/${inviteId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsInvitesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInvitesUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_join.ts
var MetorialDashboardOrganizationsJoinEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Join organization
   * @description Join an organization
   *
   * @param `query` - DashboardOrganizationsJoinGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsJoinGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(query, opts) {
    let path = "dashboard/organization-join/find";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsJoinGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardOrganizationsJoinGetOutput);
  }
  /**
   * @name Join organization
   * @description Join an organization
   *
   * @param `body` - DashboardOrganizationsJoinAcceptBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsJoinAcceptOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  accept(body, opts) {
    let path = "dashboard/organization-join/accept";
    let request = {
      path,
      body: mapDashboardOrganizationsJoinAcceptBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsJoinAcceptOutput
    );
  }
  /**
   * @name Reject organization invite
   * @description Reject an organization invite
   *
   * @param `body` - DashboardOrganizationsJoinRejectBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsJoinRejectOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  reject(body, opts) {
    let path = "dashboard/organization-join/reject";
    let request = {
      path,
      body: mapDashboardOrganizationsJoinRejectBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsJoinRejectOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_layouts.ts
var MetorialDashboardOrganizationsLayoutsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization layouts
   * @description List materialized layouts for the current user and organization
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsLayoutsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/layouts`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsLayoutsListOutput
    );
  }
  /**
   * @name Get organization layout
   * @description Get a layout by layout ID, layout type ID, or type identifier
   *
   * @param `organizationId` - string
   * @param `selector` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsLayoutsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, selector, opts) {
    let path = `dashboard/organizations/${organizationId}/layouts/${selector}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsLayoutsGetOutput
    );
  }
  /**
   * @name Set organization layout
   * @description Set a layout by layout ID, layout type ID, or type identifier
   *
   * @param `organizationId` - string
   * @param `selector` - string
   * @param `body` - DashboardOrganizationsLayoutsSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsLayoutsSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(organizationId, selector, body, opts) {
    let path = `dashboard/organizations/${organizationId}/layouts/${selector}`;
    let request = {
      path,
      body: mapDashboardOrganizationsLayoutsSetBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardOrganizationsLayoutsSetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_members.ts
var MetorialDashboardOrganizationsMembersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization members
   * @description List all organization members
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsMembersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/members`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsMembersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsMembersListOutput
    );
  }
  /**
   * @name Get organization member
   * @description Get the information of a specific organization member
   *
   * @param `organizationId` - string
   * @param `memberId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, memberId, opts) {
    let path = `dashboard/organizations/${organizationId}/members/${memberId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsMembersGetOutput
    );
  }
  /**
   * @name Delete organization member
   * @description Remove an organization member
   *
   * @param `organizationId` - string
   * @param `memberId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, memberId, opts) {
    let path = `dashboard/organizations/${organizationId}/members/${memberId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsMembersDeleteOutput
    );
  }
  /**
   * @name Update organization member
   * @description Update the role of an organization member
   *
   * @param `organizationId` - string
   * @param `memberId` - string
   * @param `body` - DashboardOrganizationsMembersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, memberId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/members/${memberId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsMembersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsMembersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_members_policies.ts
var MetorialDashboardOrganizationsMembersPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign policy to organization member
   * @description Assign an access policy to an organization member
   *
   * @param `organizationId` - string
   * @param `memberId` - string
   * @param `body` - DashboardOrganizationsMembersPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, memberId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/members/${memberId}/policies`;
    let request = {
      path,
      body: mapDashboardOrganizationsMembersPoliciesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsMembersPoliciesCreateOutput
    );
  }
  /**
   * @name Remove policy from organization member
   * @description Remove an access policy from an organization member
   *
   * @param `organizationId` - string
   * @param `memberId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, memberId, accessPolicyId, opts) {
    let path = `dashboard/organizations/${organizationId}/members/${memberId}/policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsMembersPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_oauth_apps.ts
var MetorialDashboardOrganizationsOauthAppsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth applications
   * @description Returns a paginated list of OAuth applications owned by the organization.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsOauthAppsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/apps`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthAppsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAppsListOutput
    );
  }
  /**
   * @name Get organization OAuth application
   * @description Retrieves a specific OAuth application owned by the organization.
   *
   * @param `organizationId` - string
   * @param `oauthApplicationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, oauthApplicationId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/apps/${oauthApplicationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAppsGetOutput
    );
  }
  /**
   * @name Create organization OAuth application
   * @description Creates a new OAuth application that belongs to the organization.
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsOauthAppsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/apps`;
    let request = {
      path,
      body: mapDashboardOrganizationsOauthAppsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthAppsCreateOutput
    );
  }
  /**
   * @name Update organization OAuth application
   * @description Updates an existing OAuth application owned by the organization.
   *
   * @param `organizationId` - string
   * @param `oauthApplicationId` - string
   * @param `body` - DashboardOrganizationsOauthAppsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, oauthApplicationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/apps/${oauthApplicationId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsOauthAppsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsOauthAppsUpdateOutput
    );
  }
  /**
   * @name Delete organization OAuth application
   * @description Archives an OAuth application owned by the organization.
   *
   * @param `organizationId` - string
   * @param `oauthApplicationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, oauthApplicationId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/apps/${oauthApplicationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOauthAppsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_oauth_apps_client-secrets.ts
var MetorialDashboardOrganizationsOauthAppsClientSecretsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create OAuth application client secret
   * @description Creates a new client secret for an OAuth application.
   *
   * @param `organizationId` - string
   * @param `oauthApplicationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsClientSecretsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, oauthApplicationId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/apps/${oauthApplicationId}/client-secrets`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthAppsClientSecretsCreateOutput
    );
  }
  /**
   * @name Delete OAuth application client secret
   * @description Deletes a client secret from an OAuth application.
   *
   * @param `organizationId` - string
   * @param `oauthApplicationId` - string
   * @param `oauthApplicationClientSecretId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsClientSecretsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, oauthApplicationId, oauthApplicationClientSecretId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/apps/${oauthApplicationId}/client-secrets/${oauthApplicationClientSecretId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOauthAppsClientSecretsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_oauth_authorization-logs.ts
var MetorialDashboardOrganizationsOauthAuthorizationLogsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth authorization logs
   * @description Returns a paginated list of OAuth authorization requests for the organization.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsOauthAuthorizationLogsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationLogsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/authorization-logs`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthAuthorizationLogsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAuthorizationLogsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_oauth_authorizations.ts
var MetorialDashboardOrganizationsOauthAuthorizationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth authorizations
   * @description Returns a paginated list of OAuth authorizations for the organization.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsOauthAuthorizationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/authorizations`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthAuthorizationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAuthorizationsListOutput
    );
  }
  /**
   * @name Get organization OAuth authorization
   * @description Retrieves a specific OAuth authorization for the organization.
   *
   * @param `organizationId` - string
   * @param `oauthAuthorizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, oauthAuthorizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/authorizations/${oauthAuthorizationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAuthorizationsGetOutput
    );
  }
  /**
   * @name Revoke organization OAuth authorization
   * @description Revokes a specific OAuth authorization for the organization.
   *
   * @param `organizationId` - string
   * @param `oauthAuthorizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(organizationId, oauthAuthorizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/authorizations/${oauthAuthorizationId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthAuthorizationsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_oauth_cli-devices.ts
var MetorialDashboardOrganizationsOauthCliDevicesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization CLI devices
   * @description Returns a paginated list of CLI devices for the organization.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsOauthCliDevicesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthCliDevicesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/cli-devices`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthCliDevicesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthCliDevicesListOutput
    );
  }
  /**
   * @name Get organization CLI device
   * @description Retrieves a specific CLI device for the organization.
   *
   * @param `organizationId` - string
   * @param `cliDeviceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthCliDevicesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, cliDeviceId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/cli-devices/${cliDeviceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthCliDevicesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_oauth_installations.ts
var MetorialDashboardOrganizationsOauthInstallationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth installations
   * @description Returns a paginated list of OAuth installations for the organization.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsOauthInstallationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthInstallationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/installations`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthInstallationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthInstallationsListOutput
    );
  }
  /**
   * @name Get organization OAuth installation
   * @description Retrieves a specific OAuth installation for the organization.
   *
   * @param `organizationId` - string
   * @param `oauthInstallationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthInstallationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, oauthInstallationId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/installations/${oauthInstallationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthInstallationsGetOutput
    );
  }
  /**
   * @name Revoke organization OAuth installation
   * @description Revokes a specific OAuth installation for the organization.
   *
   * @param `organizationId` - string
   * @param `oauthInstallationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthInstallationsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(organizationId, oauthInstallationId, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/installations/${oauthInstallationId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthInstallationsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_oauth_scopes.ts
var MetorialDashboardOrganizationsOauthScopesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List OAuth scopes
   * @description Returns all available OAuth scopes that organization-owned OAuth applications may request.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsOauthScopesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthScopesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/oauth/scopes`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthScopesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthScopesListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_outposts.ts
var MetorialDashboardOrganizationsOutpostsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List outposts
   * @description List every outpost in the organization's account family
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsOutpostsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOutpostsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsListOutput
    );
  }
  /**
   * @name Get outpost
   * @description Get any outpost in the organization's account family
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, outpostId, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsGetOutput
    );
  }
  /**
   * @name Create outpost
   * @description Create a new outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsOutpostsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts`;
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsCreateOutput
    );
  }
  /**
   * @name Update outpost
   * @description Update the information of an outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `body` - DashboardOrganizationsOutpostsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, outpostId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsUpdateOutput
    );
  }
  /**
   * @name Disable outpost
   * @description Disable an outpost owned by this organization. An outpost must be disabled before it can be deleted.
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsDisableOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  disable(organizationId, outpostId, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/disable`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsDisableOutput
    );
  }
  /**
   * @name Enable outpost
   * @description Enable a disabled outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsEnableOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  enable(organizationId, outpostId, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/enable`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsEnableOutput
    );
  }
  /**
   * @name Delete outpost
   * @description Delete a disabled outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, outpostId, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOutpostsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_outposts_access.ts
var MetorialDashboardOrganizationsOutpostsAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Set outpost access
   * @description Replace this organization's access grants on an outpost with the given list of instance/service grants
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `body` - DashboardOrganizationsOutpostsAccessSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsAccessSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(organizationId, outpostId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/access`;
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsAccessSetBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsAccessSetOutput
    );
  }
  /**
   * @name List outpost access
   * @description List the access grants on an outpost, optionally filtered by organization or instance
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `query` - DashboardOrganizationsOutpostsAccessListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsAccessListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, outpostId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/access`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOutpostsAccessListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsAccessListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_outposts_credentials.ts
var MetorialDashboardOrganizationsOutpostsCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create outpost credential
   * @description Create a new enrollment credential for an outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `body` - DashboardOrganizationsOutpostsCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, outpostId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/credentials`;
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsCreateOutput
    );
  }
  /**
   * @name List outpost credentials
   * @description List the credentials for an outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `query` - DashboardOrganizationsOutpostsCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, outpostId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/credentials`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOutpostsCredentialsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsListOutput
    );
  }
  /**
   * @name Get outpost credential
   * @description Get a credential for an outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `credentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, outpostId, credentialId, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/credentials/${credentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsGetOutput
    );
  }
  /**
   * @name Disable outpost credential
   * @description Disable a credential for an outpost owned by this organization. A credential must be disabled before it can be deleted.
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `credentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsDisableOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  disable(organizationId, outpostId, credentialId, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/credentials/${credentialId}/disable`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsDisableOutput
    );
  }
  /**
   * @name Delete outpost credential
   * @description Delete a disabled credential for an outpost owned by this organization
   *
   * @param `organizationId` - string
   * @param `outpostId` - string
   * @param `credentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, outpostId, credentialId, opts) {
    let path = `dashboard/organizations/${organizationId}/outposts/${outpostId}/credentials/${credentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_projects.ts
var MetorialDashboardOrganizationsProjectsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization projects
   * @description List all organization projects
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsProjectsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/projects`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsProjectsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsProjectsListOutput
    );
  }
  /**
   * @name Get organization project
   * @description Get the information of a specific organization project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsProjectsGetOutput
    );
  }
  /**
   * @name Create organization project
   * @description Create a new organization project
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsProjectsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects`;
    let request = {
      path,
      body: mapDashboardOrganizationsProjectsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsProjectsCreateOutput
    );
  }
  /**
   * @name Delete organization project
   * @description Remove an organization project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsProjectsDeleteOutput
    );
  }
  /**
   * @name Update organization project
   * @description Update the role of an organization project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardOrganizationsProjectsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsProjectsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsProjectsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_projects_branding.ts
var MetorialDashboardOrganizationsProjectsBrandingEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project branding
   * @description Get branding information for a specific project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsBrandingGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/branding`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsProjectsBrandingGetOutput
    );
  }
  /**
   * @name Update project branding
   * @description Update branding information for a specific project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardOrganizationsProjectsBrandingUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsBrandingUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/branding`;
    let request = {
      path,
      body: mapDashboardOrganizationsProjectsBrandingUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsProjectsBrandingUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_sandboxes.ts
var MetorialDashboardOrganizationsSandboxesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization sandboxes
   * @description List all organization sandboxes
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsSandboxesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/sandboxes`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsSandboxesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsSandboxesListOutput
    );
  }
  /**
   * @name Get organization sandbox
   * @description Get the information of a specific organization sandbox
   *
   * @param `organizationId` - string
   * @param `sandboxId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, sandboxId, opts) {
    let path = `dashboard/organizations/${organizationId}/sandboxes/${sandboxId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsSandboxesGetOutput
    );
  }
  /**
   * @name Create organization sandbox
   * @description Create a new development sandbox
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsSandboxesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/sandboxes`;
    let request = {
      path,
      body: mapDashboardOrganizationsSandboxesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsSandboxesCreateOutput
    );
  }
  /**
   * @name Update organization sandbox
   * @description Update a development sandbox
   *
   * @param `organizationId` - string
   * @param `sandboxId` - string
   * @param `body` - DashboardOrganizationsSandboxesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, sandboxId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/sandboxes/${sandboxId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsSandboxesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsSandboxesUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_service-accounts.ts
var MetorialDashboardOrganizationsServiceAccountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization service accounts
   * @description Returns a paginated list of service accounts owned by the organization.
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsServiceAccountsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsServiceAccountsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsListOutput
    );
  }
  /**
   * @name Get organization service account
   * @description Retrieves a specific service account owned by the organization.
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, serviceAccountId, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsGetOutput
    );
  }
  /**
   * @name Create organization service account
   * @description Creates a new service account for machine-to-machine authentication.
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsServiceAccountsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts`;
    let request = {
      path,
      body: mapDashboardOrganizationsServiceAccountsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsServiceAccountsCreateOutput
    );
  }
  /**
   * @name Update organization service account
   * @description Updates an existing service account owned by the organization.
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `body` - DashboardOrganizationsServiceAccountsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, serviceAccountId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsServiceAccountsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsServiceAccountsUpdateOutput
    );
  }
  /**
   * @name Delete organization service account
   * @description Archives a service account owned by the organization.
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, serviceAccountId, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsServiceAccountsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_service-accounts_client-secrets.ts
var MetorialDashboardOrganizationsServiceAccountsClientSecretsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create service account client secret
   * @description Creates a new client secret for a service account.
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsClientSecretsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, serviceAccountId, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}/client-secrets`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsServiceAccountsClientSecretsCreateOutput
    );
  }
  /**
   * @name Delete service account client secret
   * @description Deletes a client secret from a service account.
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `oauthApplicationClientSecretId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsClientSecretsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, serviceAccountId, oauthApplicationClientSecretId, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}/client-secrets/${oauthApplicationClientSecretId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsServiceAccountsClientSecretsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_service-accounts_credentials.ts
var MetorialDashboardOrganizationsServiceAccountsCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List service account credentials
   * @description Returns a paginated list of credentials for a service account.
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `query` - DashboardOrganizationsServiceAccountsCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, serviceAccountId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}/credentials`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsServiceAccountsCredentialsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsCredentialsListOutput
    );
  }
  /**
   * @name Get service account credential
   * @description Retrieves a specific credential for a service account.
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `serviceAccountCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, serviceAccountId, serviceAccountCredentialId, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}/credentials/${serviceAccountCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsCredentialsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_service-accounts_policies.ts
var MetorialDashboardOrganizationsServiceAccountsPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign service account policy
   * @description Assign an access policy to a service account
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `body` - DashboardOrganizationsServiceAccountsPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, serviceAccountId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}/policies`;
    let request = {
      path,
      body: mapDashboardOrganizationsServiceAccountsPoliciesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsServiceAccountsPoliciesCreateOutput
    );
  }
  /**
   * @name Remove service account policy
   * @description Remove an access policy from a service account
   *
   * @param `organizationId` - string
   * @param `serviceAccountId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, serviceAccountId, accessPolicyId, opts) {
    let path = `dashboard/organizations/${organizationId}/service-accounts/${serviceAccountId}/policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsServiceAccountsPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_teams.ts
var MetorialDashboardOrganizationsTeamsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization teams
   * @description List all organization teams
   *
   * @param `organizationId` - string
   * @param `query` - DashboardOrganizationsTeamsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/teams`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsTeamsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsTeamsListOutput
    );
  }
  /**
   * @name Get team
   * @description Get the information of a specific team
   *
   * @param `organizationId` - string
   * @param `teamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, teamId, opts) {
    let path = `dashboard/organizations/${organizationId}/teams/${teamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsTeamsGetOutput
    );
  }
  /**
   * @name Update team
   * @description Update the role of an team
   *
   * @param `organizationId` - string
   * @param `teamId` - string
   * @param `body` - DashboardOrganizationsTeamsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, teamId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/teams/${teamId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsUpdateOutput
    );
  }
  /**
   * @name Delete team
   * @description Delete a team. Its members keep their own access.
   *
   * @param `organizationId` - string
   * @param `teamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, teamId, opts) {
    let path = `dashboard/organizations/${organizationId}/teams/${teamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsTeamsDeleteOutput
    );
  }
  /**
   * @name Create organization team
   * @description Create a new organization team
   *
   * @param `organizationId` - string
   * @param `body` - DashboardOrganizationsTeamsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/teams`;
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_teams_members.ts
var MetorialDashboardOrganizationsTeamsMembersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign member to team
   * @description Assign an organization member to a team
   *
   * @param `organizationId` - string
   * @param `teamId` - string
   * @param `body` - DashboardOrganizationsTeamsMembersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsMembersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, teamId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/teams/${teamId}/members`;
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsMembersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsMembersCreateOutput
    );
  }
  /**
   * @name Remove member from team
   * @description Remove an organization member from a team
   *
   * @param `organizationId` - string
   * @param `teamId` - string
   * @param `actorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsMembersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, teamId, actorId, opts) {
    let path = `dashboard/organizations/${organizationId}/teams/${teamId}/members/${actorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsTeamsMembersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_teams_policies.ts
var MetorialDashboardOrganizationsTeamsPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign policy to team
   * @description Assign an access policy to a team
   *
   * @param `organizationId` - string
   * @param `teamId` - string
   * @param `body` - DashboardOrganizationsTeamsPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(organizationId, teamId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/teams/${teamId}/policies`;
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsPoliciesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsPoliciesCreateOutput
    );
  }
  /**
   * @name Remove policy from team
   * @description Remove an access policy from a team
   *
   * @param `organizationId` - string
   * @param `teamId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(organizationId, teamId, accessPolicyId, opts) {
    let path = `dashboard/organizations/${organizationId}/teams/${teamId}/policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsTeamsPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_organizations_webhook-events.ts
var MetorialDashboardOrganizationsWebhookEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List webhook events
   * @description List all event types that event destination listeners can subscribe to
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsWebhookEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/webhook-events`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsWebhookEventsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_auth-config.ts
var MetorialDashboardProjectsConfigureAuthConfigEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project auth config configuration
   * @description Get auth config export/import settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureAuthConfigGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/auth-config`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureAuthConfigGetOutput
    );
  }
  /**
   * @name Update project auth config configuration
   * @description Update auth config export/import settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureAuthConfigUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureAuthConfigUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/auth-config`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureAuthConfigUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureAuthConfigUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_data-retention.ts
var MetorialDashboardProjectsConfigureDataRetentionEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project data retention configuration
   * @description Get message data retention settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureDataRetentionGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/data-retention`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureDataRetentionGetOutput
    );
  }
  /**
   * @name Update project data retention configuration
   * @description Update message data retention settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureDataRetentionUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureDataRetentionUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/data-retention`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureDataRetentionUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureDataRetentionUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_integration-naming.ts
var MetorialDashboardProjectsConfigureIntegrationNamingEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project integration naming configuration
   * @description Get integration naming settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureIntegrationNamingGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/integration-naming`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureIntegrationNamingGetOutput
    );
  }
  /**
   * @name Update project integration naming configuration
   * @description Update integration naming settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureIntegrationNamingUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureIntegrationNamingUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/integration-naming`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureIntegrationNamingUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureIntegrationNamingUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_retention.ts
var MetorialDashboardProjectsConfigureRetentionEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project retention configuration
   * @description Get log retention settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureRetentionGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/retention`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureRetentionGetOutput
    );
  }
  /**
   * @name Update project retention configuration
   * @description Update log retention settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureRetentionUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureRetentionUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/retention`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureRetentionUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureRetentionUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_sessionless-mcp.ts
var MetorialDashboardProjectsConfigureSessionlessMcpEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project sessionless MCP configuration
   * @description Get the sessionless MCP setting for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureSessionlessMcpGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/sessionless-mcp`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureSessionlessMcpGetOutput
    );
  }
  /**
   * @name Update project sessionless MCP configuration
   * @description Enable or disable sessionless MCP connections for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureSessionlessMcpUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureSessionlessMcpUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/sessionless-mcp`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureSessionlessMcpUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureSessionlessMcpUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_skill-sync.ts
var MetorialDashboardProjectsConfigureSkillSyncEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project skill sync configuration
   * @description Get the skill sync settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureSkillSyncGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/skill-sync`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureSkillSyncGetOutput
    );
  }
  /**
   * @name Update project skill sync configuration
   * @description Update the skill sync settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureSkillSyncUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureSkillSyncUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/skill-sync`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureSkillSyncUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureSkillSyncUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_tool-calling.ts
var MetorialDashboardProjectsConfigureToolCallingEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project tool calling configuration
   * @description Get tool calling settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureToolCallingGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/tool-calling`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureToolCallingGetOutput
    );
  }
  /**
   * @name Update project tool calling configuration
   * @description Update tool calling settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureToolCallingUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureToolCallingUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/tool-calling`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureToolCallingUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureToolCallingUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_configure_workforce.ts
var MetorialDashboardProjectsConfigureWorkforceEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project workforce configuration
   * @description Get workforce settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureWorkforceGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/workforce`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsConfigureWorkforceGetOutput
    );
  }
  /**
   * @name Update project workforce configuration
   * @description Update workforce settings for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsConfigureWorkforceUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsConfigureWorkforceUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/configure/workforce`;
    let request = {
      path,
      body: mapDashboardProjectsConfigureWorkforceUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardProjectsConfigureWorkforceUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_key-providers.ts
var MetorialDashboardProjectsKeyProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List key providers
   * @description Returns a paginated list of key providers for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `query` - DashboardProjectsKeyProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, projectId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers`;
    let request = {
      path,
      query: query ? mapDashboardProjectsKeyProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsKeyProvidersListOutput
    );
  }
  /**
   * @name Create managed key provider
   * @description Creates a Metorial-managed key provider for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsKeyProvidersCreateManagedBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersCreateManagedOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createManaged(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers`;
    let request = {
      path,
      body: mapDashboardProjectsKeyProvidersCreateManagedBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardProjectsKeyProvidersCreateManagedOutput
    );
  }
  /**
   * @name Import key provider
   * @description Imports a customer-managed key provider for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `body` - DashboardProjectsKeyProvidersImportBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersImportOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  import(organizationId, projectId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers/import`;
    let request = {
      path,
      body: mapDashboardProjectsKeyProvidersImportBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardProjectsKeyProvidersImportOutput
    );
  }
  /**
   * @name Get key provider
   * @description Retrieves a key provider for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `keyProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, projectId, keyProviderId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers/${keyProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsKeyProvidersGetOutput
    );
  }
  /**
   * @name Get key provider setup info
   * @description Returns setup instructions for importing a key provider
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `keyProviderId` - string
   * @param `query` - DashboardProjectsKeyProvidersGetSetupInfoQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersGetSetupInfoOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getSetupInfo(organizationId, projectId, keyProviderId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers/${keyProviderId}/setup-info`;
    let request = {
      path,
      query: query ? mapDashboardProjectsKeyProvidersGetSetupInfoQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsKeyProvidersGetSetupInfoOutput
    );
  }
  /**
   * @name Validate key provider
   * @description Validates that a key provider is reachable and configured correctly
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `keyProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersValidateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  validate(organizationId, projectId, keyProviderId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers/${keyProviderId}/validate`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardProjectsKeyProvidersValidateOutput
    );
  }
  /**
   * @name Set default key provider
   * @description Sets the default key provider for a project
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `keyProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersSetDefaultOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  setDefault(organizationId, projectId, keyProviderId, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers/${keyProviderId}/set-default`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardProjectsKeyProvidersSetDefaultOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_projects_key-providers_errors.ts
var MetorialDashboardProjectsKeyProvidersErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List key provider errors
   * @description Returns aggregated key provider errors for diagnostics
   *
   * @param `organizationId` - string
   * @param `projectId` - string
   * @param `keyProviderId` - string
   * @param `query` - DashboardProjectsKeyProvidersErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardProjectsKeyProvidersErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(organizationId, projectId, keyProviderId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/projects/${projectId}/key-providers/${keyProviderId}/errors`;
    let request = {
      path,
      query: query ? mapDashboardProjectsKeyProvidersErrorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardProjectsKeyProvidersErrorsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/dashboard_usage.ts
var MetorialDashboardUsageEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get organization
   * @description Get the current organization information
   *
   * @param `organizationId` - string
   * @param `query` - DashboardUsageTimelineQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardUsageTimelineOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  timeline(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/usage/timeline`;
    let request = {
      path,
      query: query ? mapDashboardUsageTimelineQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardUsageTimelineOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/documents.ts
var MetorialDocumentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List documents
   * @description Returns a paginated list of documents owned by the instance.
   *
   * @param `query` - DashboardInstanceDocumentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "documents";
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsListOutput
    );
  }
  /**
   * @name Create document
   * @description Creates a new document for the instance.
   *
   * @param `body` - DashboardInstanceDocumentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "documents";
    let request = {
      path,
      body: mapDashboardInstanceDocumentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceDocumentsCreateOutput
    );
  }
  /**
   * @name Get document by ID
   * @description Retrieves a document by its ID.
   *
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(documentId, opts) {
    let path = `documents/${documentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceDocumentsGetOutput);
  }
  /**
   * @name Update document by ID
   * @description Updates a specific document.
   *
   * @param `documentId` - string
   * @param `body` - DashboardInstanceDocumentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(documentId, body, opts) {
    let path = `documents/${documentId}`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceDocumentsUpdateOutput
    );
  }
  /**
   * @name Delete document by ID
   * @description Deletes a specific document.
   *
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(documentId, opts) {
    let path = `documents/${documentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceDocumentsDeleteOutput
    );
  }
  /**
   * @name Clone document by ID
   * @description Clones a specific document.
   *
   * @param `documentId` - string
   * @param `body` - DashboardInstanceDocumentsCloneBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsCloneOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  clone(documentId, body, opts) {
    let path = `documents/${documentId}/clone`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsCloneBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceDocumentsCloneOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/documents_edit-token.ts
var MetorialDocumentsEditTokenEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get document edit token
   * @description Returns a short-lived read or write token for establishing a live document session.
   *
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsEditTokenGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(documentId, opts) {
    let path = `documents/${documentId}/edit-token`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsEditTokenGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/documents_participants.ts
var MetorialDocumentsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List document participants
   * @description Returns a paginated list of participants for a specific document.
   *
   * @param `documentId` - string
   * @param `query` - DashboardInstanceDocumentsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(documentId, query, opts) {
    let path = `documents/${documentId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsParticipantsListOutput
    );
  }
  /**
   * @name Get document participant by ID
   * @description Retrieves a specific document participant by its ID.
   *
   * @param `documentId` - string
   * @param `documentParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(documentId, documentParticipantId, opts) {
    let path = `documents/${documentId}/participants/${documentParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/documents_permissions.ts
var MetorialDocumentsPermissionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get document permissions
   * @description Returns the effective Cargo permissions for the current actor on a specific document.
   *
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsPermissionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(documentId, opts) {
    let path = `documents/${documentId}/permissions`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsPermissionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/documents_versions.ts
var MetorialDocumentsVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List document versions
   * @description Returns a paginated list of versions for a specific document.
   *
   * @param `documentId` - string
   * @param `query` - DashboardInstanceDocumentsVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(documentId, query, opts) {
    let path = `documents/${documentId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsVersionsListOutput
    );
  }
  /**
   * @name Get document version by ID
   * @description Retrieves a specific document version by its ID.
   *
   * @param `documentId` - string
   * @param `documentVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(documentId, documentVersionId, opts) {
    let path = `documents/${documentId}/versions/${documentVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/files.ts
var MetorialFilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List instance files
   * @description Returns a paginated list of files owned by the instance.
   *
   * @param `query` - DashboardInstanceFilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "files";
    let request = {
      path,
      query: query ? mapDashboardInstanceFilesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFilesListOutput);
  }
  /**
   * @name Get file by ID
   * @description Retrieves details for a specific file by its ID.
   *
   * @param `fileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(fileId, opts) {
    let path = `files/${fileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFilesGetOutput);
  }
  /**
   * @name Delete file by ID
   * @description Deletes a specific file by its ID.
   *
   * @param `fileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(fileId, opts) {
    let path = `files/${fileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFilesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/files_links.ts
var MetorialFilesLinksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List file links
   * @description Returns a paginated list of file links owned by the instance organization.
   *
   * @param `query` - DashboardInstanceFilesLinksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "file-links";
    let request = {
      path,
      query: query ? mapDashboardInstanceFilesLinksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFilesLinksListOutput
    );
  }
  /**
   * @name Get file link by ID
   * @description Retrieves the details of a specific file link by its ID.
   *
   * @param `linkId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(linkId, opts) {
    let path = `file-links/${linkId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFilesLinksGetOutput
    );
  }
  /**
   * @name Create file link
   * @description Creates a new link for a specific file.
   *
   * @param `body` - DashboardInstanceFilesLinksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "file-links";
    let request = {
      path,
      body: mapDashboardInstanceFilesLinksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFilesLinksCreateOutput
    );
  }
  /**
   * @name Delete file link by ID
   * @description Deletes a specific file link by its ID.
   *
   * @param `linkId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(linkId, opts) {
    let path = `file-links/${linkId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFilesLinksDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/firewalls.ts
var MetorialFirewallsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List firewalls
   * @description Returns a paginated list of firewalls.
   *
   * @param `query` - DashboardInstanceFirewallsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "firewalls";
    let request = {
      path,
      query: query ? mapDashboardInstanceFirewallsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFirewallsListOutput
    );
  }
  /**
   * @name Get firewall
   * @description Retrieves a specific firewall by ID.
   *
   * @param `firewallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(firewallId, opts) {
    let path = `firewalls/${firewallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFirewallsGetOutput);
  }
  /**
   * @name Create firewall
   * @description Creates a new firewall.
   *
   * @param `body` - DashboardInstanceFirewallsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "firewalls";
    let request = {
      path,
      body: mapDashboardInstanceFirewallsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFirewallsCreateOutput
    );
  }
  /**
   * @name Update firewall
   * @description Updates a firewall definition.
   *
   * @param `firewallId` - string
   * @param `body` - DashboardInstanceFirewallsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(firewallId, body, opts) {
    let path = `firewalls/${firewallId}`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceFirewallsUpdateOutput
    );
  }
  /**
   * @name Delete firewall
   * @description Archives a firewall.
   *
   * @param `firewallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(firewallId, opts) {
    let path = `firewalls/${firewallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFirewallsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/firewalls_network-policies.ts
var MetorialFirewallsNetworkPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Attach network policy
   * @description Attaches a network policy to a firewall.
   *
   * @param `firewallId` - string
   * @param `body` - DashboardInstanceFirewallsNetworkPoliciesAttachBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsNetworkPoliciesAttachOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  attach(firewallId, body, opts) {
    let path = `firewalls/${firewallId}/network-policies`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsNetworkPoliciesAttachBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFirewallsNetworkPoliciesAttachOutput
    );
  }
  /**
   * @name Detach network policy
   * @description Detaches a network policy from a firewall.
   *
   * @param `firewallId` - string
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsNetworkPoliciesDetachOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  detach(firewallId, networkPolicyId, opts) {
    let path = `firewalls/${firewallId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFirewallsNetworkPoliciesDetachOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/identities.ts
var MetorialIdentitiesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identities
   * @description Returns a paginated list of identities for the instance.
   *
   * @param `query` - DashboardInstanceIdentitiesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "identities";
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesListOutput
    );
  }
  /**
   * @name Get identity
   * @description Retrieves a specific identity by ID.
   *
   * @param `identityId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(identityId, opts) {
    let path = `identities/${identityId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesGetOutput
    );
  }
  /**
   * @name Create identity
   * @description Creates a new identity owned by an existing identity actor.
   *
   * @param `body` - DashboardInstanceIdentitiesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "identities";
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesCreateOutput
    );
  }
  /**
   * @name Update identity
   * @description Updates mutable fields on an existing identity.
   *
   * @param `identityId` - string
   * @param `body` - DashboardInstanceIdentitiesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(identityId, body, opts) {
    let path = `identities/${identityId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesUpdateOutput
    );
  }
  /**
   * @name Delete identity
   * @description Archives an identity.
   *
   * @param `identityId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(identityId, opts) {
    let path = `identities/${identityId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/identities_credentials.ts
var MetorialIdentitiesCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity credentials
   * @description Returns a paginated list of identity credentials for the instance.
   *
   * @param `query` - DashboardInstanceIdentitiesCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "identity-credentials";
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesCredentialsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesCredentialsListOutput
    );
  }
  /**
   * @name Get identity credential
   * @description Retrieves a specific identity credential by ID.
   *
   * @param `identityCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(identityCredentialId, opts) {
    let path = `identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesCredentialsGetOutput
    );
  }
  /**
   * @name Create identity credential
   * @description Creates a new credential and attaches it to an identity.
   *
   * @param `body` - DashboardInstanceIdentitiesCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "identity-credentials";
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesCredentialsCreateOutput
    );
  }
  /**
   * @name Update identity credential
   * @description Updates the delegation config attached to an identity credential.
   *
   * @param `identityCredentialId` - string
   * @param `body` - DashboardInstanceIdentitiesCredentialsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(identityCredentialId, body, opts) {
    let path = `identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCredentialsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesCredentialsUpdateOutput
    );
  }
  /**
   * @name Delete identity credential
   * @description Archives an identity credential.
   *
   * @param `identityCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(identityCredentialId, opts) {
    let path = `identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/identities_delegation-configs.ts
var MetorialIdentitiesDelegationConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegation configs
   * @description Returns a paginated list of identity delegation configs.
   *
   * @param `query` - DashboardInstanceIdentitiesDelegationConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "identity-delegation-configs";
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsListOutput
    );
  }
  /**
   * @name Get identity delegation config
   * @description Retrieves a specific identity delegation config by ID.
   *
   * @param `identityDelegationConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(identityDelegationConfigId, opts) {
    let path = `identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsGetOutput
    );
  }
  /**
   * @name Create identity delegation config
   * @description Creates a new identity delegation config.
   *
   * @param `body` - DashboardInstanceIdentitiesDelegationConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "identity-delegation-configs";
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsCreateOutput
    );
  }
  /**
   * @name Update identity delegation config
   * @description Updates mutable fields on an existing identity delegation config.
   *
   * @param `identityDelegationConfigId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(identityDelegationConfigId, body, opts) {
    let path = `identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsUpdateOutput
    );
  }
  /**
   * @name Delete identity delegation config
   * @description Archives an identity delegation config.
   *
   * @param `identityDelegationConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(identityDelegationConfigId, opts) {
    let path = `identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/identities_delegation-requests.ts
var MetorialIdentitiesDelegationRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegation requests
   * @description Returns a paginated list of identity delegation requests.
   *
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "identity-delegation-requests";
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsListOutput
    );
  }
  /**
   * @name Get identity delegation request
   * @description Retrieves a specific identity delegation request by ID.
   *
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(identityDelegationRequestId, query, opts) {
    let path = `identity-delegation-requests/${identityDelegationRequestId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsGetQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsGetOutput
    );
  }
  /**
   * @name Create identity delegation request
   * @description Creates a new identity delegation request.
   *
   * @param `body` - DashboardInstanceIdentitiesDelegationRequestsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "identity-delegation-requests";
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationRequestsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsCreateOutput
    );
  }
  /**
   * @name Approve identity delegation request
   * @description Approves an existing identity delegation request.
   *
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsApproveQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsApproveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  approve(identityDelegationRequestId, query, opts) {
    let path = `identity-delegation-requests/${identityDelegationRequestId}/approve`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsApproveQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsApproveOutput
    );
  }
  /**
   * @name Deny identity delegation request
   * @description Denies an existing identity delegation request.
   *
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsDenyQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsDenyOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  deny(identityDelegationRequestId, query, opts) {
    let path = `identity-delegation-requests/${identityDelegationRequestId}/deny`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsDenyQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsDenyOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/identities_delegations.ts
var MetorialIdentitiesDelegationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegations
   * @description Returns a paginated list of identity delegations for the instance.
   *
   * @param `query` - DashboardInstanceIdentitiesDelegationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "identity-delegations";
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationsListOutput
    );
  }
  /**
   * @name Get identity delegation
   * @description Retrieves a specific identity delegation by ID.
   *
   * @param `identityDelegationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(identityDelegationId, opts) {
    let path = `identity-delegations/${identityDelegationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationsGetOutput
    );
  }
  /**
   * @name Create identity delegation
   * @description Creates a new identity delegation.
   *
   * @param `body` - DashboardInstanceIdentitiesDelegationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "identity-delegations";
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationsCreateOutput
    );
  }
  /**
   * @name Revoke identity delegation
   * @description Revokes an existing identity delegation.
   *
   * @param `identityDelegationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(identityDelegationId, opts) {
    let path = `identity-delegations/${identityDelegationId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/identity-actors.ts
var MetorialIdentityActorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity actors
   * @description Returns a paginated list of identity actors for the instance.
   *
   * @param `query` - DashboardInstanceIdentityActorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "identity-actors";
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentityActorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentityActorsListOutput
    );
  }
  /**
   * @name Get identity actor
   * @description Retrieves a specific identity actor by ID.
   *
   * @param `identityActorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(identityActorId, opts) {
    let path = `identity-actors/${identityActorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentityActorsGetOutput
    );
  }
  /**
   * @name Create identity actor
   * @description Creates a new identity actor.
   *
   * @param `body` - DashboardInstanceIdentityActorsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "identity-actors";
    let request = {
      path,
      body: mapDashboardInstanceIdentityActorsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentityActorsCreateOutput
    );
  }
  /**
   * @name Update identity actor
   * @description Updates mutable fields on an existing identity actor.
   *
   * @param `identityActorId` - string
   * @param `body` - DashboardInstanceIdentityActorsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(identityActorId, body, opts) {
    let path = `identity-actors/${identityActorId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentityActorsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentityActorsUpdateOutput
    );
  }
  /**
   * @name Delete identity actor
   * @description Archives an identity actor.
   *
   * @param `identityActorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(identityActorId, opts) {
    let path = `identity-actors/${identityActorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentityActorsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/incoming-webhooks.ts
var MetorialIncomingWebhooksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List incoming webhooks
   * @description Returns a paginated list of incoming webhooks you can see.
   *
   * @param `query` - DashboardInstanceIncomingWebhooksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIncomingWebhooksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "incoming-webhooks";
    let request = {
      path,
      query: query ? mapDashboardInstanceIncomingWebhooksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIncomingWebhooksListOutput
    );
  }
  /**
   * @name Get incoming webhook
   * @description Retrieves a specific incoming webhook.
   *
   * @param `incomingWebhookId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIncomingWebhooksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(incomingWebhookId, opts) {
    let path = `incoming-webhooks/${incomingWebhookId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIncomingWebhooksGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integration-enclaves.ts
var MetorialIntegrationEnclavesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration enclaves
   * @description Returns a paginated list of integration enclaves.
   *
   * @param `query` - DashboardInstanceIntegrationEnclavesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationEnclavesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-enclaves";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationEnclavesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationEnclavesListOutput
    );
  }
  /**
   * @name Get integration enclave
   * @description Retrieves a specific integration enclave by ID.
   *
   * @param `integrationEnclaveId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationEnclavesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationEnclaveId, opts) {
    let path = `integration-enclaves/${integrationEnclaveId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationEnclavesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integration-firewall-assignments.ts
var MetorialIntegrationFirewallAssignmentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration firewall assignments
   * @description Returns a paginated list of integration firewall assignments.
   *
   * @param `query` - DashboardInstanceIntegrationFirewallAssignmentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-firewall-assignments";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationFirewallAssignmentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsListOutput
    );
  }
  /**
   * @name Get integration firewall assignment
   * @description Retrieves a specific integration firewall assignment by ID.
   *
   * @param `integrationFirewallAssignmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationFirewallAssignmentId, opts) {
    let path = `integration-firewall-assignments/${integrationFirewallAssignmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsGetOutput
    );
  }
  /**
   * @name Create integration firewall assignment
   * @description Creates an assignment that applies a firewall to a target.
   *
   * @param `body` - DashboardInstanceIntegrationFirewallAssignmentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "integration-firewall-assignments";
    let request = {
      path,
      body: mapDashboardInstanceIntegrationFirewallAssignmentsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsCreateOutput
    );
  }
  /**
   * @name Delete integration firewall assignment
   * @description Deletes an integration firewall assignment.
   *
   * @param `integrationFirewallAssignmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(integrationFirewallAssignmentId, opts) {
    let path = `integration-firewall-assignments/${integrationFirewallAssignmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integration-internet-gateway.ts
var MetorialIntegrationInternetGatewayEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get integration internet gateway
   * @description Retrieves the integration internet gateway of the instance, including its public IPs.
   *
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationInternetGatewayGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(opts) {
    let path = "integration-internet-gateway";
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationInternetGatewayGetOutput
    );
  }
  /**
   * @name List integration internet gateway network logs
   * @description Returns ingress or egress network logs for integration enclaves in the instance environment.
   *
   * @param `query` - DashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  listNetworkLogs(query, opts) {
    let path = "integration-internet-gateway/network-logs";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integrations.ts
var MetorialIntegrationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integrations
   * @description Returns a paginated list of integrations.
   *
   * @param `query` - DashboardInstanceIntegrationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integrations";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsListOutput
    );
  }
  /**
   * @name Get integration
   * @description Retrieves a specific integration.
   *
   * @param `integrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationId, opts) {
    let path = `integrations/${integrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsGetOutput
    );
  }
  /**
   * @name Create integration
   * @description Creates a new integration.
   *
   * @param `body` - DashboardInstanceIntegrationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "integrations";
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsCreateOutput
    );
  }
  /**
   * @name Update integration
   * @description Updates a specific integration.
   *
   * @param `integrationId` - string
   * @param `body` - DashboardInstanceIntegrationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(integrationId, body, opts) {
    let path = `integrations/${integrationId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsUpdateOutput
    );
  }
  /**
   * @name Delete integration
   * @description Archives a specific integration.
   *
   * @param `integrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(integrationId, opts) {
    let path = `integrations/${integrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integrations_instance-groups.ts
var MetorialIntegrationsInstanceGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance groups
   * @description Returns a paginated list of integration instance groups.
   *
   * @param `query` - DashboardInstanceIntegrationsInstanceGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-instance-groups";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstanceGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsListOutput
    );
  }
  /**
   * @name Get integration instance group
   * @description Retrieves a specific integration instance group.
   *
   * @param `integrationInstanceGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationInstanceGroupId, opts) {
    let path = `integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsGetOutput
    );
  }
  /**
   * @name Create integration instance group session template
   * @description Creates or updates the shared session template for a specific integration instance group.
   *
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSessionTemplate(integrationInstanceGroupId, body, opts) {
    let path = `integration-instance-groups/${integrationInstanceGroupId}/session-template`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput
    );
  }
  /**
   * @name Create integration instance group session
   * @description Creates a session from the shared session template of a specific integration instance group.
   *
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateSessionBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSession(integrationInstanceGroupId, body, opts) {
    let path = `integration-instance-groups/${integrationInstanceGroupId}/session`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput
    );
  }
  /**
   * @name Create integration instance group
   * @description Creates a new integration instance group.
   *
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "integration-instance-groups";
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateOutput
    );
  }
  /**
   * @name Update integration instance group
   * @description Updates a specific integration instance group.
   *
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(integrationInstanceGroupId, body, opts) {
    let path = `integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsUpdateOutput
    );
  }
  /**
   * @name Delete integration instance group
   * @description Archives a specific integration instance group.
   *
   * @param `integrationInstanceGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(integrationInstanceGroupId, opts) {
    let path = `integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integrations_instance-groups_providers.ts
var MetorialIntegrationsInstanceGroupsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance group providers
   * @description Returns a paginated list of integration instance group providers.
   *
   * @param `query` - DashboardInstanceIntegrationsInstanceGroupsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-instance-group-providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstanceGroupsProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersListOutput
    );
  }
  /**
   * @name Get integration instance group provider
   * @description Retrieves a specific integration instance group provider.
   *
   * @param `integrationInstanceGroupProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationInstanceGroupProviderId, opts) {
    let path = `integration-instance-group-providers/${integrationInstanceGroupProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput
    );
  }
  /**
   * @name Set integration instance group provider
   * @description Creates or updates the effective integration instance group provider materialization.
   *
   * @param `integrationInstanceGroupId` - string
   * @param `integrationInstanceProviderId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsProvidersSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(integrationInstanceGroupId, integrationInstanceProviderId, body, opts) {
    let path = `integration-instance-groups/${integrationInstanceGroupId}/providers/${integrationInstanceProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput
    );
  }
  /**
   * @name Delete integration instance group provider
   * @description Archives a specific integration instance group provider.
   *
   * @param `integrationInstanceGroupProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(integrationInstanceGroupProviderId, opts) {
    let path = `integration-instance-group-providers/${integrationInstanceGroupProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integrations_instances.ts
var MetorialIntegrationsInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instances
   * @description Returns a paginated list of integration instances.
   *
   * @param `query` - DashboardInstanceIntegrationsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-instances";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesListOutput
    );
  }
  /**
   * @name Get integration instance
   * @description Retrieves a specific integration instance.
   *
   * @param `integrationInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationInstanceId, opts) {
    let path = `integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesGetOutput
    );
  }
  /**
   * @name Create integration instance session template
   * @description Creates or updates the shared session template for a specific integration instance.
   *
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateSessionTemplateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSessionTemplate(integrationInstanceId, body, opts) {
    let path = `integration-instances/${integrationInstanceId}/session-template`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput
    );
  }
  /**
   * @name Create integration instance session
   * @description Creates a session from the shared session template of a specific integration instance.
   *
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateSessionBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateSessionOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSession(integrationInstanceId, body, opts) {
    let path = `integration-instances/${integrationInstanceId}/session`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateSessionBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateSessionOutput
    );
  }
  /**
   * @name Create integration instance
   * @description Creates a new integration instance.
   *
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "integration-instances";
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateOutput
    );
  }
  /**
   * @name Update integration instance
   * @description Updates a specific integration instance.
   *
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(integrationInstanceId, body, opts) {
    let path = `integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsInstancesUpdateOutput
    );
  }
  /**
   * @name Delete integration instance
   * @description Archives a specific integration instance.
   *
   * @param `integrationInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(integrationInstanceId, opts) {
    let path = `integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstancesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integrations_instances_providers.ts
var MetorialIntegrationsInstancesProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance providers
   * @description Returns a paginated list of integration instance providers.
   *
   * @param `query` - DashboardInstanceIntegrationsInstancesProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-instance-providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstancesProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersListOutput
    );
  }
  /**
   * @name Get integration instance provider
   * @description Retrieves a specific integration instance provider.
   *
   * @param `integrationInstanceProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationInstanceProviderId, opts) {
    let path = `integration-instance-providers/${integrationInstanceProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersGetOutput
    );
  }
  /**
   * @name Set integration instance provider
   * @description Creates or updates the effective integration instance provider materialization.
   *
   * @param `integrationInstanceId` - string
   * @param `providerId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesProvidersSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(integrationInstanceId, providerId, body, opts) {
    let path = `integration-instances/${integrationInstanceId}/providers/${providerId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesProvidersSetBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersSetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integrations_providers.ts
var MetorialIntegrationsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration providers
   * @description Returns a paginated list of integration providers.
   *
   * @param `query` - DashboardInstanceIntegrationsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsProvidersListOutput
    );
  }
  /**
   * @name Get integration provider
   * @description Retrieves a specific integration provider.
   *
   * @param `integrationProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationProviderId, opts) {
    let path = `integration-providers/${integrationProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsProvidersGetOutput
    );
  }
  /**
   * @name Create integration provider
   * @description Creates a new integration provider.
   *
   * @param `body` - DashboardInstanceIntegrationsProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "integration-providers";
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsProvidersCreateOutput
    );
  }
  /**
   * @name Update integration provider
   * @description Updates a specific integration provider.
   *
   * @param `integrationProviderId` - string
   * @param `body` - DashboardInstanceIntegrationsProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(integrationProviderId, body, opts) {
    let path = `integration-providers/${integrationProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsProvidersUpdateOutput
    );
  }
  /**
   * @name Delete integration provider
   * @description Archives a specific integration provider.
   *
   * @param `integrationProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(integrationProviderId, opts) {
    let path = `integration-providers/${integrationProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/integrations_setup-sessions.ts
var MetorialIntegrationsSetupSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration setup sessions
   * @description Returns a paginated list of integration setup sessions.
   *
   * @param `query` - DashboardInstanceIntegrationsSetupSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "integration-setup-sessions";
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsSetupSessionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsListOutput
    );
  }
  /**
   * @name Get integration setup session
   * @description Retrieves a specific integration setup session.
   *
   * @param `integrationSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(integrationSetupSessionId, opts) {
    let path = `integration-setup-sessions/${integrationSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsGetOutput
    );
  }
  /**
   * @name Create integration setup session
   * @description Creates a new integration setup session. Creates a draft integration instance unless integration_instance_id is given, in which case that instance is reused and its config and auth config are overwritten on completion.
   *
   * @param `body` - DashboardInstanceIntegrationsSetupSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "integration-setup-sessions";
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsSetupSessionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/magic-mcp-endpoints.ts
var MetorialMagicMcpEndpointsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP endpoints
   * @description Returns a paginated list of magic MCP endpoints.
   *
   * @param `query` - DashboardInstanceMagicMcpEndpointsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "magic-mcp-endpoints";
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpEndpointsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpEndpointsListOutput
    );
  }
  /**
   * @name Get magic MCP endpoint
   * @description Retrieves a specific magic MCP endpoint.
   *
   * @param `magicMcpEndpointId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(magicMcpEndpointId, opts) {
    let path = `magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpEndpointsGetOutput
    );
  }
  /**
   * @name Create magic MCP endpoint
   * @description Creates a magic MCP endpoint.
   *
   * @param `body` - DashboardInstanceMagicMcpEndpointsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "magic-mcp-endpoints";
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsCreateOutput
    );
  }
  /**
   * @name Delete magic MCP endpoint
   * @description Archives a magic MCP endpoint.
   *
   * @param `magicMcpEndpointId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(magicMcpEndpointId, opts) {
    let path = `magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpEndpointsDeleteOutput
    );
  }
  /**
   * @name Update magic MCP endpoint
   * @description Updates a magic MCP endpoint.
   *
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(magicMcpEndpointId, body, opts) {
    let path = `magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpEndpointsUpdateOutput
    );
  }
  /**
   * @name Add servers to magic MCP endpoint
   * @description Adds magic MCP servers to a magic MCP endpoint.
   *
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsAddServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsAddServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addServers(magicMcpEndpointId, body, opts) {
    let path = `magic-mcp-endpoints/${magicMcpEndpointId}/add-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsAddServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsAddServersOutput
    );
  }
  /**
   * @name Remove servers from magic MCP endpoint
   * @description Removes magic MCP servers from a magic MCP endpoint.
   *
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsRemoveServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsRemoveServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeServers(magicMcpEndpointId, body, opts) {
    let path = `magic-mcp-endpoints/${magicMcpEndpointId}/remove-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsRemoveServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsRemoveServersOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/magic-mcp-groups.ts
var MetorialMagicMcpGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP groups
   * @description Returns a paginated list of magic MCP groups.
   *
   * @param `query` - DashboardInstanceMagicMcpGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "magic-mcp-groups";
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpGroupsListOutput
    );
  }
  /**
   * @name Get magic MCP group
   * @description Retrieves a specific magic MCP group.
   *
   * @param `magicMcpGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(magicMcpGroupId, opts) {
    let path = `magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpGroupsGetOutput
    );
  }
  /**
   * @name Create magic MCP group
   * @description Creates a magic MCP group.
   *
   * @param `body` - DashboardInstanceMagicMcpGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "magic-mcp-groups";
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsCreateOutput
    );
  }
  /**
   * @name Delete magic MCP group
   * @description Deletes a magic MCP group.
   *
   * @param `magicMcpGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(magicMcpGroupId, opts) {
    let path = `magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpGroupsDeleteOutput
    );
  }
  /**
   * @name Update magic MCP group
   * @description Updates a magic MCP group.
   *
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(magicMcpGroupId, body, opts) {
    let path = `magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpGroupsUpdateOutput
    );
  }
  /**
   * @name Add servers to magic MCP group
   * @description Adds magic MCP servers to a group.
   *
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsAddServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsAddServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addServers(magicMcpGroupId, body, opts) {
    let path = `magic-mcp-groups/${magicMcpGroupId}/add-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsAddServersBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsAddServersOutput
    );
  }
  /**
   * @name Remove servers from magic MCP group
   * @description Removes magic MCP servers from a group.
   *
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsRemoveServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsRemoveServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeServers(magicMcpGroupId, body, opts) {
    let path = `magic-mcp-groups/${magicMcpGroupId}/remove-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsRemoveServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsRemoveServersOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/magic-mcp-servers.ts
var MetorialMagicMcpServersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP servers
   * @description Returns a paginated list of magic MCP servers.
   *
   * @param `query` - DashboardInstanceMagicMcpServersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "magic-mcp-servers";
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpServersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersListOutput
    );
  }
  /**
   * @name Get magic MCP server
   * @description Retrieves a specific magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(magicMcpServerId, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersGetOutput
    );
  }
  /**
   * @name List magic MCP server tools
   * @description Returns the effective set of tools available through the providers backing a magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersToolsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  tools(magicMcpServerId, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}/tools`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersToolsOutput
    );
  }
  /**
   * @name Create magic MCP server
   * @description Creates a magic MCP server with a new session template. A Subspace session is created automatically on first connection and then reused.
   *
   * @param `body` - DashboardInstanceMagicMcpServersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "magic-mcp-servers";
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersCreateOutput
    );
  }
  /**
   * @name Delete magic MCP server
   * @description Archives a magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(magicMcpServerId, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpServersDeleteOutput
    );
  }
  /**
   * @name Update magic MCP server
   * @description Updates a magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `body` - DashboardInstanceMagicMcpServersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(magicMcpServerId, body, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpServersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/magic-mcp-servers_providers.ts
var MetorialMagicMcpServersProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP server providers
   * @description Returns the backing integration instance providers configured for a magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `query` - DashboardInstanceMagicMcpServersProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(magicMcpServerId, query, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}/providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpServersProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersListOutput
    );
  }
  /**
   * @name Create magic MCP server provider
   * @description Creates a configurable provider row for a magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `body` - DashboardInstanceMagicMcpServersProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(magicMcpServerId, body, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}/providers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersCreateOutput
    );
  }
  /**
   * @name Get magic MCP server provider
   * @description Retrieves a specific backing integration instance provider for a magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(magicMcpServerId, magicMcpServerProviderId, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersGetOutput
    );
  }
  /**
   * @name Update magic MCP server provider
   * @description Updates a backing integration provider and then sets the corresponding integration instance provider for a magic MCP server.
   *
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `body` - DashboardInstanceMagicMcpServersProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(magicMcpServerId, magicMcpServerProviderId, body, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersUpdateOutput
    );
  }
  /**
   * @name Delete magic MCP server provider
   * @description Archives a backing integration instance provider from a magic MCP server and removes the shared integration provider when unused.
   *
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(magicMcpServerId, magicMcpServerProviderId, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/magic-mcp-servers_session.ts
var MetorialMagicMcpServersSessionEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create linked magic MCP server session
   * @description Resolves the current internal ephemeral managed session for a magic MCP server and returns it as a dashboard session.
   *
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersSessionCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(magicMcpServerId, opts) {
    let path = `magic-mcp-servers/${magicMcpServerId}/session`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersSessionCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/magic-mcp-sessions.ts
var MetorialMagicMcpSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP sessions
   * @description Returns a paginated list of magic MCP sessions.
   *
   * @param `query` - DashboardInstanceMagicMcpSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "magic-mcp-sessions";
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpSessionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpSessionsListOutput
    );
  }
  /**
   * @name Get magic MCP session
   * @description Retrieves a specific magic MCP session.
   *
   * @param `magicMcpSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(magicMcpSessionId, opts) {
    let path = `magic-mcp-sessions/${magicMcpSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpSessionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/magic-mcp-tokens.ts
var MetorialMagicMcpTokensEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP tokens
   * @description Returns a paginated list of magic MCP tokens.
   *
   * @param `query` - DashboardInstanceMagicMcpTokensListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "magic-mcp-tokens";
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpTokensListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpTokensListOutput
    );
  }
  /**
   * @name Get magic MCP token
   * @description Retrieves a specific magic MCP token.
   *
   * @param `magicMcpTokenId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(magicMcpTokenId, opts) {
    let path = `magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpTokensGetOutput
    );
  }
  /**
   * @name Create magic MCP token
   * @description Creates a new magic MCP token.
   *
   * @param `body` - DashboardInstanceMagicMcpTokensCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "magic-mcp-tokens";
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensCreateOutput
    );
  }
  /**
   * @name Delete magic MCP token
   * @description Deletes a magic MCP token.
   *
   * @param `magicMcpTokenId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(magicMcpTokenId, opts) {
    let path = `magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpTokensDeleteOutput
    );
  }
  /**
   * @name Update magic MCP token
   * @description Updates a magic MCP token.
   *
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(magicMcpTokenId, body, opts) {
    let path = `magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpTokensUpdateOutput
    );
  }
  /**
   * @name Add magic MCP groups to token
   * @description Adds groups to a magic MCP token.
   *
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensAddGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensAddGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addGroups(magicMcpTokenId, body, opts) {
    let path = `magic-mcp-tokens/${magicMcpTokenId}/add-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensAddGroupsBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensAddGroupsOutput
    );
  }
  /**
   * @name Remove magic MCP groups from token
   * @description Removes groups from a magic MCP token.
   *
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensRemoveGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensRemoveGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeGroups(magicMcpTokenId, body, opts) {
    let path = `magic-mcp-tokens/${magicMcpTokenId}/remove-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensRemoveGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensRemoveGroupsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_agents.ts
var MetorialManagementInstanceAgentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List agents
   * @description Returns a paginated list of agents for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceAgentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/agents`;
    let request = {
      path,
      query: query ? mapDashboardInstanceAgentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceAgentsListOutput);
  }
  /**
   * @name Get agent
   * @description Retrieves a specific agent by ID.
   *
   * @param `instanceId` - string
   * @param `agentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, agentId, opts) {
    let path = `instances/${instanceId}/agents/${agentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceAgentsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_agents_instances.ts
var MetorialManagementInstanceAgentsInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List agent instances
   * @description Returns a paginated list of instances for an agent.
   *
   * @param `instanceId` - string
   * @param `agentId` - string
   * @param `query` - DashboardInstanceAgentsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, agentId, query, opts) {
    let path = `instances/${instanceId}/agents/${agentId}/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceAgentsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAgentsInstancesListOutput
    );
  }
  /**
   * @name Get agent instance
   * @description Retrieves a specific agent instance by ID.
   *
   * @param `instanceId` - string
   * @param `agentId` - string
   * @param `agentInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAgentsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, agentId, agentInstanceId, opts) {
    let path = `instances/${instanceId}/agents/${agentId}/instances/${agentInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAgentsInstancesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_assistants.ts
var MetorialManagementInstanceAssistantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistants
   * @description List assistants available in an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceAssistantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAssistantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/assistants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceAssistantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAssistantsListOutput
    );
  }
  /**
   * @name Get assistant
   * @description Get an assistant available in an instance.
   *
   * @param `instanceId` - string
   * @param `assistantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceAssistantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, assistantId, opts) {
    let path = `instances/${instanceId}/assistants/${assistantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceAssistantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_callback-events.ts
var MetorialManagementInstanceCallbackEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callback events
   * @description Returns a paginated list of callback events.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCallbackEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/callback-events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbackEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackEventsListOutput
    );
  }
  /**
   * @name Get callback event
   * @description Retrieves a specific callback event by ID, enriched with the payload the provider produced for it and, if it came from a webhook, the inbound request behind it.
   *
   * @param `instanceId` - string
   * @param `callbackEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, callbackEventId, opts) {
    let path = `instances/${instanceId}/callback-events/${callbackEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_callback-instances.ts
var MetorialManagementInstanceCallbackInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callback instances
   * @description Returns a paginated list of callback instances.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCallbackInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/callback-instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbackInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackInstancesListOutput
    );
  }
  /**
   * @name Get callback instance
   * @description Retrieves a specific callback instance by ID.
   *
   * @param `instanceId` - string
   * @param `callbackInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbackInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, callbackInstanceId, opts) {
    let path = `instances/${instanceId}/callback-instances/${callbackInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbackInstancesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_callbacks.ts
var MetorialManagementInstanceCallbacksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List callbacks
   * @description Returns a paginated list of callbacks.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCallbacksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/callbacks`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCallbacksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCallbacksListOutput
    );
  }
  /**
   * @name Create callback
   * @description Enables callbacks for an integration provider and returns the callback it created. Only providers whose type reports `triggers.status` as `enabled` support this. Callback instances are then registered for every matching integration instance in the background.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCallbacksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/callbacks`;
    let request = {
      path,
      body: mapDashboardInstanceCallbacksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCallbacksCreateOutput
    );
  }
  /**
   * @name Get callback
   * @description Retrieves a specific callback by ID.
   *
   * @param `instanceId` - string
   * @param `callbackId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, callbackId, opts) {
    let path = `instances/${instanceId}/callbacks/${callbackId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceCallbacksGetOutput);
  }
  /**
   * @name Update callback
   * @description Updates the name, description or metadata of a callback. Everything else about a callback is derived from its integration provider - set `callbacks.status` to `disabled` there to tear it down.
   *
   * @param `instanceId` - string
   * @param `callbackId` - string
   * @param `body` - DashboardInstanceCallbacksUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, callbackId, body, opts) {
    let path = `instances/${instanceId}/callbacks/${callbackId}`;
    let request = {
      path,
      body: mapDashboardInstanceCallbacksUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceCallbacksUpdateOutput
    );
  }
  /**
   * @name Delete callback
   * @description Disables callbacks on the underlying integration provider, tearing down this callback and every callback instance registered for it.
   *
   * @param `instanceId` - string
   * @param `callbackId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCallbacksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, callbackId, opts) {
    let path = `instances/${instanceId}/callbacks/${callbackId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceCallbacksDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chat_connections.ts
var MetorialManagementInstanceChatConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat connections
   * @description Returns a paginated list of chat connections.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/chat/connections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatConnectionsListOutput
    );
  }
  /**
   * @name Get chat connection
   * @description Retrieves a specific chat connection.
   *
   * @param `instanceId` - string
   * @param `chatConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatConnectionId, opts) {
    let path = `instances/${instanceId}/chat/connections/${chatConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatConnectionsGetOutput
    );
  }
  /**
   * @name Create chat connection
   * @description Creates a new chat connection, together with the single provider it is linked to.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceChatConnectionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/chat/connections`;
    let request = {
      path,
      body: mapDashboardInstanceChatConnectionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatConnectionsCreateOutput
    );
  }
  /**
   * @name Update chat connection
   * @description Updates a specific chat connection.
   *
   * @param `instanceId` - string
   * @param `chatConnectionId` - string
   * @param `body` - DashboardInstanceChatConnectionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, chatConnectionId, body, opts) {
    let path = `instances/${instanceId}/chat/connections/${chatConnectionId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatConnectionsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatConnectionsUpdateOutput
    );
  }
  /**
   * @name Delete chat connection
   * @description Archives a specific chat connection.
   *
   * @param `instanceId` - string
   * @param `chatConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatConnectionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatConnectionId, opts) {
    let path = `instances/${instanceId}/chat/connections/${chatConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatConnectionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chat_events.ts
var MetorialManagementInstanceChatEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat events
   * @description Returns a paginated list of chat events.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/chat/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatEventsListOutput
    );
  }
  /**
   * @name Get chat event
   * @description Retrieves a specific chat event.
   *
   * @param `instanceId` - string
   * @param `chatEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatEventId, opts) {
    let path = `instances/${instanceId}/chat/events/${chatEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chat_instances.ts
var MetorialManagementInstanceChatInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat instances
   * @description Returns a paginated list of chat instances.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/chat/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesListOutput
    );
  }
  /**
   * @name Get chat instance
   * @description Retrieves a specific chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatInstanceId, opts) {
    let path = `instances/${instanceId}/chat/instances/${chatInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesGetOutput
    );
  }
  /**
   * @name Create chat instance
   * @description Creates a new chat instance for a chat connection.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceChatInstancesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/chat/instances`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatInstancesCreateOutput
    );
  }
  /**
   * @name Update chat instance
   * @description Updates a specific chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `body` - DashboardInstanceChatInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, chatInstanceId, body, opts) {
    let path = `instances/${instanceId}/chat/instances/${chatInstanceId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatInstancesUpdateOutput
    );
  }
  /**
   * @name Delete chat instance
   * @description Archives a specific chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatInstanceId, opts) {
    let path = `instances/${instanceId}/chat/instances/${chatInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatInstancesDeleteOutput
    );
  }
  /**
   * @name Sync chat instance
   * @description Triggers a sync of the workspaces available on this chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(instanceId, chatInstanceId, opts) {
    let path = `instances/${instanceId}/chat/instances/${chatInstanceId}/sync`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatInstancesSyncOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chat_instances_provider.ts
var MetorialManagementInstanceChatInstancesProviderEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get chat instance provider
   * @description Retrieves the single provider configured for a chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatInstanceId, opts) {
    let path = `instances/${instanceId}/chat/instances/${chatInstanceId}/provider`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesProviderGetOutput
    );
  }
  /**
   * @name Set chat instance provider
   * @description Creates or updates the single provider for a chat instance.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `body` - DashboardInstanceChatInstancesProviderSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(instanceId, chatInstanceId, body, opts) {
    let path = `instances/${instanceId}/chat/instances/${chatInstanceId}/provider`;
    let request = {
      path,
      body: mapDashboardInstanceChatInstancesProviderSetBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatInstancesProviderSetOutput
    );
  }
  /**
   * @name Get chat instance authenticated user
   * @description Retrieves the chat provider account this chat instance is authenticated as.
   *
   * @param `instanceId` - string
   * @param `chatInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatInstancesProviderAuthenticatedUserOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  authenticatedUser(instanceId, chatInstanceId, opts) {
    let path = `instances/${instanceId}/chat/instances/${chatInstanceId}/provider/authenticated-user`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatInstancesProviderAuthenticatedUserOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chat_workspaces.ts
var MetorialManagementInstanceChatWorkspacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat workspaces
   * @description Returns a paginated list of workspaces for a chat instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatWorkspacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatWorkspacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/chat/workspaces`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatWorkspacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatWorkspacesListOutput
    );
  }
  /**
   * @name Get chat workspace
   * @description Retrieves a specific chat workspace.
   *
   * @param `instanceId` - string
   * @param `chatWorkspaceId` - string
   * @param `query` - DashboardInstanceChatWorkspacesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatWorkspacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatWorkspaceId, query, opts) {
    let path = `instances/${instanceId}/chat/workspaces/${chatWorkspaceId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatWorkspacesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatWorkspacesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats.ts
var MetorialManagementInstanceChatsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chats
   * @description Returns a paginated list of chats.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceChatsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/chats`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceChatsListOutput);
  }
  /**
   * @name Get chat
   * @description Retrieves a specific chat.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, opts) {
    let path = `instances/${instanceId}/chats/${chatId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceChatsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_channels.ts
var MetorialManagementInstanceChatsChannelsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat channels
   * @description Returns a paginated list of channels for a chat.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsChannelsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/channels`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsChannelsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsListOutput
    );
  }
  /**
   * @name Get chat channel
   * @description Retrieves a specific chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, channelId, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/channels/${channelId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_channels_members.ts
var MetorialManagementInstanceChatsChannelsMembersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat channel members
   * @description Returns a paginated list of members of a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `query` - DashboardInstanceChatsChannelsMembersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsMembersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, channelId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/channels/${channelId}/members`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsChannelsMembersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsMembersListOutput
    );
  }
  /**
   * @name Get chat channel member
   * @description Retrieves a specific member of a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `userId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsMembersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, channelId, userId, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/channels/${channelId}/members/${userId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsChannelsMembersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_channels_typing.ts
var MetorialManagementInstanceChatsChannelsTypingEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Start chat typing indicator
   * @description Shows a typing indicator in a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `channelId` - string
   * @param `body` - DashboardInstanceChatsChannelsTypingStartBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsChannelsTypingStartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  start(instanceId, chatId, channelId, body, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/channels/${channelId}/typing`;
    let request = {
      path,
      body: mapDashboardInstanceChatsChannelsTypingStartBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsChannelsTypingStartOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_commands.ts
var MetorialManagementInstanceChatsCommandsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Respond to chat command
   * @description Replies to a slash command from a chat.command.invoked event, using the provider's native command response.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsCommandsRespondBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsCommandsRespondOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  respond(instanceId, chatId, body, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/commands/respond`;
    let request = {
      path,
      body: mapDashboardInstanceChatsCommandsRespondBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsCommandsRespondOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_dms.ts
var MetorialManagementInstanceChatsDmsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Open chat DM
   * @description Opens (or retrieves) a direct message channel with one or more users.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsDmsOpenBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsDmsOpenOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  open(instanceId, chatId, body, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/dms`;
    let request = {
      path,
      body: mapDashboardInstanceChatsDmsOpenBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsDmsOpenOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_messages.ts
var MetorialManagementInstanceChatsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat messages
   * @description Returns a paginated list of messages in a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesListOutput
    );
  }
  /**
   * @name Get chat message
   * @description Retrieves a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, messageId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesGetOutput
    );
  }
  /**
   * @name Send chat message
   * @description Sends a new message to a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `body` - DashboardInstanceChatsMessagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, chatId, body, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesCreateOutput
    );
  }
  /**
   * @name Edit chat message
   * @description Edits a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, chatId, messageId, body, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceChatsMessagesUpdateOutput
    );
  }
  /**
   * @name Delete chat message
   * @description Deletes a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatId, messageId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages/${messageId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesDeleteQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatsMessagesDeleteOutput
    );
  }
  /**
   * @name Mark chat message read
   * @description Marks a specific chat message as read.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesReadBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReadOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  read(instanceId, chatId, messageId, body, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages/${messageId}/read`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesReadBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesReadOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_messages_reactions.ts
var MetorialManagementInstanceChatsMessagesReactionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat message reactions
   * @description Returns the reactions left on a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesReactionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, messageId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesReactionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsMessagesReactionsListOutput
    );
  }
  /**
   * @name Add chat message reaction
   * @description Adds a reaction to a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `body` - DashboardInstanceChatsMessagesReactionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, chatId, messageId, body, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      body: mapDashboardInstanceChatsMessagesReactionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceChatsMessagesReactionsCreateOutput
    );
  }
  /**
   * @name Remove chat message reaction
   * @description Removes a reaction from a specific chat message.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `messageId` - string
   * @param `query` - DashboardInstanceChatsMessagesReactionsDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsMessagesReactionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, chatId, messageId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/messages/${messageId}/reactions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsMessagesReactionsDeleteQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceChatsMessagesReactionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_chats_threads.ts
var MetorialManagementInstanceChatsThreadsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List chat threads
   * @description Returns a paginated list of threads in a chat channel.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `query` - DashboardInstanceChatsThreadsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsThreadsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, chatId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/threads`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsThreadsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsThreadsListOutput
    );
  }
  /**
   * @name Get chat thread
   * @description Retrieves a specific chat thread.
   *
   * @param `instanceId` - string
   * @param `chatId` - string
   * @param `threadId` - string
   * @param `query` - DashboardInstanceChatsThreadsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceChatsThreadsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, chatId, threadId, query, opts) {
    let path = `instances/${instanceId}/chats/${chatId}/threads/${threadId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceChatsThreadsGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceChatsThreadsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_consumer-surfaces.ts
var MetorialManagementInstanceConsumerSurfacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumer surfaces
   * @description Returns a paginated list of consumer surfaces for an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceConsumerSurfacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumerSurfacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/consumer-surfaces`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumerSurfacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumerSurfacesListOutput
    );
  }
  /**
   * @name Get consumer surface
   * @description Retrieves a consumer surface by ID.
   *
   * @param `instanceId` - string
   * @param `consumerSurfaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumerSurfacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, consumerSurfaceId, opts) {
    let path = `instances/${instanceId}/consumer-surfaces/${consumerSurfaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumerSurfacesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_consumers.ts
var MetorialManagementInstanceConsumersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumers
   * @description Returns a paginated list of consumers for an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceConsumersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/consumers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersListOutput
    );
  }
  /**
   * @name Get consumer
   * @description Retrieves a consumer by ID.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, consumerId, opts) {
    let path = `instances/${instanceId}/consumers/${consumerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceConsumersGetOutput);
  }
  /**
   * @name Create consumer
   * @description Creates or links a consumer for an instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceConsumersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/consumers`;
    let request = {
      path,
      body: mapDashboardInstanceConsumersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConsumersCreateOutput
    );
  }
  /**
   * @name Get member consumer
   * @description Upserts and returns the consumer for the authenticated organization member.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceConsumersGetMemberConsumerBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersGetMemberConsumerOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getMemberConsumer(instanceId, body, opts) {
    let path = `instances/${instanceId}/get-member-consumer`;
    let request = {
      path,
      body: mapDashboardInstanceConsumersGetMemberConsumerBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConsumersGetMemberConsumerOutput
    );
  }
  /**
   * @name Update consumer
   * @description Updates a consumer for an instance.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `body` - DashboardInstanceConsumersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, consumerId, body, opts) {
    let path = `instances/${instanceId}/consumers/${consumerId}`;
    let request = {
      path,
      body: mapDashboardInstanceConsumersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceConsumersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_consumers_profiles.ts
var MetorialManagementInstanceConsumersProfilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List consumer profiles
   * @description Returns a paginated list of profiles for a consumer in an instance.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `query` - DashboardInstanceConsumersProfilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersProfilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, consumerId, query, opts) {
    let path = `instances/${instanceId}/consumers/${consumerId}/profiles`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConsumersProfilesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersProfilesListOutput
    );
  }
  /**
   * @name Get consumer profile
   * @description Retrieves a consumer profile by ID for a consumer.
   *
   * @param `instanceId` - string
   * @param `consumerId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConsumersProfilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, consumerId, consumerProfileId, opts) {
    let path = `instances/${instanceId}/consumers/${consumerId}/profiles/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConsumersProfilesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_conversations.ts
var MetorialManagementInstanceConversationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistant conversations
   * @description List assistant conversations in an instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceConversationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/conversations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConversationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsListOutput
    );
  }
  /**
   * @name Create assistant conversation
   * @description Create a new assistant conversation in an instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceConversationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/conversations`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsCreateOutput
    );
  }
  /**
   * @name Get assistant conversation
   * @description Get a specific assistant conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, assistantConversationId, opts) {
    let path = `instances/${instanceId}/conversations/${assistantConversationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsGetOutput
    );
  }
  /**
   * @name Update assistant conversation
   * @description Update a specific assistant conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `body` - DashboardInstanceConversationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, assistantConversationId, body, opts) {
    let path = `instances/${instanceId}/conversations/${assistantConversationId}`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceConversationsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_conversations_messages.ts
var MetorialManagementInstanceConversationsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List assistant messages
   * @description List messages in a specific assistant conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `query` - DashboardInstanceConversationsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, assistantConversationId, query, opts) {
    let path = `instances/${instanceId}/conversations/${assistantConversationId}/messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceConversationsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsMessagesListOutput
    );
  }
  /**
   * @name Create assistant message
   * @description Create a user message and assistant request in a specific conversation.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `body` - DashboardInstanceConversationsMessagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, assistantConversationId, body, opts) {
    let path = `instances/${instanceId}/conversations/${assistantConversationId}/messages`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsMessagesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsMessagesCreateOutput
    );
  }
  /**
   * @name Get assistant message
   * @description Get a specific assistant message.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `assistantMessageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, assistantConversationId, assistantMessageId, opts) {
    let path = `instances/${instanceId}/conversations/${assistantConversationId}/messages/${assistantMessageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceConversationsMessagesGetOutput
    );
  }
  /**
   * @name Respond to assistant handoffs
   * @description Submit one or more client handoff tool responses for a waiting message.
   *
   * @param `instanceId` - string
   * @param `assistantConversationId` - string
   * @param `assistantMessageId` - string
   * @param `body` - DashboardInstanceConversationsMessagesHandoffResponsesBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceConversationsMessagesHandoffResponsesOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  handoffResponses(instanceId, assistantConversationId, assistantMessageId, body, opts) {
    let path = `instances/${instanceId}/conversations/${assistantConversationId}/messages/${assistantMessageId}/handoff-responses`;
    let request = {
      path,
      body: mapDashboardInstanceConversationsMessagesHandoffResponsesBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceConversationsMessagesHandoffResponsesOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_custom-providers.ts
var MetorialManagementInstanceCustomProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom providers
   * @description Returns a paginated list of custom providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/custom-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersListOutput
    );
  }
  /**
   * @name Get custom provider
   * @description Retrieves a specific custom provider by ID.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderId, opts) {
    let path = `instances/${instanceId}/custom-providers/${customProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersGetOutput
    );
  }
  /**
   * @name Get custom provider environment
   * @description Retrieves the environment variables for a specific custom provider by ID.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersGetEnvOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEnv(instanceId, customProviderId, opts) {
    let path = `instances/${instanceId}/custom-providers/${customProviderId}/env`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersGetEnvOutput
    );
  }
  /**
   * @name Create custom provider
   * @description Creates a new custom provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCustomProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/custom-providers`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersCreateOutput
    );
  }
  /**
   * @name Update custom provider
   * @description Updates a specific custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `body` - DashboardInstanceCustomProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, customProviderId, body, opts) {
    let path = `instances/${instanceId}/custom-providers/${customProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceCustomProvidersUpdateOutput
    );
  }
  /**
   * @name Archive custom provider
   * @description Archives a specific custom provider and disables new connections to it.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(instanceId, customProviderId, opts) {
    let path = `instances/${instanceId}/custom-providers/${customProviderId}/archive`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersArchiveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_custom-providers_code.ts
var MetorialManagementInstanceCustomProvidersCodeEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get code editor token
   * @description Get a token to access the code editor for a custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getCodeEditorToken(instanceId, customProviderId, opts) {
    let path = `instances/${instanceId}/custom-providers/${customProviderId}/code-editor-token`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_custom-providers_commits.ts
var MetorialManagementInstanceCustomProvidersCommitsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider commits
   * @description Returns a paginated list of commits for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersCommitsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/custom-provider-commits`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersCommitsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCommitsListOutput
    );
  }
  /**
   * @name Get custom provider commit
   * @description Retrieves a specific commit.
   *
   * @param `instanceId` - string
   * @param `customProviderCommitId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderCommitId, opts) {
    let path = `instances/${instanceId}/custom-provider-commits/${customProviderCommitId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersCommitsGetOutput
    );
  }
  /**
   * @name Create custom provider commit
   * @description Creates a new commit to promote or rollback a version in an environment.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCustomProvidersCommitsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersCommitsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/custom-provider-commits`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersCommitsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersCommitsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_custom-providers_deployments.ts
var MetorialManagementInstanceCustomProvidersDeploymentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider deployments
   * @description Returns a paginated list of deployments for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersDeploymentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/custom-provider-deployments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersDeploymentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsListOutput
    );
  }
  /**
   * @name Get custom provider deployment
   * @description Retrieves a specific deployment.
   *
   * @param `instanceId` - string
   * @param `customProviderDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderDeploymentId, opts) {
    let path = `instances/${instanceId}/custom-provider-deployments/${customProviderDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsGetOutput
    );
  }
  /**
   * @name Get deployment logs
   * @description Retrieves the build and deployment logs for a deployment.
   *
   * @param `instanceId` - string
   * @param `customProviderDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersDeploymentsGetLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getLogs(instanceId, customProviderDeploymentId, opts) {
    let path = `instances/${instanceId}/custom-provider-deployments/${customProviderDeploymentId}/logs`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersDeploymentsGetLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_custom-providers_environments.ts
var MetorialManagementInstanceCustomProvidersEnvironmentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider environments
   * @description Returns a paginated list of environments for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersEnvironmentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersEnvironmentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/custom-provider-environments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersEnvironmentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersEnvironmentsListOutput
    );
  }
  /**
   * @name Get custom provider environment
   * @description Retrieves a specific environment.
   *
   * @param `instanceId` - string
   * @param `customProviderEnvironmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersEnvironmentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderEnvironmentId, opts) {
    let path = `instances/${instanceId}/custom-provider-environments/${customProviderEnvironmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersEnvironmentsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_custom-providers_versions.ts
var MetorialManagementInstanceCustomProvidersVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List custom provider versions
   * @description Returns a paginated list of versions for a custom provider.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceCustomProvidersVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/custom-provider-versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceCustomProvidersVersionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsListOutput
    );
  }
  /**
   * @name Get custom provider version
   * @description Retrieves a specific version of a custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, customProviderVersionId, opts) {
    let path = `instances/${instanceId}/custom-provider-versions/${customProviderVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsGetOutput
    );
  }
  /**
   * @name Get custom provider version environment
   * @description Retrieves the environment variables for a specific version of a custom provider.
   *
   * @param `instanceId` - string
   * @param `customProviderVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsGetEnvOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEnv(instanceId, customProviderVersionId, opts) {
    let path = `instances/${instanceId}/custom-provider-versions/${customProviderVersionId}/env`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceCustomProvidersVersionsGetEnvOutput
    );
  }
  /**
   * @name Create custom provider version
   * @description Creates a new version for a custom provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceCustomProvidersVersionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceCustomProvidersVersionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/custom-provider-versions`;
    let request = {
      path,
      body: mapDashboardInstanceCustomProvidersVersionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceCustomProvidersVersionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_documents.ts
var MetorialManagementInstanceDocumentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List documents
   * @description Returns a paginated list of documents owned by the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceDocumentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/documents`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsListOutput
    );
  }
  /**
   * @name Create document
   * @description Creates a new document for the instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceDocumentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/documents`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceDocumentsCreateOutput
    );
  }
  /**
   * @name Get document by ID
   * @description Retrieves a document by its ID.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, opts) {
    let path = `instances/${instanceId}/documents/${documentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceDocumentsGetOutput);
  }
  /**
   * @name Update document by ID
   * @description Updates a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `body` - DashboardInstanceDocumentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, documentId, body, opts) {
    let path = `instances/${instanceId}/documents/${documentId}`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceDocumentsUpdateOutput
    );
  }
  /**
   * @name Delete document by ID
   * @description Deletes a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, documentId, opts) {
    let path = `instances/${instanceId}/documents/${documentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceDocumentsDeleteOutput
    );
  }
  /**
   * @name Clone document by ID
   * @description Clones a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `body` - DashboardInstanceDocumentsCloneBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsCloneOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  clone(instanceId, documentId, body, opts) {
    let path = `instances/${instanceId}/documents/${documentId}/clone`;
    let request = {
      path,
      body: mapDashboardInstanceDocumentsCloneBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceDocumentsCloneOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_documents_edit-token.ts
var MetorialManagementInstanceDocumentsEditTokenEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get document edit token
   * @description Returns a short-lived read or write token for establishing a live document session.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsEditTokenGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, opts) {
    let path = `instances/${instanceId}/documents/${documentId}/edit-token`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsEditTokenGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_documents_participants.ts
var MetorialManagementInstanceDocumentsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List document participants
   * @description Returns a paginated list of participants for a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `query` - DashboardInstanceDocumentsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, documentId, query, opts) {
    let path = `instances/${instanceId}/documents/${documentId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsParticipantsListOutput
    );
  }
  /**
   * @name Get document participant by ID
   * @description Retrieves a specific document participant by its ID.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `documentParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, documentParticipantId, opts) {
    let path = `instances/${instanceId}/documents/${documentId}/participants/${documentParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_documents_permissions.ts
var MetorialManagementInstanceDocumentsPermissionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get document permissions
   * @description Returns the effective Cargo permissions for the current actor on a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsPermissionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, opts) {
    let path = `instances/${instanceId}/documents/${documentId}/permissions`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsPermissionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_documents_versions.ts
var MetorialManagementInstanceDocumentsVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List document versions
   * @description Returns a paginated list of versions for a specific document.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `query` - DashboardInstanceDocumentsVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, documentId, query, opts) {
    let path = `instances/${instanceId}/documents/${documentId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceDocumentsVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsVersionsListOutput
    );
  }
  /**
   * @name Get document version by ID
   * @description Retrieves a specific document version by its ID.
   *
   * @param `instanceId` - string
   * @param `documentId` - string
   * @param `documentVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceDocumentsVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, documentId, documentVersionId, opts) {
    let path = `instances/${instanceId}/documents/${documentId}/versions/${documentVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceDocumentsVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_files.ts
var MetorialManagementInstanceFilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List instance files
   * @description Returns a paginated list of files owned by the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceFilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/files`;
    let request = {
      path,
      query: query ? mapDashboardInstanceFilesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFilesListOutput);
  }
  /**
   * @name Get file by ID
   * @description Retrieves details for a specific file by its ID.
   *
   * @param `instanceId` - string
   * @param `fileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, fileId, opts) {
    let path = `instances/${instanceId}/files/${fileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFilesGetOutput);
  }
  /**
   * @name Delete file by ID
   * @description Deletes a specific file by its ID.
   *
   * @param `instanceId` - string
   * @param `fileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, fileId, opts) {
    let path = `instances/${instanceId}/files/${fileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFilesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_files_links.ts
var MetorialManagementInstanceFilesLinksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List file links
   * @description Returns a paginated list of file links owned by the instance organization.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceFilesLinksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/file-links`;
    let request = {
      path,
      query: query ? mapDashboardInstanceFilesLinksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFilesLinksListOutput
    );
  }
  /**
   * @name Get file link by ID
   * @description Retrieves the details of a specific file link by its ID.
   *
   * @param `instanceId` - string
   * @param `linkId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, linkId, opts) {
    let path = `instances/${instanceId}/file-links/${linkId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFilesLinksGetOutput
    );
  }
  /**
   * @name Create file link
   * @description Creates a new link for a specific file.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceFilesLinksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/file-links`;
    let request = {
      path,
      body: mapDashboardInstanceFilesLinksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFilesLinksCreateOutput
    );
  }
  /**
   * @name Delete file link by ID
   * @description Deletes a specific file link by its ID.
   *
   * @param `instanceId` - string
   * @param `linkId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFilesLinksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, linkId, opts) {
    let path = `instances/${instanceId}/file-links/${linkId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFilesLinksDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_firewalls.ts
var MetorialManagementInstanceFirewallsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List firewalls
   * @description Returns a paginated list of firewalls.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceFirewallsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/firewalls`;
    let request = {
      path,
      query: query ? mapDashboardInstanceFirewallsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceFirewallsListOutput
    );
  }
  /**
   * @name Get firewall
   * @description Retrieves a specific firewall by ID.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, firewallId, opts) {
    let path = `instances/${instanceId}/firewalls/${firewallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceFirewallsGetOutput);
  }
  /**
   * @name Create firewall
   * @description Creates a new firewall.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceFirewallsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/firewalls`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFirewallsCreateOutput
    );
  }
  /**
   * @name Update firewall
   * @description Updates a firewall definition.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `body` - DashboardInstanceFirewallsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, firewallId, body, opts) {
    let path = `instances/${instanceId}/firewalls/${firewallId}`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceFirewallsUpdateOutput
    );
  }
  /**
   * @name Delete firewall
   * @description Archives a firewall.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, firewallId, opts) {
    let path = `instances/${instanceId}/firewalls/${firewallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFirewallsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_firewalls_network-policies.ts
var MetorialManagementInstanceFirewallsNetworkPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Attach network policy
   * @description Attaches a network policy to a firewall.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `body` - DashboardInstanceFirewallsNetworkPoliciesAttachBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsNetworkPoliciesAttachOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  attach(instanceId, firewallId, body, opts) {
    let path = `instances/${instanceId}/firewalls/${firewallId}/network-policies`;
    let request = {
      path,
      body: mapDashboardInstanceFirewallsNetworkPoliciesAttachBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceFirewallsNetworkPoliciesAttachOutput
    );
  }
  /**
   * @name Detach network policy
   * @description Detaches a network policy from a firewall.
   *
   * @param `instanceId` - string
   * @param `firewallId` - string
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceFirewallsNetworkPoliciesDetachOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  detach(instanceId, firewallId, networkPolicyId, opts) {
    let path = `instances/${instanceId}/firewalls/${firewallId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceFirewallsNetworkPoliciesDetachOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_identities.ts
var MetorialManagementInstanceIdentitiesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identities
   * @description Returns a paginated list of identities for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/identities`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesListOutput
    );
  }
  /**
   * @name Get identity
   * @description Retrieves a specific identity by ID.
   *
   * @param `instanceId` - string
   * @param `identityId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityId, opts) {
    let path = `instances/${instanceId}/identities/${identityId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesGetOutput
    );
  }
  /**
   * @name Create identity
   * @description Creates a new identity owned by an existing identity actor.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/identities`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesCreateOutput
    );
  }
  /**
   * @name Update identity
   * @description Updates mutable fields on an existing identity.
   *
   * @param `instanceId` - string
   * @param `identityId` - string
   * @param `body` - DashboardInstanceIdentitiesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityId, body, opts) {
    let path = `instances/${instanceId}/identities/${identityId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesUpdateOutput
    );
  }
  /**
   * @name Delete identity
   * @description Archives an identity.
   *
   * @param `instanceId` - string
   * @param `identityId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityId, opts) {
    let path = `instances/${instanceId}/identities/${identityId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_identities_credentials.ts
var MetorialManagementInstanceIdentitiesCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity credentials
   * @description Returns a paginated list of identity credentials for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/identity-credentials`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesCredentialsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesCredentialsListOutput
    );
  }
  /**
   * @name Get identity credential
   * @description Retrieves a specific identity credential by ID.
   *
   * @param `instanceId` - string
   * @param `identityCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityCredentialId, opts) {
    let path = `instances/${instanceId}/identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesCredentialsGetOutput
    );
  }
  /**
   * @name Create identity credential
   * @description Creates a new credential and attaches it to an identity.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/identity-credentials`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesCredentialsCreateOutput
    );
  }
  /**
   * @name Update identity credential
   * @description Updates the delegation config attached to an identity credential.
   *
   * @param `instanceId` - string
   * @param `identityCredentialId` - string
   * @param `body` - DashboardInstanceIdentitiesCredentialsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityCredentialId, body, opts) {
    let path = `instances/${instanceId}/identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesCredentialsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesCredentialsUpdateOutput
    );
  }
  /**
   * @name Delete identity credential
   * @description Archives an identity credential.
   *
   * @param `instanceId` - string
   * @param `identityCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityCredentialId, opts) {
    let path = `instances/${instanceId}/identity-credentials/${identityCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_identities_delegation-configs.ts
var MetorialManagementInstanceIdentitiesDelegationConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegation configs
   * @description Returns a paginated list of identity delegation configs.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/identity-delegation-configs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsListOutput
    );
  }
  /**
   * @name Get identity delegation config
   * @description Retrieves a specific identity delegation config by ID.
   *
   * @param `instanceId` - string
   * @param `identityDelegationConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityDelegationConfigId, opts) {
    let path = `instances/${instanceId}/identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsGetOutput
    );
  }
  /**
   * @name Create identity delegation config
   * @description Creates a new identity delegation config.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/identity-delegation-configs`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsCreateOutput
    );
  }
  /**
   * @name Update identity delegation config
   * @description Updates mutable fields on an existing identity delegation config.
   *
   * @param `instanceId` - string
   * @param `identityDelegationConfigId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityDelegationConfigId, body, opts) {
    let path = `instances/${instanceId}/identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsUpdateOutput
    );
  }
  /**
   * @name Delete identity delegation config
   * @description Archives an identity delegation config.
   *
   * @param `instanceId` - string
   * @param `identityDelegationConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityDelegationConfigId, opts) {
    let path = `instances/${instanceId}/identity-delegation-configs/${identityDelegationConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentitiesDelegationConfigsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_identities_delegation-requests.ts
var MetorialManagementInstanceIdentitiesDelegationRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegation requests
   * @description Returns a paginated list of identity delegation requests.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/identity-delegation-requests`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsListOutput
    );
  }
  /**
   * @name Get identity delegation request
   * @description Retrieves a specific identity delegation request by ID.
   *
   * @param `instanceId` - string
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityDelegationRequestId, query, opts) {
    let path = `instances/${instanceId}/identity-delegation-requests/${identityDelegationRequestId}`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsGetQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsGetOutput
    );
  }
  /**
   * @name Create identity delegation request
   * @description Creates a new identity delegation request.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationRequestsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/identity-delegation-requests`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationRequestsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsCreateOutput
    );
  }
  /**
   * @name Approve identity delegation request
   * @description Approves an existing identity delegation request.
   *
   * @param `instanceId` - string
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsApproveQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsApproveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  approve(instanceId, identityDelegationRequestId, query, opts) {
    let path = `instances/${instanceId}/identity-delegation-requests/${identityDelegationRequestId}/approve`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsApproveQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsApproveOutput
    );
  }
  /**
   * @name Deny identity delegation request
   * @description Denies an existing identity delegation request.
   *
   * @param `instanceId` - string
   * @param `identityDelegationRequestId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationRequestsDenyQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationRequestsDenyOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  deny(instanceId, identityDelegationRequestId, query, opts) {
    let path = `instances/${instanceId}/identity-delegation-requests/${identityDelegationRequestId}/deny`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationRequestsDenyQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationRequestsDenyOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_identities_delegations.ts
var MetorialManagementInstanceIdentitiesDelegationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity delegations
   * @description Returns a paginated list of identity delegations for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentitiesDelegationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/identity-delegations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentitiesDelegationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationsListOutput
    );
  }
  /**
   * @name Get identity delegation
   * @description Retrieves a specific identity delegation by ID.
   *
   * @param `instanceId` - string
   * @param `identityDelegationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityDelegationId, opts) {
    let path = `instances/${instanceId}/identity-delegations/${identityDelegationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentitiesDelegationsGetOutput
    );
  }
  /**
   * @name Create identity delegation
   * @description Creates a new identity delegation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentitiesDelegationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/identity-delegations`;
    let request = {
      path,
      body: mapDashboardInstanceIdentitiesDelegationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationsCreateOutput
    );
  }
  /**
   * @name Revoke identity delegation
   * @description Revokes an existing identity delegation.
   *
   * @param `instanceId` - string
   * @param `identityDelegationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentitiesDelegationsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(instanceId, identityDelegationId, opts) {
    let path = `instances/${instanceId}/identity-delegations/${identityDelegationId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentitiesDelegationsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_identity-actors.ts
var MetorialManagementInstanceIdentityActorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List identity actors
   * @description Returns a paginated list of identity actors for the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIdentityActorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/identity-actors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIdentityActorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentityActorsListOutput
    );
  }
  /**
   * @name Get identity actor
   * @description Retrieves a specific identity actor by ID.
   *
   * @param `instanceId` - string
   * @param `identityActorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, identityActorId, opts) {
    let path = `instances/${instanceId}/identity-actors/${identityActorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIdentityActorsGetOutput
    );
  }
  /**
   * @name Create identity actor
   * @description Creates a new identity actor.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIdentityActorsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/identity-actors`;
    let request = {
      path,
      body: mapDashboardInstanceIdentityActorsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIdentityActorsCreateOutput
    );
  }
  /**
   * @name Update identity actor
   * @description Updates mutable fields on an existing identity actor.
   *
   * @param `instanceId` - string
   * @param `identityActorId` - string
   * @param `body` - DashboardInstanceIdentityActorsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, identityActorId, body, opts) {
    let path = `instances/${instanceId}/identity-actors/${identityActorId}`;
    let request = {
      path,
      body: mapDashboardInstanceIdentityActorsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIdentityActorsUpdateOutput
    );
  }
  /**
   * @name Delete identity actor
   * @description Archives an identity actor.
   *
   * @param `instanceId` - string
   * @param `identityActorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIdentityActorsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, identityActorId, opts) {
    let path = `instances/${instanceId}/identity-actors/${identityActorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIdentityActorsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_incoming-webhooks.ts
var MetorialManagementInstanceIncomingWebhooksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List incoming webhooks
   * @description Returns a paginated list of incoming webhooks you can see.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIncomingWebhooksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIncomingWebhooksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/incoming-webhooks`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIncomingWebhooksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIncomingWebhooksListOutput
    );
  }
  /**
   * @name Get incoming webhook
   * @description Retrieves a specific incoming webhook.
   *
   * @param `instanceId` - string
   * @param `incomingWebhookId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIncomingWebhooksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, incomingWebhookId, opts) {
    let path = `instances/${instanceId}/incoming-webhooks/${incomingWebhookId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIncomingWebhooksGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integration-enclaves.ts
var MetorialManagementInstanceIntegrationEnclavesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration enclaves
   * @description Returns a paginated list of integration enclaves.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationEnclavesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationEnclavesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-enclaves`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationEnclavesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationEnclavesListOutput
    );
  }
  /**
   * @name Get integration enclave
   * @description Retrieves a specific integration enclave by ID.
   *
   * @param `instanceId` - string
   * @param `integrationEnclaveId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationEnclavesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationEnclaveId, opts) {
    let path = `instances/${instanceId}/integration-enclaves/${integrationEnclaveId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationEnclavesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integration-firewall-assignments.ts
var MetorialManagementInstanceIntegrationFirewallAssignmentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration firewall assignments
   * @description Returns a paginated list of integration firewall assignments.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationFirewallAssignmentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-firewall-assignments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationFirewallAssignmentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsListOutput
    );
  }
  /**
   * @name Get integration firewall assignment
   * @description Retrieves a specific integration firewall assignment by ID.
   *
   * @param `instanceId` - string
   * @param `integrationFirewallAssignmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationFirewallAssignmentId, opts) {
    let path = `instances/${instanceId}/integration-firewall-assignments/${integrationFirewallAssignmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsGetOutput
    );
  }
  /**
   * @name Create integration firewall assignment
   * @description Creates an assignment that applies a firewall to a target.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationFirewallAssignmentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/integration-firewall-assignments`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationFirewallAssignmentsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsCreateOutput
    );
  }
  /**
   * @name Delete integration firewall assignment
   * @description Deletes an integration firewall assignment.
   *
   * @param `instanceId` - string
   * @param `integrationFirewallAssignmentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationFirewallAssignmentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationFirewallAssignmentId, opts) {
    let path = `instances/${instanceId}/integration-firewall-assignments/${integrationFirewallAssignmentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationFirewallAssignmentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integration-internet-gateway.ts
var MetorialManagementInstanceIntegrationInternetGatewayEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get integration internet gateway
   * @description Retrieves the integration internet gateway of the instance, including its public IPs.
   *
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationInternetGatewayGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, opts) {
    let path = `instances/${instanceId}/integration-internet-gateway`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationInternetGatewayGetOutput
    );
  }
  /**
   * @name List integration internet gateway network logs
   * @description Returns ingress or egress network logs for integration enclaves in the instance environment.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  listNetworkLogs(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-internet-gateway/network-logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integrations.ts
var MetorialManagementInstanceIntegrationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integrations
   * @description Returns a paginated list of integrations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integrations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsListOutput
    );
  }
  /**
   * @name Get integration
   * @description Retrieves a specific integration.
   *
   * @param `instanceId` - string
   * @param `integrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationId, opts) {
    let path = `instances/${instanceId}/integrations/${integrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsGetOutput
    );
  }
  /**
   * @name Create integration
   * @description Creates a new integration.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/integrations`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsCreateOutput
    );
  }
  /**
   * @name Update integration
   * @description Updates a specific integration.
   *
   * @param `instanceId` - string
   * @param `integrationId` - string
   * @param `body` - DashboardInstanceIntegrationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationId, body, opts) {
    let path = `instances/${instanceId}/integrations/${integrationId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsUpdateOutput
    );
  }
  /**
   * @name Delete integration
   * @description Archives a specific integration.
   *
   * @param `instanceId` - string
   * @param `integrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationId, opts) {
    let path = `instances/${instanceId}/integrations/${integrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integrations_instance-groups.ts
var MetorialManagementInstanceIntegrationsInstanceGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance groups
   * @description Returns a paginated list of integration instance groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstanceGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-instance-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstanceGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsListOutput
    );
  }
  /**
   * @name Get integration instance group
   * @description Retrieves a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceGroupId, opts) {
    let path = `instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsGetOutput
    );
  }
  /**
   * @name Create integration instance group session template
   * @description Creates or updates the shared session template for a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSessionTemplate(instanceId, integrationInstanceGroupId, body, opts) {
    let path = `instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}/session-template`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput
    );
  }
  /**
   * @name Create integration instance group session
   * @description Creates a session from the shared session template of a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateSessionBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSession(instanceId, integrationInstanceGroupId, body, opts) {
    let path = `instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}/session`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput
    );
  }
  /**
   * @name Create integration instance group
   * @description Creates a new integration instance group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/integration-instance-groups`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsCreateOutput
    );
  }
  /**
   * @name Update integration instance group
   * @description Updates a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationInstanceGroupId, body, opts) {
    let path = `instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsUpdateOutput
    );
  }
  /**
   * @name Delete integration instance group
   * @description Archives a specific integration instance group.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationInstanceGroupId, opts) {
    let path = `instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integrations_instance-groups_providers.ts
var MetorialManagementInstanceIntegrationsInstanceGroupsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance group providers
   * @description Returns a paginated list of integration instance group providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstanceGroupsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-instance-group-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstanceGroupsProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersListOutput
    );
  }
  /**
   * @name Get integration instance group provider
   * @description Retrieves a specific integration instance group provider.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceGroupProviderId, opts) {
    let path = `instances/${instanceId}/integration-instance-group-providers/${integrationInstanceGroupProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput
    );
  }
  /**
   * @name Set integration instance group provider
   * @description Creates or updates the effective integration instance group provider materialization.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupId` - string
   * @param `integrationInstanceProviderId` - string
   * @param `body` - DashboardInstanceIntegrationsInstanceGroupsProvidersSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(instanceId, integrationInstanceGroupId, integrationInstanceProviderId, body, opts) {
    let path = `instances/${instanceId}/integration-instance-groups/${integrationInstanceGroupId}/providers/${integrationInstanceProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput
    );
  }
  /**
   * @name Delete integration instance group provider
   * @description Archives a specific integration instance group provider.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceGroupProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationInstanceGroupProviderId, opts) {
    let path = `instances/${instanceId}/integration-instance-group-providers/${integrationInstanceGroupProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integrations_instances.ts
var MetorialManagementInstanceIntegrationsInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instances
   * @description Returns a paginated list of integration instances.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesListOutput
    );
  }
  /**
   * @name Get integration instance
   * @description Retrieves a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceId, opts) {
    let path = `instances/${instanceId}/integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesGetOutput
    );
  }
  /**
   * @name Create integration instance session template
   * @description Creates or updates the shared session template for a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateSessionTemplateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSessionTemplate(instanceId, integrationInstanceId, body, opts) {
    let path = `instances/${instanceId}/integration-instances/${integrationInstanceId}/session-template`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput
    );
  }
  /**
   * @name Create integration instance session
   * @description Creates a session from the shared session template of a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateSessionBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateSessionOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  createSession(instanceId, integrationInstanceId, body, opts) {
    let path = `instances/${instanceId}/integration-instances/${integrationInstanceId}/session`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateSessionBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateSessionOutput
    );
  }
  /**
   * @name Create integration instance
   * @description Creates a new integration instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/integration-instances`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsInstancesCreateOutput
    );
  }
  /**
   * @name Update integration instance
   * @description Updates a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationInstanceId, body, opts) {
    let path = `instances/${instanceId}/integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsInstancesUpdateOutput
    );
  }
  /**
   * @name Delete integration instance
   * @description Archives a specific integration instance.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationInstanceId, opts) {
    let path = `instances/${instanceId}/integration-instances/${integrationInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsInstancesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integrations_instances_providers.ts
var MetorialManagementInstanceIntegrationsInstancesProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration instance providers
   * @description Returns a paginated list of integration instance providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsInstancesProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-instance-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsInstancesProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersListOutput
    );
  }
  /**
   * @name Get integration instance provider
   * @description Retrieves a specific integration instance provider.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationInstanceProviderId, opts) {
    let path = `instances/${instanceId}/integration-instance-providers/${integrationInstanceProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersGetOutput
    );
  }
  /**
   * @name Set integration instance provider
   * @description Creates or updates the effective integration instance provider materialization.
   *
   * @param `instanceId` - string
   * @param `integrationInstanceId` - string
   * @param `providerId` - string
   * @param `body` - DashboardInstanceIntegrationsInstancesProvidersSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsInstancesProvidersSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(instanceId, integrationInstanceId, providerId, body, opts) {
    let path = `instances/${instanceId}/integration-instances/${integrationInstanceId}/providers/${providerId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsInstancesProvidersSetBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceIntegrationsInstancesProvidersSetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integrations_providers.ts
var MetorialManagementInstanceIntegrationsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration providers
   * @description Returns a paginated list of integration providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsProvidersListOutput
    );
  }
  /**
   * @name Get integration provider
   * @description Retrieves a specific integration provider.
   *
   * @param `instanceId` - string
   * @param `integrationProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationProviderId, opts) {
    let path = `instances/${instanceId}/integration-providers/${integrationProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsProvidersGetOutput
    );
  }
  /**
   * @name Create integration provider
   * @description Creates a new integration provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/integration-providers`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsProvidersCreateOutput
    );
  }
  /**
   * @name Update integration provider
   * @description Updates a specific integration provider.
   *
   * @param `instanceId` - string
   * @param `integrationProviderId` - string
   * @param `body` - DashboardInstanceIntegrationsProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, integrationProviderId, body, opts) {
    let path = `instances/${instanceId}/integration-providers/${integrationProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceIntegrationsProvidersUpdateOutput
    );
  }
  /**
   * @name Delete integration provider
   * @description Archives a specific integration provider.
   *
   * @param `instanceId` - string
   * @param `integrationProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, integrationProviderId, opts) {
    let path = `instances/${instanceId}/integration-providers/${integrationProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceIntegrationsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_integrations_setup-sessions.ts
var MetorialManagementInstanceIntegrationsSetupSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List integration setup sessions
   * @description Returns a paginated list of integration setup sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceIntegrationsSetupSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/integration-setup-sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceIntegrationsSetupSessionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsListOutput
    );
  }
  /**
   * @name Get integration setup session
   * @description Retrieves a specific integration setup session.
   *
   * @param `instanceId` - string
   * @param `integrationSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, integrationSetupSessionId, opts) {
    let path = `instances/${instanceId}/integration-setup-sessions/${integrationSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsGetOutput
    );
  }
  /**
   * @name Create integration setup session
   * @description Creates a new integration setup session. Creates a draft integration instance unless integration_instance_id is given, in which case that instance is reused and its config and auth config are overwritten on completion.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceIntegrationsSetupSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceIntegrationsSetupSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/integration-setup-sessions`;
    let request = {
      path,
      body: mapDashboardInstanceIntegrationsSetupSessionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceIntegrationsSetupSessionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_magic-mcp-endpoints.ts
var MetorialManagementInstanceMagicMcpEndpointsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP endpoints
   * @description Returns a paginated list of magic MCP endpoints.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpEndpointsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/magic-mcp-endpoints`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpEndpointsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpEndpointsListOutput
    );
  }
  /**
   * @name Get magic MCP endpoint
   * @description Retrieves a specific magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpEndpointId, opts) {
    let path = `instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpEndpointsGetOutput
    );
  }
  /**
   * @name Create magic MCP endpoint
   * @description Creates a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-endpoints`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsCreateOutput
    );
  }
  /**
   * @name Delete magic MCP endpoint
   * @description Archives a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpEndpointId, opts) {
    let path = `instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpEndpointsDeleteOutput
    );
  }
  /**
   * @name Update magic MCP endpoint
   * @description Updates a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpEndpointId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpEndpointsUpdateOutput
    );
  }
  /**
   * @name Add servers to magic MCP endpoint
   * @description Adds magic MCP servers to a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsAddServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsAddServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addServers(instanceId, magicMcpEndpointId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}/add-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsAddServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsAddServersOutput
    );
  }
  /**
   * @name Remove servers from magic MCP endpoint
   * @description Removes magic MCP servers from a magic MCP endpoint.
   *
   * @param `instanceId` - string
   * @param `magicMcpEndpointId` - string
   * @param `body` - DashboardInstanceMagicMcpEndpointsRemoveServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpEndpointsRemoveServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeServers(instanceId, magicMcpEndpointId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-endpoints/${magicMcpEndpointId}/remove-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpEndpointsRemoveServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpEndpointsRemoveServersOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_magic-mcp-groups.ts
var MetorialManagementInstanceMagicMcpGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP groups
   * @description Returns a paginated list of magic MCP groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/magic-mcp-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpGroupsListOutput
    );
  }
  /**
   * @name Get magic MCP group
   * @description Retrieves a specific magic MCP group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpGroupId, opts) {
    let path = `instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpGroupsGetOutput
    );
  }
  /**
   * @name Create magic MCP group
   * @description Creates a magic MCP group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsCreateOutput
    );
  }
  /**
   * @name Delete magic MCP group
   * @description Deletes a magic MCP group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpGroupId, opts) {
    let path = `instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpGroupsDeleteOutput
    );
  }
  /**
   * @name Update magic MCP group
   * @description Updates a magic MCP group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpGroupId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpGroupsUpdateOutput
    );
  }
  /**
   * @name Add servers to magic MCP group
   * @description Adds magic MCP servers to a group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsAddServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsAddServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addServers(instanceId, magicMcpGroupId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}/add-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsAddServersBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsAddServersOutput
    );
  }
  /**
   * @name Remove servers from magic MCP group
   * @description Removes magic MCP servers from a group.
   *
   * @param `instanceId` - string
   * @param `magicMcpGroupId` - string
   * @param `body` - DashboardInstanceMagicMcpGroupsRemoveServersBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpGroupsRemoveServersOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeServers(instanceId, magicMcpGroupId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-groups/${magicMcpGroupId}/remove-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpGroupsRemoveServersBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpGroupsRemoveServersOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_magic-mcp-servers.ts
var MetorialManagementInstanceMagicMcpServersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP servers
   * @description Returns a paginated list of magic MCP servers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpServersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpServersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersListOutput
    );
  }
  /**
   * @name Get magic MCP server
   * @description Retrieves a specific magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpServerId, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersGetOutput
    );
  }
  /**
   * @name List magic MCP server tools
   * @description Returns the effective set of tools available through the providers backing a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersToolsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  tools(instanceId, magicMcpServerId, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/tools`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersToolsOutput
    );
  }
  /**
   * @name Create magic MCP server
   * @description Creates a magic MCP server with a new session template. A Subspace session is created automatically on first connection and then reused.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpServersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersCreateOutput
    );
  }
  /**
   * @name Delete magic MCP server
   * @description Archives a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpServerId, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpServersDeleteOutput
    );
  }
  /**
   * @name Update magic MCP server
   * @description Updates a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `body` - DashboardInstanceMagicMcpServersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpServerId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpServersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_magic-mcp-servers_providers.ts
var MetorialManagementInstanceMagicMcpServersProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP server providers
   * @description Returns the backing integration instance providers configured for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `query` - DashboardInstanceMagicMcpServersProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, magicMcpServerId, query, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpServersProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersListOutput
    );
  }
  /**
   * @name Create magic MCP server provider
   * @description Creates a configurable provider row for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `body` - DashboardInstanceMagicMcpServersProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, magicMcpServerId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersCreateOutput
    );
  }
  /**
   * @name Get magic MCP server provider
   * @description Retrieves a specific backing integration instance provider for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpServerId, magicMcpServerProviderId, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersGetOutput
    );
  }
  /**
   * @name Update magic MCP server provider
   * @description Updates a backing integration provider and then sets the corresponding integration instance provider for a magic MCP server.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `body` - DashboardInstanceMagicMcpServersProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpServerId, magicMcpServerProviderId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpServersProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersUpdateOutput
    );
  }
  /**
   * @name Delete magic MCP server provider
   * @description Archives a backing integration instance provider from a magic MCP server and removes the shared integration provider when unused.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `magicMcpServerProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpServerId, magicMcpServerProviderId, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/providers/${magicMcpServerProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpServersProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_magic-mcp-servers_session.ts
var MetorialManagementInstanceMagicMcpServersSessionEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create linked magic MCP server session
   * @description Resolves the current internal ephemeral managed session for a magic MCP server and returns it as a dashboard session.
   *
   * @param `instanceId` - string
   * @param `magicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpServersSessionCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, magicMcpServerId, opts) {
    let path = `instances/${instanceId}/magic-mcp-servers/${magicMcpServerId}/session`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpServersSessionCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_magic-mcp-sessions.ts
var MetorialManagementInstanceMagicMcpSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP sessions
   * @description Returns a paginated list of magic MCP sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/magic-mcp-sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpSessionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpSessionsListOutput
    );
  }
  /**
   * @name Get magic MCP session
   * @description Retrieves a specific magic MCP session.
   *
   * @param `instanceId` - string
   * @param `magicMcpSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpSessionId, opts) {
    let path = `instances/${instanceId}/magic-mcp-sessions/${magicMcpSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpSessionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_magic-mcp-tokens.ts
var MetorialManagementInstanceMagicMcpTokensEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List magic MCP tokens
   * @description Returns a paginated list of magic MCP tokens.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMagicMcpTokensListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/magic-mcp-tokens`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMagicMcpTokensListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpTokensListOutput
    );
  }
  /**
   * @name Get magic MCP token
   * @description Retrieves a specific magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, magicMcpTokenId, opts) {
    let path = `instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMagicMcpTokensGetOutput
    );
  }
  /**
   * @name Create magic MCP token
   * @description Creates a new magic MCP token.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-tokens`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensCreateOutput
    );
  }
  /**
   * @name Delete magic MCP token
   * @description Deletes a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, magicMcpTokenId, opts) {
    let path = `instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceMagicMcpTokensDeleteOutput
    );
  }
  /**
   * @name Update magic MCP token
   * @description Updates a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, magicMcpTokenId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceMagicMcpTokensUpdateOutput
    );
  }
  /**
   * @name Add magic MCP groups to token
   * @description Adds groups to a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensAddGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensAddGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addGroups(instanceId, magicMcpTokenId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}/add-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensAddGroupsBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensAddGroupsOutput
    );
  }
  /**
   * @name Remove magic MCP groups from token
   * @description Removes groups from a magic MCP token.
   *
   * @param `instanceId` - string
   * @param `magicMcpTokenId` - string
   * @param `body` - DashboardInstanceMagicMcpTokensRemoveGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMagicMcpTokensRemoveGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeGroups(instanceId, magicMcpTokenId, body, opts) {
    let path = `instances/${instanceId}/magic-mcp-tokens/${magicMcpTokenId}/remove-groups`;
    let request = {
      path,
      body: mapDashboardInstanceMagicMcpTokensRemoveGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMagicMcpTokensRemoveGroupsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_monitor-alerts.ts
var MetorialManagementInstanceMonitorAlertsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List monitor alerts
   * @description Returns a paginated list of monitor alerts for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMonitorAlertsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/monitor-alerts`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMonitorAlertsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMonitorAlertsListOutput
    );
  }
  /**
   * @name Get monitor alert
   * @description Retrieves a monitor alert by ID.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, monitorAlertId, opts) {
    let path = `instances/${instanceId}/monitor-alerts/${monitorAlertId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMonitorAlertsGetOutput
    );
  }
  /**
   * @name Mark monitor alert viewed
   * @description Marks a monitor alert as viewed by the current actor.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsViewedOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  viewed(instanceId, monitorAlertId, opts) {
    let path = `instances/${instanceId}/monitor-alerts/${monitorAlertId}/viewed`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsViewedOutput
    );
  }
  /**
   * @name Resolve monitor alert
   * @description Marks a monitor alert as resolved.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resolve(instanceId, monitorAlertId, opts) {
    let path = `instances/${instanceId}/monitor-alerts/${monitorAlertId}/resolve`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsResolveOutput
    );
  }
  /**
   * @name Unresolve monitor alert
   * @description Reopens a resolved monitor alert.
   *
   * @param `instanceId` - string
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsUnresolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  unresolve(instanceId, monitorAlertId, opts) {
    let path = `instances/${instanceId}/monitor-alerts/${monitorAlertId}/unresolve`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsUnresolveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_monitors.ts
var MetorialManagementInstanceMonitorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List monitors
   * @description Returns a paginated list of monitors for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceMonitorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/monitors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceMonitorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceMonitorsListOutput);
  }
  /**
   * @name Get monitor
   * @description Retrieves a monitor by ID.
   *
   * @param `instanceId` - string
   * @param `monitorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, monitorId, opts) {
    let path = `instances/${instanceId}/monitors/${monitorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceMonitorsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_network-policies.ts
var MetorialManagementInstanceNetworkPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List network policies
   * @description Returns a paginated list of network policies.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceNetworkPoliciesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/network-policies`;
    let request = {
      path,
      query: query ? mapDashboardInstanceNetworkPoliciesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceNetworkPoliciesListOutput
    );
  }
  /**
   * @name Get network policy
   * @description Retrieves a specific network policy by ID.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, networkPolicyId, opts) {
    let path = `instances/${instanceId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceNetworkPoliciesGetOutput
    );
  }
  /**
   * @name Create network policy
   * @description Creates a new network policy.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/network-policies`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceNetworkPoliciesCreateOutput
    );
  }
  /**
   * @name Update network policy
   * @description Updates a network policy definition.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, networkPolicyId, body, opts) {
    let path = `instances/${instanceId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceNetworkPoliciesUpdateOutput
    );
  }
  /**
   * @name Delete network policy
   * @description Archives a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, networkPolicyId, opts) {
    let path = `instances/${instanceId}/network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceNetworkPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_network-policies_rules.ts
var MetorialManagementInstanceNetworkPoliciesRulesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create network policy rule
   * @description Adds a rule to a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesRulesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, networkPolicyId, body, opts) {
    let path = `instances/${instanceId}/network-policies/${networkPolicyId}/rules`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesRulesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesCreateOutput
    );
  }
  /**
   * @name Update network policy rule
   * @description Updates a rule on a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `ruleId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesRulesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, networkPolicyId, ruleId, body, opts) {
    let path = `instances/${instanceId}/network-policies/${networkPolicyId}/rules/${ruleId}`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesRulesUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesUpdateOutput
    );
  }
  /**
   * @name Delete network policy rule
   * @description Removes a rule from a network policy.
   *
   * @param `instanceId` - string
   * @param `networkPolicyId` - string
   * @param `ruleId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, networkPolicyId, ruleId, opts) {
    let path = `instances/${instanceId}/network-policies/${networkPolicyId}/rules/${ruleId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals.ts
var MetorialManagementInstancePortalsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portals
   * @description Returns a paginated list of portals.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePortalsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/portals`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstancePortalsListOutput);
  }
  /**
   * @name Get portal
   * @description Retrieves details for a specific portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstancePortalsGetOutput);
  }
  /**
   * @name Create portal
   * @description Creates a new portal for the instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstancePortalsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/portals`;
    let request = {
      path,
      body: mapDashboardInstancePortalsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsCreateOutput
    );
  }
  /**
   * @name Update portal
   * @description Updates an existing portal for the instance.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsUpdateOutput
    );
  }
  /**
   * @name Delete portal
   * @description Archives a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals_access-requests.ts
var MetorialManagementInstancePortalsAccessRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal access requests
   * @description Returns a paginated list of access requests for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsAccessRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access-requests`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsAccessRequestsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessRequestsListOutput
    );
  }
  /**
   * @name Get portal access request
   * @description Retrieves a access request by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, accessRequestId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access-requests/${accessRequestId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessRequestsGetOutput
    );
  }
  /**
   * @name Review portal access request
   * @description Approves or rejects a access request.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessRequestId` - string
   * @param `body` - DashboardInstancePortalsAccessRequestsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, accessRequestId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access-requests/${accessRequestId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessRequestsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsAccessRequestsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals_access.ts
var MetorialManagementInstancePortalsAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal access
   * @description Returns a paginated list of consumer access rules for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsAccessListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsAccessListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessListOutput
    );
  }
  /**
   * @name Get portal access
   * @description Retrieves a portal access rule by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, accessId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessGetOutput
    );
  }
  /**
   * @name Create portal access
   * @description Creates a new consumer access rule for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsAccessCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsAccessCreateOutput
    );
  }
  /**
   * @name Update portal access
   * @description Updates the shared listing fields for a portal access rule.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `body` - DashboardInstancePortalsAccessUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, accessId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsAccessUpdateOutput
    );
  }
  /**
   * @name Delete portal access
   * @description Deletes a consumer access rule from the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, accessId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsAccessDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals_consumer-groups.ts
var MetorialManagementInstancePortalsConsumerGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer groups
   * @description Returns a paginated list of consumer groups for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerGroupsListOutput
    );
  }
  /**
   * @name Get portal consumer group
   * @description Retrieves a portal consumer group by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerGroupId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerGroupsGetOutput
    );
  }
  /**
   * @name Create portal consumer group
   * @description Creates a new consumer group for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerGroupsCreateOutput
    );
  }
  /**
   * @name Update portal consumer group
   * @description Updates a consumer group for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `body` - DashboardInstancePortalsConsumerGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, consumerGroupId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsConsumerGroupsUpdateOutput
    );
  }
  /**
   * @name Delete portal consumer group
   * @description Archives a consumer group for the portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, consumerGroupId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsConsumerGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals_consumer-invites.ts
var MetorialManagementInstancePortalsConsumerInvitesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer invites
   * @description Returns a paginated list of invites for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerInvitesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-invites`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerInvitesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerInvitesListOutput
    );
  }
  /**
   * @name Create portal consumer invite
   * @description Invites a consumer to a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerInvitesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-invites`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerInvitesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerInvitesCreateOutput
    );
  }
  /**
   * @name Get portal consumer invite
   * @description Retrieves a portal consumer invite by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerInviteId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerInviteId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-invites/${consumerInviteId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerInvitesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals_consumer-profiles.ts
var MetorialManagementInstancePortalsConsumerProfilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer profiles
   * @description Returns a paginated list of consumer profiles for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerProfilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-profile`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerProfilesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerProfilesListOutput
    );
  }
  /**
   * @name Get portal consumer profile
   * @description Retrieves a portal consumer profile by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerProfileId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerProfilesGetOutput
    );
  }
  /**
   * @name Create portal consumer profile
   * @description Creates a new portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-profile`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesCreateOutput
    );
  }
  /**
   * @name Delete portal consumer profile
   * @description Soft-deletes a portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, consumerProfileId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsConsumerProfilesDeleteOutput
    );
  }
  /**
   * @name Assign portal consumer profile groups
   * @description Assigns one or more groups to a portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesAssignGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesAssignGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  assignGroups(instanceId, portalId, consumerProfileId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}/assign-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesAssignGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesAssignGroupsOutput
    );
  }
  /**
   * @name Unassign portal consumer profile groups
   * @description Removes one or more groups from a portal consumer profile.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesUnassignGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesUnassignGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  unassignGroups(instanceId, portalId, consumerProfileId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/consumer-profile/${consumerProfileId}/unassign-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesUnassignGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesUnassignGroupsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals_listings.ts
var MetorialManagementInstancePortalsListingsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal listings
   * @description Returns a paginated list of shared listings for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsListingsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/listings`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsListingsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsListingsListOutput
    );
  }
  /**
   * @name Get portal listing
   * @description Retrieves one shared listing for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, listingId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsListingsGetOutput
    );
  }
  /**
   * @name Create portal listing
   * @description Creates a shared listing for a portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsListingsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/listings`;
    let request = {
      path,
      body: mapDashboardInstancePortalsListingsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsListingsCreateOutput
    );
  }
  /**
   * @name Update portal listing
   * @description Updates listing metadata for a portal listing.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `body` - DashboardInstancePortalsListingsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, listingId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsListingsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsListingsUpdateOutput
    );
  }
  /**
   * @name Delete portal listing
   * @description Deletes a portal listing and all consumer access attached to it.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, listingId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsListingsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_portals_surface-provider-groups.ts
var MetorialManagementInstancePortalsSurfaceProviderGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal surface provider groups
   * @description Returns a paginated list of provider groups linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsSurfaceProviderGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/surface-provider-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsSurfaceProviderGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsListOutput
    );
  }
  /**
   * @name Get portal surface provider group
   * @description Retrieves a portal surface provider group by ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, consumerSurfaceProviderGroupId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsGetOutput
    );
  }
  /**
   * @name Create portal surface provider group
   * @description Creates a new provider group linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/surface-provider-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsCreateOutput
    );
  }
  /**
   * @name Update portal surface provider group
   * @description Updates a provider group linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, consumerSurfaceProviderGroupId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsUpdateOutput
    );
  }
  /**
   * @name Delete portal surface provider group
   * @description Deletes a provider group linked to the portal consumer surface.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, consumerSurfaceProviderGroupId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsDeleteOutput
    );
  }
  /**
   * @name Add listing to surface provider group
   * @description Adds a consumer access listing to the surface provider group.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsAddListingBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsAddListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addListing(instanceId, portalId, consumerSurfaceProviderGroupId, body, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}/listings`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsAddListingBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsAddListingOutput
    );
  }
  /**
   * @name Remove listing from surface provider group
   * @description Removes a consumer access listing from the surface provider group.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `consumerAccessListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeListing(instanceId, portalId, consumerSurfaceProviderGroupId, consumerAccessListingId, opts) {
    let path = `instances/${instanceId}/portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}/listings/${consumerAccessListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_proto-guard-alerts.ts
var MetorialManagementInstanceProtoGuardAlertsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List ProtoGuard alerts
   * @description Returns a paginated list of ProtoGuard alerts for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProtoGuardAlertsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardAlertsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/protoguard-alerts`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProtoGuardAlertsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardAlertsListOutput
    );
  }
  /**
   * @name Get ProtoGuard alert
   * @description Retrieves a ProtoGuard alert by ID.
   *
   * @param `instanceId` - string
   * @param `protoGuardAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardAlertsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, protoGuardAlertId, opts) {
    let path = `instances/${instanceId}/protoguard-alerts/${protoGuardAlertId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardAlertsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_proto-guard-config.ts
var MetorialManagementInstanceProtoGuardConfigEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get ProtoGuard config
   * @description Retrieves ProtoGuard filter configuration for this instance.
   *
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, opts) {
    let path = `instances/${instanceId}/protoguard-config`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardConfigGetOutput
    );
  }
  /**
   * @name Update ProtoGuard filter config
   * @description Updates ProtoGuard filter settings for this instance.
   *
   * @param `instanceId` - string
   * @param `filterId` - string
   * @param `body` - DashboardInstanceProtoGuardConfigUpdateFilterBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigUpdateFilterOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  updateFilter(instanceId, filterId, body, opts) {
    let path = `instances/${instanceId}/protoguard-config/filters/${filterId}`;
    let request = {
      path,
      body: mapDashboardInstanceProtoGuardConfigUpdateFilterBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProtoGuardConfigUpdateFilterOutput
    );
  }
  /**
   * @name Set ProtoGuard alert filter count threshold
   * @description Sets or clears the number of matching ProtoGuard filters required to create an alert.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  setAlertFilterCountThreshold(instanceId, body, opts) {
    let path = `instances/${instanceId}/protoguard-config/alert-filter-count-threshold`;
    let request = {
      path,
      body: mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-auth-config-errors.ts
var MetorialManagementInstanceProviderAuthConfigErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config errors
   * @description Returns a paginated list of provider auth config errors for dashboard diagnostics.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderAuthConfigErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-config-errors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigErrorsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsListOutput
    );
  }
  /**
   * @name Get provider auth config error
   * @description Retrieves a specific provider auth config error by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigErrorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigErrorId, opts) {
    let path = `instances/${instanceId}/provider-auth-config-errors/${providerAuthConfigErrorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-auth-config-errors_groups.ts
var MetorialManagementInstanceProviderAuthConfigErrorsGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config error groups
   * @description Returns grouped provider auth config errors aggregated by type and canonical message.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderAuthConfigErrorsGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-config-error-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigErrorsGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGroupsListOutput
    );
  }
  /**
   * @name Get provider auth config error group
   * @description Retrieves a specific grouped provider auth config error by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigErrorGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigErrorGroupId, opts) {
    let path = `instances/${instanceId}/provider-auth-config-error-groups/${providerAuthConfigErrorGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGroupsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-auth-config-events.ts
var MetorialManagementInstanceProviderAuthConfigEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config events
   * @description Returns a paginated list of provider auth config events for dashboard diagnostics.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderAuthConfigEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-config-events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigEventsListOutput
    );
  }
  /**
   * @name Get provider auth config event
   * @description Retrieves a specific provider auth config event by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigEventId, opts) {
    let path = `instances/${instanceId}/provider-auth-config-events/${providerAuthConfigEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-categories.ts
var MetorialManagementInstanceProviderCategoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider categories
   * @description Returns a paginated list of provider categories.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderCategoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCategoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-categories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderCategoriesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCategoriesListOutput
    );
  }
  /**
   * @name Get provider category
   * @description Retrieves a specific provider category by ID.
   *
   * @param `instanceId` - string
   * @param `providerCategoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCategoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerCategoryId, opts) {
    let path = `instances/${instanceId}/provider-categories/${providerCategoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCategoriesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-collections.ts
var MetorialManagementInstanceProviderCollectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider collections
   * @description Returns a paginated list of provider collections.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderCollectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCollectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-collections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderCollectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCollectionsListOutput
    );
  }
  /**
   * @name Get provider collection
   * @description Retrieves a specific provider collection by ID.
   *
   * @param `instanceId` - string
   * @param `providerCollectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCollectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerCollectionId, opts) {
    let path = `instances/${instanceId}/provider-collections/${providerCollectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCollectionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments.ts
var MetorialManagementInstanceProviderDeploymentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider deployments
   * @description Returns a paginated list of provider deployments.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-deployments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsListOutput
    );
  }
  /**
   * @name Get provider deployment
   * @description Retrieves a specific provider deployment by ID.
   *
   * @param `instanceId` - string
   * @param `providerDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerDeploymentId, opts) {
    let path = `instances/${instanceId}/provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsGetOutput
    );
  }
  /**
   * @name Create provider deployment
   * @description Creates a new provider deployment.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-deployments`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsCreateOutput
    );
  }
  /**
   * @name Update provider deployment
   * @description Updates a specific provider deployment.
   *
   * @param `instanceId` - string
   * @param `providerDeploymentId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerDeploymentId, body, opts) {
    let path = `instances/${instanceId}/provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsUpdateOutput
    );
  }
  /**
   * @name Delete provider deployment
   * @description Permanently deletes a provider deployment.
   *
   * @param `instanceId` - string
   * @param `providerDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerDeploymentId, opts) {
    let path = `instances/${instanceId}/provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments_auth-configs.ts
var MetorialManagementInstanceProviderDeploymentsAuthConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth configs
   * @description Returns a paginated list of provider auth configs.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-configs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsListOutput
    );
  }
  /**
   * @name Get provider auth config
   * @description Retrieves a specific provider auth config by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthConfigId, opts) {
    let path = `instances/${instanceId}/provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsGetOutput
    );
  }
  /**
   * @name Create provider auth config
   * @description Creates a new provider auth config.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-auth-configs`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsCreateOutput
    );
  }
  /**
   * @name Update provider auth config
   * @description Updates a specific provider auth config.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerAuthConfigId, body, opts) {
    let path = `instances/${instanceId}/provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput
    );
  }
  /**
   * @name Delete provider auth config
   * @description Permanently deletes a provider auth config.
   *
   * @param `instanceId` - string
   * @param `providerAuthConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerAuthConfigId, opts) {
    let path = `instances/${instanceId}/provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments_auth-configs_exports.ts
var MetorialManagementInstanceProviderDeploymentsAuthConfigsExportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth exports
   * @description Returns a paginated list of provider auth exports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-config-exports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput
    );
  }
  /**
   * @name Get provider auth export
   * @description Retrieves a specific provider auth export by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthExportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthExportId, opts) {
    let path = `instances/${instanceId}/provider-auth-config-exports/${providerAuthExportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput
    );
  }
  /**
   * @name Create provider auth export
   * @description Exports authentication credentials from a provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-auth-config-exports`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments_auth-configs_imports.ts
var MetorialManagementInstanceProviderDeploymentsAuthConfigsImportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth imports
   * @description Returns a paginated list of provider auth imports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-config-imports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput
    );
  }
  /**
   * @name Get provider auth import
   * @description Retrieves a specific provider auth import by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthImportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthImportId, opts) {
    let path = `instances/${instanceId}/provider-auth-config-imports/${providerAuthImportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput
    );
  }
  /**
   * @name Create provider auth import
   * @description Imports authentication credentials for a provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-auth-config-imports`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput
    );
  }
  /**
   * @name Get auth import schema
   * @description Retrieves the JSON Schema for importing authentication credentials.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getSchema(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-config-imports/schema`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments_auth-credentials.ts
var MetorialManagementInstanceProviderDeploymentsAuthCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth credentials
   * @description Returns a paginated list of provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsAuthCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-credentials`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthCredentialsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsListOutput
    );
  }
  /**
   * @name Get provider auth credentials
   * @description Retrieves specific provider auth credentials by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthCredentialsId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthCredentialsId, opts) {
    let path = `instances/${instanceId}/provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsGetOutput
    );
  }
  /**
   * @name Create provider auth credentials
   * @description Creates new provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-auth-credentials`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput
    );
  }
  /**
   * @name Update provider auth credentials
   * @description Updates specific provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `providerAuthCredentialsId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerAuthCredentialsId, body, opts) {
    let path = `instances/${instanceId}/provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput
    );
  }
  /**
   * @name Delete provider auth credentials
   * @description Permanently deletes provider auth credentials.
   *
   * @param `instanceId` - string
   * @param `providerAuthCredentialsId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerAuthCredentialsId, opts) {
    let path = `instances/${instanceId}/provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments_config-vaults.ts
var MetorialManagementInstanceProviderDeploymentsConfigVaultsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider config vaults
   * @description Returns a paginated list of provider config vaults.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsConfigVaultsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-config-vaults`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigVaultsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsListOutput
    );
  }
  /**
   * @name Get provider config vault
   * @description Retrieves a specific provider config vault by ID.
   *
   * @param `instanceId` - string
   * @param `providerConfigVaultId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerConfigVaultId, opts) {
    let path = `instances/${instanceId}/provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsGetOutput
    );
  }
  /**
   * @name Create provider config vault
   * @description Creates a new provider config vault.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigVaultsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-config-vaults`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigVaultsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsCreateOutput
    );
  }
  /**
   * @name Update provider config vault
   * @description Updates a specific provider config vault.
   *
   * @param `instanceId` - string
   * @param `providerConfigVaultId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigVaultsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerConfigVaultId, body, opts) {
    let path = `instances/${instanceId}/provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput
    );
  }
  /**
   * @name Delete provider config vault
   * @description Permanently deletes a provider config vault.
   *
   * @param `instanceId` - string
   * @param `providerConfigVaultId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerConfigVaultId, opts) {
    let path = `instances/${instanceId}/provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments_configs.ts
var MetorialManagementInstanceProviderDeploymentsConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider configs
   * @description Returns a paginated list of provider configs.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-configs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsListOutput
    );
  }
  /**
   * @name Get provider config
   * @description Retrieves a specific provider config by ID.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerConfigId, opts) {
    let path = `instances/${instanceId}/provider-configs/${providerConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetOutput
    );
  }
  /**
   * @name Create provider config
   * @description Creates a new provider config.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-configs`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsCreateOutput
    );
  }
  /**
   * @name Update provider config
   * @description Updates a specific provider config. Passing `value` replaces its configuration values with a new config version.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerConfigId, body, opts) {
    let path = `instances/${instanceId}/provider-configs/${providerConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsUpdateOutput
    );
  }
  /**
   * @name Get provider config value
   * @description Retrieves a provider config's current configuration values, unless the provider stores them encrypted.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetValueOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getValue(instanceId, providerConfigId, opts) {
    let path = `instances/${instanceId}/provider-configs/${providerConfigId}/value`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetValueOutput
    );
  }
  /**
   * @name Delete provider config
   * @description Permanently deletes a provider config.
   *
   * @param `instanceId` - string
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerConfigId, opts) {
    let path = `instances/${instanceId}/provider-configs/${providerConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsDeleteOutput
    );
  }
  /**
   * @name Get config schema
   * @description Retrieves the JSON Schema for configuration of this provider deployment.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getConfigSchema(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-config-schema`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-deployments_setup-sessions.ts
var MetorialManagementInstanceProviderDeploymentsSetupSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider setup sessions
   * @description Returns a paginated list of provider setup sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderDeploymentsSetupSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-setup-sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsSetupSessionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsListOutput
    );
  }
  /**
   * @name Get provider setup session
   * @description Retrieves a specific provider setup session by ID.
   *
   * @param `instanceId` - string
   * @param `providerSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerSetupSessionId, opts) {
    let path = `instances/${instanceId}/provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsGetOutput
    );
  }
  /**
   * @name Create provider setup session
   * @description Creates a new provider setup session for OAuth authentication.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsSetupSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-setup-sessions`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsSetupSessionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsCreateOutput
    );
  }
  /**
   * @name Update provider setup session
   * @description Updates a specific provider setup session.
   *
   * @param `instanceId` - string
   * @param `providerSetupSessionId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsSetupSessionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerSetupSessionId, body, opts) {
    let path = `instances/${instanceId}/provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput
    );
  }
  /**
   * @name Delete provider setup session
   * @description Deletes a provider setup session.
   *
   * @param `instanceId` - string
   * @param `providerSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerSetupSessionId, opts) {
    let path = `instances/${instanceId}/provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-groups.ts
var MetorialManagementInstanceProviderGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider groups
   * @description Returns a paginated list of provider groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderGroupsListOutput
    );
  }
  /**
   * @name Get provider group
   * @description Retrieves a specific provider group by ID.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerGroupId, opts) {
    let path = `instances/${instanceId}/provider-groups/${providerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderGroupsGetOutput
    );
  }
  /**
   * @name Create provider group
   * @description Creates a new custom provider group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-groups`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderGroupsCreateOutput
    );
  }
  /**
   * @name Update provider group
   * @description Updates an existing provider group.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `body` - DashboardInstanceProviderGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerGroupId, body, opts) {
    let path = `instances/${instanceId}/provider-groups/${providerGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderGroupsUpdateOutput
    );
  }
  /**
   * @name Add listing to group
   * @description Adds a provider listing to a group.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `body` - DashboardInstanceProviderGroupsAddListingBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsAddListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addListing(instanceId, providerGroupId, body, opts) {
    let path = `instances/${instanceId}/provider-groups/${providerGroupId}/listings`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsAddListingBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderGroupsAddListingOutput
    );
  }
  /**
   * @name Remove listing from group
   * @description Removes a provider listing from a group.
   *
   * @param `instanceId` - string
   * @param `providerGroupId` - string
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsRemoveListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeListing(instanceId, providerGroupId, providerListingId, opts) {
    let path = `instances/${instanceId}/provider-groups/${providerGroupId}/listings/${providerListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderGroupsRemoveListingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-invocations.ts
var MetorialManagementInstanceProviderInvocationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get provider invocation
   * @description Returns a single normalized provider invocation by ID.
   *
   * @param `instanceId` - string
   * @param `providerInvocationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderInvocationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerInvocationId, opts) {
    let path = `instances/${instanceId}/provider-invocations/${providerInvocationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderInvocationsGetOutput
    );
  }
  /**
   * @name List provider invocations
   * @description Returns normalized provider invocations and their logs for dashboard diagnostics.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderInvocationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderInvocationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-invocations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderInvocationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderInvocationsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-listings.ts
var MetorialManagementInstanceProviderListingsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider listings
   * @description Returns a paginated list of provider listings.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderListingsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-listings`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderListingsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderListingsListOutput
    );
  }
  /**
   * @name Get provider listing
   * @description Retrieves a specific provider listing by ID.
   *
   * @param `instanceId` - string
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerListingId, opts) {
    let path = `instances/${instanceId}/provider-listings/${providerListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderListingsGetOutput
    );
  }
  /**
   * @name Update provider listing
   * @description Updates how a provider listing appears in the library. Edited fields survive catalog re-syncs.
   *
   * @param `instanceId` - string
   * @param `providerListingId` - string
   * @param `body` - DashboardInstanceProviderListingsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerListingId, body, opts) {
    let path = `instances/${instanceId}/provider-listings/${providerListingId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderListingsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderListingsUpdateOutput
    );
  }
  /**
   * @name Reset provider listing
   * @description Drops the admin customization so the next catalog sync restores the original name, description, readme, logo, categories and rank.
   *
   * @param `instanceId` - string
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsResetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  reset(instanceId, providerListingId, opts) {
    let path = `instances/${instanceId}/provider-listings/${providerListingId}/reset`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderListingsResetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-runs.ts
var MetorialManagementInstanceProviderRunsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all provider runs
   * @description Returns a paginated list of provider runs across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderRunsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-runs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderRunsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsListOutput
    );
  }
  /**
   * @name Get provider run
   * @description Retrieves a specific provider run by ID.
   *
   * @param `instanceId` - string
   * @param `providerRunId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerRunId, opts) {
    let path = `instances/${instanceId}/provider-runs/${providerRunId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsGetOutput
    );
  }
  /**
   * @name Get provider run logs
   * @description Retrieves the logs for a specific provider run.
   *
   * @param `instanceId` - string
   * @param `providerRunId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsGetLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getLogs(instanceId, providerRunId, opts) {
    let path = `instances/${instanceId}/provider-runs/${providerRunId}/logs`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsGetLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-specification-change-notifications.ts
var MetorialManagementInstanceProviderSpecificationChangeNotificationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider specification change notifications
   * @description Returns a paginated list of provider specification change notifications for this instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderSpecificationChangeNotificationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderSpecificationChangeNotificationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-specification-change-notifications`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderSpecificationChangeNotificationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderSpecificationChangeNotificationsListOutput
    );
  }
  /**
   * @name Get provider specification change notification
   * @description Retrieves a provider specification change notification by ID.
   *
   * @param `instanceId` - string
   * @param `notificationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderSpecificationChangeNotificationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, notificationId, opts) {
    let path = `instances/${instanceId}/provider-specification-change-notifications/${notificationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderSpecificationChangeNotificationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_provider-templates.ts
var MetorialManagementInstanceProviderTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider templates
   * @description Returns a paginated list of provider templates.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProviderTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-templates`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderTemplatesListOutput
    );
  }
  /**
   * @name Get provider template
   * @description Retrieves a specific provider template.
   *
   * @param `instanceId` - string
   * @param `providerTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerTemplateId, opts) {
    let path = `instances/${instanceId}/provider-templates/${providerTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderTemplatesGetOutput
    );
  }
  /**
   * @name Create provider template
   * @description Creates a new provider template from an existing integration.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceProviderTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/provider-templates`;
    let request = {
      path,
      body: mapDashboardInstanceProviderTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderTemplatesCreateOutput
    );
  }
  /**
   * @name Update provider template
   * @description Updates an existing provider template.
   *
   * @param `instanceId` - string
   * @param `providerTemplateId` - string
   * @param `body` - DashboardInstanceProviderTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, providerTemplateId, body, opts) {
    let path = `instances/${instanceId}/provider-templates/${providerTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderTemplatesUpdateOutput
    );
  }
  /**
   * @name Archive provider template
   * @description Archives an existing provider template.
   *
   * @param `instanceId` - string
   * @param `providerTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, providerTemplateId, opts) {
    let path = `instances/${instanceId}/provider-templates/${providerTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderTemplatesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_providers.ts
var MetorialManagementInstanceProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List providers
   * @description Returns a paginated list of providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersListOutput
    );
  }
  /**
   * @name Get provider
   * @description Retrieves a specific provider by ID.
   *
   * @param `instanceId` - string
   * @param `providerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerId, opts) {
    let path = `instances/${instanceId}/providers/${providerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceProvidersGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_providers_auth-methods.ts
var MetorialManagementInstanceProvidersAuthMethodsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth methods
   * @description Returns a paginated list of provider auth methods.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersAuthMethodsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersAuthMethodsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-auth-methods`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersAuthMethodsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersAuthMethodsListOutput
    );
  }
  /**
   * @name Get provider auth method
   * @description Retrieves a specific provider auth method by ID.
   *
   * @param `instanceId` - string
   * @param `providerAuthMethodId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersAuthMethodsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerAuthMethodId, opts) {
    let path = `instances/${instanceId}/provider-auth-methods/${providerAuthMethodId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersAuthMethodsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_providers_specifications.ts
var MetorialManagementInstanceProvidersSpecificationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider specifications
   * @description Returns a paginated list of provider specifications.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersSpecificationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersSpecificationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-specifications`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersSpecificationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersSpecificationsListOutput
    );
  }
  /**
   * @name Get provider specification
   * @description Retrieves a specific provider specification by ID.
   *
   * @param `instanceId` - string
   * @param `providerSpecificationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersSpecificationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerSpecificationId, opts) {
    let path = `instances/${instanceId}/provider-specifications/${providerSpecificationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersSpecificationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_providers_tools.ts
var MetorialManagementInstanceProvidersToolsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider tools
   * @description Returns a paginated list of provider tools. By default returns tools from the latest version. Use optional filters to get tools for a specific version.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersToolsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersToolsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-tools`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersToolsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersToolsListOutput
    );
  }
  /**
   * @name Get provider tool
   * @description Retrieves a specific provider tool by ID.
   *
   * @param `instanceId` - string
   * @param `providerToolId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersToolsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerToolId, opts) {
    let path = `instances/${instanceId}/provider-tools/${providerToolId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersToolsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_providers_triggers.ts
var MetorialManagementInstanceProvidersTriggersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider triggers
   * @description Returns a paginated list of provider triggers for a specific provider version.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstanceProvidersTriggersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns ManagementInstanceProvidersTriggersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-triggers`;
    let request = {
      path,
      query: query ? mapManagementInstanceProvidersTriggersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapManagementInstanceProvidersTriggersListOutput
    );
  }
  /**
   * @name Get provider trigger
   * @description Retrieves a specific provider trigger by ID.
   *
   * @param `instanceId` - string
   * @param `providerTriggerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersTriggersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerTriggerId, opts) {
    let path = `instances/${instanceId}/provider-triggers/${providerTriggerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersTriggersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_providers_versions.ts
var MetorialManagementInstanceProvidersVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider versions
   * @description Returns a paginated list of provider versions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceProvidersVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/provider-versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersVersionsListOutput
    );
  }
  /**
   * @name Get provider version
   * @description Retrieves a specific provider version by ID.
   *
   * @param `instanceId` - string
   * @param `providerVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, providerVersionId, opts) {
    let path = `instances/${instanceId}/provider-versions/${providerVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_public-mcp-servers.ts
var MetorialManagementInstancePublicMcpServersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP servers
   * @description Returns a paginated list of public MCP servers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePublicMcpServersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/public-mcp-servers`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersListOutput
    );
  }
  /**
   * @name Get public MCP server
   * @description Retrieves a specific public MCP server by ID.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, publicMcpServerId, opts) {
    let path = `instances/${instanceId}/public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGetOutput
    );
  }
  /**
   * @name Create public MCP server
   * @description Creates a public MCP server for a provider deployment.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstancePublicMcpServersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/public-mcp-servers`;
    let request = {
      path,
      body: mapDashboardInstancePublicMcpServersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePublicMcpServersCreateOutput
    );
  }
  /**
   * @name Update public MCP server
   * @description Updates a public MCP server. Set status to disabled to stop accepting connections.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `body` - DashboardInstancePublicMcpServersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, publicMcpServerId, body, opts) {
    let path = `instances/${instanceId}/public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      body: mapDashboardInstancePublicMcpServersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePublicMcpServersUpdateOutput
    );
  }
  /**
   * @name Delete public MCP server
   * @description Archives a public MCP server, revokes every grant, and releases its slug.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, publicMcpServerId, opts) {
    let path = `instances/${instanceId}/public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePublicMcpServersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_public-mcp-servers_clients.ts
var MetorialManagementInstancePublicMcpServersClientsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP server clients
   * @description Returns the OAuth clients registered with a public MCP server.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `query` - DashboardInstancePublicMcpServersClientsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersClientsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, publicMcpServerId, query, opts) {
    let path = `instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/clients`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersClientsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersClientsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_public-mcp-servers_grants.ts
var MetorialManagementInstancePublicMcpServersGrantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP server grants
   * @description Returns the end-user grants of a public MCP server.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `query` - DashboardInstancePublicMcpServersGrantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, publicMcpServerId, query, opts) {
    let path = `instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/grants`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersGrantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGrantsListOutput
    );
  }
  /**
   * @name Get public MCP server grant
   * @description Retrieves a specific end-user grant.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `publicMcpServerGrantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, publicMcpServerId, publicMcpServerGrantId, opts) {
    let path = `instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/grants/${publicMcpServerGrantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGrantsGetOutput
    );
  }
  /**
   * @name Revoke public MCP server grant
   * @description Revokes an end-user grant. Its tokens stop working and the user's credentials are deleted.
   *
   * @param `instanceId` - string
   * @param `publicMcpServerId` - string
   * @param `publicMcpServerGrantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(instanceId, publicMcpServerId, publicMcpServerGrantId, opts) {
    let path = `instances/${instanceId}/public-mcp-servers/${publicMcpServerId}/grants/${publicMcpServerGrantId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePublicMcpServersGrantsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_public-mcp-servers_slugs.ts
var MetorialManagementInstancePublicMcpServersSlugsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Check public MCP server slug
   * @description Checks whether a slug can be claimed for a new public MCP server.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePublicMcpServersSlugsCheckQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersSlugsCheckOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  check(instanceId, query, opts) {
    let path = `instances/${instanceId}/public-mcp-server-slugs/availability`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersSlugsCheckQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersSlugsCheckOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_publishers.ts
var MetorialManagementInstancePublishersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List publishers
   * @description Returns a paginated list of publishers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstancePublishersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublishersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/publishers`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublishersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublishersListOutput
    );
  }
  /**
   * @name Get publisher
   * @description Retrieves a specific publisher by ID.
   *
   * @param `instanceId` - string
   * @param `publisherId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublishersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, publisherId, opts) {
    let path = `instances/${instanceId}/publishers/${publisherId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublishersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_disks.ts
var MetorialManagementInstanceSandboxDisksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox disks
   * @description Returns a paginated list of disks.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxDisksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/sandbox/disks`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksListOutput
    );
  }
  /**
   * @name Get sandbox disk
   * @description Retrieves a disk by ID.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, diskId, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksGetOutput
    );
  }
  /**
   * @name Create sandbox disk
   * @description Creates an empty disk.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSandboxDisksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/sandbox/disks`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksCreateOutput
    );
  }
  /**
   * @name Update sandbox disk
   * @description Updates a disk name and metadata. Only metadata can be updated for root filesystem disks.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, diskId, body, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxDisksUpdateOutput
    );
  }
  /**
   * @name Delete sandbox disk
   * @description Deletes a disk. Root filesystem disks cannot be deleted; they are removed with their machine.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, diskId, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxDisksDeleteOutput
    );
  }
  /**
   * @name Clone sandbox disk
   * @description Creates a copy of a disk in the same region.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksCloneBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksCloneOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  clone(instanceId, diskId, body, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}/clone`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksCloneBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksCloneOutput
    );
  }
  /**
   * @name Resize sandbox disk
   * @description Starts growing a disk to a larger size.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksResizeBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resize(instanceId, diskId, body, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}/resize`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksResizeBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksResizeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_disks_mounts.ts
var MetorialManagementInstanceSandboxDisksMountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List disk mounts
   * @description Returns a paginated list of the times a disk was mounted into a machine.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `query` - DashboardInstanceSandboxDisksMountsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksMountsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, diskId, query, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}/mounts`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksMountsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksMountsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_disks_resizes.ts
var MetorialManagementInstanceSandboxDisksResizesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List disk resizes
   * @description Returns a paginated list of the resizes of a disk.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `query` - DashboardInstanceSandboxDisksResizesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, diskId, query, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}/resizes`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksResizesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksResizesListOutput
    );
  }
  /**
   * @name Get disk resize
   * @description Retrieves a resize of a disk.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `resizeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, diskId, resizeId, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}/resizes/${resizeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksResizesGetOutput
    );
  }
  /**
   * @name Retry disk resize
   * @description Retries a resize that failed.
   *
   * @param `instanceId` - string
   * @param `diskId` - string
   * @param `resizeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesRetryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  retry(instanceId, diskId, resizeId, opts) {
    let path = `instances/${instanceId}/sandbox/disks/${diskId}/resizes/${resizeId}/retry`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksResizesRetryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_image-builds.ts
var MetorialManagementInstanceSandboxImageBuildsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image builds
   * @description Returns a paginated list of image builds across all images.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxImageBuildsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/sandbox/image-builds`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImageBuildsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsListOutput
    );
  }
  /**
   * @name Get image build
   * @description Retrieves an image build by ID.
   *
   * @param `instanceId` - string
   * @param `buildId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, buildId, opts) {
    let path = `instances/${instanceId}/sandbox/image-builds/${buildId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsGetOutput
    );
  }
  /**
   * @name Cancel image build
   * @description Cancels a build that is still running.
   *
   * @param `instanceId` - string
   * @param `buildId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsCancelOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  cancel(instanceId, buildId, opts) {
    let path = `instances/${instanceId}/sandbox/image-builds/${buildId}/cancel`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImageBuildsCancelOutput
    );
  }
  /**
   * @name Get image build logs
   * @description Returns a page of the build output.
   *
   * @param `instanceId` - string
   * @param `buildId` - string
   * @param `query` - DashboardInstanceSandboxImageBuildsLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  logs(instanceId, buildId, query, opts) {
    let path = `instances/${instanceId}/sandbox/image-builds/${buildId}/logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImageBuildsLogsQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_images.ts
var MetorialManagementInstanceSandboxImagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox images
   * @description Returns a paginated list of the images you can create machines from.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxImagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/sandbox/images`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesListOutput
    );
  }
  /**
   * @name Get sandbox image
   * @description Retrieves an image by ID.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, imageId, opts) {
    let path = `instances/${instanceId}/sandbox/images/${imageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesGetOutput
    );
  }
  /**
   * @name Create sandbox image
   * @description Creates an empty image. Build a version of it to make it available to machines.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSandboxImagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/sandbox/images`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImagesCreateOutput
    );
  }
  /**
   * @name Update sandbox image
   * @description Updates the name and metadata of one of your images.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `body` - DashboardInstanceSandboxImagesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, imageId, body, opts) {
    let path = `instances/${instanceId}/sandbox/images/${imageId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxImagesUpdateOutput
    );
  }
  /**
   * @name Delete sandbox image
   * @description Deletes one of your images and cancels its running builds.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, imageId, opts) {
    let path = `instances/${instanceId}/sandbox/images/${imageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxImagesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_images_builds.ts
var MetorialManagementInstanceSandboxImagesBuildsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image builds
   * @description Returns a paginated list of the builds of an image.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `query` - DashboardInstanceSandboxImagesBuildsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesBuildsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, imageId, query, opts) {
    let path = `instances/${instanceId}/sandbox/images/${imageId}/builds`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesBuildsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesBuildsListOutput
    );
  }
  /**
   * @name Build image
   * @description Builds a new version of an image from a Dockerfile. Upload the build context as a file with the sandbox_image_build_context purpose first.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `body` - DashboardInstanceSandboxImagesBuildsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesBuildsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, imageId, body, opts) {
    let path = `instances/${instanceId}/sandbox/images/${imageId}/builds`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesBuildsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImagesBuildsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_images_versions.ts
var MetorialManagementInstanceSandboxImagesVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image versions
   * @description Returns a paginated list of the versions of an image.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `query` - DashboardInstanceSandboxImagesVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, imageId, query, opts) {
    let path = `instances/${instanceId}/sandbox/images/${imageId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesVersionsListOutput
    );
  }
  /**
   * @name Get image version
   * @description Retrieves a version of an image.
   *
   * @param `instanceId` - string
   * @param `imageId` - string
   * @param `versionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, imageId, versionId, opts) {
    let path = `instances/${instanceId}/sandbox/images/${imageId}/versions/${versionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_machines.ts
var MetorialManagementInstanceSandboxMachinesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox machines
   * @description Returns a paginated list of machines.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxMachinesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesListOutput
    );
  }
  /**
   * @name Get sandbox machine
   * @description Retrieves a machine by ID.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesGetOutput
    );
  }
  /**
   * @name Create sandbox machine
   * @description Creates a machine and, unless disabled, starts it.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSandboxMachinesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/sandbox/machines`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesCreateOutput
    );
  }
  /**
   * @name Update sandbox machine
   * @description Updates a machine. Changes to its size, runtime, or mounts take effect once the machine restarts, which happens on its own for a running machine, and the machine reports restart_required until then.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, machineId, body, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxMachinesUpdateOutput
    );
  }
  /**
   * @name Terminate sandbox machine
   * @description Terminates a machine and deletes its root disk.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, machineId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxMachinesDeleteOutput
    );
  }
  /**
   * @name Start sandbox machine
   * @description Starts a paused or hibernated machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesStartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  start(instanceId, machineId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/start`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesStartOutput
    );
  }
  /**
   * @name Pause sandbox machine
   * @description Pauses a running machine and keeps its memory state.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesPauseOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  pause(instanceId, machineId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/pause`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesPauseOutput
    );
  }
  /**
   * @name Hibernate sandbox machine
   * @description Hibernates a machine so it stops consuming compute resources.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesHibernateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  hibernate(instanceId, machineId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/hibernate`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesHibernateOutput
    );
  }
  /**
   * @name Restart sandbox machine
   * @description Restarts a machine on a fresh instance.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesRestartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  restart(instanceId, machineId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/restart`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesRestartOutput
    );
  }
  /**
   * @name Touch sandbox machine
   * @description Records activity so the machine is not paused for being idle.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesTouchOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  touch(instanceId, machineId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/touch`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesTouchOutput
    );
  }
  /**
   * @name List sandbox machine usage
   * @description Returns resource usage samples of a machine, newest first.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  usage(instanceId, machineId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/usage`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageOutput
    );
  }
  /**
   * @name Run a command
   * @description Runs a shell command in the machine and returns its exit code and output. Non-interactive; starts the machine if needed.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesExecBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesExecOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  exec(instanceId, machineId, body, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/exec`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesExecBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesExecOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_machines_access.ts
var MetorialManagementInstanceSandboxMachinesAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create shell access
   * @description Creates a short-lived token for an interactive shell in the machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessShellBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessShellOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  shell(instanceId, machineId, body, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/access/shell`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessShellBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessShellOutput
    );
  }
  /**
   * @name Create files access
   * @description Creates a short-lived token for the machine's file service.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessFilesBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessFilesOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  files(instanceId, machineId, body, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/access/files`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessFilesBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessFilesOutput
    );
  }
  /**
   * @name Create port access
   * @description Creates a short-lived token for reaching ports inside the machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessPortsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessPortsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  ports(instanceId, machineId, body, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/access/ports`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessPortsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessPortsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_machines_errors.ts
var MetorialManagementInstanceSandboxMachinesErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine errors
   * @description Returns a paginated list of the errors reported by a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/errors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesErrorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesErrorsListOutput
    );
  }
  /**
   * @name Get machine error
   * @description Retrieves an error reported by a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `errorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, errorId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/errors/${errorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_machines_events.ts
var MetorialManagementInstanceSandboxMachinesEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine events
   * @description Returns a paginated list of the events of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesEventsListOutput
    );
  }
  /**
   * @name Get machine event
   * @description Retrieves an event of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, eventId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_machines_instances.ts
var MetorialManagementInstanceSandboxMachinesInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine instances
   * @description Returns a paginated list of the instances of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesInstancesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesListOutput
    );
  }
  /**
   * @name Get machine instance
   * @description Retrieves an instance of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `machineInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, machineInstanceId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/instances/${machineInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesGetOutput
    );
  }
  /**
   * @name Get machine instance logs
   * @description Returns a page of the console output of an instance.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `machineInstanceId` - string
   * @param `query` - DashboardInstanceSandboxMachinesInstancesLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  logs(instanceId, machineId, machineInstanceId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/instances/${machineInstanceId}/logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesInstancesLogsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_machines_operations.ts
var MetorialManagementInstanceSandboxMachinesOperationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine operations
   * @description Returns a paginated list of the operations of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesOperationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesOperationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, machineId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/operations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesOperationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesOperationsListOutput
    );
  }
  /**
   * @name Get machine operation
   * @description Retrieves an operation of a machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `operationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesOperationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, machineId, operationId, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/operations/${operationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesOperationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_machines_usage.ts
var MetorialManagementInstanceSandboxMachinesUsageEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get sandbox machine usage timeline
   * @description Returns chronological usage buckets. Minute data is retained for 7 days and hourly data for 30 days. Zero samples means no observations, not necessarily a stopped machine.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageTimelineQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageTimelineOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  timeline(instanceId, machineId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/usage/timeline`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageTimelineQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageTimelineOutput
    );
  }
  /**
   * @name Get sandbox machine usage summary
   * @description Returns totals and averages for a range. Summary bounds align independently to minute or hour source buckets. Use a timeline’s effective bounds to compare its totals with a summary.
   *
   * @param `instanceId` - string
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageSummaryQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageSummaryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  summary(instanceId, machineId, query, opts) {
    let path = `instances/${instanceId}/sandbox/machines/${machineId}/usage/summary`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageSummaryQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageSummaryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_regions.ts
var MetorialManagementInstanceSandboxRegionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox regions
   * @description Returns a paginated list of regions sandboxes can run in.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxRegionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxRegionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/sandbox/regions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxRegionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxRegionsListOutput
    );
  }
  /**
   * @name Get sandbox region
   * @description Retrieves a sandbox region by its identifier.
   *
   * @param `instanceId` - string
   * @param `regionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxRegionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, regionId, opts) {
    let path = `instances/${instanceId}/sandbox/regions/${regionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxRegionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sandbox_specs.ts
var MetorialManagementInstanceSandboxSpecsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox specs
   * @description Returns a paginated list of machine specs. The available field shows whether your plan allows creating machines of that size.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSandboxSpecsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxSpecsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/sandbox/specs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxSpecsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxSpecsListOutput
    );
  }
  /**
   * @name Get sandbox spec
   * @description Retrieves a machine spec by ID.
   *
   * @param `instanceId` - string
   * @param `specId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxSpecsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, specId, opts) {
    let path = `instances/${instanceId}/sandbox/specs/${specId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxSpecsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_scm_accounts.ts
var MetorialManagementInstanceScmAccountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Preview SCM accounts
   * @description Lists available accounts from an SCM installation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmAccountsPreviewBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmAccountsPreviewOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  preview(instanceId, body, opts) {
    let path = `instances/${instanceId}/scm/accounts/preview`;
    let request = {
      path,
      body: mapDashboardInstanceScmAccountsPreviewBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmAccountsPreviewOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_scm_connections.ts
var MetorialManagementInstanceScmConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM connections
   * @description Returns a paginated list of SCM connections.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/scm/connections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmConnectionsListOutput
    );
  }
  /**
   * @name Get SCM connection
   * @description Retrieves a specific SCM connection by ID.
   *
   * @param `instanceId` - string
   * @param `scmConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, scmConnectionId, opts) {
    let path = `instances/${instanceId}/scm/connections/${scmConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmConnectionsGetOutput
    );
  }
  /**
   * @name Create SCM connection
   * @description Initiates an SCM connection setup session.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmConnectionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/scm/connections`;
    let request = {
      path,
      body: mapDashboardInstanceScmConnectionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmConnectionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_scm_installation.ts
var MetorialManagementInstanceScmInstallationEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM installations
   * @description Returns a paginated list of SCM installations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmInstallationListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmInstallationListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/scm/installations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmInstallationListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmInstallationListOutput
    );
  }
  /**
   * @name Create SCM installation
   * @description Initiates an SCM installation setup (e.g. GitHub App authorization).
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmInstallationCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmInstallationCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/scm/installations`;
    let request = {
      path,
      body: mapDashboardInstanceScmInstallationCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmInstallationCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_scm_providers.ts
var MetorialManagementInstanceScmProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM providers
   * @description Returns a paginated list of SCM providers.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/scm/providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmProvidersListOutput
    );
  }
  /**
   * @name Get SCM provider
   * @description Retrieves a specific SCM provider by ID.
   *
   * @param `instanceId` - string
   * @param `scmProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, scmProviderId, opts) {
    let path = `instances/${instanceId}/scm/providers/${scmProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmProvidersGetOutput
    );
  }
  /**
   * @name Create SCM provider
   * @description Initiates a setup session for a self-hosted SCM provider.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/scm/providers`;
    let request = {
      path,
      body: mapDashboardInstanceScmProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmProvidersCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_scm_repos.ts
var MetorialManagementInstanceScmReposEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM repos
   * @description Returns a paginated list of SCM repositories.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceScmReposListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/scm/repos`;
    let request = {
      path,
      query: query ? mapDashboardInstanceScmReposListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceScmReposListOutput);
  }
  /**
   * @name Get SCM repo
   * @description Retrieves a specific SCM repository by ID.
   *
   * @param `instanceId` - string
   * @param `scmRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, scmRepositoryId, opts) {
    let path = `instances/${instanceId}/scm/repos/${scmRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceScmReposGetOutput);
  }
  /**
   * @name Preview SCM repos
   * @description Lists available repositories from an SCM installation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmReposPreviewBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposPreviewOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  preview(instanceId, body, opts) {
    let path = `instances/${instanceId}/scm/repos/preview`;
    let request = {
      path,
      body: mapDashboardInstanceScmReposPreviewBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmReposPreviewOutput
    );
  }
  /**
   * @name Create SCM repo
   * @description Links or creates a repository in an SCM installation.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceScmReposCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/scm/repos`;
    let request = {
      path,
      body: mapDashboardInstanceScmReposCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmReposCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_session-templates.ts
var MetorialManagementInstanceSessionTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session templates
   * @description Returns a paginated list of session templates.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-templates`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesListOutput
    );
  }
  /**
   * @name Get session template
   * @description Retrieves a specific session template by ID.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionTemplateId, opts) {
    let path = `instances/${instanceId}/session-templates/${sessionTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesGetOutput
    );
  }
  /**
   * @name Create session template
   * @description Creates a new session template.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/session-templates`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionTemplatesCreateOutput
    );
  }
  /**
   * @name Update session template
   * @description Updates a specific session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `body` - DashboardInstanceSessionTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionTemplateId, body, opts) {
    let path = `instances/${instanceId}/session-templates/${sessionTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionTemplatesUpdateOutput
    );
  }
  /**
   * @name Delete session template
   * @description Deletes a specific session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionTemplateId, opts) {
    let path = `instances/${instanceId}/session-templates/${sessionTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionTemplatesDeleteOutput
    );
  }
  /**
   * @name List session template tools
   * @description Returns the effective set of tools available through the providers in a session template, filtered by the tool filters of each provider, deployment, config, and auth config.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesListToolsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  listTools(instanceId, sessionTemplateId, opts) {
    let path = `instances/${instanceId}/session-templates/${sessionTemplateId}/tools`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesListToolsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_session-templates_providers.ts
var MetorialManagementInstanceSessionTemplatesProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session template providers
   * @description Returns a paginated list of providers configured for a session template.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionTemplatesProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-template-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionTemplatesProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersListOutput
    );
  }
  /**
   * @name Get session template provider
   * @description Retrieves a specific provider configuration from a session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionTemplateProviderId, opts) {
    let path = `instances/${instanceId}/session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersGetOutput
    );
  }
  /**
   * @name Create session template provider
   * @description Adds a new provider configuration to a session template.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionTemplatesProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/session-template-providers`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersCreateOutput
    );
  }
  /**
   * @name Update session template provider
   * @description Updates a provider configuration in a session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateProviderId` - string
   * @param `body` - DashboardInstanceSessionTemplatesProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionTemplateProviderId, body, opts) {
    let path = `instances/${instanceId}/session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersUpdateOutput
    );
  }
  /**
   * @name Delete session template provider
   * @description Removes a provider configuration from a session template.
   *
   * @param `instanceId` - string
   * @param `sessionTemplateProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionTemplateProviderId, opts) {
    let path = `instances/${instanceId}/session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions.ts
var MetorialManagementInstanceSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sessions
   * @description Returns a paginated list of sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/sessions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSessionsListOutput);
  }
  /**
   * @name Get session
   * @description Retrieves a specific session by ID.
   *
   * @param `instanceId` - string
   * @param `sessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionId, opts) {
    let path = `instances/${instanceId}/sessions/${sessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSessionsGetOutput);
  }
  /**
   * @name Create session
   * @description Creates a new session with provider deployments.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/sessions`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionsCreateOutput
    );
  }
  /**
   * @name Update session
   * @description Updates a session.
   *
   * @param `instanceId` - string
   * @param `sessionId` - string
   * @param `body` - DashboardInstanceSessionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionId, body, opts) {
    let path = `instances/${instanceId}/sessions/${sessionId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionsUpdateOutput
    );
  }
  /**
   * @name Delete session
   * @description Deletes a session.
   *
   * @param `instanceId` - string
   * @param `sessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionId, opts) {
    let path = `instances/${instanceId}/sessions/${sessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions_connections.ts
var MetorialManagementInstanceSessionsConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session connections
   * @description Returns a paginated list of connections for a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-connections`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsConnectionsListOutput
    );
  }
  /**
   * @name Get session connection
   * @description Retrieves a specific connection from a session.
   *
   * @param `instanceId` - string
   * @param `sessionConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionConnectionId, opts) {
    let path = `instances/${instanceId}/session-connections/${sessionConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsConnectionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions_error-groups.ts
var MetorialManagementInstanceSessionsErrorGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all session error groups
   * @description Returns a paginated list of error groups across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsErrorGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-error-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsErrorGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorGroupsListOutput
    );
  }
  /**
   * @name Get session error group
   * @description Retrieves a specific error group by ID across all sessions.
   *
   * @param `instanceId` - string
   * @param `sessionErrorGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionErrorGroupId, opts) {
    let path = `instances/${instanceId}/session-error-groups/${sessionErrorGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorGroupsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions_errors.ts
var MetorialManagementInstanceSessionsErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all session errors
   * @description Returns a paginated list of errors across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-errors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsErrorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorsListOutput
    );
  }
  /**
   * @name Get session error
   * @description Retrieves a specific error that occurred in a session.
   *
   * @param `instanceId` - string
   * @param `sessionErrorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionErrorId, opts) {
    let path = `instances/${instanceId}/session-errors/${sessionErrorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions_events.ts
var MetorialManagementInstanceSessionsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session events
   * @description Returns a paginated list of events for a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsEventsListOutput
    );
  }
  /**
   * @name Get session event
   * @description Retrieves a specific event from a session.
   *
   * @param `instanceId` - string
   * @param `sessionEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionEventId, opts) {
    let path = `instances/${instanceId}/session-events/${sessionEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions_messages.ts
var MetorialManagementInstanceSessionsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session messages
   * @description Returns a paginated list of messages for a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-messages`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsMessagesListOutput
    );
  }
  /**
   * @name Get session message
   * @description Retrieves a specific message from a session.
   *
   * @param `instanceId` - string
   * @param `sessionMessageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionMessageId, opts) {
    let path = `instances/${instanceId}/session-messages/${sessionMessageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsMessagesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions_participants.ts
var MetorialManagementInstanceSessionsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session participants
   * @description Returns a paginated list of participants in a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsParticipantsListOutput
    );
  }
  /**
   * @name Get session participant
   * @description Retrieves a specific participant in a session.
   *
   * @param `instanceId` - string
   * @param `sessionParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionParticipantId, opts) {
    let path = `instances/${instanceId}/session-participants/${sessionParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_sessions_providers.ts
var MetorialManagementInstanceSessionsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session providers
   * @description Returns a paginated list of providers connected to a session.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSessionsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/session-providers`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsProvidersListOutput
    );
  }
  /**
   * @name Get session provider
   * @description Retrieves a specific provider connected to a session.
   *
   * @param `instanceId` - string
   * @param `sessionProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, sessionProviderId, opts) {
    let path = `instances/${instanceId}/session-providers/${sessionProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsProvidersGetOutput
    );
  }
  /**
   * @name Create session provider
   * @description Adds a new provider to an active session.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSessionsProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/session-providers`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionsProvidersCreateOutput
    );
  }
  /**
   * @name Update session provider
   * @description Updates a provider connected to a session.
   *
   * @param `instanceId` - string
   * @param `sessionProviderId` - string
   * @param `body` - DashboardInstanceSessionsProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, sessionProviderId, body, opts) {
    let path = `instances/${instanceId}/session-providers/${sessionProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsProvidersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionsProvidersUpdateOutput
    );
  }
  /**
   * @name Delete session provider
   * @description Removes a provider from a session.
   *
   * @param `instanceId` - string
   * @param `sessionProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, sessionProviderId, opts) {
    let path = `instances/${instanceId}/session-providers/${sessionProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills.ts
var MetorialManagementInstanceSkillsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skills
   * @description Returns a paginated list of skills.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skills`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSkillsListOutput);
  }
  /**
   * @name Get skill
   * @description Retrieves a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSkillsGetOutput);
  }
  /**
   * @name Create skill
   * @description Creates a new skill.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skills`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsCreateOutput
    );
  }
  /**
   * @name Update skill
   * @description Updates a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsUpdateOutput
    );
  }
  /**
   * @name Delete skill
   * @description Archives a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsDeleteOutput
    );
  }
  /**
   * @name Fork skill
   * @description Forks a skill for the current consumer. Non-consumer callers duplicate the skill instead.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsForkBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  fork(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/fork`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsForkBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardInstanceSkillsForkOutput);
  }
  /**
   * @name Publish consumer skill
   * @description Publishes a consumer-owned skill to the consumer groups they belong to.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPublishConsumerSkillOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  publishConsumerSkill(instanceId, skillId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/publish`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPublishConsumerSkillOutput
    );
  }
  /**
   * @name Share skill
   * @description Shares a skill with consumers or organization members.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsShareBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsShareOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  share(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/shares`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsShareBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardInstanceSkillsShareOutput);
  }
  /**
   * @name Duplicate skill
   * @description Duplicates a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsDuplicateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsDuplicateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  duplicate(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/duplicate`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsDuplicateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsDuplicateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_agents.ts
var MetorialManagementInstanceSkillsAgentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill agent
   * @description Creates a new agent document in the skill agents directory.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsAgentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/agents`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsAgentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsAgentsCreateOutput
    );
  }
  /**
   * @name List skill agents
   * @description Returns a paginated list of agents for a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsAgentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/agents`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsAgentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsAgentsListOutput
    );
  }
  /**
   * @name Get skill agent by ID
   * @description Retrieves a specific agent within a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillAgentId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsAgentsGetOutput
    );
  }
  /**
   * @name Update skill agent
   * @description Updates the name or description for a specific skill agent.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `body` - DashboardInstanceSkillsAgentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillId, skillAgentId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsAgentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsAgentsUpdateOutput
    );
  }
  /**
   * @name Delete skill agent
   * @description Archives a specific skill agent and removes its linked store item.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, skillAgentId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsAgentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_configurations.ts
var MetorialManagementInstanceSkillsConfigurationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill configuration
   * @description Creates a new non-default skill configuration.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsConfigurationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skills/configurations`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsConfigurationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsConfigurationsCreateOutput
    );
  }
  /**
   * @name List skill configurations
   * @description Returns a paginated list of visible skill configurations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsConfigurationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skills/configurations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsConfigurationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsConfigurationsListOutput
    );
  }
  /**
   * @name Get skill configuration
   * @description Retrieves a specific skill configuration by ID, or the default.
   *
   * @param `instanceId` - string
   * @param `skillConfigurationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillConfigurationId, opts) {
    let path = `instances/${instanceId}/skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsConfigurationsGetOutput
    );
  }
  /**
   * @name Update skill configuration
   * @description Updates a specific skill configuration. Updating default creates it first if needed.
   *
   * @param `instanceId` - string
   * @param `skillConfigurationId` - string
   * @param `body` - DashboardInstanceSkillsConfigurationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillConfigurationId, body, opts) {
    let path = `instances/${instanceId}/skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsConfigurationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsConfigurationsUpdateOutput
    );
  }
  /**
   * @name Delete skill configuration
   * @description Soft deletes a specific non-internal skill configuration.
   *
   * @param `instanceId` - string
   * @param `skillConfigurationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillConfigurationId, opts) {
    let path = `instances/${instanceId}/skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsConfigurationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_exports.ts
var MetorialManagementInstanceSkillsExportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill exports
   * @description Returns a paginated list of skill exports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsExportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skill-exports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsExportsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsExportsListOutput
    );
  }
  /**
   * @name Get skill export
   * @description Retrieves a skill export.
   *
   * @param `instanceId` - string
   * @param `skillExportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillExportId, opts) {
    let path = `instances/${instanceId}/skill-exports/${skillExportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsExportsGetOutput
    );
  }
  /**
   * @name Create skill export
   * @description Creates a skill, plugin, or marketplace export.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsExportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-exports`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsExportsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsExportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_files.ts
var MetorialManagementInstanceSkillsFilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill files
   * @description Lists every file of a skill with its path, size and etag. Directories are implied by file paths.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/files`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsFilesListOutput
    );
  }
  /**
   * @name Get skill file
   * @description Retrieves a single skill file by path. Documents include their text content, other files include a download URL.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsFilesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, query, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/files/content`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsFilesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsFilesGetOutput
    );
  }
  /**
   * @name Write skill file
   * @description Creates or replaces the file at a path. Parent directories are created automatically.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesPutBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesPutOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  put(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/files`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesPutBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceSkillsFilesPutOutput
    );
  }
  /**
   * @name Delete skill file
   * @description Deletes the file at a path. Directories that were created automatically and become empty are removed. The root SKILL.md cannot be deleted.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsFilesDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, query, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/files`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsFilesDeleteQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsFilesDeleteOutput
    );
  }
  /**
   * @name Move skill file
   * @description Moves or renames a file. The root SKILL.md cannot be moved.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesMoveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesMoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  move(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/files/move`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesMoveBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsFilesMoveOutput
    );
  }
  /**
   * @name Apply skill file changes
   * @description Applies up to 100 put, delete and move changes one after another, in order. Every change is validated before any is applied, but changes are not applied atomically: if a change fails while being applied, the changes before it stay applied. Every change can carry its own if_match precondition.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesBatchBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesBatchOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  batch(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/files/batch`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesBatchBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsFilesBatchOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_fork-syncs.ts
var MetorialManagementInstanceSkillsForkSyncsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill fork sync
   * @description Queues synchronization of upstream changes into a forked skill.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsForkSyncsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkSyncsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-fork-syncs`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsForkSyncsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsForkSyncsCreateOutput
    );
  }
  /**
   * @name Get skill fork sync
   * @description Retrieves the state of a fork synchronization.
   *
   * @param `instanceId` - string
   * @param `skillForkSyncId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkSyncsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillForkSyncId, opts) {
    let path = `instances/${instanceId}/skill-fork-syncs/${skillForkSyncId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsForkSyncsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_groups.ts
var MetorialManagementInstanceSkillsGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill groups
   * @description Returns a paginated list of skill groups.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skill-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsListOutput
    );
  }
  /**
   * @name Get skill group
   * @description Retrieves a specific skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillGroupId, opts) {
    let path = `instances/${instanceId}/skill-groups/${skillGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsGetOutput
    );
  }
  /**
   * @name Create skill group
   * @description Creates a skill group.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-groups`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsGroupsCreateOutput
    );
  }
  /**
   * @name Update skill group
   * @description Updates a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `body` - DashboardInstanceSkillsGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillGroupId, body, opts) {
    let path = `instances/${instanceId}/skill-groups/${skillGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsGroupsUpdateOutput
    );
  }
  /**
   * @name Delete skill group
   * @description Archives a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillGroupId, opts) {
    let path = `instances/${instanceId}/skill-groups/${skillGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_groups_items.ts
var MetorialManagementInstanceSkillsGroupsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill group items
   * @description Returns a paginated list of items for a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `query` - DashboardInstanceSkillsGroupsItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillGroupId, query, opts) {
    let path = `instances/${instanceId}/skill-groups/${skillGroupId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsGroupsItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsItemsListOutput
    );
  }
  /**
   * @name Get skill group item
   * @description Retrieves a specific skill group item.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `skillGroupItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillGroupId, skillGroupItemId, opts) {
    let path = `instances/${instanceId}/skill-groups/${skillGroupId}/items/${skillGroupItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsItemsGetOutput
    );
  }
  /**
   * @name Create skill group item
   * @description Adds a skill to a skill group.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `body` - DashboardInstanceSkillsGroupsItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillGroupId, body, opts) {
    let path = `instances/${instanceId}/skill-groups/${skillGroupId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsItemsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsGroupsItemsCreateOutput
    );
  }
  /**
   * @name Delete skill group item
   * @description Archives a skill group item.
   *
   * @param `instanceId` - string
   * @param `skillGroupId` - string
   * @param `skillGroupItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillGroupId, skillGroupItemId, opts) {
    let path = `instances/${instanceId}/skill-groups/${skillGroupId}/items/${skillGroupItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsGroupsItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_imports.ts
var MetorialManagementInstanceSkillsImportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill imports
   * @description Returns a paginated list of skill imports.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsImportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skill-imports`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsImportsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsImportsListOutput
    );
  }
  /**
   * @name Get skill import
   * @description Retrieves an individual skill import and its results.
   *
   * @param `instanceId` - string
   * @param `skillImportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillImportId, opts) {
    let path = `instances/${instanceId}/skill-imports/${skillImportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsImportsGetOutput
    );
  }
  /**
   * @name Create skill import
   * @description Queues a skill import from a repository or uploaded file.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsImportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-imports`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsImportsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsImportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_items.ts
var MetorialManagementInstanceSkillsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill items
   * @description Returns a paginated list of items for a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsItemsListOutput
    );
  }
  /**
   * @name Get skill item
   * @description Retrieves a specific skill item.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillItemId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/items/${skillItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsItemsGetOutput
    );
  }
  /**
   * @name Create skill item
   * @description Creates a new item on a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillId, body, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsItemsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsItemsCreateOutput
    );
  }
  /**
   * @name Delete skill item
   * @description Archives a skill item.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillId, skillItemId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/items/${skillItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_marketplaces.ts
var MetorialManagementInstanceSkillsMarketplacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplaces
   * @description Returns a paginated list of skill marketplaces.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skill-marketplaces`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesListOutput
    );
  }
  /**
   * @name Get skill marketplace
   * @description Retrieves a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMarketplaceId, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesGetOutput
    );
  }
  /**
   * @name Create skill marketplace
   * @description Creates a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-marketplaces`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesCreateOutput
    );
  }
  /**
   * @name Update skill marketplace
   * @description Updates a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillMarketplaceId, body, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMarketplacesUpdateOutput
    );
  }
  /**
   * @name Archive skill marketplace
   * @description Archives a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(instanceId, skillMarketplaceId, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesArchiveOutput
    );
  }
  /**
   * @name Sync skill marketplace
   * @description Forces a skill marketplace sync.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesSyncBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(instanceId, skillMarketplaceId, body, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/sync`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesSyncBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesSyncOutput
    );
  }
  /**
   * @name Get skill marketplace editor URL
   * @description Creates an embeddable editor URL for a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesGetEditorUrlBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesGetEditorUrlOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEditorUrl(instanceId, skillMarketplaceId, body, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/editor-url`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesGetEditorUrlBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesGetEditorUrlOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_marketplaces_plugins.ts
var MetorialManagementInstanceSkillsMarketplacesPluginsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplace plugins
   * @description Returns plugins linked to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesPluginsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMarketplaceId, query, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesPluginsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsListOutput
    );
  }
  /**
   * @name Add skill marketplace plugin
   * @description Adds a skill plugin to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesPluginsAddBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsAddOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  add(instanceId, skillMarketplaceId, body, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesPluginsAddBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsAddOutput
    );
  }
  /**
   * @name Get skill marketplace plugin
   * @description Retrieves a skill marketplace plugin link.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplacePluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMarketplaceId, skillMarketplacePluginId, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins/${skillMarketplacePluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsGetOutput
    );
  }
  /**
   * @name Remove skill marketplace plugin
   * @description Removes a skill plugin from a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplacePluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsRemoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  remove(instanceId, skillMarketplaceId, skillMarketplacePluginId, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/plugins/${skillMarketplacePluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsRemoveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_marketplaces_repositories.ts
var MetorialManagementInstanceSkillsMarketplacesRepositoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplace repositories
   * @description Returns repositories linked to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesRepositoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMarketplaceId, query, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesRepositoriesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesListOutput
    );
  }
  /**
   * @name Get skill marketplace repository
   * @description Retrieves a repository linked to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplaceRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMarketplaceId, skillMarketplaceRepositoryId, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories/${skillMarketplaceRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesGetOutput
    );
  }
  /**
   * @name Link skill marketplace repository
   * @description Links an SCM repository to a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesRepositoriesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillMarketplaceId, body, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesRepositoriesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesCreateOutput
    );
  }
  /**
   * @name Unlink skill marketplace repository
   * @description Unlinks an SCM repository from a skill marketplace.
   *
   * @param `instanceId` - string
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplaceRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillMarketplaceId, skillMarketplaceRepositoryId, opts) {
    let path = `instances/${instanceId}/skill-marketplaces/${skillMarketplaceId}/repositories/${skillMarketplaceRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_merge-requests.ts
var MetorialManagementInstanceSkillsMergeRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge requests
   * @description Returns a paginated list of skill merge requests.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skill-merge-requests`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsListOutput
    );
  }
  /**
   * @name Create skill merge request
   * @description Creates a merge request from one skill into another.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-merge-requests`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCreateOutput
    );
  }
  /**
   * @name Get skill merge request
   * @description Retrieves a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsGetOutput
    );
  }
  /**
   * @name Perform skill merge request
   * @description Queues application of a resolved skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsPerformOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  perform(instanceId, skillMergeRequestId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/perform`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsPerformOutput
    );
  }
  /**
   * @name Close skill merge request
   * @description Closes an open skill merge request without applying it.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCloseOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  close(instanceId, skillMergeRequestId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/close`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCloseOutput
    );
  }
  /**
   * @name Rollback skill merge request
   * @description Restores the target skill to its state before a completed merge.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsRollbackOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  rollback(instanceId, skillMergeRequestId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/rollback`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsRollbackOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_merge-requests_comments.ts
var MetorialManagementInstanceSkillsMergeRequestsCommentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge request comments
   * @description Lists comments on a skill merge request or one of its items.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsCommentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMergeRequestId, query, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsCommentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsListOutput
    );
  }
  /**
   * @name Create skill merge request comment
   * @description Adds a comment to a skill merge request or one of its items.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCommentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillMergeRequestId, body, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCommentsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsCreateOutput
    );
  }
  /**
   * @name Get skill merge request comment
   * @description Retrieves a comment on a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, commentId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsGetOutput
    );
  }
  /**
   * @name Update skill merge request comment
   * @description Updates a comment authored by the current actor.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCommentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillMergeRequestId, commentId, body, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCommentsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsUpdateOutput
    );
  }
  /**
   * @name Delete skill merge request comment
   * @description Deletes a comment authored by the current actor.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillMergeRequestId, commentId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_merge-requests_events.ts
var MetorialManagementInstanceSkillsMergeRequestsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge request events
   * @description Returns a paginated activity history for a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillMergeRequestId, query, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsEventsListOutput
    );
  }
  /**
   * @name Get skill merge request event
   * @description Retrieves one event from a skill merge request activity history.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, eventId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_merge-requests_items.ts
var MetorialManagementInstanceSkillsMergeRequestsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Resolve skill merge request item
   * @description Saves a resolution for one proposed skill change.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `itemId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsItemsResolveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsItemsResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resolve(instanceId, skillMergeRequestId, itemId, body, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/items/${itemId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsItemsResolveBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsItemsResolveOutput
    );
  }
  /**
   * @name Resolve skill merge request items
   * @description Saves resolutions for multiple proposed skill changes.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsItemsBulkResolveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  bulkResolve(instanceId, skillMergeRequestId, body, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_merge-requests_plan.ts
var MetorialManagementInstanceSkillsMergeRequestsPlanEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get skill merge plan
   * @description Returns the proposed changes and conflicts for a skill merge request.
   *
   * @param `instanceId` - string
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsPlanGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillMergeRequestId, opts) {
    let path = `instances/${instanceId}/skill-merge-requests/${skillMergeRequestId}/plan`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsPlanGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_participants.ts
var MetorialManagementInstanceSkillsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill participants
   * @description Returns a paginated list of participants for a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsParticipantsListOutput
    );
  }
  /**
   * @name Get skill participant by ID
   * @description Retrieves a specific participant within a skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillParticipantId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/participants/${skillParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_plugins.ts
var MetorialManagementInstanceSkillsPluginsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugins
   * @description Returns a paginated list of skill plugins.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsPluginsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skill-plugins`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsListOutput
    );
  }
  /**
   * @name Get skill plugin
   * @description Retrieves a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillPluginId, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsGetOutput
    );
  }
  /**
   * @name Create skill plugin
   * @description Creates a skill plugin.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsPluginsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-plugins`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsCreateOutput
    );
  }
  /**
   * @name Update skill plugin
   * @description Updates a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillPluginId, body, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsPluginsUpdateOutput
    );
  }
  /**
   * @name Archive skill plugin
   * @description Archives a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(instanceId, skillPluginId, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsArchiveOutput
    );
  }
  /**
   * @name Sync skill plugin
   * @description Forces a skill plugin sync.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSyncBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(instanceId, skillPluginId, body, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/sync`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSyncBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsSyncOutput
    );
  }
  /**
   * @name Get skill plugin editor URL
   * @description Creates an embeddable editor URL for a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsGetEditorUrlBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsGetEditorUrlOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEditorUrl(instanceId, skillPluginId, body, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/editor-url`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsGetEditorUrlBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsGetEditorUrlOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_plugins_repositories.ts
var MetorialManagementInstanceSkillsPluginsRepositoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugin repositories
   * @description Returns repositories linked to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `query` - DashboardInstanceSkillsPluginsRepositoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillPluginId, query, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/repositories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsRepositoriesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesListOutput
    );
  }
  /**
   * @name Get skill plugin repository
   * @description Retrieves a repository linked to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillPluginId, skillPluginRepositoryId, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/repositories/${skillPluginRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesGetOutput
    );
  }
  /**
   * @name Link skill plugin repository
   * @description Links an SCM repository to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsRepositoriesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillPluginId, body, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/repositories`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsRepositoriesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesCreateOutput
    );
  }
  /**
   * @name Unlink skill plugin repository
   * @description Unlinks an SCM repository from a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillPluginId, skillPluginRepositoryId, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/repositories/${skillPluginRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_plugins_skills.ts
var MetorialManagementInstanceSkillsPluginsSkillsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugin skills
   * @description Returns skills linked to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `query` - DashboardInstanceSkillsPluginsSkillsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillPluginId, query, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/skills`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsSkillsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsListOutput
    );
  }
  /**
   * @name Add skill plugin skill
   * @description Adds a skill to a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSkillsAddBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsAddOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  add(instanceId, skillPluginId, body, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/skills`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSkillsAddBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsAddOutput
    );
  }
  /**
   * @name Get skill plugin skill
   * @description Retrieves a skill plugin skill link.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillPluginId, skillPluginSkillId, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsGetOutput
    );
  }
  /**
   * @name Update skill plugin skill
   * @description Updates a skill plugin skill link.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSkillsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillPluginId, skillPluginSkillId, body, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSkillsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsUpdateOutput
    );
  }
  /**
   * @name Remove skill plugin skill
   * @description Removes a skill from a skill plugin.
   *
   * @param `instanceId` - string
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsRemoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  remove(instanceId, skillPluginId, skillPluginSkillId, opts) {
    let path = `instances/${instanceId}/skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsRemoveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_templates.ts
var MetorialManagementInstanceSkillsTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill templates
   * @description Returns a paginated list of skill templates.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceSkillsTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/skill-templates`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesListOutput
    );
  }
  /**
   * @name Get skill template
   * @description Retrieves a specific skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillTemplateId, opts) {
    let path = `instances/${instanceId}/skill-templates/${skillTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesGetOutput
    );
  }
  /**
   * @name Create skill template
   * @description Creates a skill template.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/skill-templates`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsTemplatesCreateOutput
    );
  }
  /**
   * @name Update skill template
   * @description Updates a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, skillTemplateId, body, opts) {
    let path = `instances/${instanceId}/skill-templates/${skillTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsTemplatesUpdateOutput
    );
  }
  /**
   * @name Delete skill template
   * @description Archives a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillTemplateId, opts) {
    let path = `instances/${instanceId}/skill-templates/${skillTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsTemplatesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_templates_items.ts
var MetorialManagementInstanceSkillsTemplatesItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill template items
   * @description Returns a paginated list of items for a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `query` - DashboardInstanceSkillsTemplatesItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillTemplateId, query, opts) {
    let path = `instances/${instanceId}/skill-templates/${skillTemplateId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsTemplatesItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsListOutput
    );
  }
  /**
   * @name Get skill template item
   * @description Retrieves a specific skill template item.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `skillTemplateItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillTemplateId, skillTemplateItemId, opts) {
    let path = `instances/${instanceId}/skill-templates/${skillTemplateId}/items/${skillTemplateItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsGetOutput
    );
  }
  /**
   * @name Create skill template item
   * @description Adds a provider or integration item to a skill template.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, skillTemplateId, body, opts) {
    let path = `instances/${instanceId}/skill-templates/${skillTemplateId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesItemsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsCreateOutput
    );
  }
  /**
   * @name Delete skill template item
   * @description Deletes a skill template item.
   *
   * @param `instanceId` - string
   * @param `skillTemplateId` - string
   * @param `skillTemplateItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, skillTemplateId, skillTemplateItemId, opts) {
    let path = `instances/${instanceId}/skill-templates/${skillTemplateId}/items/${skillTemplateItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_versions.ts
var MetorialManagementInstanceSkillsVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill versions
   * @description Returns a paginated list of versions for a specific skill.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, skillId, query, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsListOutput
    );
  }
  /**
   * @name Get skill version by ID
   * @description Retrieves a specific skill version by its ID.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillVersionId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/versions/${skillVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_skills_versions_snapshot.ts
var MetorialManagementInstanceSkillsVersionsSnapshotEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get skill version snapshot
   * @description Retrieves the store-backed snapshot for a specific skill version.
   *
   * @param `instanceId` - string
   * @param `skillId` - string
   * @param `skillVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsSnapshotGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, skillId, skillVersionId, opts) {
    let path = `instances/${instanceId}/skills/${skillId}/versions/${skillVersionId}/snapshot`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsSnapshotGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_stores.ts
var MetorialManagementInstanceStoresEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List stores
   * @description Returns a paginated list of stores owned by the instance.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceStoresListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/stores`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceStoresListOutput);
  }
  /**
   * @name Create store
   * @description Creates a new store for the instance.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceStoresCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/stores`;
    let request = {
      path,
      body: mapDashboardInstanceStoresCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceStoresCreateOutput
    );
  }
  /**
   * @name Get store by ID
   * @description Retrieves a store by its ID.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, opts) {
    let path = `instances/${instanceId}/stores/${storeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceStoresGetOutput);
  }
  /**
   * @name Update store by ID
   * @description Updates a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `body` - DashboardInstanceStoresUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, storeId, body, opts) {
    let path = `instances/${instanceId}/stores/${storeId}`;
    let request = {
      path,
      body: mapDashboardInstanceStoresUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceStoresUpdateOutput
    );
  }
  /**
   * @name Delete store by ID
   * @description Deletes a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, storeId, opts) {
    let path = `instances/${instanceId}/stores/${storeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceStoresDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_stores_items.ts
var MetorialManagementInstanceStoresItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Modify store items
   * @description Applies bulk item operations to a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `body` - DashboardInstanceStoresItemsModifyBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsModifyOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  modify(instanceId, storeId, body, opts) {
    let path = `instances/${instanceId}/stores/${storeId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceStoresItemsModifyBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceStoresItemsModifyOutput
    );
  }
  /**
   * @name List store items
   * @description Returns a paginated list of items for a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `query` - DashboardInstanceStoresItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, storeId, query, opts) {
    let path = `instances/${instanceId}/stores/${storeId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresItemsListOutput
    );
  }
  /**
   * @name Get store item by ID
   * @description Retrieves a specific item within a store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `itemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, itemId, opts) {
    let path = `instances/${instanceId}/stores/${storeId}/items/${itemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresItemsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_stores_participants.ts
var MetorialManagementInstanceStoresParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List store participants
   * @description Returns a paginated list of participants for a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `query` - DashboardInstanceStoresParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, storeId, query, opts) {
    let path = `instances/${instanceId}/stores/${storeId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresParticipantsListOutput
    );
  }
  /**
   * @name Get store participant by ID
   * @description Retrieves a specific participant within a store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `storeParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, storeParticipantId, opts) {
    let path = `instances/${instanceId}/stores/${storeId}/participants/${storeParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_stores_permissions.ts
var MetorialManagementInstanceStoresPermissionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get store permissions
   * @description Returns the effective Cargo permissions for the current actor on a specific store.
   *
   * @param `instanceId` - string
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresPermissionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, storeId, opts) {
    let path = `instances/${instanceId}/stores/${storeId}/permissions`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresPermissionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_tool-calls.ts
var MetorialManagementInstanceToolCallsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all tool calls
   * @description Returns a paginated list of tool calls across all sessions.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceToolCallsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/tool-calls`;
    let request = {
      path,
      query: query ? mapDashboardInstanceToolCallsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceToolCallsListOutput
    );
  }
  /**
   * @name Get tool call
   * @description Retrieves a specific tool call by ID.
   *
   * @param `instanceId` - string
   * @param `toolCallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, toolCallId, opts) {
    let path = `instances/${instanceId}/tool-calls/${toolCallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceToolCallsGetOutput);
  }
  /**
   * @name Create tool call
   * @description Creates a new tool call in a session by invoking a specific tool.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceToolCallsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/tool-calls`;
    let request = {
      path,
      body: mapDashboardInstanceToolCallsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceToolCallsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_instance_webhook-registrations.ts
var MetorialManagementInstanceWebhookRegistrationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List webhook registrations
   * @description Returns a paginated list of webhook registrations.
   *
   * @param `instanceId` - string
   * @param `query` - DashboardInstanceWebhookRegistrationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query, opts) {
    let path = `instances/${instanceId}/webhook-registrations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceWebhookRegistrationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceWebhookRegistrationsListOutput
    );
  }
  /**
   * @name Get webhook registration
   * @description Retrieves a specific webhook registration by ID.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, webhookRegistrationId, opts) {
    let path = `instances/${instanceId}/webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceWebhookRegistrationsGetOutput
    );
  }
  /**
   * @name Create webhook registration
   * @description Creates a webhook registration for a provider. Only providers whose type reports `triggers.webhook_registration.status` as `supported` can receive one. The registration starts out awaiting setup.
   *
   * @param `instanceId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body, opts) {
    let path = `instances/${instanceId}/webhook-registrations`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceWebhookRegistrationsCreateOutput
    );
  }
  /**
   * @name Complete webhook registration setup
   * @description Submits the provider-specific configuration described by the registration setup document, activating the registration.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsSetupBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsSetupOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  setup(instanceId, webhookRegistrationId, body, opts) {
    let path = `instances/${instanceId}/webhook-registrations/${webhookRegistrationId}/setup`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsSetupBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceWebhookRegistrationsSetupOutput
    );
  }
  /**
   * @name Update webhook registration
   * @description Updates a webhook registration.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, webhookRegistrationId, body, opts) {
    let path = `instances/${instanceId}/webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceWebhookRegistrationsUpdateOutput
    );
  }
  /**
   * @name Delete webhook registration
   * @description Archives a webhook registration. The receiver is torn down on the provider before the record is removed for good.
   *
   * @param `instanceId` - string
   * @param `webhookRegistrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, webhookRegistrationId, opts) {
    let path = `instances/${instanceId}/webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceWebhookRegistrationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization.ts
var MetorialManagementOrganizationEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get organization
   * @description Get the current organization information
   *
   * @param `opts` - { headers?: Record<string, string> }
   * @returns ManagementOrganizationGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(opts) {
    let path = "organization";
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapManagementOrganizationGetOutput);
  }
  /**
   * @name Update organization
   * @description Update the current organization information
   *
   * @param `body` - ManagementOrganizationUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns ManagementOrganizationUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(body, opts) {
    let path = "organization";
    let request = {
      path,
      body: mapManagementOrganizationUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapManagementOrganizationUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_access-policies.ts
var MetorialManagementOrganizationAccessPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List access policies
   * @description List organization access policies
   *
   * @param `query` - DashboardOrganizationsAccessPoliciesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/access-policies";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessPoliciesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessPoliciesListOutput
    );
  }
  /**
   * @name Get access policy
   * @description Get a single organization access policy
   *
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(accessPolicyId, opts) {
    let path = `organization/access-policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessPoliciesGetOutput
    );
  }
  /**
   * @name List access policy versions
   * @description List version history for an organization access policy
   *
   * @param `accessPolicyId` - string
   * @param `query` - DashboardOrganizationsAccessPoliciesVersionsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesVersionsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  versions(accessPolicyId, query, opts) {
    let path = `organization/access-policies/${accessPolicyId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessPoliciesVersionsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessPoliciesVersionsOutput
    );
  }
  /**
   * @name Create access policy
   * @description Create an organization access policy
   *
   * @param `body` - DashboardOrganizationsAccessPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/access-policies";
    let request = {
      path,
      body: mapDashboardOrganizationsAccessPoliciesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAccessPoliciesCreateOutput
    );
  }
  /**
   * @name Update access policy
   * @description Update an organization access policy
   *
   * @param `accessPolicyId` - string
   * @param `body` - DashboardOrganizationsAccessPoliciesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(accessPolicyId, body, opts) {
    let path = `organization/access-policies/${accessPolicyId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsAccessPoliciesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsAccessPoliciesUpdateOutput
    );
  }
  /**
   * @name Delete access policy
   * @description Delete an organization access policy
   *
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(accessPolicyId, opts) {
    let path = `organization/access-policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsAccessPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_access-roles.ts
var MetorialManagementOrganizationAccessRolesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List access roles
   * @description List organization access roles
   *
   * @param `query` - DashboardOrganizationsAccessRolesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/access-roles";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessRolesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessRolesListOutput
    );
  }
  /**
   * @name Get access role
   * @description Get a single organization access role
   *
   * @param `accessRoleId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(accessRoleId, opts) {
    let path = `organization/access-roles/${accessRoleId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessRolesGetOutput
    );
  }
  /**
   * @name List access role versions
   * @description List version history for an organization access role
   *
   * @param `accessRoleId` - string
   * @param `query` - DashboardOrganizationsAccessRolesVersionsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesVersionsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  versions(accessRoleId, query, opts) {
    let path = `organization/access-roles/${accessRoleId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAccessRolesVersionsQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAccessRolesVersionsOutput
    );
  }
  /**
   * @name Create access role
   * @description Create an organization access role
   *
   * @param `body` - DashboardOrganizationsAccessRolesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/access-roles";
    let request = {
      path,
      body: mapDashboardOrganizationsAccessRolesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAccessRolesCreateOutput
    );
  }
  /**
   * @name Update access role
   * @description Update an organization access role
   *
   * @param `accessRoleId` - string
   * @param `body` - DashboardOrganizationsAccessRolesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(accessRoleId, body, opts) {
    let path = `organization/access-roles/${accessRoleId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsAccessRolesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsAccessRolesUpdateOutput
    );
  }
  /**
   * @name Delete access role
   * @description Delete an organization access role
   *
   * @param `accessRoleId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAccessRolesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(accessRoleId, opts) {
    let path = `organization/access-roles/${accessRoleId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsAccessRolesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_api-keys.ts
var MetorialManagementOrganizationApiKeysEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get user
   * @description Get the current user information
   *
   * @param `query` - DashboardOrganizationsApiKeysListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/api-keys";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsApiKeysListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsApiKeysListOutput
    );
  }
  /**
   * @name Get API key
   * @description Get the information of a specific API key
   *
   * @param `apiKeyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(apiKeyId, opts) {
    let path = `organization/api-keys/${apiKeyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsApiKeysGetOutput
    );
  }
  /**
   * @name Create API key
   * @description Create a new API key
   *
   * @param `body` - DashboardOrganizationsApiKeysCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/api-keys";
    let request = {
      path,
      body: mapDashboardOrganizationsApiKeysCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysCreateOutput
    );
  }
  /**
   * @name Update API key
   * @description Update the information of a specific API key
   *
   * @param `apiKeyId` - string
   * @param `body` - DashboardOrganizationsApiKeysUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(apiKeyId, body, opts) {
    let path = `organization/api-keys/${apiKeyId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsApiKeysUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysUpdateOutput
    );
  }
  /**
   * @name Revoke API key
   * @description Revoke a specific API key
   *
   * @param `apiKeyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(apiKeyId, opts) {
    let path = `organization/api-keys/${apiKeyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsApiKeysRevokeOutput
    );
  }
  /**
   * @name Rotate API key
   * @description Rotate a specific API key
   *
   * @param `apiKeyId` - string
   * @param `body` - DashboardOrganizationsApiKeysRotateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysRotateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  rotate(apiKeyId, body, opts) {
    let path = `organization/api-keys/${apiKeyId}/rotate`;
    let request = {
      path,
      body: mapDashboardOrganizationsApiKeysRotateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysRotateOutput
    );
  }
  /**
   * @name Reveal API key
   * @description Reveal a specific API key
   *
   * @param `apiKeyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsApiKeysRevealOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  reveal(apiKeyId, opts) {
    let path = `organization/api-keys/${apiKeyId}/reveal`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsApiKeysRevealOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_audit-log-streams.ts
var MetorialManagementOrganizationAuditLogStreamsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization audit log streams
   * @description List all audit log streams configured for the organization
   *
   * @param `query` - DashboardOrganizationsAuditLogStreamsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/audit-log-streams";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAuditLogStreamsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsListOutput
    );
  }
  /**
   * @name Get organization audit log stream
   * @description Get a specific audit log stream configured for the organization
   *
   * @param `auditLogStreamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(auditLogStreamId, opts) {
    let path = `organization/audit-log-streams/${auditLogStreamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsGetOutput
    );
  }
  /**
   * @name Create organization audit log stream
   * @description Create an audit log stream for the organization
   *
   * @param `body` - DashboardOrganizationsAuditLogStreamsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/audit-log-streams";
    let request = {
      path,
      body: mapDashboardOrganizationsAuditLogStreamsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAuditLogStreamsCreateOutput
    );
  }
  /**
   * @name Update organization audit log stream
   * @description Update an audit log stream configured for the organization
   *
   * @param `auditLogStreamId` - string
   * @param `body` - DashboardOrganizationsAuditLogStreamsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(auditLogStreamId, body, opts) {
    let path = `organization/audit-log-streams/${auditLogStreamId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsAuditLogStreamsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsAuditLogStreamsUpdateOutput
    );
  }
  /**
   * @name Resume organization audit log stream
   * @description Resume an audit log stream paused after repeated delivery errors
   *
   * @param `auditLogStreamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsResumeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resume(auditLogStreamId, opts) {
    let path = `organization/audit-log-streams/${auditLogStreamId}/resume`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsAuditLogStreamsResumeOutput
    );
  }
  /**
   * @name Delete organization audit log stream
   * @description Delete an audit log stream configured for the organization
   *
   * @param `auditLogStreamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(auditLogStreamId, opts) {
    let path = `organization/audit-log-streams/${auditLogStreamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsAuditLogStreamsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_audit-log-streams_events.ts
var MetorialManagementOrganizationAuditLogStreamsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List audit log stream events
   * @description List lifecycle events recorded for an audit log stream
   *
   * @param `auditLogStreamId` - string
   * @param `query` - DashboardOrganizationsAuditLogStreamsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(auditLogStreamId, query, opts) {
    let path = `organization/audit-log-streams/${auditLogStreamId}/events`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAuditLogStreamsEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsEventsListOutput
    );
  }
  /**
   * @name Get audit log stream event
   * @description Get a lifecycle event recorded for an audit log stream
   *
   * @param `auditLogStreamId` - string
   * @param `auditLogStreamEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogStreamsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(auditLogStreamId, auditLogStreamEventId, opts) {
    let path = `organization/audit-log-streams/${auditLogStreamId}/events/${auditLogStreamEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogStreamsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_audit-logs.ts
var MetorialManagementOrganizationAuditLogsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization audit logs
   * @description List audit logs recorded for the organization
   *
   * @param `query` - DashboardOrganizationsAuditLogsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/audit-logs";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsAuditLogsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogsListOutput
    );
  }
  /**
   * @name Get organization audit log
   * @description Get a specific audit log recorded for the organization
   *
   * @param `auditLogId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsAuditLogsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(auditLogId, opts) {
    let path = `organization/audit-logs/${auditLogId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsAuditLogsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_event-deliveries.ts
var MetorialManagementOrganizationEventDeliveriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event deliveries
   * @description List event deliveries recorded for the organization
   *
   * @param `query` - DashboardOrganizationsEventDeliveriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/event-deliveries";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDeliveriesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveriesListOutput
    );
  }
  /**
   * @name Get event delivery
   * @description Get a specific event delivery recorded for the organization
   *
   * @param `eventDeliveryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(eventDeliveryId, opts) {
    let path = `organization/event-deliveries/${eventDeliveryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveriesGetOutput
    );
  }
  /**
   * @name Retry event delivery
   * @description Schedules another attempt for a delivery that has finished, whether it succeeded or gave up. The delivery is given a fresh attempt budget.
   *
   * @param `eventDeliveryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveriesRetryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  retry(eventDeliveryId, opts) {
    let path = `organization/event-deliveries/${eventDeliveryId}/retry`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDeliveriesRetryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_event-delivery-attempts.ts
var MetorialManagementOrganizationEventDeliveryAttemptsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event delivery attempts
   * @description List delivery attempts recorded for the organization
   *
   * @param `query` - DashboardOrganizationsEventDeliveryAttemptsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveryAttemptsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/event-delivery-attempts";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDeliveryAttemptsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveryAttemptsListOutput
    );
  }
  /**
   * @name Get event delivery attempt
   * @description Get a specific delivery attempt, including the request Metorial sent and the response the destination returned
   *
   * @param `eventDeliveryAttemptId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDeliveryAttemptsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(eventDeliveryAttemptId, opts) {
    let path = `organization/event-delivery-attempts/${eventDeliveryAttemptId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDeliveryAttemptsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_event-destination-listeners.ts
var MetorialManagementOrganizationEventDestinationListenersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event destination listeners
   * @description Returns a paginated list of event destination listeners for the organization.
   *
   * @param `query` - DashboardOrganizationsEventDestinationListenersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/event-destination-listeners";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDestinationListenersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationListenersListOutput
    );
  }
  /**
   * @name Get event destination listener
   * @description Retrieves a specific event destination listener by ID.
   *
   * @param `eventDestinationListenerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(eventDestinationListenerId, opts) {
    let path = `organization/event-destination-listeners/${eventDestinationListenerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationListenersGetOutput
    );
  }
  /**
   * @name Create event destination listener
   * @description Subscribes an event destination to events for this instance — generic resource events, a callback's trigger events, or a chat connection's events.
   *
   * @param `body` - DashboardOrganizationsEventDestinationListenersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/event-destination-listeners";
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationListenersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationListenersCreateOutput
    );
  }
  /**
   * @name Update event destination listener
   * @description Updates the event types or callback triggers an event destination listener subscribes to.
   *
   * @param `eventDestinationListenerId` - string
   * @param `body` - DashboardOrganizationsEventDestinationListenersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(eventDestinationListenerId, body, opts) {
    let path = `organization/event-destination-listeners/${eventDestinationListenerId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationListenersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsEventDestinationListenersUpdateOutput
    );
  }
  /**
   * @name Delete event destination listener
   * @description Removes an event destination listener.
   *
   * @param `eventDestinationListenerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationListenersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(eventDestinationListenerId, opts) {
    let path = `organization/event-destination-listeners/${eventDestinationListenerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsEventDestinationListenersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_event-destinations.ts
var MetorialManagementOrganizationEventDestinationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List event destinations
   * @description List all event destinations configured for the organization
   *
   * @param `query` - DashboardOrganizationsEventDestinationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/event-destinations";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventDestinationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationsListOutput
    );
  }
  /**
   * @name Get event destination
   * @description Get a specific event destination configured for the organization
   *
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(eventDestinationId, opts) {
    let path = `organization/event-destinations/${eventDestinationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventDestinationsGetOutput
    );
  }
  /**
   * @name Create event destination
   * @description Create an event destination for the organization
   *
   * @param `body` - DashboardOrganizationsEventDestinationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/event-destinations";
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsCreateOutput
    );
  }
  /**
   * @name Update event destination
   * @description Update an event destination configured for the organization
   *
   * @param `eventDestinationId` - string
   * @param `body` - DashboardOrganizationsEventDestinationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(eventDestinationId, body, opts) {
    let path = `organization/event-destinations/${eventDestinationId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsEventDestinationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsEventDestinationsUpdateOutput
    );
  }
  /**
   * @name Archive event destination
   * @description Archives an event destination. Listeners pointed at it stop being delivered to.
   *
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(eventDestinationId, opts) {
    let path = `organization/event-destinations/${eventDestinationId}/archive`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsArchiveOutput
    );
  }
  /**
   * @name Rotate event destination webhook secret
   * @description Generates a new signing secret for this event destination's webhook, invalidating the previous one. The new secret is only returned in this response.
   *
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsRotateWebhookSecretOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  rotateWebhookSecret(eventDestinationId, opts) {
    let path = `organization/event-destinations/${eventDestinationId}/rotate-webhook-secret`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsRotateWebhookSecretOutput
    );
  }
  /**
   * @name Ping event destination
   * @description Sends a test delivery to this event destination immediately, regardless of its listeners. The ping goes through the normal delivery/retry pipeline and shows up in delivery history.
   *
   * @param `eventDestinationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventDestinationsPingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  ping(eventDestinationId, opts) {
    let path = `organization/event-destinations/${eventDestinationId}/ping`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsEventDestinationsPingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_events.ts
var MetorialManagementOrganizationEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List events
   * @description List events recorded for the organization
   *
   * @param `query` - DashboardOrganizationsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/events";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventsListOutput
    );
  }
  /**
   * @name Get event
   * @description Get a specific event recorded for the organization
   *
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(eventId, opts) {
    let path = `organization/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_instances.ts
var MetorialManagementOrganizationInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization instances
   * @description List all organization instances
   *
   * @param `query` - DashboardOrganizationsInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/instances";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsInstancesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInstancesListOutput
    );
  }
  /**
   * @name Get organization instance
   * @description Get the information of a specific organization instance
   *
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, opts) {
    let path = `organization/instances/${instanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInstancesGetOutput
    );
  }
  /**
   * @name Delete organization instance
   * @description Remove an organization instance
   *
   * @param `instanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, opts) {
    let path = `organization/instances/${instanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsInstancesDeleteOutput
    );
  }
  /**
   * @name Update organization instance
   * @description Update the role of an organization instance
   *
   * @param `instanceId` - string
   * @param `body` - DashboardOrganizationsInstancesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInstancesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, body, opts) {
    let path = `organization/instances/${instanceId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsInstancesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInstancesUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_invites.ts
var MetorialManagementOrganizationInvitesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization invites
   * @description List all organization invites
   *
   * @param `query` - DashboardOrganizationsInvitesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/invites";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsInvitesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInvitesListOutput
    );
  }
  /**
   * @name Get organization invite
   * @description Get the information of a specific organization invite
   *
   * @param `inviteId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(inviteId, opts) {
    let path = `organization/invites/${inviteId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsInvitesGetOutput
    );
  }
  /**
   * @name Create organization invite
   * @description Create a new organization invite
   *
   * @param `body` - DashboardOrganizationsInvitesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/invites";
    let request = {
      path,
      body: mapDashboardOrganizationsInvitesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInvitesCreateOutput
    );
  }
  /**
   * @name Ensure organization invite link
   * @description Ensure the invite link for the organization
   *
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesEnsureLinkOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  ensureLink(opts) {
    let path = "organization/invites/ensure";
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInvitesEnsureLinkOutput
    );
  }
  /**
   * @name Delete organization invite
   * @description Remove an organization invite
   *
   * @param `inviteId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(inviteId, opts) {
    let path = `organization/invites/${inviteId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsInvitesDeleteOutput
    );
  }
  /**
   * @name Update organization invite
   * @description Update the role of an organization invite
   *
   * @param `inviteId` - string
   * @param `body` - DashboardOrganizationsInvitesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsInvitesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(inviteId, body, opts) {
    let path = `organization/invites/${inviteId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsInvitesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsInvitesUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_members.ts
var MetorialManagementOrganizationMembersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization members
   * @description List all organization members
   *
   * @param `query` - DashboardOrganizationsMembersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/members";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsMembersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsMembersListOutput
    );
  }
  /**
   * @name Get organization member
   * @description Get the information of a specific organization member
   *
   * @param `memberId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(memberId, opts) {
    let path = `organization/members/${memberId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsMembersGetOutput
    );
  }
  /**
   * @name Delete organization member
   * @description Remove an organization member
   *
   * @param `memberId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(memberId, opts) {
    let path = `organization/members/${memberId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsMembersDeleteOutput
    );
  }
  /**
   * @name Update organization member
   * @description Update the role of an organization member
   *
   * @param `memberId` - string
   * @param `body` - DashboardOrganizationsMembersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(memberId, body, opts) {
    let path = `organization/members/${memberId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsMembersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsMembersUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_members_policies.ts
var MetorialManagementOrganizationMembersPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign policy to organization member
   * @description Assign an access policy to an organization member
   *
   * @param `memberId` - string
   * @param `body` - DashboardOrganizationsMembersPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(memberId, body, opts) {
    let path = `organization/members/${memberId}/policies`;
    let request = {
      path,
      body: mapDashboardOrganizationsMembersPoliciesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsMembersPoliciesCreateOutput
    );
  }
  /**
   * @name Remove policy from organization member
   * @description Remove an access policy from an organization member
   *
   * @param `memberId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsMembersPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(memberId, accessPolicyId, opts) {
    let path = `organization/members/${memberId}/policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsMembersPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_oauth_apps.ts
var MetorialManagementOrganizationOauthAppsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth applications
   * @description Returns a paginated list of OAuth applications owned by the organization.
   *
   * @param `query` - DashboardOrganizationsOauthAppsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/oauth/apps";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthAppsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAppsListOutput
    );
  }
  /**
   * @name Get organization OAuth application
   * @description Retrieves a specific OAuth application owned by the organization.
   *
   * @param `oauthApplicationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(oauthApplicationId, opts) {
    let path = `organization/oauth/apps/${oauthApplicationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAppsGetOutput
    );
  }
  /**
   * @name Create organization OAuth application
   * @description Creates a new OAuth application that belongs to the organization.
   *
   * @param `body` - DashboardOrganizationsOauthAppsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/oauth/apps";
    let request = {
      path,
      body: mapDashboardOrganizationsOauthAppsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthAppsCreateOutput
    );
  }
  /**
   * @name Update organization OAuth application
   * @description Updates an existing OAuth application owned by the organization.
   *
   * @param `oauthApplicationId` - string
   * @param `body` - DashboardOrganizationsOauthAppsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(oauthApplicationId, body, opts) {
    let path = `organization/oauth/apps/${oauthApplicationId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsOauthAppsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsOauthAppsUpdateOutput
    );
  }
  /**
   * @name Delete organization OAuth application
   * @description Archives an OAuth application owned by the organization.
   *
   * @param `oauthApplicationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(oauthApplicationId, opts) {
    let path = `organization/oauth/apps/${oauthApplicationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOauthAppsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_oauth_apps_client-secrets.ts
var MetorialManagementOrganizationOauthAppsClientSecretsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create OAuth application client secret
   * @description Creates a new client secret for an OAuth application.
   *
   * @param `oauthApplicationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsClientSecretsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(oauthApplicationId, opts) {
    let path = `organization/oauth/apps/${oauthApplicationId}/client-secrets`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthAppsClientSecretsCreateOutput
    );
  }
  /**
   * @name Delete OAuth application client secret
   * @description Deletes a client secret from an OAuth application.
   *
   * @param `oauthApplicationId` - string
   * @param `oauthApplicationClientSecretId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAppsClientSecretsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(oauthApplicationId, oauthApplicationClientSecretId, opts) {
    let path = `organization/oauth/apps/${oauthApplicationId}/client-secrets/${oauthApplicationClientSecretId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOauthAppsClientSecretsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_oauth_authorization-logs.ts
var MetorialManagementOrganizationOauthAuthorizationLogsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth authorization logs
   * @description Returns a paginated list of OAuth authorization requests for the organization.
   *
   * @param `query` - DashboardOrganizationsOauthAuthorizationLogsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationLogsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/oauth/authorization-logs";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthAuthorizationLogsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAuthorizationLogsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_oauth_authorizations.ts
var MetorialManagementOrganizationOauthAuthorizationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth authorizations
   * @description Returns a paginated list of OAuth authorizations for the organization.
   *
   * @param `query` - DashboardOrganizationsOauthAuthorizationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/oauth/authorizations";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthAuthorizationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAuthorizationsListOutput
    );
  }
  /**
   * @name Get organization OAuth authorization
   * @description Retrieves a specific OAuth authorization for the organization.
   *
   * @param `oauthAuthorizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(oauthAuthorizationId, opts) {
    let path = `organization/oauth/authorizations/${oauthAuthorizationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthAuthorizationsGetOutput
    );
  }
  /**
   * @name Revoke organization OAuth authorization
   * @description Revokes a specific OAuth authorization for the organization.
   *
   * @param `oauthAuthorizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthAuthorizationsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(oauthAuthorizationId, opts) {
    let path = `organization/oauth/authorizations/${oauthAuthorizationId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthAuthorizationsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_oauth_cli-devices.ts
var MetorialManagementOrganizationOauthCliDevicesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization CLI devices
   * @description Returns a paginated list of CLI devices for the organization.
   *
   * @param `query` - DashboardOrganizationsOauthCliDevicesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthCliDevicesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/oauth/cli-devices";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthCliDevicesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthCliDevicesListOutput
    );
  }
  /**
   * @name Get organization CLI device
   * @description Retrieves a specific CLI device for the organization.
   *
   * @param `cliDeviceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthCliDevicesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(cliDeviceId, opts) {
    let path = `organization/oauth/cli-devices/${cliDeviceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthCliDevicesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_oauth_installations.ts
var MetorialManagementOrganizationOauthInstallationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization OAuth installations
   * @description Returns a paginated list of OAuth installations for the organization.
   *
   * @param `query` - DashboardOrganizationsOauthInstallationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthInstallationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/oauth/installations";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthInstallationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthInstallationsListOutput
    );
  }
  /**
   * @name Get organization OAuth installation
   * @description Retrieves a specific OAuth installation for the organization.
   *
   * @param `oauthInstallationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthInstallationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(oauthInstallationId, opts) {
    let path = `organization/oauth/installations/${oauthInstallationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthInstallationsGetOutput
    );
  }
  /**
   * @name Revoke organization OAuth installation
   * @description Revokes a specific OAuth installation for the organization.
   *
   * @param `oauthInstallationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthInstallationsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(oauthInstallationId, opts) {
    let path = `organization/oauth/installations/${oauthInstallationId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOauthInstallationsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_oauth_scopes.ts
var MetorialManagementOrganizationOauthScopesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List OAuth scopes
   * @description Returns all available OAuth scopes that organization-owned OAuth applications may request.
   *
   * @param `query` - DashboardOrganizationsOauthScopesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOauthScopesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/oauth/scopes";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOauthScopesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOauthScopesListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_outposts.ts
var MetorialManagementOrganizationOutpostsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List outposts
   * @description List every outpost in the organization's account family
   *
   * @param `query` - DashboardOrganizationsOutpostsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/outposts";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOutpostsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsListOutput
    );
  }
  /**
   * @name Get outpost
   * @description Get any outpost in the organization's account family
   *
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(outpostId, opts) {
    let path = `organization/outposts/${outpostId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsGetOutput
    );
  }
  /**
   * @name Create outpost
   * @description Create a new outpost owned by this organization
   *
   * @param `body` - DashboardOrganizationsOutpostsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/outposts";
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsCreateOutput
    );
  }
  /**
   * @name Update outpost
   * @description Update the information of an outpost owned by this organization
   *
   * @param `outpostId` - string
   * @param `body` - DashboardOrganizationsOutpostsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(outpostId, body, opts) {
    let path = `organization/outposts/${outpostId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsUpdateOutput
    );
  }
  /**
   * @name Disable outpost
   * @description Disable an outpost owned by this organization. An outpost must be disabled before it can be deleted.
   *
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsDisableOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  disable(outpostId, opts) {
    let path = `organization/outposts/${outpostId}/disable`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsDisableOutput
    );
  }
  /**
   * @name Enable outpost
   * @description Enable a disabled outpost owned by this organization
   *
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsEnableOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  enable(outpostId, opts) {
    let path = `organization/outposts/${outpostId}/enable`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsEnableOutput
    );
  }
  /**
   * @name Delete outpost
   * @description Delete a disabled outpost owned by this organization
   *
   * @param `outpostId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(outpostId, opts) {
    let path = `organization/outposts/${outpostId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOutpostsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_outposts_access.ts
var MetorialManagementOrganizationOutpostsAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Set outpost access
   * @description Replace this organization's access grants on an outpost with the given list of instance/service grants
   *
   * @param `outpostId` - string
   * @param `body` - DashboardOrganizationsOutpostsAccessSetBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsAccessSetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  set(outpostId, body, opts) {
    let path = `organization/outposts/${outpostId}/access`;
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsAccessSetBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsAccessSetOutput
    );
  }
  /**
   * @name List outpost access
   * @description List the access grants on an outpost, optionally filtered by organization or instance
   *
   * @param `outpostId` - string
   * @param `query` - DashboardOrganizationsOutpostsAccessListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsAccessListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(outpostId, query, opts) {
    let path = `organization/outposts/${outpostId}/access`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOutpostsAccessListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsAccessListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_outposts_credentials.ts
var MetorialManagementOrganizationOutpostsCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create outpost credential
   * @description Create a new enrollment credential for an outpost owned by this organization
   *
   * @param `outpostId` - string
   * @param `body` - DashboardOrganizationsOutpostsCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(outpostId, body, opts) {
    let path = `organization/outposts/${outpostId}/credentials`;
    let request = {
      path,
      body: mapDashboardOrganizationsOutpostsCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsCreateOutput
    );
  }
  /**
   * @name List outpost credentials
   * @description List the credentials for an outpost owned by this organization
   *
   * @param `outpostId` - string
   * @param `query` - DashboardOrganizationsOutpostsCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(outpostId, query, opts) {
    let path = `organization/outposts/${outpostId}/credentials`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsOutpostsCredentialsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsListOutput
    );
  }
  /**
   * @name Get outpost credential
   * @description Get a credential for an outpost owned by this organization
   *
   * @param `outpostId` - string
   * @param `credentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(outpostId, credentialId, opts) {
    let path = `organization/outposts/${outpostId}/credentials/${credentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsGetOutput
    );
  }
  /**
   * @name Disable outpost credential
   * @description Disable a credential for an outpost owned by this organization. A credential must be disabled before it can be deleted.
   *
   * @param `outpostId` - string
   * @param `credentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsDisableOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  disable(outpostId, credentialId, opts) {
    let path = `organization/outposts/${outpostId}/credentials/${credentialId}/disable`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsDisableOutput
    );
  }
  /**
   * @name Delete outpost credential
   * @description Delete a disabled credential for an outpost owned by this organization
   *
   * @param `outpostId` - string
   * @param `credentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsOutpostsCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(outpostId, credentialId, opts) {
    let path = `organization/outposts/${outpostId}/credentials/${credentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsOutpostsCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_projects.ts
var MetorialManagementOrganizationProjectsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization projects
   * @description List all organization projects
   *
   * @param `query` - DashboardOrganizationsProjectsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/projects";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsProjectsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsProjectsListOutput
    );
  }
  /**
   * @name Get organization project
   * @description Get the information of a specific organization project
   *
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, opts) {
    let path = `organization/projects/${projectId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsProjectsGetOutput
    );
  }
  /**
   * @name Create organization project
   * @description Create a new organization project
   *
   * @param `body` - DashboardOrganizationsProjectsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/projects";
    let request = {
      path,
      body: mapDashboardOrganizationsProjectsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsProjectsCreateOutput
    );
  }
  /**
   * @name Delete organization project
   * @description Remove an organization project
   *
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(projectId, opts) {
    let path = `organization/projects/${projectId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsProjectsDeleteOutput
    );
  }
  /**
   * @name Update organization project
   * @description Update the role of an organization project
   *
   * @param `projectId` - string
   * @param `body` - DashboardOrganizationsProjectsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, body, opts) {
    let path = `organization/projects/${projectId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsProjectsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsProjectsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_projects_branding.ts
var MetorialManagementOrganizationProjectsBrandingEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get project branding
   * @description Get branding information for a specific project
   *
   * @param `projectId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsBrandingGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, opts) {
    let path = `organization/projects/${projectId}/branding`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsProjectsBrandingGetOutput
    );
  }
  /**
   * @name Update project branding
   * @description Update branding information for a specific project
   *
   * @param `projectId` - string
   * @param `body` - DashboardOrganizationsProjectsBrandingUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsProjectsBrandingUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, body, opts) {
    let path = `organization/projects/${projectId}/branding`;
    let request = {
      path,
      body: mapDashboardOrganizationsProjectsBrandingUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsProjectsBrandingUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_sandboxes.ts
var MetorialManagementOrganizationSandboxesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization sandboxes
   * @description List all organization sandboxes
   *
   * @param `query` - DashboardOrganizationsSandboxesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/sandboxes";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsSandboxesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsSandboxesListOutput
    );
  }
  /**
   * @name Get organization sandbox
   * @description Get the information of a specific organization sandbox
   *
   * @param `sandboxId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sandboxId, opts) {
    let path = `organization/sandboxes/${sandboxId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsSandboxesGetOutput
    );
  }
  /**
   * @name Create organization sandbox
   * @description Create a new development sandbox
   *
   * @param `body` - DashboardOrganizationsSandboxesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/sandboxes";
    let request = {
      path,
      body: mapDashboardOrganizationsSandboxesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsSandboxesCreateOutput
    );
  }
  /**
   * @name Update organization sandbox
   * @description Update a development sandbox
   *
   * @param `sandboxId` - string
   * @param `body` - DashboardOrganizationsSandboxesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsSandboxesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(sandboxId, body, opts) {
    let path = `organization/sandboxes/${sandboxId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsSandboxesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsSandboxesUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_service-accounts.ts
var MetorialManagementOrganizationServiceAccountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization service accounts
   * @description Returns a paginated list of service accounts owned by the organization.
   *
   * @param `query` - DashboardOrganizationsServiceAccountsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/service-accounts";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsServiceAccountsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsListOutput
    );
  }
  /**
   * @name Get organization service account
   * @description Retrieves a specific service account owned by the organization.
   *
   * @param `serviceAccountId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(serviceAccountId, opts) {
    let path = `organization/service-accounts/${serviceAccountId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsGetOutput
    );
  }
  /**
   * @name Create organization service account
   * @description Creates a new service account for machine-to-machine authentication.
   *
   * @param `body` - DashboardOrganizationsServiceAccountsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/service-accounts";
    let request = {
      path,
      body: mapDashboardOrganizationsServiceAccountsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsServiceAccountsCreateOutput
    );
  }
  /**
   * @name Update organization service account
   * @description Updates an existing service account owned by the organization.
   *
   * @param `serviceAccountId` - string
   * @param `body` - DashboardOrganizationsServiceAccountsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(serviceAccountId, body, opts) {
    let path = `organization/service-accounts/${serviceAccountId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsServiceAccountsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardOrganizationsServiceAccountsUpdateOutput
    );
  }
  /**
   * @name Delete organization service account
   * @description Archives a service account owned by the organization.
   *
   * @param `serviceAccountId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(serviceAccountId, opts) {
    let path = `organization/service-accounts/${serviceAccountId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsServiceAccountsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_service-accounts_client-secrets.ts
var MetorialManagementOrganizationServiceAccountsClientSecretsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create service account client secret
   * @description Creates a new client secret for a service account.
   *
   * @param `serviceAccountId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsClientSecretsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(serviceAccountId, opts) {
    let path = `organization/service-accounts/${serviceAccountId}/client-secrets`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsServiceAccountsClientSecretsCreateOutput
    );
  }
  /**
   * @name Delete service account client secret
   * @description Deletes a client secret from a service account.
   *
   * @param `serviceAccountId` - string
   * @param `oauthApplicationClientSecretId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsClientSecretsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(serviceAccountId, oauthApplicationClientSecretId, opts) {
    let path = `organization/service-accounts/${serviceAccountId}/client-secrets/${oauthApplicationClientSecretId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsServiceAccountsClientSecretsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_service-accounts_credentials.ts
var MetorialManagementOrganizationServiceAccountsCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List service account credentials
   * @description Returns a paginated list of credentials for a service account.
   *
   * @param `serviceAccountId` - string
   * @param `query` - DashboardOrganizationsServiceAccountsCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(serviceAccountId, query, opts) {
    let path = `organization/service-accounts/${serviceAccountId}/credentials`;
    let request = {
      path,
      query: query ? mapDashboardOrganizationsServiceAccountsCredentialsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsCredentialsListOutput
    );
  }
  /**
   * @name Get service account credential
   * @description Retrieves a specific credential for a service account.
   *
   * @param `serviceAccountId` - string
   * @param `serviceAccountCredentialId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(serviceAccountId, serviceAccountCredentialId, opts) {
    let path = `organization/service-accounts/${serviceAccountId}/credentials/${serviceAccountCredentialId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsServiceAccountsCredentialsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_service-accounts_policies.ts
var MetorialManagementOrganizationServiceAccountsPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign service account policy
   * @description Assign an access policy to a service account
   *
   * @param `serviceAccountId` - string
   * @param `body` - DashboardOrganizationsServiceAccountsPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(serviceAccountId, body, opts) {
    let path = `organization/service-accounts/${serviceAccountId}/policies`;
    let request = {
      path,
      body: mapDashboardOrganizationsServiceAccountsPoliciesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsServiceAccountsPoliciesCreateOutput
    );
  }
  /**
   * @name Remove service account policy
   * @description Remove an access policy from a service account
   *
   * @param `serviceAccountId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsServiceAccountsPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(serviceAccountId, accessPolicyId, opts) {
    let path = `organization/service-accounts/${serviceAccountId}/policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsServiceAccountsPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_teams.ts
var MetorialManagementOrganizationTeamsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List organization teams
   * @description List all organization teams
   *
   * @param `query` - DashboardOrganizationsTeamsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "organization/teams";
    let request = {
      path,
      query: query ? mapDashboardOrganizationsTeamsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsTeamsListOutput
    );
  }
  /**
   * @name Get team
   * @description Get the information of a specific team
   *
   * @param `teamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(teamId, opts) {
    let path = `organization/teams/${teamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsTeamsGetOutput
    );
  }
  /**
   * @name Update team
   * @description Update the role of an team
   *
   * @param `teamId` - string
   * @param `body` - DashboardOrganizationsTeamsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(teamId, body, opts) {
    let path = `organization/teams/${teamId}`;
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsUpdateOutput
    );
  }
  /**
   * @name Delete team
   * @description Delete a team. Its members keep their own access.
   *
   * @param `teamId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(teamId, opts) {
    let path = `organization/teams/${teamId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsTeamsDeleteOutput
    );
  }
  /**
   * @name Create organization team
   * @description Create a new organization team
   *
   * @param `body` - DashboardOrganizationsTeamsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "organization/teams";
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_teams_members.ts
var MetorialManagementOrganizationTeamsMembersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign member to team
   * @description Assign an organization member to a team
   *
   * @param `teamId` - string
   * @param `body` - DashboardOrganizationsTeamsMembersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsMembersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(teamId, body, opts) {
    let path = `organization/teams/${teamId}/members`;
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsMembersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsMembersCreateOutput
    );
  }
  /**
   * @name Remove member from team
   * @description Remove an organization member from a team
   *
   * @param `teamId` - string
   * @param `actorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsMembersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(teamId, actorId, opts) {
    let path = `organization/teams/${teamId}/members/${actorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsTeamsMembersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_teams_policies.ts
var MetorialManagementOrganizationTeamsPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Assign policy to team
   * @description Assign an access policy to a team
   *
   * @param `teamId` - string
   * @param `body` - DashboardOrganizationsTeamsPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(teamId, body, opts) {
    let path = `organization/teams/${teamId}/policies`;
    let request = {
      path,
      body: mapDashboardOrganizationsTeamsPoliciesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardOrganizationsTeamsPoliciesCreateOutput
    );
  }
  /**
   * @name Remove policy from team
   * @description Remove an access policy from a team
   *
   * @param `teamId` - string
   * @param `accessPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsTeamsPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(teamId, accessPolicyId, opts) {
    let path = `organization/teams/${teamId}/policies/${accessPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardOrganizationsTeamsPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_organization_webhook-events.ts
var MetorialManagementOrganizationWebhookEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List webhook events
   * @description List all event types that event destination listeners can subscribe to
   *
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardOrganizationsWebhookEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(opts) {
    let path = "organization/webhook-events";
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardOrganizationsWebhookEventsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/management_user.ts
var MetorialManagementUserEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get user
   * @description Get the current user information
   *
   * @param `opts` - { headers?: Record<string, string> }
   * @returns ManagementUserGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(opts) {
    let path = "user";
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapManagementUserGetOutput);
  }
  /**
   * @name Update user
   * @description Update the current user information
   *
   * @param `body` - ManagementUserUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns ManagementUserUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(body, opts) {
    let path = "user";
    let request = {
      path,
      body: mapManagementUserUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapManagementUserUpdateOutput);
  }
  /**
   * @name Update user
   * @description Update the current user information
   *
   * @param `body` - ManagementUserDeleteBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns ManagementUserDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(body, opts) {
    let path = "user";
    let request = {
      path,
      body: mapManagementUserDeleteBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapManagementUserDeleteOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/monitor-alerts.ts
var MetorialMonitorAlertsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List monitor alerts
   * @description Returns a paginated list of monitor alerts for this instance.
   *
   * @param `query` - DashboardInstanceMonitorAlertsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "monitor-alerts";
    let request = {
      path,
      query: query ? mapDashboardInstanceMonitorAlertsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMonitorAlertsListOutput
    );
  }
  /**
   * @name Get monitor alert
   * @description Retrieves a monitor alert by ID.
   *
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(monitorAlertId, opts) {
    let path = `monitor-alerts/${monitorAlertId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceMonitorAlertsGetOutput
    );
  }
  /**
   * @name Mark monitor alert viewed
   * @description Marks a monitor alert as viewed by the current actor.
   *
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsViewedOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  viewed(monitorAlertId, opts) {
    let path = `monitor-alerts/${monitorAlertId}/viewed`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsViewedOutput
    );
  }
  /**
   * @name Resolve monitor alert
   * @description Marks a monitor alert as resolved.
   *
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resolve(monitorAlertId, opts) {
    let path = `monitor-alerts/${monitorAlertId}/resolve`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsResolveOutput
    );
  }
  /**
   * @name Unresolve monitor alert
   * @description Reopens a resolved monitor alert.
   *
   * @param `monitorAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorAlertsUnresolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  unresolve(monitorAlertId, opts) {
    let path = `monitor-alerts/${monitorAlertId}/unresolve`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceMonitorAlertsUnresolveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/monitors.ts
var MetorialMonitorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List monitors
   * @description Returns a paginated list of monitors for this instance.
   *
   * @param `query` - DashboardInstanceMonitorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "monitors";
    let request = {
      path,
      query: query ? mapDashboardInstanceMonitorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceMonitorsListOutput);
  }
  /**
   * @name Get monitor
   * @description Retrieves a monitor by ID.
   *
   * @param `monitorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceMonitorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(monitorId, opts) {
    let path = `monitors/${monitorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceMonitorsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/network-policies.ts
var MetorialNetworkPoliciesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List network policies
   * @description Returns a paginated list of network policies.
   *
   * @param `query` - DashboardInstanceNetworkPoliciesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "network-policies";
    let request = {
      path,
      query: query ? mapDashboardInstanceNetworkPoliciesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceNetworkPoliciesListOutput
    );
  }
  /**
   * @name Get network policy
   * @description Retrieves a specific network policy by ID.
   *
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(networkPolicyId, opts) {
    let path = `network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceNetworkPoliciesGetOutput
    );
  }
  /**
   * @name Create network policy
   * @description Creates a new network policy.
   *
   * @param `body` - DashboardInstanceNetworkPoliciesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "network-policies";
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceNetworkPoliciesCreateOutput
    );
  }
  /**
   * @name Update network policy
   * @description Updates a network policy definition.
   *
   * @param `networkPolicyId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(networkPolicyId, body, opts) {
    let path = `network-policies/${networkPolicyId}`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceNetworkPoliciesUpdateOutput
    );
  }
  /**
   * @name Delete network policy
   * @description Archives a network policy.
   *
   * @param `networkPolicyId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(networkPolicyId, opts) {
    let path = `network-policies/${networkPolicyId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceNetworkPoliciesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/network-policies_rules.ts
var MetorialNetworkPoliciesRulesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create network policy rule
   * @description Adds a rule to a network policy.
   *
   * @param `networkPolicyId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesRulesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(networkPolicyId, body, opts) {
    let path = `network-policies/${networkPolicyId}/rules`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesRulesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesCreateOutput
    );
  }
  /**
   * @name Update network policy rule
   * @description Updates a rule on a network policy.
   *
   * @param `networkPolicyId` - string
   * @param `ruleId` - string
   * @param `body` - DashboardInstanceNetworkPoliciesRulesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(networkPolicyId, ruleId, body, opts) {
    let path = `network-policies/${networkPolicyId}/rules/${ruleId}`;
    let request = {
      path,
      body: mapDashboardInstanceNetworkPoliciesRulesUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesUpdateOutput
    );
  }
  /**
   * @name Delete network policy rule
   * @description Removes a rule from a network policy.
   *
   * @param `networkPolicyId` - string
   * @param `ruleId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceNetworkPoliciesRulesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(networkPolicyId, ruleId, opts) {
    let path = `network-policies/${networkPolicyId}/rules/${ruleId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceNetworkPoliciesRulesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/organizations_flags.ts
var MetorialOrganizationsFlagsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get flags
   * @description Get feature flags for the current organization and user
   *
   * @param `organizationId` - string
   * @param `query` - OrganizationsFlagsGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns OrganizationsFlagsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, query, opts) {
    let path = `dashboard/organizations/${organizationId}/flags`;
    let request = {
      path,
      query: query ? mapOrganizationsFlagsGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapOrganizationsFlagsGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/organizations_profile.ts
var MetorialOrganizationsProfileEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get own profile
   * @description Get the profile for the current organization
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns OrganizationsProfileGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/profile`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapOrganizationsProfileGetOutput);
  }
  /**
   * @name Update own profile
   * @description Update the profile for the current organization
   *
   * @param `organizationId` - string
   * @param `body` - OrganizationsProfileUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns OrganizationsProfileUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(organizationId, body, opts) {
    let path = `dashboard/organizations/${organizationId}/profile`;
    let request = {
      path,
      body: mapOrganizationsProfileUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(mapOrganizationsProfileUpdateOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/organizations_scopes.ts
var MetorialOrganizationsScopesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get my organization scopes
   * @description Get the effective scopes the current dashboard member has for this organization
   *
   * @param `organizationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns OrganizationsScopesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(organizationId, opts) {
    let path = `dashboard/organizations/${organizationId}/scopes`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapOrganizationsScopesGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals.ts
var MetorialPortalsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portals
   * @description Returns a paginated list of portals.
   *
   * @param `query` - DashboardInstancePortalsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "portals";
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstancePortalsListOutput);
  }
  /**
   * @name Get portal
   * @description Retrieves details for a specific portal.
   *
   * @param `portalId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, opts) {
    let path = `portals/${portalId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstancePortalsGetOutput);
  }
  /**
   * @name Create portal
   * @description Creates a new portal for the instance.
   *
   * @param `body` - DashboardInstancePortalsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "portals";
    let request = {
      path,
      body: mapDashboardInstancePortalsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsCreateOutput
    );
  }
  /**
   * @name Update portal
   * @description Updates an existing portal for the instance.
   *
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, body, opts) {
    let path = `portals/${portalId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsUpdateOutput
    );
  }
  /**
   * @name Delete portal
   * @description Archives a portal.
   *
   * @param `portalId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId, opts) {
    let path = `portals/${portalId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals_access-requests.ts
var MetorialPortalsAccessRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal access requests
   * @description Returns a paginated list of access requests for a portal.
   *
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsAccessRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query, opts) {
    let path = `portals/${portalId}/access-requests`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsAccessRequestsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessRequestsListOutput
    );
  }
  /**
   * @name Get portal access request
   * @description Retrieves a access request by ID.
   *
   * @param `portalId` - string
   * @param `accessRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, accessRequestId, opts) {
    let path = `portals/${portalId}/access-requests/${accessRequestId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessRequestsGetOutput
    );
  }
  /**
   * @name Review portal access request
   * @description Approves or rejects a access request.
   *
   * @param `portalId` - string
   * @param `accessRequestId` - string
   * @param `body` - DashboardInstancePortalsAccessRequestsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessRequestsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, accessRequestId, body, opts) {
    let path = `portals/${portalId}/access-requests/${accessRequestId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessRequestsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsAccessRequestsUpdateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals_access.ts
var MetorialPortalsAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal access
   * @description Returns a paginated list of consumer access rules for a portal.
   *
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsAccessListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query, opts) {
    let path = `portals/${portalId}/access`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsAccessListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessListOutput
    );
  }
  /**
   * @name Get portal access
   * @description Retrieves a portal access rule by ID.
   *
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, accessId, opts) {
    let path = `portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsAccessGetOutput
    );
  }
  /**
   * @name Create portal access
   * @description Creates a new consumer access rule for the portal.
   *
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsAccessCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(portalId, body, opts) {
    let path = `portals/${portalId}/access`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsAccessCreateOutput
    );
  }
  /**
   * @name Update portal access
   * @description Updates the shared listing fields for a portal access rule.
   *
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `body` - DashboardInstancePortalsAccessUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, accessId, body, opts) {
    let path = `portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsAccessUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsAccessUpdateOutput
    );
  }
  /**
   * @name Delete portal access
   * @description Deletes a consumer access rule from the portal.
   *
   * @param `portalId` - string
   * @param `accessId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsAccessDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId, accessId, opts) {
    let path = `portals/${portalId}/access/${accessId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsAccessDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals_consumer-groups.ts
var MetorialPortalsConsumerGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer groups
   * @description Returns a paginated list of consumer groups for a portal.
   *
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query, opts) {
    let path = `portals/${portalId}/consumer-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerGroupsListOutput
    );
  }
  /**
   * @name Get portal consumer group
   * @description Retrieves a portal consumer group by ID.
   *
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, consumerGroupId, opts) {
    let path = `portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerGroupsGetOutput
    );
  }
  /**
   * @name Create portal consumer group
   * @description Creates a new consumer group for the portal.
   *
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(portalId, body, opts) {
    let path = `portals/${portalId}/consumer-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerGroupsCreateOutput
    );
  }
  /**
   * @name Update portal consumer group
   * @description Updates a consumer group for the portal.
   *
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `body` - DashboardInstancePortalsConsumerGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, consumerGroupId, body, opts) {
    let path = `portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsConsumerGroupsUpdateOutput
    );
  }
  /**
   * @name Delete portal consumer group
   * @description Archives a consumer group for the portal.
   *
   * @param `portalId` - string
   * @param `consumerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId, consumerGroupId, opts) {
    let path = `portals/${portalId}/consumer-groups/${consumerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsConsumerGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals_consumer-invites.ts
var MetorialPortalsConsumerInvitesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer invites
   * @description Returns a paginated list of invites for a portal.
   *
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerInvitesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query, opts) {
    let path = `portals/${portalId}/consumer-invites`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerInvitesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerInvitesListOutput
    );
  }
  /**
   * @name Create portal consumer invite
   * @description Invites a consumer to a portal.
   *
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerInvitesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(portalId, body, opts) {
    let path = `portals/${portalId}/consumer-invites`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerInvitesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerInvitesCreateOutput
    );
  }
  /**
   * @name Get portal consumer invite
   * @description Retrieves a portal consumer invite by ID.
   *
   * @param `portalId` - string
   * @param `consumerInviteId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerInvitesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, consumerInviteId, opts) {
    let path = `portals/${portalId}/consumer-invites/${consumerInviteId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerInvitesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals_consumer-profiles.ts
var MetorialPortalsConsumerProfilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal consumer profiles
   * @description Returns a paginated list of consumer profiles for a portal.
   *
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsConsumerProfilesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query, opts) {
    let path = `portals/${portalId}/consumer-profile`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsConsumerProfilesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerProfilesListOutput
    );
  }
  /**
   * @name Get portal consumer profile
   * @description Retrieves a portal consumer profile by ID.
   *
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, consumerProfileId, opts) {
    let path = `portals/${portalId}/consumer-profile/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsConsumerProfilesGetOutput
    );
  }
  /**
   * @name Create portal consumer profile
   * @description Creates a new portal consumer profile.
   *
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(portalId, body, opts) {
    let path = `portals/${portalId}/consumer-profile`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesCreateOutput
    );
  }
  /**
   * @name Delete portal consumer profile
   * @description Soft-deletes a portal consumer profile.
   *
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId, consumerProfileId, opts) {
    let path = `portals/${portalId}/consumer-profile/${consumerProfileId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsConsumerProfilesDeleteOutput
    );
  }
  /**
   * @name Assign portal consumer profile groups
   * @description Assigns one or more groups to a portal consumer profile.
   *
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesAssignGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesAssignGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  assignGroups(portalId, consumerProfileId, body, opts) {
    let path = `portals/${portalId}/consumer-profile/${consumerProfileId}/assign-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesAssignGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesAssignGroupsOutput
    );
  }
  /**
   * @name Unassign portal consumer profile groups
   * @description Removes one or more groups from a portal consumer profile.
   *
   * @param `portalId` - string
   * @param `consumerProfileId` - string
   * @param `body` - DashboardInstancePortalsConsumerProfilesUnassignGroupsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsConsumerProfilesUnassignGroupsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  unassignGroups(portalId, consumerProfileId, body, opts) {
    let path = `portals/${portalId}/consumer-profile/${consumerProfileId}/unassign-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsConsumerProfilesUnassignGroupsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsConsumerProfilesUnassignGroupsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals_listings.ts
var MetorialPortalsListingsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal listings
   * @description Returns a paginated list of shared listings for a portal.
   *
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsListingsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query, opts) {
    let path = `portals/${portalId}/listings`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsListingsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsListingsListOutput
    );
  }
  /**
   * @name Get portal listing
   * @description Retrieves one shared listing for a portal.
   *
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, listingId, opts) {
    let path = `portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsListingsGetOutput
    );
  }
  /**
   * @name Create portal listing
   * @description Creates a shared listing for a portal.
   *
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsListingsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(portalId, body, opts) {
    let path = `portals/${portalId}/listings`;
    let request = {
      path,
      body: mapDashboardInstancePortalsListingsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsListingsCreateOutput
    );
  }
  /**
   * @name Update portal listing
   * @description Updates listing metadata for a portal listing.
   *
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `body` - DashboardInstancePortalsListingsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, listingId, body, opts) {
    let path = `portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsListingsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsListingsUpdateOutput
    );
  }
  /**
   * @name Delete portal listing
   * @description Deletes a portal listing and all consumer access attached to it.
   *
   * @param `portalId` - string
   * @param `listingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsListingsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId, listingId, opts) {
    let path = `portals/${portalId}/listings/${listingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsListingsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/portals_surface-provider-groups.ts
var MetorialPortalsSurfaceProviderGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List portal surface provider groups
   * @description Returns a paginated list of provider groups linked to the portal consumer surface.
   *
   * @param `portalId` - string
   * @param `query` - DashboardInstancePortalsSurfaceProviderGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query, opts) {
    let path = `portals/${portalId}/surface-provider-groups`;
    let request = {
      path,
      query: query ? mapDashboardInstancePortalsSurfaceProviderGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsListOutput
    );
  }
  /**
   * @name Get portal surface provider group
   * @description Retrieves a portal surface provider group by ID.
   *
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, consumerSurfaceProviderGroupId, opts) {
    let path = `portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsGetOutput
    );
  }
  /**
   * @name Create portal surface provider group
   * @description Creates a new provider group linked to the portal consumer surface.
   *
   * @param `portalId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(portalId, body, opts) {
    let path = `portals/${portalId}/surface-provider-groups`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsCreateOutput
    );
  }
  /**
   * @name Update portal surface provider group
   * @description Updates a provider group linked to the portal consumer surface.
   *
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, consumerSurfaceProviderGroupId, body, opts) {
    let path = `portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsUpdateOutput
    );
  }
  /**
   * @name Delete portal surface provider group
   * @description Deletes a provider group linked to the portal consumer surface.
   *
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId, consumerSurfaceProviderGroupId, opts) {
    let path = `portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsDeleteOutput
    );
  }
  /**
   * @name Add listing to surface provider group
   * @description Adds a consumer access listing to the surface provider group.
   *
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `body` - DashboardInstancePortalsSurfaceProviderGroupsAddListingBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsAddListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addListing(portalId, consumerSurfaceProviderGroupId, body, opts) {
    let path = `portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}/listings`;
    let request = {
      path,
      body: mapDashboardInstancePortalsSurfaceProviderGroupsAddListingBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsAddListingOutput
    );
  }
  /**
   * @name Remove listing from surface provider group
   * @description Removes a consumer access listing from the surface provider group.
   *
   * @param `portalId` - string
   * @param `consumerSurfaceProviderGroupId` - string
   * @param `consumerAccessListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeListing(portalId, consumerSurfaceProviderGroupId, consumerAccessListingId, opts) {
    let path = `portals/${portalId}/surface-provider-groups/${consumerSurfaceProviderGroupId}/listings/${consumerAccessListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/proto-guard-alerts.ts
var MetorialProtoGuardAlertsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List ProtoGuard alerts
   * @description Returns a paginated list of ProtoGuard alerts for this instance.
   *
   * @param `query` - DashboardInstanceProtoGuardAlertsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardAlertsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "protoguard-alerts";
    let request = {
      path,
      query: query ? mapDashboardInstanceProtoGuardAlertsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardAlertsListOutput
    );
  }
  /**
   * @name Get ProtoGuard alert
   * @description Retrieves a ProtoGuard alert by ID.
   *
   * @param `protoGuardAlertId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardAlertsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(protoGuardAlertId, opts) {
    let path = `protoguard-alerts/${protoGuardAlertId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardAlertsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/proto-guard-config.ts
var MetorialProtoGuardConfigEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get ProtoGuard config
   * @description Retrieves ProtoGuard filter configuration for this instance.
   *
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(opts) {
    let path = "protoguard-config";
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProtoGuardConfigGetOutput
    );
  }
  /**
   * @name Update ProtoGuard filter config
   * @description Updates ProtoGuard filter settings for this instance.
   *
   * @param `filterId` - string
   * @param `body` - DashboardInstanceProtoGuardConfigUpdateFilterBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigUpdateFilterOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  updateFilter(filterId, body, opts) {
    let path = `protoguard-config/filters/${filterId}`;
    let request = {
      path,
      body: mapDashboardInstanceProtoGuardConfigUpdateFilterBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProtoGuardConfigUpdateFilterOutput
    );
  }
  /**
   * @name Set ProtoGuard alert filter count threshold
   * @description Sets or clears the number of matching ProtoGuard filters required to create an alert.
   *
   * @param `body` - DashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  setAlertFilterCountThreshold(body, opts) {
    let path = "protoguard-config/alert-filter-count-threshold";
    let request = {
      path,
      body: mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-auth-config-errors.ts
var MetorialProviderAuthConfigErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config errors
   * @description Returns a paginated list of provider auth config errors for dashboard diagnostics.
   *
   * @param `query` - DashboardInstanceProviderAuthConfigErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-config-errors";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigErrorsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsListOutput
    );
  }
  /**
   * @name Get provider auth config error
   * @description Retrieves a specific provider auth config error by ID.
   *
   * @param `providerAuthConfigErrorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthConfigErrorId, opts) {
    let path = `provider-auth-config-errors/${providerAuthConfigErrorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-auth-config-errors_groups.ts
var MetorialProviderAuthConfigErrorsGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config error groups
   * @description Returns grouped provider auth config errors aggregated by type and canonical message.
   *
   * @param `query` - DashboardInstanceProviderAuthConfigErrorsGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-config-error-groups";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigErrorsGroupsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGroupsListOutput
    );
  }
  /**
   * @name Get provider auth config error group
   * @description Retrieves a specific grouped provider auth config error by ID.
   *
   * @param `providerAuthConfigErrorGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigErrorsGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthConfigErrorGroupId, opts) {
    let path = `provider-auth-config-error-groups/${providerAuthConfigErrorGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigErrorsGroupsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-auth-config-events.ts
var MetorialProviderAuthConfigEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth config events
   * @description Returns a paginated list of provider auth config events for dashboard diagnostics.
   *
   * @param `query` - DashboardInstanceProviderAuthConfigEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-config-events";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderAuthConfigEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigEventsListOutput
    );
  }
  /**
   * @name Get provider auth config event
   * @description Retrieves a specific provider auth config event by ID.
   *
   * @param `providerAuthConfigEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderAuthConfigEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthConfigEventId, opts) {
    let path = `provider-auth-config-events/${providerAuthConfigEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderAuthConfigEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-categories.ts
var MetorialProviderCategoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider categories
   * @description Returns a paginated list of provider categories.
   *
   * @param `query` - DashboardInstanceProviderCategoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCategoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-categories";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderCategoriesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCategoriesListOutput
    );
  }
  /**
   * @name Get provider category
   * @description Retrieves a specific provider category by ID.
   *
   * @param `providerCategoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCategoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerCategoryId, opts) {
    let path = `provider-categories/${providerCategoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCategoriesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-collections.ts
var MetorialProviderCollectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider collections
   * @description Returns a paginated list of provider collections.
   *
   * @param `query` - DashboardInstanceProviderCollectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCollectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-collections";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderCollectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCollectionsListOutput
    );
  }
  /**
   * @name Get provider collection
   * @description Retrieves a specific provider collection by ID.
   *
   * @param `providerCollectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderCollectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerCollectionId, opts) {
    let path = `provider-collections/${providerCollectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderCollectionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments.ts
var MetorialProviderDeploymentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider deployments
   * @description Returns a paginated list of provider deployments.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-deployments";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsListOutput
    );
  }
  /**
   * @name Get provider deployment
   * @description Retrieves a specific provider deployment by ID.
   *
   * @param `providerDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerDeploymentId, opts) {
    let path = `provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsGetOutput
    );
  }
  /**
   * @name Create provider deployment
   * @description Creates a new provider deployment.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-deployments";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsCreateOutput
    );
  }
  /**
   * @name Update provider deployment
   * @description Updates a specific provider deployment.
   *
   * @param `providerDeploymentId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerDeploymentId, body, opts) {
    let path = `provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsUpdateOutput
    );
  }
  /**
   * @name Delete provider deployment
   * @description Permanently deletes a provider deployment.
   *
   * @param `providerDeploymentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(providerDeploymentId, opts) {
    let path = `provider-deployments/${providerDeploymentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments_auth-configs.ts
var MetorialProviderDeploymentsAuthConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth configs
   * @description Returns a paginated list of provider auth configs.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-configs";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsListOutput
    );
  }
  /**
   * @name Get provider auth config
   * @description Retrieves a specific provider auth config by ID.
   *
   * @param `providerAuthConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthConfigId, opts) {
    let path = `provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsGetOutput
    );
  }
  /**
   * @name Create provider auth config
   * @description Creates a new provider auth config.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-auth-configs";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsCreateOutput
    );
  }
  /**
   * @name Update provider auth config
   * @description Updates a specific provider auth config.
   *
   * @param `providerAuthConfigId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerAuthConfigId, body, opts) {
    let path = `provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput
    );
  }
  /**
   * @name Delete provider auth config
   * @description Permanently deletes a provider auth config.
   *
   * @param `providerAuthConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(providerAuthConfigId, opts) {
    let path = `provider-auth-configs/${providerAuthConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments_auth-configs_exports.ts
var MetorialProviderDeploymentsAuthConfigsExportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth exports
   * @description Returns a paginated list of provider auth exports.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-config-exports";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput
    );
  }
  /**
   * @name Get provider auth export
   * @description Retrieves a specific provider auth export by ID.
   *
   * @param `providerAuthExportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthExportId, opts) {
    let path = `provider-auth-config-exports/${providerAuthExportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput
    );
  }
  /**
   * @name Create provider auth export
   * @description Exports authentication credentials from a provider.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-auth-config-exports";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments_auth-configs_imports.ts
var MetorialProviderDeploymentsAuthConfigsImportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth imports
   * @description Returns a paginated list of provider auth imports.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-config-imports";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput
    );
  }
  /**
   * @name Get provider auth import
   * @description Retrieves a specific provider auth import by ID.
   *
   * @param `providerAuthImportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthImportId, opts) {
    let path = `provider-auth-config-imports/${providerAuthImportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput
    );
  }
  /**
   * @name Create provider auth import
   * @description Imports authentication credentials for a provider.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-auth-config-imports";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput
    );
  }
  /**
   * @name Get auth import schema
   * @description Retrieves the JSON Schema for importing authentication credentials.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getSchema(query, opts) {
    let path = "provider-auth-config-imports/schema";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments_auth-credentials.ts
var MetorialProviderDeploymentsAuthCredentialsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth credentials
   * @description Returns a paginated list of provider auth credentials.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsAuthCredentialsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-credentials";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsAuthCredentialsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsListOutput
    );
  }
  /**
   * @name Get provider auth credentials
   * @description Retrieves specific provider auth credentials by ID.
   *
   * @param `providerAuthCredentialsId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthCredentialsId, opts) {
    let path = `provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsGetOutput
    );
  }
  /**
   * @name Create provider auth credentials
   * @description Creates new provider auth credentials.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsAuthCredentialsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-auth-credentials";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput
    );
  }
  /**
   * @name Update provider auth credentials
   * @description Updates specific provider auth credentials.
   *
   * @param `providerAuthCredentialsId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerAuthCredentialsId, body, opts) {
    let path = `provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput
    );
  }
  /**
   * @name Delete provider auth credentials
   * @description Permanently deletes provider auth credentials.
   *
   * @param `providerAuthCredentialsId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(providerAuthCredentialsId, opts) {
    let path = `provider-auth-credentials/${providerAuthCredentialsId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments_config-vaults.ts
var MetorialProviderDeploymentsConfigVaultsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider config vaults
   * @description Returns a paginated list of provider config vaults.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsConfigVaultsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-config-vaults";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigVaultsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsListOutput
    );
  }
  /**
   * @name Get provider config vault
   * @description Retrieves a specific provider config vault by ID.
   *
   * @param `providerConfigVaultId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerConfigVaultId, opts) {
    let path = `provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsGetOutput
    );
  }
  /**
   * @name Create provider config vault
   * @description Creates a new provider config vault.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsConfigVaultsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-config-vaults";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigVaultsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsCreateOutput
    );
  }
  /**
   * @name Update provider config vault
   * @description Updates a specific provider config vault.
   *
   * @param `providerConfigVaultId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigVaultsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerConfigVaultId, body, opts) {
    let path = `provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput
    );
  }
  /**
   * @name Delete provider config vault
   * @description Permanently deletes a provider config vault.
   *
   * @param `providerConfigVaultId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(providerConfigVaultId, opts) {
    let path = `provider-config-vaults/${providerConfigVaultId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments_configs.ts
var MetorialProviderDeploymentsConfigsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider configs
   * @description Returns a paginated list of provider configs.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsConfigsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-configs";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsListOutput
    );
  }
  /**
   * @name Get provider config
   * @description Retrieves a specific provider config by ID.
   *
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerConfigId, opts) {
    let path = `provider-configs/${providerConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetOutput
    );
  }
  /**
   * @name Create provider config
   * @description Creates a new provider config.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsConfigsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-configs";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsCreateOutput
    );
  }
  /**
   * @name Update provider config
   * @description Updates a specific provider config. Passing `value` replaces its configuration values with a new config version.
   *
   * @param `providerConfigId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsConfigsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerConfigId, body, opts) {
    let path = `provider-configs/${providerConfigId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsConfigsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsUpdateOutput
    );
  }
  /**
   * @name Get provider config value
   * @description Retrieves a provider config's current configuration values, unless the provider stores them encrypted.
   *
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetValueOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getValue(providerConfigId, opts) {
    let path = `provider-configs/${providerConfigId}/value`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetValueOutput
    );
  }
  /**
   * @name Delete provider config
   * @description Permanently deletes a provider config.
   *
   * @param `providerConfigId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(providerConfigId, opts) {
    let path = `provider-configs/${providerConfigId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsDeleteOutput
    );
  }
  /**
   * @name Get config schema
   * @description Retrieves the JSON Schema for configuration of this provider deployment.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getConfigSchema(query, opts) {
    let path = "provider-config-schema";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-deployments_setup-sessions.ts
var MetorialProviderDeploymentsSetupSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider setup sessions
   * @description Returns a paginated list of provider setup sessions.
   *
   * @param `query` - DashboardInstanceProviderDeploymentsSetupSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-setup-sessions";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderDeploymentsSetupSessionsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsListOutput
    );
  }
  /**
   * @name Get provider setup session
   * @description Retrieves a specific provider setup session by ID.
   *
   * @param `providerSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerSetupSessionId, opts) {
    let path = `provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsGetOutput
    );
  }
  /**
   * @name Create provider setup session
   * @description Creates a new provider setup session for OAuth authentication.
   *
   * @param `body` - DashboardInstanceProviderDeploymentsSetupSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-setup-sessions";
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsSetupSessionsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsCreateOutput
    );
  }
  /**
   * @name Update provider setup session
   * @description Updates a specific provider setup session.
   *
   * @param `providerSetupSessionId` - string
   * @param `body` - DashboardInstanceProviderDeploymentsSetupSessionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerSetupSessionId, body, opts) {
    let path = `provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput
    );
  }
  /**
   * @name Delete provider setup session
   * @description Deletes a provider setup session.
   *
   * @param `providerSetupSessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(providerSetupSessionId, opts) {
    let path = `provider-setup-sessions/${providerSetupSessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-groups.ts
var MetorialProviderGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider groups
   * @description Returns a paginated list of provider groups.
   *
   * @param `query` - DashboardInstanceProviderGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-groups";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderGroupsListOutput
    );
  }
  /**
   * @name Get provider group
   * @description Retrieves a specific provider group by ID.
   *
   * @param `providerGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerGroupId, opts) {
    let path = `provider-groups/${providerGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderGroupsGetOutput
    );
  }
  /**
   * @name Create provider group
   * @description Creates a new custom provider group.
   *
   * @param `body` - DashboardInstanceProviderGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-groups";
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderGroupsCreateOutput
    );
  }
  /**
   * @name Update provider group
   * @description Updates an existing provider group.
   *
   * @param `providerGroupId` - string
   * @param `body` - DashboardInstanceProviderGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerGroupId, body, opts) {
    let path = `provider-groups/${providerGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderGroupsUpdateOutput
    );
  }
  /**
   * @name Add listing to group
   * @description Adds a provider listing to a group.
   *
   * @param `providerGroupId` - string
   * @param `body` - DashboardInstanceProviderGroupsAddListingBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsAddListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  addListing(providerGroupId, body, opts) {
    let path = `provider-groups/${providerGroupId}/listings`;
    let request = {
      path,
      body: mapDashboardInstanceProviderGroupsAddListingBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderGroupsAddListingOutput
    );
  }
  /**
   * @name Remove listing from group
   * @description Removes a provider listing from a group.
   *
   * @param `providerGroupId` - string
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderGroupsRemoveListingOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  removeListing(providerGroupId, providerListingId, opts) {
    let path = `provider-groups/${providerGroupId}/listings/${providerListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderGroupsRemoveListingOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-invocations.ts
var MetorialProviderInvocationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get provider invocation
   * @description Returns a single normalized provider invocation by ID.
   *
   * @param `providerInvocationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderInvocationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerInvocationId, opts) {
    let path = `provider-invocations/${providerInvocationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderInvocationsGetOutput
    );
  }
  /**
   * @name List provider invocations
   * @description Returns normalized provider invocations and their logs for dashboard diagnostics.
   *
   * @param `query` - DashboardInstanceProviderInvocationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderInvocationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-invocations";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderInvocationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderInvocationsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-listings.ts
var MetorialProviderListingsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider listings
   * @description Returns a paginated list of provider listings.
   *
   * @param `query` - DashboardInstanceProviderListingsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-listings";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderListingsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderListingsListOutput
    );
  }
  /**
   * @name Get provider listing
   * @description Retrieves a specific provider listing by ID.
   *
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerListingId, opts) {
    let path = `provider-listings/${providerListingId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderListingsGetOutput
    );
  }
  /**
   * @name Update provider listing
   * @description Updates how a provider listing appears in the library. Edited fields survive catalog re-syncs.
   *
   * @param `providerListingId` - string
   * @param `body` - DashboardInstanceProviderListingsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerListingId, body, opts) {
    let path = `provider-listings/${providerListingId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderListingsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderListingsUpdateOutput
    );
  }
  /**
   * @name Reset provider listing
   * @description Drops the admin customization so the next catalog sync restores the original name, description, readme, logo, categories and rank.
   *
   * @param `providerListingId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderListingsResetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  reset(providerListingId, opts) {
    let path = `provider-listings/${providerListingId}/reset`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderListingsResetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-runs.ts
var MetorialProviderRunsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all provider runs
   * @description Returns a paginated list of provider runs across all sessions.
   *
   * @param `query` - DashboardInstanceProviderRunsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-runs";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderRunsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsListOutput
    );
  }
  /**
   * @name Get provider run
   * @description Retrieves a specific provider run by ID.
   *
   * @param `providerRunId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerRunId, opts) {
    let path = `provider-runs/${providerRunId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsGetOutput
    );
  }
  /**
   * @name Get provider run logs
   * @description Retrieves the logs for a specific provider run.
   *
   * @param `providerRunId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderRunsGetLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getLogs(providerRunId, opts) {
    let path = `provider-runs/${providerRunId}/logs`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderRunsGetLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-specification-change-notifications.ts
var MetorialProviderSpecificationChangeNotificationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider specification change notifications
   * @description Returns a paginated list of provider specification change notifications for this instance.
   *
   * @param `query` - DashboardInstanceProviderSpecificationChangeNotificationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderSpecificationChangeNotificationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-specification-change-notifications";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderSpecificationChangeNotificationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderSpecificationChangeNotificationsListOutput
    );
  }
  /**
   * @name Get provider specification change notification
   * @description Retrieves a provider specification change notification by ID.
   *
   * @param `notificationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderSpecificationChangeNotificationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(notificationId, opts) {
    let path = `provider-specification-change-notifications/${notificationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderSpecificationChangeNotificationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/provider-templates.ts
var MetorialProviderTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider templates
   * @description Returns a paginated list of provider templates.
   *
   * @param `query` - DashboardInstanceProviderTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-templates";
    let request = {
      path,
      query: query ? mapDashboardInstanceProviderTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderTemplatesListOutput
    );
  }
  /**
   * @name Get provider template
   * @description Retrieves a specific provider template.
   *
   * @param `providerTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerTemplateId, opts) {
    let path = `provider-templates/${providerTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProviderTemplatesGetOutput
    );
  }
  /**
   * @name Create provider template
   * @description Creates a new provider template from an existing integration.
   *
   * @param `body` - DashboardInstanceProviderTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "provider-templates";
    let request = {
      path,
      body: mapDashboardInstanceProviderTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceProviderTemplatesCreateOutput
    );
  }
  /**
   * @name Update provider template
   * @description Updates an existing provider template.
   *
   * @param `providerTemplateId` - string
   * @param `body` - DashboardInstanceProviderTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(providerTemplateId, body, opts) {
    let path = `provider-templates/${providerTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceProviderTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceProviderTemplatesUpdateOutput
    );
  }
  /**
   * @name Archive provider template
   * @description Archives an existing provider template.
   *
   * @param `providerTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProviderTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(providerTemplateId, opts) {
    let path = `provider-templates/${providerTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceProviderTemplatesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/providers.ts
var MetorialProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List providers
   * @description Returns a paginated list of providers.
   *
   * @param `query` - DashboardInstanceProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersListOutput
    );
  }
  /**
   * @name Get provider
   * @description Retrieves a specific provider by ID.
   *
   * @param `providerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerId, opts) {
    let path = `providers/${providerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceProvidersGetOutput);
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/providers_auth-methods.ts
var MetorialProvidersAuthMethodsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider auth methods
   * @description Returns a paginated list of provider auth methods.
   *
   * @param `query` - DashboardInstanceProvidersAuthMethodsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersAuthMethodsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-auth-methods";
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersAuthMethodsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersAuthMethodsListOutput
    );
  }
  /**
   * @name Get provider auth method
   * @description Retrieves a specific provider auth method by ID.
   *
   * @param `providerAuthMethodId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersAuthMethodsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerAuthMethodId, opts) {
    let path = `provider-auth-methods/${providerAuthMethodId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersAuthMethodsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/providers_specifications.ts
var MetorialProvidersSpecificationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider specifications
   * @description Returns a paginated list of provider specifications.
   *
   * @param `query` - DashboardInstanceProvidersSpecificationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersSpecificationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-specifications";
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersSpecificationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersSpecificationsListOutput
    );
  }
  /**
   * @name Get provider specification
   * @description Retrieves a specific provider specification by ID.
   *
   * @param `providerSpecificationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersSpecificationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerSpecificationId, opts) {
    let path = `provider-specifications/${providerSpecificationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersSpecificationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/providers_tools.ts
var MetorialProvidersToolsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider tools
   * @description Returns a paginated list of provider tools. By default returns tools from the latest version. Use optional filters to get tools for a specific version.
   *
   * @param `query` - DashboardInstanceProvidersToolsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersToolsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-tools";
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersToolsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersToolsListOutput
    );
  }
  /**
   * @name Get provider tool
   * @description Retrieves a specific provider tool by ID.
   *
   * @param `providerToolId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersToolsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerToolId, opts) {
    let path = `provider-tools/${providerToolId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersToolsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/providers_triggers.ts
var MetorialProvidersTriggersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider triggers
   * @description Returns a paginated list of provider triggers for a specific provider version.
   *
   * @param `query` - ManagementInstanceProvidersTriggersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns ManagementInstanceProvidersTriggersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-triggers";
    let request = {
      path,
      query: query ? mapManagementInstanceProvidersTriggersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapManagementInstanceProvidersTriggersListOutput
    );
  }
  /**
   * @name Get provider trigger
   * @description Retrieves a specific provider trigger by ID.
   *
   * @param `providerTriggerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersTriggersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerTriggerId, opts) {
    let path = `provider-triggers/${providerTriggerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersTriggersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/providers_versions.ts
var MetorialProvidersVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List provider versions
   * @description Returns a paginated list of provider versions.
   *
   * @param `query` - DashboardInstanceProvidersVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "provider-versions";
    let request = {
      path,
      query: query ? mapDashboardInstanceProvidersVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersVersionsListOutput
    );
  }
  /**
   * @name Get provider version
   * @description Retrieves a specific provider version by ID.
   *
   * @param `providerVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceProvidersVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(providerVersionId, opts) {
    let path = `provider-versions/${providerVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceProvidersVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/public-mcp-servers.ts
var MetorialPublicMcpServersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP servers
   * @description Returns a paginated list of public MCP servers.
   *
   * @param `query` - DashboardInstancePublicMcpServersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "public-mcp-servers";
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersListOutput
    );
  }
  /**
   * @name Get public MCP server
   * @description Retrieves a specific public MCP server by ID.
   *
   * @param `publicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(publicMcpServerId, opts) {
    let path = `public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGetOutput
    );
  }
  /**
   * @name Create public MCP server
   * @description Creates a public MCP server for a provider deployment.
   *
   * @param `body` - DashboardInstancePublicMcpServersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "public-mcp-servers";
    let request = {
      path,
      body: mapDashboardInstancePublicMcpServersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePublicMcpServersCreateOutput
    );
  }
  /**
   * @name Update public MCP server
   * @description Updates a public MCP server. Set status to disabled to stop accepting connections.
   *
   * @param `publicMcpServerId` - string
   * @param `body` - DashboardInstancePublicMcpServersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(publicMcpServerId, body, opts) {
    let path = `public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      body: mapDashboardInstancePublicMcpServersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstancePublicMcpServersUpdateOutput
    );
  }
  /**
   * @name Delete public MCP server
   * @description Archives a public MCP server, revokes every grant, and releases its slug.
   *
   * @param `publicMcpServerId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(publicMcpServerId, opts) {
    let path = `public-mcp-servers/${publicMcpServerId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstancePublicMcpServersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/public-mcp-servers_clients.ts
var MetorialPublicMcpServersClientsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP server clients
   * @description Returns the OAuth clients registered with a public MCP server.
   *
   * @param `publicMcpServerId` - string
   * @param `query` - DashboardInstancePublicMcpServersClientsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersClientsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(publicMcpServerId, query, opts) {
    let path = `public-mcp-servers/${publicMcpServerId}/clients`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersClientsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersClientsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/public-mcp-servers_grants.ts
var MetorialPublicMcpServersGrantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List public MCP server grants
   * @description Returns the end-user grants of a public MCP server.
   *
   * @param `publicMcpServerId` - string
   * @param `query` - DashboardInstancePublicMcpServersGrantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(publicMcpServerId, query, opts) {
    let path = `public-mcp-servers/${publicMcpServerId}/grants`;
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersGrantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGrantsListOutput
    );
  }
  /**
   * @name Get public MCP server grant
   * @description Retrieves a specific end-user grant.
   *
   * @param `publicMcpServerId` - string
   * @param `publicMcpServerGrantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(publicMcpServerId, publicMcpServerGrantId, opts) {
    let path = `public-mcp-servers/${publicMcpServerId}/grants/${publicMcpServerGrantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersGrantsGetOutput
    );
  }
  /**
   * @name Revoke public MCP server grant
   * @description Revokes an end-user grant. Its tokens stop working and the user's credentials are deleted.
   *
   * @param `publicMcpServerId` - string
   * @param `publicMcpServerGrantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersGrantsRevokeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  revoke(publicMcpServerId, publicMcpServerGrantId, opts) {
    let path = `public-mcp-servers/${publicMcpServerId}/grants/${publicMcpServerGrantId}/revoke`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstancePublicMcpServersGrantsRevokeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/public-mcp-servers_slugs.ts
var MetorialPublicMcpServersSlugsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Check public MCP server slug
   * @description Checks whether a slug can be claimed for a new public MCP server.
   *
   * @param `query` - DashboardInstancePublicMcpServersSlugsCheckQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublicMcpServersSlugsCheckOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  check(query, opts) {
    let path = "public-mcp-server-slugs/availability";
    let request = {
      path,
      query: query ? mapDashboardInstancePublicMcpServersSlugsCheckQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublicMcpServersSlugsCheckOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/publishers.ts
var MetorialPublishersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List publishers
   * @description Returns a paginated list of publishers.
   *
   * @param `query` - DashboardInstancePublishersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublishersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "publishers";
    let request = {
      path,
      query: query ? mapDashboardInstancePublishersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublishersListOutput
    );
  }
  /**
   * @name Get publisher
   * @description Retrieves a specific publisher by ID.
   *
   * @param `publisherId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstancePublishersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(publisherId, opts) {
    let path = `publishers/${publisherId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstancePublishersGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_disks.ts
var MetorialSandboxDisksEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox disks
   * @description Returns a paginated list of disks.
   *
   * @param `query` - DashboardInstanceSandboxDisksListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "sandbox/disks";
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksListOutput
    );
  }
  /**
   * @name Get sandbox disk
   * @description Retrieves a disk by ID.
   *
   * @param `diskId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(diskId, opts) {
    let path = `sandbox/disks/${diskId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksGetOutput
    );
  }
  /**
   * @name Create sandbox disk
   * @description Creates an empty disk.
   *
   * @param `body` - DashboardInstanceSandboxDisksCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "sandbox/disks";
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksCreateOutput
    );
  }
  /**
   * @name Update sandbox disk
   * @description Updates a disk name and metadata. Only metadata can be updated for root filesystem disks.
   *
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(diskId, body, opts) {
    let path = `sandbox/disks/${diskId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxDisksUpdateOutput
    );
  }
  /**
   * @name Delete sandbox disk
   * @description Deletes a disk. Root filesystem disks cannot be deleted; they are removed with their machine.
   *
   * @param `diskId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(diskId, opts) {
    let path = `sandbox/disks/${diskId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxDisksDeleteOutput
    );
  }
  /**
   * @name Clone sandbox disk
   * @description Creates a copy of a disk in the same region.
   *
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksCloneBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksCloneOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  clone(diskId, body, opts) {
    let path = `sandbox/disks/${diskId}/clone`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksCloneBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksCloneOutput
    );
  }
  /**
   * @name Resize sandbox disk
   * @description Starts growing a disk to a larger size.
   *
   * @param `diskId` - string
   * @param `body` - DashboardInstanceSandboxDisksResizeBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizeOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resize(diskId, body, opts) {
    let path = `sandbox/disks/${diskId}/resize`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxDisksResizeBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksResizeOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_disks_mounts.ts
var MetorialSandboxDisksMountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List disk mounts
   * @description Returns a paginated list of the times a disk was mounted into a machine.
   *
   * @param `diskId` - string
   * @param `query` - DashboardInstanceSandboxDisksMountsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksMountsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(diskId, query, opts) {
    let path = `sandbox/disks/${diskId}/mounts`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksMountsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksMountsListOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_disks_resizes.ts
var MetorialSandboxDisksResizesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List disk resizes
   * @description Returns a paginated list of the resizes of a disk.
   *
   * @param `diskId` - string
   * @param `query` - DashboardInstanceSandboxDisksResizesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(diskId, query, opts) {
    let path = `sandbox/disks/${diskId}/resizes`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxDisksResizesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksResizesListOutput
    );
  }
  /**
   * @name Get disk resize
   * @description Retrieves a resize of a disk.
   *
   * @param `diskId` - string
   * @param `resizeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(diskId, resizeId, opts) {
    let path = `sandbox/disks/${diskId}/resizes/${resizeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxDisksResizesGetOutput
    );
  }
  /**
   * @name Retry disk resize
   * @description Retries a resize that failed.
   *
   * @param `diskId` - string
   * @param `resizeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxDisksResizesRetryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  retry(diskId, resizeId, opts) {
    let path = `sandbox/disks/${diskId}/resizes/${resizeId}/retry`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxDisksResizesRetryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_image-builds.ts
var MetorialSandboxImageBuildsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image builds
   * @description Returns a paginated list of image builds across all images.
   *
   * @param `query` - DashboardInstanceSandboxImageBuildsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "sandbox/image-builds";
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImageBuildsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsListOutput
    );
  }
  /**
   * @name Get image build
   * @description Retrieves an image build by ID.
   *
   * @param `buildId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(buildId, opts) {
    let path = `sandbox/image-builds/${buildId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsGetOutput
    );
  }
  /**
   * @name Cancel image build
   * @description Cancels a build that is still running.
   *
   * @param `buildId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsCancelOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  cancel(buildId, opts) {
    let path = `sandbox/image-builds/${buildId}/cancel`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImageBuildsCancelOutput
    );
  }
  /**
   * @name Get image build logs
   * @description Returns a page of the build output.
   *
   * @param `buildId` - string
   * @param `query` - DashboardInstanceSandboxImageBuildsLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImageBuildsLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  logs(buildId, query, opts) {
    let path = `sandbox/image-builds/${buildId}/logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImageBuildsLogsQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImageBuildsLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_images.ts
var MetorialSandboxImagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox images
   * @description Returns a paginated list of the images you can create machines from.
   *
   * @param `query` - DashboardInstanceSandboxImagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "sandbox/images";
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesListOutput
    );
  }
  /**
   * @name Get sandbox image
   * @description Retrieves an image by ID.
   *
   * @param `imageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(imageId, opts) {
    let path = `sandbox/images/${imageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesGetOutput
    );
  }
  /**
   * @name Create sandbox image
   * @description Creates an empty image. Build a version of it to make it available to machines.
   *
   * @param `body` - DashboardInstanceSandboxImagesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "sandbox/images";
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImagesCreateOutput
    );
  }
  /**
   * @name Update sandbox image
   * @description Updates the name and metadata of one of your images.
   *
   * @param `imageId` - string
   * @param `body` - DashboardInstanceSandboxImagesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(imageId, body, opts) {
    let path = `sandbox/images/${imageId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxImagesUpdateOutput
    );
  }
  /**
   * @name Delete sandbox image
   * @description Deletes one of your images and cancels its running builds.
   *
   * @param `imageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(imageId, opts) {
    let path = `sandbox/images/${imageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxImagesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_images_builds.ts
var MetorialSandboxImagesBuildsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image builds
   * @description Returns a paginated list of the builds of an image.
   *
   * @param `imageId` - string
   * @param `query` - DashboardInstanceSandboxImagesBuildsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesBuildsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(imageId, query, opts) {
    let path = `sandbox/images/${imageId}/builds`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesBuildsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesBuildsListOutput
    );
  }
  /**
   * @name Build image
   * @description Builds a new version of an image from a Dockerfile. Upload the build context as a file with the sandbox_image_build_context purpose first.
   *
   * @param `imageId` - string
   * @param `body` - DashboardInstanceSandboxImagesBuildsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesBuildsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(imageId, body, opts) {
    let path = `sandbox/images/${imageId}/builds`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxImagesBuildsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxImagesBuildsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_images_versions.ts
var MetorialSandboxImagesVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List image versions
   * @description Returns a paginated list of the versions of an image.
   *
   * @param `imageId` - string
   * @param `query` - DashboardInstanceSandboxImagesVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(imageId, query, opts) {
    let path = `sandbox/images/${imageId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxImagesVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesVersionsListOutput
    );
  }
  /**
   * @name Get image version
   * @description Retrieves a version of an image.
   *
   * @param `imageId` - string
   * @param `versionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxImagesVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(imageId, versionId, opts) {
    let path = `sandbox/images/${imageId}/versions/${versionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxImagesVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_machines.ts
var MetorialSandboxMachinesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox machines
   * @description Returns a paginated list of machines.
   *
   * @param `query` - DashboardInstanceSandboxMachinesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "sandbox/machines";
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesListOutput
    );
  }
  /**
   * @name Get sandbox machine
   * @description Retrieves a machine by ID.
   *
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(machineId, opts) {
    let path = `sandbox/machines/${machineId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesGetOutput
    );
  }
  /**
   * @name Create sandbox machine
   * @description Creates a machine and, unless disabled, starts it.
   *
   * @param `body` - DashboardInstanceSandboxMachinesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "sandbox/machines";
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesCreateOutput
    );
  }
  /**
   * @name Update sandbox machine
   * @description Updates a machine. Changes to its size, runtime, or mounts take effect once the machine restarts, which happens on its own for a running machine, and the machine reports restart_required until then.
   *
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(machineId, body, opts) {
    let path = `sandbox/machines/${machineId}`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSandboxMachinesUpdateOutput
    );
  }
  /**
   * @name Terminate sandbox machine
   * @description Terminates a machine and deletes its root disk.
   *
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(machineId, opts) {
    let path = `sandbox/machines/${machineId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSandboxMachinesDeleteOutput
    );
  }
  /**
   * @name Start sandbox machine
   * @description Starts a paused or hibernated machine.
   *
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesStartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  start(machineId, opts) {
    let path = `sandbox/machines/${machineId}/start`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesStartOutput
    );
  }
  /**
   * @name Pause sandbox machine
   * @description Pauses a running machine and keeps its memory state.
   *
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesPauseOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  pause(machineId, opts) {
    let path = `sandbox/machines/${machineId}/pause`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesPauseOutput
    );
  }
  /**
   * @name Hibernate sandbox machine
   * @description Hibernates a machine so it stops consuming compute resources.
   *
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesHibernateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  hibernate(machineId, opts) {
    let path = `sandbox/machines/${machineId}/hibernate`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesHibernateOutput
    );
  }
  /**
   * @name Restart sandbox machine
   * @description Restarts a machine on a fresh instance.
   *
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesRestartOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  restart(machineId, opts) {
    let path = `sandbox/machines/${machineId}/restart`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesRestartOutput
    );
  }
  /**
   * @name Touch sandbox machine
   * @description Records activity so the machine is not paused for being idle.
   *
   * @param `machineId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesTouchOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  touch(machineId, opts) {
    let path = `sandbox/machines/${machineId}/touch`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesTouchOutput
    );
  }
  /**
   * @name List sandbox machine usage
   * @description Returns resource usage samples of a machine, newest first.
   *
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  usage(machineId, query, opts) {
    let path = `sandbox/machines/${machineId}/usage`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageOutput
    );
  }
  /**
   * @name Run a command
   * @description Runs a shell command in the machine and returns its exit code and output. Non-interactive; starts the machine if needed.
   *
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesExecBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesExecOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  exec(machineId, body, opts) {
    let path = `sandbox/machines/${machineId}/exec`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesExecBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesExecOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_machines_access.ts
var MetorialSandboxMachinesAccessEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create shell access
   * @description Creates a short-lived token for an interactive shell in the machine.
   *
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessShellBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessShellOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  shell(machineId, body, opts) {
    let path = `sandbox/machines/${machineId}/access/shell`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessShellBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessShellOutput
    );
  }
  /**
   * @name Create files access
   * @description Creates a short-lived token for the machine's file service.
   *
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessFilesBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessFilesOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  files(machineId, body, opts) {
    let path = `sandbox/machines/${machineId}/access/files`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessFilesBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessFilesOutput
    );
  }
  /**
   * @name Create port access
   * @description Creates a short-lived token for reaching ports inside the machine.
   *
   * @param `machineId` - string
   * @param `body` - DashboardInstanceSandboxMachinesAccessPortsBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesAccessPortsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  ports(machineId, body, opts) {
    let path = `sandbox/machines/${machineId}/access/ports`;
    let request = {
      path,
      body: mapDashboardInstanceSandboxMachinesAccessPortsBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSandboxMachinesAccessPortsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_machines_errors.ts
var MetorialSandboxMachinesErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine errors
   * @description Returns a paginated list of the errors reported by a machine.
   *
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(machineId, query, opts) {
    let path = `sandbox/machines/${machineId}/errors`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesErrorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesErrorsListOutput
    );
  }
  /**
   * @name Get machine error
   * @description Retrieves an error reported by a machine.
   *
   * @param `machineId` - string
   * @param `errorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(machineId, errorId, opts) {
    let path = `sandbox/machines/${machineId}/errors/${errorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_machines_events.ts
var MetorialSandboxMachinesEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine events
   * @description Returns a paginated list of the events of a machine.
   *
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(machineId, query, opts) {
    let path = `sandbox/machines/${machineId}/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesEventsListOutput
    );
  }
  /**
   * @name Get machine event
   * @description Retrieves an event of a machine.
   *
   * @param `machineId` - string
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(machineId, eventId, opts) {
    let path = `sandbox/machines/${machineId}/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_machines_instances.ts
var MetorialSandboxMachinesInstancesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine instances
   * @description Returns a paginated list of the instances of a machine.
   *
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesInstancesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(machineId, query, opts) {
    let path = `sandbox/machines/${machineId}/instances`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesInstancesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesListOutput
    );
  }
  /**
   * @name Get machine instance
   * @description Retrieves an instance of a machine.
   *
   * @param `machineId` - string
   * @param `machineInstanceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(machineId, machineInstanceId, opts) {
    let path = `sandbox/machines/${machineId}/instances/${machineInstanceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesGetOutput
    );
  }
  /**
   * @name Get machine instance logs
   * @description Returns a page of the console output of an instance.
   *
   * @param `machineId` - string
   * @param `machineInstanceId` - string
   * @param `query` - DashboardInstanceSandboxMachinesInstancesLogsQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesInstancesLogsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  logs(machineId, machineInstanceId, query, opts) {
    let path = `sandbox/machines/${machineId}/instances/${machineInstanceId}/logs`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesInstancesLogsQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesInstancesLogsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_machines_operations.ts
var MetorialSandboxMachinesOperationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List machine operations
   * @description Returns a paginated list of the operations of a machine.
   *
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesOperationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesOperationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(machineId, query, opts) {
    let path = `sandbox/machines/${machineId}/operations`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesOperationsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesOperationsListOutput
    );
  }
  /**
   * @name Get machine operation
   * @description Retrieves an operation of a machine.
   *
   * @param `machineId` - string
   * @param `operationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesOperationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(machineId, operationId, opts) {
    let path = `sandbox/machines/${machineId}/operations/${operationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesOperationsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_machines_usage.ts
var MetorialSandboxMachinesUsageEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get sandbox machine usage timeline
   * @description Returns chronological usage buckets. Minute data is retained for 7 days and hourly data for 30 days. Zero samples means no observations, not necessarily a stopped machine.
   *
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageTimelineQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageTimelineOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  timeline(machineId, query, opts) {
    let path = `sandbox/machines/${machineId}/usage/timeline`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageTimelineQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageTimelineOutput
    );
  }
  /**
   * @name Get sandbox machine usage summary
   * @description Returns totals and averages for a range. Summary bounds align independently to minute or hour source buckets. Use a timeline’s effective bounds to compare its totals with a summary.
   *
   * @param `machineId` - string
   * @param `query` - DashboardInstanceSandboxMachinesUsageSummaryQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxMachinesUsageSummaryOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  summary(machineId, query, opts) {
    let path = `sandbox/machines/${machineId}/usage/summary`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxMachinesUsageSummaryQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxMachinesUsageSummaryOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_regions.ts
var MetorialSandboxRegionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox regions
   * @description Returns a paginated list of regions sandboxes can run in.
   *
   * @param `query` - DashboardInstanceSandboxRegionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxRegionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "sandbox/regions";
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxRegionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxRegionsListOutput
    );
  }
  /**
   * @name Get sandbox region
   * @description Retrieves a sandbox region by its identifier.
   *
   * @param `regionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxRegionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(regionId, opts) {
    let path = `sandbox/regions/${regionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxRegionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sandbox_specs.ts
var MetorialSandboxSpecsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sandbox specs
   * @description Returns a paginated list of machine specs. The available field shows whether your plan allows creating machines of that size.
   *
   * @param `query` - DashboardInstanceSandboxSpecsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxSpecsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "sandbox/specs";
    let request = {
      path,
      query: query ? mapDashboardInstanceSandboxSpecsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxSpecsListOutput
    );
  }
  /**
   * @name Get sandbox spec
   * @description Retrieves a machine spec by ID.
   *
   * @param `specId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSandboxSpecsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(specId, opts) {
    let path = `sandbox/specs/${specId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSandboxSpecsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/scm_accounts.ts
var MetorialScmAccountsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Preview SCM accounts
   * @description Lists available accounts from an SCM installation.
   *
   * @param `body` - DashboardInstanceScmAccountsPreviewBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmAccountsPreviewOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  preview(body, opts) {
    let path = "scm/accounts/preview";
    let request = {
      path,
      body: mapDashboardInstanceScmAccountsPreviewBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmAccountsPreviewOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/scm_connections.ts
var MetorialScmConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM connections
   * @description Returns a paginated list of SCM connections.
   *
   * @param `query` - DashboardInstanceScmConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "scm/connections";
    let request = {
      path,
      query: query ? mapDashboardInstanceScmConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmConnectionsListOutput
    );
  }
  /**
   * @name Get SCM connection
   * @description Retrieves a specific SCM connection by ID.
   *
   * @param `scmConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(scmConnectionId, opts) {
    let path = `scm/connections/${scmConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmConnectionsGetOutput
    );
  }
  /**
   * @name Create SCM connection
   * @description Initiates an SCM connection setup session.
   *
   * @param `body` - DashboardInstanceScmConnectionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmConnectionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "scm/connections";
    let request = {
      path,
      body: mapDashboardInstanceScmConnectionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmConnectionsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/scm_installation.ts
var MetorialScmInstallationEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM installations
   * @description Returns a paginated list of SCM installations.
   *
   * @param `query` - DashboardInstanceScmInstallationListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmInstallationListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "scm/installations";
    let request = {
      path,
      query: query ? mapDashboardInstanceScmInstallationListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmInstallationListOutput
    );
  }
  /**
   * @name Create SCM installation
   * @description Initiates an SCM installation setup (e.g. GitHub App authorization).
   *
   * @param `body` - DashboardInstanceScmInstallationCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmInstallationCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "scm/installations";
    let request = {
      path,
      body: mapDashboardInstanceScmInstallationCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmInstallationCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/scm_providers.ts
var MetorialScmProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM providers
   * @description Returns a paginated list of SCM providers.
   *
   * @param `query` - DashboardInstanceScmProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "scm/providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceScmProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmProvidersListOutput
    );
  }
  /**
   * @name Get SCM provider
   * @description Retrieves a specific SCM provider by ID.
   *
   * @param `scmProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(scmProviderId, opts) {
    let path = `scm/providers/${scmProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceScmProvidersGetOutput
    );
  }
  /**
   * @name Create SCM provider
   * @description Initiates a setup session for a self-hosted SCM provider.
   *
   * @param `body` - DashboardInstanceScmProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "scm/providers";
    let request = {
      path,
      body: mapDashboardInstanceScmProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmProvidersCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/scm_repos.ts
var MetorialScmReposEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List SCM repos
   * @description Returns a paginated list of SCM repositories.
   *
   * @param `query` - DashboardInstanceScmReposListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "scm/repos";
    let request = {
      path,
      query: query ? mapDashboardInstanceScmReposListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceScmReposListOutput);
  }
  /**
   * @name Get SCM repo
   * @description Retrieves a specific SCM repository by ID.
   *
   * @param `scmRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(scmRepositoryId, opts) {
    let path = `scm/repos/${scmRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceScmReposGetOutput);
  }
  /**
   * @name Preview SCM repos
   * @description Lists available repositories from an SCM installation.
   *
   * @param `body` - DashboardInstanceScmReposPreviewBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposPreviewOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  preview(body, opts) {
    let path = "scm/repos/preview";
    let request = {
      path,
      body: mapDashboardInstanceScmReposPreviewBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmReposPreviewOutput
    );
  }
  /**
   * @name Create SCM repo
   * @description Links or creates a repository in an SCM installation.
   *
   * @param `body` - DashboardInstanceScmReposCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceScmReposCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "scm/repos";
    let request = {
      path,
      body: mapDashboardInstanceScmReposCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceScmReposCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/session-templates.ts
var MetorialSessionTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session templates
   * @description Returns a paginated list of session templates.
   *
   * @param `query` - DashboardInstanceSessionTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-templates";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesListOutput
    );
  }
  /**
   * @name Get session template
   * @description Retrieves a specific session template by ID.
   *
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionTemplateId, opts) {
    let path = `session-templates/${sessionTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesGetOutput
    );
  }
  /**
   * @name Create session template
   * @description Creates a new session template.
   *
   * @param `body` - DashboardInstanceSessionTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "session-templates";
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionTemplatesCreateOutput
    );
  }
  /**
   * @name Update session template
   * @description Updates a specific session template.
   *
   * @param `sessionTemplateId` - string
   * @param `body` - DashboardInstanceSessionTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(sessionTemplateId, body, opts) {
    let path = `session-templates/${sessionTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionTemplatesUpdateOutput
    );
  }
  /**
   * @name Delete session template
   * @description Deletes a specific session template.
   *
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(sessionTemplateId, opts) {
    let path = `session-templates/${sessionTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionTemplatesDeleteOutput
    );
  }
  /**
   * @name List session template tools
   * @description Returns the effective set of tools available through the providers in a session template, filtered by the tool filters of each provider, deployment, config, and auth config.
   *
   * @param `sessionTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesListToolsOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  listTools(sessionTemplateId, opts) {
    let path = `session-templates/${sessionTemplateId}/tools`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesListToolsOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/session-templates_providers.ts
var MetorialSessionTemplatesProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session template providers
   * @description Returns a paginated list of providers configured for a session template.
   *
   * @param `query` - DashboardInstanceSessionTemplatesProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-template-providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionTemplatesProvidersListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersListOutput
    );
  }
  /**
   * @name Get session template provider
   * @description Retrieves a specific provider configuration from a session template.
   *
   * @param `sessionTemplateProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionTemplateProviderId, opts) {
    let path = `session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersGetOutput
    );
  }
  /**
   * @name Create session template provider
   * @description Adds a new provider configuration to a session template.
   *
   * @param `body` - DashboardInstanceSessionTemplatesProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "session-template-providers";
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesProvidersCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersCreateOutput
    );
  }
  /**
   * @name Update session template provider
   * @description Updates a provider configuration in a session template.
   *
   * @param `sessionTemplateProviderId` - string
   * @param `body` - DashboardInstanceSessionTemplatesProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(sessionTemplateProviderId, body, opts) {
    let path = `session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionTemplatesProvidersUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersUpdateOutput
    );
  }
  /**
   * @name Delete session template provider
   * @description Removes a provider configuration from a session template.
   *
   * @param `sessionTemplateProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionTemplatesProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(sessionTemplateProviderId, opts) {
    let path = `session-template-providers/${sessionTemplateProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionTemplatesProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions.ts
var MetorialSessionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List sessions
   * @description Returns a paginated list of sessions.
   *
   * @param `query` - DashboardInstanceSessionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "sessions";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSessionsListOutput);
  }
  /**
   * @name Get session
   * @description Retrieves a specific session by ID.
   *
   * @param `sessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionId, opts) {
    let path = `sessions/${sessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSessionsGetOutput);
  }
  /**
   * @name Create session
   * @description Creates a new session with provider deployments.
   *
   * @param `body` - DashboardInstanceSessionsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "sessions";
    let request = {
      path,
      body: mapDashboardInstanceSessionsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionsCreateOutput
    );
  }
  /**
   * @name Update session
   * @description Updates a session.
   *
   * @param `sessionId` - string
   * @param `body` - DashboardInstanceSessionsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(sessionId, body, opts) {
    let path = `sessions/${sessionId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionsUpdateOutput
    );
  }
  /**
   * @name Delete session
   * @description Deletes a session.
   *
   * @param `sessionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(sessionId, opts) {
    let path = `sessions/${sessionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions_connections.ts
var MetorialSessionsConnectionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session connections
   * @description Returns a paginated list of connections for a session.
   *
   * @param `query` - DashboardInstanceSessionsConnectionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsConnectionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-connections";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsConnectionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsConnectionsListOutput
    );
  }
  /**
   * @name Get session connection
   * @description Retrieves a specific connection from a session.
   *
   * @param `sessionConnectionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsConnectionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionConnectionId, opts) {
    let path = `session-connections/${sessionConnectionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsConnectionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions_error-groups.ts
var MetorialSessionsErrorGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all session error groups
   * @description Returns a paginated list of error groups across all sessions.
   *
   * @param `query` - DashboardInstanceSessionsErrorGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-error-groups";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsErrorGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorGroupsListOutput
    );
  }
  /**
   * @name Get session error group
   * @description Retrieves a specific error group by ID across all sessions.
   *
   * @param `sessionErrorGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionErrorGroupId, opts) {
    let path = `session-error-groups/${sessionErrorGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorGroupsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions_errors.ts
var MetorialSessionsErrorsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all session errors
   * @description Returns a paginated list of errors across all sessions.
   *
   * @param `query` - DashboardInstanceSessionsErrorsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-errors";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsErrorsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorsListOutput
    );
  }
  /**
   * @name Get session error
   * @description Retrieves a specific error that occurred in a session.
   *
   * @param `sessionErrorId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsErrorsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionErrorId, opts) {
    let path = `session-errors/${sessionErrorId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsErrorsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions_events.ts
var MetorialSessionsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session events
   * @description Returns a paginated list of events for a session.
   *
   * @param `query` - DashboardInstanceSessionsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-events";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsEventsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsEventsListOutput
    );
  }
  /**
   * @name Get session event
   * @description Retrieves a specific event from a session.
   *
   * @param `sessionEventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionEventId, opts) {
    let path = `session-events/${sessionEventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions_messages.ts
var MetorialSessionsMessagesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session messages
   * @description Returns a paginated list of messages for a session.
   *
   * @param `query` - DashboardInstanceSessionsMessagesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsMessagesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-messages";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsMessagesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsMessagesListOutput
    );
  }
  /**
   * @name Get session message
   * @description Retrieves a specific message from a session.
   *
   * @param `sessionMessageId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsMessagesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionMessageId, opts) {
    let path = `session-messages/${sessionMessageId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsMessagesGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions_participants.ts
var MetorialSessionsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session participants
   * @description Returns a paginated list of participants in a session.
   *
   * @param `query` - DashboardInstanceSessionsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-participants";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsParticipantsListOutput
    );
  }
  /**
   * @name Get session participant
   * @description Retrieves a specific participant in a session.
   *
   * @param `sessionParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionParticipantId, opts) {
    let path = `session-participants/${sessionParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/sessions_providers.ts
var MetorialSessionsProvidersEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List session providers
   * @description Returns a paginated list of providers connected to a session.
   *
   * @param `query` - DashboardInstanceSessionsProvidersListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "session-providers";
    let request = {
      path,
      query: query ? mapDashboardInstanceSessionsProvidersListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsProvidersListOutput
    );
  }
  /**
   * @name Get session provider
   * @description Retrieves a specific provider connected to a session.
   *
   * @param `sessionProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(sessionProviderId, opts) {
    let path = `session-providers/${sessionProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSessionsProvidersGetOutput
    );
  }
  /**
   * @name Create session provider
   * @description Adds a new provider to an active session.
   *
   * @param `body` - DashboardInstanceSessionsProvidersCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "session-providers";
    let request = {
      path,
      body: mapDashboardInstanceSessionsProvidersCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSessionsProvidersCreateOutput
    );
  }
  /**
   * @name Update session provider
   * @description Updates a provider connected to a session.
   *
   * @param `sessionProviderId` - string
   * @param `body` - DashboardInstanceSessionsProvidersUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(sessionProviderId, body, opts) {
    let path = `session-providers/${sessionProviderId}`;
    let request = {
      path,
      body: mapDashboardInstanceSessionsProvidersUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSessionsProvidersUpdateOutput
    );
  }
  /**
   * @name Delete session provider
   * @description Removes a provider from a session.
   *
   * @param `sessionProviderId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSessionsProvidersDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(sessionProviderId, opts) {
    let path = `session-providers/${sessionProviderId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSessionsProvidersDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills.ts
var MetorialSkillsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skills
   * @description Returns a paginated list of skills.
   *
   * @param `query` - DashboardInstanceSkillsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skills";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSkillsListOutput);
  }
  /**
   * @name Get skill
   * @description Retrieves a specific skill.
   *
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillId, opts) {
    let path = `skills/${skillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceSkillsGetOutput);
  }
  /**
   * @name Create skill
   * @description Creates a new skill.
   *
   * @param `body` - DashboardInstanceSkillsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skills";
    let request = {
      path,
      body: mapDashboardInstanceSkillsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsCreateOutput
    );
  }
  /**
   * @name Update skill
   * @description Updates a specific skill.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillId, body, opts) {
    let path = `skills/${skillId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsUpdateOutput
    );
  }
  /**
   * @name Delete skill
   * @description Archives a specific skill.
   *
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillId, opts) {
    let path = `skills/${skillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsDeleteOutput
    );
  }
  /**
   * @name Fork skill
   * @description Forks a skill for the current consumer. Non-consumer callers duplicate the skill instead.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsForkBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  fork(skillId, body, opts) {
    let path = `skills/${skillId}/fork`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsForkBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardInstanceSkillsForkOutput);
  }
  /**
   * @name Publish consumer skill
   * @description Publishes a consumer-owned skill to the consumer groups they belong to.
   *
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPublishConsumerSkillOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  publishConsumerSkill(skillId, opts) {
    let path = `skills/${skillId}/publish`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPublishConsumerSkillOutput
    );
  }
  /**
   * @name Share skill
   * @description Shares a skill with consumers or organization members.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsShareBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsShareOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  share(skillId, body, opts) {
    let path = `skills/${skillId}/shares`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsShareBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(mapDashboardInstanceSkillsShareOutput);
  }
  /**
   * @name Duplicate skill
   * @description Duplicates a skill.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsDuplicateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsDuplicateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  duplicate(skillId, body, opts) {
    let path = `skills/${skillId}/duplicate`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsDuplicateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsDuplicateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_agents.ts
var MetorialSkillsAgentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill agent
   * @description Creates a new agent document in the skill agents directory.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsAgentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(skillId, body, opts) {
    let path = `skills/${skillId}/agents`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsAgentsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsAgentsCreateOutput
    );
  }
  /**
   * @name List skill agents
   * @description Returns a paginated list of agents for a specific skill.
   *
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsAgentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillId, query, opts) {
    let path = `skills/${skillId}/agents`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsAgentsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsAgentsListOutput
    );
  }
  /**
   * @name Get skill agent by ID
   * @description Retrieves a specific agent within a skill.
   *
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillId, skillAgentId, opts) {
    let path = `skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsAgentsGetOutput
    );
  }
  /**
   * @name Update skill agent
   * @description Updates the name or description for a specific skill agent.
   *
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `body` - DashboardInstanceSkillsAgentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillId, skillAgentId, body, opts) {
    let path = `skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsAgentsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsAgentsUpdateOutput
    );
  }
  /**
   * @name Delete skill agent
   * @description Archives a specific skill agent and removes its linked store item.
   *
   * @param `skillId` - string
   * @param `skillAgentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsAgentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillId, skillAgentId, opts) {
    let path = `skills/${skillId}/agents/${skillAgentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsAgentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_configurations.ts
var MetorialSkillsConfigurationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill configuration
   * @description Creates a new non-default skill configuration.
   *
   * @param `body` - DashboardInstanceSkillsConfigurationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skills/configurations";
    let request = {
      path,
      body: mapDashboardInstanceSkillsConfigurationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsConfigurationsCreateOutput
    );
  }
  /**
   * @name List skill configurations
   * @description Returns a paginated list of visible skill configurations.
   *
   * @param `query` - DashboardInstanceSkillsConfigurationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skills/configurations";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsConfigurationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsConfigurationsListOutput
    );
  }
  /**
   * @name Get skill configuration
   * @description Retrieves a specific skill configuration by ID, or the default.
   *
   * @param `skillConfigurationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillConfigurationId, opts) {
    let path = `skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsConfigurationsGetOutput
    );
  }
  /**
   * @name Update skill configuration
   * @description Updates a specific skill configuration. Updating default creates it first if needed.
   *
   * @param `skillConfigurationId` - string
   * @param `body` - DashboardInstanceSkillsConfigurationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillConfigurationId, body, opts) {
    let path = `skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsConfigurationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsConfigurationsUpdateOutput
    );
  }
  /**
   * @name Delete skill configuration
   * @description Soft deletes a specific non-internal skill configuration.
   *
   * @param `skillConfigurationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsConfigurationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillConfigurationId, opts) {
    let path = `skills/configurations/${skillConfigurationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsConfigurationsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_exports.ts
var MetorialSkillsExportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill exports
   * @description Returns a paginated list of skill exports.
   *
   * @param `query` - DashboardInstanceSkillsExportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skill-exports";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsExportsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsExportsListOutput
    );
  }
  /**
   * @name Get skill export
   * @description Retrieves a skill export.
   *
   * @param `skillExportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillExportId, opts) {
    let path = `skill-exports/${skillExportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsExportsGetOutput
    );
  }
  /**
   * @name Create skill export
   * @description Creates a skill, plugin, or marketplace export.
   *
   * @param `body` - DashboardInstanceSkillsExportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsExportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-exports";
    let request = {
      path,
      body: mapDashboardInstanceSkillsExportsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsExportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_files.ts
var MetorialSkillsFilesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill files
   * @description Lists every file of a skill with its path, size and etag. Directories are implied by file paths.
   *
   * @param `skillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillId, opts) {
    let path = `skills/${skillId}/files`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsFilesListOutput
    );
  }
  /**
   * @name Get skill file
   * @description Retrieves a single skill file by path. Documents include their text content, other files include a download URL.
   *
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsFilesGetQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillId, query, opts) {
    let path = `skills/${skillId}/files/content`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsFilesGetQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsFilesGetOutput
    );
  }
  /**
   * @name Write skill file
   * @description Creates or replaces the file at a path. Parent directories are created automatically.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesPutBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesPutOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  put(skillId, body, opts) {
    let path = `skills/${skillId}/files`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesPutBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._put(request).transform(
      mapDashboardInstanceSkillsFilesPutOutput
    );
  }
  /**
   * @name Delete skill file
   * @description Deletes the file at a path. Directories that were created automatically and become empty are removed. The root SKILL.md cannot be deleted.
   *
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsFilesDeleteQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillId, query, opts) {
    let path = `skills/${skillId}/files`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsFilesDeleteQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsFilesDeleteOutput
    );
  }
  /**
   * @name Move skill file
   * @description Moves or renames a file. The root SKILL.md cannot be moved.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesMoveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesMoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  move(skillId, body, opts) {
    let path = `skills/${skillId}/files/move`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesMoveBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsFilesMoveOutput
    );
  }
  /**
   * @name Apply skill file changes
   * @description Applies up to 100 put, delete and move changes one after another, in order. Every change is validated before any is applied, but changes are not applied atomically: if a change fails while being applied, the changes before it stay applied. Every change can carry its own if_match precondition.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsFilesBatchBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsFilesBatchOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  batch(skillId, body, opts) {
    let path = `skills/${skillId}/files/batch`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsFilesBatchBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsFilesBatchOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_fork-syncs.ts
var MetorialSkillsForkSyncsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create skill fork sync
   * @description Queues synchronization of upstream changes into a forked skill.
   *
   * @param `body` - DashboardInstanceSkillsForkSyncsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkSyncsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-fork-syncs";
    let request = {
      path,
      body: mapDashboardInstanceSkillsForkSyncsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsForkSyncsCreateOutput
    );
  }
  /**
   * @name Get skill fork sync
   * @description Retrieves the state of a fork synchronization.
   *
   * @param `skillForkSyncId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsForkSyncsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillForkSyncId, opts) {
    let path = `skill-fork-syncs/${skillForkSyncId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsForkSyncsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_groups.ts
var MetorialSkillsGroupsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill groups
   * @description Returns a paginated list of skill groups.
   *
   * @param `query` - DashboardInstanceSkillsGroupsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skill-groups";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsGroupsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsListOutput
    );
  }
  /**
   * @name Get skill group
   * @description Retrieves a specific skill group.
   *
   * @param `skillGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillGroupId, opts) {
    let path = `skill-groups/${skillGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsGetOutput
    );
  }
  /**
   * @name Create skill group
   * @description Creates a skill group.
   *
   * @param `body` - DashboardInstanceSkillsGroupsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-groups";
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsGroupsCreateOutput
    );
  }
  /**
   * @name Update skill group
   * @description Updates a skill group.
   *
   * @param `skillGroupId` - string
   * @param `body` - DashboardInstanceSkillsGroupsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillGroupId, body, opts) {
    let path = `skill-groups/${skillGroupId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsGroupsUpdateOutput
    );
  }
  /**
   * @name Delete skill group
   * @description Archives a skill group.
   *
   * @param `skillGroupId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillGroupId, opts) {
    let path = `skill-groups/${skillGroupId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsGroupsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_groups_items.ts
var MetorialSkillsGroupsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill group items
   * @description Returns a paginated list of items for a skill group.
   *
   * @param `skillGroupId` - string
   * @param `query` - DashboardInstanceSkillsGroupsItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillGroupId, query, opts) {
    let path = `skill-groups/${skillGroupId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsGroupsItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsItemsListOutput
    );
  }
  /**
   * @name Get skill group item
   * @description Retrieves a specific skill group item.
   *
   * @param `skillGroupId` - string
   * @param `skillGroupItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillGroupId, skillGroupItemId, opts) {
    let path = `skill-groups/${skillGroupId}/items/${skillGroupItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsGroupsItemsGetOutput
    );
  }
  /**
   * @name Create skill group item
   * @description Adds a skill to a skill group.
   *
   * @param `skillGroupId` - string
   * @param `body` - DashboardInstanceSkillsGroupsItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(skillGroupId, body, opts) {
    let path = `skill-groups/${skillGroupId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsGroupsItemsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsGroupsItemsCreateOutput
    );
  }
  /**
   * @name Delete skill group item
   * @description Archives a skill group item.
   *
   * @param `skillGroupId` - string
   * @param `skillGroupItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsGroupsItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillGroupId, skillGroupItemId, opts) {
    let path = `skill-groups/${skillGroupId}/items/${skillGroupItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsGroupsItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_imports.ts
var MetorialSkillsImportsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill imports
   * @description Returns a paginated list of skill imports.
   *
   * @param `query` - DashboardInstanceSkillsImportsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skill-imports";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsImportsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsImportsListOutput
    );
  }
  /**
   * @name Get skill import
   * @description Retrieves an individual skill import and its results.
   *
   * @param `skillImportId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillImportId, opts) {
    let path = `skill-imports/${skillImportId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsImportsGetOutput
    );
  }
  /**
   * @name Create skill import
   * @description Queues a skill import from a repository or uploaded file.
   *
   * @param `body` - DashboardInstanceSkillsImportsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsImportsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-imports";
    let request = {
      path,
      body: mapDashboardInstanceSkillsImportsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsImportsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_items.ts
var MetorialSkillsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill items
   * @description Returns a paginated list of items for a skill.
   *
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillId, query, opts) {
    let path = `skills/${skillId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsItemsListOutput
    );
  }
  /**
   * @name Get skill item
   * @description Retrieves a specific skill item.
   *
   * @param `skillId` - string
   * @param `skillItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillId, skillItemId, opts) {
    let path = `skills/${skillId}/items/${skillItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsItemsGetOutput
    );
  }
  /**
   * @name Create skill item
   * @description Creates a new item on a skill.
   *
   * @param `skillId` - string
   * @param `body` - DashboardInstanceSkillsItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(skillId, body, opts) {
    let path = `skills/${skillId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsItemsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsItemsCreateOutput
    );
  }
  /**
   * @name Delete skill item
   * @description Archives a skill item.
   *
   * @param `skillId` - string
   * @param `skillItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillId, skillItemId, opts) {
    let path = `skills/${skillId}/items/${skillItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_marketplaces.ts
var MetorialSkillsMarketplacesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplaces
   * @description Returns a paginated list of skill marketplaces.
   *
   * @param `query` - DashboardInstanceSkillsMarketplacesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skill-marketplaces";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesListOutput
    );
  }
  /**
   * @name Get skill marketplace
   * @description Retrieves a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillMarketplaceId, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesGetOutput
    );
  }
  /**
   * @name Create skill marketplace
   * @description Creates a skill marketplace.
   *
   * @param `body` - DashboardInstanceSkillsMarketplacesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-marketplaces";
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesCreateOutput
    );
  }
  /**
   * @name Update skill marketplace
   * @description Updates a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillMarketplaceId, body, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMarketplacesUpdateOutput
    );
  }
  /**
   * @name Archive skill marketplace
   * @description Archives a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(skillMarketplaceId, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesArchiveOutput
    );
  }
  /**
   * @name Sync skill marketplace
   * @description Forces a skill marketplace sync.
   *
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesSyncBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(skillMarketplaceId, body, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/sync`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesSyncBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesSyncOutput
    );
  }
  /**
   * @name Get skill marketplace editor URL
   * @description Creates an embeddable editor URL for a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesGetEditorUrlBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesGetEditorUrlOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEditorUrl(skillMarketplaceId, body, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/editor-url`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesGetEditorUrlBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesGetEditorUrlOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_marketplaces_plugins.ts
var MetorialSkillsMarketplacesPluginsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplace plugins
   * @description Returns plugins linked to a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesPluginsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillMarketplaceId, query, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/plugins`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesPluginsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsListOutput
    );
  }
  /**
   * @name Add skill marketplace plugin
   * @description Adds a skill plugin to a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesPluginsAddBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsAddOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  add(skillMarketplaceId, body, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/plugins`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesPluginsAddBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsAddOutput
    );
  }
  /**
   * @name Get skill marketplace plugin
   * @description Retrieves a skill marketplace plugin link.
   *
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplacePluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillMarketplaceId, skillMarketplacePluginId, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/plugins/${skillMarketplacePluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsGetOutput
    );
  }
  /**
   * @name Remove skill marketplace plugin
   * @description Removes a skill plugin from a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplacePluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesPluginsRemoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  remove(skillMarketplaceId, skillMarketplacePluginId, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/plugins/${skillMarketplacePluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesPluginsRemoveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_marketplaces_repositories.ts
var MetorialSkillsMarketplacesRepositoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill marketplace repositories
   * @description Returns repositories linked to a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `query` - DashboardInstanceSkillsMarketplacesRepositoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillMarketplaceId, query, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/repositories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMarketplacesRepositoriesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesListOutput
    );
  }
  /**
   * @name Get skill marketplace repository
   * @description Retrieves a repository linked to a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplaceRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillMarketplaceId, skillMarketplaceRepositoryId, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/repositories/${skillMarketplaceRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesGetOutput
    );
  }
  /**
   * @name Link skill marketplace repository
   * @description Links an SCM repository to a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `body` - DashboardInstanceSkillsMarketplacesRepositoriesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(skillMarketplaceId, body, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/repositories`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMarketplacesRepositoriesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesCreateOutput
    );
  }
  /**
   * @name Unlink skill marketplace repository
   * @description Unlinks an SCM repository from a skill marketplace.
   *
   * @param `skillMarketplaceId` - string
   * @param `skillMarketplaceRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillMarketplaceId, skillMarketplaceRepositoryId, opts) {
    let path = `skill-marketplaces/${skillMarketplaceId}/repositories/${skillMarketplaceRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_merge-requests.ts
var MetorialSkillsMergeRequestsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge requests
   * @description Returns a paginated list of skill merge requests.
   *
   * @param `query` - DashboardInstanceSkillsMergeRequestsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skill-merge-requests";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsListOutput
    );
  }
  /**
   * @name Create skill merge request
   * @description Creates a merge request from one skill into another.
   *
   * @param `body` - DashboardInstanceSkillsMergeRequestsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-merge-requests";
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCreateOutput
    );
  }
  /**
   * @name Get skill merge request
   * @description Retrieves a skill merge request.
   *
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillMergeRequestId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsGetOutput
    );
  }
  /**
   * @name Perform skill merge request
   * @description Queues application of a resolved skill merge request.
   *
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsPerformOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  perform(skillMergeRequestId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/perform`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsPerformOutput
    );
  }
  /**
   * @name Close skill merge request
   * @description Closes an open skill merge request without applying it.
   *
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCloseOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  close(skillMergeRequestId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/close`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCloseOutput
    );
  }
  /**
   * @name Rollback skill merge request
   * @description Restores the target skill to its state before a completed merge.
   *
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsRollbackOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  rollback(skillMergeRequestId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/rollback`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsRollbackOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_merge-requests_comments.ts
var MetorialSkillsMergeRequestsCommentsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge request comments
   * @description Lists comments on a skill merge request or one of its items.
   *
   * @param `skillMergeRequestId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsCommentsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillMergeRequestId, query, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/comments`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsCommentsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsListOutput
    );
  }
  /**
   * @name Create skill merge request comment
   * @description Adds a comment to a skill merge request or one of its items.
   *
   * @param `skillMergeRequestId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCommentsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(skillMergeRequestId, body, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/comments`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCommentsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsCreateOutput
    );
  }
  /**
   * @name Get skill merge request comment
   * @description Retrieves a comment on a skill merge request.
   *
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillMergeRequestId, commentId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsGetOutput
    );
  }
  /**
   * @name Update skill merge request comment
   * @description Updates a comment authored by the current actor.
   *
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsCommentsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillMergeRequestId, commentId, body, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsCommentsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsUpdateOutput
    );
  }
  /**
   * @name Delete skill merge request comment
   * @description Deletes a comment authored by the current actor.
   *
   * @param `skillMergeRequestId` - string
   * @param `commentId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsCommentsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillMergeRequestId, commentId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/comments/${commentId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsMergeRequestsCommentsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_merge-requests_events.ts
var MetorialSkillsMergeRequestsEventsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill merge request events
   * @description Returns a paginated activity history for a skill merge request.
   *
   * @param `skillMergeRequestId` - string
   * @param `query` - DashboardInstanceSkillsMergeRequestsEventsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsEventsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillMergeRequestId, query, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/events`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsMergeRequestsEventsListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsEventsListOutput
    );
  }
  /**
   * @name Get skill merge request event
   * @description Retrieves one event from a skill merge request activity history.
   *
   * @param `skillMergeRequestId` - string
   * @param `eventId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsEventsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillMergeRequestId, eventId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/events/${eventId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsEventsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_merge-requests_items.ts
var MetorialSkillsMergeRequestsItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Resolve skill merge request item
   * @description Saves a resolution for one proposed skill change.
   *
   * @param `skillMergeRequestId` - string
   * @param `itemId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsItemsResolveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsItemsResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  resolve(skillMergeRequestId, itemId, body, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/items/${itemId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsItemsResolveBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsItemsResolveOutput
    );
  }
  /**
   * @name Resolve skill merge request items
   * @description Saves resolutions for multiple proposed skill changes.
   *
   * @param `skillMergeRequestId` - string
   * @param `body` - DashboardInstanceSkillsMergeRequestsItemsBulkResolveBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  bulkResolve(skillMergeRequestId, body, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_merge-requests_plan.ts
var MetorialSkillsMergeRequestsPlanEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get skill merge plan
   * @description Returns the proposed changes and conflicts for a skill merge request.
   *
   * @param `skillMergeRequestId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsMergeRequestsPlanGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillMergeRequestId, opts) {
    let path = `skill-merge-requests/${skillMergeRequestId}/plan`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsMergeRequestsPlanGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_participants.ts
var MetorialSkillsParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill participants
   * @description Returns a paginated list of participants for a specific skill.
   *
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillId, query, opts) {
    let path = `skills/${skillId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsParticipantsListOutput
    );
  }
  /**
   * @name Get skill participant by ID
   * @description Retrieves a specific participant within a skill.
   *
   * @param `skillId` - string
   * @param `skillParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillId, skillParticipantId, opts) {
    let path = `skills/${skillId}/participants/${skillParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_plugins.ts
var MetorialSkillsPluginsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugins
   * @description Returns a paginated list of skill plugins.
   *
   * @param `query` - DashboardInstanceSkillsPluginsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skill-plugins";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsListOutput
    );
  }
  /**
   * @name Get skill plugin
   * @description Retrieves a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillPluginId, opts) {
    let path = `skill-plugins/${skillPluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsGetOutput
    );
  }
  /**
   * @name Create skill plugin
   * @description Creates a skill plugin.
   *
   * @param `body` - DashboardInstanceSkillsPluginsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-plugins";
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsCreateOutput
    );
  }
  /**
   * @name Update skill plugin
   * @description Updates a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillPluginId, body, opts) {
    let path = `skill-plugins/${skillPluginId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsPluginsUpdateOutput
    );
  }
  /**
   * @name Archive skill plugin
   * @description Archives a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsArchiveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  archive(skillPluginId, opts) {
    let path = `skill-plugins/${skillPluginId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsArchiveOutput
    );
  }
  /**
   * @name Sync skill plugin
   * @description Forces a skill plugin sync.
   *
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSyncBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSyncOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  sync(skillPluginId, body, opts) {
    let path = `skill-plugins/${skillPluginId}/sync`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSyncBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsSyncOutput
    );
  }
  /**
   * @name Get skill plugin editor URL
   * @description Creates an embeddable editor URL for a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsGetEditorUrlBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsGetEditorUrlOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  getEditorUrl(skillPluginId, body, opts) {
    let path = `skill-plugins/${skillPluginId}/editor-url`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsGetEditorUrlBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsGetEditorUrlOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_plugins_repositories.ts
var MetorialSkillsPluginsRepositoriesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugin repositories
   * @description Returns repositories linked to a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `query` - DashboardInstanceSkillsPluginsRepositoriesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillPluginId, query, opts) {
    let path = `skill-plugins/${skillPluginId}/repositories`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsRepositoriesListQuery.transformTo(
        query
      ) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesListOutput
    );
  }
  /**
   * @name Get skill plugin repository
   * @description Retrieves a repository linked to a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `skillPluginRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillPluginId, skillPluginRepositoryId, opts) {
    let path = `skill-plugins/${skillPluginId}/repositories/${skillPluginRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesGetOutput
    );
  }
  /**
   * @name Link skill plugin repository
   * @description Links an SCM repository to a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsRepositoriesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(skillPluginId, body, opts) {
    let path = `skill-plugins/${skillPluginId}/repositories`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsRepositoriesCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesCreateOutput
    );
  }
  /**
   * @name Unlink skill plugin repository
   * @description Unlinks an SCM repository from a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `skillPluginRepositoryId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsRepositoriesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillPluginId, skillPluginRepositoryId, opts) {
    let path = `skill-plugins/${skillPluginId}/repositories/${skillPluginRepositoryId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsRepositoriesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_plugins_skills.ts
var MetorialSkillsPluginsSkillsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill plugin skills
   * @description Returns skills linked to a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `query` - DashboardInstanceSkillsPluginsSkillsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillPluginId, query, opts) {
    let path = `skill-plugins/${skillPluginId}/skills`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsPluginsSkillsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsListOutput
    );
  }
  /**
   * @name Add skill plugin skill
   * @description Adds a skill to a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSkillsAddBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsAddOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  add(skillPluginId, body, opts) {
    let path = `skill-plugins/${skillPluginId}/skills`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSkillsAddBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsAddOutput
    );
  }
  /**
   * @name Get skill plugin skill
   * @description Retrieves a skill plugin skill link.
   *
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillPluginId, skillPluginSkillId, opts) {
    let path = `skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsGetOutput
    );
  }
  /**
   * @name Update skill plugin skill
   * @description Updates a skill plugin skill link.
   *
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `body` - DashboardInstanceSkillsPluginsSkillsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillPluginId, skillPluginSkillId, body, opts) {
    let path = `skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsPluginsSkillsUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsUpdateOutput
    );
  }
  /**
   * @name Remove skill plugin skill
   * @description Removes a skill from a skill plugin.
   *
   * @param `skillPluginId` - string
   * @param `skillPluginSkillId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsPluginsSkillsRemoveOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  remove(skillPluginId, skillPluginSkillId, opts) {
    let path = `skill-plugins/${skillPluginId}/skills/${skillPluginSkillId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsPluginsSkillsRemoveOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_templates.ts
var MetorialSkillsTemplatesEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill templates
   * @description Returns a paginated list of skill templates.
   *
   * @param `query` - DashboardInstanceSkillsTemplatesListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "skill-templates";
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsTemplatesListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesListOutput
    );
  }
  /**
   * @name Get skill template
   * @description Retrieves a specific skill template.
   *
   * @param `skillTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillTemplateId, opts) {
    let path = `skill-templates/${skillTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesGetOutput
    );
  }
  /**
   * @name Create skill template
   * @description Creates a skill template.
   *
   * @param `body` - DashboardInstanceSkillsTemplatesCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "skill-templates";
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsTemplatesCreateOutput
    );
  }
  /**
   * @name Update skill template
   * @description Updates a skill template.
   *
   * @param `skillTemplateId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(skillTemplateId, body, opts) {
    let path = `skill-templates/${skillTemplateId}`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceSkillsTemplatesUpdateOutput
    );
  }
  /**
   * @name Delete skill template
   * @description Archives a skill template.
   *
   * @param `skillTemplateId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillTemplateId, opts) {
    let path = `skill-templates/${skillTemplateId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsTemplatesDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_templates_items.ts
var MetorialSkillsTemplatesItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill template items
   * @description Returns a paginated list of items for a skill template.
   *
   * @param `skillTemplateId` - string
   * @param `query` - DashboardInstanceSkillsTemplatesItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillTemplateId, query, opts) {
    let path = `skill-templates/${skillTemplateId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsTemplatesItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsListOutput
    );
  }
  /**
   * @name Get skill template item
   * @description Retrieves a specific skill template item.
   *
   * @param `skillTemplateId` - string
   * @param `skillTemplateItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillTemplateId, skillTemplateItemId, opts) {
    let path = `skill-templates/${skillTemplateId}/items/${skillTemplateItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsGetOutput
    );
  }
  /**
   * @name Create skill template item
   * @description Adds a provider or integration item to a skill template.
   *
   * @param `skillTemplateId` - string
   * @param `body` - DashboardInstanceSkillsTemplatesItemsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(skillTemplateId, body, opts) {
    let path = `skill-templates/${skillTemplateId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceSkillsTemplatesItemsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsCreateOutput
    );
  }
  /**
   * @name Delete skill template item
   * @description Deletes a skill template item.
   *
   * @param `skillTemplateId` - string
   * @param `skillTemplateItemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsTemplatesItemsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(skillTemplateId, skillTemplateItemId, opts) {
    let path = `skill-templates/${skillTemplateId}/items/${skillTemplateItemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceSkillsTemplatesItemsDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_versions.ts
var MetorialSkillsVersionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List skill versions
   * @description Returns a paginated list of versions for a specific skill.
   *
   * @param `skillId` - string
   * @param `query` - DashboardInstanceSkillsVersionsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(skillId, query, opts) {
    let path = `skills/${skillId}/versions`;
    let request = {
      path,
      query: query ? mapDashboardInstanceSkillsVersionsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsListOutput
    );
  }
  /**
   * @name Get skill version by ID
   * @description Retrieves a specific skill version by its ID.
   *
   * @param `skillId` - string
   * @param `skillVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillId, skillVersionId, opts) {
    let path = `skills/${skillId}/versions/${skillVersionId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/skills_versions_snapshot.ts
var MetorialSkillsVersionsSnapshotEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get skill version snapshot
   * @description Retrieves the store-backed snapshot for a specific skill version.
   *
   * @param `skillId` - string
   * @param `skillVersionId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceSkillsVersionsSnapshotGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(skillId, skillVersionId, opts) {
    let path = `skills/${skillId}/versions/${skillVersionId}/snapshot`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceSkillsVersionsSnapshotGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/stores.ts
var MetorialStoresEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List stores
   * @description Returns a paginated list of stores owned by the instance.
   *
   * @param `query` - DashboardInstanceStoresListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "stores";
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceStoresListOutput);
  }
  /**
   * @name Create store
   * @description Creates a new store for the instance.
   *
   * @param `body` - DashboardInstanceStoresCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "stores";
    let request = {
      path,
      body: mapDashboardInstanceStoresCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceStoresCreateOutput
    );
  }
  /**
   * @name Get store by ID
   * @description Retrieves a store by its ID.
   *
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(storeId, opts) {
    let path = `stores/${storeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceStoresGetOutput);
  }
  /**
   * @name Update store by ID
   * @description Updates a specific store.
   *
   * @param `storeId` - string
   * @param `body` - DashboardInstanceStoresUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(storeId, body, opts) {
    let path = `stores/${storeId}`;
    let request = {
      path,
      body: mapDashboardInstanceStoresUpdateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceStoresUpdateOutput
    );
  }
  /**
   * @name Delete store by ID
   * @description Deletes a specific store.
   *
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(storeId, opts) {
    let path = `stores/${storeId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceStoresDeleteOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/stores_items.ts
var MetorialStoresItemsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Modify store items
   * @description Applies bulk item operations to a specific store.
   *
   * @param `storeId` - string
   * @param `body` - DashboardInstanceStoresItemsModifyBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsModifyOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  modify(storeId, body, opts) {
    let path = `stores/${storeId}/items`;
    let request = {
      path,
      body: mapDashboardInstanceStoresItemsModifyBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceStoresItemsModifyOutput
    );
  }
  /**
   * @name List store items
   * @description Returns a paginated list of items for a specific store.
   *
   * @param `storeId` - string
   * @param `query` - DashboardInstanceStoresItemsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(storeId, query, opts) {
    let path = `stores/${storeId}/items`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresItemsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresItemsListOutput
    );
  }
  /**
   * @name Get store item by ID
   * @description Retrieves a specific item within a store.
   *
   * @param `storeId` - string
   * @param `itemId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresItemsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(storeId, itemId, opts) {
    let path = `stores/${storeId}/items/${itemId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresItemsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/stores_participants.ts
var MetorialStoresParticipantsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List store participants
   * @description Returns a paginated list of participants for a specific store.
   *
   * @param `storeId` - string
   * @param `query` - DashboardInstanceStoresParticipantsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresParticipantsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(storeId, query, opts) {
    let path = `stores/${storeId}/participants`;
    let request = {
      path,
      query: query ? mapDashboardInstanceStoresParticipantsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresParticipantsListOutput
    );
  }
  /**
   * @name Get store participant by ID
   * @description Retrieves a specific participant within a store.
   *
   * @param `storeId` - string
   * @param `storeParticipantId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresParticipantsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(storeId, storeParticipantId, opts) {
    let path = `stores/${storeId}/participants/${storeParticipantId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresParticipantsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/stores_permissions.ts
var MetorialStoresPermissionsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Get store permissions
   * @description Returns the effective Cargo permissions for the current actor on a specific store.
   *
   * @param `storeId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceStoresPermissionsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(storeId, opts) {
    let path = `stores/${storeId}/permissions`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceStoresPermissionsGetOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/test-helpers_consumer-oauth_authorizations.ts
var MetorialTestHelpersConsumerOauthAuthorizationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name Create consumer OAuth test authorization
   * @description Creates a single-use test authorization token for a consumer OAuth authorize URL.
   *
   * @param `body` - TestHelpersConsumerOauthAuthorizationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns TestHelpersConsumerOauthAuthorizationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "test-helpers/consumer-oauth-authorizations";
    let request = {
      path,
      body: mapTestHelpersConsumerOauthAuthorizationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapTestHelpersConsumerOauthAuthorizationsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/tool-calls.ts
var MetorialToolCallsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List all tool calls
   * @description Returns a paginated list of tool calls across all sessions.
   *
   * @param `query` - DashboardInstanceToolCallsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "tool-calls";
    let request = {
      path,
      query: query ? mapDashboardInstanceToolCallsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceToolCallsListOutput
    );
  }
  /**
   * @name Get tool call
   * @description Retrieves a specific tool call by ID.
   *
   * @param `toolCallId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(toolCallId, opts) {
    let path = `tool-calls/${toolCallId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(mapDashboardInstanceToolCallsGetOutput);
  }
  /**
   * @name Create tool call
   * @description Creates a new tool call in a session by invoking a specific tool.
   *
   * @param `body` - DashboardInstanceToolCallsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceToolCallsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "tool-calls";
    let request = {
      path,
      body: mapDashboardInstanceToolCallsCreateBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceToolCallsCreateOutput
    );
  }
};

// src/gen/src/mt_2025_01_01_dashboard/endpoints/webhook-registrations.ts
var MetorialWebhookRegistrationsEndpoint = class {
  constructor(_manager) {
    this._manager = _manager;
  }
  // thin proxies so method bodies stay unchanged
  _get(request) {
    return this._manager._get(request);
  }
  _post(request) {
    return this._manager._post(request);
  }
  _put(request) {
    return this._manager._put(request);
  }
  _patch(request) {
    return this._manager._patch(request);
  }
  _delete(request) {
    return this._manager._delete(request);
  }
  /**
   * @name List webhook registrations
   * @description Returns a paginated list of webhook registrations.
   *
   * @param `query` - DashboardInstanceWebhookRegistrationsListQuery
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsListOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query, opts) {
    let path = "webhook-registrations";
    let request = {
      path,
      query: query ? mapDashboardInstanceWebhookRegistrationsListQuery.transformTo(query) : void 0,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceWebhookRegistrationsListOutput
    );
  }
  /**
   * @name Get webhook registration
   * @description Retrieves a specific webhook registration by ID.
   *
   * @param `webhookRegistrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsGetOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(webhookRegistrationId, opts) {
    let path = `webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._get(request).transform(
      mapDashboardInstanceWebhookRegistrationsGetOutput
    );
  }
  /**
   * @name Create webhook registration
   * @description Creates a webhook registration for a provider. Only providers whose type reports `triggers.webhook_registration.status` as `supported` can receive one. The registration starts out awaiting setup.
   *
   * @param `body` - DashboardInstanceWebhookRegistrationsCreateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsCreateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body, opts) {
    let path = "webhook-registrations";
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsCreateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceWebhookRegistrationsCreateOutput
    );
  }
  /**
   * @name Complete webhook registration setup
   * @description Submits the provider-specific configuration described by the registration setup document, activating the registration.
   *
   * @param `webhookRegistrationId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsSetupBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsSetupOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  setup(webhookRegistrationId, body, opts) {
    let path = `webhook-registrations/${webhookRegistrationId}/setup`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsSetupBody.transformTo(body),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._post(request).transform(
      mapDashboardInstanceWebhookRegistrationsSetupOutput
    );
  }
  /**
   * @name Update webhook registration
   * @description Updates a webhook registration.
   *
   * @param `webhookRegistrationId` - string
   * @param `body` - DashboardInstanceWebhookRegistrationsUpdateBody
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsUpdateOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(webhookRegistrationId, body, opts) {
    let path = `webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      body: mapDashboardInstanceWebhookRegistrationsUpdateBody.transformTo(
        body
      ),
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._patch(request).transform(
      mapDashboardInstanceWebhookRegistrationsUpdateOutput
    );
  }
  /**
   * @name Delete webhook registration
   * @description Archives a webhook registration. The receiver is torn down on the provider before the record is removed for good.
   *
   * @param `webhookRegistrationId` - string
   * @param `opts` - { headers?: Record<string, string> }
   * @returns DashboardInstanceWebhookRegistrationsDeleteOutput
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(webhookRegistrationId, opts) {
    let path = `webhook-registrations/${webhookRegistrationId}`;
    let request = {
      path,
      ...(opts == null ? void 0 : opts.headers) ? { headers: opts.headers } : {}
    };
    return this._delete(request).transform(
      mapDashboardInstanceWebhookRegistrationsDeleteOutput
    );
  }
};

// src/vendor/util-endpoint/error.ts
var METORIAL_SDK_ERROR = "metorial.sdk.error";
var MetorialSDKError = class extends Error {
  constructor(response) {
    super(`[METORIAL ERROR]: ${response.code} - ${response.message}`);
    this.response = response;
    this.__typename = METORIAL_SDK_ERROR;
    this.__isMetorialError = true;
  }
  get code() {
    return this.response.code;
  }
  get message() {
    return this.response.message;
  }
  get hint() {
    return this.response.hint;
  }
  get description() {
    return this.response.description;
  }
  get reason() {
    return this.response.reason;
  }
  get validationErrors() {
    return this.response.errors;
  }
  get entity() {
    return this.response.entity;
  }
};

// src/vendor/util-endpoint/endpoints.ts
var MetorialEndpointManager = class {
  constructor(config, apiHost, getHeaders, fetchImpl, options) {
    this.config = config;
    this.apiHost = apiHost;
    this.getHeaders = getHeaders;
    this.fetchImpl = fetchImpl;
    this.options = options;
  }
  get fetch() {
    var _a;
    return (_a = this.fetchImpl) != null ? _a : globalThis.fetch.bind(globalThis);
  }
  async request(method, request, tryCount = 0) {
    var _a, _b, _c, _d, _e;
    let path = Array.isArray(request.path) ? request.path.join("/") : request.path;
    let url = new URL((_a = request.host) != null ? _a : this.apiHost);
    url.pathname = url.pathname.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
    if (request.query) {
      url.search = qs.stringify(request.query);
    }
    let defaultHeaders = (_c = (_b = this.getHeaders) == null ? void 0 : _b.call(this, this.config)) != null ? _c : {};
    let mergedHeaders = {
      ...defaultHeaders,
      ...(_d = request.headers) != null ? _d : {}
    };
    let headers = new Headers(mergedHeaders);
    let hasBody = method === "POST" || method === "PUT" || method === "PATCH";
    let isFormData = request.body instanceof FormData;
    if (hasBody && !isFormData && !headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }
    if (this.options.enableDebugLogging) {
      console.log(`[BlackOS] ${method} ${url.toString()}`, {
        body: request.body,
        query: request.query,
        headers: Object.fromEntries(headers.entries())
      });
    }
    let response;
    try {
      response = await this.fetch(url.toString(), {
        method,
        headers,
        body: hasBody ? isFormData ? request.body : JSON.stringify((_e = request.body) != null ? _e : {}) : void 0,
        credentials: "include",
        redirect: "follow",
        referrerPolicy: "no-referrer-when-downgrade",
        cache: "no-cache",
        keepalive: true,
        mode: "cors"
      });
      if (response.status === 429 && tryCount < 3) {
        let retryAfter = response.headers.get("Retry-After");
        if (retryAfter) {
          await new Promise((resolve) => setTimeout(resolve, (parseInt(retryAfter) + 3) * 1e3));
          return this.request(method, request, tryCount + 1);
        }
      }
    } catch (error) {
      if (this.options.enableDebugLogging) {
        console.error(`[BlackOS] ${method} ${url.toString()}`, error);
      }
      throw new MetorialSDKError({
        status: 0,
        code: "network_error",
        message: "Unable to connect to the BlackOS API - please check your connection"
      });
    }
    let data;
    try {
      data = await response.json();
    } catch (error) {
      if (this.options.enableDebugLogging) {
        console.error(`[BlackOS] ${method} ${url.toString()}`, error);
      }
      throw new MetorialSDKError({
        status: response.status,
        code: "malformed_response",
        message: "The BlackOS API returned an unexpected response. Expected JSON."
      });
    }
    if (!response.ok) {
      if (this.options.enableDebugLogging) {
        console.error(`[BlackOS] ${method} ${url.toString()}`, data);
      }
      throw new MetorialSDKError(data);
    }
    if (this.options.enableDebugLogging) {
      console.log(`[BlackOS] ${method} ${url.toString()}`, data);
    }
    return data;
  }
  requestAndTransform(method, request) {
    return {
      transform: async (mapper) => {
        let data = await this.request(method, request);
        return mapper.transformFrom(data);
      }
    };
  }
  _get(request) {
    return this.requestAndTransform("GET", request);
  }
  _post(request) {
    return this.requestAndTransform("POST", request);
  }
  _put(request) {
    return this.requestAndTransform("PUT", request);
  }
  _patch(request) {
    return this.requestAndTransform("PATCH", request);
  }
  _delete(request) {
    return this.requestAndTransform("DELETE", request);
  }
};
var BaseMetorialEndpoint = class {
  constructor(manager) {
    this.manager = manager;
  }
  _get(request) {
    return this.manager._get(request);
  }
  _post(request) {
    return this.manager._post(request);
  }
  _put(request) {
    return this.manager._put(request);
  }
  _patch(request) {
    return this.manager._patch(request);
  }
  _delete(request) {
    return this.manager._delete(request);
  }
};

// src/vendor/util-endpoint/sdkBuilder.ts
var _getApiHost, _getHeaders;
var _MetorialSDKBuilder = class _MetorialSDKBuilder {
  constructor(apiName, apiVersion) {
    this.apiName = apiName;
    this.apiVersion = apiVersion;
    __privateAdd(this, _getApiHost);
    __privateAdd(this, _getHeaders);
  }
  static create(apiName, apiVersion) {
    return new _MetorialSDKBuilder(apiName, apiVersion);
  }
  setGetApiHost(getApiHost) {
    __privateSet(this, _getApiHost, getApiHost);
    return this;
  }
  setGetHeaders(getHeaders) {
    __privateSet(this, _getHeaders, getHeaders);
    return this;
  }
  build(getConfig) {
    if (!__privateGet(this, _getHeaders)) {
      throw new Error("getHeaders must be set");
    }
    if (!__privateGet(this, _getApiHost)) {
      throw new Error("apiHost must be set");
    }
    return (getEndpoints) => (config) => {
      let fullConfig = getConfig(config);
      let apiHost = __privateGet(this, _getApiHost).call(this, fullConfig);
      let manager = new MetorialEndpointManager(
        fullConfig,
        apiHost,
        __privateGet(this, _getHeaders),
        fullConfig.fetch,
        { enableDebugLogging: !!fullConfig.enableDebugLogging }
      );
      return {
        _config: {
          apiHost,
          ...fullConfig
        },
        ...getEndpoints(manager)
      };
    };
  }
};
_getApiHost = new WeakMap();
_getHeaders = new WeakMap();
var MetorialSDKBuilder = _MetorialSDKBuilder;

// src/auth.ts
var MetorialAuthEndpoint = class extends BaseMetorialEndpoint {
  constructor(config) {
    super(config);
  }
  login(data) {
    return this._post({
      path: ["_", "auth", "login"],
      body: {
        email: data.email,
        password: data.password
      }
    }).transform({
      transformFrom: (d) => d
    });
  }
  signup(data) {
    return this._post({
      path: ["_", "auth", "signup"],
      body: {
        name: data.name,
        email: data.email,
        password: data.password
      }
    }).transform({
      transformFrom: (d) => d
    });
  }
  logout() {
    return this._post({
      path: ["_", "auth", "logout"]
    }).transform({
      transformFrom: (d) => d
    });
  }
};

// src/builder.ts
var sdkBuilder = MetorialSDKBuilder.create("metorial-management-api", "2025-01-01-dashboard").setGetApiHost((config) => {
  var _a;
  return (_a = config.apiHost) != null ? _a : "http://localhost:4310";
}).setGetHeaders((config) => {
  var _a;
  return {
    "Metorial-Version": config.apiVersion,
    ...config.apiKey ? { Authorization: `Bearer ${config.apiKey}` } : {},
    ...(_a = config.headers) != null ? _a : {}
  };
});

// src/sdk.ts
var fetchWithRetry = createFetchWithRetry();
var fetchWithRetryAndLogging = async (input, init) => {
  console.log("[BlackOS API] Fetching:", {
    input,
    init
  });
  try {
    return await fetchWithRetry(input, init);
  } catch (error) {
    console.error("[BlackOS API] Fetch failed:", {
      input,
      init,
      error
    });
    throw error;
  }
};
var smallFileDirectUploadMaxBytes = 1024 * 1024;
var presignedUploadHostSuffixes = [
  ".metorial.com",
  ".metorial.app",
  ".metorial.net",
  ".metorial.cloud",
  ".metorial-staging.com"
];
var supportsPresignedUpload = (apiHost) => {
  try {
    let hostname = new URL(apiHost).hostname.toLowerCase();
    return presignedUploadHostSuffixes.some((suffix) => hostname.endsWith(suffix));
  } catch {
    return false;
  }
};
var getUploadFileName = (input) => {
  var _a, _b, _c, _d;
  return ((_a = input.file.name) == null ? void 0 : _a.trim()) || ((_c = (_b = input.store) == null ? void 0 : _b.path.split("/").filter(Boolean).at(-1)) == null ? void 0 : _c.trim()) || ((_d = input.title) == null ? void 0 : _d.trim()) || "";
};
var notifyUploadProgress = (onProgress, loaded, total) => {
  if (!onProgress) return;
  onProgress({
    loaded,
    total,
    ratio: total > 0 ? Math.min(1, loaded / total) : 0
  });
};
var createUploadAbortError = () => new DOMException("The file upload was aborted", "AbortError");
var isAbortError = (error) => error instanceof Error && (error.name == "AbortError" || error.name == "TimeoutError");
var sendWithUploadProgress = (opts) => new Promise((resolve, reject) => {
  var _a, _b, _c, _d;
  if ((_a = opts.signal) == null ? void 0 : _a.aborted) {
    reject(createUploadAbortError());
    return;
  }
  if (typeof XMLHttpRequest == "undefined") {
    fetch(opts.url, {
      method: opts.method,
      body: opts.body,
      headers: opts.headers,
      credentials: (_b = opts.credentials) != null ? _b : "same-origin",
      redirect: "follow",
      referrerPolicy: "no-referrer-when-downgrade",
      cache: "no-cache",
      mode: "cors",
      signal: opts.signal
    }).then(async (res) => {
      resolve({
        ok: res.ok,
        status: res.status,
        text: await res.text()
      });
    }).catch(reject);
    return;
  }
  let xhr = new XMLHttpRequest();
  xhr.open(opts.method, opts.url);
  xhr.withCredentials = opts.credentials == "include";
  for (let [key, value] of Object.entries((_c = opts.headers) != null ? _c : {})) {
    if (value == null || value == "") continue;
    xhr.setRequestHeader(key, value);
  }
  xhr.upload.onprogress = (event) => {
    notifyUploadProgress(
      opts.onProgress,
      event.loaded,
      event.lengthComputable ? event.total : 0
    );
  };
  xhr.onload = () => {
    resolve({
      ok: xhr.status >= 200 && xhr.status < 300,
      status: xhr.status,
      text: xhr.responseText
    });
  };
  xhr.onerror = () => reject(new Error("Network error during file upload"));
  xhr.onabort = () => reject(createUploadAbortError());
  (_d = opts.signal) == null ? void 0 : _d.addEventListener("abort", () => xhr.abort(), { once: true });
  xhr.send(opts.body);
});
var parseSseEventData = (rawData) => {
  if (!rawData) return null;
  try {
    return JSON.parse(rawData);
  } catch {
    return rawData;
  }
};
var createSseParseStream = async (stream, onEvent) => {
  var _a;
  let reader = stream.getReader();
  let decoder = new TextDecoder();
  let buffer = "";
  let flushBlock = async (block) => {
    let event = "message";
    let id;
    let dataParts = [];
    for (let rawLine of block.split(/\r?\n/)) {
      if (!rawLine || rawLine.startsWith(":")) continue;
      let separator = rawLine.indexOf(":");
      let field = separator == -1 ? rawLine : rawLine.slice(0, separator);
      let value = separator == -1 ? "" : rawLine.slice(separator + 1).replace(/^ /, "");
      if (field == "event") event = value;
      if (field == "id") id = value;
      if (field == "data") dataParts.push(value);
    }
    if (!dataParts.length) return;
    let rawData = dataParts.join("\n");
    await onEvent({
      event,
      id,
      rawData,
      data: parseSseEventData(rawData)
    });
  };
  while (true) {
    let { done, value } = await reader.read();
    buffer += decoder.decode(value != null ? value : new Uint8Array(), { stream: !done });
    let parts = buffer.split(/\r?\n\r?\n/);
    buffer = (_a = parts.pop()) != null ? _a : "";
    for (let part of parts) {
      await flushBlock(part);
    }
    if (done) {
      if (buffer.trim()) {
        await flushBlock(buffer);
      }
      break;
    }
  }
};
var createAssistantRequestDeltaConnection = (manager, assistantRequestId, opts = {}) => {
  let controller = new AbortController();
  let parentSignal = opts.signal;
  if (parentSignal == null ? void 0 : parentSignal.aborted) {
    controller.abort(parentSignal.reason);
  } else if (parentSignal) {
    parentSignal.addEventListener("abort", () => controller.abort(parentSignal.reason), {
      once: true
    });
  }
  let done = (async () => {
    var _a, _b, _c, _d;
    let headers = new Headers({
      ...manager.getHeaders(manager.config),
      Accept: "text/event-stream",
      ...(_a = opts.headers) != null ? _a : {}
    });
    if (opts.lastEventId) {
      headers.set("Last-Event-ID", opts.lastEventId);
    }
    let url = new URL(manager.apiHost);
    url.pathname = url.pathname.replace(/\/$/, "") + `/assistant-live/requests/${assistantRequestId}/deltas`;
    let response = await manager.fetch(url.toString(), {
      method: "GET",
      headers,
      credentials: "include",
      redirect: "follow",
      referrerPolicy: "no-referrer-when-downgrade",
      cache: "no-cache",
      mode: "cors",
      signal: controller.signal
    });
    await ((_b = opts.onOpen) == null ? void 0 : _b.call(opts, response));
    if (!response.ok) {
      let data;
      try {
        data = await response.json();
      } catch {
        data = {
          status: response.status,
          code: "sse_connection_failed",
          message: `Failed to open assistant delta stream (${response.status})`
        };
      }
      throw new MetorialSDKError(data);
    }
    let contentType = (_c = response.headers.get("content-type")) != null ? _c : "";
    if (!contentType.includes("text/event-stream")) {
      throw new MetorialSDKError({
        status: response.status,
        code: "invalid_sse_response",
        message: "Expected assistant delta stream to return text/event-stream"
      });
    }
    if (!response.body) {
      throw new MetorialSDKError({
        status: response.status,
        code: "empty_sse_response",
        message: "Assistant delta stream response body was empty"
      });
    }
    try {
      await createSseParseStream(response.body, async (event) => {
        var _a2, _b2, _c2, _d2;
        await ((_a2 = opts.onEvent) == null ? void 0 : _a2.call(opts, event));
        if (event.event == "snapshot") {
          await ((_b2 = opts.onSnapshot) == null ? void 0 : _b2.call(opts, event));
        } else if (event.event == "delta") {
          await ((_c2 = opts.onDelta) == null ? void 0 : _c2.call(opts, event));
        } else if (event.event == "error") {
          await ((_d2 = opts.onError) == null ? void 0 : _d2.call(opts, event));
        }
      });
    } finally {
      await ((_d = opts.onClose) == null ? void 0 : _d.call(opts));
    }
  })();
  return {
    close: () => controller.abort(),
    done
  };
};
var createSandboxSdk = (manager) => {
  let machines = new MetorialDashboardInstanceSandboxMachinesEndpoint(manager);
  let machineUsage = new MetorialDashboardInstanceSandboxMachinesUsageEndpoint(manager);
  return {
    machines: Object.assign(machines, {
      usage: Object.assign(machines.usage.bind(machines), {
        timeline: machineUsage.timeline.bind(machineUsage),
        summary: machineUsage.summary.bind(machineUsage)
      }),
      access: new MetorialDashboardInstanceSandboxMachinesAccessEndpoint(manager),
      errors: new MetorialDashboardInstanceSandboxMachinesErrorsEndpoint(manager),
      events: new MetorialDashboardInstanceSandboxMachinesEventsEndpoint(manager),
      instances: new MetorialDashboardInstanceSandboxMachinesInstancesEndpoint(manager),
      operations: new MetorialDashboardInstanceSandboxMachinesOperationsEndpoint(manager)
    }),
    images: Object.assign(new MetorialDashboardInstanceSandboxImagesEndpoint(manager), {
      builds: new MetorialDashboardInstanceSandboxImagesBuildsEndpoint(manager),
      versions: new MetorialDashboardInstanceSandboxImagesVersionsEndpoint(manager)
    }),
    imageBuilds: new MetorialDashboardInstanceSandboxImageBuildsEndpoint(manager),
    disks: Object.assign(new MetorialDashboardInstanceSandboxDisksEndpoint(manager), {
      mounts: new MetorialDashboardInstanceSandboxDisksMountsEndpoint(manager),
      resizes: new MetorialDashboardInstanceSandboxDisksResizesEndpoint(manager)
    }),
    specs: new MetorialDashboardInstanceSandboxSpecsEndpoint(manager),
    regions: new MetorialDashboardInstanceSandboxRegionsEndpoint(manager)
  };
};
var createMetorialDashboardSDK = sdkBuilder.build(
  (soft) => {
    var _a;
    return {
      ...soft,
      apiKey: (_a = soft.consumer) == null ? void 0 : _a.apiKey,
      headers: {
        ...soft.headers,
        ...soft.consumer ? {
          "Metorial-Consumer-Session-Client-Secret": soft.consumer.consumerToken
        } : {}
      },
      apiVersion: "2025-01-01-dashboard",
      fetch: (a, b) => {
        let url = new URL(a);
        if (soft.metorialInstance) {
          url.searchParams.set("_m", soft.metorialInstance);
        }
        if (soft.consumer) {
          url.searchParams.set("_c", "1");
        }
        a = url.toString();
        return fetchWithRetryAndLogging(a, b);
      },
      enableDebugLogging: true
    };
  }
)((manager) => ({
  organizations: Object.assign(new MetorialDashboardOrganizationsEndpoint(manager), {
    configureAuditLogRetention: new MetorialDashboardOrganizationsConfigureAuditLogRetentionEndpoint(manager),
    invites: new MetorialDashboardOrganizationsInvitesEndpoint(manager),
    flags: new MetorialOrganizationsFlagsEndpoint(manager),
    scopes: new MetorialOrganizationsScopesEndpoint(manager),
    outposts: Object.assign(new MetorialDashboardOrganizationsOutpostsEndpoint(manager), {
      access: new MetorialDashboardOrganizationsOutpostsAccessEndpoint(manager),
      credentials: new MetorialDashboardOrganizationsOutpostsCredentialsEndpoint(manager)
    }),
    members: Object.assign(new MetorialDashboardOrganizationsMembersEndpoint(manager), {
      policies: new MetorialDashboardOrganizationsMembersPoliciesEndpoint(manager)
    })
  }),
  organizationJoins: new MetorialDashboardOrganizationsJoinEndpoint(manager),
  profile: new MetorialOrganizationsProfileEndpoint(manager),
  instances: new MetorialDashboardOrganizationsInstancesEndpoint(manager),
  sandboxes: new MetorialDashboardOrganizationsSandboxesEndpoint(manager),
  sandbox: createSandboxSdk(manager),
  projects: Object.assign(new MetorialDashboardOrganizationsProjectsEndpoint(manager), {
    branding: new MetorialDashboardOrganizationsProjectsBrandingEndpoint(manager),
    configureAuthConfig: new MetorialDashboardProjectsConfigureAuthConfigEndpoint(manager),
    configureDataRetention: new MetorialDashboardProjectsConfigureDataRetentionEndpoint(
      manager
    ),
    configureIntegrationNaming: new MetorialDashboardProjectsConfigureIntegrationNamingEndpoint(manager),
    configureRetention: new MetorialDashboardProjectsConfigureRetentionEndpoint(manager),
    configureSessionlessMcp: new MetorialDashboardProjectsConfigureSessionlessMcpEndpoint(
      manager
    ),
    configureSkillSync: new MetorialDashboardProjectsConfigureSkillSyncEndpoint(manager),
    configureToolCalling: new MetorialDashboardProjectsConfigureToolCallingEndpoint(manager),
    configureWorkforce: new MetorialDashboardProjectsConfigureWorkforceEndpoint(manager),
    keyProviders: Object.assign(new MetorialDashboardProjectsKeyProvidersEndpoint(manager), {
      errors: new MetorialDashboardProjectsKeyProvidersErrorsEndpoint(manager)
    })
  }),
  user: new MetorialManagementUserEndpoint(manager),
  apiKeys: new MetorialDashboardOrganizationsApiKeysEndpoint(manager),
  auth: new MetorialAuthEndpoint(manager),
  dashboard: new MetorialDashboardEndpoint(manager),
  files: Object.assign(new MetorialDashboardInstanceFilesEndpoint(manager), {
    links: new MetorialDashboardInstanceFilesLinksEndpoint(manager),
    upload: async (input) => {
      var _a, _b;
      let base = manager.apiHost;
      if (!base.endsWith("/")) base += "/";
      let mode = (_a = input.mode) != null ? _a : supportsPresignedUpload(base) && input.file.size > smallFileDirectUploadMaxBytes ? "presigned" : "direct";
      let requestHeaders = manager.getHeaders(manager.config);
      let parseFilesResponse = (status, text) => {
        let json = text ? JSON.parse(text) : {};
        if (status < 200 || status >= 300) {
          throw new MetorialSDKError(
            (json == null ? void 0 : json.code) ? json : {
              status,
              code: "file_upload_failed",
              message: `File upload failed with status ${status}`
            }
          );
        }
        return json;
      };
      let postFiles = async (body, onProgress) => {
        let res = typeof body != "string" && onProgress ? await sendWithUploadProgress({
          url: `${base}files`,
          method: "POST",
          body,
          headers: requestHeaders,
          credentials: "include",
          signal: input.signal,
          onProgress
        }) : await fetch(`${base}files`, {
          method: "POST",
          body,
          headers: {
            ...requestHeaders,
            ...typeof body == "string" ? { "Content-Type": "application/json" } : {}
          },
          credentials: "include",
          redirect: "follow",
          referrerPolicy: "no-referrer-when-downgrade",
          cache: "no-cache",
          mode: "cors",
          signal: input.signal
        }).then(async (response) => ({
          ok: response.ok,
          status: response.status,
          text: await response.text()
        }));
        return parseFilesResponse(res.status, res.text);
      };
      let directUpload = async () => {
        let body = new FormData();
        body.append("file", input.file);
        body.append("purpose", input.purpose);
        body.append("instance_id", input.instanceId);
        if (input.title) body.append("title", input.title);
        if (input.store) {
          body.append("store_id", input.store.id);
          body.append("path", input.store.path);
        }
        if (input.storeReplace) body.append("store_replace", "true");
        notifyUploadProgress(input.onProgress, 0, input.file.size);
        let json = await postFiles(body, input.onProgress);
        notifyUploadProgress(input.onProgress, input.file.size, input.file.size);
        return json;
      };
      let presignedUpload = async () => {
        var _a2, _b2;
        let pending = await postFiles(
          JSON.stringify({
            mode: "get_upload_url",
            instance_id: input.instanceId,
            purpose: input.purpose,
            file_name: getUploadFileName(input),
            file_size: input.file.size,
            ...input.file.type ? { file_type: input.file.type } : {},
            ...input.title ? { title: input.title } : {},
            ...input.store ? { store_id: input.store.id, path: input.store.path } : {},
            ...input.storeReplace ? { store_replace: true } : {}
          })
        );
        notifyUploadProgress(input.onProgress, 0, input.file.size);
        let uploaded = input.onProgress ? await sendWithUploadProgress({
          url: pending.upload.url,
          method: (_a2 = pending.upload.method) != null ? _a2 : "PUT",
          body: input.file,
          headers: input.file.type ? { "Content-Type": input.file.type } : void 0,
          signal: input.signal,
          onProgress: input.onProgress
        }) : await fetch(pending.upload.url, {
          method: (_b2 = pending.upload.method) != null ? _b2 : "PUT",
          body: input.file,
          ...input.file.type ? { headers: { "Content-Type": input.file.type } } : {},
          cache: "no-cache",
          mode: "cors",
          signal: input.signal
        }).then(async (response) => ({
          ok: response.ok,
          status: response.status,
          text: await response.text()
        }));
        if (!uploaded.ok) {
          throw new Error(`Object store rejected the upload with status ${uploaded.status}`);
        }
        notifyUploadProgress(input.onProgress, input.file.size, input.file.size);
        return await postFiles(
          JSON.stringify({
            mode: "complete",
            instance_id: input.instanceId,
            file_upload_id: pending.id
          })
        );
      };
      console.log("Uploading file:", {
        mode,
        name: getUploadFileName(input),
        size: input.file.size,
        purpose: input.purpose
      });
      let attempt = 0;
      while (true) {
        try {
          let json = mode == "presigned" ? await presignedUpload() : await directUpload();
          return mapDashboardInstanceFilesGetOutput.transformFrom(json);
        } catch (error) {
          if (((_b = input.signal) == null ? void 0 : _b.aborted) || isAbortError(error)) throw error;
          if (!(error instanceof MetorialSDKError) && attempt < 2) {
            console.warn("File upload failed, retrying...", error);
            attempt++;
            continue;
          }
          console.error("File upload failed:", error);
          if (error instanceof MetorialSDKError) throw error;
          throw new MetorialSDKError({
            status: 500,
            code: "file_upload_failed",
            message: "File upload failed due to an unexpected error"
          });
        }
      }
    }
  }),
  documents: Object.assign(new MetorialDashboardInstanceDocumentsEndpoint(manager), {
    editToken: new MetorialDashboardInstanceDocumentsEditTokenEndpoint(manager),
    participants: new MetorialDashboardInstanceDocumentsParticipantsEndpoint(manager),
    permissions: new MetorialDashboardInstanceDocumentsPermissionsEndpoint(manager),
    versions: new MetorialDashboardInstanceDocumentsVersionsEndpoint(manager)
  }),
  stores: Object.assign(new MetorialDashboardInstanceStoresEndpoint(manager), {
    items: new MetorialDashboardInstanceStoresItemsEndpoint(manager),
    participants: new MetorialDashboardInstanceStoresParticipantsEndpoint(manager),
    permissions: new MetorialDashboardInstanceStoresPermissionsEndpoint(manager)
  }),
  skills: Object.assign(new MetorialDashboardInstanceSkillsEndpoint(manager), {
    agents: new MetorialDashboardInstanceSkillsAgentsEndpoint(manager),
    configurations: new MetorialDashboardInstanceSkillsConfigurationsEndpoint(manager),
    forkSyncs: new MetorialDashboardInstanceSkillsForkSyncsEndpoint(manager),
    items: new MetorialDashboardInstanceSkillsItemsEndpoint(manager),
    mergeRequests: Object.assign(
      new MetorialDashboardInstanceSkillsMergeRequestsEndpoint(manager),
      {
        plan: new MetorialDashboardInstanceSkillsMergeRequestsPlanEndpoint(manager),
        items: new MetorialDashboardInstanceSkillsMergeRequestsItemsEndpoint(manager),
        comments: new MetorialDashboardInstanceSkillsMergeRequestsCommentsEndpoint(manager),
        events: new MetorialDashboardInstanceSkillsMergeRequestsEventsEndpoint(manager)
      }
    ),
    participants: new MetorialDashboardInstanceSkillsParticipantsEndpoint(manager),
    versions: Object.assign(new MetorialDashboardInstanceSkillsVersionsEndpoint(manager), {
      snapshot: new MetorialDashboardInstanceSkillsVersionsSnapshotEndpoint(manager)
    })
  }),
  skillTemplates: Object.assign(
    new MetorialDashboardInstanceSkillsTemplatesEndpoint(manager),
    {
      items: new MetorialDashboardInstanceSkillsTemplatesItemsEndpoint(manager)
    }
  ),
  skillGroups: Object.assign(new MetorialDashboardInstanceSkillsGroupsEndpoint(manager), {
    items: new MetorialDashboardInstanceSkillsGroupsItemsEndpoint(manager)
  }),
  skillMarketplaces: Object.assign(
    new MetorialDashboardInstanceSkillsMarketplacesEndpoint(manager),
    {
      plugins: new MetorialDashboardInstanceSkillsMarketplacesPluginsEndpoint(manager),
      repositories: new MetorialDashboardInstanceSkillsMarketplacesRepositoriesEndpoint(
        manager
      )
    }
  ),
  skillPlugins: Object.assign(new MetorialDashboardInstanceSkillsPluginsEndpoint(manager), {
    skills: new MetorialDashboardInstanceSkillsPluginsSkillsEndpoint(manager),
    repositories: new MetorialDashboardInstanceSkillsPluginsRepositoriesEndpoint(manager)
  }),
  skillExports: new MetorialDashboardInstanceSkillsExportsEndpoint(manager),
  skillImports: new MetorialDashboardInstanceSkillsImportsEndpoint(manager),
  skillSyncs: new MetorialDashboardInstanceSkillsSyncsEndpoint(manager),
  integrationInternetGateway: new MetorialDashboardInstanceIntegrationInternetGatewayEndpoint(
    manager
  ),
  resourceCounts: new MetorialDashboardInstancesResourceCountsEndpoint(manager),
  networkPolicies: Object.assign(
    new MetorialDashboardInstanceNetworkPoliciesEndpoint(manager),
    { rules: new MetorialDashboardInstanceNetworkPoliciesRulesEndpoint(manager) }
  ),
  integrationEnclaves: new MetorialDashboardInstanceIntegrationEnclavesEndpoint(manager),
  firewalls: Object.assign(new MetorialDashboardInstanceFirewallsEndpoint(manager), {
    networkPolicies: new MetorialDashboardInstanceFirewallsNetworkPoliciesEndpoint(manager)
  }),
  integrationFirewallAssignments: new MetorialDashboardInstanceIntegrationFirewallAssignmentsEndpoint(manager),
  magicMcp: {
    servers: Object.assign(new MetorialDashboardInstanceMagicMcpServersEndpoint(manager), {
      providers: new MetorialDashboardInstanceMagicMcpServersProvidersEndpoint(manager),
      session: new MetorialDashboardInstanceMagicMcpServersSessionEndpoint(manager)
    }),
    sessions: new MetorialDashboardInstanceMagicMcpSessionsEndpoint(manager),
    tokens: new MetorialDashboardInstanceMagicMcpTokensEndpoint(manager),
    groups: new MetorialDashboardInstanceMagicMcpGroupsEndpoint(manager),
    endpoints: new MetorialDashboardInstanceMagicMcpEndpointsEndpoint(manager)
  },
  publicMcpServers: Object.assign(
    new MetorialDashboardInstancePublicMcpServersEndpoint(manager),
    {
      grants: new MetorialDashboardInstancePublicMcpServersGrantsEndpoint(manager),
      clients: new MetorialDashboardInstancePublicMcpServersClientsEndpoint(manager),
      slugs: new MetorialDashboardInstancePublicMcpServersSlugsEndpoint(manager)
    }
  ),
  portals: Object.assign(new MetorialDashboardInstancePortalsEndpoint(manager), {
    consumerGroups: new MetorialDashboardInstancePortalsConsumerGroupsEndpoint(manager),
    consumerAccess: new MetorialDashboardInstancePortalsAccessEndpoint(manager),
    consumerAccessListings: new MetorialDashboardInstancePortalsListingsEndpoint(manager),
    consumerProfiles: new MetorialDashboardInstancePortalsConsumerProfilesEndpoint(manager),
    consumerInvites: new MetorialDashboardInstancePortalsConsumerInvitesEndpoint(manager),
    providerGroups: new MetorialDashboardInstancePortalsSurfaceProviderGroupsEndpoint(manager),
    accessRequests: new MetorialDashboardInstancePortalsAccessRequestsEndpoint(manager)
  }),
  consumers: Object.assign(new MetorialDashboardInstanceConsumersEndpoint(manager), {
    profiles: new MetorialDashboardInstanceConsumersProfilesEndpoint(manager)
  }),
  consumerSurfaces: new MetorialDashboardInstanceConsumerSurfacesEndpoint(manager),
  accessPolicies: new MetorialDashboardOrganizationsAccessPoliciesEndpoint(manager),
  accessRoles: new MetorialDashboardOrganizationsAccessRolesEndpoint(manager),
  providerTemplates: new MetorialDashboardInstanceProviderTemplatesEndpoint(manager),
  usage: new MetorialDashboardUsageEndpoint(manager),
  oauth: {
    cliDevices: new MetorialDashboardOrganizationsOauthCliDevicesEndpoint(manager),
    authorizationRequests: Object.assign(
      new MetorialDashboardOauthAuthorizationRequestsEndpoint(manager),
      {
        consumerTargets: new MetorialDashboardOauthAuthorizationRequestsConsumerTargetsEndpoint(manager)
      }
    ),
    scopes: new MetorialDashboardOrganizationsOauthScopesEndpoint(manager),
    apps: Object.assign(new MetorialDashboardOrganizationsOauthAppsEndpoint(manager), {
      clientSecrets: new MetorialDashboardOrganizationsOauthAppsClientSecretsEndpoint(manager)
    }),
    authorizationLogs: new MetorialDashboardOrganizationsOauthAuthorizationLogsEndpoint(
      manager
    ),
    installations: new MetorialDashboardOrganizationsOauthInstallationsEndpoint(manager),
    authorizations: new MetorialDashboardOrganizationsOauthAuthorizationsEndpoint(manager)
  },
  assistant: {
    assistants: new MetorialDashboardInstanceAssistantsEndpoint(manager),
    conversations: Object.assign(new MetorialDashboardInstanceConversationsEndpoint(manager), {
      messages: new MetorialDashboardInstanceConversationsMessagesEndpoint(manager)
    }),
    connectRequestDeltas: (assistantRequestId, opts) => createAssistantRequestDeltaConnection(manager, assistantRequestId, opts)
  },
  serviceAccounts: Object.assign(
    new MetorialDashboardOrganizationsServiceAccountsEndpoint(manager),
    {
      clientSecrets: new MetorialDashboardOrganizationsServiceAccountsClientSecretsEndpoint(
        manager
      ),
      credentials: new MetorialDashboardOrganizationsServiceAccountsCredentialsEndpoint(
        manager
      ),
      policies: new MetorialDashboardOrganizationsServiceAccountsPoliciesEndpoint(manager)
    }
  ),
  teams: Object.assign(new MetorialDashboardOrganizationsTeamsEndpoint(manager), {
    members: new MetorialDashboardOrganizationsTeamsMembersEndpoint(manager),
    policies: new MetorialDashboardOrganizationsTeamsPoliciesEndpoint(manager)
  }),
  auditLogs: new MetorialDashboardOrganizationsAuditLogsEndpoint(manager),
  auditLogStreams: Object.assign(
    new MetorialDashboardOrganizationsAuditLogStreamsEndpoint(manager),
    {
      events: new MetorialDashboardOrganizationsAuditLogStreamsEventsEndpoint(manager)
    }
  ),
  customProviders: Object.assign(
    new MetorialDashboardInstanceCustomProvidersEndpoint(manager),
    {
      versions: new MetorialDashboardInstanceCustomProvidersVersionsEndpoint(manager),
      deployments: new MetorialDashboardInstanceCustomProvidersDeploymentsEndpoint(manager),
      commits: new MetorialDashboardInstanceCustomProvidersCommitsEndpoint(manager),
      environments: new MetorialDashboardInstanceCustomProvidersEnvironmentsEndpoint(manager),
      code: new MetorialDashboardInstanceCustomProvidersCodeEndpoint(manager)
    }
  ),
  providers: Object.assign(new MetorialDashboardInstanceProvidersEndpoint(manager), {
    tools: new MetorialDashboardInstanceProvidersToolsEndpoint(manager),
    versions: new MetorialDashboardInstanceProvidersVersionsEndpoint(manager),
    triggers: new MetorialDashboardInstanceProvidersTriggersEndpoint(manager),
    authMethods: new MetorialDashboardInstanceProvidersAuthMethodsEndpoint(manager),
    authConfigs: new MetorialDashboardInstanceProviderDeploymentsAuthConfigsEndpoint(manager),
    specifications: new MetorialDashboardInstanceProvidersSpecificationsEndpoint(manager),
    listings: new MetorialDashboardInstanceProviderListingsEndpoint(manager),
    categories: new MetorialDashboardInstanceProviderCategoriesEndpoint(manager),
    collections: new MetorialDashboardInstanceProviderCollectionsEndpoint(manager),
    groups: new MetorialDashboardInstanceProviderGroupsEndpoint(manager),
    publishers: new MetorialDashboardInstancePublishersEndpoint(manager)
  }),
  providerDeployments: Object.assign(
    new MetorialDashboardInstanceProviderDeploymentsEndpoint(manager),
    {
      configs: new MetorialDashboardInstanceProviderDeploymentsConfigsEndpoint(manager),
      configVaults: new MetorialDashboardInstanceProviderDeploymentsConfigVaultsEndpoint(
        manager
      ),
      authConfigs: Object.assign(
        new MetorialDashboardInstanceProviderDeploymentsAuthConfigsEndpoint(manager),
        {
          exports: new MetorialDashboardInstanceProviderDeploymentsAuthConfigsExportsEndpoint(
            manager
          ),
          imports: new MetorialDashboardInstanceProviderDeploymentsAuthConfigsImportsEndpoint(
            manager
          )
        }
      ),
      authCredentials: new MetorialDashboardInstanceProviderDeploymentsAuthCredentialsEndpoint(
        manager
      ),
      setupSessions: new MetorialDashboardInstanceProviderDeploymentsSetupSessionsEndpoint(
        manager
      )
    }
  ),
  sessions: Object.assign(new MetorialDashboardInstanceSessionsEndpoint(manager), {
    events: new MetorialDashboardInstanceSessionsEventsEndpoint(manager),
    messages: new MetorialDashboardInstanceSessionsMessagesEndpoint(manager),
    connections: new MetorialDashboardInstanceSessionsConnectionsEndpoint(manager),
    toolCalls: new MetorialDashboardInstanceToolCallsEndpoint(manager),
    providers: new MetorialDashboardInstanceSessionsProvidersEndpoint(manager),
    participants: new MetorialDashboardInstanceSessionsParticipantsEndpoint(manager),
    errors: new MetorialDashboardInstanceSessionsErrorsEndpoint(manager),
    errorGroups: new MetorialDashboardInstanceSessionsErrorGroupsEndpoint(manager)
  }),
  agents: Object.assign(new MetorialDashboardInstanceAgentsEndpoint(manager), {
    instances: new MetorialDashboardInstanceAgentsInstancesEndpoint(manager)
  }),
  providerRuns: new MetorialDashboardInstanceProviderRunsEndpoint(manager),
  monitorAlerts: new MetorialDashboardInstanceMonitorAlertsEndpoint(manager),
  monitors: new MetorialDashboardInstanceMonitorsEndpoint(manager),
  protoGuardAlerts: new MetorialDashboardInstanceProtoGuardAlertsEndpoint(manager),
  protoGuardConfig: new MetorialDashboardInstanceProtoGuardConfigEndpoint(manager),
  providerAuthConfigErrors: Object.assign(
    new MetorialDashboardInstanceProviderAuthConfigErrorsEndpoint(manager),
    {
      groups: new MetorialDashboardInstanceProviderAuthConfigErrorsGroupsEndpoint(manager)
    }
  ),
  providerAuthConfigEvents: new MetorialDashboardInstanceProviderAuthConfigEventsEndpoint(
    manager
  ),
  providerInvocations: new MetorialDashboardInstanceProviderInvocationsEndpoint(manager),
  sessionErrors: new MetorialDashboardInstanceSessionsErrorsEndpoint(manager),
  sessionErrorGroups: new MetorialDashboardInstanceSessionsErrorGroupsEndpoint(manager),
  sessionTemplates: Object.assign(
    new MetorialDashboardInstanceSessionTemplatesEndpoint(manager),
    {
      providers: new MetorialDashboardInstanceSessionTemplatesProvidersEndpoint(manager)
    }
  ),
  integration: Object.assign(new MetorialDashboardInstanceIntegrationsEndpoint(manager), {
    providers: new MetorialDashboardInstanceIntegrationsProvidersEndpoint(manager),
    instances: Object.assign(
      new MetorialDashboardInstanceIntegrationsInstancesEndpoint(manager),
      {
        providers: new MetorialDashboardInstanceIntegrationsInstancesProvidersEndpoint(manager)
      }
    ),
    groups: Object.assign(
      new MetorialDashboardInstanceIntegrationsInstanceGroupsEndpoint(manager),
      {
        providers: new MetorialDashboardInstanceIntegrationsInstanceGroupsProvidersEndpoint(
          manager
        )
      }
    ),
    setupSessions: new MetorialDashboardInstanceIntegrationsSetupSessionsEndpoint(manager)
  }),
  callbacks: Object.assign(new MetorialDashboardInstanceCallbacksEndpoint(manager), {
    events: new MetorialDashboardInstanceCallbackEventsEndpoint(manager),
    instances: new MetorialDashboardInstanceCallbackInstancesEndpoint(manager),
    incomingWebhooks: new MetorialDashboardInstanceIncomingWebhooksEndpoint(manager),
    registrations: new MetorialDashboardInstanceWebhookRegistrationsEndpoint(manager)
  }),
  chat: Object.assign(new MetorialDashboardInstanceChatsEndpoint(manager), {
    connections: new MetorialDashboardInstanceChatConnectionsEndpoint(manager),
    instances: Object.assign(new MetorialDashboardInstanceChatInstancesEndpoint(manager), {
      provider: new MetorialDashboardInstanceChatInstancesProviderEndpoint(manager)
    }),
    workspaces: new MetorialDashboardInstanceChatWorkspacesEndpoint(manager),
    events: new MetorialDashboardInstanceChatEventsEndpoint(manager),
    channels: Object.assign(new MetorialDashboardInstanceChatsChannelsEndpoint(manager), {
      members: new MetorialDashboardInstanceChatsChannelsMembersEndpoint(manager)
    }),
    threads: new MetorialDashboardInstanceChatsThreadsEndpoint(manager),
    messages: Object.assign(new MetorialDashboardInstanceChatsMessagesEndpoint(manager), {
      reactions: new MetorialDashboardInstanceChatsMessagesReactionsEndpoint(manager)
    })
  }),
  eventDestinations: Object.assign(
    new MetorialDashboardOrganizationsEventDestinationsEndpoint(manager),
    {
      listeners: new MetorialDashboardOrganizationsEventDestinationListenersEndpoint(manager)
    }
  ),
  eventDeliveries: new MetorialDashboardOrganizationsEventDeliveriesEndpoint(manager),
  eventDeliveryAttempts: new MetorialDashboardOrganizationsEventDeliveryAttemptsEndpoint(
    manager
  ),
  events: Object.assign(new MetorialDashboardOrganizationsEventsEndpoint(manager), {
    types: new MetorialDashboardOrganizationsWebhookEventsEndpoint(manager)
  }),
  scm: {
    installation: new MetorialDashboardInstanceScmInstallationEndpoint(manager),
    repos: new MetorialDashboardInstanceScmReposEndpoint(manager),
    accounts: new MetorialDashboardInstanceScmAccountsEndpoint(manager),
    connections: new MetorialDashboardInstanceScmConnectionsEndpoint(manager),
    providers: new MetorialDashboardInstanceScmProvidersEndpoint(manager)
  },
  identityActors: new MetorialDashboardInstanceIdentityActorsEndpoint(manager),
  identities: Object.assign(new MetorialDashboardInstanceIdentitiesEndpoint(manager), {
    credentials: new MetorialDashboardInstanceIdentitiesCredentialsEndpoint(manager),
    delegations: new MetorialDashboardInstanceIdentitiesDelegationsEndpoint(manager),
    delegationConfigs: new MetorialDashboardInstanceIdentitiesDelegationConfigsEndpoint(
      manager
    ),
    delegationRequests: new MetorialDashboardInstanceIdentitiesDelegationRequestsEndpoint(
      manager
    )
  })
}));

export { MetorialAgentsEndpoint, MetorialAgentsInstancesEndpoint, MetorialAssistantsEndpoint, MetorialCallbackEventsEndpoint, MetorialCallbackInstancesEndpoint, MetorialCallbacksEndpoint, MetorialChatConnectionsEndpoint, MetorialChatEventsEndpoint, MetorialChatInstancesEndpoint, MetorialChatInstancesProviderEndpoint, MetorialChatWorkspacesEndpoint, MetorialChatsChannelsEndpoint, MetorialChatsChannelsMembersEndpoint, MetorialChatsChannelsTypingEndpoint, MetorialChatsCommandsEndpoint, MetorialChatsDmsEndpoint, MetorialChatsEndpoint, MetorialChatsMessagesEndpoint, MetorialChatsMessagesReactionsEndpoint, MetorialChatsThreadsEndpoint, MetorialConsumerSurfacesEndpoint, MetorialConsumersEndpoint, MetorialConsumersProfilesEndpoint, MetorialConversationsEndpoint, MetorialConversationsMessagesEndpoint, MetorialCustomProvidersCodeEndpoint, MetorialCustomProvidersCommitsEndpoint, MetorialCustomProvidersDeploymentsEndpoint, MetorialCustomProvidersEndpoint, MetorialCustomProvidersEnvironmentsEndpoint, MetorialCustomProvidersVersionsEndpoint, MetorialDashboardEndpoint, MetorialDashboardInstanceAgentsEndpoint, MetorialDashboardInstanceAgentsInstancesEndpoint, MetorialDashboardInstanceAssistantsEndpoint, MetorialDashboardInstanceCallbackEventsEndpoint, MetorialDashboardInstanceCallbackInstancesEndpoint, MetorialDashboardInstanceCallbacksEndpoint, MetorialDashboardInstanceChatConnectionsEndpoint, MetorialDashboardInstanceChatEventsEndpoint, MetorialDashboardInstanceChatInstancesEndpoint, MetorialDashboardInstanceChatInstancesProviderEndpoint, MetorialDashboardInstanceChatWorkspacesEndpoint, MetorialDashboardInstanceChatsChannelsEndpoint, MetorialDashboardInstanceChatsChannelsMembersEndpoint, MetorialDashboardInstanceChatsChannelsTypingEndpoint, MetorialDashboardInstanceChatsCommandsEndpoint, MetorialDashboardInstanceChatsDmsEndpoint, MetorialDashboardInstanceChatsEndpoint, MetorialDashboardInstanceChatsMessagesEndpoint, MetorialDashboardInstanceChatsMessagesReactionsEndpoint, MetorialDashboardInstanceChatsThreadsEndpoint, MetorialDashboardInstanceConsumerSurfacesEndpoint, MetorialDashboardInstanceConsumersEndpoint, MetorialDashboardInstanceConsumersProfilesEndpoint, MetorialDashboardInstanceConversationsEndpoint, MetorialDashboardInstanceConversationsMessagesEndpoint, MetorialDashboardInstanceCustomProvidersCodeEndpoint, MetorialDashboardInstanceCustomProvidersCommitsEndpoint, MetorialDashboardInstanceCustomProvidersDeploymentsEndpoint, MetorialDashboardInstanceCustomProvidersEndpoint, MetorialDashboardInstanceCustomProvidersEnvironmentsEndpoint, MetorialDashboardInstanceCustomProvidersVersionsEndpoint, MetorialDashboardInstanceDocumentsEditTokenEndpoint, MetorialDashboardInstanceDocumentsEndpoint, MetorialDashboardInstanceDocumentsParticipantsEndpoint, MetorialDashboardInstanceDocumentsPermissionsEndpoint, MetorialDashboardInstanceDocumentsVersionsEndpoint, MetorialDashboardInstanceFilesEndpoint, MetorialDashboardInstanceFilesLinksEndpoint, MetorialDashboardInstanceFirewallsEndpoint, MetorialDashboardInstanceFirewallsNetworkPoliciesEndpoint, MetorialDashboardInstanceIdentitiesCredentialsEndpoint, MetorialDashboardInstanceIdentitiesDelegationConfigsEndpoint, MetorialDashboardInstanceIdentitiesDelegationRequestsEndpoint, MetorialDashboardInstanceIdentitiesDelegationsEndpoint, MetorialDashboardInstanceIdentitiesEndpoint, MetorialDashboardInstanceIdentityActorsEndpoint, MetorialDashboardInstanceIncomingWebhooksEndpoint, MetorialDashboardInstanceIntegrationEnclavesEndpoint, MetorialDashboardInstanceIntegrationFirewallAssignmentsEndpoint, MetorialDashboardInstanceIntegrationInternetGatewayEndpoint, MetorialDashboardInstanceIntegrationsEndpoint, MetorialDashboardInstanceIntegrationsInstanceGroupsEndpoint, MetorialDashboardInstanceIntegrationsInstanceGroupsProvidersEndpoint, MetorialDashboardInstanceIntegrationsInstancesEndpoint, MetorialDashboardInstanceIntegrationsInstancesProvidersEndpoint, MetorialDashboardInstanceIntegrationsProvidersEndpoint, MetorialDashboardInstanceIntegrationsSetupSessionsEndpoint, MetorialDashboardInstanceMagicMcpEndpointsEndpoint, MetorialDashboardInstanceMagicMcpGroupsEndpoint, MetorialDashboardInstanceMagicMcpServersEndpoint, MetorialDashboardInstanceMagicMcpServersProvidersEndpoint, MetorialDashboardInstanceMagicMcpServersSessionEndpoint, MetorialDashboardInstanceMagicMcpSessionsEndpoint, MetorialDashboardInstanceMagicMcpTokensEndpoint, MetorialDashboardInstanceMonitorAlertsEndpoint, MetorialDashboardInstanceMonitorsEndpoint, MetorialDashboardInstanceNetworkPoliciesEndpoint, MetorialDashboardInstanceNetworkPoliciesRulesEndpoint, MetorialDashboardInstancePortalsAccessEndpoint, MetorialDashboardInstancePortalsAccessRequestsEndpoint, MetorialDashboardInstancePortalsConsumerGroupsEndpoint, MetorialDashboardInstancePortalsConsumerInvitesEndpoint, MetorialDashboardInstancePortalsConsumerProfilesEndpoint, MetorialDashboardInstancePortalsEndpoint, MetorialDashboardInstancePortalsListingsEndpoint, MetorialDashboardInstancePortalsSurfaceProviderGroupsEndpoint, MetorialDashboardInstanceProtoGuardAlertsEndpoint, MetorialDashboardInstanceProtoGuardConfigEndpoint, MetorialDashboardInstanceProviderAuthConfigErrorsEndpoint, MetorialDashboardInstanceProviderAuthConfigErrorsGroupsEndpoint, MetorialDashboardInstanceProviderAuthConfigEventsEndpoint, MetorialDashboardInstanceProviderCategoriesEndpoint, MetorialDashboardInstanceProviderCollectionsEndpoint, MetorialDashboardInstanceProviderDeploymentsAuthConfigsEndpoint, MetorialDashboardInstanceProviderDeploymentsAuthConfigsExportsEndpoint, MetorialDashboardInstanceProviderDeploymentsAuthConfigsImportsEndpoint, MetorialDashboardInstanceProviderDeploymentsAuthCredentialsEndpoint, MetorialDashboardInstanceProviderDeploymentsConfigVaultsEndpoint, MetorialDashboardInstanceProviderDeploymentsConfigsEndpoint, MetorialDashboardInstanceProviderDeploymentsEndpoint, MetorialDashboardInstanceProviderDeploymentsSetupSessionsEndpoint, MetorialDashboardInstanceProviderGroupsEndpoint, MetorialDashboardInstanceProviderInvocationsEndpoint, MetorialDashboardInstanceProviderListingsEndpoint, MetorialDashboardInstanceProviderRunsEndpoint, MetorialDashboardInstanceProviderSpecificationChangeNotificationsEndpoint, MetorialDashboardInstanceProviderTemplatesEndpoint, MetorialDashboardInstanceProvidersAuthMethodsEndpoint, MetorialDashboardInstanceProvidersEndpoint, MetorialDashboardInstanceProvidersSpecificationsEndpoint, MetorialDashboardInstanceProvidersToolsEndpoint, MetorialDashboardInstanceProvidersTriggersEndpoint, MetorialDashboardInstanceProvidersVersionsEndpoint, MetorialDashboardInstancePublicMcpServersClientsEndpoint, MetorialDashboardInstancePublicMcpServersEndpoint, MetorialDashboardInstancePublicMcpServersGrantsEndpoint, MetorialDashboardInstancePublicMcpServersSlugsEndpoint, MetorialDashboardInstancePublishersEndpoint, MetorialDashboardInstanceSandboxDisksEndpoint, MetorialDashboardInstanceSandboxDisksMountsEndpoint, MetorialDashboardInstanceSandboxDisksResizesEndpoint, MetorialDashboardInstanceSandboxImageBuildsEndpoint, MetorialDashboardInstanceSandboxImagesBuildsEndpoint, MetorialDashboardInstanceSandboxImagesEndpoint, MetorialDashboardInstanceSandboxImagesVersionsEndpoint, MetorialDashboardInstanceSandboxMachinesAccessEndpoint, MetorialDashboardInstanceSandboxMachinesEndpoint, MetorialDashboardInstanceSandboxMachinesErrorsEndpoint, MetorialDashboardInstanceSandboxMachinesEventsEndpoint, MetorialDashboardInstanceSandboxMachinesInstancesEndpoint, MetorialDashboardInstanceSandboxMachinesOperationsEndpoint, MetorialDashboardInstanceSandboxMachinesUsageEndpoint, MetorialDashboardInstanceSandboxRegionsEndpoint, MetorialDashboardInstanceSandboxSpecsEndpoint, MetorialDashboardInstanceScmAccountsEndpoint, MetorialDashboardInstanceScmConnectionsEndpoint, MetorialDashboardInstanceScmInstallationEndpoint, MetorialDashboardInstanceScmProvidersEndpoint, MetorialDashboardInstanceScmReposEndpoint, MetorialDashboardInstanceSessionTemplatesEndpoint, MetorialDashboardInstanceSessionTemplatesProvidersEndpoint, MetorialDashboardInstanceSessionsConnectionsEndpoint, MetorialDashboardInstanceSessionsEndpoint, MetorialDashboardInstanceSessionsErrorGroupsEndpoint, MetorialDashboardInstanceSessionsErrorsEndpoint, MetorialDashboardInstanceSessionsEventsEndpoint, MetorialDashboardInstanceSessionsMessagesEndpoint, MetorialDashboardInstanceSessionsParticipantsEndpoint, MetorialDashboardInstanceSessionsProvidersEndpoint, MetorialDashboardInstanceSkillsAgentsEndpoint, MetorialDashboardInstanceSkillsConfigurationsEndpoint, MetorialDashboardInstanceSkillsEndpoint, MetorialDashboardInstanceSkillsExportsEndpoint, MetorialDashboardInstanceSkillsFilesEndpoint, MetorialDashboardInstanceSkillsForkSyncsEndpoint, MetorialDashboardInstanceSkillsGroupsEndpoint, MetorialDashboardInstanceSkillsGroupsItemsEndpoint, MetorialDashboardInstanceSkillsImportsEndpoint, MetorialDashboardInstanceSkillsItemsEndpoint, MetorialDashboardInstanceSkillsMarketplacesEndpoint, MetorialDashboardInstanceSkillsMarketplacesPluginsEndpoint, MetorialDashboardInstanceSkillsMarketplacesRepositoriesEndpoint, MetorialDashboardInstanceSkillsMergeRequestsCommentsEndpoint, MetorialDashboardInstanceSkillsMergeRequestsEndpoint, MetorialDashboardInstanceSkillsMergeRequestsEventsEndpoint, MetorialDashboardInstanceSkillsMergeRequestsItemsEndpoint, MetorialDashboardInstanceSkillsMergeRequestsPlanEndpoint, MetorialDashboardInstanceSkillsParticipantsEndpoint, MetorialDashboardInstanceSkillsPluginsEndpoint, MetorialDashboardInstanceSkillsPluginsRepositoriesEndpoint, MetorialDashboardInstanceSkillsPluginsSkillsEndpoint, MetorialDashboardInstanceSkillsSyncsEndpoint, MetorialDashboardInstanceSkillsTemplatesEndpoint, MetorialDashboardInstanceSkillsTemplatesItemsEndpoint, MetorialDashboardInstanceSkillsVersionsEndpoint, MetorialDashboardInstanceSkillsVersionsSnapshotEndpoint, MetorialDashboardInstanceStoresEndpoint, MetorialDashboardInstanceStoresItemsEndpoint, MetorialDashboardInstanceStoresParticipantsEndpoint, MetorialDashboardInstanceStoresPermissionsEndpoint, MetorialDashboardInstanceToolCallsEndpoint, MetorialDashboardInstanceWebhookRegistrationsEndpoint, MetorialDashboardInstancesResourceCountsEndpoint, MetorialDashboardOauthAuthorizationRequestsConsumerTargetsEndpoint, MetorialDashboardOauthAuthorizationRequestsEndpoint, MetorialDashboardOrganizationsAccessPoliciesEndpoint, MetorialDashboardOrganizationsAccessRolesEndpoint, MetorialDashboardOrganizationsApiKeysEndpoint, MetorialDashboardOrganizationsAuditLogStreamsEndpoint, MetorialDashboardOrganizationsAuditLogStreamsEventsEndpoint, MetorialDashboardOrganizationsAuditLogsEndpoint, MetorialDashboardOrganizationsConfigsEndpoint, MetorialDashboardOrganizationsConfigureAuditLogRetentionEndpoint, MetorialDashboardOrganizationsEndpoint, MetorialDashboardOrganizationsEventDeliveriesEndpoint, MetorialDashboardOrganizationsEventDeliveryAttemptsEndpoint, MetorialDashboardOrganizationsEventDestinationListenersEndpoint, MetorialDashboardOrganizationsEventDestinationsEndpoint, MetorialDashboardOrganizationsEventsEndpoint, MetorialDashboardOrganizationsInstancesEndpoint, MetorialDashboardOrganizationsInvitesEndpoint, MetorialDashboardOrganizationsJoinEndpoint, MetorialDashboardOrganizationsLayoutsEndpoint, MetorialDashboardOrganizationsMembersEndpoint, MetorialDashboardOrganizationsMembersPoliciesEndpoint, MetorialDashboardOrganizationsOauthAppsClientSecretsEndpoint, MetorialDashboardOrganizationsOauthAppsEndpoint, MetorialDashboardOrganizationsOauthAuthorizationLogsEndpoint, MetorialDashboardOrganizationsOauthAuthorizationsEndpoint, MetorialDashboardOrganizationsOauthCliDevicesEndpoint, MetorialDashboardOrganizationsOauthInstallationsEndpoint, MetorialDashboardOrganizationsOauthScopesEndpoint, MetorialDashboardOrganizationsOutpostsAccessEndpoint, MetorialDashboardOrganizationsOutpostsCredentialsEndpoint, MetorialDashboardOrganizationsOutpostsEndpoint, MetorialDashboardOrganizationsProjectsBrandingEndpoint, MetorialDashboardOrganizationsProjectsEndpoint, MetorialDashboardOrganizationsSandboxesEndpoint, MetorialDashboardOrganizationsServiceAccountsClientSecretsEndpoint, MetorialDashboardOrganizationsServiceAccountsCredentialsEndpoint, MetorialDashboardOrganizationsServiceAccountsEndpoint, MetorialDashboardOrganizationsServiceAccountsPoliciesEndpoint, MetorialDashboardOrganizationsTeamsEndpoint, MetorialDashboardOrganizationsTeamsMembersEndpoint, MetorialDashboardOrganizationsTeamsPoliciesEndpoint, MetorialDashboardOrganizationsWebhookEventsEndpoint, MetorialDashboardProjectsConfigureAuthConfigEndpoint, MetorialDashboardProjectsConfigureDataRetentionEndpoint, MetorialDashboardProjectsConfigureIntegrationNamingEndpoint, MetorialDashboardProjectsConfigureRetentionEndpoint, MetorialDashboardProjectsConfigureSessionlessMcpEndpoint, MetorialDashboardProjectsConfigureSkillSyncEndpoint, MetorialDashboardProjectsConfigureToolCallingEndpoint, MetorialDashboardProjectsConfigureWorkforceEndpoint, MetorialDashboardProjectsKeyProvidersEndpoint, MetorialDashboardProjectsKeyProvidersErrorsEndpoint, MetorialDashboardUsageEndpoint, MetorialDocumentsEditTokenEndpoint, MetorialDocumentsEndpoint, MetorialDocumentsParticipantsEndpoint, MetorialDocumentsPermissionsEndpoint, MetorialDocumentsVersionsEndpoint, MetorialFilesEndpoint, MetorialFilesLinksEndpoint, MetorialFirewallsEndpoint, MetorialFirewallsNetworkPoliciesEndpoint, MetorialIdentitiesCredentialsEndpoint, MetorialIdentitiesDelegationConfigsEndpoint, MetorialIdentitiesDelegationRequestsEndpoint, MetorialIdentitiesDelegationsEndpoint, MetorialIdentitiesEndpoint, MetorialIdentityActorsEndpoint, MetorialIncomingWebhooksEndpoint, MetorialIntegrationEnclavesEndpoint, MetorialIntegrationFirewallAssignmentsEndpoint, MetorialIntegrationInternetGatewayEndpoint, MetorialIntegrationsEndpoint, MetorialIntegrationsInstanceGroupsEndpoint, MetorialIntegrationsInstanceGroupsProvidersEndpoint, MetorialIntegrationsInstancesEndpoint, MetorialIntegrationsInstancesProvidersEndpoint, MetorialIntegrationsProvidersEndpoint, MetorialIntegrationsSetupSessionsEndpoint, MetorialMagicMcpEndpointsEndpoint, MetorialMagicMcpGroupsEndpoint, MetorialMagicMcpServersEndpoint, MetorialMagicMcpServersProvidersEndpoint, MetorialMagicMcpServersSessionEndpoint, MetorialMagicMcpSessionsEndpoint, MetorialMagicMcpTokensEndpoint, MetorialManagementInstanceAgentsEndpoint, MetorialManagementInstanceAgentsInstancesEndpoint, MetorialManagementInstanceAssistantsEndpoint, MetorialManagementInstanceCallbackEventsEndpoint, MetorialManagementInstanceCallbackInstancesEndpoint, MetorialManagementInstanceCallbacksEndpoint, MetorialManagementInstanceChatConnectionsEndpoint, MetorialManagementInstanceChatEventsEndpoint, MetorialManagementInstanceChatInstancesEndpoint, MetorialManagementInstanceChatInstancesProviderEndpoint, MetorialManagementInstanceChatWorkspacesEndpoint, MetorialManagementInstanceChatsChannelsEndpoint, MetorialManagementInstanceChatsChannelsMembersEndpoint, MetorialManagementInstanceChatsChannelsTypingEndpoint, MetorialManagementInstanceChatsCommandsEndpoint, MetorialManagementInstanceChatsDmsEndpoint, MetorialManagementInstanceChatsEndpoint, MetorialManagementInstanceChatsMessagesEndpoint, MetorialManagementInstanceChatsMessagesReactionsEndpoint, MetorialManagementInstanceChatsThreadsEndpoint, MetorialManagementInstanceConsumerSurfacesEndpoint, MetorialManagementInstanceConsumersEndpoint, MetorialManagementInstanceConsumersProfilesEndpoint, MetorialManagementInstanceConversationsEndpoint, MetorialManagementInstanceConversationsMessagesEndpoint, MetorialManagementInstanceCustomProvidersCodeEndpoint, MetorialManagementInstanceCustomProvidersCommitsEndpoint, MetorialManagementInstanceCustomProvidersDeploymentsEndpoint, MetorialManagementInstanceCustomProvidersEndpoint, MetorialManagementInstanceCustomProvidersEnvironmentsEndpoint, MetorialManagementInstanceCustomProvidersVersionsEndpoint, MetorialManagementInstanceDocumentsEditTokenEndpoint, MetorialManagementInstanceDocumentsEndpoint, MetorialManagementInstanceDocumentsParticipantsEndpoint, MetorialManagementInstanceDocumentsPermissionsEndpoint, MetorialManagementInstanceDocumentsVersionsEndpoint, MetorialManagementInstanceFilesEndpoint, MetorialManagementInstanceFilesLinksEndpoint, MetorialManagementInstanceFirewallsEndpoint, MetorialManagementInstanceFirewallsNetworkPoliciesEndpoint, MetorialManagementInstanceIdentitiesCredentialsEndpoint, MetorialManagementInstanceIdentitiesDelegationConfigsEndpoint, MetorialManagementInstanceIdentitiesDelegationRequestsEndpoint, MetorialManagementInstanceIdentitiesDelegationsEndpoint, MetorialManagementInstanceIdentitiesEndpoint, MetorialManagementInstanceIdentityActorsEndpoint, MetorialManagementInstanceIncomingWebhooksEndpoint, MetorialManagementInstanceIntegrationEnclavesEndpoint, MetorialManagementInstanceIntegrationFirewallAssignmentsEndpoint, MetorialManagementInstanceIntegrationInternetGatewayEndpoint, MetorialManagementInstanceIntegrationsEndpoint, MetorialManagementInstanceIntegrationsInstanceGroupsEndpoint, MetorialManagementInstanceIntegrationsInstanceGroupsProvidersEndpoint, MetorialManagementInstanceIntegrationsInstancesEndpoint, MetorialManagementInstanceIntegrationsInstancesProvidersEndpoint, MetorialManagementInstanceIntegrationsProvidersEndpoint, MetorialManagementInstanceIntegrationsSetupSessionsEndpoint, MetorialManagementInstanceMagicMcpEndpointsEndpoint, MetorialManagementInstanceMagicMcpGroupsEndpoint, MetorialManagementInstanceMagicMcpServersEndpoint, MetorialManagementInstanceMagicMcpServersProvidersEndpoint, MetorialManagementInstanceMagicMcpServersSessionEndpoint, MetorialManagementInstanceMagicMcpSessionsEndpoint, MetorialManagementInstanceMagicMcpTokensEndpoint, MetorialManagementInstanceMonitorAlertsEndpoint, MetorialManagementInstanceMonitorsEndpoint, MetorialManagementInstanceNetworkPoliciesEndpoint, MetorialManagementInstanceNetworkPoliciesRulesEndpoint, MetorialManagementInstancePortalsAccessEndpoint, MetorialManagementInstancePortalsAccessRequestsEndpoint, MetorialManagementInstancePortalsConsumerGroupsEndpoint, MetorialManagementInstancePortalsConsumerInvitesEndpoint, MetorialManagementInstancePortalsConsumerProfilesEndpoint, MetorialManagementInstancePortalsEndpoint, MetorialManagementInstancePortalsListingsEndpoint, MetorialManagementInstancePortalsSurfaceProviderGroupsEndpoint, MetorialManagementInstanceProtoGuardAlertsEndpoint, MetorialManagementInstanceProtoGuardConfigEndpoint, MetorialManagementInstanceProviderAuthConfigErrorsEndpoint, MetorialManagementInstanceProviderAuthConfigErrorsGroupsEndpoint, MetorialManagementInstanceProviderAuthConfigEventsEndpoint, MetorialManagementInstanceProviderCategoriesEndpoint, MetorialManagementInstanceProviderCollectionsEndpoint, MetorialManagementInstanceProviderDeploymentsAuthConfigsEndpoint, MetorialManagementInstanceProviderDeploymentsAuthConfigsExportsEndpoint, MetorialManagementInstanceProviderDeploymentsAuthConfigsImportsEndpoint, MetorialManagementInstanceProviderDeploymentsAuthCredentialsEndpoint, MetorialManagementInstanceProviderDeploymentsConfigVaultsEndpoint, MetorialManagementInstanceProviderDeploymentsConfigsEndpoint, MetorialManagementInstanceProviderDeploymentsEndpoint, MetorialManagementInstanceProviderDeploymentsSetupSessionsEndpoint, MetorialManagementInstanceProviderGroupsEndpoint, MetorialManagementInstanceProviderInvocationsEndpoint, MetorialManagementInstanceProviderListingsEndpoint, MetorialManagementInstanceProviderRunsEndpoint, MetorialManagementInstanceProviderSpecificationChangeNotificationsEndpoint, MetorialManagementInstanceProviderTemplatesEndpoint, MetorialManagementInstanceProvidersAuthMethodsEndpoint, MetorialManagementInstanceProvidersEndpoint, MetorialManagementInstanceProvidersSpecificationsEndpoint, MetorialManagementInstanceProvidersToolsEndpoint, MetorialManagementInstanceProvidersTriggersEndpoint, MetorialManagementInstanceProvidersVersionsEndpoint, MetorialManagementInstancePublicMcpServersClientsEndpoint, MetorialManagementInstancePublicMcpServersEndpoint, MetorialManagementInstancePublicMcpServersGrantsEndpoint, MetorialManagementInstancePublicMcpServersSlugsEndpoint, MetorialManagementInstancePublishersEndpoint, MetorialManagementInstanceSandboxDisksEndpoint, MetorialManagementInstanceSandboxDisksMountsEndpoint, MetorialManagementInstanceSandboxDisksResizesEndpoint, MetorialManagementInstanceSandboxImageBuildsEndpoint, MetorialManagementInstanceSandboxImagesBuildsEndpoint, MetorialManagementInstanceSandboxImagesEndpoint, MetorialManagementInstanceSandboxImagesVersionsEndpoint, MetorialManagementInstanceSandboxMachinesAccessEndpoint, MetorialManagementInstanceSandboxMachinesEndpoint, MetorialManagementInstanceSandboxMachinesErrorsEndpoint, MetorialManagementInstanceSandboxMachinesEventsEndpoint, MetorialManagementInstanceSandboxMachinesInstancesEndpoint, MetorialManagementInstanceSandboxMachinesOperationsEndpoint, MetorialManagementInstanceSandboxMachinesUsageEndpoint, MetorialManagementInstanceSandboxRegionsEndpoint, MetorialManagementInstanceSandboxSpecsEndpoint, MetorialManagementInstanceScmAccountsEndpoint, MetorialManagementInstanceScmConnectionsEndpoint, MetorialManagementInstanceScmInstallationEndpoint, MetorialManagementInstanceScmProvidersEndpoint, MetorialManagementInstanceScmReposEndpoint, MetorialManagementInstanceSessionTemplatesEndpoint, MetorialManagementInstanceSessionTemplatesProvidersEndpoint, MetorialManagementInstanceSessionsConnectionsEndpoint, MetorialManagementInstanceSessionsEndpoint, MetorialManagementInstanceSessionsErrorGroupsEndpoint, MetorialManagementInstanceSessionsErrorsEndpoint, MetorialManagementInstanceSessionsEventsEndpoint, MetorialManagementInstanceSessionsMessagesEndpoint, MetorialManagementInstanceSessionsParticipantsEndpoint, MetorialManagementInstanceSessionsProvidersEndpoint, MetorialManagementInstanceSkillsAgentsEndpoint, MetorialManagementInstanceSkillsConfigurationsEndpoint, MetorialManagementInstanceSkillsEndpoint, MetorialManagementInstanceSkillsExportsEndpoint, MetorialManagementInstanceSkillsFilesEndpoint, MetorialManagementInstanceSkillsForkSyncsEndpoint, MetorialManagementInstanceSkillsGroupsEndpoint, MetorialManagementInstanceSkillsGroupsItemsEndpoint, MetorialManagementInstanceSkillsImportsEndpoint, MetorialManagementInstanceSkillsItemsEndpoint, MetorialManagementInstanceSkillsMarketplacesEndpoint, MetorialManagementInstanceSkillsMarketplacesPluginsEndpoint, MetorialManagementInstanceSkillsMarketplacesRepositoriesEndpoint, MetorialManagementInstanceSkillsMergeRequestsCommentsEndpoint, MetorialManagementInstanceSkillsMergeRequestsEndpoint, MetorialManagementInstanceSkillsMergeRequestsEventsEndpoint, MetorialManagementInstanceSkillsMergeRequestsItemsEndpoint, MetorialManagementInstanceSkillsMergeRequestsPlanEndpoint, MetorialManagementInstanceSkillsParticipantsEndpoint, MetorialManagementInstanceSkillsPluginsEndpoint, MetorialManagementInstanceSkillsPluginsRepositoriesEndpoint, MetorialManagementInstanceSkillsPluginsSkillsEndpoint, MetorialManagementInstanceSkillsTemplatesEndpoint, MetorialManagementInstanceSkillsTemplatesItemsEndpoint, MetorialManagementInstanceSkillsVersionsEndpoint, MetorialManagementInstanceSkillsVersionsSnapshotEndpoint, MetorialManagementInstanceStoresEndpoint, MetorialManagementInstanceStoresItemsEndpoint, MetorialManagementInstanceStoresParticipantsEndpoint, MetorialManagementInstanceStoresPermissionsEndpoint, MetorialManagementInstanceToolCallsEndpoint, MetorialManagementInstanceWebhookRegistrationsEndpoint, MetorialManagementOrganizationAccessPoliciesEndpoint, MetorialManagementOrganizationAccessRolesEndpoint, MetorialManagementOrganizationApiKeysEndpoint, MetorialManagementOrganizationAuditLogStreamsEndpoint, MetorialManagementOrganizationAuditLogStreamsEventsEndpoint, MetorialManagementOrganizationAuditLogsEndpoint, MetorialManagementOrganizationEndpoint, MetorialManagementOrganizationEventDeliveriesEndpoint, MetorialManagementOrganizationEventDeliveryAttemptsEndpoint, MetorialManagementOrganizationEventDestinationListenersEndpoint, MetorialManagementOrganizationEventDestinationsEndpoint, MetorialManagementOrganizationEventsEndpoint, MetorialManagementOrganizationInstancesEndpoint, MetorialManagementOrganizationInvitesEndpoint, MetorialManagementOrganizationMembersEndpoint, MetorialManagementOrganizationMembersPoliciesEndpoint, MetorialManagementOrganizationOauthAppsClientSecretsEndpoint, MetorialManagementOrganizationOauthAppsEndpoint, MetorialManagementOrganizationOauthAuthorizationLogsEndpoint, MetorialManagementOrganizationOauthAuthorizationsEndpoint, MetorialManagementOrganizationOauthCliDevicesEndpoint, MetorialManagementOrganizationOauthInstallationsEndpoint, MetorialManagementOrganizationOauthScopesEndpoint, MetorialManagementOrganizationOutpostsAccessEndpoint, MetorialManagementOrganizationOutpostsCredentialsEndpoint, MetorialManagementOrganizationOutpostsEndpoint, MetorialManagementOrganizationProjectsBrandingEndpoint, MetorialManagementOrganizationProjectsEndpoint, MetorialManagementOrganizationSandboxesEndpoint, MetorialManagementOrganizationServiceAccountsClientSecretsEndpoint, MetorialManagementOrganizationServiceAccountsCredentialsEndpoint, MetorialManagementOrganizationServiceAccountsEndpoint, MetorialManagementOrganizationServiceAccountsPoliciesEndpoint, MetorialManagementOrganizationTeamsEndpoint, MetorialManagementOrganizationTeamsMembersEndpoint, MetorialManagementOrganizationTeamsPoliciesEndpoint, MetorialManagementOrganizationWebhookEventsEndpoint, MetorialManagementUserEndpoint, MetorialMonitorAlertsEndpoint, MetorialMonitorsEndpoint, MetorialNetworkPoliciesEndpoint, MetorialNetworkPoliciesRulesEndpoint, MetorialOrganizationsFlagsEndpoint, MetorialOrganizationsProfileEndpoint, MetorialOrganizationsScopesEndpoint, MetorialPortalsAccessEndpoint, MetorialPortalsAccessRequestsEndpoint, MetorialPortalsConsumerGroupsEndpoint, MetorialPortalsConsumerInvitesEndpoint, MetorialPortalsConsumerProfilesEndpoint, MetorialPortalsEndpoint, MetorialPortalsListingsEndpoint, MetorialPortalsSurfaceProviderGroupsEndpoint, MetorialProtoGuardAlertsEndpoint, MetorialProtoGuardConfigEndpoint, MetorialProviderAuthConfigErrorsEndpoint, MetorialProviderAuthConfigErrorsGroupsEndpoint, MetorialProviderAuthConfigEventsEndpoint, MetorialProviderCategoriesEndpoint, MetorialProviderCollectionsEndpoint, MetorialProviderDeploymentsAuthConfigsEndpoint, MetorialProviderDeploymentsAuthConfigsExportsEndpoint, MetorialProviderDeploymentsAuthConfigsImportsEndpoint, MetorialProviderDeploymentsAuthCredentialsEndpoint, MetorialProviderDeploymentsConfigVaultsEndpoint, MetorialProviderDeploymentsConfigsEndpoint, MetorialProviderDeploymentsEndpoint, MetorialProviderDeploymentsSetupSessionsEndpoint, MetorialProviderGroupsEndpoint, MetorialProviderInvocationsEndpoint, MetorialProviderListingsEndpoint, MetorialProviderRunsEndpoint, MetorialProviderSpecificationChangeNotificationsEndpoint, MetorialProviderTemplatesEndpoint, MetorialProvidersAuthMethodsEndpoint, MetorialProvidersEndpoint, MetorialProvidersSpecificationsEndpoint, MetorialProvidersToolsEndpoint, MetorialProvidersTriggersEndpoint, MetorialProvidersVersionsEndpoint, MetorialPublicMcpServersClientsEndpoint, MetorialPublicMcpServersEndpoint, MetorialPublicMcpServersGrantsEndpoint, MetorialPublicMcpServersSlugsEndpoint, MetorialPublishersEndpoint, MetorialSandboxDisksEndpoint, MetorialSandboxDisksMountsEndpoint, MetorialSandboxDisksResizesEndpoint, MetorialSandboxImageBuildsEndpoint, MetorialSandboxImagesBuildsEndpoint, MetorialSandboxImagesEndpoint, MetorialSandboxImagesVersionsEndpoint, MetorialSandboxMachinesAccessEndpoint, MetorialSandboxMachinesEndpoint, MetorialSandboxMachinesErrorsEndpoint, MetorialSandboxMachinesEventsEndpoint, MetorialSandboxMachinesInstancesEndpoint, MetorialSandboxMachinesOperationsEndpoint, MetorialSandboxMachinesUsageEndpoint, MetorialSandboxRegionsEndpoint, MetorialSandboxSpecsEndpoint, MetorialScmAccountsEndpoint, MetorialScmConnectionsEndpoint, MetorialScmInstallationEndpoint, MetorialScmProvidersEndpoint, MetorialScmReposEndpoint, MetorialSessionTemplatesEndpoint, MetorialSessionTemplatesProvidersEndpoint, MetorialSessionsConnectionsEndpoint, MetorialSessionsEndpoint, MetorialSessionsErrorGroupsEndpoint, MetorialSessionsErrorsEndpoint, MetorialSessionsEventsEndpoint, MetorialSessionsMessagesEndpoint, MetorialSessionsParticipantsEndpoint, MetorialSessionsProvidersEndpoint, MetorialSkillsAgentsEndpoint, MetorialSkillsConfigurationsEndpoint, MetorialSkillsEndpoint, MetorialSkillsExportsEndpoint, MetorialSkillsFilesEndpoint, MetorialSkillsForkSyncsEndpoint, MetorialSkillsGroupsEndpoint, MetorialSkillsGroupsItemsEndpoint, MetorialSkillsImportsEndpoint, MetorialSkillsItemsEndpoint, MetorialSkillsMarketplacesEndpoint, MetorialSkillsMarketplacesPluginsEndpoint, MetorialSkillsMarketplacesRepositoriesEndpoint, MetorialSkillsMergeRequestsCommentsEndpoint, MetorialSkillsMergeRequestsEndpoint, MetorialSkillsMergeRequestsEventsEndpoint, MetorialSkillsMergeRequestsItemsEndpoint, MetorialSkillsMergeRequestsPlanEndpoint, MetorialSkillsParticipantsEndpoint, MetorialSkillsPluginsEndpoint, MetorialSkillsPluginsRepositoriesEndpoint, MetorialSkillsPluginsSkillsEndpoint, MetorialSkillsTemplatesEndpoint, MetorialSkillsTemplatesItemsEndpoint, MetorialSkillsVersionsEndpoint, MetorialSkillsVersionsSnapshotEndpoint, MetorialStoresEndpoint, MetorialStoresItemsEndpoint, MetorialStoresParticipantsEndpoint, MetorialStoresPermissionsEndpoint, MetorialTestHelpersConsumerOauthAuthorizationsEndpoint, MetorialToolCallsEndpoint, MetorialWebhookRegistrationsEndpoint, createMetorialDashboardSDK, getUploadFileName, mapAgentsGetOutput, mapAgentsInstancesGetOutput, mapAgentsInstancesListOutput, mapAgentsInstancesListQuery, mapAgentsListOutput, mapAgentsListQuery, mapAssistantsGetOutput, mapAssistantsListOutput, mapAssistantsListQuery, mapCallbackEventsGetOutput, mapCallbackEventsListOutput, mapCallbackEventsListQuery, mapCallbackInstancesGetOutput, mapCallbackInstancesListOutput, mapCallbackInstancesListQuery, mapCallbacksCreateBody, mapCallbacksCreateOutput, mapCallbacksDeleteOutput, mapCallbacksGetOutput, mapCallbacksListOutput, mapCallbacksListQuery, mapCallbacksUpdateBody, mapCallbacksUpdateOutput, mapChatConnectionsCreateBody, mapChatConnectionsCreateOutput, mapChatConnectionsDeleteOutput, mapChatConnectionsGetOutput, mapChatConnectionsListOutput, mapChatConnectionsListQuery, mapChatConnectionsUpdateBody, mapChatConnectionsUpdateOutput, mapChatEventsGetOutput, mapChatEventsListOutput, mapChatEventsListQuery, mapChatInstancesCreateBody, mapChatInstancesCreateOutput, mapChatInstancesDeleteOutput, mapChatInstancesGetOutput, mapChatInstancesListOutput, mapChatInstancesListQuery, mapChatInstancesProviderAuthenticatedUserOutput, mapChatInstancesProviderGetOutput, mapChatInstancesProviderSetBody, mapChatInstancesProviderSetOutput, mapChatInstancesSyncOutput, mapChatInstancesUpdateBody, mapChatInstancesUpdateOutput, mapChatWorkspacesGetOutput, mapChatWorkspacesGetQuery, mapChatWorkspacesListOutput, mapChatWorkspacesListQuery, mapChatsChannelsGetOutput, mapChatsChannelsListOutput, mapChatsChannelsListQuery, mapChatsChannelsMembersGetOutput, mapChatsChannelsMembersListOutput, mapChatsChannelsMembersListQuery, mapChatsChannelsTypingStartBody, mapChatsChannelsTypingStartOutput, mapChatsCommandsRespondBody, mapChatsCommandsRespondOutput, mapChatsDmsOpenBody, mapChatsDmsOpenOutput, mapChatsGetOutput, mapChatsListOutput, mapChatsListQuery, mapChatsMessagesCreateBody, mapChatsMessagesCreateOutput, mapChatsMessagesDeleteOutput, mapChatsMessagesDeleteQuery, mapChatsMessagesGetOutput, mapChatsMessagesGetQuery, mapChatsMessagesListOutput, mapChatsMessagesListQuery, mapChatsMessagesReactionsCreateBody, mapChatsMessagesReactionsCreateOutput, mapChatsMessagesReactionsDeleteOutput, mapChatsMessagesReactionsDeleteQuery, mapChatsMessagesReactionsListOutput, mapChatsMessagesReactionsListQuery, mapChatsMessagesReadBody, mapChatsMessagesReadOutput, mapChatsMessagesUpdateBody, mapChatsMessagesUpdateOutput, mapChatsThreadsGetOutput, mapChatsThreadsGetQuery, mapChatsThreadsListOutput, mapChatsThreadsListQuery, mapConsumerSurfacesGetOutput, mapConsumerSurfacesListOutput, mapConsumerSurfacesListQuery, mapConsumersCreateBody, mapConsumersCreateOutput, mapConsumersGetMemberConsumerBody, mapConsumersGetMemberConsumerOutput, mapConsumersGetOutput, mapConsumersListOutput, mapConsumersListQuery, mapConsumersProfilesGetOutput, mapConsumersProfilesListOutput, mapConsumersProfilesListQuery, mapConsumersUpdateBody, mapConsumersUpdateOutput, mapConversationsCreateBody, mapConversationsCreateOutput, mapConversationsGetOutput, mapConversationsListOutput, mapConversationsListQuery, mapConversationsMessagesCreateBody, mapConversationsMessagesCreateOutput, mapConversationsMessagesGetOutput, mapConversationsMessagesHandoffResponsesBody, mapConversationsMessagesHandoffResponsesOutput, mapConversationsMessagesListOutput, mapConversationsMessagesListQuery, mapConversationsUpdateBody, mapConversationsUpdateOutput, mapCustomProvidersArchiveOutput, mapCustomProvidersCodeGetCodeEditorTokenOutput, mapCustomProvidersCommitsCreateBody, mapCustomProvidersCommitsCreateOutput, mapCustomProvidersCommitsGetOutput, mapCustomProvidersCommitsListOutput, mapCustomProvidersCommitsListQuery, mapCustomProvidersCreateBody, mapCustomProvidersCreateOutput, mapCustomProvidersDeploymentsGetLogsOutput, mapCustomProvidersDeploymentsGetOutput, mapCustomProvidersDeploymentsListOutput, mapCustomProvidersDeploymentsListQuery, mapCustomProvidersEnvironmentsGetOutput, mapCustomProvidersEnvironmentsListOutput, mapCustomProvidersEnvironmentsListQuery, mapCustomProvidersGetEnvOutput, mapCustomProvidersGetOutput, mapCustomProvidersListOutput, mapCustomProvidersListQuery, mapCustomProvidersUpdateBody, mapCustomProvidersUpdateOutput, mapCustomProvidersVersionsCreateBody, mapCustomProvidersVersionsCreateOutput, mapCustomProvidersVersionsGetEnvOutput, mapCustomProvidersVersionsGetOutput, mapCustomProvidersVersionsListOutput, mapCustomProvidersVersionsListQuery, mapDashboardBootBody, mapDashboardBootOutput, mapDashboardInstanceAgentsGetOutput, mapDashboardInstanceAgentsInstancesGetOutput, mapDashboardInstanceAgentsInstancesListOutput, mapDashboardInstanceAgentsInstancesListQuery, mapDashboardInstanceAgentsListOutput, mapDashboardInstanceAgentsListQuery, mapDashboardInstanceAssistantsGetOutput, mapDashboardInstanceAssistantsListOutput, mapDashboardInstanceAssistantsListQuery, mapDashboardInstanceCallbackEventsGetOutput, mapDashboardInstanceCallbackEventsListOutput, mapDashboardInstanceCallbackEventsListQuery, mapDashboardInstanceCallbackInstancesGetOutput, mapDashboardInstanceCallbackInstancesListOutput, mapDashboardInstanceCallbackInstancesListQuery, mapDashboardInstanceCallbacksCreateBody, mapDashboardInstanceCallbacksCreateOutput, mapDashboardInstanceCallbacksDeleteOutput, mapDashboardInstanceCallbacksGetOutput, mapDashboardInstanceCallbacksListOutput, mapDashboardInstanceCallbacksListQuery, mapDashboardInstanceCallbacksUpdateBody, mapDashboardInstanceCallbacksUpdateOutput, mapDashboardInstanceChatConnectionsCreateBody, mapDashboardInstanceChatConnectionsCreateOutput, mapDashboardInstanceChatConnectionsDeleteOutput, mapDashboardInstanceChatConnectionsGetOutput, mapDashboardInstanceChatConnectionsListOutput, mapDashboardInstanceChatConnectionsListQuery, mapDashboardInstanceChatConnectionsUpdateBody, mapDashboardInstanceChatConnectionsUpdateOutput, mapDashboardInstanceChatEventsGetOutput, mapDashboardInstanceChatEventsListOutput, mapDashboardInstanceChatEventsListQuery, mapDashboardInstanceChatInstancesCreateBody, mapDashboardInstanceChatInstancesCreateOutput, mapDashboardInstanceChatInstancesDeleteOutput, mapDashboardInstanceChatInstancesGetOutput, mapDashboardInstanceChatInstancesListOutput, mapDashboardInstanceChatInstancesListQuery, mapDashboardInstanceChatInstancesProviderAuthenticatedUserOutput, mapDashboardInstanceChatInstancesProviderGetOutput, mapDashboardInstanceChatInstancesProviderSetBody, mapDashboardInstanceChatInstancesProviderSetOutput, mapDashboardInstanceChatInstancesSyncOutput, mapDashboardInstanceChatInstancesUpdateBody, mapDashboardInstanceChatInstancesUpdateOutput, mapDashboardInstanceChatWorkspacesGetOutput, mapDashboardInstanceChatWorkspacesGetQuery, mapDashboardInstanceChatWorkspacesListOutput, mapDashboardInstanceChatWorkspacesListQuery, mapDashboardInstanceChatsChannelsGetOutput, mapDashboardInstanceChatsChannelsListOutput, mapDashboardInstanceChatsChannelsListQuery, mapDashboardInstanceChatsChannelsMembersGetOutput, mapDashboardInstanceChatsChannelsMembersListOutput, mapDashboardInstanceChatsChannelsMembersListQuery, mapDashboardInstanceChatsChannelsTypingStartBody, mapDashboardInstanceChatsChannelsTypingStartOutput, mapDashboardInstanceChatsCommandsRespondBody, mapDashboardInstanceChatsCommandsRespondOutput, mapDashboardInstanceChatsDmsOpenBody, mapDashboardInstanceChatsDmsOpenOutput, mapDashboardInstanceChatsGetOutput, mapDashboardInstanceChatsListOutput, mapDashboardInstanceChatsListQuery, mapDashboardInstanceChatsMessagesCreateBody, mapDashboardInstanceChatsMessagesCreateOutput, mapDashboardInstanceChatsMessagesDeleteOutput, mapDashboardInstanceChatsMessagesDeleteQuery, mapDashboardInstanceChatsMessagesGetOutput, mapDashboardInstanceChatsMessagesGetQuery, mapDashboardInstanceChatsMessagesListOutput, mapDashboardInstanceChatsMessagesListQuery, mapDashboardInstanceChatsMessagesReactionsCreateBody, mapDashboardInstanceChatsMessagesReactionsCreateOutput, mapDashboardInstanceChatsMessagesReactionsDeleteOutput, mapDashboardInstanceChatsMessagesReactionsDeleteQuery, mapDashboardInstanceChatsMessagesReactionsListOutput, mapDashboardInstanceChatsMessagesReactionsListQuery, mapDashboardInstanceChatsMessagesReadBody, mapDashboardInstanceChatsMessagesReadOutput, mapDashboardInstanceChatsMessagesUpdateBody, mapDashboardInstanceChatsMessagesUpdateOutput, mapDashboardInstanceChatsThreadsGetOutput, mapDashboardInstanceChatsThreadsGetQuery, mapDashboardInstanceChatsThreadsListOutput, mapDashboardInstanceChatsThreadsListQuery, mapDashboardInstanceConsumerSurfacesGetOutput, mapDashboardInstanceConsumerSurfacesListOutput, mapDashboardInstanceConsumerSurfacesListQuery, mapDashboardInstanceConsumersCreateBody, mapDashboardInstanceConsumersCreateOutput, mapDashboardInstanceConsumersGetMemberConsumerBody, mapDashboardInstanceConsumersGetMemberConsumerOutput, mapDashboardInstanceConsumersGetOutput, mapDashboardInstanceConsumersListOutput, mapDashboardInstanceConsumersListQuery, mapDashboardInstanceConsumersProfilesGetOutput, mapDashboardInstanceConsumersProfilesListOutput, mapDashboardInstanceConsumersProfilesListQuery, mapDashboardInstanceConsumersUpdateBody, mapDashboardInstanceConsumersUpdateOutput, mapDashboardInstanceConversationsCreateBody, mapDashboardInstanceConversationsCreateOutput, mapDashboardInstanceConversationsGetOutput, mapDashboardInstanceConversationsListOutput, mapDashboardInstanceConversationsListQuery, mapDashboardInstanceConversationsMessagesCreateBody, mapDashboardInstanceConversationsMessagesCreateOutput, mapDashboardInstanceConversationsMessagesGetOutput, mapDashboardInstanceConversationsMessagesHandoffResponsesBody, mapDashboardInstanceConversationsMessagesHandoffResponsesOutput, mapDashboardInstanceConversationsMessagesListOutput, mapDashboardInstanceConversationsMessagesListQuery, mapDashboardInstanceConversationsUpdateBody, mapDashboardInstanceConversationsUpdateOutput, mapDashboardInstanceCustomProvidersArchiveOutput, mapDashboardInstanceCustomProvidersCodeGetCodeEditorTokenOutput, mapDashboardInstanceCustomProvidersCommitsCreateBody, mapDashboardInstanceCustomProvidersCommitsCreateOutput, mapDashboardInstanceCustomProvidersCommitsGetOutput, mapDashboardInstanceCustomProvidersCommitsListOutput, mapDashboardInstanceCustomProvidersCommitsListQuery, mapDashboardInstanceCustomProvidersCreateBody, mapDashboardInstanceCustomProvidersCreateOutput, mapDashboardInstanceCustomProvidersDeploymentsGetLogsOutput, mapDashboardInstanceCustomProvidersDeploymentsGetOutput, mapDashboardInstanceCustomProvidersDeploymentsListOutput, mapDashboardInstanceCustomProvidersDeploymentsListQuery, mapDashboardInstanceCustomProvidersEnvironmentsGetOutput, mapDashboardInstanceCustomProvidersEnvironmentsListOutput, mapDashboardInstanceCustomProvidersEnvironmentsListQuery, mapDashboardInstanceCustomProvidersGetEnvOutput, mapDashboardInstanceCustomProvidersGetOutput, mapDashboardInstanceCustomProvidersListOutput, mapDashboardInstanceCustomProvidersListQuery, mapDashboardInstanceCustomProvidersUpdateBody, mapDashboardInstanceCustomProvidersUpdateOutput, mapDashboardInstanceCustomProvidersVersionsCreateBody, mapDashboardInstanceCustomProvidersVersionsCreateOutput, mapDashboardInstanceCustomProvidersVersionsGetEnvOutput, mapDashboardInstanceCustomProvidersVersionsGetOutput, mapDashboardInstanceCustomProvidersVersionsListOutput, mapDashboardInstanceCustomProvidersVersionsListQuery, mapDashboardInstanceDocumentsCloneBody, mapDashboardInstanceDocumentsCloneOutput, mapDashboardInstanceDocumentsCreateBody, mapDashboardInstanceDocumentsCreateOutput, mapDashboardInstanceDocumentsDeleteOutput, mapDashboardInstanceDocumentsEditTokenGetOutput, mapDashboardInstanceDocumentsGetOutput, mapDashboardInstanceDocumentsListOutput, mapDashboardInstanceDocumentsListQuery, mapDashboardInstanceDocumentsParticipantsGetOutput, mapDashboardInstanceDocumentsParticipantsListOutput, mapDashboardInstanceDocumentsParticipantsListQuery, mapDashboardInstanceDocumentsPermissionsGetOutput, mapDashboardInstanceDocumentsUpdateBody, mapDashboardInstanceDocumentsUpdateOutput, mapDashboardInstanceDocumentsVersionsGetOutput, mapDashboardInstanceDocumentsVersionsListOutput, mapDashboardInstanceDocumentsVersionsListQuery, mapDashboardInstanceFilesDeleteOutput, mapDashboardInstanceFilesGetOutput, mapDashboardInstanceFilesLinksCreateBody, mapDashboardInstanceFilesLinksCreateOutput, mapDashboardInstanceFilesLinksDeleteOutput, mapDashboardInstanceFilesLinksGetOutput, mapDashboardInstanceFilesLinksListOutput, mapDashboardInstanceFilesLinksListQuery, mapDashboardInstanceFilesListOutput, mapDashboardInstanceFilesListQuery, mapDashboardInstanceFirewallsCreateBody, mapDashboardInstanceFirewallsCreateOutput, mapDashboardInstanceFirewallsDeleteOutput, mapDashboardInstanceFirewallsGetOutput, mapDashboardInstanceFirewallsListOutput, mapDashboardInstanceFirewallsListQuery, mapDashboardInstanceFirewallsNetworkPoliciesAttachBody, mapDashboardInstanceFirewallsNetworkPoliciesAttachOutput, mapDashboardInstanceFirewallsNetworkPoliciesDetachOutput, mapDashboardInstanceFirewallsUpdateBody, mapDashboardInstanceFirewallsUpdateOutput, mapDashboardInstanceIdentitiesCreateBody, mapDashboardInstanceIdentitiesCreateOutput, mapDashboardInstanceIdentitiesCredentialsCreateBody, mapDashboardInstanceIdentitiesCredentialsCreateOutput, mapDashboardInstanceIdentitiesCredentialsDeleteOutput, mapDashboardInstanceIdentitiesCredentialsGetOutput, mapDashboardInstanceIdentitiesCredentialsListOutput, mapDashboardInstanceIdentitiesCredentialsListQuery, mapDashboardInstanceIdentitiesCredentialsUpdateBody, mapDashboardInstanceIdentitiesCredentialsUpdateOutput, mapDashboardInstanceIdentitiesDelegationConfigsCreateBody, mapDashboardInstanceIdentitiesDelegationConfigsCreateOutput, mapDashboardInstanceIdentitiesDelegationConfigsDeleteOutput, mapDashboardInstanceIdentitiesDelegationConfigsGetOutput, mapDashboardInstanceIdentitiesDelegationConfigsListOutput, mapDashboardInstanceIdentitiesDelegationConfigsListQuery, mapDashboardInstanceIdentitiesDelegationConfigsUpdateBody, mapDashboardInstanceIdentitiesDelegationConfigsUpdateOutput, mapDashboardInstanceIdentitiesDelegationRequestsApproveOutput, mapDashboardInstanceIdentitiesDelegationRequestsApproveQuery, mapDashboardInstanceIdentitiesDelegationRequestsCreateBody, mapDashboardInstanceIdentitiesDelegationRequestsCreateOutput, mapDashboardInstanceIdentitiesDelegationRequestsDenyOutput, mapDashboardInstanceIdentitiesDelegationRequestsDenyQuery, mapDashboardInstanceIdentitiesDelegationRequestsGetOutput, mapDashboardInstanceIdentitiesDelegationRequestsGetQuery, mapDashboardInstanceIdentitiesDelegationRequestsListOutput, mapDashboardInstanceIdentitiesDelegationRequestsListQuery, mapDashboardInstanceIdentitiesDelegationsCreateBody, mapDashboardInstanceIdentitiesDelegationsCreateOutput, mapDashboardInstanceIdentitiesDelegationsGetOutput, mapDashboardInstanceIdentitiesDelegationsListOutput, mapDashboardInstanceIdentitiesDelegationsListQuery, mapDashboardInstanceIdentitiesDelegationsRevokeOutput, mapDashboardInstanceIdentitiesDeleteOutput, mapDashboardInstanceIdentitiesGetOutput, mapDashboardInstanceIdentitiesListOutput, mapDashboardInstanceIdentitiesListQuery, mapDashboardInstanceIdentitiesUpdateBody, mapDashboardInstanceIdentitiesUpdateOutput, mapDashboardInstanceIdentityActorsCreateBody, mapDashboardInstanceIdentityActorsCreateOutput, mapDashboardInstanceIdentityActorsDeleteOutput, mapDashboardInstanceIdentityActorsGetOutput, mapDashboardInstanceIdentityActorsListOutput, mapDashboardInstanceIdentityActorsListQuery, mapDashboardInstanceIdentityActorsUpdateBody, mapDashboardInstanceIdentityActorsUpdateOutput, mapDashboardInstanceIncomingWebhooksGetOutput, mapDashboardInstanceIncomingWebhooksListOutput, mapDashboardInstanceIncomingWebhooksListQuery, mapDashboardInstanceIntegrationEnclavesGetLastUsedOutput, mapDashboardInstanceIntegrationEnclavesGetLastUsedQuery, mapDashboardInstanceIntegrationEnclavesGetOutput, mapDashboardInstanceIntegrationEnclavesListOutput, mapDashboardInstanceIntegrationEnclavesListQuery, mapDashboardInstanceIntegrationFirewallAssignmentsCreateBody, mapDashboardInstanceIntegrationFirewallAssignmentsCreateOutput, mapDashboardInstanceIntegrationFirewallAssignmentsDeleteOutput, mapDashboardInstanceIntegrationFirewallAssignmentsGetOutput, mapDashboardInstanceIntegrationFirewallAssignmentsListOutput, mapDashboardInstanceIntegrationFirewallAssignmentsListQuery, mapDashboardInstanceIntegrationInternetGatewayGetOutput, mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsOutput, mapDashboardInstanceIntegrationInternetGatewayListNetworkLogsQuery, mapDashboardInstanceIntegrationsCreateBody, mapDashboardInstanceIntegrationsCreateOutput, mapDashboardInstanceIntegrationsDeleteOutput, mapDashboardInstanceIntegrationsGetOutput, mapDashboardInstanceIntegrationsInstanceGroupsCreateBody, mapDashboardInstanceIntegrationsInstanceGroupsCreateOutput, mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionBody, mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionOutput, mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody, mapDashboardInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput, mapDashboardInstanceIntegrationsInstanceGroupsDeleteOutput, mapDashboardInstanceIntegrationsInstanceGroupsGetOutput, mapDashboardInstanceIntegrationsInstanceGroupsListOutput, mapDashboardInstanceIntegrationsInstanceGroupsListQuery, mapDashboardInstanceIntegrationsInstanceGroupsProvidersDeleteOutput, mapDashboardInstanceIntegrationsInstanceGroupsProvidersGetOutput, mapDashboardInstanceIntegrationsInstanceGroupsProvidersListOutput, mapDashboardInstanceIntegrationsInstanceGroupsProvidersListQuery, mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetBody, mapDashboardInstanceIntegrationsInstanceGroupsProvidersSetOutput, mapDashboardInstanceIntegrationsInstanceGroupsUpdateBody, mapDashboardInstanceIntegrationsInstanceGroupsUpdateOutput, mapDashboardInstanceIntegrationsInstancesCreateBody, mapDashboardInstanceIntegrationsInstancesCreateOutput, mapDashboardInstanceIntegrationsInstancesCreateSessionBody, mapDashboardInstanceIntegrationsInstancesCreateSessionOutput, mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateBody, mapDashboardInstanceIntegrationsInstancesCreateSessionTemplateOutput, mapDashboardInstanceIntegrationsInstancesDeleteOutput, mapDashboardInstanceIntegrationsInstancesGetOutput, mapDashboardInstanceIntegrationsInstancesListOutput, mapDashboardInstanceIntegrationsInstancesListQuery, mapDashboardInstanceIntegrationsInstancesProvidersGetOutput, mapDashboardInstanceIntegrationsInstancesProvidersListOutput, mapDashboardInstanceIntegrationsInstancesProvidersListQuery, mapDashboardInstanceIntegrationsInstancesProvidersSetBody, mapDashboardInstanceIntegrationsInstancesProvidersSetOutput, mapDashboardInstanceIntegrationsInstancesUpdateBody, mapDashboardInstanceIntegrationsInstancesUpdateOutput, mapDashboardInstanceIntegrationsListOutput, mapDashboardInstanceIntegrationsListQuery, mapDashboardInstanceIntegrationsProvidersCreateBody, mapDashboardInstanceIntegrationsProvidersCreateOutput, mapDashboardInstanceIntegrationsProvidersDeleteOutput, mapDashboardInstanceIntegrationsProvidersGetOutput, mapDashboardInstanceIntegrationsProvidersListOutput, mapDashboardInstanceIntegrationsProvidersListQuery, mapDashboardInstanceIntegrationsProvidersUpdateBody, mapDashboardInstanceIntegrationsProvidersUpdateOutput, mapDashboardInstanceIntegrationsSetupSessionsCreateBody, mapDashboardInstanceIntegrationsSetupSessionsCreateOutput, mapDashboardInstanceIntegrationsSetupSessionsGetOutput, mapDashboardInstanceIntegrationsSetupSessionsListOutput, mapDashboardInstanceIntegrationsSetupSessionsListQuery, mapDashboardInstanceIntegrationsUpdateBody, mapDashboardInstanceIntegrationsUpdateOutput, mapDashboardInstanceMagicMcpEndpointsAddServersBody, mapDashboardInstanceMagicMcpEndpointsAddServersOutput, mapDashboardInstanceMagicMcpEndpointsCreateBody, mapDashboardInstanceMagicMcpEndpointsCreateOutput, mapDashboardInstanceMagicMcpEndpointsDeleteOutput, mapDashboardInstanceMagicMcpEndpointsGetOutput, mapDashboardInstanceMagicMcpEndpointsListOutput, mapDashboardInstanceMagicMcpEndpointsListQuery, mapDashboardInstanceMagicMcpEndpointsRemoveServersBody, mapDashboardInstanceMagicMcpEndpointsRemoveServersOutput, mapDashboardInstanceMagicMcpEndpointsUpdateBody, mapDashboardInstanceMagicMcpEndpointsUpdateOutput, mapDashboardInstanceMagicMcpGroupsAddServersBody, mapDashboardInstanceMagicMcpGroupsAddServersOutput, mapDashboardInstanceMagicMcpGroupsCreateBody, mapDashboardInstanceMagicMcpGroupsCreateOutput, mapDashboardInstanceMagicMcpGroupsDeleteOutput, mapDashboardInstanceMagicMcpGroupsGetOutput, mapDashboardInstanceMagicMcpGroupsListOutput, mapDashboardInstanceMagicMcpGroupsListQuery, mapDashboardInstanceMagicMcpGroupsRemoveServersBody, mapDashboardInstanceMagicMcpGroupsRemoveServersOutput, mapDashboardInstanceMagicMcpGroupsUpdateBody, mapDashboardInstanceMagicMcpGroupsUpdateOutput, mapDashboardInstanceMagicMcpServersCreateBody, mapDashboardInstanceMagicMcpServersCreateOutput, mapDashboardInstanceMagicMcpServersDeleteOutput, mapDashboardInstanceMagicMcpServersGetOutput, mapDashboardInstanceMagicMcpServersListOutput, mapDashboardInstanceMagicMcpServersListQuery, mapDashboardInstanceMagicMcpServersProvidersCreateBody, mapDashboardInstanceMagicMcpServersProvidersCreateOutput, mapDashboardInstanceMagicMcpServersProvidersDeleteOutput, mapDashboardInstanceMagicMcpServersProvidersGetOutput, mapDashboardInstanceMagicMcpServersProvidersListOutput, mapDashboardInstanceMagicMcpServersProvidersListQuery, mapDashboardInstanceMagicMcpServersProvidersUpdateBody, mapDashboardInstanceMagicMcpServersProvidersUpdateOutput, mapDashboardInstanceMagicMcpServersSessionCreateOutput, mapDashboardInstanceMagicMcpServersToolsOutput, mapDashboardInstanceMagicMcpServersUpdateBody, mapDashboardInstanceMagicMcpServersUpdateOutput, mapDashboardInstanceMagicMcpSessionsGetOutput, mapDashboardInstanceMagicMcpSessionsListOutput, mapDashboardInstanceMagicMcpSessionsListQuery, mapDashboardInstanceMagicMcpTokensAddGroupsBody, mapDashboardInstanceMagicMcpTokensAddGroupsOutput, mapDashboardInstanceMagicMcpTokensCreateBody, mapDashboardInstanceMagicMcpTokensCreateOutput, mapDashboardInstanceMagicMcpTokensDeleteOutput, mapDashboardInstanceMagicMcpTokensGetOutput, mapDashboardInstanceMagicMcpTokensListOutput, mapDashboardInstanceMagicMcpTokensListQuery, mapDashboardInstanceMagicMcpTokensRemoveGroupsBody, mapDashboardInstanceMagicMcpTokensRemoveGroupsOutput, mapDashboardInstanceMagicMcpTokensUpdateBody, mapDashboardInstanceMagicMcpTokensUpdateOutput, mapDashboardInstanceMonitorAlertsGetOutput, mapDashboardInstanceMonitorAlertsListOutput, mapDashboardInstanceMonitorAlertsListQuery, mapDashboardInstanceMonitorAlertsResolveOutput, mapDashboardInstanceMonitorAlertsUnresolveOutput, mapDashboardInstanceMonitorAlertsViewedOutput, mapDashboardInstanceMonitorsGetOutput, mapDashboardInstanceMonitorsListOutput, mapDashboardInstanceMonitorsListQuery, mapDashboardInstanceNetworkPoliciesCreateBody, mapDashboardInstanceNetworkPoliciesCreateOutput, mapDashboardInstanceNetworkPoliciesDeleteOutput, mapDashboardInstanceNetworkPoliciesGetOutput, mapDashboardInstanceNetworkPoliciesListOutput, mapDashboardInstanceNetworkPoliciesListQuery, mapDashboardInstanceNetworkPoliciesRulesCreateBody, mapDashboardInstanceNetworkPoliciesRulesCreateOutput, mapDashboardInstanceNetworkPoliciesRulesDeleteOutput, mapDashboardInstanceNetworkPoliciesRulesUpdateBody, mapDashboardInstanceNetworkPoliciesRulesUpdateOutput, mapDashboardInstanceNetworkPoliciesUpdateBody, mapDashboardInstanceNetworkPoliciesUpdateOutput, mapDashboardInstancePortalsAccessCreateBody, mapDashboardInstancePortalsAccessCreateOutput, mapDashboardInstancePortalsAccessDeleteOutput, mapDashboardInstancePortalsAccessGetOutput, mapDashboardInstancePortalsAccessListOutput, mapDashboardInstancePortalsAccessListQuery, mapDashboardInstancePortalsAccessRequestsGetOutput, mapDashboardInstancePortalsAccessRequestsListOutput, mapDashboardInstancePortalsAccessRequestsListQuery, mapDashboardInstancePortalsAccessRequestsUpdateBody, mapDashboardInstancePortalsAccessRequestsUpdateOutput, mapDashboardInstancePortalsAccessUpdateBody, mapDashboardInstancePortalsAccessUpdateOutput, mapDashboardInstancePortalsConsumerGroupsCreateBody, mapDashboardInstancePortalsConsumerGroupsCreateOutput, mapDashboardInstancePortalsConsumerGroupsDeleteOutput, mapDashboardInstancePortalsConsumerGroupsGetOutput, mapDashboardInstancePortalsConsumerGroupsListOutput, mapDashboardInstancePortalsConsumerGroupsListQuery, mapDashboardInstancePortalsConsumerGroupsUpdateBody, mapDashboardInstancePortalsConsumerGroupsUpdateOutput, mapDashboardInstancePortalsConsumerInvitesCreateBody, mapDashboardInstancePortalsConsumerInvitesCreateOutput, mapDashboardInstancePortalsConsumerInvitesGetOutput, mapDashboardInstancePortalsConsumerInvitesListOutput, mapDashboardInstancePortalsConsumerInvitesListQuery, mapDashboardInstancePortalsConsumerProfilesAssignGroupsBody, mapDashboardInstancePortalsConsumerProfilesAssignGroupsOutput, mapDashboardInstancePortalsConsumerProfilesCreateBody, mapDashboardInstancePortalsConsumerProfilesCreateOutput, mapDashboardInstancePortalsConsumerProfilesDeleteOutput, mapDashboardInstancePortalsConsumerProfilesGetOutput, mapDashboardInstancePortalsConsumerProfilesListOutput, mapDashboardInstancePortalsConsumerProfilesListQuery, mapDashboardInstancePortalsConsumerProfilesUnassignGroupsBody, mapDashboardInstancePortalsConsumerProfilesUnassignGroupsOutput, mapDashboardInstancePortalsCreateBody, mapDashboardInstancePortalsCreateOutput, mapDashboardInstancePortalsDeleteOutput, mapDashboardInstancePortalsGetOutput, mapDashboardInstancePortalsListOutput, mapDashboardInstancePortalsListQuery, mapDashboardInstancePortalsListingsCreateBody, mapDashboardInstancePortalsListingsCreateOutput, mapDashboardInstancePortalsListingsDeleteOutput, mapDashboardInstancePortalsListingsGetOutput, mapDashboardInstancePortalsListingsListOutput, mapDashboardInstancePortalsListingsListQuery, mapDashboardInstancePortalsListingsUpdateBody, mapDashboardInstancePortalsListingsUpdateOutput, mapDashboardInstancePortalsSurfaceProviderGroupsAddListingBody, mapDashboardInstancePortalsSurfaceProviderGroupsAddListingOutput, mapDashboardInstancePortalsSurfaceProviderGroupsCreateBody, mapDashboardInstancePortalsSurfaceProviderGroupsCreateOutput, mapDashboardInstancePortalsSurfaceProviderGroupsDeleteOutput, mapDashboardInstancePortalsSurfaceProviderGroupsGetOutput, mapDashboardInstancePortalsSurfaceProviderGroupsListOutput, mapDashboardInstancePortalsSurfaceProviderGroupsListQuery, mapDashboardInstancePortalsSurfaceProviderGroupsRemoveListingOutput, mapDashboardInstancePortalsSurfaceProviderGroupsUpdateBody, mapDashboardInstancePortalsSurfaceProviderGroupsUpdateOutput, mapDashboardInstancePortalsUpdateBody, mapDashboardInstancePortalsUpdateOutput, mapDashboardInstanceProtoGuardAlertsGetOutput, mapDashboardInstanceProtoGuardAlertsListOutput, mapDashboardInstanceProtoGuardAlertsListQuery, mapDashboardInstanceProtoGuardConfigGetOutput, mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdBody, mapDashboardInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput, mapDashboardInstanceProtoGuardConfigUpdateFilterBody, mapDashboardInstanceProtoGuardConfigUpdateFilterOutput, mapDashboardInstanceProviderAuthConfigErrorsGetOutput, mapDashboardInstanceProviderAuthConfigErrorsGroupsGetOutput, mapDashboardInstanceProviderAuthConfigErrorsGroupsListOutput, mapDashboardInstanceProviderAuthConfigErrorsGroupsListQuery, mapDashboardInstanceProviderAuthConfigErrorsListOutput, mapDashboardInstanceProviderAuthConfigErrorsListQuery, mapDashboardInstanceProviderAuthConfigEventsGetOutput, mapDashboardInstanceProviderAuthConfigEventsListOutput, mapDashboardInstanceProviderAuthConfigEventsListQuery, mapDashboardInstanceProviderCategoriesGetOutput, mapDashboardInstanceProviderCategoriesListOutput, mapDashboardInstanceProviderCategoriesListQuery, mapDashboardInstanceProviderCollectionsGetOutput, mapDashboardInstanceProviderCollectionsListOutput, mapDashboardInstanceProviderCollectionsListQuery, mapDashboardInstanceProviderDeploymentsAuthConfigsCreateBody, mapDashboardInstanceProviderDeploymentsAuthConfigsCreateOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsDeleteOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateBody, mapDashboardInstanceProviderDeploymentsAuthConfigsExportsCreateOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsExportsGetOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsExportsListQuery, mapDashboardInstanceProviderDeploymentsAuthConfigsGetOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateBody, mapDashboardInstanceProviderDeploymentsAuthConfigsImportsCreateOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery, mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsImportsListQuery, mapDashboardInstanceProviderDeploymentsAuthConfigsListOutput, mapDashboardInstanceProviderDeploymentsAuthConfigsListQuery, mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateBody, mapDashboardInstanceProviderDeploymentsAuthConfigsUpdateOutput, mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateBody, mapDashboardInstanceProviderDeploymentsAuthCredentialsCreateOutput, mapDashboardInstanceProviderDeploymentsAuthCredentialsDeleteOutput, mapDashboardInstanceProviderDeploymentsAuthCredentialsGetOutput, mapDashboardInstanceProviderDeploymentsAuthCredentialsListOutput, mapDashboardInstanceProviderDeploymentsAuthCredentialsListQuery, mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateBody, mapDashboardInstanceProviderDeploymentsAuthCredentialsUpdateOutput, mapDashboardInstanceProviderDeploymentsConfigVaultsCreateBody, mapDashboardInstanceProviderDeploymentsConfigVaultsCreateOutput, mapDashboardInstanceProviderDeploymentsConfigVaultsDeleteOutput, mapDashboardInstanceProviderDeploymentsConfigVaultsGetOutput, mapDashboardInstanceProviderDeploymentsConfigVaultsListOutput, mapDashboardInstanceProviderDeploymentsConfigVaultsListQuery, mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateBody, mapDashboardInstanceProviderDeploymentsConfigVaultsUpdateOutput, mapDashboardInstanceProviderDeploymentsConfigsCreateBody, mapDashboardInstanceProviderDeploymentsConfigsCreateOutput, mapDashboardInstanceProviderDeploymentsConfigsDeleteOutput, mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaOutput, mapDashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery, mapDashboardInstanceProviderDeploymentsConfigsGetOutput, mapDashboardInstanceProviderDeploymentsConfigsGetValueOutput, mapDashboardInstanceProviderDeploymentsConfigsListOutput, mapDashboardInstanceProviderDeploymentsConfigsListQuery, mapDashboardInstanceProviderDeploymentsConfigsUpdateBody, mapDashboardInstanceProviderDeploymentsConfigsUpdateOutput, mapDashboardInstanceProviderDeploymentsCreateBody, mapDashboardInstanceProviderDeploymentsCreateOutput, mapDashboardInstanceProviderDeploymentsDeleteOutput, mapDashboardInstanceProviderDeploymentsGetOutput, mapDashboardInstanceProviderDeploymentsListOutput, mapDashboardInstanceProviderDeploymentsListQuery, mapDashboardInstanceProviderDeploymentsSetupSessionsCreateBody, mapDashboardInstanceProviderDeploymentsSetupSessionsCreateOutput, mapDashboardInstanceProviderDeploymentsSetupSessionsDeleteOutput, mapDashboardInstanceProviderDeploymentsSetupSessionsGetOutput, mapDashboardInstanceProviderDeploymentsSetupSessionsListOutput, mapDashboardInstanceProviderDeploymentsSetupSessionsListQuery, mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateBody, mapDashboardInstanceProviderDeploymentsSetupSessionsUpdateOutput, mapDashboardInstanceProviderDeploymentsUpdateBody, mapDashboardInstanceProviderDeploymentsUpdateOutput, mapDashboardInstanceProviderGroupsAddListingBody, mapDashboardInstanceProviderGroupsAddListingOutput, mapDashboardInstanceProviderGroupsCreateBody, mapDashboardInstanceProviderGroupsCreateOutput, mapDashboardInstanceProviderGroupsGetOutput, mapDashboardInstanceProviderGroupsListOutput, mapDashboardInstanceProviderGroupsListQuery, mapDashboardInstanceProviderGroupsRemoveListingOutput, mapDashboardInstanceProviderGroupsUpdateBody, mapDashboardInstanceProviderGroupsUpdateOutput, mapDashboardInstanceProviderInvocationsGetOutput, mapDashboardInstanceProviderInvocationsListOutput, mapDashboardInstanceProviderInvocationsListQuery, mapDashboardInstanceProviderListingsGetOutput, mapDashboardInstanceProviderListingsListOutput, mapDashboardInstanceProviderListingsListQuery, mapDashboardInstanceProviderListingsResetOutput, mapDashboardInstanceProviderListingsUpdateBody, mapDashboardInstanceProviderListingsUpdateOutput, mapDashboardInstanceProviderRunsGetLogsOutput, mapDashboardInstanceProviderRunsGetOutput, mapDashboardInstanceProviderRunsListOutput, mapDashboardInstanceProviderRunsListQuery, mapDashboardInstanceProviderSpecificationChangeNotificationsGetOutput, mapDashboardInstanceProviderSpecificationChangeNotificationsListOutput, mapDashboardInstanceProviderSpecificationChangeNotificationsListQuery, mapDashboardInstanceProviderTemplatesCreateBody, mapDashboardInstanceProviderTemplatesCreateOutput, mapDashboardInstanceProviderTemplatesDeleteOutput, mapDashboardInstanceProviderTemplatesGetOutput, mapDashboardInstanceProviderTemplatesListOutput, mapDashboardInstanceProviderTemplatesListQuery, mapDashboardInstanceProviderTemplatesUpdateBody, mapDashboardInstanceProviderTemplatesUpdateOutput, mapDashboardInstanceProvidersAuthMethodsGetOutput, mapDashboardInstanceProvidersAuthMethodsListOutput, mapDashboardInstanceProvidersAuthMethodsListQuery, mapDashboardInstanceProvidersGetOutput, mapDashboardInstanceProvidersListOutput, mapDashboardInstanceProvidersListQuery, mapDashboardInstanceProvidersSpecificationsGetOutput, mapDashboardInstanceProvidersSpecificationsListOutput, mapDashboardInstanceProvidersSpecificationsListQuery, mapDashboardInstanceProvidersToolsGetOutput, mapDashboardInstanceProvidersToolsListOutput, mapDashboardInstanceProvidersToolsListQuery, mapDashboardInstanceProvidersTriggersGetOutput, mapDashboardInstanceProvidersTriggersListOutput, mapDashboardInstanceProvidersTriggersListQuery, mapDashboardInstanceProvidersVersionsGetOutput, mapDashboardInstanceProvidersVersionsListOutput, mapDashboardInstanceProvidersVersionsListQuery, mapDashboardInstancePublicMcpServersClientsListOutput, mapDashboardInstancePublicMcpServersClientsListQuery, mapDashboardInstancePublicMcpServersCreateBody, mapDashboardInstancePublicMcpServersCreateOutput, mapDashboardInstancePublicMcpServersDeleteOutput, mapDashboardInstancePublicMcpServersGetOutput, mapDashboardInstancePublicMcpServersGrantsGetOutput, mapDashboardInstancePublicMcpServersGrantsListOutput, mapDashboardInstancePublicMcpServersGrantsListQuery, mapDashboardInstancePublicMcpServersGrantsRevokeOutput, mapDashboardInstancePublicMcpServersListOutput, mapDashboardInstancePublicMcpServersListQuery, mapDashboardInstancePublicMcpServersSlugsCheckOutput, mapDashboardInstancePublicMcpServersSlugsCheckQuery, mapDashboardInstancePublicMcpServersUpdateBody, mapDashboardInstancePublicMcpServersUpdateOutput, mapDashboardInstancePublishersGetOutput, mapDashboardInstancePublishersListOutput, mapDashboardInstancePublishersListQuery, mapDashboardInstanceSandboxDisksCloneBody, mapDashboardInstanceSandboxDisksCloneOutput, mapDashboardInstanceSandboxDisksCreateBody, mapDashboardInstanceSandboxDisksCreateOutput, mapDashboardInstanceSandboxDisksDeleteOutput, mapDashboardInstanceSandboxDisksGetOutput, mapDashboardInstanceSandboxDisksListOutput, mapDashboardInstanceSandboxDisksListQuery, mapDashboardInstanceSandboxDisksMountsListOutput, mapDashboardInstanceSandboxDisksMountsListQuery, mapDashboardInstanceSandboxDisksResizeBody, mapDashboardInstanceSandboxDisksResizeOutput, mapDashboardInstanceSandboxDisksResizesGetOutput, mapDashboardInstanceSandboxDisksResizesListOutput, mapDashboardInstanceSandboxDisksResizesListQuery, mapDashboardInstanceSandboxDisksResizesRetryOutput, mapDashboardInstanceSandboxDisksUpdateBody, mapDashboardInstanceSandboxDisksUpdateOutput, mapDashboardInstanceSandboxImageBuildsCancelOutput, mapDashboardInstanceSandboxImageBuildsGetOutput, mapDashboardInstanceSandboxImageBuildsListOutput, mapDashboardInstanceSandboxImageBuildsListQuery, mapDashboardInstanceSandboxImageBuildsLogsOutput, mapDashboardInstanceSandboxImageBuildsLogsQuery, mapDashboardInstanceSandboxImagesBuildsCreateBody, mapDashboardInstanceSandboxImagesBuildsCreateOutput, mapDashboardInstanceSandboxImagesBuildsListOutput, mapDashboardInstanceSandboxImagesBuildsListQuery, mapDashboardInstanceSandboxImagesCreateBody, mapDashboardInstanceSandboxImagesCreateOutput, mapDashboardInstanceSandboxImagesDeleteOutput, mapDashboardInstanceSandboxImagesGetOutput, mapDashboardInstanceSandboxImagesListOutput, mapDashboardInstanceSandboxImagesListQuery, mapDashboardInstanceSandboxImagesUpdateBody, mapDashboardInstanceSandboxImagesUpdateOutput, mapDashboardInstanceSandboxImagesVersionsGetOutput, mapDashboardInstanceSandboxImagesVersionsListOutput, mapDashboardInstanceSandboxImagesVersionsListQuery, mapDashboardInstanceSandboxMachinesAccessFilesBody, mapDashboardInstanceSandboxMachinesAccessFilesOutput, mapDashboardInstanceSandboxMachinesAccessPortsBody, mapDashboardInstanceSandboxMachinesAccessPortsOutput, mapDashboardInstanceSandboxMachinesAccessShellBody, mapDashboardInstanceSandboxMachinesAccessShellOutput, mapDashboardInstanceSandboxMachinesCreateBody, mapDashboardInstanceSandboxMachinesCreateOutput, mapDashboardInstanceSandboxMachinesDeleteOutput, mapDashboardInstanceSandboxMachinesErrorsGetOutput, mapDashboardInstanceSandboxMachinesErrorsListOutput, mapDashboardInstanceSandboxMachinesErrorsListQuery, mapDashboardInstanceSandboxMachinesEventsGetOutput, mapDashboardInstanceSandboxMachinesEventsListOutput, mapDashboardInstanceSandboxMachinesEventsListQuery, mapDashboardInstanceSandboxMachinesExecBody, mapDashboardInstanceSandboxMachinesExecOutput, mapDashboardInstanceSandboxMachinesGetOutput, mapDashboardInstanceSandboxMachinesHibernateOutput, mapDashboardInstanceSandboxMachinesInstancesGetOutput, mapDashboardInstanceSandboxMachinesInstancesListOutput, mapDashboardInstanceSandboxMachinesInstancesListQuery, mapDashboardInstanceSandboxMachinesInstancesLogsOutput, mapDashboardInstanceSandboxMachinesInstancesLogsQuery, mapDashboardInstanceSandboxMachinesListOutput, mapDashboardInstanceSandboxMachinesListQuery, mapDashboardInstanceSandboxMachinesOperationsGetOutput, mapDashboardInstanceSandboxMachinesOperationsListOutput, mapDashboardInstanceSandboxMachinesOperationsListQuery, mapDashboardInstanceSandboxMachinesPauseOutput, mapDashboardInstanceSandboxMachinesRestartOutput, mapDashboardInstanceSandboxMachinesStartOutput, mapDashboardInstanceSandboxMachinesTouchOutput, mapDashboardInstanceSandboxMachinesUpdateBody, mapDashboardInstanceSandboxMachinesUpdateOutput, mapDashboardInstanceSandboxMachinesUsageOutput, mapDashboardInstanceSandboxMachinesUsageQuery, mapDashboardInstanceSandboxMachinesUsageSummaryOutput, mapDashboardInstanceSandboxMachinesUsageSummaryQuery, mapDashboardInstanceSandboxMachinesUsageTimelineOutput, mapDashboardInstanceSandboxMachinesUsageTimelineQuery, mapDashboardInstanceSandboxRegionsGetOutput, mapDashboardInstanceSandboxRegionsListOutput, mapDashboardInstanceSandboxRegionsListQuery, mapDashboardInstanceSandboxSpecsGetOutput, mapDashboardInstanceSandboxSpecsListOutput, mapDashboardInstanceSandboxSpecsListQuery, mapDashboardInstanceScmAccountsPreviewBody, mapDashboardInstanceScmAccountsPreviewOutput, mapDashboardInstanceScmConnectionsCreateBody, mapDashboardInstanceScmConnectionsCreateOutput, mapDashboardInstanceScmConnectionsGetOutput, mapDashboardInstanceScmConnectionsListOutput, mapDashboardInstanceScmConnectionsListQuery, mapDashboardInstanceScmInstallationCreateBody, mapDashboardInstanceScmInstallationCreateOutput, mapDashboardInstanceScmInstallationListOutput, mapDashboardInstanceScmInstallationListQuery, mapDashboardInstanceScmProvidersCreateBody, mapDashboardInstanceScmProvidersCreateOutput, mapDashboardInstanceScmProvidersGetOutput, mapDashboardInstanceScmProvidersListOutput, mapDashboardInstanceScmProvidersListQuery, mapDashboardInstanceScmReposCreateBody, mapDashboardInstanceScmReposCreateOutput, mapDashboardInstanceScmReposGetOutput, mapDashboardInstanceScmReposListOutput, mapDashboardInstanceScmReposListQuery, mapDashboardInstanceScmReposPreviewBody, mapDashboardInstanceScmReposPreviewOutput, mapDashboardInstanceSessionTemplatesCreateBody, mapDashboardInstanceSessionTemplatesCreateOutput, mapDashboardInstanceSessionTemplatesDeleteOutput, mapDashboardInstanceSessionTemplatesGetOutput, mapDashboardInstanceSessionTemplatesListOutput, mapDashboardInstanceSessionTemplatesListQuery, mapDashboardInstanceSessionTemplatesListToolsOutput, mapDashboardInstanceSessionTemplatesProvidersCreateBody, mapDashboardInstanceSessionTemplatesProvidersCreateOutput, mapDashboardInstanceSessionTemplatesProvidersDeleteOutput, mapDashboardInstanceSessionTemplatesProvidersGetOutput, mapDashboardInstanceSessionTemplatesProvidersListOutput, mapDashboardInstanceSessionTemplatesProvidersListQuery, mapDashboardInstanceSessionTemplatesProvidersUpdateBody, mapDashboardInstanceSessionTemplatesProvidersUpdateOutput, mapDashboardInstanceSessionTemplatesUpdateBody, mapDashboardInstanceSessionTemplatesUpdateOutput, mapDashboardInstanceSessionsConnectionsGetOutput, mapDashboardInstanceSessionsConnectionsListOutput, mapDashboardInstanceSessionsConnectionsListQuery, mapDashboardInstanceSessionsCreateBody, mapDashboardInstanceSessionsCreateOutput, mapDashboardInstanceSessionsDeleteOutput, mapDashboardInstanceSessionsErrorGroupsGetOutput, mapDashboardInstanceSessionsErrorGroupsListOutput, mapDashboardInstanceSessionsErrorGroupsListQuery, mapDashboardInstanceSessionsErrorsGetOutput, mapDashboardInstanceSessionsErrorsListOutput, mapDashboardInstanceSessionsErrorsListQuery, mapDashboardInstanceSessionsEventsGetOutput, mapDashboardInstanceSessionsEventsListOutput, mapDashboardInstanceSessionsEventsListQuery, mapDashboardInstanceSessionsGetOutput, mapDashboardInstanceSessionsListOutput, mapDashboardInstanceSessionsListQuery, mapDashboardInstanceSessionsMessagesGetOutput, mapDashboardInstanceSessionsMessagesListOutput, mapDashboardInstanceSessionsMessagesListQuery, mapDashboardInstanceSessionsParticipantsGetOutput, mapDashboardInstanceSessionsParticipantsListOutput, mapDashboardInstanceSessionsParticipantsListQuery, mapDashboardInstanceSessionsProvidersCreateBody, mapDashboardInstanceSessionsProvidersCreateOutput, mapDashboardInstanceSessionsProvidersDeleteOutput, mapDashboardInstanceSessionsProvidersGetOutput, mapDashboardInstanceSessionsProvidersListOutput, mapDashboardInstanceSessionsProvidersListQuery, mapDashboardInstanceSessionsProvidersUpdateBody, mapDashboardInstanceSessionsProvidersUpdateOutput, mapDashboardInstanceSessionsUpdateBody, mapDashboardInstanceSessionsUpdateOutput, mapDashboardInstanceSkillsAgentsCreateBody, mapDashboardInstanceSkillsAgentsCreateOutput, mapDashboardInstanceSkillsAgentsDeleteOutput, mapDashboardInstanceSkillsAgentsGetOutput, mapDashboardInstanceSkillsAgentsListOutput, mapDashboardInstanceSkillsAgentsListQuery, mapDashboardInstanceSkillsAgentsUpdateBody, mapDashboardInstanceSkillsAgentsUpdateOutput, mapDashboardInstanceSkillsConfigurationsCreateBody, mapDashboardInstanceSkillsConfigurationsCreateOutput, mapDashboardInstanceSkillsConfigurationsDeleteOutput, mapDashboardInstanceSkillsConfigurationsGetOutput, mapDashboardInstanceSkillsConfigurationsListOutput, mapDashboardInstanceSkillsConfigurationsListQuery, mapDashboardInstanceSkillsConfigurationsUpdateBody, mapDashboardInstanceSkillsConfigurationsUpdateOutput, mapDashboardInstanceSkillsCreateBody, mapDashboardInstanceSkillsCreateOutput, mapDashboardInstanceSkillsDeleteOutput, mapDashboardInstanceSkillsDuplicateBody, mapDashboardInstanceSkillsDuplicateOutput, mapDashboardInstanceSkillsExportsCreateBody, mapDashboardInstanceSkillsExportsCreateOutput, mapDashboardInstanceSkillsExportsGetOutput, mapDashboardInstanceSkillsExportsListOutput, mapDashboardInstanceSkillsExportsListQuery, mapDashboardInstanceSkillsFilesBatchBody, mapDashboardInstanceSkillsFilesBatchOutput, mapDashboardInstanceSkillsFilesDeleteOutput, mapDashboardInstanceSkillsFilesDeleteQuery, mapDashboardInstanceSkillsFilesGetOutput, mapDashboardInstanceSkillsFilesGetQuery, mapDashboardInstanceSkillsFilesListOutput, mapDashboardInstanceSkillsFilesMoveBody, mapDashboardInstanceSkillsFilesMoveOutput, mapDashboardInstanceSkillsFilesPutBody, mapDashboardInstanceSkillsFilesPutOutput, mapDashboardInstanceSkillsForkBody, mapDashboardInstanceSkillsForkOutput, mapDashboardInstanceSkillsForkSyncsCreateBody, mapDashboardInstanceSkillsForkSyncsCreateOutput, mapDashboardInstanceSkillsForkSyncsGetOutput, mapDashboardInstanceSkillsGetOutput, mapDashboardInstanceSkillsGroupsCreateBody, mapDashboardInstanceSkillsGroupsCreateOutput, mapDashboardInstanceSkillsGroupsDeleteOutput, mapDashboardInstanceSkillsGroupsGetOutput, mapDashboardInstanceSkillsGroupsItemsCreateBody, mapDashboardInstanceSkillsGroupsItemsCreateOutput, mapDashboardInstanceSkillsGroupsItemsDeleteOutput, mapDashboardInstanceSkillsGroupsItemsGetOutput, mapDashboardInstanceSkillsGroupsItemsListOutput, mapDashboardInstanceSkillsGroupsItemsListQuery, mapDashboardInstanceSkillsGroupsListOutput, mapDashboardInstanceSkillsGroupsListQuery, mapDashboardInstanceSkillsGroupsUpdateBody, mapDashboardInstanceSkillsGroupsUpdateOutput, mapDashboardInstanceSkillsImportsCreateBody, mapDashboardInstanceSkillsImportsCreateOutput, mapDashboardInstanceSkillsImportsGetOutput, mapDashboardInstanceSkillsImportsListOutput, mapDashboardInstanceSkillsImportsListQuery, mapDashboardInstanceSkillsItemsCreateBody, mapDashboardInstanceSkillsItemsCreateOutput, mapDashboardInstanceSkillsItemsDeleteOutput, mapDashboardInstanceSkillsItemsGetOutput, mapDashboardInstanceSkillsItemsListOutput, mapDashboardInstanceSkillsItemsListQuery, mapDashboardInstanceSkillsListOutput, mapDashboardInstanceSkillsListQuery, mapDashboardInstanceSkillsMarketplacesArchiveOutput, mapDashboardInstanceSkillsMarketplacesCreateBody, mapDashboardInstanceSkillsMarketplacesCreateOutput, mapDashboardInstanceSkillsMarketplacesGetEditorUrlBody, mapDashboardInstanceSkillsMarketplacesGetEditorUrlOutput, mapDashboardInstanceSkillsMarketplacesGetOutput, mapDashboardInstanceSkillsMarketplacesListOutput, mapDashboardInstanceSkillsMarketplacesListQuery, mapDashboardInstanceSkillsMarketplacesPluginsAddBody, mapDashboardInstanceSkillsMarketplacesPluginsAddOutput, mapDashboardInstanceSkillsMarketplacesPluginsGetOutput, mapDashboardInstanceSkillsMarketplacesPluginsListOutput, mapDashboardInstanceSkillsMarketplacesPluginsListQuery, mapDashboardInstanceSkillsMarketplacesPluginsRemoveOutput, mapDashboardInstanceSkillsMarketplacesRepositoriesCreateBody, mapDashboardInstanceSkillsMarketplacesRepositoriesCreateOutput, mapDashboardInstanceSkillsMarketplacesRepositoriesDeleteOutput, mapDashboardInstanceSkillsMarketplacesRepositoriesGetOutput, mapDashboardInstanceSkillsMarketplacesRepositoriesListOutput, mapDashboardInstanceSkillsMarketplacesRepositoriesListQuery, mapDashboardInstanceSkillsMarketplacesSyncBody, mapDashboardInstanceSkillsMarketplacesSyncOutput, mapDashboardInstanceSkillsMarketplacesUpdateBody, mapDashboardInstanceSkillsMarketplacesUpdateOutput, mapDashboardInstanceSkillsMergeRequestsCloseOutput, mapDashboardInstanceSkillsMergeRequestsCommentsCreateBody, mapDashboardInstanceSkillsMergeRequestsCommentsCreateOutput, mapDashboardInstanceSkillsMergeRequestsCommentsDeleteOutput, mapDashboardInstanceSkillsMergeRequestsCommentsGetOutput, mapDashboardInstanceSkillsMergeRequestsCommentsListOutput, mapDashboardInstanceSkillsMergeRequestsCommentsListQuery, mapDashboardInstanceSkillsMergeRequestsCommentsUpdateBody, mapDashboardInstanceSkillsMergeRequestsCommentsUpdateOutput, mapDashboardInstanceSkillsMergeRequestsCreateBody, mapDashboardInstanceSkillsMergeRequestsCreateOutput, mapDashboardInstanceSkillsMergeRequestsEventsGetOutput, mapDashboardInstanceSkillsMergeRequestsEventsListOutput, mapDashboardInstanceSkillsMergeRequestsEventsListQuery, mapDashboardInstanceSkillsMergeRequestsGetOutput, mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveBody, mapDashboardInstanceSkillsMergeRequestsItemsBulkResolveOutput, mapDashboardInstanceSkillsMergeRequestsItemsResolveBody, mapDashboardInstanceSkillsMergeRequestsItemsResolveOutput, mapDashboardInstanceSkillsMergeRequestsListOutput, mapDashboardInstanceSkillsMergeRequestsListQuery, mapDashboardInstanceSkillsMergeRequestsPerformOutput, mapDashboardInstanceSkillsMergeRequestsPlanGetOutput, mapDashboardInstanceSkillsMergeRequestsRollbackOutput, mapDashboardInstanceSkillsParticipantsGetOutput, mapDashboardInstanceSkillsParticipantsListOutput, mapDashboardInstanceSkillsParticipantsListQuery, mapDashboardInstanceSkillsPluginsArchiveOutput, mapDashboardInstanceSkillsPluginsCreateBody, mapDashboardInstanceSkillsPluginsCreateOutput, mapDashboardInstanceSkillsPluginsGetEditorUrlBody, mapDashboardInstanceSkillsPluginsGetEditorUrlOutput, mapDashboardInstanceSkillsPluginsGetOutput, mapDashboardInstanceSkillsPluginsListOutput, mapDashboardInstanceSkillsPluginsListQuery, mapDashboardInstanceSkillsPluginsRepositoriesCreateBody, mapDashboardInstanceSkillsPluginsRepositoriesCreateOutput, mapDashboardInstanceSkillsPluginsRepositoriesDeleteOutput, mapDashboardInstanceSkillsPluginsRepositoriesGetOutput, mapDashboardInstanceSkillsPluginsRepositoriesListOutput, mapDashboardInstanceSkillsPluginsRepositoriesListQuery, mapDashboardInstanceSkillsPluginsSkillsAddBody, mapDashboardInstanceSkillsPluginsSkillsAddOutput, mapDashboardInstanceSkillsPluginsSkillsGetOutput, mapDashboardInstanceSkillsPluginsSkillsListOutput, mapDashboardInstanceSkillsPluginsSkillsListQuery, mapDashboardInstanceSkillsPluginsSkillsRemoveOutput, mapDashboardInstanceSkillsPluginsSkillsUpdateBody, mapDashboardInstanceSkillsPluginsSkillsUpdateOutput, mapDashboardInstanceSkillsPluginsSyncBody, mapDashboardInstanceSkillsPluginsSyncOutput, mapDashboardInstanceSkillsPluginsUpdateBody, mapDashboardInstanceSkillsPluginsUpdateOutput, mapDashboardInstanceSkillsPublishConsumerSkillOutput, mapDashboardInstanceSkillsShareBody, mapDashboardInstanceSkillsShareOutput, mapDashboardInstanceSkillsSyncsGetOutput, mapDashboardInstanceSkillsSyncsListOutput, mapDashboardInstanceSkillsSyncsListQuery, mapDashboardInstanceSkillsSyncsRepositoryChecksOutput, mapDashboardInstanceSkillsTemplatesCreateBody, mapDashboardInstanceSkillsTemplatesCreateOutput, mapDashboardInstanceSkillsTemplatesDeleteOutput, mapDashboardInstanceSkillsTemplatesGetOutput, mapDashboardInstanceSkillsTemplatesItemsCreateBody, mapDashboardInstanceSkillsTemplatesItemsCreateOutput, mapDashboardInstanceSkillsTemplatesItemsDeleteOutput, mapDashboardInstanceSkillsTemplatesItemsGetOutput, mapDashboardInstanceSkillsTemplatesItemsListOutput, mapDashboardInstanceSkillsTemplatesItemsListQuery, mapDashboardInstanceSkillsTemplatesListOutput, mapDashboardInstanceSkillsTemplatesListQuery, mapDashboardInstanceSkillsTemplatesUpdateBody, mapDashboardInstanceSkillsTemplatesUpdateOutput, mapDashboardInstanceSkillsUpdateBody, mapDashboardInstanceSkillsUpdateOutput, mapDashboardInstanceSkillsVersionsGetOutput, mapDashboardInstanceSkillsVersionsListOutput, mapDashboardInstanceSkillsVersionsListQuery, mapDashboardInstanceSkillsVersionsSnapshotGetOutput, mapDashboardInstanceStoresCreateBody, mapDashboardInstanceStoresCreateOutput, mapDashboardInstanceStoresDeleteOutput, mapDashboardInstanceStoresGetOutput, mapDashboardInstanceStoresItemsGetOutput, mapDashboardInstanceStoresItemsListOutput, mapDashboardInstanceStoresItemsListQuery, mapDashboardInstanceStoresItemsModifyBody, mapDashboardInstanceStoresItemsModifyOutput, mapDashboardInstanceStoresListOutput, mapDashboardInstanceStoresListQuery, mapDashboardInstanceStoresParticipantsGetOutput, mapDashboardInstanceStoresParticipantsListOutput, mapDashboardInstanceStoresParticipantsListQuery, mapDashboardInstanceStoresPermissionsGetOutput, mapDashboardInstanceStoresUpdateBody, mapDashboardInstanceStoresUpdateOutput, mapDashboardInstanceToolCallsCreateBody, mapDashboardInstanceToolCallsCreateOutput, mapDashboardInstanceToolCallsGetOutput, mapDashboardInstanceToolCallsListOutput, mapDashboardInstanceToolCallsListQuery, mapDashboardInstanceWebhookRegistrationsCreateBody, mapDashboardInstanceWebhookRegistrationsCreateOutput, mapDashboardInstanceWebhookRegistrationsDeleteOutput, mapDashboardInstanceWebhookRegistrationsGetOutput, mapDashboardInstanceWebhookRegistrationsListOutput, mapDashboardInstanceWebhookRegistrationsListQuery, mapDashboardInstanceWebhookRegistrationsSetupBody, mapDashboardInstanceWebhookRegistrationsSetupOutput, mapDashboardInstanceWebhookRegistrationsUpdateBody, mapDashboardInstanceWebhookRegistrationsUpdateOutput, mapDashboardInstancesResourceCountsGetOutput, mapDashboardInstancesResourceCountsGetQuery, mapDashboardOauthAuthorizationRequestsApproveBody, mapDashboardOauthAuthorizationRequestsApproveOutput, mapDashboardOauthAuthorizationRequestsConsumerTargetsListOutput, mapDashboardOauthAuthorizationRequestsGetOutput, mapDashboardOauthAuthorizationRequestsRejectBody, mapDashboardOauthAuthorizationRequestsRejectOutput, mapDashboardOrganizationsAccessPoliciesCreateBody, mapDashboardOrganizationsAccessPoliciesCreateOutput, mapDashboardOrganizationsAccessPoliciesDeleteOutput, mapDashboardOrganizationsAccessPoliciesGetOutput, mapDashboardOrganizationsAccessPoliciesListOutput, mapDashboardOrganizationsAccessPoliciesListQuery, mapDashboardOrganizationsAccessPoliciesUpdateBody, mapDashboardOrganizationsAccessPoliciesUpdateOutput, mapDashboardOrganizationsAccessPoliciesVersionsOutput, mapDashboardOrganizationsAccessPoliciesVersionsQuery, mapDashboardOrganizationsAccessRolesCreateBody, mapDashboardOrganizationsAccessRolesCreateOutput, mapDashboardOrganizationsAccessRolesDeleteOutput, mapDashboardOrganizationsAccessRolesGetOutput, mapDashboardOrganizationsAccessRolesListOutput, mapDashboardOrganizationsAccessRolesListQuery, mapDashboardOrganizationsAccessRolesUpdateBody, mapDashboardOrganizationsAccessRolesUpdateOutput, mapDashboardOrganizationsAccessRolesVersionsOutput, mapDashboardOrganizationsAccessRolesVersionsQuery, mapDashboardOrganizationsApiKeysCreateBody, mapDashboardOrganizationsApiKeysCreateOutput, mapDashboardOrganizationsApiKeysGetOutput, mapDashboardOrganizationsApiKeysListOutput, mapDashboardOrganizationsApiKeysListQuery, mapDashboardOrganizationsApiKeysRevealOutput, mapDashboardOrganizationsApiKeysRevokeOutput, mapDashboardOrganizationsApiKeysRotateBody, mapDashboardOrganizationsApiKeysRotateOutput, mapDashboardOrganizationsApiKeysUpdateBody, mapDashboardOrganizationsApiKeysUpdateOutput, mapDashboardOrganizationsAuditLogStreamsCreateBody, mapDashboardOrganizationsAuditLogStreamsCreateOutput, mapDashboardOrganizationsAuditLogStreamsDeleteOutput, mapDashboardOrganizationsAuditLogStreamsEventsGetOutput, mapDashboardOrganizationsAuditLogStreamsEventsListOutput, mapDashboardOrganizationsAuditLogStreamsEventsListQuery, mapDashboardOrganizationsAuditLogStreamsGetOutput, mapDashboardOrganizationsAuditLogStreamsListOutput, mapDashboardOrganizationsAuditLogStreamsListQuery, mapDashboardOrganizationsAuditLogStreamsResumeOutput, mapDashboardOrganizationsAuditLogStreamsUpdateBody, mapDashboardOrganizationsAuditLogStreamsUpdateOutput, mapDashboardOrganizationsAuditLogsGetOutput, mapDashboardOrganizationsAuditLogsListOutput, mapDashboardOrganizationsAuditLogsListQuery, mapDashboardOrganizationsConfigsGetOutput, mapDashboardOrganizationsConfigsListOutput, mapDashboardOrganizationsConfigsSetBody, mapDashboardOrganizationsConfigsSetOutput, mapDashboardOrganizationsConfigureAuditLogRetentionGetOutput, mapDashboardOrganizationsConfigureAuditLogRetentionUpdateBody, mapDashboardOrganizationsConfigureAuditLogRetentionUpdateOutput, mapDashboardOrganizationsCreateBody, mapDashboardOrganizationsCreateOutput, mapDashboardOrganizationsDeleteOutput, mapDashboardOrganizationsEventDeliveriesGetOutput, mapDashboardOrganizationsEventDeliveriesListOutput, mapDashboardOrganizationsEventDeliveriesListQuery, mapDashboardOrganizationsEventDeliveriesRetryOutput, mapDashboardOrganizationsEventDeliveryAttemptsGetOutput, mapDashboardOrganizationsEventDeliveryAttemptsListOutput, mapDashboardOrganizationsEventDeliveryAttemptsListQuery, mapDashboardOrganizationsEventDestinationListenersCreateBody, mapDashboardOrganizationsEventDestinationListenersCreateOutput, mapDashboardOrganizationsEventDestinationListenersDeleteOutput, mapDashboardOrganizationsEventDestinationListenersGetOutput, mapDashboardOrganizationsEventDestinationListenersListOutput, mapDashboardOrganizationsEventDestinationListenersListQuery, mapDashboardOrganizationsEventDestinationListenersUpdateBody, mapDashboardOrganizationsEventDestinationListenersUpdateOutput, mapDashboardOrganizationsEventDestinationsArchiveOutput, mapDashboardOrganizationsEventDestinationsCreateBody, mapDashboardOrganizationsEventDestinationsCreateOutput, mapDashboardOrganizationsEventDestinationsGetOutput, mapDashboardOrganizationsEventDestinationsListOutput, mapDashboardOrganizationsEventDestinationsListQuery, mapDashboardOrganizationsEventDestinationsPingOutput, mapDashboardOrganizationsEventDestinationsRotateWebhookSecretOutput, mapDashboardOrganizationsEventDestinationsUpdateBody, mapDashboardOrganizationsEventDestinationsUpdateOutput, mapDashboardOrganizationsEventsGetOutput, mapDashboardOrganizationsEventsListOutput, mapDashboardOrganizationsEventsListQuery, mapDashboardOrganizationsGetOutput, mapDashboardOrganizationsInstancesDeleteOutput, mapDashboardOrganizationsInstancesGetOutput, mapDashboardOrganizationsInstancesListOutput, mapDashboardOrganizationsInstancesListQuery, mapDashboardOrganizationsInstancesUpdateBody, mapDashboardOrganizationsInstancesUpdateOutput, mapDashboardOrganizationsInvitesCreateBody, mapDashboardOrganizationsInvitesCreateOutput, mapDashboardOrganizationsInvitesDeleteOutput, mapDashboardOrganizationsInvitesEnsureLinkOutput, mapDashboardOrganizationsInvitesGetOutput, mapDashboardOrganizationsInvitesListOutput, mapDashboardOrganizationsInvitesListQuery, mapDashboardOrganizationsInvitesUpdateBody, mapDashboardOrganizationsInvitesUpdateOutput, mapDashboardOrganizationsJoinAcceptBody, mapDashboardOrganizationsJoinAcceptOutput, mapDashboardOrganizationsJoinGetOutput, mapDashboardOrganizationsJoinGetQuery, mapDashboardOrganizationsJoinRejectBody, mapDashboardOrganizationsJoinRejectOutput, mapDashboardOrganizationsLayoutsGetOutput, mapDashboardOrganizationsLayoutsListOutput, mapDashboardOrganizationsLayoutsSetBody, mapDashboardOrganizationsLayoutsSetOutput, mapDashboardOrganizationsListOutput, mapDashboardOrganizationsListQuery, mapDashboardOrganizationsMembersDeleteOutput, mapDashboardOrganizationsMembersGetOutput, mapDashboardOrganizationsMembersListOutput, mapDashboardOrganizationsMembersListQuery, mapDashboardOrganizationsMembersPoliciesCreateBody, mapDashboardOrganizationsMembersPoliciesCreateOutput, mapDashboardOrganizationsMembersPoliciesDeleteOutput, mapDashboardOrganizationsMembersUpdateBody, mapDashboardOrganizationsMembersUpdateOutput, mapDashboardOrganizationsOauthAppsClientSecretsCreateOutput, mapDashboardOrganizationsOauthAppsClientSecretsDeleteOutput, mapDashboardOrganizationsOauthAppsCreateBody, mapDashboardOrganizationsOauthAppsCreateOutput, mapDashboardOrganizationsOauthAppsDeleteOutput, mapDashboardOrganizationsOauthAppsGetOutput, mapDashboardOrganizationsOauthAppsListOutput, mapDashboardOrganizationsOauthAppsListQuery, mapDashboardOrganizationsOauthAppsUpdateBody, mapDashboardOrganizationsOauthAppsUpdateOutput, mapDashboardOrganizationsOauthAuthorizationLogsListOutput, mapDashboardOrganizationsOauthAuthorizationLogsListQuery, mapDashboardOrganizationsOauthAuthorizationsGetOutput, mapDashboardOrganizationsOauthAuthorizationsListOutput, mapDashboardOrganizationsOauthAuthorizationsListQuery, mapDashboardOrganizationsOauthAuthorizationsRevokeOutput, mapDashboardOrganizationsOauthCliDevicesGetOutput, mapDashboardOrganizationsOauthCliDevicesListOutput, mapDashboardOrganizationsOauthCliDevicesListQuery, mapDashboardOrganizationsOauthInstallationsGetOutput, mapDashboardOrganizationsOauthInstallationsListOutput, mapDashboardOrganizationsOauthInstallationsListQuery, mapDashboardOrganizationsOauthInstallationsRevokeOutput, mapDashboardOrganizationsOauthScopesListOutput, mapDashboardOrganizationsOauthScopesListQuery, mapDashboardOrganizationsOutpostsAccessListOutput, mapDashboardOrganizationsOutpostsAccessListQuery, mapDashboardOrganizationsOutpostsAccessSetBody, mapDashboardOrganizationsOutpostsAccessSetOutput, mapDashboardOrganizationsOutpostsCreateBody, mapDashboardOrganizationsOutpostsCreateOutput, mapDashboardOrganizationsOutpostsCredentialsCreateBody, mapDashboardOrganizationsOutpostsCredentialsCreateOutput, mapDashboardOrganizationsOutpostsCredentialsDeleteOutput, mapDashboardOrganizationsOutpostsCredentialsDisableOutput, mapDashboardOrganizationsOutpostsCredentialsGetOutput, mapDashboardOrganizationsOutpostsCredentialsListOutput, mapDashboardOrganizationsOutpostsCredentialsListQuery, mapDashboardOrganizationsOutpostsDeleteOutput, mapDashboardOrganizationsOutpostsDisableOutput, mapDashboardOrganizationsOutpostsEnableOutput, mapDashboardOrganizationsOutpostsGetOutput, mapDashboardOrganizationsOutpostsListOutput, mapDashboardOrganizationsOutpostsListQuery, mapDashboardOrganizationsOutpostsUpdateBody, mapDashboardOrganizationsOutpostsUpdateOutput, mapDashboardOrganizationsProjectsBrandingGetOutput, mapDashboardOrganizationsProjectsBrandingUpdateBody, mapDashboardOrganizationsProjectsBrandingUpdateOutput, mapDashboardOrganizationsProjectsCreateBody, mapDashboardOrganizationsProjectsCreateOutput, mapDashboardOrganizationsProjectsDeleteOutput, mapDashboardOrganizationsProjectsGetOutput, mapDashboardOrganizationsProjectsListOutput, mapDashboardOrganizationsProjectsListQuery, mapDashboardOrganizationsProjectsUpdateBody, mapDashboardOrganizationsProjectsUpdateOutput, mapDashboardOrganizationsSandboxesCreateBody, mapDashboardOrganizationsSandboxesCreateOutput, mapDashboardOrganizationsSandboxesGetOutput, mapDashboardOrganizationsSandboxesListOutput, mapDashboardOrganizationsSandboxesListQuery, mapDashboardOrganizationsSandboxesUpdateBody, mapDashboardOrganizationsSandboxesUpdateOutput, mapDashboardOrganizationsServiceAccountsClientSecretsCreateOutput, mapDashboardOrganizationsServiceAccountsClientSecretsDeleteOutput, mapDashboardOrganizationsServiceAccountsCreateBody, mapDashboardOrganizationsServiceAccountsCreateOutput, mapDashboardOrganizationsServiceAccountsCredentialsGetOutput, mapDashboardOrganizationsServiceAccountsCredentialsListOutput, mapDashboardOrganizationsServiceAccountsCredentialsListQuery, mapDashboardOrganizationsServiceAccountsDeleteOutput, mapDashboardOrganizationsServiceAccountsGetOutput, mapDashboardOrganizationsServiceAccountsListOutput, mapDashboardOrganizationsServiceAccountsListQuery, mapDashboardOrganizationsServiceAccountsPoliciesCreateBody, mapDashboardOrganizationsServiceAccountsPoliciesCreateOutput, mapDashboardOrganizationsServiceAccountsPoliciesDeleteOutput, mapDashboardOrganizationsServiceAccountsUpdateBody, mapDashboardOrganizationsServiceAccountsUpdateOutput, mapDashboardOrganizationsTeamsCreateBody, mapDashboardOrganizationsTeamsCreateOutput, mapDashboardOrganizationsTeamsDeleteOutput, mapDashboardOrganizationsTeamsGetOutput, mapDashboardOrganizationsTeamsListOutput, mapDashboardOrganizationsTeamsListQuery, mapDashboardOrganizationsTeamsMembersCreateBody, mapDashboardOrganizationsTeamsMembersCreateOutput, mapDashboardOrganizationsTeamsMembersDeleteOutput, mapDashboardOrganizationsTeamsPoliciesCreateBody, mapDashboardOrganizationsTeamsPoliciesCreateOutput, mapDashboardOrganizationsTeamsPoliciesDeleteOutput, mapDashboardOrganizationsTeamsUpdateBody, mapDashboardOrganizationsTeamsUpdateOutput, mapDashboardOrganizationsUpdateBody, mapDashboardOrganizationsUpdateOutput, mapDashboardOrganizationsWebhookEventsListOutput, mapDashboardProjectsConfigureAuthConfigGetOutput, mapDashboardProjectsConfigureAuthConfigUpdateBody, mapDashboardProjectsConfigureAuthConfigUpdateOutput, mapDashboardProjectsConfigureDataRetentionGetOutput, mapDashboardProjectsConfigureDataRetentionUpdateBody, mapDashboardProjectsConfigureDataRetentionUpdateOutput, mapDashboardProjectsConfigureIntegrationNamingGetOutput, mapDashboardProjectsConfigureIntegrationNamingUpdateBody, mapDashboardProjectsConfigureIntegrationNamingUpdateOutput, mapDashboardProjectsConfigureRetentionGetOutput, mapDashboardProjectsConfigureRetentionUpdateBody, mapDashboardProjectsConfigureRetentionUpdateOutput, mapDashboardProjectsConfigureSessionlessMcpGetOutput, mapDashboardProjectsConfigureSessionlessMcpUpdateBody, mapDashboardProjectsConfigureSessionlessMcpUpdateOutput, mapDashboardProjectsConfigureSkillSyncGetOutput, mapDashboardProjectsConfigureSkillSyncUpdateBody, mapDashboardProjectsConfigureSkillSyncUpdateOutput, mapDashboardProjectsConfigureToolCallingGetOutput, mapDashboardProjectsConfigureToolCallingUpdateBody, mapDashboardProjectsConfigureToolCallingUpdateOutput, mapDashboardProjectsConfigureWorkforceGetOutput, mapDashboardProjectsConfigureWorkforceUpdateBody, mapDashboardProjectsConfigureWorkforceUpdateOutput, mapDashboardProjectsKeyProvidersCreateManagedBody, mapDashboardProjectsKeyProvidersCreateManagedOutput, mapDashboardProjectsKeyProvidersErrorsListOutput, mapDashboardProjectsKeyProvidersErrorsListQuery, mapDashboardProjectsKeyProvidersGetOutput, mapDashboardProjectsKeyProvidersGetSetupInfoOutput, mapDashboardProjectsKeyProvidersGetSetupInfoQuery, mapDashboardProjectsKeyProvidersImportBody, mapDashboardProjectsKeyProvidersImportOutput, mapDashboardProjectsKeyProvidersListOutput, mapDashboardProjectsKeyProvidersListQuery, mapDashboardProjectsKeyProvidersSetDefaultOutput, mapDashboardProjectsKeyProvidersValidateOutput, mapDashboardUsageTimelineOutput, mapDashboardUsageTimelineQuery, mapDocumentsCloneBody, mapDocumentsCloneOutput, mapDocumentsCreateBody, mapDocumentsCreateOutput, mapDocumentsDeleteOutput, mapDocumentsEditTokenGetOutput, mapDocumentsGetOutput, mapDocumentsListOutput, mapDocumentsListQuery, mapDocumentsParticipantsGetOutput, mapDocumentsParticipantsListOutput, mapDocumentsParticipantsListQuery, mapDocumentsPermissionsGetOutput, mapDocumentsUpdateBody, mapDocumentsUpdateOutput, mapDocumentsVersionsGetOutput, mapDocumentsVersionsListOutput, mapDocumentsVersionsListQuery, mapFilesDeleteOutput, mapFilesGetOutput, mapFilesLinksCreateBody, mapFilesLinksCreateOutput, mapFilesLinksDeleteOutput, mapFilesLinksGetOutput, mapFilesLinksListOutput, mapFilesLinksListQuery, mapFilesListOutput, mapFilesListQuery, mapFirewallsCreateBody, mapFirewallsCreateOutput, mapFirewallsDeleteOutput, mapFirewallsGetOutput, mapFirewallsListOutput, mapFirewallsListQuery, mapFirewallsNetworkPoliciesAttachBody, mapFirewallsNetworkPoliciesAttachOutput, mapFirewallsNetworkPoliciesDetachOutput, mapFirewallsUpdateBody, mapFirewallsUpdateOutput, mapIdentitiesCreateBody, mapIdentitiesCreateOutput, mapIdentitiesCredentialsCreateBody, mapIdentitiesCredentialsCreateOutput, mapIdentitiesCredentialsDeleteOutput, mapIdentitiesCredentialsGetOutput, mapIdentitiesCredentialsListOutput, mapIdentitiesCredentialsListQuery, mapIdentitiesCredentialsUpdateBody, mapIdentitiesCredentialsUpdateOutput, mapIdentitiesDelegationConfigsCreateBody, mapIdentitiesDelegationConfigsCreateOutput, mapIdentitiesDelegationConfigsDeleteOutput, mapIdentitiesDelegationConfigsGetOutput, mapIdentitiesDelegationConfigsListOutput, mapIdentitiesDelegationConfigsListQuery, mapIdentitiesDelegationConfigsUpdateBody, mapIdentitiesDelegationConfigsUpdateOutput, mapIdentitiesDelegationRequestsApproveOutput, mapIdentitiesDelegationRequestsApproveQuery, mapIdentitiesDelegationRequestsCreateBody, mapIdentitiesDelegationRequestsCreateOutput, mapIdentitiesDelegationRequestsDenyOutput, mapIdentitiesDelegationRequestsDenyQuery, mapIdentitiesDelegationRequestsGetOutput, mapIdentitiesDelegationRequestsGetQuery, mapIdentitiesDelegationRequestsListOutput, mapIdentitiesDelegationRequestsListQuery, mapIdentitiesDelegationsCreateBody, mapIdentitiesDelegationsCreateOutput, mapIdentitiesDelegationsGetOutput, mapIdentitiesDelegationsListOutput, mapIdentitiesDelegationsListQuery, mapIdentitiesDelegationsRevokeOutput, mapIdentitiesDeleteOutput, mapIdentitiesGetOutput, mapIdentitiesListOutput, mapIdentitiesListQuery, mapIdentitiesUpdateBody, mapIdentitiesUpdateOutput, mapIdentityActorsCreateBody, mapIdentityActorsCreateOutput, mapIdentityActorsDeleteOutput, mapIdentityActorsGetOutput, mapIdentityActorsListOutput, mapIdentityActorsListQuery, mapIdentityActorsUpdateBody, mapIdentityActorsUpdateOutput, mapIncomingWebhooksGetOutput, mapIncomingWebhooksListOutput, mapIncomingWebhooksListQuery, mapIntegrationEnclavesGetOutput, mapIntegrationEnclavesListOutput, mapIntegrationEnclavesListQuery, mapIntegrationFirewallAssignmentsCreateBody, mapIntegrationFirewallAssignmentsCreateOutput, mapIntegrationFirewallAssignmentsDeleteOutput, mapIntegrationFirewallAssignmentsGetOutput, mapIntegrationFirewallAssignmentsListOutput, mapIntegrationFirewallAssignmentsListQuery, mapIntegrationInternetGatewayGetOutput, mapIntegrationInternetGatewayListNetworkLogsOutput, mapIntegrationInternetGatewayListNetworkLogsQuery, mapIntegrationsCreateBody, mapIntegrationsCreateOutput, mapIntegrationsDeleteOutput, mapIntegrationsGetOutput, mapIntegrationsInstanceGroupsCreateBody, mapIntegrationsInstanceGroupsCreateOutput, mapIntegrationsInstanceGroupsCreateSessionBody, mapIntegrationsInstanceGroupsCreateSessionOutput, mapIntegrationsInstanceGroupsCreateSessionTemplateBody, mapIntegrationsInstanceGroupsCreateSessionTemplateOutput, mapIntegrationsInstanceGroupsDeleteOutput, mapIntegrationsInstanceGroupsGetOutput, mapIntegrationsInstanceGroupsListOutput, mapIntegrationsInstanceGroupsListQuery, mapIntegrationsInstanceGroupsProvidersDeleteOutput, mapIntegrationsInstanceGroupsProvidersGetOutput, mapIntegrationsInstanceGroupsProvidersListOutput, mapIntegrationsInstanceGroupsProvidersListQuery, mapIntegrationsInstanceGroupsProvidersSetBody, mapIntegrationsInstanceGroupsProvidersSetOutput, mapIntegrationsInstanceGroupsUpdateBody, mapIntegrationsInstanceGroupsUpdateOutput, mapIntegrationsInstancesCreateBody, mapIntegrationsInstancesCreateOutput, mapIntegrationsInstancesCreateSessionBody, mapIntegrationsInstancesCreateSessionOutput, mapIntegrationsInstancesCreateSessionTemplateBody, mapIntegrationsInstancesCreateSessionTemplateOutput, mapIntegrationsInstancesDeleteOutput, mapIntegrationsInstancesGetOutput, mapIntegrationsInstancesListOutput, mapIntegrationsInstancesListQuery, mapIntegrationsInstancesProvidersGetOutput, mapIntegrationsInstancesProvidersListOutput, mapIntegrationsInstancesProvidersListQuery, mapIntegrationsInstancesProvidersSetBody, mapIntegrationsInstancesProvidersSetOutput, mapIntegrationsInstancesUpdateBody, mapIntegrationsInstancesUpdateOutput, mapIntegrationsListOutput, mapIntegrationsListQuery, mapIntegrationsProvidersCreateBody, mapIntegrationsProvidersCreateOutput, mapIntegrationsProvidersDeleteOutput, mapIntegrationsProvidersGetOutput, mapIntegrationsProvidersListOutput, mapIntegrationsProvidersListQuery, mapIntegrationsProvidersUpdateBody, mapIntegrationsProvidersUpdateOutput, mapIntegrationsSetupSessionsCreateBody, mapIntegrationsSetupSessionsCreateOutput, mapIntegrationsSetupSessionsGetOutput, mapIntegrationsSetupSessionsListOutput, mapIntegrationsSetupSessionsListQuery, mapIntegrationsUpdateBody, mapIntegrationsUpdateOutput, mapMagicMcpEndpointsAddServersBody, mapMagicMcpEndpointsAddServersOutput, mapMagicMcpEndpointsCreateBody, mapMagicMcpEndpointsCreateOutput, mapMagicMcpEndpointsDeleteOutput, mapMagicMcpEndpointsGetOutput, mapMagicMcpEndpointsListOutput, mapMagicMcpEndpointsListQuery, mapMagicMcpEndpointsRemoveServersBody, mapMagicMcpEndpointsRemoveServersOutput, mapMagicMcpEndpointsUpdateBody, mapMagicMcpEndpointsUpdateOutput, mapMagicMcpGroupsAddServersBody, mapMagicMcpGroupsAddServersOutput, mapMagicMcpGroupsCreateBody, mapMagicMcpGroupsCreateOutput, mapMagicMcpGroupsDeleteOutput, mapMagicMcpGroupsGetOutput, mapMagicMcpGroupsListOutput, mapMagicMcpGroupsListQuery, mapMagicMcpGroupsRemoveServersBody, mapMagicMcpGroupsRemoveServersOutput, mapMagicMcpGroupsUpdateBody, mapMagicMcpGroupsUpdateOutput, mapMagicMcpServersCreateBody, mapMagicMcpServersCreateOutput, mapMagicMcpServersDeleteOutput, mapMagicMcpServersGetOutput, mapMagicMcpServersListOutput, mapMagicMcpServersListQuery, mapMagicMcpServersProvidersCreateBody, mapMagicMcpServersProvidersCreateOutput, mapMagicMcpServersProvidersDeleteOutput, mapMagicMcpServersProvidersGetOutput, mapMagicMcpServersProvidersListOutput, mapMagicMcpServersProvidersListQuery, mapMagicMcpServersProvidersUpdateBody, mapMagicMcpServersProvidersUpdateOutput, mapMagicMcpServersSessionCreateOutput, mapMagicMcpServersToolsOutput, mapMagicMcpServersUpdateBody, mapMagicMcpServersUpdateOutput, mapMagicMcpSessionsGetOutput, mapMagicMcpSessionsListOutput, mapMagicMcpSessionsListQuery, mapMagicMcpTokensAddGroupsBody, mapMagicMcpTokensAddGroupsOutput, mapMagicMcpTokensCreateBody, mapMagicMcpTokensCreateOutput, mapMagicMcpTokensDeleteOutput, mapMagicMcpTokensGetOutput, mapMagicMcpTokensListOutput, mapMagicMcpTokensListQuery, mapMagicMcpTokensRemoveGroupsBody, mapMagicMcpTokensRemoveGroupsOutput, mapMagicMcpTokensUpdateBody, mapMagicMcpTokensUpdateOutput, mapManagementInstanceAgentsGetOutput, mapManagementInstanceAgentsInstancesGetOutput, mapManagementInstanceAgentsInstancesListOutput, mapManagementInstanceAgentsInstancesListQuery, mapManagementInstanceAgentsListOutput, mapManagementInstanceAgentsListQuery, mapManagementInstanceAssistantsGetOutput, mapManagementInstanceAssistantsListOutput, mapManagementInstanceAssistantsListQuery, mapManagementInstanceCallbackEventsGetOutput, mapManagementInstanceCallbackEventsListOutput, mapManagementInstanceCallbackEventsListQuery, mapManagementInstanceCallbackInstancesGetOutput, mapManagementInstanceCallbackInstancesListOutput, mapManagementInstanceCallbackInstancesListQuery, mapManagementInstanceCallbacksCreateBody, mapManagementInstanceCallbacksCreateOutput, mapManagementInstanceCallbacksDeleteOutput, mapManagementInstanceCallbacksGetOutput, mapManagementInstanceCallbacksListOutput, mapManagementInstanceCallbacksListQuery, mapManagementInstanceCallbacksUpdateBody, mapManagementInstanceCallbacksUpdateOutput, mapManagementInstanceChatConnectionsCreateBody, mapManagementInstanceChatConnectionsCreateOutput, mapManagementInstanceChatConnectionsDeleteOutput, mapManagementInstanceChatConnectionsGetOutput, mapManagementInstanceChatConnectionsListOutput, mapManagementInstanceChatConnectionsListQuery, mapManagementInstanceChatConnectionsUpdateBody, mapManagementInstanceChatConnectionsUpdateOutput, mapManagementInstanceChatEventsGetOutput, mapManagementInstanceChatEventsListOutput, mapManagementInstanceChatEventsListQuery, mapManagementInstanceChatInstancesCreateBody, mapManagementInstanceChatInstancesCreateOutput, mapManagementInstanceChatInstancesDeleteOutput, mapManagementInstanceChatInstancesGetOutput, mapManagementInstanceChatInstancesListOutput, mapManagementInstanceChatInstancesListQuery, mapManagementInstanceChatInstancesProviderAuthenticatedUserOutput, mapManagementInstanceChatInstancesProviderGetOutput, mapManagementInstanceChatInstancesProviderSetBody, mapManagementInstanceChatInstancesProviderSetOutput, mapManagementInstanceChatInstancesSyncOutput, mapManagementInstanceChatInstancesUpdateBody, mapManagementInstanceChatInstancesUpdateOutput, mapManagementInstanceChatWorkspacesGetOutput, mapManagementInstanceChatWorkspacesGetQuery, mapManagementInstanceChatWorkspacesListOutput, mapManagementInstanceChatWorkspacesListQuery, mapManagementInstanceChatsChannelsGetOutput, mapManagementInstanceChatsChannelsListOutput, mapManagementInstanceChatsChannelsListQuery, mapManagementInstanceChatsChannelsMembersGetOutput, mapManagementInstanceChatsChannelsMembersListOutput, mapManagementInstanceChatsChannelsMembersListQuery, mapManagementInstanceChatsChannelsTypingStartBody, mapManagementInstanceChatsChannelsTypingStartOutput, mapManagementInstanceChatsCommandsRespondBody, mapManagementInstanceChatsCommandsRespondOutput, mapManagementInstanceChatsDmsOpenBody, mapManagementInstanceChatsDmsOpenOutput, mapManagementInstanceChatsGetOutput, mapManagementInstanceChatsListOutput, mapManagementInstanceChatsListQuery, mapManagementInstanceChatsMessagesCreateBody, mapManagementInstanceChatsMessagesCreateOutput, mapManagementInstanceChatsMessagesDeleteOutput, mapManagementInstanceChatsMessagesDeleteQuery, mapManagementInstanceChatsMessagesGetOutput, mapManagementInstanceChatsMessagesGetQuery, mapManagementInstanceChatsMessagesListOutput, mapManagementInstanceChatsMessagesListQuery, mapManagementInstanceChatsMessagesReactionsCreateBody, mapManagementInstanceChatsMessagesReactionsCreateOutput, mapManagementInstanceChatsMessagesReactionsDeleteOutput, mapManagementInstanceChatsMessagesReactionsDeleteQuery, mapManagementInstanceChatsMessagesReactionsListOutput, mapManagementInstanceChatsMessagesReactionsListQuery, mapManagementInstanceChatsMessagesReadBody, mapManagementInstanceChatsMessagesReadOutput, mapManagementInstanceChatsMessagesUpdateBody, mapManagementInstanceChatsMessagesUpdateOutput, mapManagementInstanceChatsThreadsGetOutput, mapManagementInstanceChatsThreadsGetQuery, mapManagementInstanceChatsThreadsListOutput, mapManagementInstanceChatsThreadsListQuery, mapManagementInstanceConsumerSurfacesGetOutput, mapManagementInstanceConsumerSurfacesListOutput, mapManagementInstanceConsumerSurfacesListQuery, mapManagementInstanceConsumersCreateBody, mapManagementInstanceConsumersCreateOutput, mapManagementInstanceConsumersGetMemberConsumerBody, mapManagementInstanceConsumersGetMemberConsumerOutput, mapManagementInstanceConsumersGetOutput, mapManagementInstanceConsumersListOutput, mapManagementInstanceConsumersListQuery, mapManagementInstanceConsumersProfilesGetOutput, mapManagementInstanceConsumersProfilesListOutput, mapManagementInstanceConsumersProfilesListQuery, mapManagementInstanceConsumersUpdateBody, mapManagementInstanceConsumersUpdateOutput, mapManagementInstanceConversationsCreateBody, mapManagementInstanceConversationsCreateOutput, mapManagementInstanceConversationsGetOutput, mapManagementInstanceConversationsListOutput, mapManagementInstanceConversationsListQuery, mapManagementInstanceConversationsMessagesCreateBody, mapManagementInstanceConversationsMessagesCreateOutput, mapManagementInstanceConversationsMessagesGetOutput, mapManagementInstanceConversationsMessagesHandoffResponsesBody, mapManagementInstanceConversationsMessagesHandoffResponsesOutput, mapManagementInstanceConversationsMessagesListOutput, mapManagementInstanceConversationsMessagesListQuery, mapManagementInstanceConversationsUpdateBody, mapManagementInstanceConversationsUpdateOutput, mapManagementInstanceCustomProvidersArchiveOutput, mapManagementInstanceCustomProvidersCodeGetCodeEditorTokenOutput, mapManagementInstanceCustomProvidersCommitsCreateBody, mapManagementInstanceCustomProvidersCommitsCreateOutput, mapManagementInstanceCustomProvidersCommitsGetOutput, mapManagementInstanceCustomProvidersCommitsListOutput, mapManagementInstanceCustomProvidersCommitsListQuery, mapManagementInstanceCustomProvidersCreateBody, mapManagementInstanceCustomProvidersCreateOutput, mapManagementInstanceCustomProvidersDeploymentsGetLogsOutput, mapManagementInstanceCustomProvidersDeploymentsGetOutput, mapManagementInstanceCustomProvidersDeploymentsListOutput, mapManagementInstanceCustomProvidersDeploymentsListQuery, mapManagementInstanceCustomProvidersEnvironmentsGetOutput, mapManagementInstanceCustomProvidersEnvironmentsListOutput, mapManagementInstanceCustomProvidersEnvironmentsListQuery, mapManagementInstanceCustomProvidersGetEnvOutput, mapManagementInstanceCustomProvidersGetOutput, mapManagementInstanceCustomProvidersListOutput, mapManagementInstanceCustomProvidersListQuery, mapManagementInstanceCustomProvidersUpdateBody, mapManagementInstanceCustomProvidersUpdateOutput, mapManagementInstanceCustomProvidersVersionsCreateBody, mapManagementInstanceCustomProvidersVersionsCreateOutput, mapManagementInstanceCustomProvidersVersionsGetEnvOutput, mapManagementInstanceCustomProvidersVersionsGetOutput, mapManagementInstanceCustomProvidersVersionsListOutput, mapManagementInstanceCustomProvidersVersionsListQuery, mapManagementInstanceDocumentsCloneBody, mapManagementInstanceDocumentsCloneOutput, mapManagementInstanceDocumentsCreateBody, mapManagementInstanceDocumentsCreateOutput, mapManagementInstanceDocumentsDeleteOutput, mapManagementInstanceDocumentsEditTokenGetOutput, mapManagementInstanceDocumentsGetOutput, mapManagementInstanceDocumentsListOutput, mapManagementInstanceDocumentsListQuery, mapManagementInstanceDocumentsParticipantsGetOutput, mapManagementInstanceDocumentsParticipantsListOutput, mapManagementInstanceDocumentsParticipantsListQuery, mapManagementInstanceDocumentsPermissionsGetOutput, mapManagementInstanceDocumentsUpdateBody, mapManagementInstanceDocumentsUpdateOutput, mapManagementInstanceDocumentsVersionsGetOutput, mapManagementInstanceDocumentsVersionsListOutput, mapManagementInstanceDocumentsVersionsListQuery, mapManagementInstanceFilesDeleteOutput, mapManagementInstanceFilesGetOutput, mapManagementInstanceFilesLinksCreateBody, mapManagementInstanceFilesLinksCreateOutput, mapManagementInstanceFilesLinksDeleteOutput, mapManagementInstanceFilesLinksGetOutput, mapManagementInstanceFilesLinksListOutput, mapManagementInstanceFilesLinksListQuery, mapManagementInstanceFilesListOutput, mapManagementInstanceFilesListQuery, mapManagementInstanceFirewallsCreateBody, mapManagementInstanceFirewallsCreateOutput, mapManagementInstanceFirewallsDeleteOutput, mapManagementInstanceFirewallsGetOutput, mapManagementInstanceFirewallsListOutput, mapManagementInstanceFirewallsListQuery, mapManagementInstanceFirewallsNetworkPoliciesAttachBody, mapManagementInstanceFirewallsNetworkPoliciesAttachOutput, mapManagementInstanceFirewallsNetworkPoliciesDetachOutput, mapManagementInstanceFirewallsUpdateBody, mapManagementInstanceFirewallsUpdateOutput, mapManagementInstanceIdentitiesCreateBody, mapManagementInstanceIdentitiesCreateOutput, mapManagementInstanceIdentitiesCredentialsCreateBody, mapManagementInstanceIdentitiesCredentialsCreateOutput, mapManagementInstanceIdentitiesCredentialsDeleteOutput, mapManagementInstanceIdentitiesCredentialsGetOutput, mapManagementInstanceIdentitiesCredentialsListOutput, mapManagementInstanceIdentitiesCredentialsListQuery, mapManagementInstanceIdentitiesCredentialsUpdateBody, mapManagementInstanceIdentitiesCredentialsUpdateOutput, mapManagementInstanceIdentitiesDelegationConfigsCreateBody, mapManagementInstanceIdentitiesDelegationConfigsCreateOutput, mapManagementInstanceIdentitiesDelegationConfigsDeleteOutput, mapManagementInstanceIdentitiesDelegationConfigsGetOutput, mapManagementInstanceIdentitiesDelegationConfigsListOutput, mapManagementInstanceIdentitiesDelegationConfigsListQuery, mapManagementInstanceIdentitiesDelegationConfigsUpdateBody, mapManagementInstanceIdentitiesDelegationConfigsUpdateOutput, mapManagementInstanceIdentitiesDelegationRequestsApproveOutput, mapManagementInstanceIdentitiesDelegationRequestsApproveQuery, mapManagementInstanceIdentitiesDelegationRequestsCreateBody, mapManagementInstanceIdentitiesDelegationRequestsCreateOutput, mapManagementInstanceIdentitiesDelegationRequestsDenyOutput, mapManagementInstanceIdentitiesDelegationRequestsDenyQuery, mapManagementInstanceIdentitiesDelegationRequestsGetOutput, mapManagementInstanceIdentitiesDelegationRequestsGetQuery, mapManagementInstanceIdentitiesDelegationRequestsListOutput, mapManagementInstanceIdentitiesDelegationRequestsListQuery, mapManagementInstanceIdentitiesDelegationsCreateBody, mapManagementInstanceIdentitiesDelegationsCreateOutput, mapManagementInstanceIdentitiesDelegationsGetOutput, mapManagementInstanceIdentitiesDelegationsListOutput, mapManagementInstanceIdentitiesDelegationsListQuery, mapManagementInstanceIdentitiesDelegationsRevokeOutput, mapManagementInstanceIdentitiesDeleteOutput, mapManagementInstanceIdentitiesGetOutput, mapManagementInstanceIdentitiesListOutput, mapManagementInstanceIdentitiesListQuery, mapManagementInstanceIdentitiesUpdateBody, mapManagementInstanceIdentitiesUpdateOutput, mapManagementInstanceIdentityActorsCreateBody, mapManagementInstanceIdentityActorsCreateOutput, mapManagementInstanceIdentityActorsDeleteOutput, mapManagementInstanceIdentityActorsGetOutput, mapManagementInstanceIdentityActorsListOutput, mapManagementInstanceIdentityActorsListQuery, mapManagementInstanceIdentityActorsUpdateBody, mapManagementInstanceIdentityActorsUpdateOutput, mapManagementInstanceIncomingWebhooksGetOutput, mapManagementInstanceIncomingWebhooksListOutput, mapManagementInstanceIncomingWebhooksListQuery, mapManagementInstanceIntegrationEnclavesGetOutput, mapManagementInstanceIntegrationEnclavesListOutput, mapManagementInstanceIntegrationEnclavesListQuery, mapManagementInstanceIntegrationFirewallAssignmentsCreateBody, mapManagementInstanceIntegrationFirewallAssignmentsCreateOutput, mapManagementInstanceIntegrationFirewallAssignmentsDeleteOutput, mapManagementInstanceIntegrationFirewallAssignmentsGetOutput, mapManagementInstanceIntegrationFirewallAssignmentsListOutput, mapManagementInstanceIntegrationFirewallAssignmentsListQuery, mapManagementInstanceIntegrationInternetGatewayGetOutput, mapManagementInstanceIntegrationInternetGatewayListNetworkLogsOutput, mapManagementInstanceIntegrationInternetGatewayListNetworkLogsQuery, mapManagementInstanceIntegrationsCreateBody, mapManagementInstanceIntegrationsCreateOutput, mapManagementInstanceIntegrationsDeleteOutput, mapManagementInstanceIntegrationsGetOutput, mapManagementInstanceIntegrationsInstanceGroupsCreateBody, mapManagementInstanceIntegrationsInstanceGroupsCreateOutput, mapManagementInstanceIntegrationsInstanceGroupsCreateSessionBody, mapManagementInstanceIntegrationsInstanceGroupsCreateSessionOutput, mapManagementInstanceIntegrationsInstanceGroupsCreateSessionTemplateBody, mapManagementInstanceIntegrationsInstanceGroupsCreateSessionTemplateOutput, mapManagementInstanceIntegrationsInstanceGroupsDeleteOutput, mapManagementInstanceIntegrationsInstanceGroupsGetOutput, mapManagementInstanceIntegrationsInstanceGroupsListOutput, mapManagementInstanceIntegrationsInstanceGroupsListQuery, mapManagementInstanceIntegrationsInstanceGroupsProvidersDeleteOutput, mapManagementInstanceIntegrationsInstanceGroupsProvidersGetOutput, mapManagementInstanceIntegrationsInstanceGroupsProvidersListOutput, mapManagementInstanceIntegrationsInstanceGroupsProvidersListQuery, mapManagementInstanceIntegrationsInstanceGroupsProvidersSetBody, mapManagementInstanceIntegrationsInstanceGroupsProvidersSetOutput, mapManagementInstanceIntegrationsInstanceGroupsUpdateBody, mapManagementInstanceIntegrationsInstanceGroupsUpdateOutput, mapManagementInstanceIntegrationsInstancesCreateBody, mapManagementInstanceIntegrationsInstancesCreateOutput, mapManagementInstanceIntegrationsInstancesCreateSessionBody, mapManagementInstanceIntegrationsInstancesCreateSessionOutput, mapManagementInstanceIntegrationsInstancesCreateSessionTemplateBody, mapManagementInstanceIntegrationsInstancesCreateSessionTemplateOutput, mapManagementInstanceIntegrationsInstancesDeleteOutput, mapManagementInstanceIntegrationsInstancesGetOutput, mapManagementInstanceIntegrationsInstancesListOutput, mapManagementInstanceIntegrationsInstancesListQuery, mapManagementInstanceIntegrationsInstancesProvidersGetOutput, mapManagementInstanceIntegrationsInstancesProvidersListOutput, mapManagementInstanceIntegrationsInstancesProvidersListQuery, mapManagementInstanceIntegrationsInstancesProvidersSetBody, mapManagementInstanceIntegrationsInstancesProvidersSetOutput, mapManagementInstanceIntegrationsInstancesUpdateBody, mapManagementInstanceIntegrationsInstancesUpdateOutput, mapManagementInstanceIntegrationsListOutput, mapManagementInstanceIntegrationsListQuery, mapManagementInstanceIntegrationsProvidersCreateBody, mapManagementInstanceIntegrationsProvidersCreateOutput, mapManagementInstanceIntegrationsProvidersDeleteOutput, mapManagementInstanceIntegrationsProvidersGetOutput, mapManagementInstanceIntegrationsProvidersListOutput, mapManagementInstanceIntegrationsProvidersListQuery, mapManagementInstanceIntegrationsProvidersUpdateBody, mapManagementInstanceIntegrationsProvidersUpdateOutput, mapManagementInstanceIntegrationsSetupSessionsCreateBody, mapManagementInstanceIntegrationsSetupSessionsCreateOutput, mapManagementInstanceIntegrationsSetupSessionsGetOutput, mapManagementInstanceIntegrationsSetupSessionsListOutput, mapManagementInstanceIntegrationsSetupSessionsListQuery, mapManagementInstanceIntegrationsUpdateBody, mapManagementInstanceIntegrationsUpdateOutput, mapManagementInstanceMagicMcpEndpointsAddServersBody, mapManagementInstanceMagicMcpEndpointsAddServersOutput, mapManagementInstanceMagicMcpEndpointsCreateBody, mapManagementInstanceMagicMcpEndpointsCreateOutput, mapManagementInstanceMagicMcpEndpointsDeleteOutput, mapManagementInstanceMagicMcpEndpointsGetOutput, mapManagementInstanceMagicMcpEndpointsListOutput, mapManagementInstanceMagicMcpEndpointsListQuery, mapManagementInstanceMagicMcpEndpointsRemoveServersBody, mapManagementInstanceMagicMcpEndpointsRemoveServersOutput, mapManagementInstanceMagicMcpEndpointsUpdateBody, mapManagementInstanceMagicMcpEndpointsUpdateOutput, mapManagementInstanceMagicMcpGroupsAddServersBody, mapManagementInstanceMagicMcpGroupsAddServersOutput, mapManagementInstanceMagicMcpGroupsCreateBody, mapManagementInstanceMagicMcpGroupsCreateOutput, mapManagementInstanceMagicMcpGroupsDeleteOutput, mapManagementInstanceMagicMcpGroupsGetOutput, mapManagementInstanceMagicMcpGroupsListOutput, mapManagementInstanceMagicMcpGroupsListQuery, mapManagementInstanceMagicMcpGroupsRemoveServersBody, mapManagementInstanceMagicMcpGroupsRemoveServersOutput, mapManagementInstanceMagicMcpGroupsUpdateBody, mapManagementInstanceMagicMcpGroupsUpdateOutput, mapManagementInstanceMagicMcpServersCreateBody, mapManagementInstanceMagicMcpServersCreateOutput, mapManagementInstanceMagicMcpServersDeleteOutput, mapManagementInstanceMagicMcpServersGetOutput, mapManagementInstanceMagicMcpServersListOutput, mapManagementInstanceMagicMcpServersListQuery, mapManagementInstanceMagicMcpServersProvidersCreateBody, mapManagementInstanceMagicMcpServersProvidersCreateOutput, mapManagementInstanceMagicMcpServersProvidersDeleteOutput, mapManagementInstanceMagicMcpServersProvidersGetOutput, mapManagementInstanceMagicMcpServersProvidersListOutput, mapManagementInstanceMagicMcpServersProvidersListQuery, mapManagementInstanceMagicMcpServersProvidersUpdateBody, mapManagementInstanceMagicMcpServersProvidersUpdateOutput, mapManagementInstanceMagicMcpServersSessionCreateOutput, mapManagementInstanceMagicMcpServersToolsOutput, mapManagementInstanceMagicMcpServersUpdateBody, mapManagementInstanceMagicMcpServersUpdateOutput, mapManagementInstanceMagicMcpSessionsGetOutput, mapManagementInstanceMagicMcpSessionsListOutput, mapManagementInstanceMagicMcpSessionsListQuery, mapManagementInstanceMagicMcpTokensAddGroupsBody, mapManagementInstanceMagicMcpTokensAddGroupsOutput, mapManagementInstanceMagicMcpTokensCreateBody, mapManagementInstanceMagicMcpTokensCreateOutput, mapManagementInstanceMagicMcpTokensDeleteOutput, mapManagementInstanceMagicMcpTokensGetOutput, mapManagementInstanceMagicMcpTokensListOutput, mapManagementInstanceMagicMcpTokensListQuery, mapManagementInstanceMagicMcpTokensRemoveGroupsBody, mapManagementInstanceMagicMcpTokensRemoveGroupsOutput, mapManagementInstanceMagicMcpTokensUpdateBody, mapManagementInstanceMagicMcpTokensUpdateOutput, mapManagementInstanceMonitorAlertsGetOutput, mapManagementInstanceMonitorAlertsListOutput, mapManagementInstanceMonitorAlertsListQuery, mapManagementInstanceMonitorAlertsResolveOutput, mapManagementInstanceMonitorAlertsUnresolveOutput, mapManagementInstanceMonitorAlertsViewedOutput, mapManagementInstanceMonitorsGetOutput, mapManagementInstanceMonitorsListOutput, mapManagementInstanceMonitorsListQuery, mapManagementInstanceNetworkPoliciesCreateBody, mapManagementInstanceNetworkPoliciesCreateOutput, mapManagementInstanceNetworkPoliciesDeleteOutput, mapManagementInstanceNetworkPoliciesGetOutput, mapManagementInstanceNetworkPoliciesListOutput, mapManagementInstanceNetworkPoliciesListQuery, mapManagementInstanceNetworkPoliciesRulesCreateBody, mapManagementInstanceNetworkPoliciesRulesCreateOutput, mapManagementInstanceNetworkPoliciesRulesDeleteOutput, mapManagementInstanceNetworkPoliciesRulesUpdateBody, mapManagementInstanceNetworkPoliciesRulesUpdateOutput, mapManagementInstanceNetworkPoliciesUpdateBody, mapManagementInstanceNetworkPoliciesUpdateOutput, mapManagementInstancePortalsAccessCreateBody, mapManagementInstancePortalsAccessCreateOutput, mapManagementInstancePortalsAccessDeleteOutput, mapManagementInstancePortalsAccessGetOutput, mapManagementInstancePortalsAccessListOutput, mapManagementInstancePortalsAccessListQuery, mapManagementInstancePortalsAccessRequestsGetOutput, mapManagementInstancePortalsAccessRequestsListOutput, mapManagementInstancePortalsAccessRequestsListQuery, mapManagementInstancePortalsAccessRequestsUpdateBody, mapManagementInstancePortalsAccessRequestsUpdateOutput, mapManagementInstancePortalsAccessUpdateBody, mapManagementInstancePortalsAccessUpdateOutput, mapManagementInstancePortalsConsumerGroupsCreateBody, mapManagementInstancePortalsConsumerGroupsCreateOutput, mapManagementInstancePortalsConsumerGroupsDeleteOutput, mapManagementInstancePortalsConsumerGroupsGetOutput, mapManagementInstancePortalsConsumerGroupsListOutput, mapManagementInstancePortalsConsumerGroupsListQuery, mapManagementInstancePortalsConsumerGroupsUpdateBody, mapManagementInstancePortalsConsumerGroupsUpdateOutput, mapManagementInstancePortalsConsumerInvitesCreateBody, mapManagementInstancePortalsConsumerInvitesCreateOutput, mapManagementInstancePortalsConsumerInvitesGetOutput, mapManagementInstancePortalsConsumerInvitesListOutput, mapManagementInstancePortalsConsumerInvitesListQuery, mapManagementInstancePortalsConsumerProfilesAssignGroupsBody, mapManagementInstancePortalsConsumerProfilesAssignGroupsOutput, mapManagementInstancePortalsConsumerProfilesCreateBody, mapManagementInstancePortalsConsumerProfilesCreateOutput, mapManagementInstancePortalsConsumerProfilesDeleteOutput, mapManagementInstancePortalsConsumerProfilesGetOutput, mapManagementInstancePortalsConsumerProfilesListOutput, mapManagementInstancePortalsConsumerProfilesListQuery, mapManagementInstancePortalsConsumerProfilesUnassignGroupsBody, mapManagementInstancePortalsConsumerProfilesUnassignGroupsOutput, mapManagementInstancePortalsCreateBody, mapManagementInstancePortalsCreateOutput, mapManagementInstancePortalsDeleteOutput, mapManagementInstancePortalsGetOutput, mapManagementInstancePortalsListOutput, mapManagementInstancePortalsListQuery, mapManagementInstancePortalsListingsCreateBody, mapManagementInstancePortalsListingsCreateOutput, mapManagementInstancePortalsListingsDeleteOutput, mapManagementInstancePortalsListingsGetOutput, mapManagementInstancePortalsListingsListOutput, mapManagementInstancePortalsListingsListQuery, mapManagementInstancePortalsListingsUpdateBody, mapManagementInstancePortalsListingsUpdateOutput, mapManagementInstancePortalsSurfaceProviderGroupsAddListingBody, mapManagementInstancePortalsSurfaceProviderGroupsAddListingOutput, mapManagementInstancePortalsSurfaceProviderGroupsCreateBody, mapManagementInstancePortalsSurfaceProviderGroupsCreateOutput, mapManagementInstancePortalsSurfaceProviderGroupsDeleteOutput, mapManagementInstancePortalsSurfaceProviderGroupsGetOutput, mapManagementInstancePortalsSurfaceProviderGroupsListOutput, mapManagementInstancePortalsSurfaceProviderGroupsListQuery, mapManagementInstancePortalsSurfaceProviderGroupsRemoveListingOutput, mapManagementInstancePortalsSurfaceProviderGroupsUpdateBody, mapManagementInstancePortalsSurfaceProviderGroupsUpdateOutput, mapManagementInstancePortalsUpdateBody, mapManagementInstancePortalsUpdateOutput, mapManagementInstanceProtoGuardAlertsGetOutput, mapManagementInstanceProtoGuardAlertsListOutput, mapManagementInstanceProtoGuardAlertsListQuery, mapManagementInstanceProtoGuardConfigGetOutput, mapManagementInstanceProtoGuardConfigSetAlertFilterCountThresholdBody, mapManagementInstanceProtoGuardConfigSetAlertFilterCountThresholdOutput, mapManagementInstanceProtoGuardConfigUpdateFilterBody, mapManagementInstanceProtoGuardConfigUpdateFilterOutput, mapManagementInstanceProviderAuthConfigErrorsGetOutput, mapManagementInstanceProviderAuthConfigErrorsGroupsGetOutput, mapManagementInstanceProviderAuthConfigErrorsGroupsListOutput, mapManagementInstanceProviderAuthConfigErrorsGroupsListQuery, mapManagementInstanceProviderAuthConfigErrorsListOutput, mapManagementInstanceProviderAuthConfigErrorsListQuery, mapManagementInstanceProviderAuthConfigEventsGetOutput, mapManagementInstanceProviderAuthConfigEventsListOutput, mapManagementInstanceProviderAuthConfigEventsListQuery, mapManagementInstanceProviderCategoriesGetOutput, mapManagementInstanceProviderCategoriesListOutput, mapManagementInstanceProviderCategoriesListQuery, mapManagementInstanceProviderCollectionsGetOutput, mapManagementInstanceProviderCollectionsListOutput, mapManagementInstanceProviderCollectionsListQuery, mapManagementInstanceProviderDeploymentsAuthConfigsCreateBody, mapManagementInstanceProviderDeploymentsAuthConfigsCreateOutput, mapManagementInstanceProviderDeploymentsAuthConfigsDeleteOutput, mapManagementInstanceProviderDeploymentsAuthConfigsExportsCreateBody, mapManagementInstanceProviderDeploymentsAuthConfigsExportsCreateOutput, mapManagementInstanceProviderDeploymentsAuthConfigsExportsGetOutput, mapManagementInstanceProviderDeploymentsAuthConfigsExportsListOutput, mapManagementInstanceProviderDeploymentsAuthConfigsExportsListQuery, mapManagementInstanceProviderDeploymentsAuthConfigsGetOutput, mapManagementInstanceProviderDeploymentsAuthConfigsImportsCreateBody, mapManagementInstanceProviderDeploymentsAuthConfigsImportsCreateOutput, mapManagementInstanceProviderDeploymentsAuthConfigsImportsGetOutput, mapManagementInstanceProviderDeploymentsAuthConfigsImportsGetSchemaOutput, mapManagementInstanceProviderDeploymentsAuthConfigsImportsGetSchemaQuery, mapManagementInstanceProviderDeploymentsAuthConfigsImportsListOutput, mapManagementInstanceProviderDeploymentsAuthConfigsImportsListQuery, mapManagementInstanceProviderDeploymentsAuthConfigsListOutput, mapManagementInstanceProviderDeploymentsAuthConfigsListQuery, mapManagementInstanceProviderDeploymentsAuthConfigsUpdateBody, mapManagementInstanceProviderDeploymentsAuthConfigsUpdateOutput, mapManagementInstanceProviderDeploymentsAuthCredentialsCreateBody, mapManagementInstanceProviderDeploymentsAuthCredentialsCreateOutput, mapManagementInstanceProviderDeploymentsAuthCredentialsDeleteOutput, mapManagementInstanceProviderDeploymentsAuthCredentialsGetOutput, mapManagementInstanceProviderDeploymentsAuthCredentialsListOutput, mapManagementInstanceProviderDeploymentsAuthCredentialsListQuery, mapManagementInstanceProviderDeploymentsAuthCredentialsUpdateBody, mapManagementInstanceProviderDeploymentsAuthCredentialsUpdateOutput, mapManagementInstanceProviderDeploymentsConfigVaultsCreateBody, mapManagementInstanceProviderDeploymentsConfigVaultsCreateOutput, mapManagementInstanceProviderDeploymentsConfigVaultsDeleteOutput, mapManagementInstanceProviderDeploymentsConfigVaultsGetOutput, mapManagementInstanceProviderDeploymentsConfigVaultsListOutput, mapManagementInstanceProviderDeploymentsConfigVaultsListQuery, mapManagementInstanceProviderDeploymentsConfigVaultsUpdateBody, mapManagementInstanceProviderDeploymentsConfigVaultsUpdateOutput, mapManagementInstanceProviderDeploymentsConfigsCreateBody, mapManagementInstanceProviderDeploymentsConfigsCreateOutput, mapManagementInstanceProviderDeploymentsConfigsDeleteOutput, mapManagementInstanceProviderDeploymentsConfigsGetConfigSchemaOutput, mapManagementInstanceProviderDeploymentsConfigsGetConfigSchemaQuery, mapManagementInstanceProviderDeploymentsConfigsGetOutput, mapManagementInstanceProviderDeploymentsConfigsGetValueOutput, mapManagementInstanceProviderDeploymentsConfigsListOutput, mapManagementInstanceProviderDeploymentsConfigsListQuery, mapManagementInstanceProviderDeploymentsConfigsUpdateBody, mapManagementInstanceProviderDeploymentsConfigsUpdateOutput, mapManagementInstanceProviderDeploymentsCreateBody, mapManagementInstanceProviderDeploymentsCreateOutput, mapManagementInstanceProviderDeploymentsDeleteOutput, mapManagementInstanceProviderDeploymentsGetOutput, mapManagementInstanceProviderDeploymentsListOutput, mapManagementInstanceProviderDeploymentsListQuery, mapManagementInstanceProviderDeploymentsSetupSessionsCreateBody, mapManagementInstanceProviderDeploymentsSetupSessionsCreateOutput, mapManagementInstanceProviderDeploymentsSetupSessionsDeleteOutput, mapManagementInstanceProviderDeploymentsSetupSessionsGetOutput, mapManagementInstanceProviderDeploymentsSetupSessionsListOutput, mapManagementInstanceProviderDeploymentsSetupSessionsListQuery, mapManagementInstanceProviderDeploymentsSetupSessionsUpdateBody, mapManagementInstanceProviderDeploymentsSetupSessionsUpdateOutput, mapManagementInstanceProviderDeploymentsUpdateBody, mapManagementInstanceProviderDeploymentsUpdateOutput, mapManagementInstanceProviderGroupsAddListingBody, mapManagementInstanceProviderGroupsAddListingOutput, mapManagementInstanceProviderGroupsCreateBody, mapManagementInstanceProviderGroupsCreateOutput, mapManagementInstanceProviderGroupsGetOutput, mapManagementInstanceProviderGroupsListOutput, mapManagementInstanceProviderGroupsListQuery, mapManagementInstanceProviderGroupsRemoveListingOutput, mapManagementInstanceProviderGroupsUpdateBody, mapManagementInstanceProviderGroupsUpdateOutput, mapManagementInstanceProviderInvocationsGetOutput, mapManagementInstanceProviderInvocationsListOutput, mapManagementInstanceProviderInvocationsListQuery, mapManagementInstanceProviderListingsGetOutput, mapManagementInstanceProviderListingsListOutput, mapManagementInstanceProviderListingsListQuery, mapManagementInstanceProviderListingsResetOutput, mapManagementInstanceProviderListingsUpdateBody, mapManagementInstanceProviderListingsUpdateOutput, mapManagementInstanceProviderRunsGetLogsOutput, mapManagementInstanceProviderRunsGetOutput, mapManagementInstanceProviderRunsListOutput, mapManagementInstanceProviderRunsListQuery, mapManagementInstanceProviderSpecificationChangeNotificationsGetOutput, mapManagementInstanceProviderSpecificationChangeNotificationsListOutput, mapManagementInstanceProviderSpecificationChangeNotificationsListQuery, mapManagementInstanceProviderTemplatesCreateBody, mapManagementInstanceProviderTemplatesCreateOutput, mapManagementInstanceProviderTemplatesDeleteOutput, mapManagementInstanceProviderTemplatesGetOutput, mapManagementInstanceProviderTemplatesListOutput, mapManagementInstanceProviderTemplatesListQuery, mapManagementInstanceProviderTemplatesUpdateBody, mapManagementInstanceProviderTemplatesUpdateOutput, mapManagementInstanceProvidersAuthMethodsGetOutput, mapManagementInstanceProvidersAuthMethodsListOutput, mapManagementInstanceProvidersAuthMethodsListQuery, mapManagementInstanceProvidersGetOutput, mapManagementInstanceProvidersListOutput, mapManagementInstanceProvidersListQuery, mapManagementInstanceProvidersSpecificationsGetOutput, mapManagementInstanceProvidersSpecificationsListOutput, mapManagementInstanceProvidersSpecificationsListQuery, mapManagementInstanceProvidersToolsGetOutput, mapManagementInstanceProvidersToolsListOutput, mapManagementInstanceProvidersToolsListQuery, mapManagementInstanceProvidersTriggersGetOutput, mapManagementInstanceProvidersTriggersListOutput, mapManagementInstanceProvidersTriggersListQuery, mapManagementInstanceProvidersVersionsGetOutput, mapManagementInstanceProvidersVersionsListOutput, mapManagementInstanceProvidersVersionsListQuery, mapManagementInstancePublicMcpServersClientsListOutput, mapManagementInstancePublicMcpServersClientsListQuery, mapManagementInstancePublicMcpServersCreateBody, mapManagementInstancePublicMcpServersCreateOutput, mapManagementInstancePublicMcpServersDeleteOutput, mapManagementInstancePublicMcpServersGetOutput, mapManagementInstancePublicMcpServersGrantsGetOutput, mapManagementInstancePublicMcpServersGrantsListOutput, mapManagementInstancePublicMcpServersGrantsListQuery, mapManagementInstancePublicMcpServersGrantsRevokeOutput, mapManagementInstancePublicMcpServersListOutput, mapManagementInstancePublicMcpServersListQuery, mapManagementInstancePublicMcpServersSlugsCheckOutput, mapManagementInstancePublicMcpServersSlugsCheckQuery, mapManagementInstancePublicMcpServersUpdateBody, mapManagementInstancePublicMcpServersUpdateOutput, mapManagementInstancePublishersGetOutput, mapManagementInstancePublishersListOutput, mapManagementInstancePublishersListQuery, mapManagementInstanceSandboxDisksCloneBody, mapManagementInstanceSandboxDisksCloneOutput, mapManagementInstanceSandboxDisksCreateBody, mapManagementInstanceSandboxDisksCreateOutput, mapManagementInstanceSandboxDisksDeleteOutput, mapManagementInstanceSandboxDisksGetOutput, mapManagementInstanceSandboxDisksListOutput, mapManagementInstanceSandboxDisksListQuery, mapManagementInstanceSandboxDisksMountsListOutput, mapManagementInstanceSandboxDisksMountsListQuery, mapManagementInstanceSandboxDisksResizeBody, mapManagementInstanceSandboxDisksResizeOutput, mapManagementInstanceSandboxDisksResizesGetOutput, mapManagementInstanceSandboxDisksResizesListOutput, mapManagementInstanceSandboxDisksResizesListQuery, mapManagementInstanceSandboxDisksResizesRetryOutput, mapManagementInstanceSandboxDisksUpdateBody, mapManagementInstanceSandboxDisksUpdateOutput, mapManagementInstanceSandboxImageBuildsCancelOutput, mapManagementInstanceSandboxImageBuildsGetOutput, mapManagementInstanceSandboxImageBuildsListOutput, mapManagementInstanceSandboxImageBuildsListQuery, mapManagementInstanceSandboxImageBuildsLogsOutput, mapManagementInstanceSandboxImageBuildsLogsQuery, mapManagementInstanceSandboxImagesBuildsCreateBody, mapManagementInstanceSandboxImagesBuildsCreateOutput, mapManagementInstanceSandboxImagesBuildsListOutput, mapManagementInstanceSandboxImagesBuildsListQuery, mapManagementInstanceSandboxImagesCreateBody, mapManagementInstanceSandboxImagesCreateOutput, mapManagementInstanceSandboxImagesDeleteOutput, mapManagementInstanceSandboxImagesGetOutput, mapManagementInstanceSandboxImagesListOutput, mapManagementInstanceSandboxImagesListQuery, mapManagementInstanceSandboxImagesUpdateBody, mapManagementInstanceSandboxImagesUpdateOutput, mapManagementInstanceSandboxImagesVersionsGetOutput, mapManagementInstanceSandboxImagesVersionsListOutput, mapManagementInstanceSandboxImagesVersionsListQuery, mapManagementInstanceSandboxMachinesAccessFilesBody, mapManagementInstanceSandboxMachinesAccessFilesOutput, mapManagementInstanceSandboxMachinesAccessPortsBody, mapManagementInstanceSandboxMachinesAccessPortsOutput, mapManagementInstanceSandboxMachinesAccessShellBody, mapManagementInstanceSandboxMachinesAccessShellOutput, mapManagementInstanceSandboxMachinesCreateBody, mapManagementInstanceSandboxMachinesCreateOutput, mapManagementInstanceSandboxMachinesDeleteOutput, mapManagementInstanceSandboxMachinesErrorsGetOutput, mapManagementInstanceSandboxMachinesErrorsListOutput, mapManagementInstanceSandboxMachinesErrorsListQuery, mapManagementInstanceSandboxMachinesEventsGetOutput, mapManagementInstanceSandboxMachinesEventsListOutput, mapManagementInstanceSandboxMachinesEventsListQuery, mapManagementInstanceSandboxMachinesExecBody, mapManagementInstanceSandboxMachinesExecOutput, mapManagementInstanceSandboxMachinesGetOutput, mapManagementInstanceSandboxMachinesHibernateOutput, mapManagementInstanceSandboxMachinesInstancesGetOutput, mapManagementInstanceSandboxMachinesInstancesListOutput, mapManagementInstanceSandboxMachinesInstancesListQuery, mapManagementInstanceSandboxMachinesInstancesLogsOutput, mapManagementInstanceSandboxMachinesInstancesLogsQuery, mapManagementInstanceSandboxMachinesListOutput, mapManagementInstanceSandboxMachinesListQuery, mapManagementInstanceSandboxMachinesOperationsGetOutput, mapManagementInstanceSandboxMachinesOperationsListOutput, mapManagementInstanceSandboxMachinesOperationsListQuery, mapManagementInstanceSandboxMachinesPauseOutput, mapManagementInstanceSandboxMachinesRestartOutput, mapManagementInstanceSandboxMachinesStartOutput, mapManagementInstanceSandboxMachinesTouchOutput, mapManagementInstanceSandboxMachinesUpdateBody, mapManagementInstanceSandboxMachinesUpdateOutput, mapManagementInstanceSandboxMachinesUsageOutput, mapManagementInstanceSandboxMachinesUsageQuery, mapManagementInstanceSandboxMachinesUsageSummaryOutput, mapManagementInstanceSandboxMachinesUsageSummaryQuery, mapManagementInstanceSandboxMachinesUsageTimelineOutput, mapManagementInstanceSandboxMachinesUsageTimelineQuery, mapManagementInstanceSandboxRegionsGetOutput, mapManagementInstanceSandboxRegionsListOutput, mapManagementInstanceSandboxRegionsListQuery, mapManagementInstanceSandboxSpecsGetOutput, mapManagementInstanceSandboxSpecsListOutput, mapManagementInstanceSandboxSpecsListQuery, mapManagementInstanceScmAccountsPreviewBody, mapManagementInstanceScmAccountsPreviewOutput, mapManagementInstanceScmConnectionsCreateBody, mapManagementInstanceScmConnectionsCreateOutput, mapManagementInstanceScmConnectionsGetOutput, mapManagementInstanceScmConnectionsListOutput, mapManagementInstanceScmConnectionsListQuery, mapManagementInstanceScmInstallationCreateBody, mapManagementInstanceScmInstallationCreateOutput, mapManagementInstanceScmInstallationListOutput, mapManagementInstanceScmInstallationListQuery, mapManagementInstanceScmProvidersCreateBody, mapManagementInstanceScmProvidersCreateOutput, mapManagementInstanceScmProvidersGetOutput, mapManagementInstanceScmProvidersListOutput, mapManagementInstanceScmProvidersListQuery, mapManagementInstanceScmReposCreateBody, mapManagementInstanceScmReposCreateOutput, mapManagementInstanceScmReposGetOutput, mapManagementInstanceScmReposListOutput, mapManagementInstanceScmReposListQuery, mapManagementInstanceScmReposPreviewBody, mapManagementInstanceScmReposPreviewOutput, mapManagementInstanceSessionTemplatesCreateBody, mapManagementInstanceSessionTemplatesCreateOutput, mapManagementInstanceSessionTemplatesDeleteOutput, mapManagementInstanceSessionTemplatesGetOutput, mapManagementInstanceSessionTemplatesListOutput, mapManagementInstanceSessionTemplatesListQuery, mapManagementInstanceSessionTemplatesListToolsOutput, mapManagementInstanceSessionTemplatesProvidersCreateBody, mapManagementInstanceSessionTemplatesProvidersCreateOutput, mapManagementInstanceSessionTemplatesProvidersDeleteOutput, mapManagementInstanceSessionTemplatesProvidersGetOutput, mapManagementInstanceSessionTemplatesProvidersListOutput, mapManagementInstanceSessionTemplatesProvidersListQuery, mapManagementInstanceSessionTemplatesProvidersUpdateBody, mapManagementInstanceSessionTemplatesProvidersUpdateOutput, mapManagementInstanceSessionTemplatesUpdateBody, mapManagementInstanceSessionTemplatesUpdateOutput, mapManagementInstanceSessionsConnectionsGetOutput, mapManagementInstanceSessionsConnectionsListOutput, mapManagementInstanceSessionsConnectionsListQuery, mapManagementInstanceSessionsCreateBody, mapManagementInstanceSessionsCreateOutput, mapManagementInstanceSessionsDeleteOutput, mapManagementInstanceSessionsErrorGroupsGetOutput, mapManagementInstanceSessionsErrorGroupsListOutput, mapManagementInstanceSessionsErrorGroupsListQuery, mapManagementInstanceSessionsErrorsGetOutput, mapManagementInstanceSessionsErrorsListOutput, mapManagementInstanceSessionsErrorsListQuery, mapManagementInstanceSessionsEventsGetOutput, mapManagementInstanceSessionsEventsListOutput, mapManagementInstanceSessionsEventsListQuery, mapManagementInstanceSessionsGetOutput, mapManagementInstanceSessionsListOutput, mapManagementInstanceSessionsListQuery, mapManagementInstanceSessionsMessagesGetOutput, mapManagementInstanceSessionsMessagesListOutput, mapManagementInstanceSessionsMessagesListQuery, mapManagementInstanceSessionsParticipantsGetOutput, mapManagementInstanceSessionsParticipantsListOutput, mapManagementInstanceSessionsParticipantsListQuery, mapManagementInstanceSessionsProvidersCreateBody, mapManagementInstanceSessionsProvidersCreateOutput, mapManagementInstanceSessionsProvidersDeleteOutput, mapManagementInstanceSessionsProvidersGetOutput, mapManagementInstanceSessionsProvidersListOutput, mapManagementInstanceSessionsProvidersListQuery, mapManagementInstanceSessionsProvidersUpdateBody, mapManagementInstanceSessionsProvidersUpdateOutput, mapManagementInstanceSessionsUpdateBody, mapManagementInstanceSessionsUpdateOutput, mapManagementInstanceSkillsAgentsCreateBody, mapManagementInstanceSkillsAgentsCreateOutput, mapManagementInstanceSkillsAgentsDeleteOutput, mapManagementInstanceSkillsAgentsGetOutput, mapManagementInstanceSkillsAgentsListOutput, mapManagementInstanceSkillsAgentsListQuery, mapManagementInstanceSkillsAgentsUpdateBody, mapManagementInstanceSkillsAgentsUpdateOutput, mapManagementInstanceSkillsConfigurationsCreateBody, mapManagementInstanceSkillsConfigurationsCreateOutput, mapManagementInstanceSkillsConfigurationsDeleteOutput, mapManagementInstanceSkillsConfigurationsGetOutput, mapManagementInstanceSkillsConfigurationsListOutput, mapManagementInstanceSkillsConfigurationsListQuery, mapManagementInstanceSkillsConfigurationsUpdateBody, mapManagementInstanceSkillsConfigurationsUpdateOutput, mapManagementInstanceSkillsCreateBody, mapManagementInstanceSkillsCreateOutput, mapManagementInstanceSkillsDeleteOutput, mapManagementInstanceSkillsDuplicateBody, mapManagementInstanceSkillsDuplicateOutput, mapManagementInstanceSkillsExportsCreateBody, mapManagementInstanceSkillsExportsCreateOutput, mapManagementInstanceSkillsExportsGetOutput, mapManagementInstanceSkillsExportsListOutput, mapManagementInstanceSkillsExportsListQuery, mapManagementInstanceSkillsFilesBatchBody, mapManagementInstanceSkillsFilesBatchOutput, mapManagementInstanceSkillsFilesDeleteOutput, mapManagementInstanceSkillsFilesDeleteQuery, mapManagementInstanceSkillsFilesGetOutput, mapManagementInstanceSkillsFilesGetQuery, mapManagementInstanceSkillsFilesListOutput, mapManagementInstanceSkillsFilesMoveBody, mapManagementInstanceSkillsFilesMoveOutput, mapManagementInstanceSkillsFilesPutBody, mapManagementInstanceSkillsFilesPutOutput, mapManagementInstanceSkillsForkBody, mapManagementInstanceSkillsForkOutput, mapManagementInstanceSkillsForkSyncsCreateBody, mapManagementInstanceSkillsForkSyncsCreateOutput, mapManagementInstanceSkillsForkSyncsGetOutput, mapManagementInstanceSkillsGetOutput, mapManagementInstanceSkillsGroupsCreateBody, mapManagementInstanceSkillsGroupsCreateOutput, mapManagementInstanceSkillsGroupsDeleteOutput, mapManagementInstanceSkillsGroupsGetOutput, mapManagementInstanceSkillsGroupsItemsCreateBody, mapManagementInstanceSkillsGroupsItemsCreateOutput, mapManagementInstanceSkillsGroupsItemsDeleteOutput, mapManagementInstanceSkillsGroupsItemsGetOutput, mapManagementInstanceSkillsGroupsItemsListOutput, mapManagementInstanceSkillsGroupsItemsListQuery, mapManagementInstanceSkillsGroupsListOutput, mapManagementInstanceSkillsGroupsListQuery, mapManagementInstanceSkillsGroupsUpdateBody, mapManagementInstanceSkillsGroupsUpdateOutput, mapManagementInstanceSkillsImportsCreateBody, mapManagementInstanceSkillsImportsCreateOutput, mapManagementInstanceSkillsImportsGetOutput, mapManagementInstanceSkillsImportsListOutput, mapManagementInstanceSkillsImportsListQuery, mapManagementInstanceSkillsItemsCreateBody, mapManagementInstanceSkillsItemsCreateOutput, mapManagementInstanceSkillsItemsDeleteOutput, mapManagementInstanceSkillsItemsGetOutput, mapManagementInstanceSkillsItemsListOutput, mapManagementInstanceSkillsItemsListQuery, mapManagementInstanceSkillsListOutput, mapManagementInstanceSkillsListQuery, mapManagementInstanceSkillsMarketplacesArchiveOutput, mapManagementInstanceSkillsMarketplacesCreateBody, mapManagementInstanceSkillsMarketplacesCreateOutput, mapManagementInstanceSkillsMarketplacesGetEditorUrlBody, mapManagementInstanceSkillsMarketplacesGetEditorUrlOutput, mapManagementInstanceSkillsMarketplacesGetOutput, mapManagementInstanceSkillsMarketplacesListOutput, mapManagementInstanceSkillsMarketplacesListQuery, mapManagementInstanceSkillsMarketplacesPluginsAddBody, mapManagementInstanceSkillsMarketplacesPluginsAddOutput, mapManagementInstanceSkillsMarketplacesPluginsGetOutput, mapManagementInstanceSkillsMarketplacesPluginsListOutput, mapManagementInstanceSkillsMarketplacesPluginsListQuery, mapManagementInstanceSkillsMarketplacesPluginsRemoveOutput, mapManagementInstanceSkillsMarketplacesRepositoriesCreateBody, mapManagementInstanceSkillsMarketplacesRepositoriesCreateOutput, mapManagementInstanceSkillsMarketplacesRepositoriesDeleteOutput, mapManagementInstanceSkillsMarketplacesRepositoriesGetOutput, mapManagementInstanceSkillsMarketplacesRepositoriesListOutput, mapManagementInstanceSkillsMarketplacesRepositoriesListQuery, mapManagementInstanceSkillsMarketplacesSyncBody, mapManagementInstanceSkillsMarketplacesSyncOutput, mapManagementInstanceSkillsMarketplacesUpdateBody, mapManagementInstanceSkillsMarketplacesUpdateOutput, mapManagementInstanceSkillsMergeRequestsCloseOutput, mapManagementInstanceSkillsMergeRequestsCommentsCreateBody, mapManagementInstanceSkillsMergeRequestsCommentsCreateOutput, mapManagementInstanceSkillsMergeRequestsCommentsDeleteOutput, mapManagementInstanceSkillsMergeRequestsCommentsGetOutput, mapManagementInstanceSkillsMergeRequestsCommentsListOutput, mapManagementInstanceSkillsMergeRequestsCommentsListQuery, mapManagementInstanceSkillsMergeRequestsCommentsUpdateBody, mapManagementInstanceSkillsMergeRequestsCommentsUpdateOutput, mapManagementInstanceSkillsMergeRequestsCreateBody, mapManagementInstanceSkillsMergeRequestsCreateOutput, mapManagementInstanceSkillsMergeRequestsEventsGetOutput, mapManagementInstanceSkillsMergeRequestsEventsListOutput, mapManagementInstanceSkillsMergeRequestsEventsListQuery, mapManagementInstanceSkillsMergeRequestsGetOutput, mapManagementInstanceSkillsMergeRequestsItemsBulkResolveBody, mapManagementInstanceSkillsMergeRequestsItemsBulkResolveOutput, mapManagementInstanceSkillsMergeRequestsItemsResolveBody, mapManagementInstanceSkillsMergeRequestsItemsResolveOutput, mapManagementInstanceSkillsMergeRequestsListOutput, mapManagementInstanceSkillsMergeRequestsListQuery, mapManagementInstanceSkillsMergeRequestsPerformOutput, mapManagementInstanceSkillsMergeRequestsPlanGetOutput, mapManagementInstanceSkillsMergeRequestsRollbackOutput, mapManagementInstanceSkillsParticipantsGetOutput, mapManagementInstanceSkillsParticipantsListOutput, mapManagementInstanceSkillsParticipantsListQuery, mapManagementInstanceSkillsPluginsArchiveOutput, mapManagementInstanceSkillsPluginsCreateBody, mapManagementInstanceSkillsPluginsCreateOutput, mapManagementInstanceSkillsPluginsGetEditorUrlBody, mapManagementInstanceSkillsPluginsGetEditorUrlOutput, mapManagementInstanceSkillsPluginsGetOutput, mapManagementInstanceSkillsPluginsListOutput, mapManagementInstanceSkillsPluginsListQuery, mapManagementInstanceSkillsPluginsRepositoriesCreateBody, mapManagementInstanceSkillsPluginsRepositoriesCreateOutput, mapManagementInstanceSkillsPluginsRepositoriesDeleteOutput, mapManagementInstanceSkillsPluginsRepositoriesGetOutput, mapManagementInstanceSkillsPluginsRepositoriesListOutput, mapManagementInstanceSkillsPluginsRepositoriesListQuery, mapManagementInstanceSkillsPluginsSkillsAddBody, mapManagementInstanceSkillsPluginsSkillsAddOutput, mapManagementInstanceSkillsPluginsSkillsGetOutput, mapManagementInstanceSkillsPluginsSkillsListOutput, mapManagementInstanceSkillsPluginsSkillsListQuery, mapManagementInstanceSkillsPluginsSkillsRemoveOutput, mapManagementInstanceSkillsPluginsSkillsUpdateBody, mapManagementInstanceSkillsPluginsSkillsUpdateOutput, mapManagementInstanceSkillsPluginsSyncBody, mapManagementInstanceSkillsPluginsSyncOutput, mapManagementInstanceSkillsPluginsUpdateBody, mapManagementInstanceSkillsPluginsUpdateOutput, mapManagementInstanceSkillsPublishConsumerSkillOutput, mapManagementInstanceSkillsShareBody, mapManagementInstanceSkillsShareOutput, mapManagementInstanceSkillsTemplatesCreateBody, mapManagementInstanceSkillsTemplatesCreateOutput, mapManagementInstanceSkillsTemplatesDeleteOutput, mapManagementInstanceSkillsTemplatesGetOutput, mapManagementInstanceSkillsTemplatesItemsCreateBody, mapManagementInstanceSkillsTemplatesItemsCreateOutput, mapManagementInstanceSkillsTemplatesItemsDeleteOutput, mapManagementInstanceSkillsTemplatesItemsGetOutput, mapManagementInstanceSkillsTemplatesItemsListOutput, mapManagementInstanceSkillsTemplatesItemsListQuery, mapManagementInstanceSkillsTemplatesListOutput, mapManagementInstanceSkillsTemplatesListQuery, mapManagementInstanceSkillsTemplatesUpdateBody, mapManagementInstanceSkillsTemplatesUpdateOutput, mapManagementInstanceSkillsUpdateBody, mapManagementInstanceSkillsUpdateOutput, mapManagementInstanceSkillsVersionsGetOutput, mapManagementInstanceSkillsVersionsListOutput, mapManagementInstanceSkillsVersionsListQuery, mapManagementInstanceSkillsVersionsSnapshotGetOutput, mapManagementInstanceStoresCreateBody, mapManagementInstanceStoresCreateOutput, mapManagementInstanceStoresDeleteOutput, mapManagementInstanceStoresGetOutput, mapManagementInstanceStoresItemsGetOutput, mapManagementInstanceStoresItemsListOutput, mapManagementInstanceStoresItemsListQuery, mapManagementInstanceStoresItemsModifyBody, mapManagementInstanceStoresItemsModifyOutput, mapManagementInstanceStoresListOutput, mapManagementInstanceStoresListQuery, mapManagementInstanceStoresParticipantsGetOutput, mapManagementInstanceStoresParticipantsListOutput, mapManagementInstanceStoresParticipantsListQuery, mapManagementInstanceStoresPermissionsGetOutput, mapManagementInstanceStoresUpdateBody, mapManagementInstanceStoresUpdateOutput, mapManagementInstanceToolCallsCreateBody, mapManagementInstanceToolCallsCreateOutput, mapManagementInstanceToolCallsGetOutput, mapManagementInstanceToolCallsListOutput, mapManagementInstanceToolCallsListQuery, mapManagementInstanceWebhookRegistrationsCreateBody, mapManagementInstanceWebhookRegistrationsCreateOutput, mapManagementInstanceWebhookRegistrationsDeleteOutput, mapManagementInstanceWebhookRegistrationsGetOutput, mapManagementInstanceWebhookRegistrationsListOutput, mapManagementInstanceWebhookRegistrationsListQuery, mapManagementInstanceWebhookRegistrationsSetupBody, mapManagementInstanceWebhookRegistrationsSetupOutput, mapManagementInstanceWebhookRegistrationsUpdateBody, mapManagementInstanceWebhookRegistrationsUpdateOutput, mapManagementOrganizationAccessPoliciesCreateBody, mapManagementOrganizationAccessPoliciesCreateOutput, mapManagementOrganizationAccessPoliciesDeleteOutput, mapManagementOrganizationAccessPoliciesGetOutput, mapManagementOrganizationAccessPoliciesListOutput, mapManagementOrganizationAccessPoliciesListQuery, mapManagementOrganizationAccessPoliciesUpdateBody, mapManagementOrganizationAccessPoliciesUpdateOutput, mapManagementOrganizationAccessPoliciesVersionsOutput, mapManagementOrganizationAccessPoliciesVersionsQuery, mapManagementOrganizationAccessRolesCreateBody, mapManagementOrganizationAccessRolesCreateOutput, mapManagementOrganizationAccessRolesDeleteOutput, mapManagementOrganizationAccessRolesGetOutput, mapManagementOrganizationAccessRolesListOutput, mapManagementOrganizationAccessRolesListQuery, mapManagementOrganizationAccessRolesUpdateBody, mapManagementOrganizationAccessRolesUpdateOutput, mapManagementOrganizationAccessRolesVersionsOutput, mapManagementOrganizationAccessRolesVersionsQuery, mapManagementOrganizationApiKeysCreateBody, mapManagementOrganizationApiKeysCreateOutput, mapManagementOrganizationApiKeysGetOutput, mapManagementOrganizationApiKeysListOutput, mapManagementOrganizationApiKeysListQuery, mapManagementOrganizationApiKeysRevealOutput, mapManagementOrganizationApiKeysRevokeOutput, mapManagementOrganizationApiKeysRotateBody, mapManagementOrganizationApiKeysRotateOutput, mapManagementOrganizationApiKeysUpdateBody, mapManagementOrganizationApiKeysUpdateOutput, mapManagementOrganizationAuditLogStreamsCreateBody, mapManagementOrganizationAuditLogStreamsCreateOutput, mapManagementOrganizationAuditLogStreamsDeleteOutput, mapManagementOrganizationAuditLogStreamsEventsGetOutput, mapManagementOrganizationAuditLogStreamsEventsListOutput, mapManagementOrganizationAuditLogStreamsEventsListQuery, mapManagementOrganizationAuditLogStreamsGetOutput, mapManagementOrganizationAuditLogStreamsListOutput, mapManagementOrganizationAuditLogStreamsListQuery, mapManagementOrganizationAuditLogStreamsResumeOutput, mapManagementOrganizationAuditLogStreamsUpdateBody, mapManagementOrganizationAuditLogStreamsUpdateOutput, mapManagementOrganizationAuditLogsGetOutput, mapManagementOrganizationAuditLogsListOutput, mapManagementOrganizationAuditLogsListQuery, mapManagementOrganizationEventDeliveriesGetOutput, mapManagementOrganizationEventDeliveriesListOutput, mapManagementOrganizationEventDeliveriesListQuery, mapManagementOrganizationEventDeliveriesRetryOutput, mapManagementOrganizationEventDeliveryAttemptsGetOutput, mapManagementOrganizationEventDeliveryAttemptsListOutput, mapManagementOrganizationEventDeliveryAttemptsListQuery, mapManagementOrganizationEventDestinationListenersCreateBody, mapManagementOrganizationEventDestinationListenersCreateOutput, mapManagementOrganizationEventDestinationListenersDeleteOutput, mapManagementOrganizationEventDestinationListenersGetOutput, mapManagementOrganizationEventDestinationListenersListOutput, mapManagementOrganizationEventDestinationListenersListQuery, mapManagementOrganizationEventDestinationListenersUpdateBody, mapManagementOrganizationEventDestinationListenersUpdateOutput, mapManagementOrganizationEventDestinationsArchiveOutput, mapManagementOrganizationEventDestinationsCreateBody, mapManagementOrganizationEventDestinationsCreateOutput, mapManagementOrganizationEventDestinationsGetOutput, mapManagementOrganizationEventDestinationsListOutput, mapManagementOrganizationEventDestinationsListQuery, mapManagementOrganizationEventDestinationsPingOutput, mapManagementOrganizationEventDestinationsRotateWebhookSecretOutput, mapManagementOrganizationEventDestinationsUpdateBody, mapManagementOrganizationEventDestinationsUpdateOutput, mapManagementOrganizationEventsGetOutput, mapManagementOrganizationEventsListOutput, mapManagementOrganizationEventsListQuery, mapManagementOrganizationGetOutput, mapManagementOrganizationInstancesDeleteOutput, mapManagementOrganizationInstancesGetOutput, mapManagementOrganizationInstancesListOutput, mapManagementOrganizationInstancesListQuery, mapManagementOrganizationInstancesUpdateBody, mapManagementOrganizationInstancesUpdateOutput, mapManagementOrganizationInvitesCreateBody, mapManagementOrganizationInvitesCreateOutput, mapManagementOrganizationInvitesDeleteOutput, mapManagementOrganizationInvitesEnsureLinkOutput, mapManagementOrganizationInvitesGetOutput, mapManagementOrganizationInvitesListOutput, mapManagementOrganizationInvitesListQuery, mapManagementOrganizationInvitesUpdateBody, mapManagementOrganizationInvitesUpdateOutput, mapManagementOrganizationMembersDeleteOutput, mapManagementOrganizationMembersGetOutput, mapManagementOrganizationMembersListOutput, mapManagementOrganizationMembersListQuery, mapManagementOrganizationMembersPoliciesCreateBody, mapManagementOrganizationMembersPoliciesCreateOutput, mapManagementOrganizationMembersPoliciesDeleteOutput, mapManagementOrganizationMembersUpdateBody, mapManagementOrganizationMembersUpdateOutput, mapManagementOrganizationOauthAppsClientSecretsCreateOutput, mapManagementOrganizationOauthAppsClientSecretsDeleteOutput, mapManagementOrganizationOauthAppsCreateBody, mapManagementOrganizationOauthAppsCreateOutput, mapManagementOrganizationOauthAppsDeleteOutput, mapManagementOrganizationOauthAppsGetOutput, mapManagementOrganizationOauthAppsListOutput, mapManagementOrganizationOauthAppsListQuery, mapManagementOrganizationOauthAppsUpdateBody, mapManagementOrganizationOauthAppsUpdateOutput, mapManagementOrganizationOauthAuthorizationLogsListOutput, mapManagementOrganizationOauthAuthorizationLogsListQuery, mapManagementOrganizationOauthAuthorizationsGetOutput, mapManagementOrganizationOauthAuthorizationsListOutput, mapManagementOrganizationOauthAuthorizationsListQuery, mapManagementOrganizationOauthAuthorizationsRevokeOutput, mapManagementOrganizationOauthCliDevicesGetOutput, mapManagementOrganizationOauthCliDevicesListOutput, mapManagementOrganizationOauthCliDevicesListQuery, mapManagementOrganizationOauthInstallationsGetOutput, mapManagementOrganizationOauthInstallationsListOutput, mapManagementOrganizationOauthInstallationsListQuery, mapManagementOrganizationOauthInstallationsRevokeOutput, mapManagementOrganizationOauthScopesListOutput, mapManagementOrganizationOauthScopesListQuery, mapManagementOrganizationOutpostsAccessListOutput, mapManagementOrganizationOutpostsAccessListQuery, mapManagementOrganizationOutpostsAccessSetBody, mapManagementOrganizationOutpostsAccessSetOutput, mapManagementOrganizationOutpostsCreateBody, mapManagementOrganizationOutpostsCreateOutput, mapManagementOrganizationOutpostsCredentialsCreateBody, mapManagementOrganizationOutpostsCredentialsCreateOutput, mapManagementOrganizationOutpostsCredentialsDeleteOutput, mapManagementOrganizationOutpostsCredentialsDisableOutput, mapManagementOrganizationOutpostsCredentialsGetOutput, mapManagementOrganizationOutpostsCredentialsListOutput, mapManagementOrganizationOutpostsCredentialsListQuery, mapManagementOrganizationOutpostsDeleteOutput, mapManagementOrganizationOutpostsDisableOutput, mapManagementOrganizationOutpostsEnableOutput, mapManagementOrganizationOutpostsGetOutput, mapManagementOrganizationOutpostsListOutput, mapManagementOrganizationOutpostsListQuery, mapManagementOrganizationOutpostsUpdateBody, mapManagementOrganizationOutpostsUpdateOutput, mapManagementOrganizationProjectsBrandingGetOutput, mapManagementOrganizationProjectsBrandingUpdateBody, mapManagementOrganizationProjectsBrandingUpdateOutput, mapManagementOrganizationProjectsCreateBody, mapManagementOrganizationProjectsCreateOutput, mapManagementOrganizationProjectsDeleteOutput, mapManagementOrganizationProjectsGetOutput, mapManagementOrganizationProjectsListOutput, mapManagementOrganizationProjectsListQuery, mapManagementOrganizationProjectsUpdateBody, mapManagementOrganizationProjectsUpdateOutput, mapManagementOrganizationSandboxesCreateBody, mapManagementOrganizationSandboxesCreateOutput, mapManagementOrganizationSandboxesGetOutput, mapManagementOrganizationSandboxesListOutput, mapManagementOrganizationSandboxesListQuery, mapManagementOrganizationSandboxesUpdateBody, mapManagementOrganizationSandboxesUpdateOutput, mapManagementOrganizationServiceAccountsClientSecretsCreateOutput, mapManagementOrganizationServiceAccountsClientSecretsDeleteOutput, mapManagementOrganizationServiceAccountsCreateBody, mapManagementOrganizationServiceAccountsCreateOutput, mapManagementOrganizationServiceAccountsCredentialsGetOutput, mapManagementOrganizationServiceAccountsCredentialsListOutput, mapManagementOrganizationServiceAccountsCredentialsListQuery, mapManagementOrganizationServiceAccountsDeleteOutput, mapManagementOrganizationServiceAccountsGetOutput, mapManagementOrganizationServiceAccountsListOutput, mapManagementOrganizationServiceAccountsListQuery, mapManagementOrganizationServiceAccountsPoliciesCreateBody, mapManagementOrganizationServiceAccountsPoliciesCreateOutput, mapManagementOrganizationServiceAccountsPoliciesDeleteOutput, mapManagementOrganizationServiceAccountsUpdateBody, mapManagementOrganizationServiceAccountsUpdateOutput, mapManagementOrganizationTeamsCreateBody, mapManagementOrganizationTeamsCreateOutput, mapManagementOrganizationTeamsDeleteOutput, mapManagementOrganizationTeamsGetOutput, mapManagementOrganizationTeamsListOutput, mapManagementOrganizationTeamsListQuery, mapManagementOrganizationTeamsMembersCreateBody, mapManagementOrganizationTeamsMembersCreateOutput, mapManagementOrganizationTeamsMembersDeleteOutput, mapManagementOrganizationTeamsPoliciesCreateBody, mapManagementOrganizationTeamsPoliciesCreateOutput, mapManagementOrganizationTeamsPoliciesDeleteOutput, mapManagementOrganizationTeamsUpdateBody, mapManagementOrganizationTeamsUpdateOutput, mapManagementOrganizationUpdateBody, mapManagementOrganizationUpdateOutput, mapManagementOrganizationWebhookEventsListOutput, mapManagementUserDeleteBody, mapManagementUserDeleteOutput, mapManagementUserGetOutput, mapManagementUserUpdateBody, mapManagementUserUpdateOutput, mapMonitorAlertsGetOutput, mapMonitorAlertsListOutput, mapMonitorAlertsListQuery, mapMonitorAlertsResolveOutput, mapMonitorAlertsUnresolveOutput, mapMonitorAlertsViewedOutput, mapMonitorsGetOutput, mapMonitorsListOutput, mapMonitorsListQuery, mapNetworkPoliciesCreateBody, mapNetworkPoliciesCreateOutput, mapNetworkPoliciesDeleteOutput, mapNetworkPoliciesGetOutput, mapNetworkPoliciesListOutput, mapNetworkPoliciesListQuery, mapNetworkPoliciesRulesCreateBody, mapNetworkPoliciesRulesCreateOutput, mapNetworkPoliciesRulesDeleteOutput, mapNetworkPoliciesRulesUpdateBody, mapNetworkPoliciesRulesUpdateOutput, mapNetworkPoliciesUpdateBody, mapNetworkPoliciesUpdateOutput, mapOrganizationsFlagsGetOutput, mapOrganizationsFlagsGetQuery, mapOrganizationsProfileGetOutput, mapOrganizationsProfileUpdateBody, mapOrganizationsProfileUpdateOutput, mapOrganizationsScopesGetOutput, mapPortalsAccessCreateBody, mapPortalsAccessCreateOutput, mapPortalsAccessDeleteOutput, mapPortalsAccessGetOutput, mapPortalsAccessListOutput, mapPortalsAccessListQuery, mapPortalsAccessRequestsGetOutput, mapPortalsAccessRequestsListOutput, mapPortalsAccessRequestsListQuery, mapPortalsAccessRequestsUpdateBody, mapPortalsAccessRequestsUpdateOutput, mapPortalsAccessUpdateBody, mapPortalsAccessUpdateOutput, mapPortalsConsumerGroupsCreateBody, mapPortalsConsumerGroupsCreateOutput, mapPortalsConsumerGroupsDeleteOutput, mapPortalsConsumerGroupsGetOutput, mapPortalsConsumerGroupsListOutput, mapPortalsConsumerGroupsListQuery, mapPortalsConsumerGroupsUpdateBody, mapPortalsConsumerGroupsUpdateOutput, mapPortalsConsumerInvitesCreateBody, mapPortalsConsumerInvitesCreateOutput, mapPortalsConsumerInvitesGetOutput, mapPortalsConsumerInvitesListOutput, mapPortalsConsumerInvitesListQuery, mapPortalsConsumerProfilesAssignGroupsBody, mapPortalsConsumerProfilesAssignGroupsOutput, mapPortalsConsumerProfilesCreateBody, mapPortalsConsumerProfilesCreateOutput, mapPortalsConsumerProfilesDeleteOutput, mapPortalsConsumerProfilesGetOutput, mapPortalsConsumerProfilesListOutput, mapPortalsConsumerProfilesListQuery, mapPortalsConsumerProfilesUnassignGroupsBody, mapPortalsConsumerProfilesUnassignGroupsOutput, mapPortalsCreateBody, mapPortalsCreateOutput, mapPortalsDeleteOutput, mapPortalsGetOutput, mapPortalsListOutput, mapPortalsListQuery, mapPortalsListingsCreateBody, mapPortalsListingsCreateOutput, mapPortalsListingsDeleteOutput, mapPortalsListingsGetOutput, mapPortalsListingsListOutput, mapPortalsListingsListQuery, mapPortalsListingsUpdateBody, mapPortalsListingsUpdateOutput, mapPortalsSurfaceProviderGroupsAddListingBody, mapPortalsSurfaceProviderGroupsAddListingOutput, mapPortalsSurfaceProviderGroupsCreateBody, mapPortalsSurfaceProviderGroupsCreateOutput, mapPortalsSurfaceProviderGroupsDeleteOutput, mapPortalsSurfaceProviderGroupsGetOutput, mapPortalsSurfaceProviderGroupsListOutput, mapPortalsSurfaceProviderGroupsListQuery, mapPortalsSurfaceProviderGroupsRemoveListingOutput, mapPortalsSurfaceProviderGroupsUpdateBody, mapPortalsSurfaceProviderGroupsUpdateOutput, mapPortalsUpdateBody, mapPortalsUpdateOutput, mapProtoGuardAlertsGetOutput, mapProtoGuardAlertsListOutput, mapProtoGuardAlertsListQuery, mapProtoGuardConfigGetOutput, mapProtoGuardConfigSetAlertFilterCountThresholdBody, mapProtoGuardConfigSetAlertFilterCountThresholdOutput, mapProtoGuardConfigUpdateFilterBody, mapProtoGuardConfigUpdateFilterOutput, mapProviderAuthConfigErrorsGetOutput, mapProviderAuthConfigErrorsGroupsGetOutput, mapProviderAuthConfigErrorsGroupsListOutput, mapProviderAuthConfigErrorsGroupsListQuery, mapProviderAuthConfigErrorsListOutput, mapProviderAuthConfigErrorsListQuery, mapProviderAuthConfigEventsGetOutput, mapProviderAuthConfigEventsListOutput, mapProviderAuthConfigEventsListQuery, mapProviderCategoriesGetOutput, mapProviderCategoriesListOutput, mapProviderCategoriesListQuery, mapProviderCollectionsGetOutput, mapProviderCollectionsListOutput, mapProviderCollectionsListQuery, mapProviderDeploymentsAuthConfigsCreateBody, mapProviderDeploymentsAuthConfigsCreateOutput, mapProviderDeploymentsAuthConfigsDeleteOutput, mapProviderDeploymentsAuthConfigsExportsCreateBody, mapProviderDeploymentsAuthConfigsExportsCreateOutput, mapProviderDeploymentsAuthConfigsExportsGetOutput, mapProviderDeploymentsAuthConfigsExportsListOutput, mapProviderDeploymentsAuthConfigsExportsListQuery, mapProviderDeploymentsAuthConfigsGetOutput, mapProviderDeploymentsAuthConfigsImportsCreateBody, mapProviderDeploymentsAuthConfigsImportsCreateOutput, mapProviderDeploymentsAuthConfigsImportsGetOutput, mapProviderDeploymentsAuthConfigsImportsGetSchemaOutput, mapProviderDeploymentsAuthConfigsImportsGetSchemaQuery, mapProviderDeploymentsAuthConfigsImportsListOutput, mapProviderDeploymentsAuthConfigsImportsListQuery, mapProviderDeploymentsAuthConfigsListOutput, mapProviderDeploymentsAuthConfigsListQuery, mapProviderDeploymentsAuthConfigsUpdateBody, mapProviderDeploymentsAuthConfigsUpdateOutput, mapProviderDeploymentsAuthCredentialsCreateBody, mapProviderDeploymentsAuthCredentialsCreateOutput, mapProviderDeploymentsAuthCredentialsDeleteOutput, mapProviderDeploymentsAuthCredentialsGetOutput, mapProviderDeploymentsAuthCredentialsListOutput, mapProviderDeploymentsAuthCredentialsListQuery, mapProviderDeploymentsAuthCredentialsUpdateBody, mapProviderDeploymentsAuthCredentialsUpdateOutput, mapProviderDeploymentsConfigVaultsCreateBody, mapProviderDeploymentsConfigVaultsCreateOutput, mapProviderDeploymentsConfigVaultsDeleteOutput, mapProviderDeploymentsConfigVaultsGetOutput, mapProviderDeploymentsConfigVaultsListOutput, mapProviderDeploymentsConfigVaultsListQuery, mapProviderDeploymentsConfigVaultsUpdateBody, mapProviderDeploymentsConfigVaultsUpdateOutput, mapProviderDeploymentsConfigsCreateBody, mapProviderDeploymentsConfigsCreateOutput, mapProviderDeploymentsConfigsDeleteOutput, mapProviderDeploymentsConfigsGetConfigSchemaOutput, mapProviderDeploymentsConfigsGetConfigSchemaQuery, mapProviderDeploymentsConfigsGetOutput, mapProviderDeploymentsConfigsGetValueOutput, mapProviderDeploymentsConfigsListOutput, mapProviderDeploymentsConfigsListQuery, mapProviderDeploymentsConfigsUpdateBody, mapProviderDeploymentsConfigsUpdateOutput, mapProviderDeploymentsCreateBody, mapProviderDeploymentsCreateOutput, mapProviderDeploymentsDeleteOutput, mapProviderDeploymentsGetOutput, mapProviderDeploymentsListOutput, mapProviderDeploymentsListQuery, mapProviderDeploymentsSetupSessionsCreateBody, mapProviderDeploymentsSetupSessionsCreateOutput, mapProviderDeploymentsSetupSessionsDeleteOutput, mapProviderDeploymentsSetupSessionsGetOutput, mapProviderDeploymentsSetupSessionsListOutput, mapProviderDeploymentsSetupSessionsListQuery, mapProviderDeploymentsSetupSessionsUpdateBody, mapProviderDeploymentsSetupSessionsUpdateOutput, mapProviderDeploymentsUpdateBody, mapProviderDeploymentsUpdateOutput, mapProviderGroupsAddListingBody, mapProviderGroupsAddListingOutput, mapProviderGroupsCreateBody, mapProviderGroupsCreateOutput, mapProviderGroupsGetOutput, mapProviderGroupsListOutput, mapProviderGroupsListQuery, mapProviderGroupsRemoveListingOutput, mapProviderGroupsUpdateBody, mapProviderGroupsUpdateOutput, mapProviderInvocationsGetOutput, mapProviderInvocationsListOutput, mapProviderInvocationsListQuery, mapProviderListingsGetOutput, mapProviderListingsListOutput, mapProviderListingsListQuery, mapProviderListingsResetOutput, mapProviderListingsUpdateBody, mapProviderListingsUpdateOutput, mapProviderRunsGetLogsOutput, mapProviderRunsGetOutput, mapProviderRunsListOutput, mapProviderRunsListQuery, mapProviderSpecificationChangeNotificationsGetOutput, mapProviderSpecificationChangeNotificationsListOutput, mapProviderSpecificationChangeNotificationsListQuery, mapProviderTemplatesCreateBody, mapProviderTemplatesCreateOutput, mapProviderTemplatesDeleteOutput, mapProviderTemplatesGetOutput, mapProviderTemplatesListOutput, mapProviderTemplatesListQuery, mapProviderTemplatesUpdateBody, mapProviderTemplatesUpdateOutput, mapProvidersAuthMethodsGetOutput, mapProvidersAuthMethodsListOutput, mapProvidersAuthMethodsListQuery, mapProvidersGetOutput, mapProvidersListOutput, mapProvidersListQuery, mapProvidersSpecificationsGetOutput, mapProvidersSpecificationsListOutput, mapProvidersSpecificationsListQuery, mapProvidersToolsGetOutput, mapProvidersToolsListOutput, mapProvidersToolsListQuery, mapProvidersTriggersGetOutput, mapProvidersTriggersListOutput, mapProvidersTriggersListQuery, mapProvidersVersionsGetOutput, mapProvidersVersionsListOutput, mapProvidersVersionsListQuery, mapPublicMcpServersClientsListOutput, mapPublicMcpServersClientsListQuery, mapPublicMcpServersCreateBody, mapPublicMcpServersCreateOutput, mapPublicMcpServersDeleteOutput, mapPublicMcpServersGetOutput, mapPublicMcpServersGrantsGetOutput, mapPublicMcpServersGrantsListOutput, mapPublicMcpServersGrantsListQuery, mapPublicMcpServersGrantsRevokeOutput, mapPublicMcpServersListOutput, mapPublicMcpServersListQuery, mapPublicMcpServersSlugsCheckOutput, mapPublicMcpServersSlugsCheckQuery, mapPublicMcpServersUpdateBody, mapPublicMcpServersUpdateOutput, mapPublishersGetOutput, mapPublishersListOutput, mapPublishersListQuery, mapSandboxDisksCloneBody, mapSandboxDisksCloneOutput, mapSandboxDisksCreateBody, mapSandboxDisksCreateOutput, mapSandboxDisksDeleteOutput, mapSandboxDisksGetOutput, mapSandboxDisksListOutput, mapSandboxDisksListQuery, mapSandboxDisksMountsListOutput, mapSandboxDisksMountsListQuery, mapSandboxDisksResizeBody, mapSandboxDisksResizeOutput, mapSandboxDisksResizesGetOutput, mapSandboxDisksResizesListOutput, mapSandboxDisksResizesListQuery, mapSandboxDisksResizesRetryOutput, mapSandboxDisksUpdateBody, mapSandboxDisksUpdateOutput, mapSandboxImageBuildsCancelOutput, mapSandboxImageBuildsGetOutput, mapSandboxImageBuildsListOutput, mapSandboxImageBuildsListQuery, mapSandboxImageBuildsLogsOutput, mapSandboxImageBuildsLogsQuery, mapSandboxImagesBuildsCreateBody, mapSandboxImagesBuildsCreateOutput, mapSandboxImagesBuildsListOutput, mapSandboxImagesBuildsListQuery, mapSandboxImagesCreateBody, mapSandboxImagesCreateOutput, mapSandboxImagesDeleteOutput, mapSandboxImagesGetOutput, mapSandboxImagesListOutput, mapSandboxImagesListQuery, mapSandboxImagesUpdateBody, mapSandboxImagesUpdateOutput, mapSandboxImagesVersionsGetOutput, mapSandboxImagesVersionsListOutput, mapSandboxImagesVersionsListQuery, mapSandboxMachinesAccessFilesBody, mapSandboxMachinesAccessFilesOutput, mapSandboxMachinesAccessPortsBody, mapSandboxMachinesAccessPortsOutput, mapSandboxMachinesAccessShellBody, mapSandboxMachinesAccessShellOutput, mapSandboxMachinesCreateBody, mapSandboxMachinesCreateOutput, mapSandboxMachinesDeleteOutput, mapSandboxMachinesErrorsGetOutput, mapSandboxMachinesErrorsListOutput, mapSandboxMachinesErrorsListQuery, mapSandboxMachinesEventsGetOutput, mapSandboxMachinesEventsListOutput, mapSandboxMachinesEventsListQuery, mapSandboxMachinesExecBody, mapSandboxMachinesExecOutput, mapSandboxMachinesGetOutput, mapSandboxMachinesHibernateOutput, mapSandboxMachinesInstancesGetOutput, mapSandboxMachinesInstancesListOutput, mapSandboxMachinesInstancesListQuery, mapSandboxMachinesInstancesLogsOutput, mapSandboxMachinesInstancesLogsQuery, mapSandboxMachinesListOutput, mapSandboxMachinesListQuery, mapSandboxMachinesOperationsGetOutput, mapSandboxMachinesOperationsListOutput, mapSandboxMachinesOperationsListQuery, mapSandboxMachinesPauseOutput, mapSandboxMachinesRestartOutput, mapSandboxMachinesStartOutput, mapSandboxMachinesTouchOutput, mapSandboxMachinesUpdateBody, mapSandboxMachinesUpdateOutput, mapSandboxMachinesUsageOutput, mapSandboxMachinesUsageQuery, mapSandboxMachinesUsageSummaryOutput, mapSandboxMachinesUsageSummaryQuery, mapSandboxMachinesUsageTimelineOutput, mapSandboxMachinesUsageTimelineQuery, mapSandboxRegionsGetOutput, mapSandboxRegionsListOutput, mapSandboxRegionsListQuery, mapSandboxSpecsGetOutput, mapSandboxSpecsListOutput, mapSandboxSpecsListQuery, mapScmAccountsPreviewBody, mapScmAccountsPreviewOutput, mapScmConnectionsCreateBody, mapScmConnectionsCreateOutput, mapScmConnectionsGetOutput, mapScmConnectionsListOutput, mapScmConnectionsListQuery, mapScmInstallationCreateBody, mapScmInstallationCreateOutput, mapScmInstallationListOutput, mapScmInstallationListQuery, mapScmProvidersCreateBody, mapScmProvidersCreateOutput, mapScmProvidersGetOutput, mapScmProvidersListOutput, mapScmProvidersListQuery, mapScmReposCreateBody, mapScmReposCreateOutput, mapScmReposGetOutput, mapScmReposListOutput, mapScmReposListQuery, mapScmReposPreviewBody, mapScmReposPreviewOutput, mapSessionTemplatesCreateBody, mapSessionTemplatesCreateOutput, mapSessionTemplatesDeleteOutput, mapSessionTemplatesGetOutput, mapSessionTemplatesListOutput, mapSessionTemplatesListQuery, mapSessionTemplatesListToolsOutput, mapSessionTemplatesProvidersCreateBody, mapSessionTemplatesProvidersCreateOutput, mapSessionTemplatesProvidersDeleteOutput, mapSessionTemplatesProvidersGetOutput, mapSessionTemplatesProvidersListOutput, mapSessionTemplatesProvidersListQuery, mapSessionTemplatesProvidersUpdateBody, mapSessionTemplatesProvidersUpdateOutput, mapSessionTemplatesUpdateBody, mapSessionTemplatesUpdateOutput, mapSessionsConnectionsGetOutput, mapSessionsConnectionsListOutput, mapSessionsConnectionsListQuery, mapSessionsCreateBody, mapSessionsCreateOutput, mapSessionsDeleteOutput, mapSessionsErrorGroupsGetOutput, mapSessionsErrorGroupsListOutput, mapSessionsErrorGroupsListQuery, mapSessionsErrorsGetOutput, mapSessionsErrorsListOutput, mapSessionsErrorsListQuery, mapSessionsEventsGetOutput, mapSessionsEventsListOutput, mapSessionsEventsListQuery, mapSessionsGetOutput, mapSessionsListOutput, mapSessionsListQuery, mapSessionsMessagesGetOutput, mapSessionsMessagesListOutput, mapSessionsMessagesListQuery, mapSessionsParticipantsGetOutput, mapSessionsParticipantsListOutput, mapSessionsParticipantsListQuery, mapSessionsProvidersCreateBody, mapSessionsProvidersCreateOutput, mapSessionsProvidersDeleteOutput, mapSessionsProvidersGetOutput, mapSessionsProvidersListOutput, mapSessionsProvidersListQuery, mapSessionsProvidersUpdateBody, mapSessionsProvidersUpdateOutput, mapSessionsUpdateBody, mapSessionsUpdateOutput, mapSkillsAgentsCreateBody, mapSkillsAgentsCreateOutput, mapSkillsAgentsDeleteOutput, mapSkillsAgentsGetOutput, mapSkillsAgentsListOutput, mapSkillsAgentsListQuery, mapSkillsAgentsUpdateBody, mapSkillsAgentsUpdateOutput, mapSkillsConfigurationsCreateBody, mapSkillsConfigurationsCreateOutput, mapSkillsConfigurationsDeleteOutput, mapSkillsConfigurationsGetOutput, mapSkillsConfigurationsListOutput, mapSkillsConfigurationsListQuery, mapSkillsConfigurationsUpdateBody, mapSkillsConfigurationsUpdateOutput, mapSkillsCreateBody, mapSkillsCreateOutput, mapSkillsDeleteOutput, mapSkillsDuplicateBody, mapSkillsDuplicateOutput, mapSkillsExportsCreateBody, mapSkillsExportsCreateOutput, mapSkillsExportsGetOutput, mapSkillsExportsListOutput, mapSkillsExportsListQuery, mapSkillsFilesBatchBody, mapSkillsFilesBatchOutput, mapSkillsFilesDeleteOutput, mapSkillsFilesDeleteQuery, mapSkillsFilesGetOutput, mapSkillsFilesGetQuery, mapSkillsFilesListOutput, mapSkillsFilesMoveBody, mapSkillsFilesMoveOutput, mapSkillsFilesPutBody, mapSkillsFilesPutOutput, mapSkillsForkBody, mapSkillsForkOutput, mapSkillsForkSyncsCreateBody, mapSkillsForkSyncsCreateOutput, mapSkillsForkSyncsGetOutput, mapSkillsGetOutput, mapSkillsGroupsCreateBody, mapSkillsGroupsCreateOutput, mapSkillsGroupsDeleteOutput, mapSkillsGroupsGetOutput, mapSkillsGroupsItemsCreateBody, mapSkillsGroupsItemsCreateOutput, mapSkillsGroupsItemsDeleteOutput, mapSkillsGroupsItemsGetOutput, mapSkillsGroupsItemsListOutput, mapSkillsGroupsItemsListQuery, mapSkillsGroupsListOutput, mapSkillsGroupsListQuery, mapSkillsGroupsUpdateBody, mapSkillsGroupsUpdateOutput, mapSkillsImportsCreateBody, mapSkillsImportsCreateOutput, mapSkillsImportsGetOutput, mapSkillsImportsListOutput, mapSkillsImportsListQuery, mapSkillsItemsCreateBody, mapSkillsItemsCreateOutput, mapSkillsItemsDeleteOutput, mapSkillsItemsGetOutput, mapSkillsItemsListOutput, mapSkillsItemsListQuery, mapSkillsListOutput, mapSkillsListQuery, mapSkillsMarketplacesArchiveOutput, mapSkillsMarketplacesCreateBody, mapSkillsMarketplacesCreateOutput, mapSkillsMarketplacesGetEditorUrlBody, mapSkillsMarketplacesGetEditorUrlOutput, mapSkillsMarketplacesGetOutput, mapSkillsMarketplacesListOutput, mapSkillsMarketplacesListQuery, mapSkillsMarketplacesPluginsAddBody, mapSkillsMarketplacesPluginsAddOutput, mapSkillsMarketplacesPluginsGetOutput, mapSkillsMarketplacesPluginsListOutput, mapSkillsMarketplacesPluginsListQuery, mapSkillsMarketplacesPluginsRemoveOutput, mapSkillsMarketplacesRepositoriesCreateBody, mapSkillsMarketplacesRepositoriesCreateOutput, mapSkillsMarketplacesRepositoriesDeleteOutput, mapSkillsMarketplacesRepositoriesGetOutput, mapSkillsMarketplacesRepositoriesListOutput, mapSkillsMarketplacesRepositoriesListQuery, mapSkillsMarketplacesSyncBody, mapSkillsMarketplacesSyncOutput, mapSkillsMarketplacesUpdateBody, mapSkillsMarketplacesUpdateOutput, mapSkillsMergeRequestsCloseOutput, mapSkillsMergeRequestsCommentsCreateBody, mapSkillsMergeRequestsCommentsCreateOutput, mapSkillsMergeRequestsCommentsDeleteOutput, mapSkillsMergeRequestsCommentsGetOutput, mapSkillsMergeRequestsCommentsListOutput, mapSkillsMergeRequestsCommentsListQuery, mapSkillsMergeRequestsCommentsUpdateBody, mapSkillsMergeRequestsCommentsUpdateOutput, mapSkillsMergeRequestsCreateBody, mapSkillsMergeRequestsCreateOutput, mapSkillsMergeRequestsEventsGetOutput, mapSkillsMergeRequestsEventsListOutput, mapSkillsMergeRequestsEventsListQuery, mapSkillsMergeRequestsGetOutput, mapSkillsMergeRequestsItemsBulkResolveBody, mapSkillsMergeRequestsItemsBulkResolveOutput, mapSkillsMergeRequestsItemsResolveBody, mapSkillsMergeRequestsItemsResolveOutput, mapSkillsMergeRequestsListOutput, mapSkillsMergeRequestsListQuery, mapSkillsMergeRequestsPerformOutput, mapSkillsMergeRequestsPlanGetOutput, mapSkillsMergeRequestsRollbackOutput, mapSkillsParticipantsGetOutput, mapSkillsParticipantsListOutput, mapSkillsParticipantsListQuery, mapSkillsPluginsArchiveOutput, mapSkillsPluginsCreateBody, mapSkillsPluginsCreateOutput, mapSkillsPluginsGetEditorUrlBody, mapSkillsPluginsGetEditorUrlOutput, mapSkillsPluginsGetOutput, mapSkillsPluginsListOutput, mapSkillsPluginsListQuery, mapSkillsPluginsRepositoriesCreateBody, mapSkillsPluginsRepositoriesCreateOutput, mapSkillsPluginsRepositoriesDeleteOutput, mapSkillsPluginsRepositoriesGetOutput, mapSkillsPluginsRepositoriesListOutput, mapSkillsPluginsRepositoriesListQuery, mapSkillsPluginsSkillsAddBody, mapSkillsPluginsSkillsAddOutput, mapSkillsPluginsSkillsGetOutput, mapSkillsPluginsSkillsListOutput, mapSkillsPluginsSkillsListQuery, mapSkillsPluginsSkillsRemoveOutput, mapSkillsPluginsSkillsUpdateBody, mapSkillsPluginsSkillsUpdateOutput, mapSkillsPluginsSyncBody, mapSkillsPluginsSyncOutput, mapSkillsPluginsUpdateBody, mapSkillsPluginsUpdateOutput, mapSkillsPublishConsumerSkillOutput, mapSkillsShareBody, mapSkillsShareOutput, mapSkillsTemplatesCreateBody, mapSkillsTemplatesCreateOutput, mapSkillsTemplatesDeleteOutput, mapSkillsTemplatesGetOutput, mapSkillsTemplatesItemsCreateBody, mapSkillsTemplatesItemsCreateOutput, mapSkillsTemplatesItemsDeleteOutput, mapSkillsTemplatesItemsGetOutput, mapSkillsTemplatesItemsListOutput, mapSkillsTemplatesItemsListQuery, mapSkillsTemplatesListOutput, mapSkillsTemplatesListQuery, mapSkillsTemplatesUpdateBody, mapSkillsTemplatesUpdateOutput, mapSkillsUpdateBody, mapSkillsUpdateOutput, mapSkillsVersionsGetOutput, mapSkillsVersionsListOutput, mapSkillsVersionsListQuery, mapSkillsVersionsSnapshotGetOutput, mapStoresCreateBody, mapStoresCreateOutput, mapStoresDeleteOutput, mapStoresGetOutput, mapStoresItemsGetOutput, mapStoresItemsListOutput, mapStoresItemsListQuery, mapStoresItemsModifyBody, mapStoresItemsModifyOutput, mapStoresListOutput, mapStoresListQuery, mapStoresParticipantsGetOutput, mapStoresParticipantsListOutput, mapStoresParticipantsListQuery, mapStoresPermissionsGetOutput, mapStoresUpdateBody, mapStoresUpdateOutput, mapTestHelpersConsumerOauthAuthorizationsCreateBody, mapTestHelpersConsumerOauthAuthorizationsCreateOutput, mapToolCallsCreateBody, mapToolCallsCreateOutput, mapToolCallsGetOutput, mapToolCallsListOutput, mapToolCallsListQuery, mapWebhookRegistrationsCreateBody, mapWebhookRegistrationsCreateOutput, mapWebhookRegistrationsDeleteOutput, mapWebhookRegistrationsGetOutput, mapWebhookRegistrationsListOutput, mapWebhookRegistrationsListQuery, mapWebhookRegistrationsSetupBody, mapWebhookRegistrationsSetupOutput, mapWebhookRegistrationsUpdateBody, mapWebhookRegistrationsUpdateOutput, smallFileDirectUploadMaxBytes, supportsPresignedUpload };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map